var _a, _b, _c, _d, _e2, _f, _g;
var selected_style = [];

var selected_iti_prompt = 0;
let t__message;
let div_message;
let p_message;
let wishlist_item = [];
let wishlist_uniqueId = [];
let image_heart_div;
let button0;
let input_custom_style;
let croppedimages3bucketurl = false
// let image_heart_div_a_unheart;
let image_heart_div_a_heart;
let product_cart_detail = {};
let maindisplayimagediv;
let openOverLayBtn;
let loaderdiv;
let customimagediv;
let cropper;
let isVerticalCustomNew = true;
let finalIsVertical = false;
let editimageprompt = false;
let imagetobeedited = false;
let croppedImageBinary = false;
let p2_preview;
let div2prdernow;
let numberoffaces = false;
let div1_image_history;
let ul_images_stylepresets;
let cancelimagebutton1;
let validated_image = true;
let get_image_detail  = true;
let image_detail_array = [];
let image_description = false;
let generate_image_description = false;
let process_interrupted = false
let image_detail = {"girl child":0,"boy child":0,"adult woman":0,"adult man":0, "number of animals":0, "toddler":0, "object":1,"objectname":"","total figures":0,"image_detail_inshort":""};
let image_validation_error = ""
let advanceButton; 
let checkboxWrapper; 

let formDetailHistory = false;
let preloadedimageurl = false;
let formsubmittedafterlogin  = false;
let button_disabled_value;
let finalsubmissionbutton;

let variedcheckbox;
let variedcheckboxLabel;

let compositioncheckbox;
let compositioncheckboxLabel;
let div2_imagehistory;
let updated_is_vertical = undefined;
let generated_image_array = []
let image_generation_error = false;
let pending_images_array = [];
let form_detail_array = [];
let inprogressimageid = false;

let t29_value;
let t29;
let button_art_icon;
let in_progress_prompt = "";
let in_progress_orientation = "none";
let ipaddress = async ()=>{

  return fetch('https://api.ipify.org?format=json')
    .then(response => response.json())
    .then(data => {
   
      device_ip = data.ip
      // console.log("device_ip----------------", device_ip)
      return data.ip;
    })
    .catch(err => console.error("Error fetching IP:", err));
}


let ps = [false, false, false,false];
const deleteCookiein = async (name) => {
  document.cookie = `${name}=; path=/; max-age=0`;
};
const getCookiein = async (name) => {
  const cookies = document.cookie.split("; ");
  for (const cookie of cookies) {
    const [key, value] = cookie.split("=");
    if (key === name) return value;
  }
  return null;
};


let formDetailHistoryImageURL = false;
if(!customer_custom_store){ 
  await deleteCookiein("formdetail");
  await deleteCookiein("dataforwishlist");
}
await deleteCookiein("formdetail"); //temporary delete  formDetailHistory
let formDetail = await getCookiein("formdetail");
if(formDetail){ 
  formDetailHistory = JSON.parse(decodeURIComponent(formDetail));
  image_detail = (formDetailHistory?.image_detail)?formDetailHistory?.image_detail:image_detail;
  formDetailHistoryImageURL = formDetailHistory?.imageUrl
}
// console.log("formDetailHistory--------------", formDetailHistory)
const selected_link = await getCookiein("selectedlink");


const dataforwishlist = await getCookiein("dataforwishlist");
let addwishlistdata = {}

if(dataforwishlist){ 

  addwishlistdata = JSON.parse(decodeURIComponent(dataforwishlist));
  
  const fingerprint = await getFingerprint();
  // console.log("deviceid-", fingerprint)
  addwishlistdata.customerId = customer_custom_store;
  if(addwishlistdata.action=="add"){
    delete addwishlistdata.action;
    addwishlistdata.customermail = customer_custom_email
    const workerUrl = "https://webhook.wallart.ai/savewishlistItems";
    fetch(workerUrl, {
      method: "POST",
      headers: {
        "content-type": "application/json",
        "x-device-id": fingerprint,
      },
      body: JSON.stringify(addwishlistdata),
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.error == false) {
          const countElement = document.querySelector(".count");
          if (countElement) {
            countElement.innerText = data?.count || 0;
          }
          wishlist_item.push(selected_link)
          wishlist_uniqueId[selected_link] = addwishlistdata;
        }
      });
  }else if(addwishlistdata.action=="delete"){
    delete addwishlistdata.action;
    fetch("https://webhook.wallart.ai/removefromwishlist", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(addwishlistdata),
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.error == false) {
          const countElement = document.querySelector(".count");
          if (countElement) {
            countElement.innerText = data?.count || 0;
          }

          
        }
      });
}


}

(function polyfill() {
  const relList = document.createElement("link").relList;
  if (relList && relList.supports && relList.supports("modulepreload")) {
    return;
  }
  for (const link of document.querySelectorAll('link[rel="modulepreload"]')) {
    processPreload(link);
  }
  new MutationObserver((mutations) => {
    for (const mutation of mutations) {
      if (mutation.type !== "childList") {
        continue;
      }
      for (const node of mutation.addedNodes) {
        if (node.tagName === "LINK" && node.rel === "modulepreload")
          processPreload(node);
      }
    }
  }).observe(document, { childList: true, subtree: true });
  function getFetchOpts(link) {
    const fetchOpts = {};
    if (link.integrity) fetchOpts.integrity = link.integrity;
    if (link.referrerPolicy) fetchOpts.referrerPolicy = link.referrerPolicy;
    if (link.crossOrigin === "use-credentials")
      fetchOpts.credentials = "include";
    else if (link.crossOrigin === "anonymous") fetchOpts.credentials = "omit";
    else fetchOpts.credentials = "same-origin";
    return fetchOpts;
  }
  function processPreload(link) {
    if (link.ep) return;
    link.ep = true;
    const fetchOpts = getFetchOpts(link);
    fetch(link.href, fetchOpts);
  }
})();
const style = "";
function noop$1() {}
const identity$2 = (x2) => x2;

function run(fn) {
  return fn();
}
function blank_object() {
  return /* @__PURE__ */ Object.create(null);
}
function run_all(fns) {
  fns.forEach(run);
}
function is_function(thing) {
  return typeof thing === "function";
}
function safe_not_equal(a, b2) {
  return a != a
    ? b2 == b2
    : a !== b2 || (a && typeof a === "object") || typeof a === "function";
}
let src_url_equal_anchor;
function src_url_equal(element_src, url) {
  if (!src_url_equal_anchor) {
    src_url_equal_anchor = document.createElement("a");
  }
  src_url_equal_anchor.href = url;
  return element_src === src_url_equal_anchor.href;
}
function is_empty(obj) {
  return Object.keys(obj).length === 0;
}
function split_css_unit(value) {
  const split =
    typeof value === "string" && value.match(/^\s*(-?[\d.]+)([^\s]*)\s*$/);
  return split ? [parseFloat(split[1]), split[2] || "px"] : [value, "px"];
}
const is_client = typeof window !== "undefined";
let now = is_client ? () => window.performance.now() : () => Date.now();
let raf = is_client ? (cb2) => requestAnimationFrame(cb2) : noop$1;
const tasks = /* @__PURE__ */ new Set();
function run_tasks(now2) {
  tasks.forEach((task) => {
    if (!task.c(now2)) {
      tasks.delete(task);
      task.f();
    }
  });
  if (tasks.size !== 0) raf(run_tasks);
}
function loop(callback) {
  let task;
  if (tasks.size === 0) raf(run_tasks);
  return {
    promise: new Promise((fulfill) => {
      tasks.add((task = { c: callback, f: fulfill }));
    }),
    abort() {
      tasks.delete(task);
    },
  };
}
function append(target, node) {
  target.appendChild(node);
}
function get_root_for_style(node) {
  if (!node) return document;
  const root = node.getRootNode ? node.getRootNode() : node.ownerDocument;
  if (root && root.host) {
    return root;
  }
  return node.ownerDocument;
}
function append_empty_stylesheet(node) {
  const style_element = element("style");
  append_stylesheet(get_root_for_style(node), style_element);
  return style_element.sheet;
}
function append_stylesheet(node, style2) {
  append(node.head || node, style2);
  return style2.sheet;
}
function insert(target, node, anchor) {
  target.insertBefore(node, anchor || null);
}
function detach(node) {
  if (node.parentNode) {
    node.parentNode.removeChild(node);
  }
}
function destroy_each(iterations, detaching) {
  for (let i = 0; i < iterations.length; i += 1) {
    if (iterations[i]) iterations[i].d(detaching);
  }
}
function element(name2) {
  return document.createElement(name2);
}
function svg_element(name2) {
  return document.createElementNS("http://www.w3.org/2000/svg", name2);
}
function text$1(data) {
  return document.createTextNode(data);
}
function space() {
  return text$1(" ");
}
function empty() {
  return text$1("");
}
function listen(node, event, handler, options) {
  node.addEventListener(event, handler, options);
  return () => node.removeEventListener(event, handler, options);
}
function prevent_default(fn) {
  return function (event) {
    event.preventDefault();
    return fn.call(this, event);
  };
}
function attr(node, attribute, value) {
  if (value == null) node.removeAttribute(attribute);
  else if (node.getAttribute(attribute) !== value)
    node.setAttribute(attribute, value);
}
function init_binding_group(group) {
  let _inputs;
  return {
    /* push */
    p(...inputs) {
      _inputs = inputs;
      _inputs.forEach((input) => group.push(input));
    },
    /* remove */
    r() {
      _inputs.forEach((input) => group.splice(group.indexOf(input), 1));
    },
  };
}
function children(element2) {
  return Array.from(element2.childNodes);
}
function set_data(text2, data) {
  data = "" + data;
  if (text2.data === data) return;
  text2.data = data;
}
function set_input_value(input, value) {
  input.value = value == null ? "" : value;
}
function set_style(node, key, value, important) {
  if (value == null) {
    node.style.removeProperty(key);
  } else {
    node.style.setProperty(key, value, important ? "important" : "");
  }
}
function select_option(select, value, mounting) {
  for (let i = 0; i < select.options.length; i += 1) {
    const option = select.options[i];
    if (option.__value === value) {
      option.selected = true;
      return;
    }
  }
  if (!mounting || value !== void 0) {
    select.selectedIndex = -1;
  }
}
function select_value(select) {
  const selected_option = select.querySelector(":checked");
  return selected_option && selected_option.__value;
}
function custom_event(
  type3,
  detail,
  { bubbles = false, cancelable = false } = {}
) {
  const e = document.createEvent("CustomEvent");
  e.initCustomEvent(type3, bubbles, cancelable, detail);
  return e;
}
const managed_styles = /* @__PURE__ */ new Map();
let active = 0;
function hash(str) {
  let hash2 = 5381;
  let i = str.length;
  while (i--) hash2 = ((hash2 << 5) - hash2) ^ str.charCodeAt(i);
  return hash2 >>> 0;
}
function create_style_information(doc2, node) {
  const info = { stylesheet: append_empty_stylesheet(node), rules: {} };
  managed_styles.set(doc2, info);
  return info;
}
function create_rule(node, a, b2, duration, delay, ease, fn, uid = 0) {
  const step = 16.666 / duration;
  let keyframes = "{\n";
  for (let p2 = 0; p2 <= 1; p2 += step) {
    const t = a + (b2 - a) * ease(p2);
    keyframes +=
      p2 * 100 +
      `%{${fn(t, 1 - t)}}
`;
  }
  const rule =
    keyframes +
    `100% {${fn(b2, 1 - b2)}}
}`;
  const name2 = `__svelte_${hash(rule)}_${uid}`;
  const doc2 = get_root_for_style(node);
  const { stylesheet, rules } =
    managed_styles.get(doc2) || create_style_information(doc2, node);
  if (!rules[name2]) {
    rules[name2] = true;
    stylesheet.insertRule(
      `@keyframes ${name2} ${rule}`,
      stylesheet.cssRules.length
    );
  }
  const animation = node.style.animation || "";
  node.style.animation = `${
    animation ? `${animation}, ` : ""
  }${name2} ${duration}ms linear ${delay}ms 1 both`;
  active += 1;
  return name2;
}
function delete_rule(node, name2) {
  const previous = (node.style.animation || "").split(", ");
  const next = previous.filter(
    name2
      ? (anim) => anim.indexOf(name2) < 0
      : (anim) => anim.indexOf("__svelte") === -1
    // remove all Svelte animations
  );
  const deleted = previous.length - next.length;
  if (deleted) {
    node.style.animation = next.join(", ");
    active -= deleted;
    if (!active) clear_rules();
  }
}
function clear_rules() {
  raf(() => {
    if (active) return;
    managed_styles.forEach((info) => {
      const { ownerNode } = info.stylesheet;
      if (ownerNode) detach(ownerNode);
    });
    managed_styles.clear();
  });
}
let current_component;
function set_current_component(component) {
  current_component = component;
}
function get_current_component() {
  if (!current_component)
    throw new Error("Function called outside component initialization");
  return current_component;
}

function onMount(fn) {
  // alert("dddddd")
  
  get_current_component().$$.on_mount.push(fn);
}
function onDestroy(fn) {
  get_current_component().$$.on_destroy.push(fn);
}
function createEventDispatcher() {
  const component = get_current_component();
  return (type3, detail, { cancelable = false } = {}) => {
    const callbacks = component.$$.callbacks[type3];
    if (callbacks) {
      const event = custom_event(type3, detail, { cancelable });
      callbacks.slice().forEach((fn) => {
        fn.call(component, event);
      });
      return !event.defaultPrevented;
    }
    return true;
  };
}
function bubble(component, event) {
  const callbacks = component.$$.callbacks[event.type];
  if (callbacks) {
    callbacks.slice().forEach((fn) => fn.call(this, event));
  }
}
const dirty_components = [];
const binding_callbacks = [];
let render_callbacks = [];
const flush_callbacks = [];
const resolved_promise = /* @__PURE__ */ Promise.resolve();
let update_scheduled = false;
function schedule_update() {
  if (!update_scheduled) {
    update_scheduled = true;
    resolved_promise.then(flush);
  }
}
function add_render_callback(fn) {
  render_callbacks.push(fn);
}
function add_flush_callback(fn) {
  flush_callbacks.push(fn);
}
const seen_callbacks = /* @__PURE__ */ new Set();
let flushidx = 0;
function flush() {
  if (flushidx !== 0) {
    return;
  }
  const saved_component = current_component;
  do {
    try {
      while (flushidx < dirty_components.length) {
        const component = dirty_components[flushidx];
        flushidx++;
        set_current_component(component);
        update(component.$$);
      }
    } catch (e) {
      dirty_components.length = 0;
      flushidx = 0;
      throw e;
    }
    set_current_component(null);
    dirty_components.length = 0;
    flushidx = 0;
    while (binding_callbacks.length) binding_callbacks.pop()();
    for (let i = 0; i < render_callbacks.length; i += 1) {
      const callback = render_callbacks[i];
      if (!seen_callbacks.has(callback)) {
        seen_callbacks.add(callback);
        callback();
      }
    }
    render_callbacks.length = 0;
  } while (dirty_components.length);
  while (flush_callbacks.length) {
    flush_callbacks.pop()();
  }
  update_scheduled = false;
  seen_callbacks.clear();
  set_current_component(saved_component);
}
function update($$) {
  if ($$.fragment !== null) {
    $$.update();
    run_all($$.before_update);
    const dirty = $$.dirty;
    $$.dirty = [-1];
    $$.fragment && $$.fragment.p($$.ctx, dirty);
    $$.after_update.forEach(add_render_callback);
  }
}
function flush_render_callbacks(fns) {
  const filtered = [];
  const targets = [];
  render_callbacks.forEach((c) =>
    fns.indexOf(c) === -1 ? filtered.push(c) : targets.push(c)
  );
  targets.forEach((c) => c());
  render_callbacks = filtered;
}
let promise;
function wait() {
  if (!promise) {
    promise = Promise.resolve();
    promise.then(() => {
      promise = null;
    });
  }
  return promise;
}
function dispatch(node, direction, kind) {
  node.dispatchEvent(custom_event(`${direction ? "intro" : "outro"}${kind}`));
}
const outroing = /* @__PURE__ */ new Set();
let outros;
function group_outros() {
  outros = {
    r: 0,
    c: [],
    p: outros,
    // parent group
  };
}
function check_outros() {
  if (!outros.r) {
    run_all(outros.c);
  }
  outros = outros.p;
}
function transition_in(block, local) {
  if (block && block.i) {
    outroing.delete(block);
    block.i(local);
  }
}
function transition_out(block, local, detach2, callback) {
  if (block && block.o) {
    if (outroing.has(block)) return;
    outroing.add(block);
    outros.c.push(() => {
      outroing.delete(block);
      if (callback) {
        if (detach2) block.d(1);
        callback();
      }
    });
    block.o(local);
  } else if (callback) {
    callback();
  }
}
const null_transition = { duration: 0 };
function create_in_transition(node, fn, params) {
  const options = { direction: "in" };
  let config = fn(node, params, options);
  let running = false;
  let animation_name;
  let task;
  let uid = 0;
  function cleanup() {
    if (animation_name) delete_rule(node, animation_name);
  }
  function go() {
    const {
      delay = 0,
      duration = 300,
      easing = identity$2,
      tick = noop$1,
      css,
    } = config || null_transition;
    if (css)
      animation_name = create_rule(
        node,
        0,
        1,
        duration,
        delay,
        easing,
        css,
        uid++
      );
    tick(0, 1);
    const start_time = now() + delay;
    const end_time = start_time + duration;
    if (task) task.abort();
    running = true;
    add_render_callback(() => dispatch(node, true, "start"));
    task = loop((now2) => {
      if (running) {
        if (now2 >= end_time) {
          tick(1, 0);
          dispatch(node, true, "end");
          cleanup();
          return (running = false);
        }
        if (now2 >= start_time) {
          const t = easing((now2 - start_time) / duration);
          tick(t, 1 - t);
        }
      }
      return running;
    });
  }
  let started = false;
  return {
    start() {
      if (started) return;
      started = true;
      delete_rule(node);
      if (is_function(config)) {
        config = config(options);
        wait().then(go);
      } else {
        go();
      }
    },
    invalidate() {
      started = false;
    },
    end() {
      if (running) {
        cleanup();
        running = false;
      }
    },
  };
}
function create_bidirectional_transition(node, fn, params, intro) {
  const options = { direction: "both" };
  let config = fn(node, params, options);
  let t = intro ? 0 : 1;
  let running_program = null;
  let pending_program = null;
  let animation_name = null;
  function clear_animation() {
    if (animation_name) delete_rule(node, animation_name);
  }
  function init2(program, duration) {
    const d = program.b - t;
    duration *= Math.abs(d);
    return {
      a: t,
      b: program.b,
      d,
      duration,
      start: program.start,
      end: program.start + duration,
      group: program.group,
    };
  }
  function go(b2) {
    const {
      delay = 0,
      duration = 300,
      easing = identity$2,
      tick = noop$1,
      css,
    } = config || null_transition;
    const program = {
      start: now() + delay,
      b: b2,
    };
    if (!b2) {
      program.group = outros;
      outros.r += 1;
    }
    if (running_program || pending_program) {
      pending_program = program;
    } else {
      if (css) {
        clear_animation();
        animation_name = create_rule(node, t, b2, duration, delay, easing, css);
      }
      if (b2) tick(0, 1);
      running_program = init2(program, duration);
      add_render_callback(() => dispatch(node, b2, "start"));
      loop((now2) => {
        if (pending_program && now2 > pending_program.start) {
          running_program = init2(pending_program, duration);
          pending_program = null;
          dispatch(node, running_program.b, "start");
          if (css) {
            clear_animation();
            animation_name = create_rule(
              node,
              t,
              running_program.b,
              running_program.duration,
              0,
              easing,
              config.css
            );
          }
        }
        if (running_program) {
          if (now2 >= running_program.end) {
            tick((t = running_program.b), 1 - t);
            dispatch(node, running_program.b, "end");
            if (!pending_program) {
              if (running_program.b) {
                clear_animation();
              } else {
                if (!--running_program.group.r)
                  run_all(running_program.group.c);
              }
            }
            running_program = null;
          } else if (now2 >= running_program.start) {
            const p2 = now2 - running_program.start;
            t =
              running_program.a +
              running_program.d * easing(p2 / running_program.duration);
            tick(t, 1 - t);
          }
        }
        return !!(running_program || pending_program);
      });
    }
  }
  return {
    run(b2) {
      if (is_function(config)) {
        wait().then(() => {
          config = config(options);
          go(b2);
        });
      } else {
        go(b2);
      }
    },
    end() {
      clear_animation();
      running_program = pending_program = null;
    },
  };
}
function bind$2(component, name2, callback) {
  const index = component.$$.props[name2];
  if (index !== void 0) {
    component.$$.bound[index] = callback;
    callback(component.$$.ctx[index]);
  }
}
function create_component(block) {
  block && block.c();
}
function mount_component(component, target, anchor, customElement) {
  const { fragment, after_update } = component.$$;
  fragment && fragment.m(target, anchor);
  if (!customElement) {
    add_render_callback(() => {
      const new_on_destroy = component.$$.on_mount.map(run).filter(is_function);
      if (component.$$.on_destroy) {
        component.$$.on_destroy.push(...new_on_destroy);
      } else {
        run_all(new_on_destroy);
      }
      component.$$.on_mount = [];
    });
  }
  after_update.forEach(add_render_callback);
}
function destroy_component(component, detaching) {
  const $$ = component.$$;
  if ($$.fragment !== null) {
    flush_render_callbacks($$.after_update);
    run_all($$.on_destroy);
    $$.fragment && $$.fragment.d(detaching);
    $$.on_destroy = $$.fragment = null;
    $$.ctx = [];
  }
}
function make_dirty(component, i) {
  if (component.$$.dirty[0] === -1) {
    dirty_components.push(component);
    schedule_update();
    component.$$.dirty.fill(0);
  }
  component.$$.dirty[(i / 31) | 0] |= 1 << i % 31;
}
function init(
  component,
  options,
  instance2,
  create_fragment2,
  not_equal,
  props,
  append_styles,
  dirty = [-1]
) {
  const parent_component = current_component;
  set_current_component(component);
  const $$ = (component.$$ = {
    fragment: null,
    ctx: [],
    // state
    props,
    update: noop$1,
    not_equal,
    bound: blank_object(),
    // lifecycle
    on_mount: [],
    on_destroy: [],
    on_disconnect: [],
    before_update: [],
    after_update: [],
    context: new Map(
      options.context || (parent_component ? parent_component.$$.context : [])
    ),
    // everything else
    callbacks: blank_object(),
    dirty,
    skip_bound: false,
    root: options.target || parent_component.$$.root,
  });
  append_styles && append_styles($$.root);
  let ready = false;
  $$.ctx = instance2
    ? instance2(component, options.props || {}, (i, ret, ...rest) => {
        const value = rest.length ? rest[0] : ret;
        if ($$.ctx && not_equal($$.ctx[i], ($$.ctx[i] = value))) {
          if (!$$.skip_bound && $$.bound[i]) $$.bound[i](value);
          if (ready) make_dirty(component, i);
        }
        return ret;
      })
    : [];
  $$.update();
  ready = true;
  run_all($$.before_update);
  $$.fragment = create_fragment2 ? create_fragment2($$.ctx) : false;
  if (options.target) {
    if (options.hydrate) {
      const nodes = children(options.target);
      $$.fragment && $$.fragment.l(nodes);
      nodes.forEach(detach);
    } else {
      $$.fragment && $$.fragment.c();
    }
    if (options.intro) transition_in(component.$$.fragment);
    mount_component(
      component,
      options.target,
      options.anchor,
      options.customElement
    );
    flush();
  }
  set_current_component(parent_component);
}
class SvelteComponent {
  $destroy() {
    destroy_component(this, 1);
    this.$destroy = noop$1;
  }
  $on(type3, callback) {
    if (!is_function(callback)) {
      return noop$1;
    }
    const callbacks =
      this.$$.callbacks[type3] || (this.$$.callbacks[type3] = []);
    callbacks.push(callback);
    return () => {
      const index = callbacks.indexOf(callback);
      if (index !== -1) callbacks.splice(index, 1);
    };
  }
  $set($$props) {
    if (this.$$set && !is_empty($$props)) {
      this.$$.skip_bound = true;
      this.$$set($$props);
      this.$$.skip_bound = false;
    }
  }
}

const taketourcss = 
".custom-intro-tooltip{font-family: 'Poppins', sans-serif;border-radius: 12px; padding: 20px; background: #fff; color: #333; box-shadow: 0 4px 20px rgba(0,0,0,0.1);}.introjs-tour{transition:all .3s ease-out}.introjs-overlay{position:absolute;box-sizing:content-box;z-index:999999;opacity:0;transition:all .3s ease-out}.introjs-showElement{z-index:9999999!important}tr.introjs-showElement>td{z-index:9999999!important;position:relative}tr.introjs-showElement>th{z-index:9999999!important;position:relative}.introjs-disableInteraction{z-index:99999999!important;position:absolute;background-color:#fff;opacity:0}.introjs-relativePosition{position:relative}.introjs-helperLayer{box-sizing:content-box;position:absolute;z-index:9999998;border-radius:4px;transition:all .3s ease-out}.introjs-helperLayer *{box-sizing:content-box}.introjs-helperLayer :before{box-sizing:content-box}.introjs-helperLayer :after{box-sizing:content-box}.introjs-tooltipReferenceLayer{font-family:Poppins, sans-serif;box-sizing:content-box;position:absolute;visibility:hidden;z-index:100000000;background-color:transparent;transition:all .3s ease-out}.introjs-tooltipReferenceLayer *{font-family:Poppins, sans-serif}.introjs-helperNumberLayer{font-family:Poppins, sans-serif;color:#9e9e9e;text-align:center;padding-top:10px;padding-bottom:10px}.introjs-arrow{border:5px solid transparent;content:'';position:absolute}.introjs-arrow.top{top:-10px;left:10px;border-bottom-color:#fff}.introjs-arrow.top-right{top:-10px;right:10px;border-bottom-color:#fff}.introjs-arrow.top-middle{top:-10px;left:50%;margin-left:-5px;border-bottom-color:#fff}.introjs-arrow.right{right:-10px;top:10px;border-left-color:#fff}.introjs-arrow.right-bottom{bottom:10px;right:-10px;border-left-color:#fff}.introjs-arrow.bottom{bottom:-10px;left:10px;border-top-color:#fff}.introjs-arrow.bottom-right{bottom:-10px;right:10px;border-top-color:#fff}.introjs-arrow.bottom-middle{bottom:-10px;left:50%;margin-left:-5px;border-top-color:#fff}.introjs-arrow.left{left:-10px;top:10px;border-right-color:#fff}.introjs-arrow.left-bottom{left:-10px;bottom:10px;border-right-color:#fff}.introjs-tooltip{box-sizing:content-box;position:absolute;visibility:visible;background-color:#fff;min-width:300px;max-width:300px;border-radius:5px;box-shadow:0 3px 30px rgba(33,33,33,.3);transition:opacity .1s ease-out}.introjs-tooltiptext{padding:10px}.introjs-dontShowAgain{padding-left:20px;padding-right:20px}.introjs-dontShowAgain input{padding:0;margin:0;margin-bottom:2px;display:inline;width:10px;height:10px}.introjs-dontShowAgain label{font-size:14px;display:inline-block;font-weight:400;margin:0 0 0 5px;padding:0;background-color:#fff;color:#616161;-webkit-user-select:none;user-select:none}.introjs-tooltip-title{font-size:18px;width:90%;min-height:0;margin:0;padding:0;font-weight:700;line-height:0}..introjs-tooltipbuttons{border-top:1px solid #e0e0e0;padding:10px;text-align:right;white-space:nowrap}.introjs-tooltipbuttons:after{content:'';visibility:hidden;display:block;height:0;clear:both}.introjs-button{box-sizing:content-box;position:relative;overflow:visible;border:1px solid #bdbdbd;text-decoration:none;text-shadow:1px 1px 0 #fff;color:#424242;white-space:nowrap;cursor:pointer;outline:0;background-color:#f4f4f4;border-radius:6px;zoom:1;display:inline;font-weight: 600 !important;padding: 10px 18px !important;font-family: 'Poppins', sans-serif !important;font-size: 14px !important;box-shadow: 0 4px 10px rgba(0,0,0,0.1);transition: all 0.2s ease-in-out;}.introjs-button:hover{outline:0;text-decoration:none;border-color:#9e9e9e;background-color:#e0e0e0;color:#212121}.introjs-button:focus{outline:0;text-decoration:none;background-color:#eee;box-shadow:0 0 0 .2rem rgba(158,158,158,.5);border:1px solid #616161;color:#212121}.introjs-button:active{outline:0;text-decoration:none;background-color:#e0e0e0;border-color:#9e9e9e;color:#212121}.introjs-button::-moz-focus-inner{padding:0;border:0}.introjs-skipbutton{position:absolute;top:0;right:0;display:inline-block;width:45px;height:45px;line-height:45px;color:#777!important;font-size:22px;cursor:pointer;font-weight:500;text-align:center;text-decoration:none}.introjs-skipbutton:focus,.introjs-skipbutton:hover{color:#212121;outline:0;text-decoration:none}.introjs-prevbutton{float:left}.introjs-nextbutton{float:right}.introjs-nextbutton, .introjs-prevbutton {background-color: #ffffff !important;border: 1.5px solid #000 !important;color: #000 !important;}.introjs-nextbutton:hover, .introjs-prevbutton:hover {background-color: #f6f6f6 !important;}.introjs-disabled{color:#9e9e9e;border-color:#bdbdbd;box-shadow:none;cursor:default;background-color:#f4f4f4;background-image:none;text-decoration:none}.introjs-disabled:focus,.introjs-disabled:hover{color:#9e9e9e;border-color:#bdbdbd;box-shadow:none;cursor:default;background-color:#f4f4f4;background-image:none;text-decoration:none}.introjs-hidden{display:none}.introjs-bullets{text-align:center;padding-top:10px;padding-bottom:10px}.introjs-bullets ul{box-sizing:content-box;clear:both;margin:0 auto 0;padding:0;display:inline-block}.introjs-bullets ul li{box-sizing:content-box;list-style:none;float:left;margin:0 2px}.introjs-bullets ul li a{transition:width .1s ease-in;box-sizing:content-box;display:block;width:6px;height:6px;background:#ccc;border-radius:10px;text-decoration:none;cursor:pointer}.introjs-bullets ul li a:focus,.introjs-bullets ul li a:hover{width:15px;background:#999;text-decoration:none;outline:0}.introjs-bullets ul li a.active{width:15px;background:#999}.introjs-progress{box-sizing:content-box;overflow:hidden;margin:10px;background-color: #f2f2f2 !important;height: 6px !important;border-radius: 3px !important;}.introjs-progressbar{box-sizing:content-box;float:left;width:0%;font-size:10px;line-height:10px;text-align:center;background-color:#08c;background-color: #d61a1a !important; /* your theme red */height: 6px !important;border-radius: 3px !important;transition: width 0.3s ease;}.introjsFloatingElement{position:absolute;height:0;width:0;left:50%;top:50%}.introjs-fixedTooltip{position:fixed}.introjs-hint{box-sizing:content-box;position:absolute;background:0 0;width:20px;height:15px;cursor:pointer}.introjs-hint:focus{border:0;outline:0}.introjs-hint:hover>.introjs-hint-pulse{background-color:rgba(60,60,60,.57)}.introjs-hidehint{display:none}.introjs-fixedhint{position:fixed}@keyframes introjspulse{0%{transform:scale(.95);box-shadow:0 0 0 0 rgba(0,0,0,.7)}70%{transform:scale(1);box-shadow:0 0 0 10px transparent}100%{transform:scale(.95);box-shadow:0 0 0 0 transparent}}.introjs-hint-pulse{box-sizing:content-box;width:15px;height:15px;border-radius:30px;background-color:rgba(136,136,136,.24);z-index:10;position:absolute;transition:all .2s ease-out;animation:introjspulse 2s infinite}.introjs-hint-no-anim .introjs-hint-pulse{animation:none}.introjs-hint-dot{box-sizing:content-box;background:0 0;border-radius:60px;height:50px;width:50px;position:absolute;top:-18px;left:-18px;z-index:1;opacity:0}"


const styles =
  "/*!\n * Cropper.js v1.6.1\n * https://fengyuanchen.github.io/cropperjs\n *\n * Copyright 2015-present Chen Fengyuan\n * Released under the MIT license\n *\n * Date: 2023-09-17T03:44:17.565Z\n */\n\n @import url('https://fonts.googleapis.com/css2?family=Parkinsans:wght@300..800&family=Poppins:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap'); .cropper-container {\n  direction: ltr;\n  font-size: 0;\n  line-height: 0;\n  position: relative;\n  touch-action: none;\n  -webkit-user-select: none;\n     -moz-user-select: none;\n          user-select: none;\n} .border-8px,.sss img {border: 0px solid #000;} .select-none { border: 2px solid #D9D9D9; padding: 12px 28px; width: 50%; text-align: center; border-radius: 8px; } img.h-14.d-desktop,img.object-contain.h-8.mx-auto { filter: brightness(0.01); } .selected {    border: 2px solid #dd2946;} .select-none input { width: 0; margin: 0; padding: 0;opacity: 0;visibility: hidden; } .select-none:active { border: 2px solid #000; }  \n\n.cropper-container img {\n    backface-visibility: hidden;\n    display: block;\n    height: 100%;\n    image-orientation: 0deg;\n    max-height: none !important;\n    max-width: none !important;\n    min-height: 0 !important;\n    min-width: 0 !important;\n    width: 100%;\n  }.bulb { padding: 0 !important; gap: 0; height: 35px !important; width: 35px !important; }\n\n.cropper-wrap-box,\n.cropper-canvas,\n.cropper-drag-box,\n.cropper-crop-box,\n.cropper-modal {\n  bottom: 0;\n  left: 0;\n  position: absolute;\n  right: 0;\n  top: 0;\n}\n\n h2.text-2xl.font-bold.text-center.text-brand-red.mb-4 {    font-size: 34px;    font-family: Inter;}.flex.items-center.justify-center.w-full.h-full.mb-0 { overflow: hidden; } .cropper-wrap-box,\n.cropper-canvas {\n  overflow: hidden;\n}\n\n.cropper-drag-box {\n  background-color: #fff;\n  opacity: 0;\n}\n\n.cropper-modal {\n  background-color: #000;\n  opacity: 0.5;\n}\n\n.cropper-view-box {\n  display: block;\n  height: 100%;\n  outline: 1px solid #39f;\n  outline-color: rgba(51, 153, 255, 0.75);\n  overflow: hidden;\n  width: 100%;\n}\n\n.cropper-dashed {\n  border: 0 dashed #eee;\n  display: block;\n  opacity: 0.5;\n  position: absolute;\n}\n\n.cropper-dashed.dashed-h {\n    border-bottom-width: 1px;\n    border-top-width: 1px;\n    height: calc(100% / 3);\n    left: 0;\n    top: calc(100% / 3);\n    width: 100%;\n  }\n\n.cropper-dashed.dashed-v {\n    border-left-width: 1px;\n    border-right-width: 1px;\n    height: 100%;\n    left: calc(100% / 3);\n    top: 0;\n    width: calc(100% / 3);\n  }\n\n.cropper-center {\n  display: block;\n  height: 0;\n  left: 50%;\n  opacity: 0.75;\n  position: absolute;\n  top: 50%;\n  width: 0;\n}\n\n.cropper-center::before,\n  .cropper-center::after {\n    background-color: #eee;\n    content: ' ';\n    display: block;\n    position: absolute;\n  }\n\n.cropper-center::before {\n    height: 1px;\n    left: -3px;\n    top: 0;\n    width: 7px;\n  }\n\n.cropper-center::after {\n    height: 7px;\n    left: 0;\n    top: -3px;\n    width: 1px;\n  }\n\n.cropper-face,\n.cropper-line,\n.cropper-point {\n  display: block;\n  height: 100%;\n  opacity: 0.1;\n  position: absolute;\n  width: 100%;\n}\n\n.cropper-face {\n  background-color: #fff;\n  left: 0;\n  top: 0;\n}\n\n.cropper-line {\n  background-color: #39f;\n}\n\n.cropper-line.line-e {\n    cursor: ew-resize;\n    right: -3px;\n    top: 0;\n    width: 5px;\n  }\n\n.cropper-line.line-n {\n    cursor: ns-resize;\n    height: 5px;\n    left: 0;\n    top: -3px;\n  }\n\n.cropper-line.line-w {\n    cursor: ew-resize;\n    left: -3px;\n    top: 0;\n    width: 5px;\n  }\n\n.cropper-line.line-s {\n    bottom: -3px;\n    cursor: ns-resize;\n    height: 5px;\n    left: 0;\n  }\n\n.cropper-point {\n  background-color: #39f;\n  height: 5px;\n  opacity: 0.75;\n  width: 5px;\n}\n\n.cropper-point.point-e {\n    cursor: ew-resize;\n    margin-top: -3px;\n    right: -3px;\n    top: 50%;\n  }\n\n.cropper-point.point-n {\n    cursor: ns-resize;\n    left: 50%;\n    margin-left: -3px;\n    top: -3px;\n  }\n\n.cropper-point.point-w {\n    cursor: ew-resize;\n    left: -3px;\n    margin-top: -3px;\n    top: 50%;\n  }\n\n.cropper-point.point-s {\n    bottom: -3px;\n    cursor: s-resize;\n    left: 50%;\n    margin-left: -3px;\n  }\n\n.cropper-point.point-ne {\n    cursor: nesw-resize;\n    right: -3px;\n    top: -3px;\n  }\n\n.cropper-point.point-nw {\n    cursor: nwse-resize;\n    left: -3px;\n    top: -3px;\n  }\n\n.cropper-point.point-sw {\n    bottom: -3px;\n    cursor: nesw-resize;\n    left: -3px;\n  }\n\n.cropper-point.point-se {\n    bottom: -3px;\n    cursor: nwse-resize;\n    height: 20px;\n    opacity: 1;\n    right: -3px;\n    width: 20px;\n  }\n\n@media (min-width: 992px) {\n\n.cropper-point.point-se {\n      height: 15px;\n      width: 15px;\n  }\n    }\n\n@media (min-width: 992px) {\n\n.cropper-point.point-se {\n      height: 10px;\n      width: 10px;\n  }\n    }\n\n@media (min-width: 1200px) {\n\n.cropper-point.point-se {\n      height: 5px;\n      opacity: 0.75;\n      width: 5px;\n  }\n    }\n\n.cropper-point.point-se::before {\n    background-color: #39f;\n    bottom: -50%;\n    content: ' ';\n    display: block;\n    height: 200%;\n    opacity: 0;\n    position: absolute;\n    right: -50%;\n    width: 200%;\n  }\n\n.cropper-invisible {\n  opacity: 0;\n}\n\n.cropper-bg {\n  background-image: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQAQMAAAAlPW0iAAAAA3NCSVQICAjb4U/gAAAABlBMVEXMzMz////TjRV2AAAACXBIWXMAAArrAAAK6wGCiw1aAAAAHHRFWHRTb2Z0d2FyZQBBZG9iZSBGaXJld29ya3MgQ1M26LyyjAAAABFJREFUCJlj+M/AgBVhF/0PAH6/D/HkDxOGAAAAAElFTkSuQmCC');\n}\n\n.cropper-hide {\n  display: block;\n  height: 0;\n  position: absolute;\n  width: 0;\n}\n\n.cropper-hidden {\n  display: none !important;\n}\n\n.cropper-move {\n  cursor: move;\n}\n\n.cropper-crop {\n  cursor: crosshair;\n}\n\n.cropper-disabled .cropper-drag-box,\n.cropper-disabled .cropper-face,\n.cropper-disabled .cropper-line,\n.cropper-disabled .cropper-point {\n  cursor: not-allowed;\n}\n\n/*! tailwindcss v3.3.3 | MIT License | https://tailwindcss.com\n */\n\n/*\n1. Prevent padding and border from affecting element width. (https://github.com/mozdevs/cssremedy/issues/4)\n2. Allow adding a border to an element by just adding a border-width. (https://github.com/tailwindcss/tailwindcss/pull/116)\n*/\n\n*,\n::before,\n::after {\n  box-sizing: border-box; /* 1 */\n  border-width: 0; /* 2 */\n  border-style: solid; /* 2 */\n  border-color: #e5e7eb; /* 2 */\n}\n\n::before,\n::after {\n  --tw-content: '';\n}\n\n/*\n1. Use a consistent sensible line-height in all browsers.\n2. Prevent adjustments of font size after orientation changes in iOS.\n3. Use a more readable tab size.\n4. Use the user's configured `sans` font-family by default.\n5. Use the user's configured `sans` font-feature-settings by default.\n6. Use the user's configured `sans` font-variation-settings by default.\n*/\n\nhtml {\n  line-height: 1.5; /* 1 */\n  -webkit-text-size-adjust: 100%; /* 2 */\n  -moz-tab-size: 4; /* 3 */\n  -o-tab-size: 4;\n     tab-size: 4; /* 3 */\n  font-family: Poppins, sans-serif; /* 4 */\n  font-feature-settings: normal; /* 5 */\n  font-variation-settings: normal; /* 6 */\n}\n\n/*\n1. Remove the margin in all browsers.\n2. Inherit line-height from `html` so users can set them as a class directly on the `html` element.\n*/\n\nbody {\n  margin: 0; /* 1 */\n  line-height: inherit; /* 2 */\n}\n\n/*\n1. Add the correct height in Firefox.\n2. Correct the inheritance of border color in Firefox. (https://bugzilla.mozilla.org/show_bug.cgi?id=190655)\n3. Ensure horizontal rules are visible by default.\n*/\n\nhr {\n  height: 0; /* 1 */\n  color: inherit; /* 2 */\n  border-top-width: 1px; /* 3 */\n}\n\n/*\nAdd the correct text decoration in Chrome, Edge, and Safari.\n*/\n\nabbr:where([title]) {\n  -webkit-text-decoration: underline dotted;\n          text-decoration: underline dotted;\n}\n\n/*\nRemove the default font size and weight for headings.\n*/\n\nh1,\nh2,\nh3,\nh4,\nh5,\nh6 {\n  font-size: inherit;\n  font-weight: inherit;\n}\n\n/*\nReset links to optimize for opt-in styling instead of opt-out.\n*/\n\na {\n  color: inherit;\n  text-decoration: inherit;\n}\n\n/*\nAdd the correct font weight in Edge and Safari.\n*/\n\nb,\nstrong {\n  font-weight: bolder;\n}\n\n/*\n1. Use the user's configured `mono` font family by default.\n2. Correct the odd `em` font sizing in all browsers.\n*/\n\ncode,\nkbd,\nsamp,\npre {\n  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, \"Liberation Mono\", \"Courier New\", monospace; /* 1 */\n  font-size: 1em; /* 2 */\n}\n\n/*\nAdd the correct font size in all browsers.\n*/\n\nsmall {\n  font-size: 80%;\n}\n\n/*\nPrevent `sub` and `sup` elements from affecting the line height in all browsers.\n*/\n\nsub,\nsup {\n  font-size: 75%;\n  line-height: 0;\n  position: relative;\n  vertical-align: baseline;\n}\n\nsub {\n  bottom: -0.25em;\n}\n\nsup {\n  top: -0.5em;\n}\n\n/*\n1. Remove text indentation from table contents in Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=999088, https://bugs.webkit.org/show_bug.cgi?id=201297)\n2. Correct table border color inheritance in all Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=935729, https://bugs.webkit.org/show_bug.cgi?id=195016)\n3. Remove gaps between table borders by default.\n*/\n\ntable {\n  text-indent: 0; /* 1 */\n  border-color: inherit; /* 2 */\n  border-collapse: collapse; /* 3 */\n}\n\n/*\n1. Change the font styles in all browsers.\n2. Remove the margin in Firefox and Safari.\n3. Remove default padding in all browsers.\n*/\n\nbutton,\ninput,\noptgroup,\nselect,\ntextarea {\n  font-family: inherit; /* 1 */\n  font-feature-settings: inherit; /* 1 */\n  font-variation-settings: inherit; /* 1 */\n  font-size: 100%; /* 1 */\n  font-weight: inherit; /* 1 */\n  line-height: inherit; /* 1 */\n  color: inherit; /* 1 */\n  margin: 0; /* 2 */\n  padding: 0; /* 3 */\n}\n\n/*\nRemove the inheritance of text transform in Edge and Firefox.\n*/\n\nbutton,\nselect {\n  text-transform: none;\n}\n\n/*\n1. Correct the inability to style clickable types in iOS and Safari.\n2. Remove default button styles.\n*/\n\nbutton,\n[type='button'],\n[type='reset'],\n[type='submit'] {\n  -webkit-appearance: button; /* 1 */\n  background-color: transparent; /* 2 */\n  background-image: none; /* 2 */\n}\n\n/*\nUse the modern Firefox focus style for all focusable elements.\n*/\n\n:-moz-focusring {\n  outline: auto;\n}\n\n/*\nRemove the additional `:invalid` styles in Firefox. (https://github.com/mozilla/gecko-dev/blob/2f9eacd9d3d995c937b4251a5557d95d494c9be1/layout/style/res/forms.css#L728-L737)\n*/\n\n:-moz-ui-invalid {\n  box-shadow: none;\n}\n\n/*\nAdd the correct vertical alignment in Chrome and Firefox.\n*/\n\nprogress {\n  vertical-align: baseline;\n}\n\n/*\nCorrect the cursor style of increment and decrement buttons in Safari.\n*/\n\n::-webkit-inner-spin-button,\n::-webkit-outer-spin-button {\n  height: auto;\n}\n\n/*\n1. Correct the odd appearance in Chrome and Safari.\n2. Correct the outline style in Safari.\n*/\n\n[type='search'] {\n  -webkit-appearance: textfield; /* 1 */\n  outline-offset: -2px; /* 2 */\n}\n\n/*\nRemove the inner padding in Chrome and Safari on macOS.\n*/\n\n::-webkit-search-decoration {\n  -webkit-appearance: none;\n}\n\n/*\n1. Correct the inability to style clickable types in iOS and Safari.\n2. Change font properties to `inherit` in Safari.\n*/\n\n::-webkit-file-upload-button {\n  -webkit-appearance: button; /* 1 */\n  font: inherit; /* 2 */\n}\n\n/*\nAdd the correct display in Chrome and Safari.\n*/\n\nsummary {\n  display: list-item;\n}\n\n/*\nRemoves the default spacing and border for appropriate elements.\n*/\n\nblockquote,\ndl,\ndd,\nh1,\nh2,\nh3,\nh4,\nh5,\nh6,\nhr,\nfigure,\np,\npre {\n  margin: 0;\n}\n\nfieldset {\n  margin: 0;\n  padding: 0;\n}\n\nlegend {\n  padding: 0;\n}\n\nol,\nul,\nmenu {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n}\n\n/*\nReset default styling for dialogs.\n*/\n\ndialog {\n  padding: 0;\n}\n\n/*\nPrevent resizing textareas horizontally by default.\n*/\n\ntextarea {\n  resize: vertical;\n}\n\n/*\n1. Reset the default placeholder opacity in Firefox. (https://github.com/tailwindlabs/tailwindcss/issues/3300)\n2. Set the default placeholder color to the user's configured gray 400 color.\n*/\n\ninput::-moz-placeholder, textarea::-moz-placeholder {\n  opacity: 1; /* 1 */\n  color: #9ca3af; /* 2 */\n}\n\ninput::placeholder,\ntextarea::placeholder {\n  opacity: 1; /* 1 */\n  color: #9ca3af; /* 2 */\n}\n\n/*\nSet the default cursor for buttons.\n*/\n\nbutton,\n[role=\"button\"] {\n  cursor: pointer;\n}\n\n/*\nMake sure disabled buttons don't get the pointer cursor.\n*/\n\n:disabled {\n  cursor: default;\n}\n\n/*\n1. Make replaced elements `display: block` by default. (https://github.com/mozdevs/cssremedy/issues/14)\n2. Add `vertical-align: middle` to align replaced elements more sensibly by default. (https://github.com/jensimmons/cssremedy/issues/14#issuecomment-634934210)\n   This can trigger a poorly considered lint error in some tools but is included by design.\n*/\n\nimg,\nsvg,\nvideo,\ncanvas,\naudio,\niframe,\nembed,\nobject {\n  display: block; /* 1 */\n  vertical-align: middle; /* 2 */\n}\n\n/*\nConstrain images and videos to the parent width and preserve their intrinsic aspect ratio. (https://github.com/mozdevs/cssremedy/issues/14)\n*/\n\nimg,\nvideo {\n  max-width: 100%;\n  height: auto;\n}\n\n/* Make elements with the HTML hidden attribute stay hidden by default */\n\n[hidden] {\n  display: none;\n}\n\n*, ::before, ::after {\n  --tw-border-spacing-x: 0;\n  --tw-border-spacing-y: 0;\n  --tw-translate-x: 0;\n  --tw-translate-y: 0;\n  --tw-rotate: 0;\n  --tw-skew-x: 0;\n  --tw-skew-y: 0;\n  --tw-scale-x: 1;\n  --tw-scale-y: 1;\n  --tw-pan-x:  ;\n  --tw-pan-y:  ;\n  --tw-pinch-zoom:  ;\n  --tw-scroll-snap-strictness: proximity;\n  --tw-gradient-from-position:  ;\n  --tw-gradient-via-position:  ;\n  --tw-gradient-to-position:  ;\n  --tw-ordinal:  ;\n  --tw-slashed-zero:  ;\n  --tw-numeric-figure:  ;\n  --tw-numeric-spacing:  ;\n  --tw-numeric-fraction:  ;\n  --tw-ring-inset:  ;\n  --tw-ring-offset-width: 0px;\n  --tw-ring-offset-color: #fff;\n  --tw-ring-color: rgb(59 130 246 / 0.5);\n  --tw-ring-offset-shadow: 0 0 #0000;\n  --tw-ring-shadow: 0 0 #0000;\n  --tw-shadow: 0 0 #0000;\n  --tw-shadow-colored: 0 0 #0000;\n  --tw-blur:  ;\n  --tw-brightness:  ;\n  --tw-contrast:  ;\n  --tw-grayscale:  ;\n  --tw-hue-rotate:  ;\n  --tw-invert:  ;\n  --tw-saturate:  ;\n  --tw-sepia:  ;\n  --tw-drop-shadow:  ;\n  --tw-backdrop-blur:  ;\n  --tw-backdrop-brightness:  ;\n  --tw-backdrop-contrast:  ;\n  --tw-backdrop-grayscale:  ;\n  --tw-backdrop-hue-rotate:  ;\n  --tw-backdrop-invert:  ;\n  --tw-backdrop-opacity:  ;\n  --tw-backdrop-saturate:  ;\n  --tw-backdrop-sepia:  ;\n}\n\n::backdrop {\n  --tw-border-spacing-x: 0;\n  --tw-border-spacing-y: 0;\n  --tw-translate-x: 0;\n  --tw-translate-y: 0;\n  --tw-rotate: 0;\n  --tw-skew-x: 0;\n  --tw-skew-y: 0;\n  --tw-scale-x: 1;\n  --tw-scale-y: 1;\n  --tw-pan-x:  ;\n  --tw-pan-y:  ;\n  --tw-pinch-zoom:  ;\n  --tw-scroll-snap-strictness: proximity;\n  --tw-gradient-from-position:  ;\n  --tw-gradient-via-position:  ;\n  --tw-gradient-to-position:  ;\n  --tw-ordinal:  ;\n  --tw-slashed-zero:  ;\n  --tw-numeric-figure:  ;\n  --tw-numeric-spacing:  ;\n  --tw-numeric-fraction:  ;\n  --tw-ring-inset:  ;\n  --tw-ring-offset-width: 0px;\n  --tw-ring-offset-color: #fff;\n  --tw-ring-color: rgb(59 130 246 / 0.5);\n  --tw-ring-offset-shadow: 0 0 #0000;\n  --tw-ring-shadow: 0 0 #0000;\n  --tw-shadow: 0 0 #0000;\n  --tw-shadow-colored: 0 0 #0000;\n  --tw-blur:  ;\n  --tw-brightness:  ;\n  --tw-contrast:  ;\n  --tw-grayscale:  ;\n  --tw-hue-rotate:  ;\n  --tw-invert:  ;\n  --tw-saturate:  ;\n  --tw-sepia:  ;\n  --tw-drop-shadow:  ;\n  --tw-backdrop-blur:  ;\n  --tw-backdrop-brightness:  ;\n  --tw-backdrop-contrast:  ;\n  --tw-backdrop-grayscale:  ;\n  --tw-backdrop-hue-rotate:  ;\n  --tw-backdrop-invert:  ;\n  --tw-backdrop-opacity:  ;\n  --tw-backdrop-saturate:  ;\n  --tw-backdrop-sepia:  ;\n}\n\n.visible {\n  visibility: visible;\n}\n\n.invisible {\n  visibility: hidden;\n}\n\n.fixed {\n  position: fixed;\n}\n\n.absolute {\n  position: absolute;\n}\n\n.relative {\n  position: relative;\n}\n\n.-top-8 {\n  top: -2rem;\n}\n\n.bottom-1 {\n  bottom: 0.25rem;\n}\n\n.bottom-4 {\n  bottom: 1rem;\n}\n\n.left-0 {\n  left: 0px;\n}\n\n.left-1 {\n  left: 0.25rem;\n}\n\n.right-0 {\n  right: 0px;\n}\n\n.right-1 {\n  right: 0.25rem;\n}\n\n.right-3 {\n  right: 0.75rem;\n}\n\n.right-4 {\n  right: -3.5rem;\n}\n\n.top-0 {\n  top: 0px;\n}\n\n.top-2 {\n  top: 0.5rem;\n}\n\n.top-4 {\n  top: 0.3rem;\n}\n\n.top-\\[-3rem\\] {\n  top: -3rem;\n}\n\n.top-\\[100\\%\\] {\n  top: 100%;\n}\n\n.z-\\[1\\] {\n  z-index: 1;\n}\n\n.z-\\[2\\] {\n  z-index: 2;\n}\n\n.m-0 {\n  margin: 0px;\n}\n\n.mx-auto {\n  margin-left: auto;\n  margin-right: auto;\n}\n\n.mb-0 {\n  margin-bottom: 0px;\n}\n\n.mb-2 {\n  margin-bottom: 0.5rem;\n}\n\n.mb-24 {\n  margin-bottom: 6rem;\n}\n\n.mb-4 {\n  margin-bottom: 1rem;\n}\n\n.mb-8 {\n  margin-bottom: 1rem;\n}\n\n.mt-2 {\n  margin-top: 0.5rem;\n}\n\n.mt-4 {\n  margin-top: 1rem;\n}\n\n.\\!block {\n  display: block !important;\n}\n\n.block {\n  display: block;\n}\n\n.inline {\n  display: inline;\n}\n\n.flex {\n  display: flex;\n}\n\n.grid {\n  display: grid;\n}\n\n.hidden {\n  display: none;\n}\n\n.h-10 {\n  height: 2.5rem;\n}\n\n.h-12 {\n  height: 100%;\n}\n\n.h-14 {\n  height: 3.5rem;\n}\n\n.h-16 {\n  height: 100%;\n}\n\n.h-20 {\n  height: 5rem;\n}\n\n.h-6 {\n  height: 1.5rem;\n}\n\n.h-8 {\n  height: 3rem;\n}\n\n.h-\\[18rem\\] {\n  height: 18rem;\n}\n\n.h-full {\n  height: 100%;\n}\n\n.preview-image{\n transform: scale(1.3); position: relative;\n}\n\n.min-h-\\[1\\.5rem\\] {\n  min-height: 1.5rem;\n}\n\n.min-h-\\[4rem\\] {\n  min-height: 4rem;\n}\n\n.w-10 {\n  width: 2.5rem;\n}\n\n.w-12 {\n  width: 100%;\n}\n\n.w-16 {\n  width: 100%;\n}\n\n.w-20 {\n  width: 5rem;\n}\n\n.w-4 {\n  width: 1rem;\n}\n\n.w-6 {\n  width: 1.5rem;\n}\n\n.w-8 {\n  width: 3rem;\n}\n\n.w-full {\n  width: 100%;\n}\n\n.min-w-\\[3rem\\] {\n  min-width: 3rem;\n}\n\n.min-w-\\[4rem\\] {\n  min-width: 4rem;\n}\n\n.max-w-\\[100\\%\\] {\n  max-width: 100%;\n}\n\n.max-w-\\[15rem\\] {\n  max-width: 15rem;\n}\n\n.max-w-full {\n  max-width: 100%;\n}\n\n.flex-1 {\n  flex: 1 1 0%;\n}\n\n.flex-shrink-0 {\n  flex-shrink: 0;\n}\n\n.rotate-90 {\n  --tw-rotate: 90deg;\n  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));\n}\n\n.scale-\\[0\\.98\\] {\n  --tw-scale-x: 0.98;\n  --tw-scale-y: 0.98;\n  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));\n}\n\n@keyframes pulse {\n\n  50% {\n    opacity: .5;\n  }\n}\n\n.animate-pulse {\n  animation: pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite;\n}\n\n@keyframes spin {\n\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n.animate-spin {\n  animation: spin 1s linear infinite;\n}\n\n.cursor-pointer {\n  cursor: pointer;\n}\n\n.select-none {\n  -webkit-user-select: none;\n     -moz-user-select: none;\n          user-select: none;\n}\n\n.resize {\n  resize: both;\n}\n\n.list-none {\n  list-style-type: none;\n}\n\n.flex-col {\n  flex-direction: column;\n}\n\n.flex-col-reverse {\n  flex-direction: column-reverse;\n}\n\n.items-start {\n  align-items: flex-start;\n}\n\n.items-center {\n  align-items: center;\n}\n\n.justify-start {\n  justify-content: flex-start;\n}\n\n.justify-center {\n  justify-content: center;\n}\n\n.justify-between {\n  justify-content: space-between;\n}\n\n.gap-0 {\n  gap: 0px;\n}\n\n.gap-2 {\n  gap: 0.5rem;\n}\n\n.gap-4 {\n  gap: 1rem;\n}\n\n.overflow-auto {\n  overflow: auto;\n}\n\n.overflow-hidden {\n  overflow: hidden;\n}\n\n.overflow-x-auto {\n  overflow-x: auto;\n}\n\n.whitespace-pre-line {\n  white-space: pre-line;\n}\n\n.rounded-full {\n  border-radius: 9999px;\n}\n\n.rounded-lg {\n  border-radius: 0.5rem;\n}\n\n.rounded-md {\n  border-radius: 0.375rem;\n}\n\n.border {\n  border-width: 1px;\n}\n\n.border-2 {\n  border-width: 2px;\n}\n\n.border-8 {\n  border-width: 8px;\n}\n\n.border-\\[1px\\] {\n  border-width: 1px;\n}\n\n.border-b-\\[0\\.4rem\\] {\n  border-bottom-width: 0.4rem;\n}\n\n.border-l-\\[0\\.4rem\\] {\n  border-left-width: 0.4rem;\n}\n\n.border-r-\\[0\\.4rem\\] {\n  border-right-width: 0.4rem;\n}\n\n.border-t-\\[0\\.4rem\\] {\n  border-top-width: 0.4rem;\n}\n\n.border-solid {\n  border-style: solid;\n}\n\n.border-dashed {\n  border-style: dashed;\n}\n\n.border-none {\n  border-style: none;\n}\n\n.border-gray-300 {\n  --tw-border-opacity: 1;\n  border-color: rgb(209 213 219 / var(--tw-border-opacity));\n}\n\n.border-gray-400 {\n  --tw-border-opacity: 1;\n  border-color: rgb(156 163 175 / var(--tw-border-opacity));\n}\n\n.border-gray-600 {\n  --tw-border-opacity: 1;\n      border-color: rgb(221 41 70);\n}\n\n.border-gray-700 {\n  --tw-border-opacity: 1;\n  border-color: rgb(55 65 81 / var(--tw-border-opacity));\n}\n\n.border-gray-950 {\n  --tw-border-opacity: 1;\n  border-color: rgb(3 7 18 / var(--tw-border-opacity));\n}\n\n.border-yellow-400 {\n  border-color:#000000; \n --tw-border-opacity: 1;\n \n}\n\n.border-b-\\[\\#d0011c\\] {\n  --tw-border-opacity: 1;\n  border-bottom-color: rgb(208 1 28 / var(--tw-border-opacity));\n}\n\n.border-l-transparent {\n  border-left-color: transparent;\n}\n\n.border-r-transparent {\n  border-right-color: transparent;\n}\n\n.border-t-black {\n  --tw-border-opacity: 1;\n  border-top-color: rgb(0 0 0 / var(--tw-border-opacity));\n}\n\n.\\!bg-brand-black {\n  --tw-bg-opacity: 1 !important;\n  background-color: rgb(18 18 18 / var(--tw-bg-opacity)) !important;\n}\n\n.\\!bg-brand-red {\n  --tw-bg-opacity: 1 !important;\n  background-color: rgb(229 31 20 / var(--tw-bg-opacity)) !important;\n}\n\n.bg-\\[\\#d0011c\\] {\n  --tw-bg-opacity: 1;\n  background-color: rgb(208 1 28 / var(--tw-bg-opacity));\n}\n\n.bg-gray-100 {\n  --tw-bg-opacity: 1;\n  background-color: rgb(243 244 246 / var(--tw-bg-opacity));\n}\n\n.bg-gray-300 {\n  --tw-bg-opacity: 1;\n  background-color: rgb(209 213 219 / var(--tw-bg-opacity));\n}\n\n.bg-gray-50 {\n  --tw-bg-opacity: 1;\n  background-color: rgb(249 250 251 / var(--tw-bg-opacity));\n}\n\n.bg-gray-950 {\n  --tw-bg-opacity: 1;\n  background-color: rgb(3 7 18 / var(--tw-bg-opacity));\n}\n\n.bg-stone-950 {\n  --tw-bg-opacity: 1;\n  background-color: rgb(12 10 9 / var(--tw-bg-opacity));\n}\n\n.bg-transparent {\n  background-color: transparent;\n}\n\n.bg-white {\n  --tw-bg-opacity: 1;\n  background-color: rgb(255 255 255 / var(--tw-bg-opacity));\n}\n\n.bg-white\\/50 {\n  background-color: rgb(255 255 255 / 0.5);\n}\n\n.bg-yellow-50 {\n  --tw-bg-opacity: 1;\n  background-color: #ffffff;\n}\n\n.bg-opacity-10 {\n  --tw-bg-opacity: 0.1;\n}\n\n.bg-opacity-70 {\n  --tw-bg-opacity: 0.7;\n}\n\n.bg-none {\n  background-image: none;\n}\n\n.fill-gray-600 {\n  fill: #4b5563;\n}\n\n.fill-red-500 {\n  fill: #dd2946;\n}\n\n.object-contain {\n  -o-object-fit: contain;\n     object-fit: contain;\n}\n\n.object-cover {\n  -o-object-fit: cover;\n     object-fit: cover;\n}\n\n.\\!p-4 {\n  padding: 1rem !important;\n}\n\n.p-0 {\n  padding: 0px;\n}\n\n.p-1 {\n  padding: 0.25rem;\n}\n\n.p-4 {\n  padding: 1rem 0;\n}\n\n.p-8 {\n  padding: 2rem;\n}\n\n.\\!py-2 {\n  padding-top: 0.5rem !important;\n  padding-bottom: 0.5rem !important;\n}\n\n.px-2 {\n  padding-left: 0.5rem;\n  padding-right: 0.5rem;\n}\n\n.px-3 {\n  padding-left: 0.75rem;\n  padding-right: 0.75rem;\n}\n\n.px-4 {\n  padding-left: 1rem;\n  padding-right: 1rem;\n}\n\n.px-6 {\n  padding-left: 1.5rem;\n  padding-right: 1.5rem;\n}\n\n.py-1 {\n  padding-top: 0.25rem;\n  padding-bottom: 0.25rem;\n}\n\n.py-2 {\n  padding-top: 0.5rem;\n  padding-bottom: 0.5rem;\n}\n\n.py-8 {\n  padding-top: 2rem;\n  padding-bottom: 2rem;\n}\n\n.pb-1 {\n  padding-bottom: 0.25rem;\n}\n\n.pb-1\\.5 {\n  padding-bottom: 0.375rem;\n}\n\n.pb-14 {\n  padding-bottom: 3.5rem;\n}\n\n.pb-16 {\n  padding-bottom: 4rem;\n}\n\n.pl-0 {\n  padding-left: 0px;\n}\n\n.pl-1 {\n  padding-left: 0.25rem;\n}\n\n.pl-4 {\n  padding-left: 1rem;\n}\n\n.pr-0 {\n  padding-right: 0px;\n}\n\n.pr-4 {\n  padding-right: 1rem;\n}\n\n.pt-10 {\n  padding-top: 2.5rem;\n}\n\n.pt-4 {\n  padding-top: 1rem;\n}\n\n.text-center {\n  text-align: center;\n}\n\n.text-right {\n  text-align: right;\n}\n\n.\\!text-sm {\n  font-size: 0.875rem !important;\n  line-height: 1.25rem !important;\n}\n\n.\\!text-xs {\n  font-size: 0.75rem !important;\n  line-height: 1rem !important;\n}\n\n.text-3xl {\n  font-size: 1.875rem;\n  line-height: 2.25rem;\n}\n\n.text-base {\n  font-size: 1rem;\n  line-height: 1.5rem;\n}\n\n.text-lg {\n  font-size: 1.125rem;\n  line-height: 1.75rem;\n}\n\n.text-sm {\n  font-size: 0.875rem;\n  line-height: 1.25rem;\n} \n\n.text-xl {\n  font-size: 1.25rem;\n  line-height: 1.75rem;\n}\n\n.text-xs {\n  font-size: 0.75rem;\n  line-height: 1rem;\n}\n\n.font-bold {\n  font-weight: 700;\n}\n\n.font-light {\n  font-weight: 300;\n}\n\n.font-semibold {\n  font-weight: 600;\n}\n\n.leading-tight {\n  line-height: 1.25;\n}\n\n.text-gray-200 {\n  --tw-text-opacity: 1;\n  color: rgb(229 231 235 / var(--tw-text-opacity));\n}\n\n.text-gray-500 {\n  --tw-text-opacity: 1;\n  color: rgb(107 114 128 / var(--tw-text-opacity));\n}\n\n.text-gray-600 {\n  --tw-text-opacity: 1;\n  color: rgb(75 85 99 / var(--tw-text-opacity));\n}\n\n.text-gray-950 {\n  --tw-text-opacity: 1;\n  color: rgb(3 7 18 / var(--tw-text-opacity));\n}\n\n.text-stone-100 {\n  --tw-text-opacity: 1;\n  color: rgb(245 245 244 / var(--tw-text-opacity));\n}\n\n.text-white {\n  --tw-text-opacity: 1;\n  color: rgb(255 255 255 / var(--tw-text-opacity));\n}\n\n.opacity-0 {\n  opacity: 0;\n}\n\n.opacity-100 {\n  opacity: 1;\n}\n\n.opacity-50 {\n  opacity: 0.5;\n}\n\n.opacity-70 {\n  opacity: 0.7;\n}\n\n.shadow {\n  --tw-shadow: 0 1px 3px 0 rgb(0 0 0 / 0.1), 0 1px 2px -1px rgb(0 0 0 / 0.1);\n  --tw-shadow-colored: 0 1px 3px 0 var(--tw-shadow-color), 0 1px 2px -1px var(--tw-shadow-color);\n  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);\n}\n\n.shadow-lg {\n  --tw-shadow: 0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1);\n  --tw-shadow-colored: 0 10px 15px -3px var(--tw-shadow-color), 0 4px 6px -4px var(--tw-shadow-color);\n  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);\n}\n\n.outline-none {\n  outline: 2px solid transparent;\n  outline-offset: 2px;\n}\n\n.filter {\n  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);\n}\n\n.transition-all {\n  transition-property: all;\n  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);\n  transition-duration: 150ms;\n}\n\nbutton.addhertonimg {position: relative;bottom: 30px;left: 10px;}\n\nbutton.removehertonimg {position: relative;bottom: 30px;left: 10px;}  \n\n.transition-opacity {\n  transition-property: opacity;\n  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);\n  transition-duration: 150ms;\n}\n\n.transition-shadow {\n  transition-property: box-shadow;\n  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);\n  transition-duration: 150ms;\n}\n\n.will-change-transform {\n  will-change: transform;\n}\n\nhtml {\n  scroll-behavior: smooth;\n}\n\n.select {\n  width: 100%;\n  flex: 1 1 0%;\n  resize: none;\n  border-radius: 0.375rem;\n  border-width: 1px;\n  --tw-border-opacity: 1;\n  border-color: rgb(209 213 219 / var(--tw-border-opacity));\n  padding: 1rem;\n  padding-top: 0.75rem;\n  padding-bottom: 0.75rem;\n  font-size: 1rem;\n  line-height: 1.5rem;\n  outline: 2px solid transparent;\n  outline-offset: 2px;\n  --tw-ring-opacity: 1;\n  --tw-ring-color: rgb(156 163 175 / var(--tw-ring-opacity));\n}\n\n.select:focus {\n  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);\n  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(1px + var(--tw-ring-offset-width)) var(--tw-ring-color);\n  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);\n}\n\n@media (min-width: 992px) {\n\n  .select {\n    font-size: 0.875rem;\n    line-height: 1.25rem;\n  }\n}\n\n.textarea {\n  box-sizing: border-box;\n  width: 100%;\n  flex: 1 1 0%;\n  resize: none;\n  border-radius: 0.375rem;\n  border-width: 1px;\n  --tw-border-opacity: 1;\n  border-color: rgb(156 163 175 / var(--tw-border-opacity));\n  padding: 1rem;\n  font-size: 1rem;\n  line-height: 1.5rem;\n  outline: 2px solid transparent;\n  outline-offset: 2px;\n  --tw-ring-opacity: 1;\n  --tw-ring-color: rgb(156 163 175 / var(--tw-ring-opacity));\n}\n\n.textarea:focus,.select:focus {\n border: 1px solid #dd2946;box-shadow: none; \n\n}\n\n@media (min-width: 992px) {\n\n  .textarea {\n    font-size: 0.875rem;\n    line-height: 1.1rem;\n  }\n}\n\n.button {\n  -webkit-user-select: none;\n     -moz-user-select: none;\n          user-select: none;\n  border-radius: 0.5rem;\n  --tw-bg-opacity: 1;\n  background-color: rgb(17 24 39 / var(--tw-bg-opacity));\n  padding-top: 1rem;\n  padding-bottom: 1rem;\n  padding-left: 1.5rem;\n  padding-right: 1.5rem;\n  font-size: 0.875rem;\n  line-height: 1.25rem;\n  --tw-text-opacity: 1;\n  color: rgb(255 255 255 / var(--tw-text-opacity));\n  --tw-shadow: 0 20px 25px -5px rgb(0 0 0 / 0.1), 0 8px 10px -6px rgb(0 0 0 / 0.1);\n  --tw-shadow-colored: 0 20px 25px -5px var(--tw-shadow-color), 0 8px 10px -6px var(--tw-shadow-color);\n  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);\n  transition-property: all;\n  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);\n  transition-duration: 150ms;\n}\n\n .gnrateart:hover {box-shadow: 0 0 5px grey;font-size: 15px;}\n\n.button:active {\n  --tw-bg-opacity: 1;\n  background-color: rgb(31 41 55 / var(--tw-bg-opacity));\n  --tw-shadow: 0 0 #0000;\n  --tw-shadow-colored: 0 0 #0000;\n  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);\n}\n\n:disabled,\n.disabled {\n  opacity: 0.5;\n  pointer-events: none;\n  cursor: not-allowed;\n} \n\n button.button.md:!px-12.md:w-auto.w-full.!bg-brand-red:hover {opacity:o.6;}\n\n   \n\n.step-icon {\n  margin: 0px;\n  display: flex;\n  height: 1.75rem;\n  width: 1.75rem;\n  align-items: center;\n  justify-content: center;\n  border-radius: 9999px;\n  border-width: 1px;\n  border-style: solid;\n  --tw-border-opacity: 1;\n  border-color: rgb(120 113 108 / var(--tw-border-opacity));\n  --tw-bg-opacity: 1;\n  background-color: rgb(18 18 18 / var(--tw-bg-opacity));\n  font-size: 0.875rem;\n  line-height: 1.25rem;\n  --tw-text-opacity: 1;\n  color: rgb(255 255 255 / var(--tw-text-opacity));\n}\n\n@media (min-width: 992px) {\n\n  .step-icon {\n    font-size: 0.875rem;\n    line-height: 1.25rem;\n  }\n}\n\na[data-disabled=\"true\"] {\n  -webkit-user-select: none;\n     -moz-user-select: none;\n          user-select: none;\n  pointer-events: none;\n  cursor: progress;\n}\n\n.hover\\:fill-red-500:hover {\n  fill: #ef4444;background: transparent !important;\n}\n\n.hover\\:text-red-500:hover {\n  --tw-text-opacity: 1;\n  color: rgb(239 68 68 / var(--tw-text-opacity));background: transparent !important;\n}\n\n.hover\\:opacity-75:hover {\n  opacity: 0.75;\n}\n\n.hover\\:brightness-75:hover {\n  --tw-brightness: brightness(.75);\n  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);\n}\n\n.active\\:border-gray-700:active {\n  --tw-border-opacity: 1;\n  border-color: rgb(55 65 81 / var(--tw-border-opacity));\n}\n\n.active\\:bg-yellow-200:active {\n  --tw-bg-opacity: 1;\n  background-color: rgb(254 240 138 / var(--tw-bg-opacity));\n}\n\n.active\\:fill-red-600:active {\n  fill: #dc2626;\n}\n\n.active\\:text-red-600:active {\n  --tw-text-opacity: 1;\n  color: rgb(220 38 38 / var(--tw-text-opacity));\n}\n\n.group:hover .group-hover\\:opacity-100 {\n  opacity: 1;\n} \n\n.relative.mb-24.border-8.shadow-lg.border-gray-950:hover .group-hover\\:opacity-100 {\n opacity: 1 !important;\n}\n\n.custom-white-background{background-color:white} \n\n.group:hover .group-hover\\:shadow-xl {\n  --tw-shadow: 0 20px 25px -5px rgb(0 0 0 / 0.1), 0 8px 10px -6px rgb(0 0 0 / 0.1);\n  --tw-shadow-colored: 0 20px 25px -5px var(--tw-shadow-color), 0 8px 10px -6px var(--tw-shadow-color);\n  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);\n}\n\n@media (min-width: 640px) {\n\n  .sm\\:px-0 {\n    padding-left: 0px;\n    padding-right: 0px;\n  }\n}\n\n@media (min-width: 992px) {\n\n  .md\\:ml-8 {\n    margin-left: 0rem;\n  }\n\n  .md\\:block {\n    display: block;\n  }\n\n  .md\\:flex {\n    display: flex;\n  }\n\n  .md\\:hidden {\n    display: none;\n  }\n\n  .md\\:h-20 {\n    height: 5rem;\n  }\n\n  .md\\:h-\\[590px\\] {\n    height: 590px;\n  }\n\n  .md\\:min-h-\\[3rem\\] {\n    min-height: 3rem;\n  }\n\n  .md\\:min-h-\\[8rem\\] {\n    min-height: 5rem;\n  }\n\n  .md\\:w-5 {\n    width: 1.25rem;\n  }\n\n  .md\\:w-auto {\n    width: auto;\n  }\n\n  .md\\:flex-\\[0_1_16prem\\] {\n    flex: 0 1 16prem;\n  }\n\n  .md\\:scale-100 {\n    --tw-scale-x: 1;\n    --tw-scale-y: 1;\n    transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));\n  }\n\n  .md\\:flex-row {\n    flex-direction: row;\n  }\n\n  .md\\:items-center {\n    align-items: center;\n  }\n\n  .md\\:justify-end {\n    justify-content: flex-end;\n  }\n\n  .md\\:justify-center {\n    justify-content: center;\n  }\n\n  .md\\:gap-16 {\n    gap: 4rem;\n  }\n\n  .md\\:gap-8 {\n    gap: 1rem;\n  }\n\n  .md\\:\\!px-12 {\n    padding-left: 3rem !important;\n    padding-right: 3rem !important;\n  }\n\n  .md\\:px-0 {\n    padding-left: 0px;\n    padding-right: 0px;\n  }.p-r-5{     padding-right: 3rem;}    \n\n  .md\\:pl-0 {\n    padding-left: 0px;\n  }\n\n  .md\\:pl-10 {\n    padding-left: 0rem;\n  }\n\n  .md\\:pl-8 {\n    padding-left: 0rem;\n  }\n\n  .md\\:pr-0 {\n    padding-right: 0px;\n  }\n\n  .md\\:pt-8 {\n    padding-top: 2rem;\n  }\n\n .bpst\n { \n  position: absolute;  \n  right: 7px;    height: 35px;width: 35px;         padding: 0 !important;   \nbottom: 5px;}\n\n .md\\:text-3xl {\n    font-size: 1.875rem;\n    line-height: 2.25rem;\n  }\n\n  .md\\:text-sm {\n    font-size: 0.875rem;\n    line-height: 1.25rem;\n  }\n}.mx-450 {    width: 500px;flex: 0 0 450px;    background: rgb(255 255 255);  padding: 25px;    box-shadow: 0 0 10px #bdbdbd;    margin-left: 15px;    border-radius: 16px;}::-webkit-scrollbar-track{-webkit-box-shadow:inset 0 0 6px rgba(0,0,0,0.3);border: 1px solid #000; border-radius:20px;background-color:#F5F5F5} ::-webkit-scrollbar{width:16px;background-color:#F5F5F5}::-webkit-scrollbar-thumb{border-radius:20px;background-color:#dd2946;    border: 0px solid #000;}::-webkit-scrollbar-thumb:hover {background-color:#000; }        .lxmd { min-height: 3rem !important; padding: 5px 8px; padding-right: 50px;}p.text-sm.font-medium {  font-size: 10px;    line-height: 1.25rem;}.gnrateart { width: 100%; background: #000000 !important; }.Flex3art { background: #ffffff; height: 100%; position: absolute; width:400px; right: 0; top: -16px; box-shadow: 0 0 15px #ababab; padding: 25px;border-bottom: 1px solid rgb(229, 231, 235);    padding-bottom: 55px; }.w-50 {width: 50%;}.fwrap{ row-gap: 8px; display: flex; flex-wrap: wrap; justify-content: space-between; align-items: center;}.fwrap li {flex: 0 0 47%;}.flex-column { flex-direction: column; margin-top: -20px; } button.edit-btn { position: absolute; right: 10px; bottom: 8px; color: #fff; z-index: 9999; }.edit-btn img {width:25px;}  .orderbutton { position: relative; z-index: 999; top: -8px; background: #ffffff !important; color: #000000; border: 2px solid #000000; font-weight: bold; opacity: 1 !important;transition: 0.3s all;    padding-left: 3rem;padding-right: 3rem; } .orderbutton:hover { background: #000000 !important; color: #fff; } .pt-12 {padding-top: 2.5rem;}.bg-reds { background-color: rgb(0 0 0 / 55%); color: #fff !important; }.relative.group:hover .border-gray-400 { border-color: #dd2946; } .CanButton {     width: 90px;border: none; color: #dd2946; font-weight: bold; }.SaveButton { border: 2px solid #dd2946; background: transparent; color: #dd2946; font-weight: bold; padding: 9px 25px !important; } .SaveButton:hover { border: 2px solid #dd2946; background: #dd2946; color: #fff;  }.flex.items-center.justify-center.pt-4 { display: flex; flex-direction: row-reverse; justify-content: center; gap: 10px; }.CanButton:focus {outline: none;}.varitcalload { min-height: 8.4vw; }.squareload { min-height: 6vw; } .horiload { min-height: 5vw; }.mysleect { opacity: 0; height: 0; padding: 0; margin: 0; }.cursor-pointer { padding: 10px; gap: 20px;}.bg-gray-200 { background: rgb(217 217 217);}.cursor-pointer img {  border-radius: 10px;} label.cursor-pointer>div { display:flex; flex-direction:row-reverse; align-content:center; justify-content:center; align-items:center; gap:10px; max-width: 100%;word-break: break-all;overflow-wrap: anywhere;} .cursor-pointer:hover {  background:rgb(217 217 217);  color: #dd2946;}.mydropdown {    margin-top: -26px;    min-height: 62px;}.max-h-60 { max-height: 320px;  overflow:auto;z-index: 99;    bottom: 63px;border-radius: 2px;padding: 0 10px;  }li.ddd {  display: flex;     border-radius: 6px;width: 33%;float: left;flex-direction: column;    margin-top: 8px;    gap: 10px;}button.border.border-gray-300.rounded.p-2.bg-white.w-full.text-left.flex.items-center {padding: 4px 5px;     border-radius: 8px;display: flex;  gap: 20px;}button.border.border-gray-300.rounded.p-2.bg-white.w-full.text-left.flex.items-center:hover{ border: 1px solid #757575;} button.border.border-gray-300.rounded.p-2.bg-white.w-full.text-left.flex.items-center:focus {  border: 1px solid #dd2946;}button.border.border-gray-300.rounded.p-2.bg-white.w-full.text-left.flex.items-center:after { content: ''; background: url(https://cdn.shopify.com/s/files/1/0736/6996/8165/files/Chevron_down.png?v=1751446647); width: 17px; height: 14px; right: 12px; position: absolute;}.h-5.w-5 { width: 50px;border-radius: 50%;}.w75{width:75px!important;height: 75px;border-radius: 50% !important;}.svg-inline--fa {padding: 0 !important;} .select-none:active { border: 2px solid #dd2946; color: #000 !important; background: #fff !important;}.mfull a { position: absolute; height: 100%; width: 100%; left: 0; top: 0; bottom: 0; right: 0; display: flex; flex-direction: column; align-content: center; justify-content: center; align-items: center; } .select-none:hover { border: 2px solid #dd2946; color: #000 !important; background: #fff !important;} div#suggetionboxdiv {    text-align: center;}input#fileInput {    width: 100%;    overflow: hidden !important;    max-width: 100%;    position: absolute;    left: 0;}span.croptext {    font-size: 14px;    text-align: center;    padding-left: 12px;    position: relative;    top: -16px;    color: #dd2946;} button#generate-button {    display: flex;    align-content: center;    justify-content: center;    align-items: center;    gap: 9px;    font-weight: 500;    font-size: 18px;}      #generate-button img {    width: 27px;}                                                                                                                                                                                                                                                             @media(max-width:1499px){.mx-450 { width: 330px; flex: 0 0 390px; }.w-full.overflow-x-auto.mymobile1 { flex: 0 0 63%; }.Flex3art {width: 252px;}          .posabtbtm {width: 252px !important;    font-size: 10px;}.w-50 {  width: 61%;}}                                                                                                                                                                                                                                             @media only screen and (min-device-width: 768px) and (max-device-width: 1024px)   and (orientation: landscape) { .mx-450 { width: 343px; flex: 0 0 310px; } .text-sm {     font-size: 10px; } .gap-0 {gap: 1rem !important;}.w-full.overflow-x-auto.mymobile1 {  flex: 0 0 80%; } .fwrap { flex-wrap: wrap; gap: 6px; } div#frame{    overflow-x: hidden;} .Flex3art { width: 23%; padding: 15px; } } @media(max-width:991px){ .mx-450 { width: 100%; flex: 0 0 450px; background: rgb(255 255 255); padding: 0px; box-shadow: none; margin-left: 0; border-radius: 0;max-width: 500px;margin: auto;margin-top: 20px;}.Flex3art { background: #ffffff; height: 100%; position: relative; width: 100%; right: 0; top: 0; box-shadow: none; padding: 15px; order: 1; }.mymobile1 { order: 2;}.fwrap { flex-wrap: wrap; gap: 5px; }svg.svg-inline--fa { padding: 0 !important; gap: 0 !important; }.mymobile2 { position: relative;align-items: center; }.w-50.relative { width: 93%;    margin: auto !important; }.mymobile1 .object-contain { -o-object-fit: contain; object-fit: none; }.pt-12 { padding-top: 0; }.w-full.text-left.text-lg.font-semibold.mb-4 { display: none; }button.text-sm.p-1.mb-2.px-3.rounded-lg.mt-2.border.select-none { position: absolute; z-index: 9; width: 97px; right: 3px; top: -5px; background: #fff; }.fwrap li { flex: 0 0 62px; }.pt-4 { padding-top: 5px;}.mb-24 { margin-bottom: 0;}img.object-contain.h-8.mx-auto { max-width: 84%; object-fit: contain;}.d-desktop{display:none;}.border-2 { border-width: 2px;}.rounded-md { border-radius: 0;}.pl-4 { padding-left: 1rem;  padding-right: 1rem;}.justify-end { justify-content: end; right: 8px; top: -16px; border-radius: 0 !important; }.bg-white1 path { fill: #fff; }.bpst { right: 8px !important; position: absolute; bottom: 6px; width: 35px; height: 35px; padding: 0; }.bulb { padding: 0 !important; gap: 0; height: 35px; width: 35px; }.h-14 { height: 5.5rem; }.bg-white1 { margin-top: -81px;}.max-h-60 { max-height: 350px;  overflow: auto;  z-index: 99;  top: -350px;   border-radius: 8px;}img.hori { height: 316px; object-fit: cover;        width: 500px; }.sss img {height: 450px;}}.sss span { position: absolute; top: 0; bottom: 0; right: 0; left: 0; color: #ffffff; font-weight: bold; font-size: 18px; padding-top: 0;     background-color: rgb(0 0 0 / 39%);    text-transform: uppercase;    display: none; height: 100%; align-content: center; justify-content: center; align-items: center; } @media only screen and (min-device-width: 820px) and (max-device-width: 1180px) and (orientation: portrait) { .w-50.relative {   width: 93%;  margin: auto; height: 560px; } .sss img {   height: 508px; } }                                                                                                                                                                                                         @media only screen and  (min-width: 1200px) and (max-width: 1350px)  {     .mx-450 {        flex: 0 0 360px;    padding: 16px;}.Flex3art {width: 250px;}.gap-0 {        gap: 1rem !important;}.w-50 {    width: 60%;} .w-full.overflow-x-auto.mymobile1 {flex: 0 0 63%; }.fwrap {    flex-wrap: wrap;    gap: 6px;}.fwrap li {    flex: 0 0 47%;} .horizontalbox .custom-white-background { height: 206px !important;  width: 275px !important;  } .squarebox .custom-white-background { height: 360px !important;  width: 360px !important;  }   .orderbutton {padding-left: 1rem; padding-right: 1rem;} .verticalbox .custom-white-background {  height: 390px !important;  width: 293px !important;} }                                                                                                                                                                                                                                                                                                                                                                                                         @media only screen and  (min-width: 992px) and (max-width: 1199px)  {     .mx-450 {        flex: 0 0 360px;    padding: 16px;}.Flex3art {width: 220px;}.gap-0 {        gap: 1rem !important;}.w-50 {    width: 60%;} .w-full.overflow-x-auto.mymobile1 {flex: 0 0 62%; }.fwrap {    flex-wrap: wrap;    gap: 6px;}.fwrap li {    flex: 0 0 47%;} .horizontalbox .custom-white-background { height: 247px !important;  width: 330px !important;  } .squarebox .custom-white-background { height: 330px !important;  width: 330px !important;  }   .orderbutton {padding-left: 1rem; padding-right: 1rem;} .verticalbox .custom-white-background {  height: 350px !important;  width: 263px !important;}.text-sm {        font-size: 14px;    } p.text-sm.font-medium {  font-size: 11px;}}                                                                                                                                           .cst-mladjustradio {margin-left: 1.5rem; margin-right: 5px;}         .paddlefnone {padding-left: 0 !important;}                                                                                                                                                                                                                                                                              .bpsta {  position: absolute;  right: 12px;    bottom: 15px;    height: 35px;    width: 35px;    padding: 0;} textarea.popup-input {    outline: none !important;}  .sss:hover span { display:flex; }span.inline-block.mr-1 { background: #fefce8;  border: 1px solid #fad233;  border-radius: 50%;  padding: 0px;}.posabtbtm {   position: fixed;bottom: -15px;  background: #ffffff;  padding: 16px 10px;  width: 400px;  right: 0;   z-index: 99;display: flex;  align-content: center;  justify-content: flex-start;  align-items: center;    gap: 5px;    color: #000;}.hovehideshow { padding-left: 0px;font-size: 0.875rem;}.hovehideshow:hover {  color: #dd2946;}label.text-sm.labels {    padding-left: 5px;cursor: pointer;}                                                                                                                                                                                                                                                                                                                            @media only screen and  (min-width: 1301px) and (max-width: 1400px) { .fwrap { flex-wrap: wrap;  gap: 3px;} }@media only screen and  (min-width: 992px) and (max-width: 1300px) {     .posabtbtm { width: 219px !important; background: transparent;        font-size: 9px;   }.fwrap { flex-wrap: wrap;  gap: 3px;} }@media(max-width:768px){.bg-reds {  opacity: 0;} .posabtbtm {  display: none;}.Flex3art {     padding-bottom: 0;   }.orderbutton {  box-shadow: none;}.justify-end {    top: 0px;display: flex;    align-items: flex-start;  }.flex-column {  flex-direction: column; margin-top: 24px;}.bg-white1 {    margin-top: 0;  }::-webkit-scrollbar-track{-webkit-box-shadow:inset 0 0 6px rgba(0,0,0,0.3);border: 1px solid #eee; border-radius:0px;background-color:#F5F5F5} ::-webkit-scrollbar{width:10px;background-color:#F5F5F5}::-webkit-scrollbar-thumb{border-radius:0px;background-color:#dd2946;    border: 0px solid #000;}}@media(max-width:390px){.text-sm {   font-size: 0.80rem;   line-height: 1.25rem;}p.text-sm.font-medium { font-size: 10.5px;} }a.underline.text-blue-600.cursor-pointer.csd { color:#dd2946; padding: 0; text-decoration: underline;  background: none !important;  margin-left: 0px;}.posabtbtm strong {    position: relative;    top: 1px;} \n  \n button#openPopupBtn {position: absolute;left: 15px;top: 4px;z-index: 9999;}\n\n @media (max-width: 576px){button#openPopupBtn {display: none !important;}}.thumb-arrow { display:none; }                                                                                                                                                                                                                                                                                                                                                                                                                                             @media(max-width:991px){div#image_history_tab .scrolldiv {  overflow-y: auto;  overflow-x: hidden;  height: calc(100% - 0px);   scrollbar-width: none; /* Firefox */  -ms-overflow-style: none; /* IE */}div#image_history_tab .scrolldiv::-webkit-scrollbar{  display: none;}                                                                                                                                               .relative.mb-24.border-8.shadow-lg.border-gray-950:hover .group-hover\\:opacity-100 {\n opacity: 0 !important;\n}  .posabtbtm {  display: none;}.thumb-arrow { display:block; } .horizontalbox .custom-white-background { height: 206px !important;  width: 275px !important;  } .squarebox .custom-white-background { height: 275px !important;  width: 275px !important;  }    .verticalbox .custom-white-background {  height: 350px !important;  width: 263px !important;}    .mymobile2 { position: relative;       align-items: center; justify-content: flex-start; }.w-50.relative {height: 410px; }.orderbutton { padding-left: 1rem; padding-right: 1rem;}div#image_history_tab { position: absolute; overflow: hidden; height: 367px;        width: 87px;  padding: 0;     top: 65px;  margin-top: 0;     z-index: 999;    padding-top: 9px !important;   padding-bottom: 12px !important;   background: transparent !important;        border: none !important;    } .imageHistorySquarebox {height: 290px !important;   top: 60px !important;        padding-top: 12px !important;padding-bottom: 12px !important;   border: none; }.imageHistoryHorizontalbox {height: 250px !important;   top: 60px !important;        padding-top: 12px !important;padding-bottom: 12px !important;   border: none; }.horizontalbox { height: 261px !important;}    .mymobile2 {   top: -16px; }  .w-50.relative {    width: 94%; }button.thumb-arrow.down-arrow { position: absolute;    z-index: 20;  color: #000;  left: 18px;         bottom: -0px; font-size: 25px; padding: 0px 5px; border-radius: 20px;        transform: rotate(90deg);        background: #fff; width: 28px;       height: 28px;   line-height: 15px;}button.thumb-arrow.up-arrow { position: absolute; z-index: 20; color: #000; left: 18px;    top: -0px; font-size: 25px; padding: 0px 5px; border-radius: 20px;        transform: rotate(90deg);        background: #fff;    width: 28px;     height: 28px;     line-height: 17px;}#image_history_tab::-webkit-scrollbar {display: none;} .thumbs-list{    transform: translateY(0px);}p.font-bold {  font-size: 12px;  font-weight: 500;}.border-none.bg-transparent.flex.items-center.justify-center.h-8.w-8.rounded-full {  height: 1.5rem;}.squarebox {    height: 300px !important;}.verticalbox { height: 392px !important;} }                             @media(max-width:392px){div#image_history_tab { position: absolute;    height: 350px;  width: 75px;} .w-50.relative {  width: 95%;  } .horizontalbox .custom-white-background { height: 190px !important;  width: 255px !important;  }   .squarebox .custom-white-background { height: 255px !important;  width: 255px !important;  }  .verticalbox .custom-white-background {  height: 350px !important;   width: 249px !important;   } }  @media(max-width:350px){div#image_history_tab { position: absolute;    height: 350px;  width: 75px;} .w-50.relative {  width: 95%;  } .horizontalbox .custom-white-background { height: 180px !important;  width: 235px !important;  }    .squarebox .custom-white-background { height: 235px !important;  width: 235px !important;  }  .verticalbox .custom-white-background {  height: 340px !important;   width: 239px !important;   } } .bulb,.bpsta,.bpst {  background: #fff !important;} .w50x {    width: 50%;    margin-bottom: -28px;}                                                                                                                                                                                                                                                                                                                                                                                          @media only screen   and (min-device-width: 768px)   and (max-device-width: 991px)  {   .posabtbtm {  display: none;}  .Flex3art {        right: 15%; }    .horizontalbox .custom-white-background {   height: 250px !important;  width: 350px !important;  }  .w-50.relative {     width: 500px;   }img.object-contain.h-8.mx-auto{margin-top: 15px; margin-bottom: 15px;   }     .imageHistoryHorizontalbox {    top: 113px !important;        height: 290px !important;} .imageHistorySquarebox {    top: 111px !important;}.squarebox .custom-white-background {  height: 350px !important;  width: 350px !important; }  .imageHistorySquarebox { height: 373px !important;}     .verticalbox .custom-white-background {   height: 350px !important;    width: 282px !important; }.imageHistoryVerticalbox {    top: 112px !important;}    .mymobile2 {     top: 0; }     .horizontalbox {    height: 325px !important;  }} \n";
function _isPlaceholder(a) {
  return (
    a != null && typeof a === "object" && a["@@functional/placeholder"] === true
  );
}
function _curry1(fn) {
  return function f1(a) {
    if (arguments.length === 0 || _isPlaceholder(a)) {
      return f1;
    } else {
      return fn.apply(this, arguments);
    }
  };
}
function _curry2(fn) {
  return function f2(a, b2) {
    switch (arguments.length) {
      case 0:
        return f2;
      case 1:
        return _isPlaceholder(a)
          ? f2
          : _curry1(function (_b2) {
              return fn(a, _b2);
            });
      default:
        return _isPlaceholder(a) && _isPlaceholder(b2)
          ? f2
          : _isPlaceholder(a)
          ? _curry1(function (_a2) {
              return fn(_a2, b2);
            })
          : _isPlaceholder(b2)
          ? _curry1(function (_b2) {
              return fn(a, _b2);
            })
          : fn(a, b2);
    }
  };
}
function _concat(set1, set2) {
  set1 = set1 || [];
  set2 = set2 || [];
  var idx;
  var len1 = set1.length;
  var len2 = set2.length;
  var result = [];
  idx = 0;
  while (idx < len1) {
    result[result.length] = set1[idx];
    idx += 1;
  }
  idx = 0;
  while (idx < len2) {
    result[result.length] = set2[idx];
    idx += 1;
  }
  return result;
}
function _arity(n, fn) {
  switch (n) {
    case 0:
      return function () {
        return fn.apply(this, arguments);
      };
    case 1:
      return function (a0) {
        return fn.apply(this, arguments);
      };
    case 2:
      return function (a0, a1) {
        return fn.apply(this, arguments);
      };
    case 3:
      return function (a0, a1, a2) {
        return fn.apply(this, arguments);
      };
    case 4:
      return function (a0, a1, a2, a3) {
        return fn.apply(this, arguments);
      };
    case 5:
      return function (a0, a1, a2, a3, a4) {
        return fn.apply(this, arguments);
      };
    case 6:
      return function (a0, a1, a2, a3, a4, a5) {
        return fn.apply(this, arguments);
      };
    case 7:
      return function (a0, a1, a2, a3, a4, a5, a6) {
        return fn.apply(this, arguments);
      };
    case 8:
      return function (a0, a1, a2, a3, a4, a5, a6, a7) {
        return fn.apply(this, arguments);
      };
    case 9:
      return function (a0, a1, a2, a3, a4, a5, a6, a7, a8) {
        return fn.apply(this, arguments);
      };
    case 10:
      return function (a0, a1, a2, a3, a4, a5, a6, a7, a8, a9) {
        return fn.apply(this, arguments);
      };
    default:
      throw new Error(
        "First argument to _arity must be a non-negative integer no greater than ten"
      );
  }
}
function _curryN(length, received, fn) {
  return function () {
    var combined = [];
    var argsIdx = 0;
    var left = length;
    var combinedIdx = 0;
    while (combinedIdx < received.length || argsIdx < arguments.length) {
      var result;
      if (
        combinedIdx < received.length &&
        (!_isPlaceholder(received[combinedIdx]) || argsIdx >= arguments.length)
      ) {
        result = received[combinedIdx];
      } else {
        result = arguments[argsIdx];
        argsIdx += 1;
      }
      combined[combinedIdx] = result;
      if (!_isPlaceholder(result)) {
        left -= 1;
      }
      combinedIdx += 1;
    }
    return left <= 0
      ? fn.apply(this, combined)
      : _arity(left, _curryN(length, combined, fn));
  };
}
var curryN = /* @__PURE__ */ _curry2(function curryN2(length, fn) {
  if (length === 1) {
    return _curry1(fn);
  }
  return _arity(length, _curryN(length, [], fn));
});
const curryN$1 = curryN;
function _curry3(fn) {
  return function f3(a, b2, c) {
    switch (arguments.length) {
      case 0:
        return f3;
      case 1:
        return _isPlaceholder(a)
          ? f3
          : _curry2(function (_b2, _c2) {
              return fn(a, _b2, _c2);
            });
      case 2:
        return _isPlaceholder(a) && _isPlaceholder(b2)
          ? f3
          : _isPlaceholder(a)
          ? _curry2(function (_a2, _c2) {
              return fn(_a2, b2, _c2);
            })
          : _isPlaceholder(b2)
          ? _curry2(function (_b2, _c2) {
              return fn(a, _b2, _c2);
            })
          : _curry1(function (_c2) {
              return fn(a, b2, _c2);
            });
      default:
        return _isPlaceholder(a) && _isPlaceholder(b2) && _isPlaceholder(c)
          ? f3
          : _isPlaceholder(a) && _isPlaceholder(b2)
          ? _curry2(function (_a2, _b2) {
              return fn(_a2, _b2, c);
            })
          : _isPlaceholder(a) && _isPlaceholder(c)
          ? _curry2(function (_a2, _c2) {
              return fn(_a2, b2, _c2);
            })
          : _isPlaceholder(b2) && _isPlaceholder(c)
          ? _curry2(function (_b2, _c2) {
              return fn(a, _b2, _c2);
            })
          : _isPlaceholder(a)
          ? _curry1(function (_a2) {
              return fn(_a2, b2, c);
            })
          : _isPlaceholder(b2)
          ? _curry1(function (_b2) {
              return fn(a, _b2, c);
            })
          : _isPlaceholder(c)
          ? _curry1(function (_c2) {
              return fn(a, b2, _c2);
            })
          : fn(a, b2, c);
    }
  };
}
const _isArray =
  Array.isArray ||
  function _isArray2(val) {
    return (
      val != null &&
      val.length >= 0 &&
      Object.prototype.toString.call(val) === "[object Array]"
    );
  };
function _isTransformer(obj) {
  return obj != null && typeof obj["@@transducer/step"] === "function";
}
function _dispatchable(methodNames, transducerCreator, fn) {
  return function () {
    if (arguments.length === 0) {
      return fn();
    }
    var obj = arguments[arguments.length - 1];
    if (!_isArray(obj)) {
      var idx = 0;
      while (idx < methodNames.length) {
        if (typeof obj[methodNames[idx]] === "function") {
          return obj[methodNames[idx]].apply(
            obj,
            Array.prototype.slice.call(arguments, 0, -1)
          );
        }
        idx += 1;
      }
      if (_isTransformer(obj)) {
        var transducer = transducerCreator.apply(
          null,
          Array.prototype.slice.call(arguments, 0, -1)
        );
        return transducer(obj);
      }
    }
    return fn.apply(this, arguments);
  };
}
const _xfBase = {
  init: function () {
    return this.xf["@@transducer/init"]();
  },
  result: function (result) {
    return this.xf["@@transducer/result"](result);
  },
};
function _arrayFromIterator(iter) {
  var list = [];
  var next;
  while (!(next = iter.next()).done) {
    list.push(next.value);
  }
  return list;
}
function _includesWith(pred, x2, list) {
  var idx = 0;
  var len = list.length;
  while (idx < len) {
    if (pred(x2, list[idx])) {
      return true;
    }
    idx += 1;
  }
  return false;
}
function _functionName(f) {
  var match = String(f).match(/^function (\w*)/);
  return match == null ? "" : match[1];
}
function _has(prop3, obj) {
  return Object.prototype.hasOwnProperty.call(obj, prop3);
}
function _objectIs(a, b2) {
  if (a === b2) {
    return a !== 0 || 1 / a === 1 / b2;
  } else {
    return a !== a && b2 !== b2;
  }
}
const _objectIs$1 = typeof Object.is === "function" ? Object.is : _objectIs;
var toString$1 = Object.prototype.toString;
var _isArguments = /* @__PURE__ */ (function () {
  return toString$1.call(arguments) === "[object Arguments]"
    ? function _isArguments2(x2) {
        return toString$1.call(x2) === "[object Arguments]";
      }
    : function _isArguments2(x2) {
        return _has("callee", x2);
      };
})();
var hasEnumBug = !(
  /* @__PURE__ */ {
    toString: null,
  }.propertyIsEnumerable("toString")
);
var nonEnumerableProps = [
  "constructor",
  "valueOf",
  "isPrototypeOf",
  "toString",
  "propertyIsEnumerable",
  "hasOwnProperty",
  "toLocaleString",
];
var hasArgsEnumBug = /* @__PURE__ */ (function () {
  return arguments.propertyIsEnumerable("length");
})();
var contains = function contains2(list, item) {
  var idx = 0;
  while (idx < list.length) {
    if (list[idx] === item) {
      return true;
    }
    idx += 1;
  }
  return false;
};
var keys =
  typeof Object.keys === "function" && !hasArgsEnumBug
    ? /* @__PURE__ */ _curry1(function keys2(obj) {
        return Object(obj) !== obj ? [] : Object.keys(obj);
      })
    : /* @__PURE__ */ _curry1(function keys3(obj) {
        if (Object(obj) !== obj) {
          return [];
        }
        var prop3, nIdx;
        var ks = [];
        var checkArgsLength = hasArgsEnumBug && _isArguments(obj);
        for (prop3 in obj) {
          if (_has(prop3, obj) && (!checkArgsLength || prop3 !== "length")) {
            ks[ks.length] = prop3;
          }
        }
        if (hasEnumBug) {
          nIdx = nonEnumerableProps.length - 1;
          while (nIdx >= 0) {
            prop3 = nonEnumerableProps[nIdx];
            if (_has(prop3, obj) && !contains(ks, prop3)) {
              ks[ks.length] = prop3;
            }
            nIdx -= 1;
          }
        }
        return ks;
      });
var type = /* @__PURE__ */ _curry1(function type2(val) {
  return val === null
    ? "Null"
    : val === void 0
    ? "Undefined"
    : Object.prototype.toString.call(val).slice(8, -1);
});
const type$1 = type;
function _uniqContentEquals(aIterator, bIterator, stackA, stackB) {
  var a = _arrayFromIterator(aIterator);
  var b2 = _arrayFromIterator(bIterator);
  function eq(_a2, _b2) {
    return _equals(_a2, _b2, stackA.slice(), stackB.slice());
  }
  return !_includesWith(
    function (b3, aItem) {
      return !_includesWith(eq, aItem, b3);
    },
    b2,
    a
  );
}
function _equals(a, b2, stackA, stackB) {
  if (_objectIs$1(a, b2)) {
    return true;
  }
  var typeA = type$1(a);
  if (typeA !== type$1(b2)) {
    return false;
  }
  if (
    typeof a["fantasy-land/equals"] === "function" ||
    typeof b2["fantasy-land/equals"] === "function"
  ) {
    return (
      typeof a["fantasy-land/equals"] === "function" &&
      a["fantasy-land/equals"](b2) &&
      typeof b2["fantasy-land/equals"] === "function" &&
      b2["fantasy-land/equals"](a)
    );
  }
  if (typeof a.equals === "function" || typeof b2.equals === "function") {
    return (
      typeof a.equals === "function" &&
      a.equals(b2) &&
      typeof b2.equals === "function" &&
      b2.equals(a)
    );
  }
  switch (typeA) {
    case "Arguments":
    case "Array":
    case "Object":
      if (
        typeof a.constructor === "function" &&
        _functionName(a.constructor) === "Promise"
      ) {
        return a === b2;
      }
      break;
    case "Boolean":
    case "Number":
    case "String":
      if (!(typeof a === typeof b2 && _objectIs$1(a.valueOf(), b2.valueOf()))) {
        return false;
      }
      break;
    case "Date":
      if (!_objectIs$1(a.valueOf(), b2.valueOf())) {
        return false;
      }
      break;
    case "Error":
      return a.name === b2.name && a.message === b2.message;
    case "RegExp":
      if (
        !(
          a.source === b2.source &&
          a.global === b2.global &&
          a.ignoreCase === b2.ignoreCase &&
          a.multiline === b2.multiline &&
          a.sticky === b2.sticky &&
          a.unicode === b2.unicode
        )
      ) {
        return false;
      }
      break;
  }
  var idx = stackA.length - 1;
  while (idx >= 0) {
    if (stackA[idx] === a) {
      return stackB[idx] === b2;
    }
    idx -= 1;
  }
  switch (typeA) {
    case "Map":
      if (a.size !== b2.size) {
        return false;
      }
      return _uniqContentEquals(
        a.entries(),
        b2.entries(),
        stackA.concat([a]),
        stackB.concat([b2])
      );
    case "Set":
      if (a.size !== b2.size) {
        return false;
      }
      return _uniqContentEquals(
        a.values(),
        b2.values(),
        stackA.concat([a]),
        stackB.concat([b2])
      );
    case "Arguments":
    case "Array":
    case "Object":
    case "Boolean":
    case "Number":
    case "String":
    case "Date":
    case "Error":
    case "RegExp":
    case "Int8Array":
    case "Uint8Array":
    case "Uint8ClampedArray":
    case "Int16Array":
    case "Uint16Array":
    case "Int32Array":
    case "Uint32Array":
    case "Float32Array":
    case "Float64Array":
    case "ArrayBuffer":
      break;
    default:
      return false;
  }
  var keysA = keys(a);
  if (keysA.length !== keys(b2).length) {
    return false;
  }
  var extendedStackA = stackA.concat([a]);
  var extendedStackB = stackB.concat([b2]);
  idx = keysA.length - 1;
  while (idx >= 0) {
    var key = keysA[idx];
    if (
      !(
        _has(key, b2) &&
        _equals(b2[key], a[key], extendedStackA, extendedStackB)
      )
    ) {
      return false;
    }
    idx -= 1;
  }
  return true;
}
var equals = /* @__PURE__ */ _curry2(function equals2(a, b2) {
  return _equals(a, b2, [], []);
});
const equals$1 = equals;
function _indexOf(list, a, idx) {
  var inf, item;
  if (typeof list.indexOf === "function") {
    switch (typeof a) {
      case "number":
        if (a === 0) {
          inf = 1 / a;
          while (idx < list.length) {
            item = list[idx];
            if (item === 0 && 1 / item === inf) {
              return idx;
            }
            idx += 1;
          }
          return -1;
        } else if (a !== a) {
          while (idx < list.length) {
            item = list[idx];
            if (typeof item === "number" && item !== item) {
              return idx;
            }
            idx += 1;
          }
          return -1;
        }
        return list.indexOf(a, idx);
      case "string":
      case "boolean":
      case "function":
      case "undefined":
        return list.indexOf(a, idx);
      case "object":
        if (a === null) {
          return list.indexOf(a, idx);
        }
    }
  }
  while (idx < list.length) {
    if (equals$1(list[idx], a)) {
      return idx;
    }
    idx += 1;
  }
  return -1;
}
function _includes(a, list) {
  return _indexOf(list, a, 0) >= 0;
}
function _map(fn, functor) {
  var idx = 0;
  var len = functor.length;
  var result = Array(len);
  while (idx < len) {
    result[idx] = fn(functor[idx]);
    idx += 1;
  }
  return result;
}
function _quote(s) {
  var escaped = s
    .replace(/\\/g, "\\\\")
    .replace(/[\b]/g, "\\b")
    .replace(/\f/g, "\\f")
    .replace(/\n/g, "\\n")
    .replace(/\r/g, "\\r")
    .replace(/\t/g, "\\t")
    .replace(/\v/g, "\\v")
    .replace(/\0/g, "\\0");
  return '"' + escaped.replace(/"/g, '\\"') + '"';
}
var pad = function pad2(n) {
  return (n < 10 ? "0" : "") + n;
};
var _toISOString =
  typeof Date.prototype.toISOString === "function"
    ? function _toISOString2(d) {
        return d.toISOString();
      }
    : function _toISOString3(d) {
        return (
          d.getUTCFullYear() +
          "-" +
          pad(d.getUTCMonth() + 1) +
          "-" +
          pad(d.getUTCDate()) +
          "T" +
          pad(d.getUTCHours()) +
          ":" +
          pad(d.getUTCMinutes()) +
          ":" +
          pad(d.getUTCSeconds()) +
          "." +
          (d.getUTCMilliseconds() / 1e3).toFixed(3).slice(2, 5) +
          "Z"
        );
      };
function _complement(f) {
  return function () {
    return !f.apply(this, arguments);
  };
}
function _arrayReduce(reducer, acc, list) {
  var index = 0;
  var length = list.length;
  while (index < length) {
    acc = reducer(acc, list[index]);
    index += 1;
  }
  return acc;
}
function _filter(fn, list) {
  var idx = 0;
  var len = list.length;
  var result = [];
  while (idx < len) {
    if (fn(list[idx])) {
      result[result.length] = list[idx];
    }
    idx += 1;
  }
  return result;
}
function _isObject(x2) {
  return Object.prototype.toString.call(x2) === "[object Object]";
}
var XFilter = /* @__PURE__ */ (function () {
  function XFilter2(f, xf) {
    this.xf = xf;
    this.f = f;
  }
  XFilter2.prototype["@@transducer/init"] = _xfBase.init;
  XFilter2.prototype["@@transducer/result"] = _xfBase.result;
  XFilter2.prototype["@@transducer/step"] = function (result, input) {
    return this.f(input) ? this.xf["@@transducer/step"](result, input) : result;
  };
  return XFilter2;
})();
function _xfilter(f) {
  return function (xf) {
    return new XFilter(f, xf);
  };
}
var filter = /* @__PURE__ */ _curry2(
  /* @__PURE__ */ _dispatchable(
    ["fantasy-land/filter", "filter"],
    _xfilter,
    function (pred, filterable) {
      return _isObject(filterable)
        ? _arrayReduce(
            function (acc, key) {
              if (pred(filterable[key])) {
                acc[key] = filterable[key];
              }
              return acc;
            },
            {},
            keys(filterable)
          )
        : // else
          _filter(pred, filterable);
    }
  )
);
var reject = /* @__PURE__ */ _curry2(function reject2(pred, filterable) {
  return filter(_complement(pred), filterable);
});
function _toString(x2, seen) {
  var recur = function recur2(y2) {
    var xs = seen.concat([x2]);
    return _includes(y2, xs) ? "<Circular>" : _toString(y2, xs);
  };
  var mapPairs = function (obj, keys4) {
    return _map(function (k2) {
      return _quote(k2) + ": " + recur(obj[k2]);
    }, keys4.slice().sort());
  };
  switch (Object.prototype.toString.call(x2)) {
    case "[object Arguments]":
      return (
        "(function() { return arguments; }(" + _map(recur, x2).join(", ") + "))"
      );
    case "[object Array]":
      return (
        "[" +
        _map(recur, x2)
          .concat(
            mapPairs(
              x2,
              reject(function (k2) {
                return /^\d+$/.test(k2);
              }, keys(x2))
            )
          )
          .join(", ") +
        "]"
      );
    case "[object Boolean]":
      return typeof x2 === "object"
        ? "new Boolean(" + recur(x2.valueOf()) + ")"
        : x2.toString();
    case "[object Date]":
      return (
        "new Date(" +
        (isNaN(x2.valueOf()) ? recur(NaN) : _quote(_toISOString(x2))) +
        ")"
      );
    case "[object Map]":
      return "new Map(" + recur(Array.from(x2)) + ")";
    case "[object Null]":
      return "null";
    case "[object Number]":
      return typeof x2 === "object"
        ? "new Number(" + recur(x2.valueOf()) + ")"
        : 1 / x2 === -Infinity
        ? "-0"
        : x2.toString(10);
    case "[object Set]":
      return "new Set(" + recur(Array.from(x2).sort()) + ")";
    case "[object String]":
      return typeof x2 === "object"
        ? "new String(" + recur(x2.valueOf()) + ")"
        : _quote(x2);
    case "[object Undefined]":
      return "undefined";
    default:
      if (typeof x2.toString === "function") {
        var repr = x2.toString();
        if (repr !== "[object Object]") {
          return repr;
        }
      }
      return "{" + mapPairs(x2, keys(x2)).join(", ") + "}";
  }
}
var toString = /* @__PURE__ */ _curry1(function toString2(val) {
  return _toString(val, []);
});
var max = /* @__PURE__ */ _curry2(function max2(a, b2) {
  if (a === b2) {
    return b2;
  }
  function safeMax(x2, y2) {
    if (x2 > y2 !== y2 > x2) {
      return y2 > x2 ? y2 : x2;
    }
    return void 0;
  }
  var maxByValue = safeMax(a, b2);
  if (maxByValue !== void 0) {
    return maxByValue;
  }
  var maxByType = safeMax(typeof a, typeof b2);
  if (maxByType !== void 0) {
    return maxByType === typeof a ? a : b2;
  }
  var stringA = toString(a);
  var maxByStringValue = safeMax(stringA, toString(b2));
  if (maxByStringValue !== void 0) {
    return maxByStringValue === stringA ? a : b2;
  }
  return b2;
});
var XMap = /* @__PURE__ */ (function () {
  function XMap2(f, xf) {
    this.xf = xf;
    this.f = f;
  }
  XMap2.prototype["@@transducer/init"] = _xfBase.init;
  XMap2.prototype["@@transducer/result"] = _xfBase.result;
  XMap2.prototype["@@transducer/step"] = function (result, input) {
    return this.xf["@@transducer/step"](result, this.f(input));
  };
  return XMap2;
})();
var _xmap = function _xmap2(f) {
  return function (xf) {
    return new XMap(f, xf);
  };
};
var map = /* @__PURE__ */ _curry2(
  /* @__PURE__ */ _dispatchable(
    ["fantasy-land/map", "map"],
    _xmap,
    function map2(fn, functor) {
      switch (Object.prototype.toString.call(functor)) {
        case "[object Function]":
          return curryN$1(functor.length, function () {
            return fn.call(this, functor.apply(this, arguments));
          });
        case "[object Object]":
          return _arrayReduce(
            function (acc, key) {
              acc[key] = fn(functor[key]);
              return acc;
            },
            {},
            keys(functor)
          );
        default:
          return _map(fn, functor);
      }
    }
  )
);
const _isInteger =
  Number.isInteger ||
  function _isInteger2(n) {
    return n << 0 === n;
  };
function _isString(x2) {
  return Object.prototype.toString.call(x2) === "[object String]";
}
var nth = /* @__PURE__ */ _curry2(function nth2(offset, list) {
  var idx = offset < 0 ? list.length + offset : offset;
  return _isString(list) ? list.charAt(idx) : list[idx];
});
const nth$1 = nth;
var prop = /* @__PURE__ */ _curry2(function prop2(p2, obj) {
  if (obj == null) {
    return;
  }
  return _isInteger(p2) ? nth$1(p2, obj) : obj[p2];
});
var pluck = /* @__PURE__ */ _curry2(function pluck2(p2, list) {
  return map(prop(p2), list);
});
var _isArrayLike = /* @__PURE__ */ _curry1(function isArrayLike(x2) {
  if (_isArray(x2)) {
    return true;
  }
  if (!x2) {
    return false;
  }
  if (typeof x2 !== "object") {
    return false;
  }
  if (_isString(x2)) {
    return false;
  }
  if (x2.length === 0) {
    return true;
  }
  if (x2.length > 0) {
    return x2.hasOwnProperty(0) && x2.hasOwnProperty(x2.length - 1);
  }
  return false;
});
var symIterator =
  typeof Symbol !== "undefined" ? Symbol.iterator : "@@iterator";
function _createReduce(arrayReduce, methodReduce, iterableReduce) {
  return function _reduce2(xf, acc, list) {
    if (_isArrayLike(list)) {
      return arrayReduce(xf, acc, list);
    }
    if (list == null) {
      return acc;
    }
    if (typeof list["fantasy-land/reduce"] === "function") {
      return methodReduce(xf, acc, list, "fantasy-land/reduce");
    }
    if (list[symIterator] != null) {
      return iterableReduce(xf, acc, list[symIterator]());
    }
    if (typeof list.next === "function") {
      return iterableReduce(xf, acc, list);
    }
    if (typeof list.reduce === "function") {
      return methodReduce(xf, acc, list, "reduce");
    }
    throw new TypeError("reduce: list must be array or iterable");
  };
}
function _xArrayReduce(xf, acc, list) {
  var idx = 0;
  var len = list.length;
  while (idx < len) {
    acc = xf["@@transducer/step"](acc, list[idx]);
    if (acc && acc["@@transducer/reduced"]) {
      acc = acc["@@transducer/value"];
      break;
    }
    idx += 1;
  }
  return xf["@@transducer/result"](acc);
}
var bind = /* @__PURE__ */ _curry2(function bind2(fn, thisObj) {
  return _arity(fn.length, function () {
    return fn.apply(thisObj, arguments);
  });
});
const bind$1 = bind;
function _xIterableReduce(xf, acc, iter) {
  var step = iter.next();
  while (!step.done) {
    acc = xf["@@transducer/step"](acc, step.value);
    if (acc && acc["@@transducer/reduced"]) {
      acc = acc["@@transducer/value"];
      break;
    }
    step = iter.next();
  }
  return xf["@@transducer/result"](acc);
}
function _xMethodReduce(xf, acc, obj, methodName) {
  return xf["@@transducer/result"](
    obj[methodName](bind$1(xf["@@transducer/step"], xf), acc)
  );
}
var _xReduce = /* @__PURE__ */ _createReduce(
  _xArrayReduce,
  _xMethodReduce,
  _xIterableReduce
);
var XWrap = /* @__PURE__ */ (function () {
  function XWrap2(fn) {
    this.f = fn;
  }
  XWrap2.prototype["@@transducer/init"] = function () {
    throw new Error("init not implemented on XWrap");
  };
  XWrap2.prototype["@@transducer/result"] = function (acc) {
    return acc;
  };
  XWrap2.prototype["@@transducer/step"] = function (acc, x2) {
    return this.f(acc, x2);
  };
  return XWrap2;
})();
function _xwrap(fn) {
  return new XWrap(fn);
}
var reduce = /* @__PURE__ */ _curry3(function (xf, acc, list) {
  return _xReduce(typeof xf === "function" ? _xwrap(xf) : xf, acc, list);
});
const reduce$1 = reduce;
var and = /* @__PURE__ */ _curry2(function and2(a, b2) {
  return a && b2;
});
var anyPass = /* @__PURE__ */ _curry1(function anyPass2(preds) {
  return curryN$1(reduce$1(max, 0, pluck("length", preds)), function () {
    var idx = 0;
    var len = preds.length;
    while (idx < len) {
      if (preds[idx].apply(this, arguments)) {
        return true;
      }
      idx += 1;
    }
    return false;
  });
});
const anyPass$1 = anyPass;
function _iterableReduce(reducer, acc, iter) {
  var step = iter.next();
  while (!step.done) {
    acc = reducer(acc, step.value);
    step = iter.next();
  }
  return acc;
}
function _methodReduce(reducer, acc, obj, methodName) {
  return obj[methodName](reducer, acc);
}
var _reduce = /* @__PURE__ */ _createReduce(
  _arrayReduce,
  _methodReduce,
  _iterableReduce
);
var ap = /* @__PURE__ */ _curry2(function ap2(applyF, applyX) {
  return typeof applyX["fantasy-land/ap"] === "function"
    ? applyX["fantasy-land/ap"](applyF)
    : typeof applyF.ap === "function"
    ? applyF.ap(applyX)
    : typeof applyF === "function"
    ? function (x2) {
        return applyF(x2)(applyX(x2));
      }
    : _reduce(
        function (acc, f) {
          return _concat(acc, map(f, applyX));
        },
        [],
        applyF
      );
});
function _isFunction(x2) {
  var type3 = Object.prototype.toString.call(x2);
  return (
    type3 === "[object Function]" ||
    type3 === "[object AsyncFunction]" ||
    type3 === "[object GeneratorFunction]" ||
    type3 === "[object AsyncGeneratorFunction]"
  );
}
var liftN = /* @__PURE__ */ _curry2(function liftN2(arity, fn) {
  var lifted = curryN$1(arity, fn);
  return curryN$1(arity, function () {
    return _arrayReduce(
      ap,
      map(lifted, arguments[0]),
      Array.prototype.slice.call(arguments, 1)
    );
  });
});
var lift = /* @__PURE__ */ _curry1(function lift2(fn) {
  return liftN(fn.length, fn);
});
var both = /* @__PURE__ */ _curry2(function both2(f, g) {
  return _isFunction(f)
    ? function _both() {
        return f.apply(this, arguments) && g.apply(this, arguments);
      }
    : lift(and)(f, g);
});
const both$1 = both;
function _pipe(f, g) {
  return function () {
    return g.call(this, f.apply(this, arguments));
  };
}
function _checkForMethod(methodname, fn) {
  return function () {
    var length = arguments.length;
    if (length === 0) {
      return fn();
    }
    var obj = arguments[length - 1];
    return _isArray(obj) || typeof obj[methodname] !== "function"
      ? fn.apply(this, arguments)
      : obj[methodname].apply(
          obj,
          Array.prototype.slice.call(arguments, 0, length - 1)
        );
  };
}
var slice$1 = /* @__PURE__ */ _curry3(
  /* @__PURE__ */ _checkForMethod(
    "slice",
    function slice(fromIndex, toIndex, list) {
      return Array.prototype.slice.call(list, fromIndex, toIndex);
    }
  )
);
var tail = /* @__PURE__ */ _curry1(
  /* @__PURE__ */ _checkForMethod("tail", /* @__PURE__ */ slice$1(1, Infinity))
);
const tail$1 = tail;
function pipe() {
  if (arguments.length === 0) {
    throw new Error("pipe requires at least one argument");
  }
  return _arity(
    arguments[0].length,
    reduce$1(_pipe, arguments[0], tail$1(arguments))
  );
}
function _identity(x2) {
  return x2;
}
var identity = /* @__PURE__ */ _curry1(_identity);
const identity$1 = identity;
var curry = /* @__PURE__ */ _curry1(function curry2(fn) {
  return curryN$1(fn.length, fn);
});
const curry$1 = curry;
var converge = /* @__PURE__ */ _curry2(function converge2(after, fns) {
  return curryN$1(reduce$1(max, 0, pluck("length", fns)), function () {
    var args = arguments;
    var context = this;
    return after.apply(
      context,
      _map(function (fn) {
        return fn.apply(context, args);
      }, fns)
    );
  });
});
const converge$1 = converge;
var defaultTo = /* @__PURE__ */ _curry2(function defaultTo2(d, v2) {
  return v2 == null || v2 !== v2 ? d : v2;
});
var flip = /* @__PURE__ */ _curry1(function flip2(fn) {
  return curryN$1(fn.length, function (a, b2) {
    var args = Array.prototype.slice.call(arguments, 0);
    args[0] = b2;
    args[1] = a;
    return fn.apply(this, args);
  });
});
const flip$1 = flip;
var gte = /* @__PURE__ */ _curry2(function gte2(a, b2) {
  return a >= b2;
});
const gte$1 = gte;
var identical = function (a, b2) {
  switch (arguments.length) {
    case 0:
      return identical;
    case 1:
      return (function () {
        return function unaryIdentical(_b2) {
          switch (arguments.length) {
            case 0:
              return unaryIdentical;
            default:
              return _objectIs$1(a, _b2);
          }
        };
      })();
    default:
      return _objectIs$1(a, b2);
  }
};
const identical$1 = identical;
function _createPartialApplicator(concat) {
  return _curry2(function (fn, args) {
    return _arity(Math.max(0, fn.length - args.length), function () {
      return fn.apply(this, concat(args, arguments));
    });
  });
}
var partial = /* @__PURE__ */ _createPartialApplicator(_concat);
const partial$1 = partial;
var propOr = /* @__PURE__ */ _curry3(function propOr2(val, p2, obj) {
  return defaultTo(val, prop(p2, obj));
});
const propOr$1 = propOr;
var isGeneratorFunction = curryN$1(
  1,
  pipe(type$1, identical$1("GeneratorFunction"))
);
const isGeneratorFunction$1 = isGeneratorFunction;
var isAsyncFunction = curryN$1(1, pipe(type$1, identical$1("AsyncFunction")));
const isAsyncFunction$1 = isAsyncFunction;
var isFunction$2 = anyPass$1([
  pipe(type$1, identical$1("Function")),
  isGeneratorFunction$1,
  isAsyncFunction$1,
]);
const isFunction$3 = isFunction$2;
var isNumber$1 = curryN$1(1, pipe(type$1, identical$1("Number")));
const isNumber$2 = isNumber$1;
var isNonNegative = curryN$1(1, both$1(isNumber$2, flip$1(gte$1)(0)));
const isNonNegative$1 = isNonNegative;
var isFinitePonyfill$1 = both$1(isNumber$2, isFinite);
const ponyfill$1 = isFinitePonyfill$1;
var isFinitePonyfill = curryN$1(1, ponyfill$1);
var _isFinite = isFunction$3(Number.isFinite)
  ? curryN$1(1, bind$1(Number.isFinite, Number))
  : isFinitePonyfill;
const isFinite$1 = _isFinite;
var isIntegerPonyfill$1 = both$1(
  isFinite$1,
  converge$1(equals$1, [Math.floor, identity$1])
);
const ponyfill = isIntegerPonyfill$1;
var isIntegerPonyfill = curryN$1(1, ponyfill);
var isInteger$1 = isFunction$3(Number.isInteger)
  ? curryN$1(1, bind$1(Number.isInteger, Number))
  : isIntegerPonyfill;
const isInteger$2 = isInteger$1;
var makeDelay = curry$1(function (settleFnPicker, opts) {
  var timeout;
  var value;
  if (isInteger$2(opts) && isNonNegative$1(opts)) {
    timeout = opts;
  } else {
    timeout = propOr$1(0, "timeout", opts);
    value = propOr$1(value, "value", opts);
  }
  return new Promise(function () {
    for (
      var _len = arguments.length, args = new Array(_len), _key = 0;
      _key < _len;
      _key++
    ) {
      args[_key] = arguments[_key];
    }
    var settleFn = settleFnPicker(args);
    setTimeout(partial$1(settleFn, [value]), timeout);
  });
});
var delayP = makeDelay(nth$1(0));
delayP.reject = makeDelay(nth$1(1));
const delayP$1 = delayP;
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const stringToByteArray$1 = function (str) {
  const out = [];
  let p2 = 0;
  for (let i = 0; i < str.length; i++) {
    let c = str.charCodeAt(i);
    if (c < 128) {
      out[p2++] = c;
    } else if (c < 2048) {
      out[p2++] = (c >> 6) | 192;
      out[p2++] = (c & 63) | 128;
    } else if (
      (c & 64512) === 55296 &&
      i + 1 < str.length &&
      (str.charCodeAt(i + 1) & 64512) === 56320
    ) {
      c = 65536 + ((c & 1023) << 10) + (str.charCodeAt(++i) & 1023);
      out[p2++] = (c >> 18) | 240;
      out[p2++] = ((c >> 12) & 63) | 128;
      out[p2++] = ((c >> 6) & 63) | 128;
      out[p2++] = (c & 63) | 128;
    } else {
      out[p2++] = (c >> 12) | 224;
      out[p2++] = ((c >> 6) & 63) | 128;
      out[p2++] = (c & 63) | 128;
    }
  }
  return out;
};
const byteArrayToString = function (bytes) {
  const out = [];
  let pos = 0,
    c = 0;
  while (pos < bytes.length) {
    const c1 = bytes[pos++];
    if (c1 < 128) {
      out[c++] = String.fromCharCode(c1);
    } else if (c1 > 191 && c1 < 224) {
      const c2 = bytes[pos++];
      out[c++] = String.fromCharCode(((c1 & 31) << 6) | (c2 & 63));
    } else if (c1 > 239 && c1 < 365) {
      const c2 = bytes[pos++];
      const c3 = bytes[pos++];
      const c4 = bytes[pos++];
      const u =
        (((c1 & 7) << 18) | ((c2 & 63) << 12) | ((c3 & 63) << 6) | (c4 & 63)) -
        65536;
      out[c++] = String.fromCharCode(55296 + (u >> 10));
      out[c++] = String.fromCharCode(56320 + (u & 1023));
    } else {
      const c2 = bytes[pos++];
      const c3 = bytes[pos++];
      out[c++] = String.fromCharCode(
        ((c1 & 15) << 12) | ((c2 & 63) << 6) | (c3 & 63)
      );
    }
  }
  return out.join("");
};
const base64 = {
  /**
   * Maps bytes to characters.
   */
  byteToCharMap_: null,
  /**
   * Maps characters to bytes.
   */
  charToByteMap_: null,
  /**
   * Maps bytes to websafe characters.
   * @private
   */
  byteToCharMapWebSafe_: null,
  /**
   * Maps websafe characters to bytes.
   * @private
   */
  charToByteMapWebSafe_: null,
  /**
   * Our default alphabet, shared between
   * ENCODED_VALS and ENCODED_VALS_WEBSAFE
   */
  ENCODED_VALS_BASE:
    "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789",
  /**
   * Our default alphabet. Value 64 (=) is special; it means "nothing."
   */
  get ENCODED_VALS() {
    return this.ENCODED_VALS_BASE + "+/=";
  },
  /**
   * Our websafe alphabet.
   */
  get ENCODED_VALS_WEBSAFE() {
    return this.ENCODED_VALS_BASE + "-_.";
  },
  /**
   * Whether this browser supports the atob and btoa functions. This extension
   * started at Mozilla but is now implemented by many browsers. We use the
   * ASSUME_* variables to avoid pulling in the full useragent detection library
   * but still allowing the standard per-browser compilations.
   *
   */
  HAS_NATIVE_SUPPORT: typeof atob === "function",
  /**
   * Base64-encode an array of bytes.
   *
   * @param input An array of bytes (numbers with
   *     value in [0, 255]) to encode.
   * @param webSafe Boolean indicating we should use the
   *     alternative alphabet.
   * @return The base64 encoded string.
   */
  encodeByteArray(input, webSafe) {
    if (!Array.isArray(input)) {
      throw Error("encodeByteArray takes an array as a parameter");
    }
    this.init_();
    const byteToCharMap = webSafe
      ? this.byteToCharMapWebSafe_
      : this.byteToCharMap_;
    const output2 = [];
    for (let i = 0; i < input.length; i += 3) {
      const byte1 = input[i];
      const haveByte2 = i + 1 < input.length;
      const byte2 = haveByte2 ? input[i + 1] : 0;
      const haveByte3 = i + 2 < input.length;
      const byte3 = haveByte3 ? input[i + 2] : 0;
      const outByte1 = byte1 >> 2;
      const outByte2 = ((byte1 & 3) << 4) | (byte2 >> 4);
      let outByte3 = ((byte2 & 15) << 2) | (byte3 >> 6);
      let outByte4 = byte3 & 63;
      if (!haveByte3) {
        outByte4 = 64;
        if (!haveByte2) {
          outByte3 = 64;
        }
      }
      output2.push(
        byteToCharMap[outByte1],
        byteToCharMap[outByte2],
        byteToCharMap[outByte3],
        byteToCharMap[outByte4]
      );
    }
    return output2.join("");
  },
  /**
   * Base64-encode a string.
   *
   * @param input A string to encode.
   * @param webSafe If true, we should use the
   *     alternative alphabet.
   * @return The base64 encoded string.
   */
  encodeString(input, webSafe) {
    if (this.HAS_NATIVE_SUPPORT && !webSafe) {
      return btoa(input);
    }
    return this.encodeByteArray(stringToByteArray$1(input), webSafe);
  },
  /**
   * Base64-decode a string.
   *
   * @param input to decode.
   * @param webSafe True if we should use the
   *     alternative alphabet.
   * @return string representing the decoded value.
   */
  decodeString(input, webSafe) {
    if (this.HAS_NATIVE_SUPPORT && !webSafe) {
      return atob(input);
    }
    return byteArrayToString(this.decodeStringToByteArray(input, webSafe));
  },
  /**
   * Base64-decode a string.
   *
   * In base-64 decoding, groups of four characters are converted into three
   * bytes.  If the encoder did not apply padding, the input length may not
   * be a multiple of 4.
   *
   * In this case, the last group will have fewer than 4 characters, and
   * padding will be inferred.  If the group has one or two characters, it decodes
   * to one byte.  If the group has three characters, it decodes to two bytes.
   *
   * @param input Input to decode.
   * @param webSafe True if we should use the web-safe alphabet.
   * @return bytes representing the decoded value.
   */
  decodeStringToByteArray(input, webSafe) {
    this.init_();
    const charToByteMap = webSafe
      ? this.charToByteMapWebSafe_
      : this.charToByteMap_;
    const output2 = [];
    for (let i = 0; i < input.length; ) {
      const byte1 = charToByteMap[input.charAt(i++)];
      const haveByte2 = i < input.length;
      const byte2 = haveByte2 ? charToByteMap[input.charAt(i)] : 0;
      ++i;
      const haveByte3 = i < input.length;
      const byte3 = haveByte3 ? charToByteMap[input.charAt(i)] : 64;
      ++i;
      const haveByte4 = i < input.length;
      const byte4 = haveByte4 ? charToByteMap[input.charAt(i)] : 64;
      ++i;
      if (byte1 == null || byte2 == null || byte3 == null || byte4 == null) {
        throw new DecodeBase64StringError();
      }
      const outByte1 = (byte1 << 2) | (byte2 >> 4);
      output2.push(outByte1);
      if (byte3 !== 64) {
        const outByte2 = ((byte2 << 4) & 240) | (byte3 >> 2);
        output2.push(outByte2);
        if (byte4 !== 64) {
          const outByte3 = ((byte3 << 6) & 192) | byte4;
          output2.push(outByte3);
        }
      }
    }
    return output2;
  },
  /**
   * Lazy static initialization function. Called before
   * accessing any of the static map variables.
   * @private
   */
  init_() {
    if (!this.byteToCharMap_) {
      this.byteToCharMap_ = {};
      this.charToByteMap_ = {};
      this.byteToCharMapWebSafe_ = {};
      this.charToByteMapWebSafe_ = {};
      for (let i = 0; i < this.ENCODED_VALS.length; i++) {
        this.byteToCharMap_[i] = this.ENCODED_VALS.charAt(i);
        this.charToByteMap_[this.byteToCharMap_[i]] = i;
        this.byteToCharMapWebSafe_[i] = this.ENCODED_VALS_WEBSAFE.charAt(i);
        this.charToByteMapWebSafe_[this.byteToCharMapWebSafe_[i]] = i;
        if (i >= this.ENCODED_VALS_BASE.length) {
          this.charToByteMap_[this.ENCODED_VALS_WEBSAFE.charAt(i)] = i;
          this.charToByteMapWebSafe_[this.ENCODED_VALS.charAt(i)] = i;
        }
      }
    }
  },
};
class DecodeBase64StringError extends Error {
  constructor() {
    super(...arguments);
    this.name = "DecodeBase64StringError";
  }
}
const base64Encode = function (str) {
  const utf8Bytes = stringToByteArray$1(str);
  return base64.encodeByteArray(utf8Bytes, true);
};
const base64urlEncodeWithoutPadding = function (str) {
  return base64Encode(str).replace(/\./g, "");
};
const base64Decode = function (str) {
  try {
    return base64.decodeString(str, true);
  } catch (e) {
    console.error("base64Decode failed: ", e);
  }
  return null;
};
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function getGlobal() {
  if (typeof self !== "undefined") {
    return self;
  }
  if (typeof window !== "undefined") {
    return window;
  }
  if (typeof global !== "undefined") {
    return global;
  }
  throw new Error("Unable to locate global object.");
}
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const getDefaultsFromGlobal = () => getGlobal().__FIREBASE_DEFAULTS__;
const getDefaultsFromEnvVariable = () => {
  if (typeof process === "undefined" || typeof process.env === "undefined") {
    return;
  }
  const defaultsJsonString = {}.__FIREBASE_DEFAULTS__;
  if (defaultsJsonString) {
    return JSON.parse(defaultsJsonString);
  }
};
const getDefaultsFromCookie = () => {
  if (typeof document === "undefined") {
    return;
  }
  let match;
  try {
    match = document.cookie.match(/__FIREBASE_DEFAULTS__=([^;]+)/);
  } catch (e) {
    return;
  }
  const decoded = match && base64Decode(match[1]);
  return decoded && JSON.parse(decoded);
};
const getDefaults = () => {
  try {
    return (
      getDefaultsFromGlobal() ||
      getDefaultsFromEnvVariable() ||
      getDefaultsFromCookie()
    );
  } catch (e) {
    console.info(`Unable to get __FIREBASE_DEFAULTS__ due to: ${e}`);
    return;
  }
};
const getDefaultEmulatorHost = (productName) => {
  var _a2, _b2;
  return (_b2 =
    (_a2 = getDefaults()) === null || _a2 === void 0
      ? void 0
      : _a2.emulatorHosts) === null || _b2 === void 0
    ? void 0
    : _b2[productName];
};
const getDefaultEmulatorHostnameAndPort = (productName) => {
  const host = getDefaultEmulatorHost(productName);
  if (!host) {
    return void 0;
  }
  const separatorIndex = host.lastIndexOf(":");
  if (separatorIndex <= 0 || separatorIndex + 1 === host.length) {
    throw new Error(`Invalid host ${host} with no separate hostname and port!`);
  }
  const port = parseInt(host.substring(separatorIndex + 1), 10);
  if (host[0] === "[") {
    return [host.substring(1, separatorIndex - 1), port];
  } else {
    return [host.substring(0, separatorIndex), port];
  }
};
const getDefaultAppConfig = () => {
  var _a2;
  return (_a2 = getDefaults()) === null || _a2 === void 0 ? void 0 : _a2.config;
};
const getExperimentalSetting = (name2) => {
  var _a2;
  return (_a2 = getDefaults()) === null || _a2 === void 0
    ? void 0
    : _a2[`_${name2}`];
};
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class Deferred {
  constructor() {
    this.reject = () => {};
    this.resolve = () => {};
    this.promise = new Promise((resolve, reject3) => {
      this.resolve = resolve;
      this.reject = reject3;
    });
  }
  /**
   * Our API internals are not promiseified and cannot because our callback APIs have subtle expectations around
   * invoking promises inline, which Promises are forbidden to do. This method accepts an optional node-style callback
   * and returns a node-style callback which will resolve or reject the Deferred's promise.
   */
  wrapCallback(callback) {
    return (error, value) => {
      if (error) {
        this.reject(error);
      } else {
        this.resolve(value);
      }
      if (typeof callback === "function") {
        this.promise.catch(() => {});
        if (callback.length === 1) {
          callback(error);
        } else {
          callback(error, value);
        }
      }
    };
  }
}
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function createMockUserToken(token2, projectId) {
  if (token2.uid) {
    throw new Error(
      'The "uid" field is no longer supported by mockUserToken. Please use "sub" instead for Firebase Auth User ID.'
    );
  }
  const header = {
    alg: "none",
    type: "JWT",
  };
  const project = projectId || "demo-project";
  const iat = token2.iat || 0;
  const sub = token2.sub || token2.user_id;
  if (!sub) {
    throw new Error("mockUserToken must contain 'sub' or 'user_id' field!");
  }
  const payload = Object.assign(
    {
      // Set all required fields to decent defaults
      iss: `https://securetoken.google.com/${project}`,
      aud: project,
      iat,
      exp: iat + 3600,
      auth_time: iat,
      sub,
      user_id: sub,
      firebase: {
        sign_in_provider: "custom",
        identities: {},
      },
    },
    token2
  );
  const signature = "";
  return [
    base64urlEncodeWithoutPadding(JSON.stringify(header)),
    base64urlEncodeWithoutPadding(JSON.stringify(payload)),
    signature,
  ].join(".");
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function getUA() {
  if (
    typeof navigator !== "undefined" &&
    typeof navigator["userAgent"] === "string"
  ) {
    return navigator["userAgent"];
  } else {
    return "";
  }
}
function isMobileCordova() {
  return (
    typeof window !== "undefined" && // @ts-ignore Setting up an broadly applicable index signature for Window
    // just to deal with this case would probably be a bad idea.
    !!(window["cordova"] || window["phonegap"] || window["PhoneGap"]) &&
    /ios|iphone|ipod|ipad|android|blackberry|iemobile/i.test(getUA())
  );
}
function isNode() {
  var _a2;
  const forceEnvironment =
    (_a2 = getDefaults()) === null || _a2 === void 0
      ? void 0
      : _a2.forceEnvironment;
  if (forceEnvironment === "node") {
    return true;
  } else if (forceEnvironment === "browser") {
    return false;
  }
  try {
    return (
      Object.prototype.toString.call(global.process) === "[object process]"
    );
  } catch (e) {
    return false;
  }
}
function isBrowserExtension() {
  const runtime =
    typeof chrome === "object"
      ? chrome.runtime
      : typeof browser === "object"
      ? browser.runtime
      : void 0;
  return typeof runtime === "object" && runtime.id !== void 0;
}
function isReactNative() {
  return (
    typeof navigator === "object" && navigator["product"] === "ReactNative"
  );
}
function isIE() {
  const ua2 = getUA();
  return ua2.indexOf("MSIE ") >= 0 || ua2.indexOf("Trident/") >= 0;
}
function isSafari() {
  return (
    !isNode() &&
    !!navigator.userAgent &&
    navigator.userAgent.includes("Safari") &&
    !navigator.userAgent.includes("Chrome")
  );
}
function isIndexedDBAvailable() {
  try {
    return typeof indexedDB === "object";
  } catch (e) {
    return false;
  }
}
function validateIndexedDBOpenable() {
  return new Promise((resolve, reject3) => {
    try {
      let preExist = true;
      const DB_CHECK_NAME =
        "validate-browser-context-for-indexeddb-analytics-module";
      const request = self.indexedDB.open(DB_CHECK_NAME);
      request.onsuccess = () => {
        request.result.close();
        if (!preExist) {
          self.indexedDB.deleteDatabase(DB_CHECK_NAME);
        }
        resolve(true);
      };
      request.onupgradeneeded = () => {
        preExist = false;
      };
      request.onerror = () => {
        var _a2;
        reject3(
          ((_a2 = request.error) === null || _a2 === void 0
            ? void 0
            : _a2.message) || ""
        );
      };
    } catch (error) {
      reject3(error);
    }
  });
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const ERROR_NAME = "FirebaseError";
class FirebaseError extends Error {
  constructor(code, message, customData) {
    super(message);
    this.code = code;
    this.customData = customData;
    this.name = ERROR_NAME;
    Object.setPrototypeOf(this, FirebaseError.prototype);
    if (Error.captureStackTrace) {
      Error.captureStackTrace(this, ErrorFactory.prototype.create);
    }
  }
}
class ErrorFactory {
  constructor(service, serviceName, errors) {
    this.service = service;
    this.serviceName = serviceName;
    this.errors = errors;
  }
  create(code, ...data) {
    const customData = data[0] || {};
    const fullCode = `${this.service}/${code}`;
    const template = this.errors[code];
    const message = template ? replaceTemplate(template, customData) : "Error";
    const fullMessage = `${this.serviceName}: ${message} (${fullCode}).`;
    const error = new FirebaseError(fullCode, fullMessage, customData);
    return error;
  }
}
function replaceTemplate(template, data) {
  return template.replace(PATTERN, (_, key) => {
    const value = data[key];
    return value != null ? String(value) : `<${key}?>`;
  });
}
const PATTERN = /\{\$([^}]+)}/g;
function isEmpty$1(obj) {
  for (const key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      return false;
    }
  }
  return true;
}
function deepEqual(a, b2) {
  if (a === b2) {
    return true;
  }
  const aKeys = Object.keys(a);
  const bKeys = Object.keys(b2);
  for (const k2 of aKeys) {
    if (!bKeys.includes(k2)) {
      return false;
    }
    const aProp = a[k2];
    const bProp = b2[k2];
    if (isObject$1(aProp) && isObject$1(bProp)) {
      if (!deepEqual(aProp, bProp)) {
        return false;
      }
    } else if (aProp !== bProp) {
      return false;
    }
  }
  for (const k2 of bKeys) {
    if (!aKeys.includes(k2)) {
      return false;
    }
  }
  return true;
}
function isObject$1(thing) {
  return thing !== null && typeof thing === "object";
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function querystring(querystringParams) {
  const params = [];
  for (const [key, value] of Object.entries(querystringParams)) {
    if (Array.isArray(value)) {
      value.forEach((arrayVal) => {
        params.push(
          encodeURIComponent(key) + "=" + encodeURIComponent(arrayVal)
        );
      });
    } else {
      params.push(encodeURIComponent(key) + "=" + encodeURIComponent(value));
    }
  }
  return params.length ? "&" + params.join("&") : "";
}
function createSubscribe(executor, onNoObservers) {
  const proxy = new ObserverProxy(executor, onNoObservers);
  return proxy.subscribe.bind(proxy);
}
class ObserverProxy {
  /**
   * @param executor Function which can make calls to a single Observer
   *     as a proxy.
   * @param onNoObservers Callback when count of Observers goes to zero.
   */
  constructor(executor, onNoObservers) {
    this.observers = [];
    this.unsubscribes = [];
    this.observerCount = 0;
    this.task = Promise.resolve();
    this.finalized = false;
    this.onNoObservers = onNoObservers;
    this.task
      .then(() => {
        executor(this);
      })
      .catch((e) => {
        this.error(e);
      });
  }
  next(value) {
    this.forEachObserver((observer) => {
      observer.next(value);
    });
  }
  error(error) {
    this.forEachObserver((observer) => {
      observer.error(error);
    });
    this.close(error);
  }
  complete() {
    this.forEachObserver((observer) => {
      observer.complete();
    });
    this.close();
  }
  /**
   * Subscribe function that can be used to add an Observer to the fan-out list.
   *
   * - We require that no event is sent to a subscriber sychronously to their
   *   call to subscribe().
   */
  subscribe(nextOrObserver, error, complete) {
    let observer;
    if (nextOrObserver === void 0 && error === void 0 && complete === void 0) {
      throw new Error("Missing Observer.");
    }
    if (implementsAnyMethods(nextOrObserver, ["next", "error", "complete"])) {
      observer = nextOrObserver;
    } else {
      observer = {
        next: nextOrObserver,
        error,
        complete,
      };
    }
    if (observer.next === void 0) {
      observer.next = noop;
    }
    if (observer.error === void 0) {
      observer.error = noop;
    }
    if (observer.complete === void 0) {
      observer.complete = noop;
    }
    const unsub = this.unsubscribeOne.bind(this, this.observers.length);
    if (this.finalized) {
      this.task.then(() => {
        try {
          if (this.finalError) {
            observer.error(this.finalError);
          } else {
            observer.complete();
          }
        } catch (e) {}
        return;
      });
    }
    this.observers.push(observer);
    return unsub;
  }
  // Unsubscribe is synchronous - we guarantee that no events are sent to
  // any unsubscribed Observer.
  unsubscribeOne(i) {
    if (this.observers === void 0 || this.observers[i] === void 0) {
      return;
    }
    delete this.observers[i];
    this.observerCount -= 1;
    if (this.observerCount === 0 && this.onNoObservers !== void 0) {
      this.onNoObservers(this);
    }
  }
  forEachObserver(fn) {
    if (this.finalized) {
      return;
    }
    for (let i = 0; i < this.observers.length; i++) {
      this.sendOne(i, fn);
    }
  }
  // Call the Observer via one of it's callback function. We are careful to
  // confirm that the observe has not been unsubscribed since this asynchronous
  // function had been queued.
  sendOne(i, fn) {
    this.task.then(() => {
      if (this.observers !== void 0 && this.observers[i] !== void 0) {
        try {
          fn(this.observers[i]);
        } catch (e) {
          if (typeof console !== "undefined" && console.error) {
            console.error(e);
          }
        }
      }
    });
  }
  close(err) {
    if (this.finalized) {
      return;
    }
    this.finalized = true;
    if (err !== void 0) {
      this.finalError = err;
    }
    this.task.then(() => {
      this.observers = void 0;
      this.onNoObservers = void 0;
    });
  }
}
function implementsAnyMethods(obj, methods2) {
  if (typeof obj !== "object" || obj === null) {
    return false;
  }
  for (const method of methods2) {
    if (method in obj && typeof obj[method] === "function") {
      return true;
    }
  }
  return false;
}
function noop() {}
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function getModularInstance(service) {
  if (service && service._delegate) {
    return service._delegate;
  } else {
    return service;
  }
}
class Component {
  /**
   *
   * @param name The public service name, e.g. app, auth, firestore, database
   * @param instanceFactory Service factory responsible for creating the public interface
   * @param type whether the service provided by the component is public or private
   */
  constructor(name2, instanceFactory, type3) {
    this.name = name2;
    this.instanceFactory = instanceFactory;
    this.type = type3;
    this.multipleInstances = false;
    this.serviceProps = {};
    this.instantiationMode = "LAZY";
    this.onInstanceCreated = null;
  }
  setInstantiationMode(mode) {
    this.instantiationMode = mode;
    return this;
  }
  setMultipleInstances(multipleInstances) {
    this.multipleInstances = multipleInstances;
    return this;
  }
  setServiceProps(props) {
    this.serviceProps = props;
    return this;
  }
  setInstanceCreatedCallback(callback) {
    this.onInstanceCreated = callback;
    return this;
  }
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const DEFAULT_ENTRY_NAME$1 = "[DEFAULT]";
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class Provider {
  constructor(name2, container) {
    this.name = name2;
    this.container = container;
    this.component = null;
    this.instances = /* @__PURE__ */ new Map();
    this.instancesDeferred = /* @__PURE__ */ new Map();
    this.instancesOptions = /* @__PURE__ */ new Map();
    this.onInitCallbacks = /* @__PURE__ */ new Map();
  }
  /**
   * @param identifier A provider can provide mulitple instances of a service
   * if this.component.multipleInstances is true.
   */
  get(identifier) {
    const normalizedIdentifier = this.normalizeInstanceIdentifier(identifier);
    if (!this.instancesDeferred.has(normalizedIdentifier)) {
      const deferred = new Deferred();
      this.instancesDeferred.set(normalizedIdentifier, deferred);
      if (
        this.isInitialized(normalizedIdentifier) ||
        this.shouldAutoInitialize()
      ) {
        try {
          const instance2 = this.getOrInitializeService({
            instanceIdentifier: normalizedIdentifier,
          });
          if (instance2) {
            deferred.resolve(instance2);
          }
        } catch (e) {}
      }
    }
    return this.instancesDeferred.get(normalizedIdentifier).promise;
  }
  getImmediate(options) {
    var _a2;
    const normalizedIdentifier = this.normalizeInstanceIdentifier(
      options === null || options === void 0 ? void 0 : options.identifier
    );
    const optional =
      (_a2 =
        options === null || options === void 0 ? void 0 : options.optional) !==
        null && _a2 !== void 0
        ? _a2
        : false;
    if (
      this.isInitialized(normalizedIdentifier) ||
      this.shouldAutoInitialize()
    ) {
      try {
        return this.getOrInitializeService({
          instanceIdentifier: normalizedIdentifier,
        });
      } catch (e) {
        if (optional) {
          return null;
        } else {
          throw e;
        }
      }
    } else {
      if (optional) {
        return null;
      } else {
        throw Error(`Service ${this.name} is not available`);
      }
    }
  }
  getComponent() {
    return this.component;
  }
  setComponent(component) {
    if (component.name !== this.name) {
      throw Error(
        `Mismatching Component ${component.name} for Provider ${this.name}.`
      );
    }
    if (this.component) {
      throw Error(`Component for ${this.name} has already been provided`);
    }
    this.component = component;
    if (!this.shouldAutoInitialize()) {
      return;
    }
    if (isComponentEager(component)) {
      try {
        this.getOrInitializeService({
          instanceIdentifier: DEFAULT_ENTRY_NAME$1,
        });
      } catch (e) {}
    }
    for (const [
      instanceIdentifier,
      instanceDeferred,
    ] of this.instancesDeferred.entries()) {
      const normalizedIdentifier =
        this.normalizeInstanceIdentifier(instanceIdentifier);
      try {
        const instance2 = this.getOrInitializeService({
          instanceIdentifier: normalizedIdentifier,
        });
        instanceDeferred.resolve(instance2);
      } catch (e) {}
    }
  }
  clearInstance(identifier = DEFAULT_ENTRY_NAME$1) {
    this.instancesDeferred.delete(identifier);
    this.instancesOptions.delete(identifier);
    this.instances.delete(identifier);
  }
  // app.delete() will call this method on every provider to delete the services
  // TODO: should we mark the provider as deleted?
  async delete() {
    const services = Array.from(this.instances.values());
    await Promise.all([
      ...services
        .filter((service) => "INTERNAL" in service)
        .map((service) => service.INTERNAL.delete()),
      ...services
        .filter((service) => "_delete" in service)
        .map((service) => service._delete()),
    ]);
  }
  isComponentSet() {
    return this.component != null;
  }
  isInitialized(identifier = DEFAULT_ENTRY_NAME$1) {
    return this.instances.has(identifier);
  }
  getOptions(identifier = DEFAULT_ENTRY_NAME$1) {
    return this.instancesOptions.get(identifier) || {};
  }
  initialize(opts = {}) {
    const { options = {} } = opts;
    const normalizedIdentifier = this.normalizeInstanceIdentifier(
      opts.instanceIdentifier
    );
    if (this.isInitialized(normalizedIdentifier)) {
      throw Error(
        `${this.name}(${normalizedIdentifier}) has already been initialized`
      );
    }
    if (!this.isComponentSet()) {
      throw Error(`Component ${this.name} has not been registered yet`);
    }
    const instance2 = this.getOrInitializeService({
      instanceIdentifier: normalizedIdentifier,
      options,
    });
    for (const [
      instanceIdentifier,
      instanceDeferred,
    ] of this.instancesDeferred.entries()) {
      const normalizedDeferredIdentifier =
        this.normalizeInstanceIdentifier(instanceIdentifier);
      if (normalizedIdentifier === normalizedDeferredIdentifier) {
        instanceDeferred.resolve(instance2);
      }
    }
    return instance2;
  }
  /**
   *
   * @param callback - a function that will be invoked  after the provider has been initialized by calling provider.initialize().
   * The function is invoked SYNCHRONOUSLY, so it should not execute any longrunning tasks in order to not block the program.
   *
   * @param identifier An optional instance identifier
   * @returns a function to unregister the callback
   */
  onInit(callback, identifier) {
    var _a2;
    const normalizedIdentifier = this.normalizeInstanceIdentifier(identifier);
    const existingCallbacks =
      (_a2 = this.onInitCallbacks.get(normalizedIdentifier)) !== null &&
      _a2 !== void 0
        ? _a2
        : /* @__PURE__ */ new Set();
    existingCallbacks.add(callback);
    this.onInitCallbacks.set(normalizedIdentifier, existingCallbacks);
    const existingInstance = this.instances.get(normalizedIdentifier);
    if (existingInstance) {
      callback(existingInstance, normalizedIdentifier);
    }
    return () => {
      existingCallbacks.delete(callback);
    };
  }
  /**
   * Invoke onInit callbacks synchronously
   * @param instance the service instance`
   */
  invokeOnInitCallbacks(instance2, identifier) {
    const callbacks = this.onInitCallbacks.get(identifier);
    if (!callbacks) {
      return;
    }
    for (const callback of callbacks) {
      try {
        callback(instance2, identifier);
      } catch (_a2) {}
    }
  }
  getOrInitializeService({ instanceIdentifier, options = {} }) {
    let instance2 = this.instances.get(instanceIdentifier);
    if (!instance2 && this.component) {
      instance2 = this.component.instanceFactory(this.container, {
        instanceIdentifier: normalizeIdentifierForFactory(instanceIdentifier),
        options,
      });
      this.instances.set(instanceIdentifier, instance2);
      this.instancesOptions.set(instanceIdentifier, options);
      this.invokeOnInitCallbacks(instance2, instanceIdentifier);
      if (this.component.onInstanceCreated) {
        try {
          this.component.onInstanceCreated(
            this.container,
            instanceIdentifier,
            instance2
          );
        } catch (_a2) {}
      }
    }
    return instance2 || null;
  }
  normalizeInstanceIdentifier(identifier = DEFAULT_ENTRY_NAME$1) {
    if (this.component) {
      return this.component.multipleInstances
        ? identifier
        : DEFAULT_ENTRY_NAME$1;
    } else {
      return identifier;
    }
  }
  shouldAutoInitialize() {
    return !!this.component && this.component.instantiationMode !== "EXPLICIT";
  }
}
function normalizeIdentifierForFactory(identifier) {
  return identifier === DEFAULT_ENTRY_NAME$1 ? void 0 : identifier;
}
function isComponentEager(component) {
  return component.instantiationMode === "EAGER";
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class ComponentContainer {
  constructor(name2) {
    this.name = name2;
    this.providers = /* @__PURE__ */ new Map();
  }
  /**
   *
   * @param component Component being added
   * @param overwrite When a component with the same name has already been registered,
   * if overwrite is true: overwrite the existing component with the new component and create a new
   * provider with the new component. It can be useful in tests where you want to use different mocks
   * for different tests.
   * if overwrite is false: throw an exception
   */
  addComponent(component) {
    const provider = this.getProvider(component.name);
    if (provider.isComponentSet()) {
      throw new Error(
        `Component ${component.name} has already been registered with ${this.name}`
      );
    }
    provider.setComponent(component);
  }
  addOrOverwriteComponent(component) {
    const provider = this.getProvider(component.name);
    if (provider.isComponentSet()) {
      this.providers.delete(component.name);
    }
    this.addComponent(component);
  }
  /**
   * getProvider provides a type safe interface where it can only be called with a field name
   * present in NameServiceMapping interface.
   *
   * Firebase SDKs providing services should extend NameServiceMapping interface to register
   * themselves.
   */
  getProvider(name2) {
    if (this.providers.has(name2)) {
      return this.providers.get(name2);
    }
    const provider = new Provider(name2, this);
    this.providers.set(name2, provider);
    return provider;
  }
  getProviders() {
    return Array.from(this.providers.values());
  }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var LogLevel;
(function (LogLevel2) {
  LogLevel2[(LogLevel2["DEBUG"] = 0)] = "DEBUG";
  LogLevel2[(LogLevel2["VERBOSE"] = 1)] = "VERBOSE";
  LogLevel2[(LogLevel2["INFO"] = 2)] = "INFO";
  LogLevel2[(LogLevel2["WARN"] = 3)] = "WARN";
  LogLevel2[(LogLevel2["ERROR"] = 4)] = "ERROR";
  LogLevel2[(LogLevel2["SILENT"] = 5)] = "SILENT";
})(LogLevel || (LogLevel = {}));
const levelStringToEnum = {
  debug: LogLevel.DEBUG,
  verbose: LogLevel.VERBOSE,
  info: LogLevel.INFO,
  warn: LogLevel.WARN,
  error: LogLevel.ERROR,
  silent: LogLevel.SILENT,
};
const defaultLogLevel = LogLevel.INFO;
const ConsoleMethod = {
  [LogLevel.DEBUG]: "log",
  [LogLevel.VERBOSE]: "log",
  [LogLevel.INFO]: "info",
  [LogLevel.WARN]: "warn",
  [LogLevel.ERROR]: "error",
};
const defaultLogHandler = (instance2, logType, ...args) => {
  if (logType < instance2.logLevel) {
    return;
  }
  const now2 = /* @__PURE__ */ new Date().toISOString();
  const method = ConsoleMethod[logType];
  if (method) {
    console[method](`[${now2}]  ${instance2.name}:`, ...args);
  } else {
    throw new Error(
      `Attempted to log a message with an invalid logType (value: ${logType})`
    );
  }
};
class Logger {
  /**
   * Gives you an instance of a Logger to capture messages according to
   * Firebase's logging scheme.
   *
   * @param name The name that the logs will be associated with
   */
  constructor(name2) {
    this.name = name2;
    this._logLevel = defaultLogLevel;
    this._logHandler = defaultLogHandler;
    this._userLogHandler = null;
  }
  get logLevel() {
    return this._logLevel;
  }
  set logLevel(val) {
    if (!(val in LogLevel)) {
      throw new TypeError(`Invalid value "${val}" assigned to \`logLevel\``);
    }
    this._logLevel = val;
  }
  // Workaround for setter/getter having to be the same type.
  setLogLevel(val) {
    this._logLevel = typeof val === "string" ? levelStringToEnum[val] : val;
  }
  get logHandler() {
    return this._logHandler;
  }
  set logHandler(val) {
    if (typeof val !== "function") {
      throw new TypeError("Value assigned to `logHandler` must be a function");
    }
    this._logHandler = val;
  }
  get userLogHandler() {
    return this._userLogHandler;
  }
  set userLogHandler(val) {
    this._userLogHandler = val;
  }
  /**
   * The functions below are all based on the `console` interface
   */
  debug(...args) {
    this._userLogHandler && this._userLogHandler(this, LogLevel.DEBUG, ...args);
    this._logHandler(this, LogLevel.DEBUG, ...args);
  }
  log(...args) {
    this._userLogHandler &&
      this._userLogHandler(this, LogLevel.VERBOSE, ...args);
    this._logHandler(this, LogLevel.VERBOSE, ...args);
  }
  info(...args) {
    this._userLogHandler && this._userLogHandler(this, LogLevel.INFO, ...args);
    this._logHandler(this, LogLevel.INFO, ...args);
  }
  warn(...args) {
    this._userLogHandler && this._userLogHandler(this, LogLevel.WARN, ...args);
    this._logHandler(this, LogLevel.WARN, ...args);
  }
  error(...args) {
    this._userLogHandler && this._userLogHandler(this, LogLevel.ERROR, ...args);
    this._logHandler(this, LogLevel.ERROR, ...args);
  }
}
const instanceOfAny = (object, constructors) =>
  constructors.some((c) => object instanceof c);
let idbProxyableTypes;
let cursorAdvanceMethods;
function getIdbProxyableTypes() {
  return (
    idbProxyableTypes ||
    (idbProxyableTypes = [
      IDBDatabase,
      IDBObjectStore,
      IDBIndex,
      IDBCursor,
      IDBTransaction,
    ])
  );
}
function getCursorAdvanceMethods() {
  return (
    cursorAdvanceMethods ||
    (cursorAdvanceMethods = [
      IDBCursor.prototype.advance,
      IDBCursor.prototype.continue,
      IDBCursor.prototype.continuePrimaryKey,
    ])
  );
}
const cursorRequestMap = /* @__PURE__ */ new WeakMap();
const transactionDoneMap = /* @__PURE__ */ new WeakMap();
const transactionStoreNamesMap = /* @__PURE__ */ new WeakMap();
const transformCache = /* @__PURE__ */ new WeakMap();
const reverseTransformCache = /* @__PURE__ */ new WeakMap();
function promisifyRequest(request) {
  const promise2 = new Promise((resolve, reject3) => {
    const unlisten = () => {
      request.removeEventListener("success", success);
      request.removeEventListener("error", error);
    };
    const success = () => {
      resolve(wrap(request.result));
      unlisten();
    };
    const error = () => {
      reject3(request.error);
      unlisten();
    };
    request.addEventListener("success", success);
    request.addEventListener("error", error);
  });
  promise2
    .then((value) => {
      if (value instanceof IDBCursor) {
        cursorRequestMap.set(value, request);
      }
    })
    .catch(() => {});
  reverseTransformCache.set(promise2, request);
  return promise2;
}
function cacheDonePromiseForTransaction(tx) {
  if (transactionDoneMap.has(tx)) return;
  const done = new Promise((resolve, reject3) => {
    const unlisten = () => {
      tx.removeEventListener("complete", complete);
      tx.removeEventListener("error", error);
      tx.removeEventListener("abort", error);
    };
    const complete = () => {
      resolve();
      unlisten();
    };
    const error = () => {
      reject3(tx.error || new DOMException("AbortError", "AbortError"));
      unlisten();
    };
    tx.addEventListener("complete", complete);
    tx.addEventListener("error", error);
    tx.addEventListener("abort", error);
  });
  transactionDoneMap.set(tx, done);
}
let idbProxyTraps = {
  get(target, prop3, receiver) {
    if (target instanceof IDBTransaction) {
      if (prop3 === "done") return transactionDoneMap.get(target);
      if (prop3 === "objectStoreNames") {
        return target.objectStoreNames || transactionStoreNamesMap.get(target);
      }
      if (prop3 === "store") {
        return receiver.objectStoreNames[1]
          ? void 0
          : receiver.objectStore(receiver.objectStoreNames[0]);
      }
    }
    return wrap(target[prop3]);
  },
  set(target, prop3, value) {
    target[prop3] = value;
    return true;
  },
  has(target, prop3) {
    if (
      target instanceof IDBTransaction &&
      (prop3 === "done" || prop3 === "store")
    ) {
      return true;
    }
    return prop3 in target;
  },
};
function replaceTraps(callback) {
  idbProxyTraps = callback(idbProxyTraps);
}
function wrapFunction(func) {
  if (
    func === IDBDatabase.prototype.transaction &&
    !("objectStoreNames" in IDBTransaction.prototype)
  ) {
    return function (storeNames, ...args) {
      const tx = func.call(unwrap(this), storeNames, ...args);
      transactionStoreNamesMap.set(
        tx,
        storeNames.sort ? storeNames.sort() : [storeNames]
      );
      return wrap(tx);
    };
  }
  if (getCursorAdvanceMethods().includes(func)) {
    return function (...args) {
      func.apply(unwrap(this), args);
      return wrap(cursorRequestMap.get(this));
    };
  }
  return function (...args) {
    return wrap(func.apply(unwrap(this), args));
  };
}
function transformCachableValue(value) {
  if (typeof value === "function") return wrapFunction(value);
  if (value instanceof IDBTransaction) cacheDonePromiseForTransaction(value);
  if (instanceOfAny(value, getIdbProxyableTypes()))
    return new Proxy(value, idbProxyTraps);
  return value;
}
function wrap(value) {
  if (value instanceof IDBRequest) return promisifyRequest(value);
  if (transformCache.has(value)) return transformCache.get(value);
  const newValue = transformCachableValue(value);
  if (newValue !== value) {
    transformCache.set(value, newValue);
    reverseTransformCache.set(newValue, value);
  }
  return newValue;
}
const unwrap = (value) => reverseTransformCache.get(value);
function openDB(
  name2,
  version2,
  { blocked, upgrade, blocking, terminated } = {}
) {
  const request = indexedDB.open(name2, version2);
  const openPromise = wrap(request);
  if (upgrade) {
    request.addEventListener("upgradeneeded", (event) => {
      upgrade(
        wrap(request.result),
        event.oldVersion,
        event.newVersion,
        wrap(request.transaction),
        event
      );
    });
  }
  if (blocked) {
    request.addEventListener("blocked", (event) =>
      blocked(
        // Casting due to https://github.com/microsoft/TypeScript-DOM-lib-generator/pull/1405
        event.oldVersion,
        event.newVersion,
        event
      )
    );
  }
  openPromise
    .then((db2) => {
      if (terminated) db2.addEventListener("close", () => terminated());
      if (blocking) {
        db2.addEventListener("versionchange", (event) =>
          blocking(event.oldVersion, event.newVersion, event)
        );
      }
    })
    .catch(() => {});
  return openPromise;
}
const readMethods = ["get", "getKey", "getAll", "getAllKeys", "count"];
const writeMethods = ["put", "add", "delete", "clear"];
const cachedMethods = /* @__PURE__ */ new Map();
function getMethod(target, prop3) {
  if (
    !(
      target instanceof IDBDatabase &&
      !(prop3 in target) &&
      typeof prop3 === "string"
    )
  ) {
    return;
  }
  if (cachedMethods.get(prop3)) return cachedMethods.get(prop3);
  const targetFuncName = prop3.replace(/FromIndex$/, "");
  const useIndex = prop3 !== targetFuncName;
  const isWrite = writeMethods.includes(targetFuncName);
  if (
    // Bail if the target doesn't exist on the target. Eg, getAll isn't in Edge.
    !(targetFuncName in (useIndex ? IDBIndex : IDBObjectStore).prototype) ||
    !(isWrite || readMethods.includes(targetFuncName))
  ) {
    return;
  }
  const method = async function (storeName, ...args) {
    const tx = this.transaction(storeName, isWrite ? "readwrite" : "readonly");
    let target2 = tx.store;
    if (useIndex) target2 = target2.index(args.shift());
    return (
      await Promise.all([target2[targetFuncName](...args), isWrite && tx.done])
    )[0];
  };
  cachedMethods.set(prop3, method);
  return method;
}
replaceTraps((oldTraps) => ({
  ...oldTraps,
  get: (target, prop3, receiver) =>
    getMethod(target, prop3) || oldTraps.get(target, prop3, receiver),
  has: (target, prop3) =>
    !!getMethod(target, prop3) || oldTraps.has(target, prop3),
}));
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class PlatformLoggerServiceImpl {
  constructor(container) {
    this.container = container;
  }
  // In initial implementation, this will be called by installations on
  // auth token refresh, and installations will send this string.
  getPlatformInfoString() {
    const providers = this.container.getProviders();
    return providers
      .map((provider) => {
        if (isVersionServiceProvider(provider)) {
          const service = provider.getImmediate();
          return `${service.library}/${service.version}`;
        } else {
          return null;
        }
      })
      .filter((logString) => logString)
      .join(" ");
  }
}
function isVersionServiceProvider(provider) {
  const component = provider.getComponent();
  return (
    (component === null || component === void 0 ? void 0 : component.type) ===
    "VERSION"
  );
}
const name$o = "@firebase/app";
const version$1$1 = "0.10.1";
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const logger = new Logger("@firebase/app");
const name$n = "@firebase/app-compat";
const name$m = "@firebase/analytics-compat";
const name$l = "@firebase/analytics";
const name$k = "@firebase/app-check-compat";
const name$j = "@firebase/app-check";
const name$i = "@firebase/auth";
const name$h = "@firebase/auth-compat";
const name$g = "@firebase/database";
const name$f = "@firebase/database-compat";
const name$e = "@firebase/functions";
const name$d = "@firebase/functions-compat";
const name$c = "@firebase/installations";
const name$b = "@firebase/installations-compat";
const name$a = "@firebase/messaging";
const name$9 = "@firebase/messaging-compat";
const name$8 = "@firebase/performance";
const name$7 = "@firebase/performance-compat";
const name$6 = "@firebase/remote-config";
const name$5 = "@firebase/remote-config-compat";
const name$4 = "@firebase/storage";
const name$3$1 = "@firebase/storage-compat";
const name$2$1 = "@firebase/firestore";
const name$1$1 = "@firebase/firestore-compat";
const name$p = "firebase";
const version$4 = "10.11.0";
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const DEFAULT_ENTRY_NAME = "[DEFAULT]";
const PLATFORM_LOG_STRING = {
  [name$o]: "fire-core",
  [name$n]: "fire-core-compat",
  [name$l]: "fire-analytics",
  [name$m]: "fire-analytics-compat",
  [name$j]: "fire-app-check",
  [name$k]: "fire-app-check-compat",
  [name$i]: "fire-auth",
  [name$h]: "fire-auth-compat",
  [name$g]: "fire-rtdb",
  [name$f]: "fire-rtdb-compat",
  [name$e]: "fire-fn",
  [name$d]: "fire-fn-compat",
  [name$c]: "fire-iid",
  [name$b]: "fire-iid-compat",
  [name$a]: "fire-fcm",
  [name$9]: "fire-fcm-compat",
  [name$8]: "fire-perf",
  [name$7]: "fire-perf-compat",
  [name$6]: "fire-rc",
  [name$5]: "fire-rc-compat",
  [name$4]: "fire-gcs",
  [name$3$1]: "fire-gcs-compat",
  [name$2$1]: "fire-fst",
  [name$1$1]: "fire-fst-compat",
  "fire-js": "fire-js",
  [name$p]: "fire-js-all",
};
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const _apps = /* @__PURE__ */ new Map();
const _serverApps = /* @__PURE__ */ new Map();
const _components = /* @__PURE__ */ new Map();
function _addComponent(app2, component) {
  try {
    app2.container.addComponent(component);
  } catch (e) {
    logger.debug(
      `Component ${component.name} failed to register with FirebaseApp ${app2.name}`,
      e
    );
  }
}
function _registerComponent(component) {
  const componentName = component.name;
  if (_components.has(componentName)) {
    logger.debug(
      `There were multiple attempts to register component ${componentName}.`
    );
    return false;
  }
  _components.set(componentName, component);
  for (const app2 of _apps.values()) {
    _addComponent(app2, component);
  }
  for (const serverApp of _serverApps.values()) {
    _addComponent(serverApp, component);
  }
  return true;
}
function _getProvider(app2, name2) {
  const heartbeatController = app2.container
    .getProvider("heartbeat")
    .getImmediate({ optional: true });
  if (heartbeatController) {
    void heartbeatController.triggerHeartbeat();
  }
  return app2.container.getProvider(name2);
}
function _isFirebaseServerApp(obj) {
  return obj.settings !== void 0;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const ERRORS = {
  ["no-app"]:
    /* AppError.NO_APP */
    "No Firebase App '{$appName}' has been created - call initializeApp() first",
  ["bad-app-name"]:
    /* AppError.BAD_APP_NAME */
    "Illegal App name: '{$appName}'",
  ["duplicate-app"]:
    /* AppError.DUPLICATE_APP */
    "Firebase App named '{$appName}' already exists with different options or config",
  ["app-deleted"]:
    /* AppError.APP_DELETED */
    "Firebase App named '{$appName}' already deleted",
  ["server-app-deleted"]:
    /* AppError.SERVER_APP_DELETED */
    "Firebase Server App has been deleted",
  ["no-options"]:
    /* AppError.NO_OPTIONS */
    "Need to provide options, when not being deployed to hosting via source.",
  ["invalid-app-argument"]:
    /* AppError.INVALID_APP_ARGUMENT */
    "firebase.{$appName}() takes either no argument or a Firebase App instance.",
  ["invalid-log-argument"]:
    /* AppError.INVALID_LOG_ARGUMENT */
    "First argument to `onLog` must be null or a function.",
  ["idb-open"]:
    /* AppError.IDB_OPEN */
    "Error thrown when opening IndexedDB. Original error: {$originalErrorMessage}.",
  ["idb-get"]:
    /* AppError.IDB_GET */
    "Error thrown when reading from IndexedDB. Original error: {$originalErrorMessage}.",
  ["idb-set"]:
    /* AppError.IDB_WRITE */
    "Error thrown when writing to IndexedDB. Original error: {$originalErrorMessage}.",
  ["idb-delete"]:
    /* AppError.IDB_DELETE */
    "Error thrown when deleting from IndexedDB. Original error: {$originalErrorMessage}.",
  ["finalization-registry-not-supported"]:
    /* AppError.FINALIZATION_REGISTRY_NOT_SUPPORTED */
    "FirebaseServerApp deleteOnDeref field defined but the JS runtime does not support FinalizationRegistry.",
  ["invalid-server-app-environment"]:
    /* AppError.INVALID_SERVER_APP_ENVIRONMENT */
    "FirebaseServerApp is not for use in browser environments.",
};
const ERROR_FACTORY = new ErrorFactory("app", "Firebase", ERRORS);
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class FirebaseAppImpl {
  constructor(options, config, container) {
    this._isDeleted = false;
    this._options = Object.assign({}, options);
    this._config = Object.assign({}, config);
    this._name = config.name;
    this._automaticDataCollectionEnabled =
      config.automaticDataCollectionEnabled;
    this._container = container;
    this.container.addComponent(
      new Component(
        "app",
        () => this,
        "PUBLIC"
        /* ComponentType.PUBLIC */
      )
    );
  }
  get automaticDataCollectionEnabled() {
    this.checkDestroyed();
    return this._automaticDataCollectionEnabled;
  }
  set automaticDataCollectionEnabled(val) {
    this.checkDestroyed();
    this._automaticDataCollectionEnabled = val;
  }
  get name() {
    this.checkDestroyed();
    return this._name;
  }
  get options() {
    this.checkDestroyed();
    return this._options;
  }
  get config() {
    this.checkDestroyed();
    return this._config;
  }
  get container() {
    return this._container;
  }
  get isDeleted() {
    return this._isDeleted;
  }
  set isDeleted(val) {
    this._isDeleted = val;
  }
  /**
   * This function will throw an Error if the App has already been deleted -
   * use before performing API actions on the App.
   */
  checkDestroyed() {
    if (this.isDeleted) {
      throw ERROR_FACTORY.create("app-deleted", { appName: this._name });
    }
  }
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const SDK_VERSION = version$4;
function initializeApp(_options, rawConfig = {}) {
  let options = _options;
  if (typeof rawConfig !== "object") {
    const name3 = rawConfig;
    rawConfig = { name: name3 };
  }
  const config = Object.assign(
    { name: DEFAULT_ENTRY_NAME, automaticDataCollectionEnabled: false },
    rawConfig
  );
  const name2 = config.name;
  if (typeof name2 !== "string" || !name2) {
    throw ERROR_FACTORY.create("bad-app-name", {
      appName: String(name2),
    });
  }
  options || (options = getDefaultAppConfig());
  if (!options) {
    throw ERROR_FACTORY.create(
      "no-options"
      /* AppError.NO_OPTIONS */
    );
  }
  const existingApp = _apps.get(name2);
  if (existingApp) {
    if (
      deepEqual(options, existingApp.options) &&
      deepEqual(config, existingApp.config)
    ) {
      return existingApp;
    } else {
      throw ERROR_FACTORY.create("duplicate-app", { appName: name2 });
    }
  }
  const container = new ComponentContainer(name2);
  for (const component of _components.values()) {
    container.addComponent(component);
  }
  const newApp = new FirebaseAppImpl(options, config, container);
  _apps.set(name2, newApp);
  return newApp;
}
function getApp(name2 = DEFAULT_ENTRY_NAME) {
  const app2 = _apps.get(name2);
  if (!app2 && name2 === DEFAULT_ENTRY_NAME && getDefaultAppConfig()) {
    return initializeApp();
  }
  if (!app2) {
    throw ERROR_FACTORY.create("no-app", { appName: name2 });
  }
  return app2;
}
function registerVersion(libraryKeyOrName, version2, variant) {
  var _a2;
  let library =
    (_a2 = PLATFORM_LOG_STRING[libraryKeyOrName]) !== null && _a2 !== void 0
      ? _a2
      : libraryKeyOrName;
  if (variant) {
    library += `-${variant}`;
  }
  const libraryMismatch = library.match(/\s|\//);
  const versionMismatch = version2.match(/\s|\//);
  if (libraryMismatch || versionMismatch) {
    const warning = [
      `Unable to register library "${library}" with version "${version2}":`,
    ];
    if (libraryMismatch) {
      warning.push(
        `library name "${library}" contains illegal characters (whitespace or "/")`
      );
    }
    if (libraryMismatch && versionMismatch) {
      warning.push("and");
    }
    if (versionMismatch) {
      warning.push(
        `version name "${version2}" contains illegal characters (whitespace or "/")`
      );
    }
    logger.warn(warning.join(" "));
    return;
  }
  _registerComponent(
    new Component(
      `${library}-version`,
      () => ({ library, version: version2 }),
      "VERSION"
      /* ComponentType.VERSION */
    )
  );
}
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const DB_NAME$1 = "firebase-heartbeat-database";
const DB_VERSION$1 = 1;
const STORE_NAME = "firebase-heartbeat-store";
let dbPromise = null;
function getDbPromise() {
  if (!dbPromise) {
    dbPromise = openDB(DB_NAME$1, DB_VERSION$1, {
      upgrade: (db2, oldVersion) => {
        switch (oldVersion) {
          case 0:
            try {
              db2.createObjectStore(STORE_NAME);
            } catch (e) {
              console.warn(e);
            }
        }
      },
    }).catch((e) => {
      throw ERROR_FACTORY.create("idb-open", {
        originalErrorMessage: e.message,
      });
    });
  }
  return dbPromise;
}
async function readHeartbeatsFromIndexedDB(app2) {
  try {
    const db2 = await getDbPromise();
    const tx = db2.transaction(STORE_NAME);
    const result = await tx.objectStore(STORE_NAME).get(computeKey(app2));
    await tx.done;
    return result;
  } catch (e) {
    if (e instanceof FirebaseError) {
      logger.warn(e.message);
    } else {
      const idbGetError = ERROR_FACTORY.create("idb-get", {
        originalErrorMessage: e === null || e === void 0 ? void 0 : e.message,
      });
      logger.warn(idbGetError.message);
    }
  }
}
async function writeHeartbeatsToIndexedDB(app2, heartbeatObject) {
  try {
    const db2 = await getDbPromise();
    const tx = db2.transaction(STORE_NAME, "readwrite");
    const objectStore = tx.objectStore(STORE_NAME);
    await objectStore.put(heartbeatObject, computeKey(app2));
    await tx.done;
  } catch (e) {
    if (e instanceof FirebaseError) {
      logger.warn(e.message);
    } else {
      const idbGetError = ERROR_FACTORY.create("idb-set", {
        originalErrorMessage: e === null || e === void 0 ? void 0 : e.message,
      });
      logger.warn(idbGetError.message);
    }
  }
}
function computeKey(app2) {
  return `${app2.name}!${app2.options.appId}`;
}
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const MAX_HEADER_BYTES = 1024;
const STORED_HEARTBEAT_RETENTION_MAX_MILLIS = 30 * 24 * 60 * 60 * 1e3;
class HeartbeatServiceImpl {
  constructor(container) {
    this.container = container;
    this._heartbeatsCache = null;
    const app2 = this.container.getProvider("app").getImmediate();
    this._storage = new HeartbeatStorageImpl(app2);
    this._heartbeatsCachePromise = this._storage.read().then((result) => {
      this._heartbeatsCache = result;
      return result;
    });
  }
  /**
   * Called to report a heartbeat. The function will generate
   * a HeartbeatsByUserAgent object, update heartbeatsCache, and persist it
   * to IndexedDB.
   * Note that we only store one heartbeat per day. So if a heartbeat for today is
   * already logged, subsequent calls to this function in the same day will be ignored.
   */
  async triggerHeartbeat() {
    var _a2, _b2;
    const platformLogger = this.container
      .getProvider("platform-logger")
      .getImmediate();
    const agent = platformLogger.getPlatformInfoString();
    const date = getUTCDateString();
    if (
      ((_a2 = this._heartbeatsCache) === null || _a2 === void 0
        ? void 0
        : _a2.heartbeats) == null
    ) {
      this._heartbeatsCache = await this._heartbeatsCachePromise;
      if (
        ((_b2 = this._heartbeatsCache) === null || _b2 === void 0
          ? void 0
          : _b2.heartbeats) == null
      ) {
        return;
      }
    }
    if (
      this._heartbeatsCache.lastSentHeartbeatDate === date ||
      this._heartbeatsCache.heartbeats.some(
        (singleDateHeartbeat) => singleDateHeartbeat.date === date
      )
    ) {
      return;
    } else {
      this._heartbeatsCache.heartbeats.push({ date, agent });
    }
    this._heartbeatsCache.heartbeats = this._heartbeatsCache.heartbeats.filter(
      (singleDateHeartbeat) => {
        const hbTimestamp = new Date(singleDateHeartbeat.date).valueOf();
        const now2 = Date.now();
        return now2 - hbTimestamp <= STORED_HEARTBEAT_RETENTION_MAX_MILLIS;
      }
    );
    return this._storage.overwrite(this._heartbeatsCache);
  }
  /**
   * Returns a base64 encoded string which can be attached to the heartbeat-specific header directly.
   * It also clears all heartbeats from memory as well as in IndexedDB.
   *
   * NOTE: Consuming product SDKs should not send the header if this method
   * returns an empty string.
   */
  async getHeartbeatsHeader() {
    var _a2;
    if (this._heartbeatsCache === null) {
      await this._heartbeatsCachePromise;
    }
    if (
      ((_a2 = this._heartbeatsCache) === null || _a2 === void 0
        ? void 0
        : _a2.heartbeats) == null ||
      this._heartbeatsCache.heartbeats.length === 0
    ) {
      return "";
    }
    const date = getUTCDateString();
    const { heartbeatsToSend, unsentEntries } = extractHeartbeatsForHeader(
      this._heartbeatsCache.heartbeats
    );
    const headerString = base64urlEncodeWithoutPadding(
      JSON.stringify({ version: 2, heartbeats: heartbeatsToSend })
    );
    this._heartbeatsCache.lastSentHeartbeatDate = date;
    if (unsentEntries.length > 0) {
      this._heartbeatsCache.heartbeats = unsentEntries;
      await this._storage.overwrite(this._heartbeatsCache);
    } else {
      this._heartbeatsCache.heartbeats = [];
      void this._storage.overwrite(this._heartbeatsCache);
    }
    return headerString;
  }
}
function getUTCDateString() {
  const today = /* @__PURE__ */ new Date();
  return today.toISOString().substring(0, 10);
}
function extractHeartbeatsForHeader(
  heartbeatsCache,
  maxSize = MAX_HEADER_BYTES
) {
  const heartbeatsToSend = [];
  let unsentEntries = heartbeatsCache.slice();
  for (const singleDateHeartbeat of heartbeatsCache) {
    const heartbeatEntry = heartbeatsToSend.find(
      (hb2) => hb2.agent === singleDateHeartbeat.agent
    );
    if (!heartbeatEntry) {
      heartbeatsToSend.push({
        agent: singleDateHeartbeat.agent,
        dates: [singleDateHeartbeat.date],
      });
      if (countBytes(heartbeatsToSend) > maxSize) {
        heartbeatsToSend.pop();
        break;
      }
    } else {
      heartbeatEntry.dates.push(singleDateHeartbeat.date);
      if (countBytes(heartbeatsToSend) > maxSize) {
        heartbeatEntry.dates.pop();
        break;
      }
    }
    unsentEntries = unsentEntries.slice(1);
  }
  return {
    heartbeatsToSend,
    unsentEntries,
  };
}
class HeartbeatStorageImpl {
  constructor(app2) {
    this.app = app2;
    this._canUseIndexedDBPromise = this.runIndexedDBEnvironmentCheck();
  }
  async runIndexedDBEnvironmentCheck() {
    if (!isIndexedDBAvailable()) {
      return false;
    } else {
      return validateIndexedDBOpenable()
        .then(() => true)
        .catch(() => false);
    }
  }
  /**
   * Read all heartbeats.
   */
  async read() {
    const canUseIndexedDB = await this._canUseIndexedDBPromise;
    if (!canUseIndexedDB) {
      return { heartbeats: [] };
    } else {
      const idbHeartbeatObject = await readHeartbeatsFromIndexedDB(this.app);
      if (
        idbHeartbeatObject === null || idbHeartbeatObject === void 0
          ? void 0
          : idbHeartbeatObject.heartbeats
      ) {
        return idbHeartbeatObject;
      } else {
        return { heartbeats: [] };
      }
    }
  }
  // overwrite the storage with the provided heartbeats
  async overwrite(heartbeatsObject) {
    var _a2;
    const canUseIndexedDB = await this._canUseIndexedDBPromise;
    if (!canUseIndexedDB) {
      return;
    } else {
      const existingHeartbeatsObject = await this.read();
      return writeHeartbeatsToIndexedDB(this.app, {
        lastSentHeartbeatDate:
          (_a2 = heartbeatsObject.lastSentHeartbeatDate) !== null &&
          _a2 !== void 0
            ? _a2
            : existingHeartbeatsObject.lastSentHeartbeatDate,
        heartbeats: heartbeatsObject.heartbeats,
      });
    }
  }
  // add heartbeats
  async add(heartbeatsObject) {
    var _a2;
    const canUseIndexedDB = await this._canUseIndexedDBPromise;
    if (!canUseIndexedDB) {
      return;
    } else {
      const existingHeartbeatsObject = await this.read();
      return writeHeartbeatsToIndexedDB(this.app, {
        lastSentHeartbeatDate:
          (_a2 = heartbeatsObject.lastSentHeartbeatDate) !== null &&
          _a2 !== void 0
            ? _a2
            : existingHeartbeatsObject.lastSentHeartbeatDate,
        heartbeats: [
          ...existingHeartbeatsObject.heartbeats,
          ...heartbeatsObject.heartbeats,
        ],
      });
    }
  }
}
function countBytes(heartbeatsCache) {
  return base64urlEncodeWithoutPadding(
    // heartbeatsCache wrapper properties
    JSON.stringify({ version: 2, heartbeats: heartbeatsCache })
  ).length;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function registerCoreComponents(variant) {
  _registerComponent(
    new Component(
      "platform-logger",
      (container) => new PlatformLoggerServiceImpl(container),
      "PRIVATE"
      /* ComponentType.PRIVATE */
    )
  );
  _registerComponent(
    new Component(
      "heartbeat",
      (container) => new HeartbeatServiceImpl(container),
      "PRIVATE"
      /* ComponentType.PRIVATE */
    )
  );
  registerVersion(name$o, version$1$1, variant);
  registerVersion(name$o, version$1$1, "esm2017");
  registerVersion("fire-js", "");
}
registerCoreComponents("");
var commonjsGlobal =
  typeof globalThis !== "undefined"
    ? globalThis
    : typeof window !== "undefined"
    ? window
    : typeof global !== "undefined"
    ? global
    : typeof self !== "undefined"
    ? self
    : {};
var k,
  goog = goog || {},
  l = commonjsGlobal || self;
function aa(a) {
  var b2 = typeof a;
  b2 = "object" != b2 ? b2 : a ? (Array.isArray(a) ? "array" : b2) : "null";
  return "array" == b2 || ("object" == b2 && "number" == typeof a.length);
}
function p(a) {
  var b2 = typeof a;
  return ("object" == b2 && null != a) || "function" == b2;
}
function ba(a) {
  return (
    (Object.prototype.hasOwnProperty.call(a, ca) && a[ca]) || (a[ca] = ++da)
  );
}
var ca = "closure_uid_" + ((1e9 * Math.random()) >>> 0),
  da = 0;
function ea(a, b2, c) {
  return a.call.apply(a.bind, arguments);
}
function fa(a, b2, c) {
  if (!a) throw Error();
  if (2 < arguments.length) {
    var d = Array.prototype.slice.call(arguments, 2);
    return function () {
      var e = Array.prototype.slice.call(arguments);
      Array.prototype.unshift.apply(e, d);
      return a.apply(b2, e);
    };
  }
  return function () {
    return a.apply(b2, arguments);
  };
}
function q(a, b2, c) {
  Function.prototype.bind &&
  -1 != Function.prototype.bind.toString().indexOf("native code")
    ? (q = ea)
    : (q = fa);
  return q.apply(null, arguments);
}
function ha(a, b2) {
  var c = Array.prototype.slice.call(arguments, 1);
  return function () {
    var d = c.slice();
    d.push.apply(d, arguments);
    return a.apply(this, d);
  };
}
function r(a, b2) {
  function c() {}
  c.prototype = b2.prototype;
  a.$ = b2.prototype;
  a.prototype = new c();
  a.prototype.constructor = a;
  a.ac = function (d, e, f) {
    for (var h = Array(arguments.length - 2), n = 2; n < arguments.length; n++)
      h[n - 2] = arguments[n];
    return b2.prototype[e].apply(d, h);
  };
}
function v$1() {
  this.s = this.s;
  this.o = this.o;
}
var ia = 0;
v$1.prototype.s = false;
v$1.prototype.sa = function () {
  if (!this.s && ((this.s = true), this.N(), 0 != ia)) {
    ba(this);
  }
};
v$1.prototype.N = function () {
  if (this.o) for (; this.o.length; ) this.o.shift()();
};
const ka = Array.prototype.indexOf
  ? function (a, b2) {
      return Array.prototype.indexOf.call(a, b2, void 0);
    }
  : function (a, b2) {
      if ("string" === typeof a)
        return "string" !== typeof b2 || 1 != b2.length ? -1 : a.indexOf(b2, 0);
      for (let c = 0; c < a.length; c++) if (c in a && a[c] === b2) return c;
      return -1;
    };
function ma(a) {
  const b2 = a.length;
  if (0 < b2) {
    const c = Array(b2);
    for (let d = 0; d < b2; d++) c[d] = a[d];
    return c;
  }
  return [];
}
function na(a, b2) {
  for (let c = 1; c < arguments.length; c++) {
    const d = arguments[c];
    if (aa(d)) {
      const e = a.length || 0,
        f = d.length || 0;
      a.length = e + f;
      for (let h = 0; h < f; h++) a[e + h] = d[h];
    } else a.push(d);
  }
}
function w$1(a, b2) {
  this.type = a;
  this.g = this.target = b2;
  this.defaultPrevented = false;
}
w$1.prototype.h = function () {
  this.defaultPrevented = true;
};
var oa = (function () {
  if (!l.addEventListener || !Object.defineProperty) return false;
  var a = false,
    b2 = Object.defineProperty({}, "passive", {
      get: function () {
        a = true;
      },
    });
  try {
    const c = () => {};
    l.addEventListener("test", c, b2);
    l.removeEventListener("test", c, b2);
  } catch (c) {}
  return a;
})();
function x(a) {
  return /^[\s\xa0]*$/.test(a);
}
function pa() {
  var a = l.navigator;
  return a && (a = a.userAgent) ? a : "";
}
function y(a) {
  return -1 != pa().indexOf(a);
}
function qa(a) {
  qa[" "](a);
  return a;
}
qa[" "] = function () {};
function ra(a, b2) {
  var c = sa;
  return Object.prototype.hasOwnProperty.call(c, a) ? c[a] : (c[a] = b2(a));
}
var ta = y("Opera"),
  z = y("Trident") || y("MSIE"),
  ua = y("Edge"),
  va = ua || z,
  wa =
    y("Gecko") &&
    !(-1 != pa().toLowerCase().indexOf("webkit") && !y("Edge")) &&
    !(y("Trident") || y("MSIE")) &&
    !y("Edge"),
  xa = -1 != pa().toLowerCase().indexOf("webkit") && !y("Edge");
function ya() {
  var a = l.document;
  return a ? a.documentMode : void 0;
}
var za;
a: {
  var Aa = "",
    Ba = (function () {
      var a = pa();
      if (wa) return /rv:([^\);]+)(\)|;)/.exec(a);
      if (ua) return /Edge\/([\d\.]+)/.exec(a);
      if (z) return /\b(?:MSIE|rv)[: ]([^\);]+)(\)|;)/.exec(a);
      if (xa) return /WebKit\/(\S+)/.exec(a);
      if (ta) return /(?:Version)[ \/]?(\S+)/.exec(a);
    })();
  Ba && (Aa = Ba ? Ba[1] : "");
  if (z) {
    var Ca = ya();
    if (null != Ca && Ca > parseFloat(Aa)) {
      za = String(Ca);
      break a;
    }
  }
  za = Aa;
}
var Da;
if (l.document && z) {
  var Ea = ya();
  Da = Ea ? Ea : parseInt(za, 10) || void 0;
} else Da = void 0;
var Fa = Da;
function A(a, b2) {
  w$1.call(this, a ? a.type : "");
  this.relatedTarget = this.g = this.target = null;
  this.button = this.screenY = this.screenX = this.clientY = this.clientX = 0;
  this.key = "";
  this.metaKey = this.shiftKey = this.altKey = this.ctrlKey = false;
  this.state = null;
  this.pointerId = 0;
  this.pointerType = "";
  this.i = null;
  if (a) {
    var c = (this.type = a.type),
      d =
        a.changedTouches && a.changedTouches.length
          ? a.changedTouches[0]
          : null;
    this.target = a.target || a.srcElement;
    this.g = b2;
    if ((b2 = a.relatedTarget)) {
      if (wa) {
        a: {
          try {
            qa(b2.nodeName);
            var e = true;
            break a;
          } catch (f) {}
          e = false;
        }
        e || (b2 = null);
      }
    } else
      "mouseover" == c
        ? (b2 = a.fromElement)
        : "mouseout" == c && (b2 = a.toElement);
    this.relatedTarget = b2;
    d
      ? ((this.clientX = void 0 !== d.clientX ? d.clientX : d.pageX),
        (this.clientY = void 0 !== d.clientY ? d.clientY : d.pageY),
        (this.screenX = d.screenX || 0),
        (this.screenY = d.screenY || 0))
      : ((this.clientX = void 0 !== a.clientX ? a.clientX : a.pageX),
        (this.clientY = void 0 !== a.clientY ? a.clientY : a.pageY),
        (this.screenX = a.screenX || 0),
        (this.screenY = a.screenY || 0));
    this.button = a.button;
    this.key = a.key || "";
    this.ctrlKey = a.ctrlKey;
    this.altKey = a.altKey;
    this.shiftKey = a.shiftKey;
    this.metaKey = a.metaKey;
    this.pointerId = a.pointerId || 0;
    this.pointerType =
      "string" === typeof a.pointerType
        ? a.pointerType
        : Ga[a.pointerType] || "";
    this.state = a.state;
    this.i = a;
    a.defaultPrevented && A.$.h.call(this);
  }
}
r(A, w$1);
var Ga = { 2: "touch", 3: "pen", 4: "mouse" };
A.prototype.h = function () {
  A.$.h.call(this);
  var a = this.i;
  a.preventDefault ? a.preventDefault() : (a.returnValue = false);
};
var Ha = "closure_listenable_" + ((1e6 * Math.random()) | 0);
var Ia = 0;
function Ja(a, b2, c, d, e) {
  this.listener = a;
  this.proxy = null;
  this.src = b2;
  this.type = c;
  this.capture = !!d;
  this.la = e;
  this.key = ++Ia;
  this.fa = this.ia = false;
}
function Ma(a) {
  a.fa = true;
  a.listener = null;
  a.proxy = null;
  a.src = null;
  a.la = null;
}
function Na(a, b2, c) {
  for (const d in a) b2.call(c, a[d], d, a);
}
function Oa(a, b2) {
  for (const c in a) b2.call(void 0, a[c], c, a);
}
function Pa(a) {
  const b2 = {};
  for (const c in a) b2[c] = a[c];
  return b2;
}
const Qa =
  "constructor hasOwnProperty isPrototypeOf propertyIsEnumerable toLocaleString toString valueOf".split(
    " "
  );
function Ra(a, b2) {
  let c, d;
  for (let e = 1; e < arguments.length; e++) {
    d = arguments[e];
    for (c in d) a[c] = d[c];
    for (let f = 0; f < Qa.length; f++)
      (c = Qa[f]), Object.prototype.hasOwnProperty.call(d, c) && (a[c] = d[c]);
  }
}
function Sa(a) {
  this.src = a;
  this.g = {};
  this.h = 0;
}
Sa.prototype.add = function (a, b2, c, d, e) {
  var f = a.toString();
  a = this.g[f];
  a || ((a = this.g[f] = []), this.h++);
  var h = Ta(a, b2, d, e);
  -1 < h
    ? ((b2 = a[h]), c || (b2.ia = false))
    : ((b2 = new Ja(b2, this.src, f, !!d, e)), (b2.ia = c), a.push(b2));
  return b2;
};
function Ua(a, b2) {
  var c = b2.type;
  if (c in a.g) {
    var d = a.g[c],
      e = ka(d, b2),
      f;
    (f = 0 <= e) && Array.prototype.splice.call(d, e, 1);
    f && (Ma(b2), 0 == a.g[c].length && (delete a.g[c], a.h--));
  }
}
function Ta(a, b2, c, d) {
  for (var e = 0; e < a.length; ++e) {
    var f = a[e];
    if (!f.fa && f.listener == b2 && f.capture == !!c && f.la == d) return e;
  }
  return -1;
}
var Va = "closure_lm_" + ((1e6 * Math.random()) | 0),
  Wa = {};
function Ya(a, b2, c, d, e) {
  if (d && d.once) return Za(a, b2, c, d, e);
  if (Array.isArray(b2)) {
    for (var f = 0; f < b2.length; f++) Ya(a, b2[f], c, d, e);
    return null;
  }
  c = $a(c);
  return a && a[Ha]
    ? a.O(b2, c, p(d) ? !!d.capture : !!d, e)
    : ab(a, b2, c, false, d, e);
}
function ab(a, b2, c, d, e, f) {
  if (!b2) throw Error("Invalid event type");
  var h = p(e) ? !!e.capture : !!e,
    n = bb(a);
  n || (a[Va] = n = new Sa(a));
  c = n.add(b2, c, d, h, f);
  if (c.proxy) return c;
  d = cb();
  c.proxy = d;
  d.src = a;
  d.listener = c;
  if (a.addEventListener)
    oa || (e = h),
      void 0 === e && (e = false),
      a.addEventListener(b2.toString(), d, e);
  else if (a.attachEvent) a.attachEvent(db$1(b2.toString()), d);
  else if (a.addListener && a.removeListener) a.addListener(d);
  else throw Error("addEventListener and attachEvent are unavailable.");
  return c;
}
function cb() {
  function a(c) {
    return b2.call(a.src, a.listener, c);
  }
  const b2 = eb;
  return a;
}
function Za(a, b2, c, d, e) {
  if (Array.isArray(b2)) {
    for (var f = 0; f < b2.length; f++) Za(a, b2[f], c, d, e);
    return null;
  }
  c = $a(c);
  return a && a[Ha]
    ? a.P(b2, c, p(d) ? !!d.capture : !!d, e)
    : ab(a, b2, c, true, d, e);
}
function fb(a, b2, c, d, e) {
  if (Array.isArray(b2))
    for (var f = 0; f < b2.length; f++) fb(a, b2[f], c, d, e);
  else
    ((d = p(d) ? !!d.capture : !!d), (c = $a(c)), a && a[Ha])
      ? ((a = a.i),
        (b2 = String(b2).toString()),
        b2 in a.g &&
          ((f = a.g[b2]),
          (c = Ta(f, c, d, e)),
          -1 < c &&
            (Ma(f[c]),
            Array.prototype.splice.call(f, c, 1),
            0 == f.length && (delete a.g[b2], a.h--))))
      : a &&
        (a = bb(a)) &&
        ((b2 = a.g[b2.toString()]),
        (a = -1),
        b2 && (a = Ta(b2, c, d, e)),
        (c = -1 < a ? b2[a] : null) && gb(c));
}
function gb(a) {
  if ("number" !== typeof a && a && !a.fa) {
    var b2 = a.src;
    if (b2 && b2[Ha]) Ua(b2.i, a);
    else {
      var c = a.type,
        d = a.proxy;
      b2.removeEventListener
        ? b2.removeEventListener(c, d, a.capture)
        : b2.detachEvent
        ? b2.detachEvent(db$1(c), d)
        : b2.addListener && b2.removeListener && b2.removeListener(d);
      (c = bb(b2))
        ? (Ua(c, a), 0 == c.h && ((c.src = null), (b2[Va] = null)))
        : Ma(a);
    }
  }
}
function db$1(a) {
  return a in Wa ? Wa[a] : (Wa[a] = "on" + a);
}
function eb(a, b2) {
  if (a.fa) a = true;
  else {
    b2 = new A(b2, this);
    var c = a.listener,
      d = a.la || a.src;
    a.ia && gb(a);
    a = c.call(d, b2);
  }
  return a;
}
function bb(a) {
  a = a[Va];
  return a instanceof Sa ? a : null;
}
var hb = "__closure_events_fn_" + ((1e9 * Math.random()) >>> 0);
function $a(a) {
  if ("function" === typeof a) return a;
  a[hb] ||
    (a[hb] = function (b2) {
      return a.handleEvent(b2);
    });
  return a[hb];
}
function B() {
  v$1.call(this);
  this.i = new Sa(this);
  this.S = this;
  this.J = null;
}
r(B, v$1);
B.prototype[Ha] = true;
B.prototype.removeEventListener = function (a, b2, c, d) {
  fb(this, a, b2, c, d);
};
function C$1(a, b2) {
  var c,
    d = a.J;
  if (d) for (c = []; d; d = d.J) c.push(d);
  a = a.S;
  d = b2.type || b2;
  if ("string" === typeof b2) b2 = new w$1(b2, a);
  else if (b2 instanceof w$1) b2.target = b2.target || a;
  else {
    var e = b2;
    b2 = new w$1(d, a);
    Ra(b2, e);
  }
  e = true;
  if (c)
    for (var f = c.length - 1; 0 <= f; f--) {
      var h = (b2.g = c[f]);
      e = ib(h, d, true, b2) && e;
    }
  h = b2.g = a;
  e = ib(h, d, true, b2) && e;
  e = ib(h, d, false, b2) && e;
  if (c)
    for (f = 0; f < c.length; f++)
      (h = b2.g = c[f]), (e = ib(h, d, false, b2) && e);
}
B.prototype.N = function () {
  B.$.N.call(this);
  if (this.i) {
    var a = this.i,
      c;
    for (c in a.g) {
      for (var d = a.g[c], e = 0; e < d.length; e++) Ma(d[e]);
      delete a.g[c];
      a.h--;
    }
  }
  this.J = null;
};
B.prototype.O = function (a, b2, c, d) {
  return this.i.add(String(a), b2, false, c, d);
};
B.prototype.P = function (a, b2, c, d) {
  return this.i.add(String(a), b2, true, c, d);
};
function ib(a, b2, c, d) {
  b2 = a.i.g[String(b2)];
  if (!b2) return true;
  b2 = b2.concat();
  for (var e = true, f = 0; f < b2.length; ++f) {
    var h = b2[f];
    if (h && !h.fa && h.capture == c) {
      var n = h.listener,
        t = h.la || h.src;
      h.ia && Ua(a.i, h);
      e = false !== n.call(t, d) && e;
    }
  }
  return e && !d.defaultPrevented;
}
var jb = l.JSON.stringify;
class kb {
  constructor(a, b2) {
    this.i = a;
    this.j = b2;
    this.h = 0;
    this.g = null;
  }
  get() {
    let a;
    0 < this.h
      ? (this.h--, (a = this.g), (this.g = a.next), (a.next = null))
      : (a = this.i());
    return a;
  }
}
function lb() {
  var a = mb;
  let b2 = null;
  a.g && ((b2 = a.g), (a.g = a.g.next), a.g || (a.h = null), (b2.next = null));
  return b2;
}
class nb {
  constructor() {
    this.h = this.g = null;
  }
  add(a, b2) {
    const c = ob.get();
    c.set(a, b2);
    this.h ? (this.h.next = c) : (this.g = c);
    this.h = c;
  }
}
var ob = new kb(
  () => new pb(),
  (a) => a.reset()
);
class pb {
  constructor() {
    this.next = this.g = this.h = null;
  }
  set(a, b2) {
    this.h = a;
    this.g = b2;
    this.next = null;
  }
  reset() {
    this.next = this.g = this.h = null;
  }
}
function qb(a) {
  var b2 = 1;
  a = a.split(":");
  const c = [];
  for (; 0 < b2 && a.length; ) c.push(a.shift()), b2--;
  a.length && c.push(a.join(":"));
  return c;
}
function rb(a) {
  l.setTimeout(() => {
    throw a;
  }, 0);
}
let sb,
  tb = false,
  mb = new nb(),
  vb = () => {
    const a = l.Promise.resolve(void 0);
    sb = () => {
      a.then(ub);
    };
  };
var ub = () => {
  for (var a; (a = lb()); ) {
    try {
      a.h.call(a.g);
    } catch (c) {
      rb(c);
    }
    var b2 = ob;
    b2.j(a);
    100 > b2.h && (b2.h++, (a.next = b2.g), (b2.g = a));
  }
  tb = false;
};
function wb(a, b2) {
  B.call(this);
  this.h = a || 1;
  this.g = b2 || l;
  this.j = q(this.qb, this);
  this.l = Date.now();
}
r(wb, B);
k = wb.prototype;
k.ga = false;
k.T = null;
k.qb = function () {
  if (this.ga) {
    var a = Date.now() - this.l;
    0 < a && a < 0.8 * this.h
      ? (this.T = this.g.setTimeout(this.j, this.h - a))
      : (this.T && (this.g.clearTimeout(this.T), (this.T = null)),
        C$1(this, "tick"),
        this.ga && (xb(this), this.start()));
  }
};
k.start = function () {
  this.ga = true;
  this.T ||
    ((this.T = this.g.setTimeout(this.j, this.h)), (this.l = Date.now()));
};
function xb(a) {
  a.ga = false;
  a.T && (a.g.clearTimeout(a.T), (a.T = null));
}
k.N = function () {
  wb.$.N.call(this);
  xb(this);
  delete this.g;
};
function yb(a, b2, c) {
  if ("function" === typeof a) c && (a = q(a, c));
  else if (a && "function" == typeof a.handleEvent) a = q(a.handleEvent, a);
  else throw Error("Invalid listener argument");
  return 2147483647 < Number(b2) ? -1 : l.setTimeout(a, b2 || 0);
}
function zb(a) {
  a.g = yb(() => {
    a.g = null;
    a.i && ((a.i = false), zb(a));
  }, a.j);
  const b2 = a.h;
  a.h = null;
  a.m.apply(null, b2);
}
class Ab extends v$1 {
  constructor(a, b2) {
    super();
    this.m = a;
    this.j = b2;
    this.h = null;
    this.i = false;
    this.g = null;
  }
  l(a) {
    this.h = arguments;
    this.g ? (this.i = true) : zb(this);
  }
  N() {
    super.N();
    this.g &&
      (l.clearTimeout(this.g),
      (this.g = null),
      (this.i = false),
      (this.h = null));
  }
}
function Bb(a) {
  v$1.call(this);
  this.h = a;
  this.g = {};
}
r(Bb, v$1);
var Cb = [];
function Eb(a, b2, c, d) {
  Array.isArray(c) || (c && (Cb[0] = c.toString()), (c = Cb));
  for (var e = 0; e < c.length; e++) {
    var f = Ya(b2, c[e], d || a.handleEvent, false, a.h || a);
    if (!f) break;
    a.g[f.key] = f;
  }
}
function Fb(a) {
  Na(
    a.g,
    function (b2, c) {
      this.g.hasOwnProperty(c) && gb(b2);
    },
    a
  );
  a.g = {};
}
Bb.prototype.N = function () {
  Bb.$.N.call(this);
  Fb(this);
};
Bb.prototype.handleEvent = function () {
  throw Error("EventHandler.handleEvent not implemented");
};
function Gb() {
  this.g = true;
}
Gb.prototype.Ea = function () {
  this.g = false;
};
function Hb(a, b2, c, d, e, f) {
  a.info(function () {
    if (a.g)
      if (f) {
        var h = "";
        for (var n = f.split("&"), t = 0; t < n.length; t++) {
          var m = n[t].split("=");
          if (1 < m.length) {
            var u = m[0];
            m = m[1];
            var L = u.split("_");
            h =
              2 <= L.length && "type" == L[1]
                ? h + (u + "=" + m + "&")
                : h + (u + "=redacted&");
          }
        }
      } else h = null;
    else h = f;
    return (
      "XMLHTTP REQ (" + d + ") [attempt " + e + "]: " + b2 + "\n" + c + "\n" + h
    );
  });
}
function Ib(a, b2, c, d, e, f, h) {
  a.info(function () {
    return (
      "XMLHTTP RESP (" +
      d +
      ") [ attempt " +
      e +
      "]: " +
      b2 +
      "\n" +
      c +
      "\n" +
      f +
      " " +
      h
    );
  });
}
function D$1(a, b2, c, d) {
  a.info(function () {
    return "XMLHTTP TEXT (" + b2 + "): " + Jb(a, c) + (d ? " " + d : "");
  });
}
function Kb(a, b2) {
  a.info(function () {
    return "TIMEOUT: " + b2;
  });
}
Gb.prototype.info = function () {};
function Jb(a, b2) {
  if (!a.g) return b2;
  if (!b2) return null;
  try {
    var c = JSON.parse(b2);
    if (c) {
      for (a = 0; a < c.length; a++)
        if (Array.isArray(c[a])) {
          var d = c[a];
          if (!(2 > d.length)) {
            var e = d[1];
            if (Array.isArray(e) && !(1 > e.length)) {
              var f = e[0];
              if ("noop" != f && "stop" != f && "close" != f)
                for (var h = 1; h < e.length; h++) e[h] = "";
            }
          }
        }
    }
    return jb(c);
  } catch (n) {
    return b2;
  }
}
var E = {},
  Lb = null;
function Mb() {
  return (Lb = Lb || new B());
}
E.Ta = "serverreachability";
function Nb(a) {
  w$1.call(this, E.Ta, a);
}
r(Nb, w$1);
function Ob(a) {
  const b2 = Mb();
  C$1(b2, new Nb(b2));
}
E.STAT_EVENT = "statevent";
function Pb(a, b2) {
  w$1.call(this, E.STAT_EVENT, a);
  this.stat = b2;
}
r(Pb, w$1);
function F$1(a) {
  const b2 = Mb();
  C$1(b2, new Pb(b2, a));
}
E.Ua = "timingevent";
function Qb(a, b2) {
  w$1.call(this, E.Ua, a);
  this.size = b2;
}
r(Qb, w$1);
function Rb(a, b2) {
  if ("function" !== typeof a)
    throw Error("Fn must not be null and must be a function");
  return l.setTimeout(function () {
    a();
  }, b2);
}
var Sb = {
  NO_ERROR: 0,
  rb: 1,
  Eb: 2,
  Db: 3,
  yb: 4,
  Cb: 5,
  Fb: 6,
  Qa: 7,
  TIMEOUT: 8,
  Ib: 9,
};
var Tb = {
  wb: "complete",
  Sb: "success",
  Ra: "error",
  Qa: "abort",
  Kb: "ready",
  Lb: "readystatechange",
  TIMEOUT: "timeout",
  Gb: "incrementaldata",
  Jb: "progress",
  zb: "downloadprogress",
  $b: "uploadprogress",
};
function Ub() {}
Ub.prototype.h = null;
function Vb(a) {
  return a.h || (a.h = a.i());
}
function Wb() {}
var Xb = { OPEN: "a", vb: "b", Ra: "c", Hb: "d" };
function Yb() {
  w$1.call(this, "d");
}
r(Yb, w$1);
function Zb() {
  w$1.call(this, "c");
}
r(Zb, w$1);
var $b;
function ac() {}
r(ac, Ub);
ac.prototype.g = function () {
  return new XMLHttpRequest();
};
ac.prototype.i = function () {
  return {};
};
$b = new ac();
function bc(a, b2, c, d) {
  this.l = a;
  this.j = b2;
  this.m = c;
  this.W = d || 1;
  this.U = new Bb(this);
  this.P = cc;
  a = va ? 125 : void 0;
  this.V = new wb(a);
  this.I = null;
  this.i = false;
  this.u = this.B = this.A = this.L = this.G = this.Y = this.C = null;
  this.F = [];
  this.g = null;
  this.o = 0;
  this.s = this.v = null;
  this.ca = -1;
  this.J = false;
  this.O = 0;
  this.M = null;
  this.ba = this.K = this.aa = this.S = false;
  this.h = new dc();
}
function dc() {
  this.i = null;
  this.g = "";
  this.h = false;
}
var cc = 45e3,
  ec = {},
  fc = {};
k = bc.prototype;
k.setTimeout = function (a) {
  this.P = a;
};
function gc(a, b2, c) {
  a.L = 1;
  a.A = hc(G(b2));
  a.u = c;
  a.S = true;
  ic(a, null);
}
function ic(a, b2) {
  a.G = Date.now();
  jc(a);
  a.B = G(a.A);
  var c = a.B,
    d = a.W;
  Array.isArray(d) || (d = [String(d)]);
  kc(c.i, "t", d);
  a.o = 0;
  c = a.l.J;
  a.h = new dc();
  a.g = lc(a.l, c ? b2 : null, !a.u);
  0 < a.O && (a.M = new Ab(q(a.Pa, a, a.g), a.O));
  Eb(a.U, a.g, "readystatechange", a.nb);
  b2 = a.I ? Pa(a.I) : {};
  a.u
    ? (a.v || (a.v = "POST"),
      (b2["Content-Type"] = "application/x-www-form-urlencoded"),
      a.g.ha(a.B, a.v, a.u, b2))
    : ((a.v = "GET"), a.g.ha(a.B, a.v, null, b2));
  Ob();
  Hb(a.j, a.v, a.B, a.m, a.W, a.u);
}
k.nb = function (a) {
  a = a.target;
  const b2 = this.M;
  b2 && 3 == H(a) ? b2.l() : this.Pa(a);
};
k.Pa = function (a) {
  try {
    if (a == this.g)
      a: {
        const u = H(this.g);
        var b2 = this.g.Ia();
        const L = this.g.da();
        if (
          !(3 > u) &&
          (3 != u || va || (this.g && (this.h.h || this.g.ja() || mc(this.g))))
        ) {
          this.J || 4 != u || 7 == b2 || (8 == b2 || 0 >= L ? Ob(3) : Ob(2));
          nc(this);
          var c = this.g.da();
          this.ca = c;
          b: if (oc(this)) {
            var d = mc(this.g);
            a = "";
            var e = d.length,
              f = 4 == H(this.g);
            if (!this.h.i) {
              if ("undefined" === typeof TextDecoder) {
                I(this);
                pc(this);
                var h = "";
                break b;
              }
              this.h.i = new l.TextDecoder();
            }
            for (b2 = 0; b2 < e; b2++)
              (this.h.h = true),
                (a += this.h.i.decode(d[b2], { stream: f && b2 == e - 1 }));
            d.length = 0;
            this.h.g += a;
            this.o = 0;
            h = this.h.g;
          } else h = this.g.ja();
          this.i = 200 == c;
          Ib(this.j, this.v, this.B, this.m, this.W, u, c);
          if (this.i) {
            if (this.aa && !this.K) {
              b: {
                if (this.g) {
                  var n,
                    t = this.g;
                  if (
                    (n = t.g
                      ? t.g.getResponseHeader("X-HTTP-Initial-Response")
                      : null) &&
                    !x(n)
                  ) {
                    var m = n;
                    break b;
                  }
                }
                m = null;
              }
              if ((c = m))
                D$1(
                  this.j,
                  this.m,
                  c,
                  "Initial handshake response via X-HTTP-Initial-Response"
                ),
                  (this.K = true),
                  qc(this, c);
              else {
                this.i = false;
                this.s = 3;
                F$1(12);
                I(this);
                pc(this);
                break a;
              }
            }
            this.S
              ? (rc(this, u, h),
                va &&
                  this.i &&
                  3 == u &&
                  (Eb(this.U, this.V, "tick", this.mb), this.V.start()))
              : (D$1(this.j, this.m, h, null), qc(this, h));
            4 == u && I(this);
            this.i &&
              !this.J &&
              (4 == u ? sc(this.l, this) : ((this.i = false), jc(this)));
          } else
            tc(this.g),
              400 == c && 0 < h.indexOf("Unknown SID")
                ? ((this.s = 3), F$1(12))
                : ((this.s = 0), F$1(13)),
              I(this),
              pc(this);
        }
      }
  } catch (u) {
  } finally {
  }
};
function oc(a) {
  return a.g ? "GET" == a.v && 2 != a.L && a.l.Ha : false;
}
function rc(a, b2, c) {
  let d = true,
    e;
  for (; !a.J && a.o < c.length; )
    if (((e = uc(a, c)), e == fc)) {
      4 == b2 && ((a.s = 4), F$1(14), (d = false));
      D$1(a.j, a.m, null, "[Incomplete Response]");
      break;
    } else if (e == ec) {
      a.s = 4;
      F$1(15);
      D$1(a.j, a.m, c, "[Invalid Chunk]");
      d = false;
      break;
    } else D$1(a.j, a.m, e, null), qc(a, e);
  oc(a) && 0 != a.o && ((a.h.g = a.h.g.slice(a.o)), (a.o = 0));
  4 != b2 || 0 != c.length || a.h.h || ((a.s = 1), F$1(16), (d = false));
  a.i = a.i && d;
  d
    ? 0 < c.length &&
      !a.ba &&
      ((a.ba = true),
      (b2 = a.l),
      b2.g == a &&
        b2.ca &&
        !b2.M &&
        (b2.l.info(
          "Great, no buffering proxy detected. Bytes received: " + c.length
        ),
        vc(b2),
        (b2.M = true),
        F$1(11)))
    : (D$1(a.j, a.m, c, "[Invalid Chunked Response]"), I(a), pc(a));
}
k.mb = function () {
  if (this.g) {
    var a = H(this.g),
      b2 = this.g.ja();
    this.o < b2.length &&
      (nc(this), rc(this, a, b2), this.i && 4 != a && jc(this));
  }
};
function uc(a, b2) {
  var c = a.o,
    d = b2.indexOf("\n", c);
  if (-1 == d) return fc;
  c = Number(b2.substring(c, d));
  if (isNaN(c)) return ec;
  d += 1;
  if (d + c > b2.length) return fc;
  b2 = b2.slice(d, d + c);
  a.o = d + c;
  return b2;
}
k.cancel = function () {
  this.J = true;
  I(this);
};
function jc(a) {
  a.Y = Date.now() + a.P;
  wc(a, a.P);
}
function wc(a, b2) {
  if (null != a.C) throw Error("WatchDog timer not null");
  a.C = Rb(q(a.lb, a), b2);
}
function nc(a) {
  a.C && (l.clearTimeout(a.C), (a.C = null));
}
k.lb = function () {
  this.C = null;
  const a = Date.now();
  0 <= a - this.Y
    ? (Kb(this.j, this.B),
      2 != this.L && (Ob(), F$1(17)),
      I(this),
      (this.s = 2),
      pc(this))
    : wc(this, this.Y - a);
};
function pc(a) {
  0 == a.l.H || a.J || sc(a.l, a);
}
function I(a) {
  nc(a);
  var b2 = a.M;
  b2 && "function" == typeof b2.sa && b2.sa();
  a.M = null;
  xb(a.V);
  Fb(a.U);
  a.g && ((b2 = a.g), (a.g = null), b2.abort(), b2.sa());
}
function qc(a, b2) {
  try {
    var c = a.l;
    if (0 != c.H && (c.g == a || xc(c.i, a))) {
      if (!a.K && xc(c.i, a) && 3 == c.H) {
        try {
          var d = c.Ja.g.parse(b2);
        } catch (m) {
          d = null;
        }
        if (Array.isArray(d) && 3 == d.length) {
          var e = d;
          if (0 == e[0])
            a: {
              if (!c.u) {
                if (c.g)
                  if (c.g.G + 3e3 < a.G) yc(c), zc(c);
                  else break a;
                Ac(c);
                F$1(18);
              }
            }
          else
            (c.Fa = e[1]),
              0 < c.Fa - c.V &&
                37500 > e[2] &&
                c.G &&
                0 == c.A &&
                !c.v &&
                (c.v = Rb(q(c.ib, c), 6e3));
          if (1 >= Bc(c.i) && c.oa) {
            try {
              c.oa();
            } catch (m) {}
            c.oa = void 0;
          }
        } else J(c, 11);
      } else if (((a.K || c.g == a) && yc(c), !x(b2)))
        for (e = c.Ja.g.parse(b2), b2 = 0; b2 < e.length; b2++) {
          let m = e[b2];
          c.V = m[0];
          m = m[1];
          if (2 == c.H)
            if ("c" == m[0]) {
              c.K = m[1];
              c.pa = m[2];
              const u = m[3];
              null != u && ((c.ra = u), c.l.info("VER=" + c.ra));
              const L = m[4];
              null != L && ((c.Ga = L), c.l.info("SVER=" + c.Ga));
              const Ka = m[5];
              null != Ka &&
                "number" === typeof Ka &&
                0 < Ka &&
                ((d = 1.5 * Ka),
                (c.L = d),
                c.l.info("backChannelRequestTimeoutMs_=" + d));
              d = c;
              const la = a.g;
              if (la) {
                const La = la.g
                  ? la.g.getResponseHeader("X-Client-Wire-Protocol")
                  : null;
                if (La) {
                  var f = d.i;
                  f.g ||
                    (-1 == La.indexOf("spdy") &&
                      -1 == La.indexOf("quic") &&
                      -1 == La.indexOf("h2")) ||
                    ((f.j = f.l),
                    (f.g = /* @__PURE__ */ new Set()),
                    f.h && (Cc(f, f.h), (f.h = null)));
                }
                if (d.F) {
                  const Db = la.g
                    ? la.g.getResponseHeader("X-HTTP-Session-Id")
                    : null;
                  Db && ((d.Da = Db), K(d.I, d.F, Db));
                }
              }
              c.H = 3;
              c.h && c.h.Ba();
              c.ca &&
                ((c.S = Date.now() - a.G),
                c.l.info("Handshake RTT: " + c.S + "ms"));
              d = c;
              var h = a;
              d.wa = Dc(d, d.J ? d.pa : null, d.Y);
              if (h.K) {
                Ec(d.i, h);
                var n = h,
                  t = d.L;
                t && n.setTimeout(t);
                n.C && (nc(n), jc(n));
                d.g = h;
              } else Fc(d);
              0 < c.j.length && Gc(c);
            } else ("stop" != m[0] && "close" != m[0]) || J(c, 7);
          else
            3 == c.H &&
              ("stop" == m[0] || "close" == m[0]
                ? "stop" == m[0]
                  ? J(c, 7)
                  : Hc(c)
                : "noop" != m[0] && c.h && c.h.Aa(m),
              (c.A = 0));
        }
    }
    Ob(4);
  } catch (m) {}
}
function Ic(a) {
  if (a.Z && "function" == typeof a.Z) return a.Z();
  if (
    ("undefined" !== typeof Map && a instanceof Map) ||
    ("undefined" !== typeof Set && a instanceof Set)
  )
    return Array.from(a.values());
  if ("string" === typeof a) return a.split("");
  if (aa(a)) {
    for (var b2 = [], c = a.length, d = 0; d < c; d++) b2.push(a[d]);
    return b2;
  }
  b2 = [];
  c = 0;
  for (d in a) b2[c++] = a[d];
  return b2;
}
function Jc(a) {
  if (a.ta && "function" == typeof a.ta) return a.ta();
  if (!a.Z || "function" != typeof a.Z) {
    if ("undefined" !== typeof Map && a instanceof Map)
      return Array.from(a.keys());
    if (!("undefined" !== typeof Set && a instanceof Set)) {
      if (aa(a) || "string" === typeof a) {
        var b2 = [];
        a = a.length;
        for (var c = 0; c < a; c++) b2.push(c);
        return b2;
      }
      b2 = [];
      c = 0;
      for (const d in a) b2[c++] = d;
      return b2;
    }
  }
}
function Kc(a, b2) {
  if (a.forEach && "function" == typeof a.forEach) a.forEach(b2, void 0);
  else if (aa(a) || "string" === typeof a)
    Array.prototype.forEach.call(a, b2, void 0);
  else
    for (var c = Jc(a), d = Ic(a), e = d.length, f = 0; f < e; f++)
      b2.call(void 0, d[f], c && c[f], a);
}
var Lc = RegExp(
  "^(?:([^:/?#.]+):)?(?://(?:([^\\\\/?#]*)@)?([^\\\\/?#]*?)(?::([0-9]+))?(?=[\\\\/?#]|$))?([^?#]+)?(?:\\?([^#]*))?(?:#([\\s\\S]*))?$"
);
function Mc(a, b2) {
  if (a) {
    a = a.split("&");
    for (var c = 0; c < a.length; c++) {
      var d = a[c].indexOf("="),
        e = null;
      if (0 <= d) {
        var f = a[c].substring(0, d);
        e = a[c].substring(d + 1);
      } else f = a[c];
      b2(f, e ? decodeURIComponent(e.replace(/\+/g, " ")) : "");
    }
  }
}
function M(a) {
  this.g = this.s = this.j = "";
  this.m = null;
  this.o = this.l = "";
  this.h = false;
  if (a instanceof M) {
    this.h = a.h;
    Nc(this, a.j);
    this.s = a.s;
    this.g = a.g;
    Oc(this, a.m);
    this.l = a.l;
    var b2 = a.i;
    var c = new Pc();
    c.i = b2.i;
    b2.g && ((c.g = new Map(b2.g)), (c.h = b2.h));
    Qc(this, c);
    this.o = a.o;
  } else
    a && (b2 = String(a).match(Lc))
      ? ((this.h = false),
        Nc(this, b2[1] || "", true),
        (this.s = Rc(b2[2] || "")),
        (this.g = Rc(b2[3] || "", true)),
        Oc(this, b2[4]),
        (this.l = Rc(b2[5] || "", true)),
        Qc(this, b2[6] || "", true),
        (this.o = Rc(b2[7] || "")))
      : ((this.h = false), (this.i = new Pc(null, this.h)));
}
M.prototype.toString = function () {
  var a = [],
    b2 = this.j;
  b2 && a.push(Sc(b2, Tc, true), ":");
  var c = this.g;
  if (c || "file" == b2)
    a.push("//"),
      (b2 = this.s) && a.push(Sc(b2, Tc, true), "@"),
      a.push(
        encodeURIComponent(String(c)).replace(/%25([0-9a-fA-F]{2})/g, "%$1")
      ),
      (c = this.m),
      null != c && a.push(":", String(c));
  if ((c = this.l))
    this.g && "/" != c.charAt(0) && a.push("/"),
      a.push(Sc(c, "/" == c.charAt(0) ? Uc : Vc, true));
  (c = this.i.toString()) && a.push("?", c);
  (c = this.o) && a.push("#", Sc(c, Wc));
  return a.join("");
};
function G(a) {
  return new M(a);
}
function Nc(a, b2, c) {
  a.j = c ? Rc(b2, true) : b2;
  a.j && (a.j = a.j.replace(/:$/, ""));
}
function Oc(a, b2) {
  if (b2) {
    b2 = Number(b2);
    if (isNaN(b2) || 0 > b2) throw Error("Bad port number " + b2);
    a.m = b2;
  } else a.m = null;
}
function Qc(a, b2, c) {
  b2 instanceof Pc
    ? ((a.i = b2), Xc(a.i, a.h))
    : (c || (b2 = Sc(b2, Yc)), (a.i = new Pc(b2, a.h)));
}
function K(a, b2, c) {
  a.i.set(b2, c);
}
function hc(a) {
  K(
    a,
    "zx",
    Math.floor(2147483648 * Math.random()).toString(36) +
      Math.abs(Math.floor(2147483648 * Math.random()) ^ Date.now()).toString(36)
  );
  return a;
}
function Rc(a, b2) {
  return a
    ? b2
      ? decodeURI(a.replace(/%25/g, "%2525"))
      : decodeURIComponent(a)
    : "";
}
function Sc(a, b2, c) {
  return "string" === typeof a
    ? ((a = encodeURI(a).replace(b2, Zc)),
      c && (a = a.replace(/%25([0-9a-fA-F]{2})/g, "%$1")),
      a)
    : null;
}
function Zc(a) {
  a = a.charCodeAt(0);
  return "%" + ((a >> 4) & 15).toString(16) + (a & 15).toString(16);
}
var Tc = /[#\/\?@]/g,
  Vc = /[#\?:]/g,
  Uc = /[#\?]/g,
  Yc = /[#\?@]/g,
  Wc = /#/g;
function Pc(a, b2) {
  this.h = this.g = null;
  this.i = a || null;
  this.j = !!b2;
}
function N(a) {
  a.g ||
    ((a.g = /* @__PURE__ */ new Map()),
    (a.h = 0),
    a.i &&
      Mc(a.i, function (b2, c) {
        a.add(decodeURIComponent(b2.replace(/\+/g, " ")), c);
      }));
}
k = Pc.prototype;
k.add = function (a, b2) {
  N(this);
  this.i = null;
  a = O(this, a);
  var c = this.g.get(a);
  c || this.g.set(a, (c = []));
  c.push(b2);
  this.h += 1;
  return this;
};
function $c(a, b2) {
  N(a);
  b2 = O(a, b2);
  a.g.has(b2) && ((a.i = null), (a.h -= a.g.get(b2).length), a.g.delete(b2));
}
function ad(a, b2) {
  N(a);
  b2 = O(a, b2);
  return a.g.has(b2);
}
k.forEach = function (a, b2) {
  N(this);
  this.g.forEach(function (c, d) {
    c.forEach(function (e) {
      a.call(b2, e, d, this);
    }, this);
  }, this);
};
k.ta = function () {
  N(this);
  const a = Array.from(this.g.values()),
    b2 = Array.from(this.g.keys()),
    c = [];
  for (let d = 0; d < b2.length; d++) {
    const e = a[d];
    for (let f = 0; f < e.length; f++) c.push(b2[d]);
  }
  return c;
};
k.Z = function (a) {
  N(this);
  let b2 = [];
  if ("string" === typeof a)
    ad(this, a) && (b2 = b2.concat(this.g.get(O(this, a))));
  else {
    a = Array.from(this.g.values());
    for (let c = 0; c < a.length; c++) b2 = b2.concat(a[c]);
  }
  return b2;
};
k.set = function (a, b2) {
  N(this);
  this.i = null;
  a = O(this, a);
  ad(this, a) && (this.h -= this.g.get(a).length);
  this.g.set(a, [b2]);
  this.h += 1;
  return this;
};
k.get = function (a, b2) {
  if (!a) return b2;
  a = this.Z(a);
  return 0 < a.length ? String(a[0]) : b2;
};
function kc(a, b2, c) {
  $c(a, b2);
  0 < c.length && ((a.i = null), a.g.set(O(a, b2), ma(c)), (a.h += c.length));
}
k.toString = function () {
  if (this.i) return this.i;
  if (!this.g) return "";
  const a = [],
    b2 = Array.from(this.g.keys());
  for (var c = 0; c < b2.length; c++) {
    var d = b2[c];
    const f = encodeURIComponent(String(d)),
      h = this.Z(d);
    for (d = 0; d < h.length; d++) {
      var e = f;
      "" !== h[d] && (e += "=" + encodeURIComponent(String(h[d])));
      a.push(e);
    }
  }
  return (this.i = a.join("&"));
};
function O(a, b2) {
  b2 = String(b2);
  a.j && (b2 = b2.toLowerCase());
  return b2;
}
function Xc(a, b2) {
  b2 &&
    !a.j &&
    (N(a),
    (a.i = null),
    a.g.forEach(function (c, d) {
      var e = d.toLowerCase();
      d != e && ($c(this, d), kc(this, e, c));
    }, a));
  a.j = b2;
}
var bd = class {
  constructor(a, b2) {
    this.g = a;
    this.map = b2;
  }
};
function cd(a) {
  this.l = a || dd;
  l.PerformanceNavigationTiming
    ? ((a = l.performance.getEntriesByType("navigation")),
      (a =
        0 < a.length &&
        ("hq" == a[0].nextHopProtocol || "h2" == a[0].nextHopProtocol)))
    : (a = !!(l.g && l.g.Ka && l.g.Ka() && l.g.Ka().dc));
  this.j = a ? this.l : 1;
  this.g = null;
  1 < this.j && (this.g = /* @__PURE__ */ new Set());
  this.h = null;
  this.i = [];
}
var dd = 10;
function ed(a) {
  return a.h ? true : a.g ? a.g.size >= a.j : false;
}
function Bc(a) {
  return a.h ? 1 : a.g ? a.g.size : 0;
}
function xc(a, b2) {
  return a.h ? a.h == b2 : a.g ? a.g.has(b2) : false;
}
function Cc(a, b2) {
  a.g ? a.g.add(b2) : (a.h = b2);
}
function Ec(a, b2) {
  a.h && a.h == b2 ? (a.h = null) : a.g && a.g.has(b2) && a.g.delete(b2);
}
cd.prototype.cancel = function () {
  this.i = fd(this);
  if (this.h) this.h.cancel(), (this.h = null);
  else if (this.g && 0 !== this.g.size) {
    for (const a of this.g.values()) a.cancel();
    this.g.clear();
  }
};
function fd(a) {
  if (null != a.h) return a.i.concat(a.h.F);
  if (null != a.g && 0 !== a.g.size) {
    let b2 = a.i;
    for (const c of a.g.values()) b2 = b2.concat(c.F);
    return b2;
  }
  return ma(a.i);
}
var gd = class {
  stringify(a) {
    return l.JSON.stringify(a, void 0);
  }
  parse(a) {
    return l.JSON.parse(a, void 0);
  }
};
function hd() {
  this.g = new gd();
}
function id(a, b2, c) {
  const d = c || "";
  try {
    Kc(a, function (e, f) {
      let h = e;
      p(e) && (h = jb(e));
      b2.push(d + f + "=" + encodeURIComponent(h));
    });
  } catch (e) {
    throw (b2.push(d + "type=" + encodeURIComponent("_badmap")), e);
  }
}
function jd(a, b2) {
  const c = new Gb();
  if (l.Image) {
    const d = new Image();
    d.onload = ha(kd, c, d, "TestLoadImage: loaded", true, b2);
    d.onerror = ha(kd, c, d, "TestLoadImage: error", false, b2);
    d.onabort = ha(kd, c, d, "TestLoadImage: abort", false, b2);
    d.ontimeout = ha(kd, c, d, "TestLoadImage: timeout", false, b2);
    l.setTimeout(function () {
      if (d.ontimeout) d.ontimeout();
    }, 1e4);
    d.src = a;
  } else b2(false);
}
function kd(a, b2, c, d, e) {
  try {
    (b2.onload = null),
      (b2.onerror = null),
      (b2.onabort = null),
      (b2.ontimeout = null),
      e(d);
  } catch (f) {}
}
function ld(a) {
  this.l = a.ec || null;
  this.j = a.ob || false;
}
r(ld, Ub);
ld.prototype.g = function () {
  return new md(this.l, this.j);
};
ld.prototype.i = (function (a) {
  return function () {
    return a;
  };
})({});
function md(a, b2) {
  B.call(this);
  this.F = a;
  this.u = b2;
  this.m = void 0;
  this.readyState = nd;
  this.status = 0;
  this.responseType = this.responseText = this.response = this.statusText = "";
  this.onreadystatechange = null;
  this.v = new Headers();
  this.h = null;
  this.C = "GET";
  this.B = "";
  this.g = false;
  this.A = this.j = this.l = null;
}
r(md, B);
var nd = 0;
k = md.prototype;
k.open = function (a, b2) {
  if (this.readyState != nd)
    throw (this.abort(), Error("Error reopening a connection"));
  this.C = a;
  this.B = b2;
  this.readyState = 1;
  od(this);
};
k.send = function (a) {
  if (1 != this.readyState)
    throw (this.abort(), Error("need to call open() first. "));
  this.g = true;
  const b2 = {
    headers: this.v,
    method: this.C,
    credentials: this.m,
    cache: void 0,
  };
  a && (b2.body = a);
  (this.F || l)
    .fetch(new Request(this.B, b2))
    .then(this.$a.bind(this), this.ka.bind(this));
};
k.abort = function () {
  this.response = this.responseText = "";
  this.v = new Headers();
  this.status = 0;
  this.j && this.j.cancel("Request was aborted.").catch(() => {});
  1 <= this.readyState &&
    this.g &&
    4 != this.readyState &&
    ((this.g = false), pd(this));
  this.readyState = nd;
};
k.$a = function (a) {
  if (
    this.g &&
    ((this.l = a),
    this.h ||
      ((this.status = this.l.status),
      (this.statusText = this.l.statusText),
      (this.h = a.headers),
      (this.readyState = 2),
      od(this)),
    this.g && ((this.readyState = 3), od(this), this.g))
  )
    if ("arraybuffer" === this.responseType)
      a.arrayBuffer().then(this.Ya.bind(this), this.ka.bind(this));
    else if ("undefined" !== typeof l.ReadableStream && "body" in a) {
      this.j = a.body.getReader();
      if (this.u) {
        if (this.responseType)
          throw Error(
            'responseType must be empty for "streamBinaryChunks" mode responses.'
          );
        this.response = [];
      } else
        (this.response = this.responseText = ""), (this.A = new TextDecoder());
      qd(this);
    } else a.text().then(this.Za.bind(this), this.ka.bind(this));
};
function qd(a) {
  a.j.read().then(a.Xa.bind(a)).catch(a.ka.bind(a));
}
k.Xa = function (a) {
  if (this.g) {
    if (this.u && a.value) this.response.push(a.value);
    else if (!this.u) {
      var b2 = a.value ? a.value : new Uint8Array(0);
      if ((b2 = this.A.decode(b2, { stream: !a.done })))
        this.response = this.responseText += b2;
    }
    a.done ? pd(this) : od(this);
    3 == this.readyState && qd(this);
  }
};
k.Za = function (a) {
  this.g && ((this.response = this.responseText = a), pd(this));
};
k.Ya = function (a) {
  this.g && ((this.response = a), pd(this));
};
k.ka = function () {
  this.g && pd(this);
};
function pd(a) {
  a.readyState = 4;
  a.l = null;
  a.j = null;
  a.A = null;
  od(a);
}
k.setRequestHeader = function (a, b2) {
  this.v.append(a, b2);
};
k.getResponseHeader = function (a) {
  return this.h ? this.h.get(a.toLowerCase()) || "" : "";
};
k.getAllResponseHeaders = function () {
  if (!this.h) return "";
  const a = [],
    b2 = this.h.entries();
  for (var c = b2.next(); !c.done; )
    (c = c.value), a.push(c[0] + ": " + c[1]), (c = b2.next());
  return a.join("\r\n");
};
function od(a) {
  a.onreadystatechange && a.onreadystatechange.call(a);
}
Object.defineProperty(md.prototype, "withCredentials", {
  get: function () {
    return "include" === this.m;
  },
  set: function (a) {
    this.m = a ? "include" : "same-origin";
  },
});
var rd = l.JSON.parse;
function P(a) {
  B.call(this);
  this.headers = /* @__PURE__ */ new Map();
  this.u = a || null;
  this.h = false;
  this.C = this.g = null;
  this.I = "";
  this.m = 0;
  this.j = "";
  this.l = this.G = this.v = this.F = false;
  this.B = 0;
  this.A = null;
  this.K = sd;
  this.L = this.M = false;
}
r(P, B);
var sd = "",
  td = /^https?$/i,
  ud = ["POST", "PUT"];
k = P.prototype;
k.Oa = function (a) {
  this.M = a;
};
k.ha = function (a, b2, c, d) {
  if (this.g)
    throw Error(
      "[goog.net.XhrIo] Object is active with another request=" +
        this.I +
        "; newUri=" +
        a
    );
  b2 = b2 ? b2.toUpperCase() : "GET";
  this.I = a;
  this.j = "";
  this.m = 0;
  this.F = false;
  this.h = true;
  this.g = this.u ? this.u.g() : $b.g();
  this.C = this.u ? Vb(this.u) : Vb($b);
  this.g.onreadystatechange = q(this.La, this);
  try {
    (this.G = true), this.g.open(b2, String(a), true), (this.G = false);
  } catch (f) {
    vd(this, f);
    return;
  }
  a = c || "";
  c = new Map(this.headers);
  if (d)
    if (Object.getPrototypeOf(d) === Object.prototype)
      for (var e in d) c.set(e, d[e]);
    else if ("function" === typeof d.keys && "function" === typeof d.get)
      for (const f of d.keys()) c.set(f, d.get(f));
    else throw Error("Unknown input type for opt_headers: " + String(d));
  d = Array.from(c.keys()).find((f) => "content-type" == f.toLowerCase());
  e = l.FormData && a instanceof l.FormData;
  !(0 <= ka(ud, b2)) ||
    d ||
    e ||
    c.set("Content-Type", "application/x-www-form-urlencoded;charset=utf-8");
  for (const [f, h] of c) this.g.setRequestHeader(f, h);
  this.K && (this.g.responseType = this.K);
  "withCredentials" in this.g &&
    this.g.withCredentials !== this.M &&
    (this.g.withCredentials = this.M);
  try {
    wd(this),
      0 < this.B &&
        ((this.L = xd(this.g))
          ? ((this.g.timeout = this.B), (this.g.ontimeout = q(this.ua, this)))
          : (this.A = yb(this.ua, this.B, this))),
      (this.v = true),
      this.g.send(a),
      (this.v = false);
  } catch (f) {
    vd(this, f);
  }
};
function xd(a) {
  return z && "number" === typeof a.timeout && void 0 !== a.ontimeout;
}
k.ua = function () {
  "undefined" != typeof goog &&
    this.g &&
    ((this.j = "Timed out after " + this.B + "ms, aborting"),
    (this.m = 8),
    C$1(this, "timeout"),
    this.abort(8));
};
function vd(a, b2) {
  a.h = false;
  a.g && ((a.l = true), a.g.abort(), (a.l = false));
  a.j = b2;
  a.m = 5;
  yd(a);
  zd(a);
}
function yd(a) {
  a.F || ((a.F = true), C$1(a, "complete"), C$1(a, "error"));
}
k.abort = function (a) {
  this.g &&
    this.h &&
    ((this.h = false),
    (this.l = true),
    this.g.abort(),
    (this.l = false),
    (this.m = a || 7),
    C$1(this, "complete"),
    C$1(this, "abort"),
    zd(this));
};
k.N = function () {
  this.g &&
    (this.h &&
      ((this.h = false), (this.l = true), this.g.abort(), (this.l = false)),
    zd(this, true));
  P.$.N.call(this);
};
k.La = function () {
  this.s || (this.G || this.v || this.l ? Ad(this) : this.kb());
};
k.kb = function () {
  Ad(this);
};
function Ad(a) {
  if (
    a.h &&
    "undefined" != typeof goog &&
    (!a.C[1] || 4 != H(a) || 2 != a.da())
  ) {
    if (a.v && 4 == H(a)) yb(a.La, 0, a);
    else if ((C$1(a, "readystatechange"), 4 == H(a))) {
      a.h = false;
      try {
        const h = a.da();
        a: switch (h) {
          case 200:
          case 201:
          case 202:
          case 204:
          case 206:
          case 304:
          case 1223:
            var b2 = true;
            break a;
          default:
            b2 = false;
        }
        var c;
        if (!(c = b2)) {
          var d;
          if ((d = 0 === h)) {
            var e = String(a.I).match(Lc)[1] || null;
            !e &&
              l.self &&
              l.self.location &&
              (e = l.self.location.protocol.slice(0, -1));
            d = !td.test(e ? e.toLowerCase() : "");
          }
          c = d;
        }
        if (c) C$1(a, "complete"), C$1(a, "success");
        else {
          a.m = 6;
          try {
            var f = 2 < H(a) ? a.g.statusText : "";
          } catch (n) {
            f = "";
          }
          a.j = f + " [" + a.da() + "]";
          yd(a);
        }
      } finally {
        zd(a);
      }
    }
  }
}
function zd(a, b2) {
  if (a.g) {
    wd(a);
    const c = a.g,
      d = a.C[0] ? () => {} : null;
    a.g = null;
    a.C = null;
    b2 || C$1(a, "ready");
    try {
      c.onreadystatechange = d;
    } catch (e) {}
  }
}
function wd(a) {
  a.g && a.L && (a.g.ontimeout = null);
  a.A && (l.clearTimeout(a.A), (a.A = null));
}
k.isActive = function () {
  return !!this.g;
};
function H(a) {
  return a.g ? a.g.readyState : 0;
}
k.da = function () {
  try {
    return 2 < H(this) ? this.g.status : -1;
  } catch (a) {
    return -1;
  }
};
k.ja = function () {
  try {
    return this.g ? this.g.responseText : "";
  } catch (a) {
    return "";
  }
};
k.Wa = function (a) {
  if (this.g) {
    var b2 = this.g.responseText;
    a && 0 == b2.indexOf(a) && (b2 = b2.substring(a.length));
    return rd(b2);
  }
};
function mc(a) {
  try {
    if (!a.g) return null;
    if ("response" in a.g) return a.g.response;
    switch (a.K) {
      case sd:
      case "text":
        return a.g.responseText;
      case "arraybuffer":
        if ("mozResponseArrayBuffer" in a.g) return a.g.mozResponseArrayBuffer;
    }
    return null;
  } catch (b2) {
    return null;
  }
}
function tc(a) {
  const b2 = {};
  a = (a.g && 2 <= H(a) ? a.g.getAllResponseHeaders() || "" : "").split("\r\n");
  for (let d = 0; d < a.length; d++) {
    if (x(a[d])) continue;
    var c = qb(a[d]);
    const e = c[0];
    c = c[1];
    if ("string" !== typeof c) continue;
    c = c.trim();
    const f = b2[e] || [];
    b2[e] = f;
    f.push(c);
  }
  Oa(b2, function (d) {
    return d.join(", ");
  });
}
k.Ia = function () {
  return this.m;
};
k.Sa = function () {
  return "string" === typeof this.j ? this.j : String(this.j);
};
function Bd(a) {
  let b2 = "";
  Na(a, function (c, d) {
    b2 += d;
    b2 += ":";
    b2 += c;
    b2 += "\r\n";
  });
  return b2;
}
function Cd(a, b2, c) {
  a: {
    for (d in c) {
      var d = false;
      break a;
    }
    d = true;
  }
  d ||
    ((c = Bd(c)),
    "string" === typeof a
      ? null != c && encodeURIComponent(String(c))
      : K(a, b2, c));
}
function Dd(a, b2, c) {
  return c && c.internalChannelParams ? c.internalChannelParams[a] || b2 : b2;
}
function Ed(a) {
  this.Ga = 0;
  this.j = [];
  this.l = new Gb();
  this.pa =
    this.wa =
    this.I =
    this.Y =
    this.g =
    this.Da =
    this.F =
    this.na =
    this.o =
    this.U =
    this.s =
      null;
  this.fb = this.W = 0;
  this.cb = Dd("failFast", false, a);
  this.G = this.v = this.u = this.m = this.h = null;
  this.aa = true;
  this.Fa = this.V = -1;
  this.ba = this.A = this.C = 0;
  this.ab = Dd("baseRetryDelayMs", 5e3, a);
  this.hb = Dd("retryDelaySeedMs", 1e4, a);
  this.eb = Dd("forwardChannelMaxRetries", 2, a);
  this.xa = Dd("forwardChannelRequestTimeoutMs", 2e4, a);
  this.va = (a && a.xmlHttpFactory) || void 0;
  this.Ha = (a && a.useFetchStreams) || false;
  this.L = void 0;
  this.J = (a && a.supportsCrossDomainXhr) || false;
  this.K = "";
  this.i = new cd(a && a.concurrentRequestLimit);
  this.Ja = new hd();
  this.P = (a && a.fastHandshake) || false;
  this.O = (a && a.encodeInitMessageHeaders) || false;
  this.P && this.O && (this.O = false);
  this.bb = (a && a.bc) || false;
  a && a.Ea && this.l.Ea();
  a && a.forceLongPolling && (this.aa = false);
  this.ca = (!this.P && this.aa && a && a.detectBufferingProxy) || false;
  this.qa = void 0;
  a &&
    a.longPollingTimeout &&
    0 < a.longPollingTimeout &&
    (this.qa = a.longPollingTimeout);
  this.oa = void 0;
  this.S = 0;
  this.M = false;
  this.ma = this.B = null;
}
k = Ed.prototype;
k.ra = 8;
k.H = 1;
function Hc(a) {
  Fd(a);
  if (3 == a.H) {
    var b2 = a.W++,
      c = G(a.I);
    K(c, "SID", a.K);
    K(c, "RID", b2);
    K(c, "TYPE", "terminate");
    Gd(a, c);
    b2 = new bc(a, a.l, b2);
    b2.L = 2;
    b2.A = hc(G(c));
    c = false;
    if (l.navigator && l.navigator.sendBeacon)
      try {
        c = l.navigator.sendBeacon(b2.A.toString(), "");
      } catch (d) {}
    !c && l.Image && ((new Image().src = b2.A), (c = true));
    c || ((b2.g = lc(b2.l, null)), b2.g.ha(b2.A));
    b2.G = Date.now();
    jc(b2);
  }
  Hd(a);
}
function zc(a) {
  a.g && (vc(a), a.g.cancel(), (a.g = null));
}
function Fd(a) {
  zc(a);
  a.u && (l.clearTimeout(a.u), (a.u = null));
  yc(a);
  a.i.cancel();
  a.m && ("number" === typeof a.m && l.clearTimeout(a.m), (a.m = null));
}
function Gc(a) {
  if (!ed(a.i) && !a.m) {
    a.m = true;
    var b2 = a.Na;
    sb || vb();
    tb || (sb(), (tb = true));
    mb.add(b2, a);
    a.C = 0;
  }
}
function Id(a, b2) {
  if (Bc(a.i) >= a.i.j - (a.m ? 1 : 0)) return false;
  if (a.m) return (a.j = b2.F.concat(a.j)), true;
  if (1 == a.H || 2 == a.H || a.C >= (a.cb ? 0 : a.eb)) return false;
  a.m = Rb(q(a.Na, a, b2), Jd(a, a.C));
  a.C++;
  return true;
}
k.Na = function (a) {
  if (this.m)
    if (((this.m = null), 1 == this.H)) {
      if (!a) {
        this.W = Math.floor(1e5 * Math.random());
        a = this.W++;
        const e = new bc(this, this.l, a);
        let f = this.s;
        this.U && (f ? ((f = Pa(f)), Ra(f, this.U)) : (f = this.U));
        null !== this.o || this.O || ((e.I = f), (f = null));
        if (this.P)
          a: {
            var b2 = 0;
            for (var c = 0; c < this.j.length; c++) {
              b: {
                var d = this.j[c];
                if (
                  "__data__" in d.map &&
                  ((d = d.map.__data__), "string" === typeof d)
                ) {
                  d = d.length;
                  break b;
                }
                d = void 0;
              }
              if (void 0 === d) break;
              b2 += d;
              if (4096 < b2) {
                b2 = c;
                break a;
              }
              if (4096 === b2 || c === this.j.length - 1) {
                b2 = c + 1;
                break a;
              }
            }
            b2 = 1e3;
          }
        else b2 = 1e3;
        b2 = Kd(this, e, b2);
        c = G(this.I);
        K(c, "RID", a);
        K(c, "CVER", 22);
        this.F && K(c, "X-HTTP-Session-Id", this.F);
        Gd(this, c);
        f &&
          (this.O
            ? (b2 = "headers=" + encodeURIComponent(String(Bd(f))) + "&" + b2)
            : this.o && Cd(c, this.o, f));
        Cc(this.i, e);
        this.bb && K(c, "TYPE", "init");
        this.P
          ? (K(c, "$req", b2),
            K(c, "SID", "null"),
            (e.aa = true),
            gc(e, c, null))
          : gc(e, c, b2);
        this.H = 2;
      }
    } else
      3 == this.H &&
        (a ? Ld(this, a) : 0 == this.j.length || ed(this.i) || Ld(this));
};
function Ld(a, b2) {
  var c;
  b2 ? (c = b2.m) : (c = a.W++);
  const d = G(a.I);
  K(d, "SID", a.K);
  K(d, "RID", c);
  K(d, "AID", a.V);
  Gd(a, d);
  a.o && a.s && Cd(d, a.o, a.s);
  c = new bc(a, a.l, c, a.C + 1);
  null === a.o && (c.I = a.s);
  b2 && (a.j = b2.F.concat(a.j));
  b2 = Kd(a, c, 1e3);
  c.setTimeout(Math.round(0.5 * a.xa) + Math.round(0.5 * a.xa * Math.random()));
  Cc(a.i, c);
  gc(c, d, b2);
}
function Gd(a, b2) {
  a.na &&
    Na(a.na, function (c, d) {
      K(b2, d, c);
    });
  a.h &&
    Kc({}, function (c, d) {
      K(b2, d, c);
    });
}
function Kd(a, b2, c) {
  c = Math.min(a.j.length, c);
  var d = a.h ? q(a.h.Va, a.h, a) : null;
  a: {
    var e = a.j;
    let f = -1;
    for (;;) {
      const h = ["count=" + c];
      -1 == f
        ? 0 < c
          ? ((f = e[0].g), h.push("ofs=" + f))
          : (f = 0)
        : h.push("ofs=" + f);
      let n = true;
      for (let t = 0; t < c; t++) {
        let m = e[t].g;
        const u = e[t].map;
        m -= f;
        if (0 > m) (f = Math.max(0, e[t].g - 100)), (n = false);
        else
          try {
            id(u, h, "req" + m + "_");
          } catch (L) {
            d && d(u);
          }
      }
      if (n) {
        d = h.join("&");
        break a;
      }
    }
  }
  a = a.j.splice(0, c);
  b2.F = a;
  return d;
}
function Fc(a) {
  if (!a.g && !a.u) {
    a.ba = 1;
    var b2 = a.Ma;
    sb || vb();
    tb || (sb(), (tb = true));
    mb.add(b2, a);
    a.A = 0;
  }
}
function Ac(a) {
  if (a.g || a.u || 3 <= a.A) return false;
  a.ba++;
  a.u = Rb(q(a.Ma, a), Jd(a, a.A));
  a.A++;
  return true;
}
k.Ma = function () {
  this.u = null;
  Md(this);
  if (this.ca && !(this.M || null == this.g || 0 >= this.S)) {
    var a = 2 * this.S;
    this.l.info("BP detection timer enabled: " + a);
    this.B = Rb(q(this.jb, this), a);
  }
};
k.jb = function () {
  this.B &&
    ((this.B = null),
    this.l.info("BP detection timeout reached."),
    this.l.info("Buffering proxy detected and switch to long-polling!"),
    (this.G = false),
    (this.M = true),
    F$1(10),
    zc(this),
    Md(this));
};
function vc(a) {
  null != a.B && (l.clearTimeout(a.B), (a.B = null));
}
function Md(a) {
  a.g = new bc(a, a.l, "rpc", a.ba);
  null === a.o && (a.g.I = a.s);
  a.g.O = 0;
  var b2 = G(a.wa);
  K(b2, "RID", "rpc");
  K(b2, "SID", a.K);
  K(b2, "AID", a.V);
  K(b2, "CI", a.G ? "0" : "1");
  !a.G && a.qa && K(b2, "TO", a.qa);
  K(b2, "TYPE", "xmlhttp");
  Gd(a, b2);
  a.o && a.s && Cd(b2, a.o, a.s);
  a.L && a.g.setTimeout(a.L);
  var c = a.g;
  a = a.pa;
  c.L = 1;
  c.A = hc(G(b2));
  c.u = null;
  c.S = true;
  ic(c, a);
}
k.ib = function () {
  null != this.v && ((this.v = null), zc(this), Ac(this), F$1(19));
};
function yc(a) {
  null != a.v && (l.clearTimeout(a.v), (a.v = null));
}
function sc(a, b2) {
  var c = null;
  if (a.g == b2) {
    yc(a);
    vc(a);
    a.g = null;
    var d = 2;
  } else if (xc(a.i, b2)) (c = b2.F), Ec(a.i, b2), (d = 1);
  else return;
  if (0 != a.H) {
    if (b2.i)
      if (1 == d) {
        c = b2.u ? b2.u.length : 0;
        b2 = Date.now() - b2.G;
        var e = a.C;
        d = Mb();
        C$1(d, new Qb(d, c));
        Gc(a);
      } else Fc(a);
    else if (
      ((e = b2.s),
      3 == e ||
        (0 == e && 0 < b2.ca) ||
        !((1 == d && Id(a, b2)) || (2 == d && Ac(a))))
    )
      switch ((c && 0 < c.length && ((b2 = a.i), (b2.i = b2.i.concat(c))), e)) {
        case 1:
          J(a, 5);
          break;
        case 4:
          J(a, 10);
          break;
        case 3:
          J(a, 6);
          break;
        default:
          J(a, 2);
      }
  }
}
function Jd(a, b2) {
  let c = a.ab + Math.floor(Math.random() * a.hb);
  a.isActive() || (c *= 2);
  return c * b2;
}
function J(a, b2) {
  a.l.info("Error code " + b2);
  if (2 == b2) {
    var c = null;
    a.h && (c = null);
    var d = q(a.pb, a);
    c ||
      ((c = new M("//www.google.com/images/cleardot.gif")),
      (l.location && "http" == l.location.protocol) || Nc(c, "https"),
      hc(c));
    jd(c.toString(), d);
  } else F$1(2);
  a.H = 0;
  a.h && a.h.za(b2);
  Hd(a);
  Fd(a);
}
k.pb = function (a) {
  a
    ? (this.l.info("Successfully pinged google.com"), F$1(2))
    : (this.l.info("Failed to ping google.com"), F$1(1));
};
function Hd(a) {
  a.H = 0;
  a.ma = [];
  if (a.h) {
    const b2 = fd(a.i);
    if (0 != b2.length || 0 != a.j.length)
      na(a.ma, b2),
        na(a.ma, a.j),
        (a.i.i.length = 0),
        ma(a.j),
        (a.j.length = 0);
    a.h.ya();
  }
}
function Dc(a, b2, c) {
  var d = c instanceof M ? G(c) : new M(c);
  if ("" != d.g) b2 && (d.g = b2 + "." + d.g), Oc(d, d.m);
  else {
    var e = l.location;
    d = e.protocol;
    b2 = b2 ? b2 + "." + e.hostname : e.hostname;
    e = +e.port;
    var f = new M(null);
    d && Nc(f, d);
    b2 && (f.g = b2);
    e && Oc(f, e);
    c && (f.l = c);
    d = f;
  }
  c = a.F;
  b2 = a.Da;
  c && b2 && K(d, c, b2);
  K(d, "VER", a.ra);
  Gd(a, d);
  return d;
}
function lc(a, b2, c) {
  if (b2 && !a.J)
    throw Error("Can't create secondary domain capable XhrIo object.");
  b2 = a.Ha && !a.va ? new P(new ld({ ob: c })) : new P(a.va);
  b2.Oa(a.J);
  return b2;
}
k.isActive = function () {
  return !!this.h && this.h.isActive(this);
};
function Nd() {}
k = Nd.prototype;
k.Ba = function () {};
k.Aa = function () {};
k.za = function () {};
k.ya = function () {};
k.isActive = function () {
  return true;
};
k.Va = function () {};
function Od() {
  if (z && !(10 <= Number(Fa)))
    throw Error("Environmental error: no available transport.");
}
Od.prototype.g = function (a, b2) {
  return new Q(a, b2);
};
function Q(a, b2) {
  B.call(this);
  this.g = new Ed(b2);
  this.l = a;
  this.h = (b2 && b2.messageUrlParams) || null;
  a = (b2 && b2.messageHeaders) || null;
  b2 &&
    b2.clientProtocolHeaderRequired &&
    (a
      ? (a["X-Client-Protocol"] = "webchannel")
      : (a = { "X-Client-Protocol": "webchannel" }));
  this.g.s = a;
  a = (b2 && b2.initMessageHeaders) || null;
  b2 &&
    b2.messageContentType &&
    (a
      ? (a["X-WebChannel-Content-Type"] = b2.messageContentType)
      : (a = { "X-WebChannel-Content-Type": b2.messageContentType }));
  b2 &&
    b2.Ca &&
    (a
      ? (a["X-WebChannel-Client-Profile"] = b2.Ca)
      : (a = { "X-WebChannel-Client-Profile": b2.Ca }));
  this.g.U = a;
  (a = b2 && b2.cc) && !x(a) && (this.g.o = a);
  this.A = (b2 && b2.supportsCrossDomainXhr) || false;
  this.v = (b2 && b2.sendRawJson) || false;
  (b2 = b2 && b2.httpSessionIdParam) &&
    !x(b2) &&
    ((this.g.F = b2),
    (a = this.h),
    null !== a && b2 in a && ((a = this.h), b2 in a && delete a[b2]));
  this.j = new R(this);
}
r(Q, B);
Q.prototype.m = function () {
  this.g.h = this.j;
  this.A && (this.g.J = true);
  var a = this.g,
    b2 = this.l,
    c = this.h || void 0;
  F$1(0);
  a.Y = b2;
  a.na = c || {};
  a.G = a.aa;
  a.I = Dc(a, null, a.Y);
  Gc(a);
};
Q.prototype.close = function () {
  Hc(this.g);
};
Q.prototype.u = function (a) {
  var b2 = this.g;
  if ("string" === typeof a) {
    var c = {};
    c.__data__ = a;
    a = c;
  } else this.v && ((c = {}), (c.__data__ = jb(a)), (a = c));
  b2.j.push(new bd(b2.fb++, a));
  3 == b2.H && Gc(b2);
};
Q.prototype.N = function () {
  this.g.h = null;
  delete this.j;
  Hc(this.g);
  delete this.g;
  Q.$.N.call(this);
};
function Pd(a) {
  Yb.call(this);
  a.__headers__ &&
    ((this.headers = a.__headers__),
    (this.statusCode = a.__status__),
    delete a.__headers__,
    delete a.__status__);
  var b2 = a.__sm__;
  if (b2) {
    a: {
      for (const c in b2) {
        a = c;
        break a;
      }
      a = void 0;
    }
    if ((this.i = a))
      (a = this.i), (b2 = null !== b2 && a in b2 ? b2[a] : void 0);
    this.data = b2;
  } else this.data = a;
}
r(Pd, Yb);
function Qd() {
  Zb.call(this);
  this.status = 1;
}
r(Qd, Zb);
function R(a) {
  this.g = a;
}
r(R, Nd);
R.prototype.Ba = function () {
  C$1(this.g, "a");
};
R.prototype.Aa = function (a) {
  C$1(this.g, new Pd(a));
};
R.prototype.za = function (a) {
  C$1(this.g, new Qd());
};
R.prototype.ya = function () {
  C$1(this.g, "b");
};
function Rd() {
  this.blockSize = -1;
}
function S$1() {
  this.blockSize = -1;
  this.blockSize = 64;
  this.g = Array(4);
  this.m = Array(this.blockSize);
  this.i = this.h = 0;
  this.reset();
}
r(S$1, Rd);
S$1.prototype.reset = function () {
  this.g[0] = 1732584193;
  this.g[1] = 4023233417;
  this.g[2] = 2562383102;
  this.g[3] = 271733878;
  this.i = this.h = 0;
};
function Sd(a, b2, c) {
  c || (c = 0);
  var d = Array(16);
  if ("string" === typeof b2)
    for (var e = 0; 16 > e; ++e)
      d[e] =
        b2.charCodeAt(c++) |
        (b2.charCodeAt(c++) << 8) |
        (b2.charCodeAt(c++) << 16) |
        (b2.charCodeAt(c++) << 24);
  else
    for (e = 0; 16 > e; ++e)
      d[e] = b2[c++] | (b2[c++] << 8) | (b2[c++] << 16) | (b2[c++] << 24);
  b2 = a.g[0];
  c = a.g[1];
  e = a.g[2];
  var f = a.g[3];
  var h = (b2 + (f ^ (c & (e ^ f))) + d[0] + 3614090360) & 4294967295;
  b2 = c + (((h << 7) & 4294967295) | (h >>> 25));
  h = (f + (e ^ (b2 & (c ^ e))) + d[1] + 3905402710) & 4294967295;
  f = b2 + (((h << 12) & 4294967295) | (h >>> 20));
  h = (e + (c ^ (f & (b2 ^ c))) + d[2] + 606105819) & 4294967295;
  e = f + (((h << 17) & 4294967295) | (h >>> 15));
  h = (c + (b2 ^ (e & (f ^ b2))) + d[3] + 3250441966) & 4294967295;
  c = e + (((h << 22) & 4294967295) | (h >>> 10));
  h = (b2 + (f ^ (c & (e ^ f))) + d[4] + 4118548399) & 4294967295;
  b2 = c + (((h << 7) & 4294967295) | (h >>> 25));
  h = (f + (e ^ (b2 & (c ^ e))) + d[5] + 1200080426) & 4294967295;
  f = b2 + (((h << 12) & 4294967295) | (h >>> 20));
  h = (e + (c ^ (f & (b2 ^ c))) + d[6] + 2821735955) & 4294967295;
  e = f + (((h << 17) & 4294967295) | (h >>> 15));
  h = (c + (b2 ^ (e & (f ^ b2))) + d[7] + 4249261313) & 4294967295;
  c = e + (((h << 22) & 4294967295) | (h >>> 10));
  h = (b2 + (f ^ (c & (e ^ f))) + d[8] + 1770035416) & 4294967295;
  b2 = c + (((h << 7) & 4294967295) | (h >>> 25));
  h = (f + (e ^ (b2 & (c ^ e))) + d[9] + 2336552879) & 4294967295;
  f = b2 + (((h << 12) & 4294967295) | (h >>> 20));
  h = (e + (c ^ (f & (b2 ^ c))) + d[10] + 4294925233) & 4294967295;
  e = f + (((h << 17) & 4294967295) | (h >>> 15));
  h = (c + (b2 ^ (e & (f ^ b2))) + d[11] + 2304563134) & 4294967295;
  c = e + (((h << 22) & 4294967295) | (h >>> 10));
  h = (b2 + (f ^ (c & (e ^ f))) + d[12] + 1804603682) & 4294967295;
  b2 = c + (((h << 7) & 4294967295) | (h >>> 25));
  h = (f + (e ^ (b2 & (c ^ e))) + d[13] + 4254626195) & 4294967295;
  f = b2 + (((h << 12) & 4294967295) | (h >>> 20));
  h = (e + (c ^ (f & (b2 ^ c))) + d[14] + 2792965006) & 4294967295;
  e = f + (((h << 17) & 4294967295) | (h >>> 15));
  h = (c + (b2 ^ (e & (f ^ b2))) + d[15] + 1236535329) & 4294967295;
  c = e + (((h << 22) & 4294967295) | (h >>> 10));
  h = (b2 + (e ^ (f & (c ^ e))) + d[1] + 4129170786) & 4294967295;
  b2 = c + (((h << 5) & 4294967295) | (h >>> 27));
  h = (f + (c ^ (e & (b2 ^ c))) + d[6] + 3225465664) & 4294967295;
  f = b2 + (((h << 9) & 4294967295) | (h >>> 23));
  h = (e + (b2 ^ (c & (f ^ b2))) + d[11] + 643717713) & 4294967295;
  e = f + (((h << 14) & 4294967295) | (h >>> 18));
  h = (c + (f ^ (b2 & (e ^ f))) + d[0] + 3921069994) & 4294967295;
  c = e + (((h << 20) & 4294967295) | (h >>> 12));
  h = (b2 + (e ^ (f & (c ^ e))) + d[5] + 3593408605) & 4294967295;
  b2 = c + (((h << 5) & 4294967295) | (h >>> 27));
  h = (f + (c ^ (e & (b2 ^ c))) + d[10] + 38016083) & 4294967295;
  f = b2 + (((h << 9) & 4294967295) | (h >>> 23));
  h = (e + (b2 ^ (c & (f ^ b2))) + d[15] + 3634488961) & 4294967295;
  e = f + (((h << 14) & 4294967295) | (h >>> 18));
  h = (c + (f ^ (b2 & (e ^ f))) + d[4] + 3889429448) & 4294967295;
  c = e + (((h << 20) & 4294967295) | (h >>> 12));
  h = (b2 + (e ^ (f & (c ^ e))) + d[9] + 568446438) & 4294967295;
  b2 = c + (((h << 5) & 4294967295) | (h >>> 27));
  h = (f + (c ^ (e & (b2 ^ c))) + d[14] + 3275163606) & 4294967295;
  f = b2 + (((h << 9) & 4294967295) | (h >>> 23));
  h = (e + (b2 ^ (c & (f ^ b2))) + d[3] + 4107603335) & 4294967295;
  e = f + (((h << 14) & 4294967295) | (h >>> 18));
  h = (c + (f ^ (b2 & (e ^ f))) + d[8] + 1163531501) & 4294967295;
  c = e + (((h << 20) & 4294967295) | (h >>> 12));
  h = (b2 + (e ^ (f & (c ^ e))) + d[13] + 2850285829) & 4294967295;
  b2 = c + (((h << 5) & 4294967295) | (h >>> 27));
  h = (f + (c ^ (e & (b2 ^ c))) + d[2] + 4243563512) & 4294967295;
  f = b2 + (((h << 9) & 4294967295) | (h >>> 23));
  h = (e + (b2 ^ (c & (f ^ b2))) + d[7] + 1735328473) & 4294967295;
  e = f + (((h << 14) & 4294967295) | (h >>> 18));
  h = (c + (f ^ (b2 & (e ^ f))) + d[12] + 2368359562) & 4294967295;
  c = e + (((h << 20) & 4294967295) | (h >>> 12));
  h = (b2 + (c ^ e ^ f) + d[5] + 4294588738) & 4294967295;
  b2 = c + (((h << 4) & 4294967295) | (h >>> 28));
  h = (f + (b2 ^ c ^ e) + d[8] + 2272392833) & 4294967295;
  f = b2 + (((h << 11) & 4294967295) | (h >>> 21));
  h = (e + (f ^ b2 ^ c) + d[11] + 1839030562) & 4294967295;
  e = f + (((h << 16) & 4294967295) | (h >>> 16));
  h = (c + (e ^ f ^ b2) + d[14] + 4259657740) & 4294967295;
  c = e + (((h << 23) & 4294967295) | (h >>> 9));
  h = (b2 + (c ^ e ^ f) + d[1] + 2763975236) & 4294967295;
  b2 = c + (((h << 4) & 4294967295) | (h >>> 28));
  h = (f + (b2 ^ c ^ e) + d[4] + 1272893353) & 4294967295;
  f = b2 + (((h << 11) & 4294967295) | (h >>> 21));
  h = (e + (f ^ b2 ^ c) + d[7] + 4139469664) & 4294967295;
  e = f + (((h << 16) & 4294967295) | (h >>> 16));
  h = (c + (e ^ f ^ b2) + d[10] + 3200236656) & 4294967295;
  c = e + (((h << 23) & 4294967295) | (h >>> 9));
  h = (b2 + (c ^ e ^ f) + d[13] + 681279174) & 4294967295;
  b2 = c + (((h << 4) & 4294967295) | (h >>> 28));
  h = (f + (b2 ^ c ^ e) + d[0] + 3936430074) & 4294967295;
  f = b2 + (((h << 11) & 4294967295) | (h >>> 21));
  h = (e + (f ^ b2 ^ c) + d[3] + 3572445317) & 4294967295;
  e = f + (((h << 16) & 4294967295) | (h >>> 16));
  h = (c + (e ^ f ^ b2) + d[6] + 76029189) & 4294967295;
  c = e + (((h << 23) & 4294967295) | (h >>> 9));
  h = (b2 + (c ^ e ^ f) + d[9] + 3654602809) & 4294967295;
  b2 = c + (((h << 4) & 4294967295) | (h >>> 28));
  h = (f + (b2 ^ c ^ e) + d[12] + 3873151461) & 4294967295;
  f = b2 + (((h << 11) & 4294967295) | (h >>> 21));
  h = (e + (f ^ b2 ^ c) + d[15] + 530742520) & 4294967295;
  e = f + (((h << 16) & 4294967295) | (h >>> 16));
  h = (c + (e ^ f ^ b2) + d[2] + 3299628645) & 4294967295;
  c = e + (((h << 23) & 4294967295) | (h >>> 9));
  h = (b2 + (e ^ (c | ~f)) + d[0] + 4096336452) & 4294967295;
  b2 = c + (((h << 6) & 4294967295) | (h >>> 26));
  h = (f + (c ^ (b2 | ~e)) + d[7] + 1126891415) & 4294967295;
  f = b2 + (((h << 10) & 4294967295) | (h >>> 22));
  h = (e + (b2 ^ (f | ~c)) + d[14] + 2878612391) & 4294967295;
  e = f + (((h << 15) & 4294967295) | (h >>> 17));
  h = (c + (f ^ (e | ~b2)) + d[5] + 4237533241) & 4294967295;
  c = e + (((h << 21) & 4294967295) | (h >>> 11));
  h = (b2 + (e ^ (c | ~f)) + d[12] + 1700485571) & 4294967295;
  b2 = c + (((h << 6) & 4294967295) | (h >>> 26));
  h = (f + (c ^ (b2 | ~e)) + d[3] + 2399980690) & 4294967295;
  f = b2 + (((h << 10) & 4294967295) | (h >>> 22));
  h = (e + (b2 ^ (f | ~c)) + d[10] + 4293915773) & 4294967295;
  e = f + (((h << 15) & 4294967295) | (h >>> 17));
  h = (c + (f ^ (e | ~b2)) + d[1] + 2240044497) & 4294967295;
  c = e + (((h << 21) & 4294967295) | (h >>> 11));
  h = (b2 + (e ^ (c | ~f)) + d[8] + 1873313359) & 4294967295;
  b2 = c + (((h << 6) & 4294967295) | (h >>> 26));
  h = (f + (c ^ (b2 | ~e)) + d[15] + 4264355552) & 4294967295;
  f = b2 + (((h << 10) & 4294967295) | (h >>> 22));
  h = (e + (b2 ^ (f | ~c)) + d[6] + 2734768916) & 4294967295;
  e = f + (((h << 15) & 4294967295) | (h >>> 17));
  h = (c + (f ^ (e | ~b2)) + d[13] + 1309151649) & 4294967295;
  c = e + (((h << 21) & 4294967295) | (h >>> 11));
  h = (b2 + (e ^ (c | ~f)) + d[4] + 4149444226) & 4294967295;
  b2 = c + (((h << 6) & 4294967295) | (h >>> 26));
  h = (f + (c ^ (b2 | ~e)) + d[11] + 3174756917) & 4294967295;
  f = b2 + (((h << 10) & 4294967295) | (h >>> 22));
  h = (e + (b2 ^ (f | ~c)) + d[2] + 718787259) & 4294967295;
  e = f + (((h << 15) & 4294967295) | (h >>> 17));
  h = (c + (f ^ (e | ~b2)) + d[9] + 3951481745) & 4294967295;
  a.g[0] = (a.g[0] + b2) & 4294967295;
  a.g[1] =
    (a.g[1] + (e + (((h << 21) & 4294967295) | (h >>> 11)))) & 4294967295;
  a.g[2] = (a.g[2] + e) & 4294967295;
  a.g[3] = (a.g[3] + f) & 4294967295;
}
S$1.prototype.j = function (a, b2) {
  void 0 === b2 && (b2 = a.length);
  for (var c = b2 - this.blockSize, d = this.m, e = this.h, f = 0; f < b2; ) {
    if (0 == e) for (; f <= c; ) Sd(this, a, f), (f += this.blockSize);
    if ("string" === typeof a)
      for (; f < b2; ) {
        if (((d[e++] = a.charCodeAt(f++)), e == this.blockSize)) {
          Sd(this, d);
          e = 0;
          break;
        }
      }
    else
      for (; f < b2; )
        if (((d[e++] = a[f++]), e == this.blockSize)) {
          Sd(this, d);
          e = 0;
          break;
        }
  }
  this.h = e;
  this.i += b2;
};
S$1.prototype.l = function () {
  var a = Array((56 > this.h ? this.blockSize : 2 * this.blockSize) - this.h);
  a[0] = 128;
  for (var b2 = 1; b2 < a.length - 8; ++b2) a[b2] = 0;
  var c = 8 * this.i;
  for (b2 = a.length - 8; b2 < a.length; ++b2) (a[b2] = c & 255), (c /= 256);
  this.j(a);
  a = Array(16);
  for (b2 = c = 0; 4 > b2; ++b2)
    for (var d = 0; 32 > d; d += 8) a[c++] = (this.g[b2] >>> d) & 255;
  return a;
};
function T(a, b2) {
  this.h = b2;
  for (var c = [], d = true, e = a.length - 1; 0 <= e; e--) {
    var f = a[e] | 0;
    (d && f == b2) || ((c[e] = f), (d = false));
  }
  this.g = c;
}
var sa = {};
function Td(a) {
  return -128 <= a && 128 > a
    ? ra(a, function (b2) {
        return new T([b2 | 0], 0 > b2 ? -1 : 0);
      })
    : new T([a | 0], 0 > a ? -1 : 0);
}
function U(a) {
  if (isNaN(a) || !isFinite(a)) return V;
  if (0 > a) return W(U(-a));
  for (var b2 = [], c = 1, d = 0; a >= c; d++) (b2[d] = (a / c) | 0), (c *= Ud);
  return new T(b2, 0);
}
function Vd(a, b2) {
  if (0 == a.length) throw Error("number format error: empty string");
  b2 = b2 || 10;
  if (2 > b2 || 36 < b2) throw Error("radix out of range: " + b2);
  if ("-" == a.charAt(0)) return W(Vd(a.substring(1), b2));
  if (0 <= a.indexOf("-"))
    throw Error('number format error: interior "-" character');
  for (var c = U(Math.pow(b2, 8)), d = V, e = 0; e < a.length; e += 8) {
    var f = Math.min(8, a.length - e),
      h = parseInt(a.substring(e, e + f), b2);
    8 > f
      ? ((f = U(Math.pow(b2, f))), (d = d.R(f).add(U(h))))
      : ((d = d.R(c)), (d = d.add(U(h))));
  }
  return d;
}
var Ud = 4294967296,
  V = Td(0),
  Wd = Td(1),
  Xd = Td(16777216);
k = T.prototype;
k.ea = function () {
  if (X(this)) return -W(this).ea();
  for (var a = 0, b2 = 1, c = 0; c < this.g.length; c++) {
    var d = this.D(c);
    a += (0 <= d ? d : Ud + d) * b2;
    b2 *= Ud;
  }
  return a;
};
k.toString = function (a) {
  a = a || 10;
  if (2 > a || 36 < a) throw Error("radix out of range: " + a);
  if (Y(this)) return "0";
  if (X(this)) return "-" + W(this).toString(a);
  for (var b2 = U(Math.pow(a, 6)), c = this, d = ""; ; ) {
    var e = Yd(c, b2).g;
    c = Zd(c, e.R(b2));
    var f = ((0 < c.g.length ? c.g[0] : c.h) >>> 0).toString(a);
    c = e;
    if (Y(c)) return f + d;
    for (; 6 > f.length; ) f = "0" + f;
    d = f + d;
  }
};
k.D = function (a) {
  return 0 > a ? 0 : a < this.g.length ? this.g[a] : this.h;
};
function Y(a) {
  if (0 != a.h) return false;
  for (var b2 = 0; b2 < a.g.length; b2++) if (0 != a.g[b2]) return false;
  return true;
}
function X(a) {
  return -1 == a.h;
}
k.X = function (a) {
  a = Zd(this, a);
  return X(a) ? -1 : Y(a) ? 0 : 1;
};
function W(a) {
  for (var b2 = a.g.length, c = [], d = 0; d < b2; d++) c[d] = ~a.g[d];
  return new T(c, ~a.h).add(Wd);
}
k.abs = function () {
  return X(this) ? W(this) : this;
};
k.add = function (a) {
  for (
    var b2 = Math.max(this.g.length, a.g.length), c = [], d = 0, e = 0;
    e <= b2;
    e++
  ) {
    var f = d + (this.D(e) & 65535) + (a.D(e) & 65535),
      h = (f >>> 16) + (this.D(e) >>> 16) + (a.D(e) >>> 16);
    d = h >>> 16;
    f &= 65535;
    h &= 65535;
    c[e] = (h << 16) | f;
  }
  return new T(c, c[c.length - 1] & -2147483648 ? -1 : 0);
};
function Zd(a, b2) {
  return a.add(W(b2));
}
k.R = function (a) {
  if (Y(this) || Y(a)) return V;
  if (X(this)) return X(a) ? W(this).R(W(a)) : W(W(this).R(a));
  if (X(a)) return W(this.R(W(a)));
  if (0 > this.X(Xd) && 0 > a.X(Xd)) return U(this.ea() * a.ea());
  for (var b2 = this.g.length + a.g.length, c = [], d = 0; d < 2 * b2; d++)
    c[d] = 0;
  for (d = 0; d < this.g.length; d++)
    for (var e = 0; e < a.g.length; e++) {
      var f = this.D(d) >>> 16,
        h = this.D(d) & 65535,
        n = a.D(e) >>> 16,
        t = a.D(e) & 65535;
      c[2 * d + 2 * e] += h * t;
      $d(c, 2 * d + 2 * e);
      c[2 * d + 2 * e + 1] += f * t;
      $d(c, 2 * d + 2 * e + 1);
      c[2 * d + 2 * e + 1] += h * n;
      $d(c, 2 * d + 2 * e + 1);
      c[2 * d + 2 * e + 2] += f * n;
      $d(c, 2 * d + 2 * e + 2);
    }
  for (d = 0; d < b2; d++) c[d] = (c[2 * d + 1] << 16) | c[2 * d];
  for (d = b2; d < 2 * b2; d++) c[d] = 0;
  return new T(c, 0);
};
function $d(a, b2) {
  for (; (a[b2] & 65535) != a[b2]; )
    (a[b2 + 1] += a[b2] >>> 16), (a[b2] &= 65535), b2++;
}
function ae$1(a, b2) {
  this.g = a;
  this.h = b2;
}
function Yd(a, b2) {
  if (Y(b2)) throw Error("division by zero");
  if (Y(a)) return new ae$1(V, V);
  if (X(a)) return (b2 = Yd(W(a), b2)), new ae$1(W(b2.g), W(b2.h));
  if (X(b2)) return (b2 = Yd(a, W(b2))), new ae$1(W(b2.g), b2.h);
  if (30 < a.g.length) {
    if (X(a) || X(b2))
      throw Error("slowDivide_ only works with positive integers.");
    for (var c = Wd, d = b2; 0 >= d.X(a); ) (c = be(c)), (d = be(d));
    var e = Z(c, 1),
      f = Z(d, 1);
    d = Z(d, 2);
    for (c = Z(c, 2); !Y(d); ) {
      var h = f.add(d);
      0 >= h.X(a) && ((e = e.add(c)), (f = h));
      d = Z(d, 1);
      c = Z(c, 1);
    }
    b2 = Zd(a, e.R(b2));
    return new ae$1(e, b2);
  }
  for (e = V; 0 <= a.X(b2); ) {
    c = Math.max(1, Math.floor(a.ea() / b2.ea()));
    d = Math.ceil(Math.log(c) / Math.LN2);
    d = 48 >= d ? 1 : Math.pow(2, d - 48);
    f = U(c);
    for (h = f.R(b2); X(h) || 0 < h.X(a); ) (c -= d), (f = U(c)), (h = f.R(b2));
    Y(f) && (f = Wd);
    e = e.add(f);
    a = Zd(a, h);
  }
  return new ae$1(e, a);
}
k.gb = function (a) {
  return Yd(this, a).h;
};
k.and = function (a) {
  for (var b2 = Math.max(this.g.length, a.g.length), c = [], d = 0; d < b2; d++)
    c[d] = this.D(d) & a.D(d);
  return new T(c, this.h & a.h);
};
k.or = function (a) {
  for (var b2 = Math.max(this.g.length, a.g.length), c = [], d = 0; d < b2; d++)
    c[d] = this.D(d) | a.D(d);
  return new T(c, this.h | a.h);
};
k.xor = function (a) {
  for (var b2 = Math.max(this.g.length, a.g.length), c = [], d = 0; d < b2; d++)
    c[d] = this.D(d) ^ a.D(d);
  return new T(c, this.h ^ a.h);
};
function be(a) {
  for (var b2 = a.g.length + 1, c = [], d = 0; d < b2; d++)
    c[d] = (a.D(d) << 1) | (a.D(d - 1) >>> 31);
  return new T(c, a.h);
}
function Z(a, b2) {
  var c = b2 >> 5;
  b2 %= 32;
  for (var d = a.g.length - c, e = [], f = 0; f < d; f++)
    e[f] =
      0 < b2 ? (a.D(f + c) >>> b2) | (a.D(f + c + 1) << (32 - b2)) : a.D(f + c);
  return new T(e, a.h);
}
Od.prototype.createWebChannel = Od.prototype.g;
Q.prototype.send = Q.prototype.u;
Q.prototype.open = Q.prototype.m;
Q.prototype.close = Q.prototype.close;
Sb.NO_ERROR = 0;
Sb.TIMEOUT = 8;
Sb.HTTP_ERROR = 6;
Tb.COMPLETE = "complete";
Wb.EventType = Xb;
Xb.OPEN = "a";
Xb.CLOSE = "b";
Xb.ERROR = "c";
Xb.MESSAGE = "d";
B.prototype.listen = B.prototype.O;
P.prototype.listenOnce = P.prototype.P;
P.prototype.getLastError = P.prototype.Sa;
P.prototype.getLastErrorCode = P.prototype.Ia;
P.prototype.getStatus = P.prototype.da;
P.prototype.getResponseJson = P.prototype.Wa;
P.prototype.getResponseText = P.prototype.ja;
P.prototype.send = P.prototype.ha;
P.prototype.setWithCredentials = P.prototype.Oa;
S$1.prototype.digest = S$1.prototype.l;
S$1.prototype.reset = S$1.prototype.reset;
S$1.prototype.update = S$1.prototype.j;
T.prototype.add = T.prototype.add;
T.prototype.multiply = T.prototype.R;
T.prototype.modulo = T.prototype.gb;
T.prototype.compare = T.prototype.X;
T.prototype.toNumber = T.prototype.ea;
T.prototype.toString = T.prototype.toString;
T.prototype.getBits = T.prototype.D;
T.fromNumber = U;
T.fromString = Vd;
var createWebChannelTransport = function () {
  return new Od();
};
var getStatEventTarget = function () {
  return Mb();
};
var ErrorCode$1 = Sb;
var EventType = Tb;
var Event$1 = E;
var Stat = {
  xb: 0,
  Ab: 1,
  Bb: 2,
  Ub: 3,
  Zb: 4,
  Wb: 5,
  Xb: 6,
  Vb: 7,
  Tb: 8,
  Yb: 9,
  PROXY: 10,
  NOPROXY: 11,
  Rb: 12,
  Nb: 13,
  Ob: 14,
  Mb: 15,
  Pb: 16,
  Qb: 17,
  tb: 18,
  sb: 19,
  ub: 20,
};
var WebChannel = Wb;
var XhrIo = P;
var Md5 = S$1;
var Integer = T;
const w = "@firebase/firestore";
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class User {
  constructor(e) {
    this.uid = e;
  }
  isAuthenticated() {
    return null != this.uid;
  }
  /**
   * Returns a key representing this user, suitable for inclusion in a
   * dictionary.
   */
  toKey() {
    return this.isAuthenticated() ? "uid:" + this.uid : "anonymous-user";
  }
  isEqual(e) {
    return e.uid === this.uid;
  }
}
(User.UNAUTHENTICATED = new User(null)), // TODO(mikelehen): Look into getting a proper uid-equivalent for
  // non-FirebaseAuth providers.
  (User.GOOGLE_CREDENTIALS = new User("google-credentials-uid")),
  (User.FIRST_PARTY = new User("first-party-uid")),
  (User.MOCK_USER = new User("mock-user"));
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
let S = "10.11.0";
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const b = new Logger("@firebase/firestore");
function __PRIVATE_getLogLevel() {
  return b.logLevel;
}
function __PRIVATE_logDebug(e, ...t) {
  if (b.logLevel <= LogLevel.DEBUG) {
    const n = t.map(__PRIVATE_argToString);
    b.debug(`Firestore (${S}): ${e}`, ...n);
  }
}
function __PRIVATE_logError(e, ...t) {
  if (b.logLevel <= LogLevel.ERROR) {
    const n = t.map(__PRIVATE_argToString);
    b.error(`Firestore (${S}): ${e}`, ...n);
  }
}
function __PRIVATE_logWarn(e, ...t) {
  if (b.logLevel <= LogLevel.WARN) {
    const n = t.map(__PRIVATE_argToString);
    b.warn(`Firestore (${S}): ${e}`, ...n);
  }
}
function __PRIVATE_argToString(e) {
  if ("string" == typeof e) return e;
  try {
    /**
     * @license
     * Copyright 2020 Google LLC
     *
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     *   http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     */
    return (function __PRIVATE_formatJSON(e2) {
      return JSON.stringify(e2);
    })(e);
  } catch (t) {
    return e;
  }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function fail(e = "Unexpected state") {
  const t = `FIRESTORE (${S}) INTERNAL ASSERTION FAILED: ` + e;
  throw (__PRIVATE_logError(t), new Error(t));
}
function __PRIVATE_hardAssert(e, t) {
  e || fail();
}
function __PRIVATE_debugCast(e, t) {
  return e;
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const D = {
  // Causes are copied from:
  // https://github.com/grpc/grpc/blob/bceec94ea4fc5f0085d81235d8e1c06798dc341a/include/grpc%2B%2B/impl/codegen/status_code_enum.h
  /** Not an error; returned on success. */
  OK: "ok",
  /** The operation was cancelled (typically by the caller). */
  CANCELLED: "cancelled",
  /** Unknown error or an error from a different error domain. */
  UNKNOWN: "unknown",
  /**
   * Client specified an invalid argument. Note that this differs from
   * FAILED_PRECONDITION. INVALID_ARGUMENT indicates arguments that are
   * problematic regardless of the state of the system (e.g., a malformed file
   * name).
   */
  INVALID_ARGUMENT: "invalid-argument",
  /**
   * Deadline expired before operation could complete. For operations that
   * change the state of the system, this error may be returned even if the
   * operation has completed successfully. For example, a successful response
   * from a server could have been delayed long enough for the deadline to
   * expire.
   */
  DEADLINE_EXCEEDED: "deadline-exceeded",
  /** Some requested entity (e.g., file or directory) was not found. */
  NOT_FOUND: "not-found",
  /**
   * Some entity that we attempted to create (e.g., file or directory) already
   * exists.
   */
  ALREADY_EXISTS: "already-exists",
  /**
   * The caller does not have permission to execute the specified operation.
   * PERMISSION_DENIED must not be used for rejections caused by exhausting
   * some resource (use RESOURCE_EXHAUSTED instead for those errors).
   * PERMISSION_DENIED must not be used if the caller can not be identified
   * (use UNAUTHENTICATED instead for those errors).
   */
  PERMISSION_DENIED: "permission-denied",
  /**
   * The request does not have valid authentication credentials for the
   * operation.
   */
  UNAUTHENTICATED: "unauthenticated",
  /**
   * Some resource has been exhausted, perhaps a per-user quota, or perhaps the
   * entire file system is out of space.
   */
  RESOURCE_EXHAUSTED: "resource-exhausted",
  /**
   * Operation was rejected because the system is not in a state required for
   * the operation's execution. For example, directory to be deleted may be
   * non-empty, an rmdir operation is applied to a non-directory, etc.
   *
   * A litmus test that may help a service implementor in deciding
   * between FAILED_PRECONDITION, ABORTED, and UNAVAILABLE:
   *  (a) Use UNAVAILABLE if the client can retry just the failing call.
   *  (b) Use ABORTED if the client should retry at a higher-level
   *      (e.g., restarting a read-modify-write sequence).
   *  (c) Use FAILED_PRECONDITION if the client should not retry until
   *      the system state has been explicitly fixed. E.g., if an "rmdir"
   *      fails because the directory is non-empty, FAILED_PRECONDITION
   *      should be returned since the client should not retry unless
   *      they have first fixed up the directory by deleting files from it.
   *  (d) Use FAILED_PRECONDITION if the client performs conditional
   *      REST Get/Update/Delete on a resource and the resource on the
   *      server does not match the condition. E.g., conflicting
   *      read-modify-write on the same resource.
   */
  FAILED_PRECONDITION: "failed-precondition",
  /**
   * The operation was aborted, typically due to a concurrency issue like
   * sequencer check failures, transaction aborts, etc.
   *
   * See litmus test above for deciding between FAILED_PRECONDITION, ABORTED,
   * and UNAVAILABLE.
   */
  ABORTED: "aborted",
  /**
   * Operation was attempted past the valid range. E.g., seeking or reading
   * past end of file.
   *
   * Unlike INVALID_ARGUMENT, this error indicates a problem that may be fixed
   * if the system state changes. For example, a 32-bit file system will
   * generate INVALID_ARGUMENT if asked to read at an offset that is not in the
   * range [0,2^32-1], but it will generate OUT_OF_RANGE if asked to read from
   * an offset past the current file size.
   *
   * There is a fair bit of overlap between FAILED_PRECONDITION and
   * OUT_OF_RANGE. We recommend using OUT_OF_RANGE (the more specific error)
   * when it applies so that callers who are iterating through a space can
   * easily look for an OUT_OF_RANGE error to detect when they are done.
   */
  OUT_OF_RANGE: "out-of-range",
  /** Operation is not implemented or not supported/enabled in this service. */
  UNIMPLEMENTED: "unimplemented",
  /**
   * Internal errors. Means some invariants expected by underlying System has
   * been broken. If you see one of these errors, Something is very broken.
   */
  INTERNAL: "internal",
  /**
   * The service is currently unavailable. This is a most likely a transient
   * condition and may be corrected by retrying with a backoff.
   *
   * See litmus test above for deciding between FAILED_PRECONDITION, ABORTED,
   * and UNAVAILABLE.
   */
  UNAVAILABLE: "unavailable",
  /** Unrecoverable data loss or corruption. */
  DATA_LOSS: "data-loss",
};
class FirestoreError extends FirebaseError {
  /** @hideconstructor */
  constructor(e, t) {
    super(e, t),
      (this.code = e),
      (this.message = t), // HACK: We write a toString property directly because Error is not a real
      // class and so inheritance does not work correctly. We could alternatively
      // do the same "back-door inheritance" trick that FirebaseError does.
      (this.toString = () =>
        `${this.name}: [code=${this.code}]: ${this.message}`);
  }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class __PRIVATE_Deferred {
  constructor() {
    this.promise = new Promise((e, t) => {
      (this.resolve = e), (this.reject = t);
    });
  }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class __PRIVATE_OAuthToken {
  constructor(e, t) {
    (this.user = t),
      (this.type = "OAuth"),
      (this.headers = /* @__PURE__ */ new Map()),
      this.headers.set("Authorization", `Bearer ${e}`);
  }
}
class __PRIVATE_EmptyAuthCredentialsProvider {
  getToken() {
    return Promise.resolve(null);
  }
  invalidateToken() {}
  start(e, t) {
    e.enqueueRetryable(() => t(User.UNAUTHENTICATED));
  }
  shutdown() {}
}
class __PRIVATE_FirebaseAuthCredentialsProvider {
  constructor(e) {
    (this.t = e) /** Tracks the current User. */,
      (this.currentUser = User.UNAUTHENTICATED),
      /**
       * Counter used to detect if the token changed while a getToken request was
       * outstanding.
       */ (this.i = 0),
      (this.forceRefresh = false),
      (this.auth = null);
  }
  start(e, t) {
    let n = this.i;
    const __PRIVATE_guardedChangeListener = (e2) =>
      this.i !== n ? ((n = this.i), t(e2)) : Promise.resolve();
    let r2 = new __PRIVATE_Deferred();
    this.o = () => {
      this.i++,
        (this.currentUser = this.u()),
        r2.resolve(),
        (r2 = new __PRIVATE_Deferred()),
        e.enqueueRetryable(() =>
          __PRIVATE_guardedChangeListener(this.currentUser)
        );
    };
    const __PRIVATE_awaitNextToken = () => {
        const t2 = r2;
        e.enqueueRetryable(async () => {
          await t2.promise,
            await __PRIVATE_guardedChangeListener(this.currentUser);
        });
      },
      __PRIVATE_registerAuth = (e2) => {
        __PRIVATE_logDebug("FirebaseAuthCredentialsProvider", "Auth detected"),
          (this.auth = e2),
          this.auth.addAuthTokenListener(this.o),
          __PRIVATE_awaitNextToken();
      };
    this.t.onInit((e2) => __PRIVATE_registerAuth(e2)), // Our users can initialize Auth right after Firestore, so we give it
      // a chance to register itself with the component framework before we
      // determine whether to start up in unauthenticated mode.
      setTimeout(() => {
        if (!this.auth) {
          const e2 = this.t.getImmediate({
            optional: true,
          });
          e2
            ? __PRIVATE_registerAuth(e2)
            : // If auth is still not available, proceed with `null` user
              (__PRIVATE_logDebug(
                "FirebaseAuthCredentialsProvider",
                "Auth not yet detected"
              ),
              r2.resolve(),
              (r2 = new __PRIVATE_Deferred()));
        }
      }, 0),
      __PRIVATE_awaitNextToken();
  }
  getToken() {
    const e = this.i,
      t = this.forceRefresh;
    return (
      (this.forceRefresh = false),
      this.auth
        ? this.auth.getToken(t).then((t2) =>
            // Cancel the request since the token changed while the request was
            // outstanding so the response is potentially for a previous user (which
            // user, we can't be sure).
            this.i !== e
              ? (__PRIVATE_logDebug(
                  "FirebaseAuthCredentialsProvider",
                  "getToken aborted due to token change."
                ),
                this.getToken())
              : t2
              ? (__PRIVATE_hardAssert("string" == typeof t2.accessToken),
                new __PRIVATE_OAuthToken(t2.accessToken, this.currentUser))
              : null
          )
        : Promise.resolve(null)
    );
  }
  invalidateToken() {
    this.forceRefresh = true;
  }
  shutdown() {
    this.auth && this.auth.removeAuthTokenListener(this.o);
  }
  // Auth.getUid() can return null even with a user logged in. It is because
  // getUid() is synchronous, but the auth code populating Uid is asynchronous.
  // This method should only be called in the AuthTokenListener callback
  // to guarantee to get the actual user.
  u() {
    const e = this.auth && this.auth.getUid();
    return (
      __PRIVATE_hardAssert(null === e || "string" == typeof e), new User(e)
    );
  }
}
class __PRIVATE_FirstPartyToken {
  constructor(e, t, n) {
    (this.l = e),
      (this.h = t),
      (this.P = n),
      (this.type = "FirstParty"),
      (this.user = User.FIRST_PARTY),
      (this.I = /* @__PURE__ */ new Map());
  }
  /**
   * Gets an authorization token, using a provided factory function, or return
   * null.
   */
  T() {
    return this.P ? this.P() : null;
  }
  get headers() {
    this.I.set("X-Goog-AuthUser", this.l);
    const e = this.T();
    return (
      e && this.I.set("Authorization", e),
      this.h && this.I.set("X-Goog-Iam-Authorization-Token", this.h),
      this.I
    );
  }
}
class __PRIVATE_FirstPartyAuthCredentialsProvider {
  constructor(e, t, n) {
    (this.l = e), (this.h = t), (this.P = n);
  }
  getToken() {
    return Promise.resolve(
      new __PRIVATE_FirstPartyToken(this.l, this.h, this.P)
    );
  }
  start(e, t) {
    e.enqueueRetryable(() => t(User.FIRST_PARTY));
  }
  shutdown() {}
  invalidateToken() {}
}
class AppCheckToken {
  constructor(e) {
    (this.value = e),
      (this.type = "AppCheck"),
      (this.headers = /* @__PURE__ */ new Map()),
      e && e.length > 0 && this.headers.set("x-firebase-appcheck", this.value);
  }
}
class __PRIVATE_FirebaseAppCheckTokenProvider {
  constructor(e) {
    (this.A = e),
      (this.forceRefresh = false),
      (this.appCheck = null),
      (this.R = null);
  }
  start(e, t) {
    const onTokenChanged = (e2) => {
      null != e2.error &&
        __PRIVATE_logDebug(
          "FirebaseAppCheckTokenProvider",
          `Error getting App Check token; using placeholder token instead. Error: ${e2.error.message}`
        );
      const n = e2.token !== this.R;
      return (
        (this.R = e2.token),
        __PRIVATE_logDebug(
          "FirebaseAppCheckTokenProvider",
          `Received ${n ? "new" : "existing"} token.`
        ),
        n ? t(e2.token) : Promise.resolve()
      );
    };
    this.o = (t2) => {
      e.enqueueRetryable(() => onTokenChanged(t2));
    };
    const __PRIVATE_registerAppCheck = (e2) => {
      __PRIVATE_logDebug("FirebaseAppCheckTokenProvider", "AppCheck detected"),
        (this.appCheck = e2),
        this.appCheck.addTokenListener(this.o);
    };
    this.A.onInit((e2) => __PRIVATE_registerAppCheck(e2)), // Our users can initialize AppCheck after Firestore, so we give it
      // a chance to register itself with the component framework.
      setTimeout(() => {
        if (!this.appCheck) {
          const e2 = this.A.getImmediate({
            optional: true,
          });
          e2
            ? __PRIVATE_registerAppCheck(e2)
            : // If AppCheck is still not available, proceed without it.
              __PRIVATE_logDebug(
                "FirebaseAppCheckTokenProvider",
                "AppCheck not yet detected"
              );
        }
      }, 0);
  }
  getToken() {
    const e = this.forceRefresh;
    return (
      (this.forceRefresh = false),
      this.appCheck
        ? this.appCheck
            .getToken(e)
            .then((e2) =>
              e2
                ? (__PRIVATE_hardAssert("string" == typeof e2.token),
                  (this.R = e2.token),
                  new AppCheckToken(e2.token))
                : null
            )
        : Promise.resolve(null)
    );
  }
  invalidateToken() {
    this.forceRefresh = true;
  }
  shutdown() {
    this.appCheck && this.appCheck.removeTokenListener(this.o);
  }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function __PRIVATE_randomBytes(e) {
  const t =
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      "undefined" != typeof self && (self.crypto || self.msCrypto),
    n = new Uint8Array(e);
  if (t && "function" == typeof t.getRandomValues) t.getRandomValues(n);
  else for (let t2 = 0; t2 < e; t2++) n[t2] = Math.floor(256 * Math.random());
  return n;
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class __PRIVATE_AutoId {
  static newId() {
    const e = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789",
      t = Math.floor(256 / e.length) * e.length;
    let n = "";
    for (; n.length < 20; ) {
      const r2 = __PRIVATE_randomBytes(40);
      for (let i = 0; i < r2.length; ++i)
        n.length < 20 && r2[i] < t && (n += e.charAt(r2[i] % e.length));
    }
    return n;
  }
}
function __PRIVATE_primitiveComparator(e, t) {
  return e < t ? -1 : e > t ? 1 : 0;
}
function __PRIVATE_arrayEquals(e, t, n) {
  return e.length === t.length && e.every((e2, r2) => n(e2, t[r2]));
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class Timestamp {
  /**
   * Creates a new timestamp.
   *
   * @param seconds - The number of seconds of UTC time since Unix epoch
   *     1970-01-01T00:00:00Z. Must be from 0001-01-01T00:00:00Z to
   *     9999-12-31T23:59:59Z inclusive.
   * @param nanoseconds - The non-negative fractions of a second at nanosecond
   *     resolution. Negative second values with fractions must still have
   *     non-negative nanoseconds values that count forward in time. Must be
   *     from 0 to 999,999,999 inclusive.
   */
  constructor(e, t) {
    if (((this.seconds = e), (this.nanoseconds = t), t < 0))
      throw new FirestoreError(
        D.INVALID_ARGUMENT,
        "Timestamp nanoseconds out of range: " + t
      );
    if (t >= 1e9)
      throw new FirestoreError(
        D.INVALID_ARGUMENT,
        "Timestamp nanoseconds out of range: " + t
      );
    if (e < -62135596800)
      throw new FirestoreError(
        D.INVALID_ARGUMENT,
        "Timestamp seconds out of range: " + e
      );
    if (e >= 253402300800)
      throw new FirestoreError(
        D.INVALID_ARGUMENT,
        "Timestamp seconds out of range: " + e
      );
  }
  /**
   * Creates a new timestamp with the current date, with millisecond precision.
   *
   * @returns a new timestamp representing the current date.
   */
  static now() {
    return Timestamp.fromMillis(Date.now());
  }
  /**
   * Creates a new timestamp from the given date.
   *
   * @param date - The date to initialize the `Timestamp` from.
   * @returns A new `Timestamp` representing the same point in time as the given
   *     date.
   */
  static fromDate(e) {
    return Timestamp.fromMillis(e.getTime());
  }
  /**
   * Creates a new timestamp from the given number of milliseconds.
   *
   * @param milliseconds - Number of milliseconds since Unix epoch
   *     1970-01-01T00:00:00Z.
   * @returns A new `Timestamp` representing the same point in time as the given
   *     number of milliseconds.
   */
  static fromMillis(e) {
    const t = Math.floor(e / 1e3),
      n = Math.floor(1e6 * (e - 1e3 * t));
    return new Timestamp(t, n);
  }
  /**
   * Converts a `Timestamp` to a JavaScript `Date` object. This conversion
   * causes a loss of precision since `Date` objects only support millisecond
   * precision.
   *
   * @returns JavaScript `Date` object representing the same point in time as
   *     this `Timestamp`, with millisecond precision.
   */
  toDate() {
    return new Date(this.toMillis());
  }
  /**
   * Converts a `Timestamp` to a numeric timestamp (in milliseconds since
   * epoch). This operation causes a loss of precision.
   *
   * @returns The point in time corresponding to this timestamp, represented as
   *     the number of milliseconds since Unix epoch 1970-01-01T00:00:00Z.
   */
  toMillis() {
    return 1e3 * this.seconds + this.nanoseconds / 1e6;
  }
  _compareTo(e) {
    return this.seconds === e.seconds
      ? __PRIVATE_primitiveComparator(this.nanoseconds, e.nanoseconds)
      : __PRIVATE_primitiveComparator(this.seconds, e.seconds);
  }
  /**
   * Returns true if this `Timestamp` is equal to the provided one.
   *
   * @param other - The `Timestamp` to compare against.
   * @returns true if this `Timestamp` is equal to the provided one.
   */
  isEqual(e) {
    return e.seconds === this.seconds && e.nanoseconds === this.nanoseconds;
  }
  /** Returns a textual representation of this `Timestamp`. */
  toString() {
    return (
      "Timestamp(seconds=" +
      this.seconds +
      ", nanoseconds=" +
      this.nanoseconds +
      ")"
    );
  }
  /** Returns a JSON-serializable representation of this `Timestamp`. */
  toJSON() {
    return {
      seconds: this.seconds,
      nanoseconds: this.nanoseconds,
    };
  }
  /**
   * Converts this object to a primitive string, which allows `Timestamp` objects
   * to be compared using the `>`, `<=`, `>=` and `>` operators.
   */
  valueOf() {
    const e = this.seconds - -62135596800;
    return (
      String(e).padStart(12, "0") +
      "." +
      String(this.nanoseconds).padStart(9, "0")
    );
  }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class SnapshotVersion {
  constructor(e) {
    this.timestamp = e;
  }
  static fromTimestamp(e) {
    return new SnapshotVersion(e);
  }
  static min() {
    return new SnapshotVersion(new Timestamp(0, 0));
  }
  static max() {
    return new SnapshotVersion(new Timestamp(253402300799, 999999999));
  }
  compareTo(e) {
    return this.timestamp._compareTo(e.timestamp);
  }
  isEqual(e) {
    return this.timestamp.isEqual(e.timestamp);
  }
  /** Returns a number representation of the version for use in spec tests. */
  toMicroseconds() {
    return 1e6 * this.timestamp.seconds + this.timestamp.nanoseconds / 1e3;
  }
  toString() {
    return "SnapshotVersion(" + this.timestamp.toString() + ")";
  }
  toTimestamp() {
    return this.timestamp;
  }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class BasePath {
  constructor(e, t, n) {
    void 0 === t ? (t = 0) : t > e.length && fail(),
      void 0 === n ? (n = e.length - t) : n > e.length - t && fail(),
      (this.segments = e),
      (this.offset = t),
      (this.len = n);
  }
  get length() {
    return this.len;
  }
  isEqual(e) {
    return 0 === BasePath.comparator(this, e);
  }
  child(e) {
    const t = this.segments.slice(this.offset, this.limit());
    return (
      e instanceof BasePath
        ? e.forEach((e2) => {
            t.push(e2);
          })
        : t.push(e),
      this.construct(t)
    );
  }
  /** The index of one past the last segment of the path. */
  limit() {
    return this.offset + this.length;
  }
  popFirst(e) {
    return (
      (e = void 0 === e ? 1 : e),
      this.construct(this.segments, this.offset + e, this.length - e)
    );
  }
  popLast() {
    return this.construct(this.segments, this.offset, this.length - 1);
  }
  firstSegment() {
    return this.segments[this.offset];
  }
  lastSegment() {
    return this.get(this.length - 1);
  }
  get(e) {
    return this.segments[this.offset + e];
  }
  isEmpty() {
    return 0 === this.length;
  }
  isPrefixOf(e) {
    if (e.length < this.length) return false;
    for (let t = 0; t < this.length; t++)
      if (this.get(t) !== e.get(t)) return false;
    return true;
  }
  isImmediateParentOf(e) {
    if (this.length + 1 !== e.length) return false;
    for (let t = 0; t < this.length; t++)
      if (this.get(t) !== e.get(t)) return false;
    return true;
  }
  forEach(e) {
    for (let t = this.offset, n = this.limit(); t < n; t++) e(this.segments[t]);
  }
  toArray() {
    return this.segments.slice(this.offset, this.limit());
  }
  static comparator(e, t) {
    const n = Math.min(e.length, t.length);
    for (let r2 = 0; r2 < n; r2++) {
      const n2 = e.get(r2),
        i = t.get(r2);
      if (n2 < i) return -1;
      if (n2 > i) return 1;
    }
    return e.length < t.length ? -1 : e.length > t.length ? 1 : 0;
  }
}
class ResourcePath extends BasePath {
  construct(e, t, n) {
    return new ResourcePath(e, t, n);
  }
  canonicalString() {
    return this.toArray().join("/");
  }
  toString() {
    return this.canonicalString();
  }
  /**
   * Returns a string representation of this path
   * where each path segment has been encoded with
   * `encodeURIComponent`.
   */
  toUriEncodedString() {
    return this.toArray().map(encodeURIComponent).join("/");
  }
  /**
   * Creates a resource path from the given slash-delimited string. If multiple
   * arguments are provided, all components are combined. Leading and trailing
   * slashes from all components are ignored.
   */
  static fromString(...e) {
    const t = [];
    for (const n of e) {
      if (n.indexOf("//") >= 0)
        throw new FirestoreError(
          D.INVALID_ARGUMENT,
          `Invalid segment (${n}). Paths must not contain // in them.`
        );
      t.push(...n.split("/").filter((e2) => e2.length > 0));
    }
    return new ResourcePath(t);
  }
  static emptyPath() {
    return new ResourcePath([]);
  }
}
const C = /^[_a-zA-Z][_a-zA-Z0-9]*$/;
class FieldPath$1 extends BasePath {
  construct(e, t, n) {
    return new FieldPath$1(e, t, n);
  }
  /**
   * Returns true if the string could be used as a segment in a field path
   * without escaping.
   */
  static isValidIdentifier(e) {
    return C.test(e);
  }
  canonicalString() {
    return this.toArray()
      .map(
        (e) => (
          (e = e.replace(/\\/g, "\\\\").replace(/`/g, "\\`")),
          FieldPath$1.isValidIdentifier(e) || (e = "`" + e + "`"),
          e
        )
      )
      .join(".");
  }
  toString() {
    return this.canonicalString();
  }
  /**
   * Returns true if this field references the key of a document.
   */
  isKeyField() {
    return 1 === this.length && "__name__" === this.get(0);
  }
  /**
   * The field designating the key of a document.
   */
  static keyField() {
    return new FieldPath$1(["__name__"]);
  }
  /**
   * Parses a field string from the given server-formatted string.
   *
   * - Splitting the empty string is not allowed (for now at least).
   * - Empty segments within the string (e.g. if there are two consecutive
   *   separators) are not allowed.
   *
   * TODO(b/37244157): we should make this more strict. Right now, it allows
   * non-identifier path components, even if they aren't escaped.
   */
  static fromServerFormat(e) {
    const t = [];
    let n = "",
      r2 = 0;
    const __PRIVATE_addCurrentSegment = () => {
      if (0 === n.length)
        throw new FirestoreError(
          D.INVALID_ARGUMENT,
          `Invalid field path (${e}). Paths must not be empty, begin with '.', end with '.', or contain '..'`
        );
      t.push(n), (n = "");
    };
    let i = false;
    for (; r2 < e.length; ) {
      const t2 = e[r2];
      if ("\\" === t2) {
        if (r2 + 1 === e.length)
          throw new FirestoreError(
            D.INVALID_ARGUMENT,
            "Path has trailing escape character: " + e
          );
        const t3 = e[r2 + 1];
        if ("\\" !== t3 && "." !== t3 && "`" !== t3)
          throw new FirestoreError(
            D.INVALID_ARGUMENT,
            "Path has invalid escape sequence: " + e
          );
        (n += t3), (r2 += 2);
      } else
        "`" === t2
          ? ((i = !i), r2++)
          : "." !== t2 || i
          ? ((n += t2), r2++)
          : (__PRIVATE_addCurrentSegment(), r2++);
    }
    if ((__PRIVATE_addCurrentSegment(), i))
      throw new FirestoreError(
        D.INVALID_ARGUMENT,
        "Unterminated ` in path: " + e
      );
    return new FieldPath$1(t);
  }
  static emptyPath() {
    return new FieldPath$1([]);
  }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class DocumentKey {
  constructor(e) {
    this.path = e;
  }
  static fromPath(e) {
    return new DocumentKey(ResourcePath.fromString(e));
  }
  static fromName(e) {
    return new DocumentKey(ResourcePath.fromString(e).popFirst(5));
  }
  static empty() {
    return new DocumentKey(ResourcePath.emptyPath());
  }
  get collectionGroup() {
    return this.path.popLast().lastSegment();
  }
  /** Returns true if the document is in the specified collectionId. */
  hasCollectionId(e) {
    return this.path.length >= 2 && this.path.get(this.path.length - 2) === e;
  }
  /** Returns the collection group (i.e. the name of the parent collection) for this key. */
  getCollectionGroup() {
    return this.path.get(this.path.length - 2);
  }
  /** Returns the fully qualified path to the parent collection. */
  getCollectionPath() {
    return this.path.popLast();
  }
  isEqual(e) {
    return null !== e && 0 === ResourcePath.comparator(this.path, e.path);
  }
  toString() {
    return this.path.toString();
  }
  static comparator(e, t) {
    return ResourcePath.comparator(e.path, t.path);
  }
  static isDocumentKey(e) {
    return e.length % 2 == 0;
  }
  /**
   * Creates and returns a new document key with the given segments.
   *
   * @param segments - The segments of the path to the document
   * @returns A new instance of DocumentKey
   */
  static fromSegments(e) {
    return new DocumentKey(new ResourcePath(e.slice()));
  }
}
function __PRIVATE_newIndexOffsetSuccessorFromReadTime(e, t) {
  const n = e.toTimestamp().seconds,
    r2 = e.toTimestamp().nanoseconds + 1,
    i = SnapshotVersion.fromTimestamp(
      1e9 === r2 ? new Timestamp(n + 1, 0) : new Timestamp(n, r2)
    );
  return new IndexOffset(i, DocumentKey.empty(), t);
}
function __PRIVATE_newIndexOffsetFromDocument(e) {
  return new IndexOffset(e.readTime, e.key, -1);
}
class IndexOffset {
  constructor(e, t, n) {
    (this.readTime = e), (this.documentKey = t), (this.largestBatchId = n);
  }
  /** Returns an offset that sorts before all regular offsets. */
  static min() {
    return new IndexOffset(SnapshotVersion.min(), DocumentKey.empty(), -1);
  }
  /** Returns an offset that sorts after all regular offsets. */
  static max() {
    return new IndexOffset(SnapshotVersion.max(), DocumentKey.empty(), -1);
  }
}
function __PRIVATE_indexOffsetComparator(e, t) {
  let n = e.readTime.compareTo(t.readTime);
  return 0 !== n
    ? n
    : ((n = DocumentKey.comparator(e.documentKey, t.documentKey)),
      0 !== n
        ? n
        : __PRIVATE_primitiveComparator(e.largestBatchId, t.largestBatchId));
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const v =
  "The current tab is not in the required state to perform this operation. It might be necessary to refresh the browser tab.";
class PersistenceTransaction {
  constructor() {
    this.onCommittedListeners = [];
  }
  addOnCommittedListener(e) {
    this.onCommittedListeners.push(e);
  }
  raiseOnCommittedEvent() {
    this.onCommittedListeners.forEach((e) => e());
  }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
async function __PRIVATE_ignoreIfPrimaryLeaseLoss(e) {
  if (e.code !== D.FAILED_PRECONDITION || e.message !== v) throw e;
  __PRIVATE_logDebug("LocalStore", "Unexpectedly lost primary lease");
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class PersistencePromise {
  constructor(e) {
    (this.nextCallback = null),
      (this.catchCallback = null), // When the operation resolves, we'll set result or error and mark isDone.
      (this.result = void 0),
      (this.error = void 0),
      (this.isDone = false), // Set to true when .then() or .catch() are called and prevents additional
      // chaining.
      (this.callbackAttached = false),
      e(
        (e2) => {
          (this.isDone = true),
            (this.result = e2),
            this.nextCallback && // value should be defined unless T is Void, but we can't express
              // that in the type system.
              this.nextCallback(e2);
        },
        (e2) => {
          (this.isDone = true),
            (this.error = e2),
            this.catchCallback && this.catchCallback(e2);
        }
      );
  }
  catch(e) {
    return this.next(void 0, e);
  }
  next(e, t) {
    return (
      this.callbackAttached && fail(),
      (this.callbackAttached = true),
      this.isDone
        ? this.error
          ? this.wrapFailure(t, this.error)
          : this.wrapSuccess(e, this.result)
        : new PersistencePromise((n, r2) => {
            (this.nextCallback = (t2) => {
              this.wrapSuccess(e, t2).next(n, r2);
            }),
              (this.catchCallback = (e2) => {
                this.wrapFailure(t, e2).next(n, r2);
              });
          })
    );
  }
  toPromise() {
    return new Promise((e, t) => {
      this.next(e, t);
    });
  }
  wrapUserFunction(e) {
    try {
      const t = e();
      return t instanceof PersistencePromise
        ? t
        : PersistencePromise.resolve(t);
    } catch (e2) {
      return PersistencePromise.reject(e2);
    }
  }
  wrapSuccess(e, t) {
    return e
      ? this.wrapUserFunction(() => e(t))
      : PersistencePromise.resolve(t);
  }
  wrapFailure(e, t) {
    return e ? this.wrapUserFunction(() => e(t)) : PersistencePromise.reject(t);
  }
  static resolve(e) {
    return new PersistencePromise((t, n) => {
      t(e);
    });
  }
  static reject(e) {
    return new PersistencePromise((t, n) => {
      n(e);
    });
  }
  static waitFor(e) {
    return new PersistencePromise((t, n) => {
      let r2 = 0,
        i = 0,
        s = false;
      e.forEach((e2) => {
        ++r2,
          e2.next(
            () => {
              ++i, s && i === r2 && t();
            },
            (e3) => n(e3)
          );
      }),
        (s = true),
        i === r2 && t();
    });
  }
  /**
   * Given an array of predicate functions that asynchronously evaluate to a
   * boolean, implements a short-circuiting `or` between the results. Predicates
   * will be evaluated until one of them returns `true`, then stop. The final
   * result will be whether any of them returned `true`.
   */
  static or(e) {
    let t = PersistencePromise.resolve(false);
    for (const n of e)
      t = t.next((e2) => (e2 ? PersistencePromise.resolve(e2) : n()));
    return t;
  }
  static forEach(e, t) {
    const n = [];
    return (
      e.forEach((e2, r2) => {
        n.push(t.call(this, e2, r2));
      }),
      this.waitFor(n)
    );
  }
  /**
   * Concurrently map all array elements through asynchronous function.
   */
  static mapArray(e, t) {
    return new PersistencePromise((n, r2) => {
      const i = e.length,
        s = new Array(i);
      let o = 0;
      for (let _ = 0; _ < i; _++) {
        const a = _;
        t(e[a]).next(
          (e2) => {
            (s[a] = e2), ++o, o === i && n(s);
          },
          (e2) => r2(e2)
        );
      }
    });
  }
  /**
   * An alternative to recursive PersistencePromise calls, that avoids
   * potential memory problems from unbounded chains of promises.
   *
   * The `action` will be called repeatedly while `condition` is true.
   */
  static doWhile(e, t) {
    return new PersistencePromise((n, r2) => {
      const process2 = () => {
        true === e()
          ? t().next(() => {
              process2();
            }, r2)
          : n();
      };
      process2();
    });
  }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class __PRIVATE_SimpleDbTransaction {
  constructor(e, t) {
    (this.action = e),
      (this.transaction = t),
      (this.aborted = false),
      /**
       * A `Promise` that resolves with the result of the IndexedDb transaction.
       */ (this.V = new __PRIVATE_Deferred()),
      (this.transaction.oncomplete = () => {
        this.V.resolve();
      }),
      (this.transaction.onabort = () => {
        t.error
          ? this.V.reject(new __PRIVATE_IndexedDbTransactionError(e, t.error))
          : this.V.resolve();
      }),
      (this.transaction.onerror = (t2) => {
        const n = __PRIVATE_checkForAndReportiOSError(t2.target.error);
        this.V.reject(new __PRIVATE_IndexedDbTransactionError(e, n));
      });
  }
  static open(e, t, n, r2) {
    try {
      return new __PRIVATE_SimpleDbTransaction(t, e.transaction(r2, n));
    } catch (e2) {
      throw new __PRIVATE_IndexedDbTransactionError(t, e2);
    }
  }
  get m() {
    return this.V.promise;
  }
  abort(e) {
    e && this.V.reject(e),
      this.aborted ||
        (__PRIVATE_logDebug(
          "SimpleDb",
          "Aborting transaction:",
          e ? e.message : "Client-initiated abort"
        ),
        (this.aborted = true),
        this.transaction.abort());
  }
  g() {
    const e = this.transaction;
    this.aborted || "function" != typeof e.commit || e.commit();
  }
  /**
   * Returns a SimpleDbStore<KeyType, ValueType> for the specified store. All
   * operations performed on the SimpleDbStore happen within the context of this
   * transaction and it cannot be used anymore once the transaction is
   * completed.
   *
   * Note that we can't actually enforce that the KeyType and ValueType are
   * correct, but they allow type safety through the rest of the consuming code.
   */
  store(e) {
    const t = this.transaction.objectStore(e);
    return new __PRIVATE_SimpleDbStore(t);
  }
}
class __PRIVATE_SimpleDb {
  /*
   * Creates a new SimpleDb wrapper for IndexedDb database `name`.
   *
   * Note that `version` must not be a downgrade. IndexedDB does not support
   * downgrading the schema version. We currently do not support any way to do
   * versioning outside of IndexedDB's versioning mechanism, as only
   * version-upgrade transactions are allowed to do things like create
   * objectstores.
   */
  constructor(e, t, n) {
    (this.name = e), (this.version = t), (this.p = n);
    12.2 === __PRIVATE_SimpleDb.S(getUA()) &&
      __PRIVATE_logError(
        "Firestore persistence suffers from a bug in iOS 12.2 Safari that may cause your app to stop working. See https://stackoverflow.com/q/56496296/110915 for details and a potential workaround."
      );
  }
  /** Deletes the specified database. */
  static delete(e) {
    return (
      __PRIVATE_logDebug("SimpleDb", "Removing database:", e),
      __PRIVATE_wrapRequest(window.indexedDB.deleteDatabase(e)).toPromise()
    );
  }
  /** Returns true if IndexedDB is available in the current environment. */
  static D() {
    if (!isIndexedDBAvailable()) return false;
    if (__PRIVATE_SimpleDb.C()) return true;
    const e = getUA(),
      t = __PRIVATE_SimpleDb.S(e),
      n = 0 < t && t < 10,
      r2 = __PRIVATE_SimpleDb.v(e),
      i = 0 < r2 && r2 < 4.5;
    return !(
      e.indexOf("MSIE ") > 0 ||
      e.indexOf("Trident/") > 0 ||
      e.indexOf("Edge/") > 0 ||
      n ||
      i
    );
  }
  /**
   * Returns true if the backing IndexedDB store is the Node IndexedDBShim
   * (see https://github.com/axemclion/IndexedDBShim).
   */
  static C() {
    var e;
    return (
      "undefined" != typeof process &&
      "YES" ===
        (null === (e = process.__PRIVATE_env) || void 0 === e ? void 0 : e.F)
    );
  }
  /** Helper to get a typed SimpleDbStore from a transaction. */
  static M(e, t) {
    return e.store(t);
  }
  // visible for testing
  /** Parse User Agent to determine iOS version. Returns -1 if not found. */
  static S(e) {
    const t = e.match(/i(?:phone|pad|pod) os ([\d_]+)/i),
      n = t ? t[1].split("_").slice(0, 2).join(".") : "-1";
    return Number(n);
  }
  // visible for testing
  /** Parse User Agent to determine Android version. Returns -1 if not found. */
  static v(e) {
    const t = e.match(/Android ([\d.]+)/i),
      n = t ? t[1].split(".").slice(0, 2).join(".") : "-1";
    return Number(n);
  }
  /**
   * Opens the specified database, creating or upgrading it if necessary.
   */
  async O(e) {
    return (
      this.db ||
        (__PRIVATE_logDebug("SimpleDb", "Opening database:", this.name),
        (this.db = await new Promise((t, n) => {
          const r2 = indexedDB.open(this.name, this.version);
          (r2.onsuccess = (e2) => {
            const n2 = e2.target.result;
            t(n2);
          }),
            (r2.onblocked = () => {
              n(
                new __PRIVATE_IndexedDbTransactionError(
                  e,
                  "Cannot upgrade IndexedDB schema while another tab is open. Close all tabs that access Firestore and reload this page to proceed."
                )
              );
            }),
            (r2.onerror = (t2) => {
              const r3 = t2.target.error;
              "VersionError" === r3.name
                ? n(
                    new FirestoreError(
                      D.FAILED_PRECONDITION,
                      "A newer version of the Firestore SDK was previously used and so the persisted data is not compatible with the version of the SDK you are now using. The SDK will operate with persistence disabled. If you need persistence, please re-upgrade to a newer version of the SDK or else clear the persisted IndexedDB data for your app to start fresh."
                    )
                  )
                : "InvalidStateError" === r3.name
                ? n(
                    new FirestoreError(
                      D.FAILED_PRECONDITION,
                      "Unable to open an IndexedDB connection. This could be due to running in a private browsing session on a browser whose private browsing sessions do not support IndexedDB: " +
                        r3
                    )
                  )
                : n(new __PRIVATE_IndexedDbTransactionError(e, r3));
            }),
            (r2.onupgradeneeded = (e2) => {
              __PRIVATE_logDebug(
                "SimpleDb",
                'Database "' + this.name + '" requires upgrade from version:',
                e2.oldVersion
              );
              const t2 = e2.target.result;
              this.p
                .N(t2, r2.transaction, e2.oldVersion, this.version)
                .next(() => {
                  __PRIVATE_logDebug(
                    "SimpleDb",
                    "Database upgrade to version " + this.version + " complete"
                  );
                });
            });
        }))),
      this.L && (this.db.onversionchange = (e2) => this.L(e2)),
      this.db
    );
  }
  B(e) {
    (this.L = e), this.db && (this.db.onversionchange = (t) => e(t));
  }
  async runTransaction(e, t, n, r2) {
    const i = "readonly" === t;
    let s = 0;
    for (;;) {
      ++s;
      try {
        this.db = await this.O(e);
        const t2 = __PRIVATE_SimpleDbTransaction.open(
            this.db,
            e,
            i ? "readonly" : "readwrite",
            n
          ),
          s2 = r2(t2)
            .next((e2) => (t2.g(), e2))
            .catch(
              (e2) => (
                // Abort the transaction if there was an error.
                t2.abort(e2), PersistencePromise.reject(e2)
              )
            )
            .toPromise();
        return (
          s2.catch(() => {}), // Wait for the transaction to complete (i.e. IndexedDb's onsuccess event to
          // fire), but still return the original transactionFnResult back to the
          // caller.
          await t2.m,
          s2
        );
      } catch (e2) {
        const t2 = e2,
          n2 = "FirebaseError" !== t2.name && s < 3;
        if (
          (__PRIVATE_logDebug(
            "SimpleDb",
            "Transaction failed with error:",
            t2.message,
            "Retrying:",
            n2
          ),
          this.close(),
          !n2)
        )
          return Promise.reject(t2);
      }
    }
  }
  close() {
    this.db && this.db.close(), (this.db = void 0);
  }
}
class __PRIVATE_IterationController {
  constructor(e) {
    (this.k = e), (this.q = false), (this.K = null);
  }
  get isDone() {
    return this.q;
  }
  get $() {
    return this.K;
  }
  set cursor(e) {
    this.k = e;
  }
  /**
   * This function can be called to stop iteration at any point.
   */
  done() {
    this.q = true;
  }
  /**
   * This function can be called to skip to that next key, which could be
   * an index or a primary key.
   */
  U(e) {
    this.K = e;
  }
  /**
   * Delete the current cursor value from the object store.
   *
   * NOTE: You CANNOT do this with a keysOnly query.
   */
  delete() {
    return __PRIVATE_wrapRequest(this.k.delete());
  }
}
class __PRIVATE_IndexedDbTransactionError extends FirestoreError {
  constructor(e, t) {
    super(D.UNAVAILABLE, `IndexedDB transaction '${e}' failed: ${t}`),
      (this.name = "IndexedDbTransactionError");
  }
}
function __PRIVATE_isIndexedDbTransactionError(e) {
  return "IndexedDbTransactionError" === e.name;
}
class __PRIVATE_SimpleDbStore {
  constructor(e) {
    this.store = e;
  }
  put(e, t) {
    let n;
    return (
      void 0 !== t
        ? (__PRIVATE_logDebug("SimpleDb", "PUT", this.store.name, e, t),
          (n = this.store.put(t, e)))
        : (__PRIVATE_logDebug(
            "SimpleDb",
            "PUT",
            this.store.name,
            "<auto-key>",
            e
          ),
          (n = this.store.put(e))),
      __PRIVATE_wrapRequest(n)
    );
  }
  /**
   * Adds a new value into an Object Store and returns the new key. Similar to
   * IndexedDb's `add()`, this method will fail on primary key collisions.
   *
   * @param value - The object to write.
   * @returns The key of the value to add.
   */
  add(e) {
    __PRIVATE_logDebug("SimpleDb", "ADD", this.store.name, e, e);
    return __PRIVATE_wrapRequest(this.store.add(e));
  }
  /**
   * Gets the object with the specified key from the specified store, or null
   * if no object exists with the specified key.
   *
   * @key The key of the object to get.
   * @returns The object with the specified key or null if no object exists.
   */
  get(e) {
    return __PRIVATE_wrapRequest(this.store.get(e)).next(
      (t) => (
        // Normalize nonexistence to null.
        void 0 === t && (t = null),
        __PRIVATE_logDebug("SimpleDb", "GET", this.store.name, e, t),
        t
      )
    );
  }
  delete(e) {
    __PRIVATE_logDebug("SimpleDb", "DELETE", this.store.name, e);
    return __PRIVATE_wrapRequest(this.store.delete(e));
  }
  /**
   * If we ever need more of the count variants, we can add overloads. For now,
   * all we need is to count everything in a store.
   *
   * Returns the number of rows in the store.
   */
  count() {
    __PRIVATE_logDebug("SimpleDb", "COUNT", this.store.name);
    return __PRIVATE_wrapRequest(this.store.count());
  }
  W(e, t) {
    const n = this.options(e, t),
      r2 = n.index ? this.store.index(n.index) : this.store;
    if ("function" == typeof r2.getAll) {
      const e2 = r2.getAll(n.range);
      return new PersistencePromise((t2, n2) => {
        (e2.onerror = (e3) => {
          n2(e3.target.error);
        }),
          (e2.onsuccess = (e3) => {
            t2(e3.target.result);
          });
      });
    }
    {
      const e2 = this.cursor(n),
        t2 = [];
      return this.G(e2, (e3, n2) => {
        t2.push(n2);
      }).next(() => t2);
    }
  }
  /**
   * Loads the first `count` elements from the provided index range. Loads all
   * elements if no limit is provided.
   */
  j(e, t) {
    const n = this.store.getAll(e, null === t ? void 0 : t);
    return new PersistencePromise((e2, t2) => {
      (n.onerror = (e3) => {
        t2(e3.target.error);
      }),
        (n.onsuccess = (t3) => {
          e2(t3.target.result);
        });
    });
  }
  H(e, t) {
    __PRIVATE_logDebug("SimpleDb", "DELETE ALL", this.store.name);
    const n = this.options(e, t);
    n.J = false;
    const r2 = this.cursor(n);
    return this.G(r2, (e2, t2, n2) => n2.delete());
  }
  Y(e, t) {
    let n;
    t ? (n = e) : ((n = {}), (t = e));
    const r2 = this.cursor(n);
    return this.G(r2, t);
  }
  /**
   * Iterates over a store, but waits for the given callback to complete for
   * each entry before iterating the next entry. This allows the callback to do
   * asynchronous work to determine if this iteration should continue.
   *
   * The provided callback should return `true` to continue iteration, and
   * `false` otherwise.
   */
  Z(e) {
    const t = this.cursor({});
    return new PersistencePromise((n, r2) => {
      (t.onerror = (e2) => {
        const t2 = __PRIVATE_checkForAndReportiOSError(e2.target.error);
        r2(t2);
      }),
        (t.onsuccess = (t2) => {
          const r3 = t2.target.result;
          r3
            ? e(r3.primaryKey, r3.value).next((e2) => {
                e2 ? r3.continue() : n();
              })
            : n();
        });
    });
  }
  G(e, t) {
    const n = [];
    return new PersistencePromise((r2, i) => {
      (e.onerror = (e2) => {
        i(e2.target.error);
      }),
        (e.onsuccess = (e2) => {
          const i2 = e2.target.result;
          if (!i2) return void r2();
          const s = new __PRIVATE_IterationController(i2),
            o = t(i2.primaryKey, i2.value, s);
          if (o instanceof PersistencePromise) {
            const e3 = o.catch(
              (e4) => (s.done(), PersistencePromise.reject(e4))
            );
            n.push(e3);
          }
          s.isDone ? r2() : null === s.$ ? i2.continue() : i2.continue(s.$);
        });
    }).next(() => PersistencePromise.waitFor(n));
  }
  options(e, t) {
    let n;
    return (
      void 0 !== e && ("string" == typeof e ? (n = e) : (t = e)),
      {
        index: n,
        range: t,
      }
    );
  }
  cursor(e) {
    let t = "next";
    if ((e.reverse && (t = "prev"), e.index)) {
      const n = this.store.index(e.index);
      return e.J ? n.openKeyCursor(e.range, t) : n.openCursor(e.range, t);
    }
    return this.store.openCursor(e.range, t);
  }
}
function __PRIVATE_wrapRequest(e) {
  return new PersistencePromise((t, n) => {
    (e.onsuccess = (e2) => {
      const n2 = e2.target.result;
      t(n2);
    }),
      (e.onerror = (e2) => {
        const t2 = __PRIVATE_checkForAndReportiOSError(e2.target.error);
        n(t2);
      });
  });
}
let F = false;
function __PRIVATE_checkForAndReportiOSError(e) {
  const t = __PRIVATE_SimpleDb.S(getUA());
  if (t >= 12.2 && t < 13) {
    const t2 =
      "An internal error was encountered in the Indexed Database server";
    if (e.message.indexOf(t2) >= 0) {
      const e2 = new FirestoreError(
        "internal",
        `IOS_INDEXEDDB_BUG1: IndexedDb has thrown '${t2}'. This is likely due to an unavoidable bug in iOS. See https://stackoverflow.com/q/56496296/110915 for details and a potential workaround.`
      );
      return (
        F ||
          ((F = true), // Throw a global exception outside of this promise chain, for the user to
          // potentially catch.
          setTimeout(() => {
            throw e2;
          }, 0)),
        e2
      );
    }
  }
  return e;
}
/**
 * @license
 * Copyright 2018 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class __PRIVATE_ListenSequence {
  constructor(e, t) {
    (this.previousValue = e),
      t &&
        ((t.sequenceNumberHandler = (e2) => this.se(e2)),
        (this.oe = (e2) => t.writeSequenceNumber(e2)));
  }
  se(e) {
    return (
      (this.previousValue = Math.max(e, this.previousValue)), this.previousValue
    );
  }
  next() {
    const e = ++this.previousValue;
    return this.oe && this.oe(e), e;
  }
}
__PRIVATE_ListenSequence._e = -1;
function __PRIVATE_isNullOrUndefined(e) {
  return null == e;
}
function __PRIVATE_isNegativeZero(e) {
  return 0 === e && 1 / e == -1 / 0;
}
function isSafeInteger(e) {
  return (
    "number" == typeof e &&
    Number.isInteger(e) &&
    !__PRIVATE_isNegativeZero(e) &&
    e <= Number.MAX_SAFE_INTEGER &&
    e >= Number.MIN_SAFE_INTEGER
  );
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function __PRIVATE_objectSize(e) {
  let t = 0;
  for (const n in e) Object.prototype.hasOwnProperty.call(e, n) && t++;
  return t;
}
function forEach$1(e, t) {
  for (const n in e) Object.prototype.hasOwnProperty.call(e, n) && t(n, e[n]);
}
function isEmpty(e) {
  for (const t in e)
    if (Object.prototype.hasOwnProperty.call(e, t)) return false;
  return true;
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class SortedMap {
  constructor(e, t) {
    (this.comparator = e), (this.root = t || LLRBNode.EMPTY);
  }
  // Returns a copy of the map, with the specified key/value added or replaced.
  insert(e, t) {
    return new SortedMap(
      this.comparator,
      this.root
        .insert(e, t, this.comparator)
        .copy(null, null, LLRBNode.BLACK, null, null)
    );
  }
  // Returns a copy of the map, with the specified key removed.
  remove(e) {
    return new SortedMap(
      this.comparator,
      this.root
        .remove(e, this.comparator)
        .copy(null, null, LLRBNode.BLACK, null, null)
    );
  }
  // Returns the value of the node with the given key, or null.
  get(e) {
    let t = this.root;
    for (; !t.isEmpty(); ) {
      const n = this.comparator(e, t.key);
      if (0 === n) return t.value;
      n < 0 ? (t = t.left) : n > 0 && (t = t.right);
    }
    return null;
  }
  // Returns the index of the element in this sorted map, or -1 if it doesn't
  // exist.
  indexOf(e) {
    let t = 0,
      n = this.root;
    for (; !n.isEmpty(); ) {
      const r2 = this.comparator(e, n.key);
      if (0 === r2) return t + n.left.size;
      r2 < 0
        ? (n = n.left)
        : // Count all nodes left of the node plus the node itself
          ((t += n.left.size + 1), (n = n.right));
    }
    return -1;
  }
  isEmpty() {
    return this.root.isEmpty();
  }
  // Returns the total number of nodes in the map.
  get size() {
    return this.root.size;
  }
  // Returns the minimum key in the map.
  minKey() {
    return this.root.minKey();
  }
  // Returns the maximum key in the map.
  maxKey() {
    return this.root.maxKey();
  }
  // Traverses the map in key order and calls the specified action function
  // for each key/value pair. If action returns true, traversal is aborted.
  // Returns the first truthy value returned by action, or the last falsey
  // value returned by action.
  inorderTraversal(e) {
    return this.root.inorderTraversal(e);
  }
  forEach(e) {
    this.inorderTraversal((t, n) => (e(t, n), false));
  }
  toString() {
    const e = [];
    return (
      this.inorderTraversal((t, n) => (e.push(`${t}:${n}`), false)),
      `{${e.join(", ")}}`
    );
  }
  // Traverses the map in reverse key order and calls the specified action
  // function for each key/value pair. If action returns true, traversal is
  // aborted.
  // Returns the first truthy value returned by action, or the last falsey
  // value returned by action.
  reverseTraversal(e) {
    return this.root.reverseTraversal(e);
  }
  // Returns an iterator over the SortedMap.
  getIterator() {
    return new SortedMapIterator(this.root, null, this.comparator, false);
  }
  getIteratorFrom(e) {
    return new SortedMapIterator(this.root, e, this.comparator, false);
  }
  getReverseIterator() {
    return new SortedMapIterator(this.root, null, this.comparator, true);
  }
  getReverseIteratorFrom(e) {
    return new SortedMapIterator(this.root, e, this.comparator, true);
  }
}
class SortedMapIterator {
  constructor(e, t, n, r2) {
    (this.isReverse = r2), (this.nodeStack = []);
    let i = 1;
    for (; !e.isEmpty(); )
      if (
        ((i = t ? n(e.key, t) : 1), // flip the comparison if we're going in reverse
        t && r2 && (i *= -1),
        i < 0)
      )
        e = this.isReverse ? e.left : e.right;
      else {
        if (0 === i) {
          this.nodeStack.push(e);
          break;
        }
        this.nodeStack.push(e), (e = this.isReverse ? e.right : e.left);
      }
  }
  getNext() {
    let e = this.nodeStack.pop();
    const t = {
      key: e.key,
      value: e.value,
    };
    if (this.isReverse)
      for (e = e.left; !e.isEmpty(); ) this.nodeStack.push(e), (e = e.right);
    else for (e = e.right; !e.isEmpty(); ) this.nodeStack.push(e), (e = e.left);
    return t;
  }
  hasNext() {
    return this.nodeStack.length > 0;
  }
  peek() {
    if (0 === this.nodeStack.length) return null;
    const e = this.nodeStack[this.nodeStack.length - 1];
    return {
      key: e.key,
      value: e.value,
    };
  }
}
class LLRBNode {
  constructor(e, t, n, r2, i) {
    (this.key = e),
      (this.value = t),
      (this.color = null != n ? n : LLRBNode.RED),
      (this.left = null != r2 ? r2 : LLRBNode.EMPTY),
      (this.right = null != i ? i : LLRBNode.EMPTY),
      (this.size = this.left.size + 1 + this.right.size);
  }
  // Returns a copy of the current node, optionally replacing pieces of it.
  copy(e, t, n, r2, i) {
    return new LLRBNode(
      null != e ? e : this.key,
      null != t ? t : this.value,
      null != n ? n : this.color,
      null != r2 ? r2 : this.left,
      null != i ? i : this.right
    );
  }
  isEmpty() {
    return false;
  }
  // Traverses the tree in key order and calls the specified action function
  // for each node. If action returns true, traversal is aborted.
  // Returns the first truthy value returned by action, or the last falsey
  // value returned by action.
  inorderTraversal(e) {
    return (
      this.left.inorderTraversal(e) ||
      e(this.key, this.value) ||
      this.right.inorderTraversal(e)
    );
  }
  // Traverses the tree in reverse key order and calls the specified action
  // function for each node. If action returns true, traversal is aborted.
  // Returns the first truthy value returned by action, or the last falsey
  // value returned by action.
  reverseTraversal(e) {
    return (
      this.right.reverseTraversal(e) ||
      e(this.key, this.value) ||
      this.left.reverseTraversal(e)
    );
  }
  // Returns the minimum node in the tree.
  min() {
    return this.left.isEmpty() ? this : this.left.min();
  }
  // Returns the maximum key in the tree.
  minKey() {
    return this.min().key;
  }
  // Returns the maximum key in the tree.
  maxKey() {
    return this.right.isEmpty() ? this.key : this.right.maxKey();
  }
  // Returns new tree, with the key/value added.
  insert(e, t, n) {
    let r2 = this;
    const i = n(e, r2.key);
    return (
      (r2 =
        i < 0
          ? r2.copy(null, null, null, r2.left.insert(e, t, n), null)
          : 0 === i
          ? r2.copy(null, t, null, null, null)
          : r2.copy(null, null, null, null, r2.right.insert(e, t, n))),
      r2.fixUp()
    );
  }
  removeMin() {
    if (this.left.isEmpty()) return LLRBNode.EMPTY;
    let e = this;
    return (
      e.left.isRed() || e.left.left.isRed() || (e = e.moveRedLeft()),
      (e = e.copy(null, null, null, e.left.removeMin(), null)),
      e.fixUp()
    );
  }
  // Returns new tree, with the specified item removed.
  remove(e, t) {
    let n,
      r2 = this;
    if (t(e, r2.key) < 0)
      r2.left.isEmpty() ||
        r2.left.isRed() ||
        r2.left.left.isRed() ||
        (r2 = r2.moveRedLeft()),
        (r2 = r2.copy(null, null, null, r2.left.remove(e, t), null));
    else {
      if (
        (r2.left.isRed() && (r2 = r2.rotateRight()),
        r2.right.isEmpty() ||
          r2.right.isRed() ||
          r2.right.left.isRed() ||
          (r2 = r2.moveRedRight()),
        0 === t(e, r2.key))
      ) {
        if (r2.right.isEmpty()) return LLRBNode.EMPTY;
        (n = r2.right.min()),
          (r2 = r2.copy(n.key, n.value, null, null, r2.right.removeMin()));
      }
      r2 = r2.copy(null, null, null, null, r2.right.remove(e, t));
    }
    return r2.fixUp();
  }
  isRed() {
    return this.color;
  }
  // Returns new tree after performing any needed rotations.
  fixUp() {
    let e = this;
    return (
      e.right.isRed() && !e.left.isRed() && (e = e.rotateLeft()),
      e.left.isRed() && e.left.left.isRed() && (e = e.rotateRight()),
      e.left.isRed() && e.right.isRed() && (e = e.colorFlip()),
      e
    );
  }
  moveRedLeft() {
    let e = this.colorFlip();
    return (
      e.right.left.isRed() &&
        ((e = e.copy(null, null, null, null, e.right.rotateRight())),
        (e = e.rotateLeft()),
        (e = e.colorFlip())),
      e
    );
  }
  moveRedRight() {
    let e = this.colorFlip();
    return (
      e.left.left.isRed() && ((e = e.rotateRight()), (e = e.colorFlip())), e
    );
  }
  rotateLeft() {
    const e = this.copy(null, null, LLRBNode.RED, null, this.right.left);
    return this.right.copy(null, null, this.color, e, null);
  }
  rotateRight() {
    const e = this.copy(null, null, LLRBNode.RED, this.left.right, null);
    return this.left.copy(null, null, this.color, null, e);
  }
  colorFlip() {
    const e = this.left.copy(null, null, !this.left.color, null, null),
      t = this.right.copy(null, null, !this.right.color, null, null);
    return this.copy(null, null, !this.color, e, t);
  }
  // For testing.
  checkMaxDepth() {
    const e = this.check();
    return Math.pow(2, e) <= this.size + 1;
  }
  // In a balanced RB tree, the black-depth (number of black nodes) from root to
  // leaves is equal on both sides.  This function verifies that or asserts.
  check() {
    if (this.isRed() && this.left.isRed()) throw fail();
    if (this.right.isRed()) throw fail();
    const e = this.left.check();
    if (e !== this.right.check()) throw fail();
    return e + (this.isRed() ? 0 : 1);
  }
}
(LLRBNode.EMPTY = null), (LLRBNode.RED = true), (LLRBNode.BLACK = false);
LLRBNode.EMPTY =
  new // Represents an empty node (a leaf node in the Red-Black Tree).
  (class LLRBEmptyNode {
    constructor() {
      this.size = 0;
    }
    get key() {
      throw fail();
    }
    get value() {
      throw fail();
    }
    get color() {
      throw fail();
    }
    get left() {
      throw fail();
    }
    get right() {
      throw fail();
    }
    // Returns a copy of the current node.
    copy(e, t, n, r2, i) {
      return this;
    }
    // Returns a copy of the tree, with the specified key/value added.
    insert(e, t, n) {
      return new LLRBNode(e, t);
    }
    // Returns a copy of the tree, with the specified key removed.
    remove(e, t) {
      return this;
    }
    isEmpty() {
      return true;
    }
    inorderTraversal(e) {
      return false;
    }
    reverseTraversal(e) {
      return false;
    }
    minKey() {
      return null;
    }
    maxKey() {
      return null;
    }
    isRed() {
      return false;
    }
    // For testing.
    checkMaxDepth() {
      return true;
    }
    check() {
      return 0;
    }
  })();
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class SortedSet {
  constructor(e) {
    (this.comparator = e), (this.data = new SortedMap(this.comparator));
  }
  has(e) {
    return null !== this.data.get(e);
  }
  first() {
    return this.data.minKey();
  }
  last() {
    return this.data.maxKey();
  }
  get size() {
    return this.data.size;
  }
  indexOf(e) {
    return this.data.indexOf(e);
  }
  /** Iterates elements in order defined by "comparator" */
  forEach(e) {
    this.data.inorderTraversal((t, n) => (e(t), false));
  }
  /** Iterates over `elem`s such that: range[0] &lt;= elem &lt; range[1]. */
  forEachInRange(e, t) {
    const n = this.data.getIteratorFrom(e[0]);
    for (; n.hasNext(); ) {
      const r2 = n.getNext();
      if (this.comparator(r2.key, e[1]) >= 0) return;
      t(r2.key);
    }
  }
  /**
   * Iterates over `elem`s such that: start &lt;= elem until false is returned.
   */
  forEachWhile(e, t) {
    let n;
    for (
      n = void 0 !== t ? this.data.getIteratorFrom(t) : this.data.getIterator();
      n.hasNext();

    ) {
      if (!e(n.getNext().key)) return;
    }
  }
  /** Finds the least element greater than or equal to `elem`. */
  firstAfterOrEqual(e) {
    const t = this.data.getIteratorFrom(e);
    return t.hasNext() ? t.getNext().key : null;
  }
  getIterator() {
    return new SortedSetIterator(this.data.getIterator());
  }
  getIteratorFrom(e) {
    return new SortedSetIterator(this.data.getIteratorFrom(e));
  }
  /** Inserts or updates an element */
  add(e) {
    return this.copy(this.data.remove(e).insert(e, true));
  }
  /** Deletes an element */
  delete(e) {
    return this.has(e) ? this.copy(this.data.remove(e)) : this;
  }
  isEmpty() {
    return this.data.isEmpty();
  }
  unionWith(e) {
    let t = this;
    return (
      t.size < e.size && ((t = e), (e = this)),
      e.forEach((e2) => {
        t = t.add(e2);
      }),
      t
    );
  }
  isEqual(e) {
    if (!(e instanceof SortedSet)) return false;
    if (this.size !== e.size) return false;
    const t = this.data.getIterator(),
      n = e.data.getIterator();
    for (; t.hasNext(); ) {
      const e2 = t.getNext().key,
        r2 = n.getNext().key;
      if (0 !== this.comparator(e2, r2)) return false;
    }
    return true;
  }
  toArray() {
    const e = [];
    return (
      this.forEach((t) => {
        e.push(t);
      }),
      e
    );
  }
  toString() {
    const e = [];
    return this.forEach((t) => e.push(t)), "SortedSet(" + e.toString() + ")";
  }
  copy(e) {
    const t = new SortedSet(this.comparator);
    return (t.data = e), t;
  }
}
class SortedSetIterator {
  constructor(e) {
    this.iter = e;
  }
  getNext() {
    return this.iter.getNext().key;
  }
  hasNext() {
    return this.iter.hasNext();
  }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class FieldMask {
  constructor(e) {
    (this.fields = e), // TODO(dimond): validation of FieldMask
      // Sort the field mask to support `FieldMask.isEqual()` and assert below.
      e.sort(FieldPath$1.comparator);
  }
  static empty() {
    return new FieldMask([]);
  }
  /**
   * Returns a new FieldMask object that is the result of adding all the given
   * fields paths to this field mask.
   */
  unionWith(e) {
    let t = new SortedSet(FieldPath$1.comparator);
    for (const e2 of this.fields) t = t.add(e2);
    for (const n of e) t = t.add(n);
    return new FieldMask(t.toArray());
  }
  /**
   * Verifies that `fieldPath` is included by at least one field in this field
   * mask.
   *
   * This is an O(n) operation, where `n` is the size of the field mask.
   */
  covers(e) {
    for (const t of this.fields) if (t.isPrefixOf(e)) return true;
    return false;
  }
  isEqual(e) {
    return __PRIVATE_arrayEquals(this.fields, e.fields, (e2, t) =>
      e2.isEqual(t)
    );
  }
}
/**
 * @license
 * Copyright 2023 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class __PRIVATE_Base64DecodeError extends Error {
  constructor() {
    super(...arguments), (this.name = "Base64DecodeError");
  }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class ByteString {
  constructor(e) {
    this.binaryString = e;
  }
  static fromBase64String(e) {
    const t = (function __PRIVATE_decodeBase64(e2) {
      try {
        return atob(e2);
      } catch (e3) {
        throw "undefined" != typeof DOMException && e3 instanceof DOMException
          ? new __PRIVATE_Base64DecodeError("Invalid base64 string: " + e3)
          : e3;
      }
    })(e);
    return new ByteString(t);
  }
  static fromUint8Array(e) {
    const t =
      /**
       * Helper function to convert an Uint8array to a binary string.
       */
      (function __PRIVATE_binaryStringFromUint8Array(e2) {
        let t2 = "";
        for (let n = 0; n < e2.length; ++n) t2 += String.fromCharCode(e2[n]);
        return t2;
      })(e);
    return new ByteString(t);
  }
  [Symbol.iterator]() {
    let e = 0;
    return {
      next: () =>
        e < this.binaryString.length
          ? {
              value: this.binaryString.charCodeAt(e++),
              done: false,
            }
          : {
              value: void 0,
              done: true,
            },
    };
  }
  toBase64() {
    return (function __PRIVATE_encodeBase64(e) {
      return btoa(e);
    })(this.binaryString);
  }
  toUint8Array() {
    return (function __PRIVATE_uint8ArrayFromBinaryString(e) {
      const t = new Uint8Array(e.length);
      for (let n = 0; n < e.length; n++) t[n] = e.charCodeAt(n);
      return t;
    })(this.binaryString);
  }
  approximateByteSize() {
    return 2 * this.binaryString.length;
  }
  compareTo(e) {
    return __PRIVATE_primitiveComparator(this.binaryString, e.binaryString);
  }
  isEqual(e) {
    return this.binaryString === e.binaryString;
  }
}
ByteString.EMPTY_BYTE_STRING = new ByteString("");
const te = new RegExp(/^\d{4}-\d\d-\d\dT\d\d:\d\d:\d\d(?:\.(\d+))?Z$/);
function __PRIVATE_normalizeTimestamp(e) {
  if ((__PRIVATE_hardAssert(!!e), "string" == typeof e)) {
    let t = 0;
    const n = te.exec(e);
    if ((__PRIVATE_hardAssert(!!n), n[1])) {
      let e2 = n[1];
      (e2 = (e2 + "000000000").substr(0, 9)), (t = Number(e2));
    }
    const r2 = new Date(e);
    return {
      seconds: Math.floor(r2.getTime() / 1e3),
      nanos: t,
    };
  }
  return {
    seconds: __PRIVATE_normalizeNumber(e.seconds),
    nanos: __PRIVATE_normalizeNumber(e.nanos),
  };
}
function __PRIVATE_normalizeNumber(e) {
  return "number" == typeof e ? e : "string" == typeof e ? Number(e) : 0;
}
function __PRIVATE_normalizeByteString(e) {
  return "string" == typeof e
    ? ByteString.fromBase64String(e)
    : ByteString.fromUint8Array(e);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function __PRIVATE_isServerTimestamp(e) {
  var t, n;
  return (
    "server_timestamp" ===
    (null ===
      (n = (
        (null === (t = null == e ? void 0 : e.mapValue) || void 0 === t
          ? void 0
          : t.fields) || {}
      ).__type__) || void 0 === n
      ? void 0
      : n.stringValue)
  );
}
function __PRIVATE_getPreviousValue(e) {
  const t = e.mapValue.fields.__previous_value__;
  return __PRIVATE_isServerTimestamp(t) ? __PRIVATE_getPreviousValue(t) : t;
}
function __PRIVATE_getLocalWriteTime(e) {
  const t = __PRIVATE_normalizeTimestamp(
    e.mapValue.fields.__local_write_time__.timestampValue
  );
  return new Timestamp(t.seconds, t.nanos);
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class DatabaseInfo {
  /**
   * Constructs a DatabaseInfo using the provided host, databaseId and
   * persistenceKey.
   *
   * @param databaseId - The database to use.
   * @param appId - The Firebase App Id.
   * @param persistenceKey - A unique identifier for this Firestore's local
   * storage (used in conjunction with the databaseId).
   * @param host - The Firestore backend host to connect to.
   * @param ssl - Whether to use SSL when connecting.
   * @param forceLongPolling - Whether to use the forceLongPolling option
   * when using WebChannel as the network transport.
   * @param autoDetectLongPolling - Whether to use the detectBufferingProxy
   * option when using WebChannel as the network transport.
   * @param longPollingOptions Options that configure long-polling.
   * @param useFetchStreams Whether to use the Fetch API instead of
   * XMLHTTPRequest
   */
  constructor(e, t, n, r2, i, s, o, _, a) {
    (this.databaseId = e),
      (this.appId = t),
      (this.persistenceKey = n),
      (this.host = r2),
      (this.ssl = i),
      (this.forceLongPolling = s),
      (this.autoDetectLongPolling = o),
      (this.longPollingOptions = _),
      (this.useFetchStreams = a);
  }
}
class DatabaseId {
  constructor(e, t) {
    (this.projectId = e), (this.database = t || "(default)");
  }
  static empty() {
    return new DatabaseId("", "");
  }
  get isDefaultDatabase() {
    return "(default)" === this.database;
  }
  isEqual(e) {
    return (
      e instanceof DatabaseId &&
      e.projectId === this.projectId &&
      e.database === this.database
    );
  }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const ne = {
  mapValue: {
    fields: {
      __type__: {
        stringValue: "__max__",
      },
    },
  },
};
function __PRIVATE_typeOrder(e) {
  return "nullValue" in e
    ? 0
    : "booleanValue" in e
    ? 1
    : "integerValue" in e || "doubleValue" in e
    ? 2
    : "timestampValue" in e
    ? 3
    : "stringValue" in e
    ? 5
    : "bytesValue" in e
    ? 6
    : "referenceValue" in e
    ? 7
    : "geoPointValue" in e
    ? 8
    : "arrayValue" in e
    ? 9
    : "mapValue" in e
    ? __PRIVATE_isServerTimestamp(e)
      ? 4
      : __PRIVATE_isMaxValue(e)
      ? 9007199254740991
      : 10
    : fail();
}
function __PRIVATE_valueEquals(e, t) {
  if (e === t) return true;
  const n = __PRIVATE_typeOrder(e);
  if (n !== __PRIVATE_typeOrder(t)) return false;
  switch (n) {
    case 0:
    case 9007199254740991:
      return true;
    case 1:
      return e.booleanValue === t.booleanValue;
    case 4:
      return __PRIVATE_getLocalWriteTime(e).isEqual(
        __PRIVATE_getLocalWriteTime(t)
      );
    case 3:
      return (function __PRIVATE_timestampEquals(e2, t2) {
        if (
          "string" == typeof e2.timestampValue &&
          "string" == typeof t2.timestampValue &&
          e2.timestampValue.length === t2.timestampValue.length
        )
          return e2.timestampValue === t2.timestampValue;
        const n2 = __PRIVATE_normalizeTimestamp(e2.timestampValue),
          r2 = __PRIVATE_normalizeTimestamp(t2.timestampValue);
        return n2.seconds === r2.seconds && n2.nanos === r2.nanos;
      })(e, t);
    case 5:
      return e.stringValue === t.stringValue;
    case 6:
      return (function __PRIVATE_blobEquals(e2, t2) {
        return __PRIVATE_normalizeByteString(e2.bytesValue).isEqual(
          __PRIVATE_normalizeByteString(t2.bytesValue)
        );
      })(e, t);
    case 7:
      return e.referenceValue === t.referenceValue;
    case 8:
      return (function __PRIVATE_geoPointEquals(e2, t2) {
        return (
          __PRIVATE_normalizeNumber(e2.geoPointValue.latitude) ===
            __PRIVATE_normalizeNumber(t2.geoPointValue.latitude) &&
          __PRIVATE_normalizeNumber(e2.geoPointValue.longitude) ===
            __PRIVATE_normalizeNumber(t2.geoPointValue.longitude)
        );
      })(e, t);
    case 2:
      return (function __PRIVATE_numberEquals(e2, t2) {
        if ("integerValue" in e2 && "integerValue" in t2)
          return (
            __PRIVATE_normalizeNumber(e2.integerValue) ===
            __PRIVATE_normalizeNumber(t2.integerValue)
          );
        if ("doubleValue" in e2 && "doubleValue" in t2) {
          const n2 = __PRIVATE_normalizeNumber(e2.doubleValue),
            r2 = __PRIVATE_normalizeNumber(t2.doubleValue);
          return n2 === r2
            ? __PRIVATE_isNegativeZero(n2) === __PRIVATE_isNegativeZero(r2)
            : isNaN(n2) && isNaN(r2);
        }
        return false;
      })(e, t);
    case 9:
      return __PRIVATE_arrayEquals(
        e.arrayValue.values || [],
        t.arrayValue.values || [],
        __PRIVATE_valueEquals
      );
    case 10:
      return (function __PRIVATE_objectEquals(e2, t2) {
        const n2 = e2.mapValue.fields || {},
          r2 = t2.mapValue.fields || {};
        if (__PRIVATE_objectSize(n2) !== __PRIVATE_objectSize(r2)) return false;
        for (const e3 in n2)
          if (
            n2.hasOwnProperty(e3) &&
            (void 0 === r2[e3] || !__PRIVATE_valueEquals(n2[e3], r2[e3]))
          )
            return false;
        return true;
      })(e, t);
    default:
      return fail();
  }
}
function __PRIVATE_arrayValueContains(e, t) {
  return void 0 !== (e.values || []).find((e2) => __PRIVATE_valueEquals(e2, t));
}
function __PRIVATE_valueCompare(e, t) {
  if (e === t) return 0;
  const n = __PRIVATE_typeOrder(e),
    r2 = __PRIVATE_typeOrder(t);
  if (n !== r2) return __PRIVATE_primitiveComparator(n, r2);
  switch (n) {
    case 0:
    case 9007199254740991:
      return 0;
    case 1:
      return __PRIVATE_primitiveComparator(e.booleanValue, t.booleanValue);
    case 2:
      return (function __PRIVATE_compareNumbers(e2, t2) {
        const n2 = __PRIVATE_normalizeNumber(e2.integerValue || e2.doubleValue),
          r3 = __PRIVATE_normalizeNumber(t2.integerValue || t2.doubleValue);
        return n2 < r3
          ? -1
          : n2 > r3
          ? 1
          : n2 === r3
          ? 0
          : // one or both are NaN.
          isNaN(n2)
          ? isNaN(r3)
            ? 0
            : -1
          : 1;
      })(e, t);
    case 3:
      return __PRIVATE_compareTimestamps(e.timestampValue, t.timestampValue);
    case 4:
      return __PRIVATE_compareTimestamps(
        __PRIVATE_getLocalWriteTime(e),
        __PRIVATE_getLocalWriteTime(t)
      );
    case 5:
      return __PRIVATE_primitiveComparator(e.stringValue, t.stringValue);
    case 6:
      return (function __PRIVATE_compareBlobs(e2, t2) {
        const n2 = __PRIVATE_normalizeByteString(e2),
          r3 = __PRIVATE_normalizeByteString(t2);
        return n2.compareTo(r3);
      })(e.bytesValue, t.bytesValue);
    case 7:
      return (function __PRIVATE_compareReferences(e2, t2) {
        const n2 = e2.split("/"),
          r3 = t2.split("/");
        for (let e3 = 0; e3 < n2.length && e3 < r3.length; e3++) {
          const t3 = __PRIVATE_primitiveComparator(n2[e3], r3[e3]);
          if (0 !== t3) return t3;
        }
        return __PRIVATE_primitiveComparator(n2.length, r3.length);
      })(e.referenceValue, t.referenceValue);
    case 8:
      return (function __PRIVATE_compareGeoPoints(e2, t2) {
        const n2 = __PRIVATE_primitiveComparator(
          __PRIVATE_normalizeNumber(e2.latitude),
          __PRIVATE_normalizeNumber(t2.latitude)
        );
        if (0 !== n2) return n2;
        return __PRIVATE_primitiveComparator(
          __PRIVATE_normalizeNumber(e2.longitude),
          __PRIVATE_normalizeNumber(t2.longitude)
        );
      })(e.geoPointValue, t.geoPointValue);
    case 9:
      return (function __PRIVATE_compareArrays(e2, t2) {
        const n2 = e2.values || [],
          r3 = t2.values || [];
        for (let e3 = 0; e3 < n2.length && e3 < r3.length; ++e3) {
          const t3 = __PRIVATE_valueCompare(n2[e3], r3[e3]);
          if (t3) return t3;
        }
        return __PRIVATE_primitiveComparator(n2.length, r3.length);
      })(e.arrayValue, t.arrayValue);
    case 10:
      return (function __PRIVATE_compareMaps(e2, t2) {
        if (e2 === ne.mapValue && t2 === ne.mapValue) return 0;
        if (e2 === ne.mapValue) return 1;
        if (t2 === ne.mapValue) return -1;
        const n2 = e2.fields || {},
          r3 = Object.keys(n2),
          i = t2.fields || {},
          s = Object.keys(i);
        r3.sort(), s.sort();
        for (let e3 = 0; e3 < r3.length && e3 < s.length; ++e3) {
          const t3 = __PRIVATE_primitiveComparator(r3[e3], s[e3]);
          if (0 !== t3) return t3;
          const o = __PRIVATE_valueCompare(n2[r3[e3]], i[s[e3]]);
          if (0 !== o) return o;
        }
        return __PRIVATE_primitiveComparator(r3.length, s.length);
      })(e.mapValue, t.mapValue);
    default:
      throw fail();
  }
}
function __PRIVATE_compareTimestamps(e, t) {
  if ("string" == typeof e && "string" == typeof t && e.length === t.length)
    return __PRIVATE_primitiveComparator(e, t);
  const n = __PRIVATE_normalizeTimestamp(e),
    r2 = __PRIVATE_normalizeTimestamp(t),
    i = __PRIVATE_primitiveComparator(n.seconds, r2.seconds);
  return 0 !== i ? i : __PRIVATE_primitiveComparator(n.nanos, r2.nanos);
}
function canonicalId(e) {
  return __PRIVATE_canonifyValue(e);
}
function __PRIVATE_canonifyValue(e) {
  return "nullValue" in e
    ? "null"
    : "booleanValue" in e
    ? "" + e.booleanValue
    : "integerValue" in e
    ? "" + e.integerValue
    : "doubleValue" in e
    ? "" + e.doubleValue
    : "timestampValue" in e
    ? (function __PRIVATE_canonifyTimestamp(e2) {
        const t = __PRIVATE_normalizeTimestamp(e2);
        return `time(${t.seconds},${t.nanos})`;
      })(e.timestampValue)
    : "stringValue" in e
    ? e.stringValue
    : "bytesValue" in e
    ? (function __PRIVATE_canonifyByteString(e2) {
        return __PRIVATE_normalizeByteString(e2).toBase64();
      })(e.bytesValue)
    : "referenceValue" in e
    ? (function __PRIVATE_canonifyReference(e2) {
        return DocumentKey.fromName(e2).toString();
      })(e.referenceValue)
    : "geoPointValue" in e
    ? (function __PRIVATE_canonifyGeoPoint(e2) {
        return `geo(${e2.latitude},${e2.longitude})`;
      })(e.geoPointValue)
    : "arrayValue" in e
    ? (function __PRIVATE_canonifyArray(e2) {
        let t = "[",
          n = true;
        for (const r2 of e2.values || [])
          n ? (n = false) : (t += ","), (t += __PRIVATE_canonifyValue(r2));
        return t + "]";
      })(e.arrayValue)
    : "mapValue" in e
    ? (function __PRIVATE_canonifyMap(e2) {
        const t = Object.keys(e2.fields || {}).sort();
        let n = "{",
          r2 = true;
        for (const i of t)
          r2 ? (r2 = false) : (n += ","),
            (n += `${i}:${__PRIVATE_canonifyValue(e2.fields[i])}`);
        return n + "}";
      })(e.mapValue)
    : fail();
}
function __PRIVATE_refValue(e, t) {
  return {
    referenceValue: `projects/${e.projectId}/databases/${
      e.database
    }/documents/${t.path.canonicalString()}`,
  };
}
function isInteger(e) {
  return !!e && "integerValue" in e;
}
function isArray(e) {
  return !!e && "arrayValue" in e;
}
function __PRIVATE_isNullValue(e) {
  return !!e && "nullValue" in e;
}
function __PRIVATE_isNanValue(e) {
  return !!e && "doubleValue" in e && isNaN(Number(e.doubleValue));
}
function __PRIVATE_isMapValue(e) {
  return !!e && "mapValue" in e;
}
function __PRIVATE_deepClone(e) {
  if (e.geoPointValue)
    return {
      geoPointValue: Object.assign({}, e.geoPointValue),
    };
  if (e.timestampValue && "object" == typeof e.timestampValue)
    return {
      timestampValue: Object.assign({}, e.timestampValue),
    };
  if (e.mapValue) {
    const t = {
      mapValue: {
        fields: {},
      },
    };
    return (
      forEach$1(
        e.mapValue.fields,
        (e2, n) => (t.mapValue.fields[e2] = __PRIVATE_deepClone(n))
      ),
      t
    );
  }
  if (e.arrayValue) {
    const t = {
      arrayValue: {
        values: [],
      },
    };
    for (let n = 0; n < (e.arrayValue.values || []).length; ++n)
      t.arrayValue.values[n] = __PRIVATE_deepClone(e.arrayValue.values[n]);
    return t;
  }
  return Object.assign({}, e);
}
function __PRIVATE_isMaxValue(e) {
  return (
    "__max__" === (((e.mapValue || {}).fields || {}).__type__ || {}).stringValue
  );
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class ObjectValue {
  constructor(e) {
    this.value = e;
  }
  static empty() {
    return new ObjectValue({
      mapValue: {},
    });
  }
  /**
   * Returns the value at the given path or null.
   *
   * @param path - the path to search
   * @returns The value at the path or null if the path is not set.
   */
  field(e) {
    if (e.isEmpty()) return this.value;
    {
      let t = this.value;
      for (let n = 0; n < e.length - 1; ++n)
        if (
          ((t = (t.mapValue.fields || {})[e.get(n)]), !__PRIVATE_isMapValue(t))
        )
          return null;
      return (t = (t.mapValue.fields || {})[e.lastSegment()]), t || null;
    }
  }
  /**
   * Sets the field to the provided value.
   *
   * @param path - The field path to set.
   * @param value - The value to set.
   */
  set(e, t) {
    this.getFieldsMap(e.popLast())[e.lastSegment()] = __PRIVATE_deepClone(t);
  }
  /**
   * Sets the provided fields to the provided values.
   *
   * @param data - A map of fields to values (or null for deletes).
   */
  setAll(e) {
    let t = FieldPath$1.emptyPath(),
      n = {},
      r2 = [];
    e.forEach((e2, i2) => {
      if (!t.isImmediateParentOf(i2)) {
        const e3 = this.getFieldsMap(t);
        this.applyChanges(e3, n, r2), (n = {}), (r2 = []), (t = i2.popLast());
      }
      e2
        ? (n[i2.lastSegment()] = __PRIVATE_deepClone(e2))
        : r2.push(i2.lastSegment());
    });
    const i = this.getFieldsMap(t);
    this.applyChanges(i, n, r2);
  }
  /**
   * Removes the field at the specified path. If there is no field at the
   * specified path, nothing is changed.
   *
   * @param path - The field path to remove.
   */
  delete(e) {
    const t = this.field(e.popLast());
    __PRIVATE_isMapValue(t) &&
      t.mapValue.fields &&
      delete t.mapValue.fields[e.lastSegment()];
  }
  isEqual(e) {
    return __PRIVATE_valueEquals(this.value, e.value);
  }
  /**
   * Returns the map that contains the leaf element of `path`. If the parent
   * entry does not yet exist, or if it is not a map, a new map will be created.
   */
  getFieldsMap(e) {
    let t = this.value;
    t.mapValue.fields ||
      (t.mapValue = {
        fields: {},
      });
    for (let n = 0; n < e.length; ++n) {
      let r2 = t.mapValue.fields[e.get(n)];
      (__PRIVATE_isMapValue(r2) && r2.mapValue.fields) ||
        ((r2 = {
          mapValue: {
            fields: {},
          },
        }),
        (t.mapValue.fields[e.get(n)] = r2)),
        (t = r2);
    }
    return t.mapValue.fields;
  }
  /**
   * Modifies `fieldsMap` by adding, replacing or deleting the specified
   * entries.
   */
  applyChanges(e, t, n) {
    forEach$1(t, (t2, n2) => (e[t2] = n2));
    for (const t2 of n) delete e[t2];
  }
  clone() {
    return new ObjectValue(__PRIVATE_deepClone(this.value));
  }
}
function __PRIVATE_extractFieldMask(e) {
  const t = [];
  return (
    forEach$1(e.fields, (e2, n) => {
      const r2 = new FieldPath$1([e2]);
      if (__PRIVATE_isMapValue(n)) {
        const e3 = __PRIVATE_extractFieldMask(n.mapValue).fields;
        if (0 === e3.length) t.push(r2);
        else for (const n2 of e3) t.push(r2.child(n2));
      } else t.push(r2);
    }),
    new FieldMask(t)
  );
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class MutableDocument {
  constructor(e, t, n, r2, i, s, o) {
    (this.key = e),
      (this.documentType = t),
      (this.version = n),
      (this.readTime = r2),
      (this.createTime = i),
      (this.data = s),
      (this.documentState = o);
  }
  /**
   * Creates a document with no known version or data, but which can serve as
   * base document for mutations.
   */
  static newInvalidDocument(e) {
    return new MutableDocument(
      e,
      0,
      /* version */
      SnapshotVersion.min(),
      /* readTime */
      SnapshotVersion.min(),
      /* createTime */
      SnapshotVersion.min(),
      ObjectValue.empty(),
      0
      /* DocumentState.SYNCED */
    );
  }
  /**
   * Creates a new document that is known to exist with the given data at the
   * given version.
   */
  static newFoundDocument(e, t, n, r2) {
    return new MutableDocument(
      e,
      1,
      /* version */
      t,
      /* readTime */
      SnapshotVersion.min(),
      /* createTime */
      n,
      r2,
      0
      /* DocumentState.SYNCED */
    );
  }
  /** Creates a new document that is known to not exist at the given version. */
  static newNoDocument(e, t) {
    return new MutableDocument(
      e,
      2,
      /* version */
      t,
      /* readTime */
      SnapshotVersion.min(),
      /* createTime */
      SnapshotVersion.min(),
      ObjectValue.empty(),
      0
      /* DocumentState.SYNCED */
    );
  }
  /**
   * Creates a new document that is known to exist at the given version but
   * whose data is not known (e.g. a document that was updated without a known
   * base document).
   */
  static newUnknownDocument(e, t) {
    return new MutableDocument(
      e,
      3,
      /* version */
      t,
      /* readTime */
      SnapshotVersion.min(),
      /* createTime */
      SnapshotVersion.min(),
      ObjectValue.empty(),
      2
      /* DocumentState.HAS_COMMITTED_MUTATIONS */
    );
  }
  /**
   * Changes the document type to indicate that it exists and that its version
   * and data are known.
   */
  convertToFoundDocument(e, t) {
    return (
      !this.createTime.isEqual(SnapshotVersion.min()) ||
        (2 !== this.documentType && 0 !== this.documentType) ||
        (this.createTime = e),
      (this.version = e),
      (this.documentType = 1),
      (this.data = t),
      (this.documentState = 0),
      this
    );
  }
  /**
   * Changes the document type to indicate that it doesn't exist at the given
   * version.
   */
  convertToNoDocument(e) {
    return (
      (this.version = e),
      (this.documentType = 2),
      (this.data = ObjectValue.empty()),
      (this.documentState = 0),
      this
    );
  }
  /**
   * Changes the document type to indicate that it exists at a given version but
   * that its data is not known (e.g. a document that was updated without a known
   * base document).
   */
  convertToUnknownDocument(e) {
    return (
      (this.version = e),
      (this.documentType = 3),
      (this.data = ObjectValue.empty()),
      (this.documentState = 2),
      this
    );
  }
  setHasCommittedMutations() {
    return (this.documentState = 2), this;
  }
  setHasLocalMutations() {
    return (
      (this.documentState = 1), (this.version = SnapshotVersion.min()), this
    );
  }
  setReadTime(e) {
    return (this.readTime = e), this;
  }
  get hasLocalMutations() {
    return 1 === this.documentState;
  }
  get hasCommittedMutations() {
    return 2 === this.documentState;
  }
  get hasPendingWrites() {
    return this.hasLocalMutations || this.hasCommittedMutations;
  }
  isValidDocument() {
    return 0 !== this.documentType;
  }
  isFoundDocument() {
    return 1 === this.documentType;
  }
  isNoDocument() {
    return 2 === this.documentType;
  }
  isUnknownDocument() {
    return 3 === this.documentType;
  }
  isEqual(e) {
    return (
      e instanceof MutableDocument &&
      this.key.isEqual(e.key) &&
      this.version.isEqual(e.version) &&
      this.documentType === e.documentType &&
      this.documentState === e.documentState &&
      this.data.isEqual(e.data)
    );
  }
  mutableCopy() {
    return new MutableDocument(
      this.key,
      this.documentType,
      this.version,
      this.readTime,
      this.createTime,
      this.data.clone(),
      this.documentState
    );
  }
  toString() {
    return `Document(${this.key}, ${this.version}, ${JSON.stringify(
      this.data.value
    )}, {createTime: ${this.createTime}}), {documentType: ${
      this.documentType
    }}), {documentState: ${this.documentState}})`;
  }
}
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class Bound {
  constructor(e, t) {
    (this.position = e), (this.inclusive = t);
  }
}
function __PRIVATE_boundCompareToDocument(e, t, n) {
  let r2 = 0;
  for (let i = 0; i < e.position.length; i++) {
    const s = t[i],
      o = e.position[i];
    if (s.field.isKeyField())
      r2 = DocumentKey.comparator(
        DocumentKey.fromName(o.referenceValue),
        n.key
      );
    else {
      r2 = __PRIVATE_valueCompare(o, n.data.field(s.field));
    }
    if (("desc" === s.dir && (r2 *= -1), 0 !== r2)) break;
  }
  return r2;
}
function __PRIVATE_boundEquals(e, t) {
  if (null === e) return null === t;
  if (null === t) return false;
  if (e.inclusive !== t.inclusive || e.position.length !== t.position.length)
    return false;
  for (let n = 0; n < e.position.length; n++) {
    if (!__PRIVATE_valueEquals(e.position[n], t.position[n])) return false;
  }
  return true;
}
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class OrderBy {
  constructor(e, t = "asc") {
    (this.field = e), (this.dir = t);
  }
}
function __PRIVATE_orderByEquals(e, t) {
  return e.dir === t.dir && e.field.isEqual(t.field);
}
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class Filter {}
class FieldFilter extends Filter {
  constructor(e, t, n) {
    super(), (this.field = e), (this.op = t), (this.value = n);
  }
  /**
   * Creates a filter based on the provided arguments.
   */
  static create(e, t, n) {
    return e.isKeyField()
      ? "in" === t || "not-in" === t
        ? this.createKeyFieldInFilter(e, t, n)
        : new __PRIVATE_KeyFieldFilter(e, t, n)
      : "array-contains" === t
      ? new __PRIVATE_ArrayContainsFilter(e, n)
      : "in" === t
      ? new __PRIVATE_InFilter(e, n)
      : "not-in" === t
      ? new __PRIVATE_NotInFilter(e, n)
      : "array-contains-any" === t
      ? new __PRIVATE_ArrayContainsAnyFilter(e, n)
      : new FieldFilter(e, t, n);
  }
  static createKeyFieldInFilter(e, t, n) {
    return "in" === t
      ? new __PRIVATE_KeyFieldInFilter(e, n)
      : new __PRIVATE_KeyFieldNotInFilter(e, n);
  }
  matches(e) {
    const t = e.data.field(this.field);
    return "!=" === this.op
      ? null !== t &&
          this.matchesComparison(__PRIVATE_valueCompare(t, this.value))
      : null !== t &&
          __PRIVATE_typeOrder(this.value) === __PRIVATE_typeOrder(t) &&
          this.matchesComparison(__PRIVATE_valueCompare(t, this.value));
  }
  matchesComparison(e) {
    switch (this.op) {
      case "<":
        return e < 0;
      case "<=":
        return e <= 0;
      case "==":
        return 0 === e;
      case "!=":
        return 0 !== e;
      case ">":
        return e > 0;
      case ">=":
        return e >= 0;
      default:
        return fail();
    }
  }
  isInequality() {
    return (
      [
        "<",
        "<=",
        ">",
        ">=",
        "!=",
        "not-in",
        /* Operator.NOT_IN */
      ].indexOf(this.op) >= 0
    );
  }
  getFlattenedFilters() {
    return [this];
  }
  getFilters() {
    return [this];
  }
}
class CompositeFilter extends Filter {
  constructor(e, t) {
    super(), (this.filters = e), (this.op = t), (this.ue = null);
  }
  /**
   * Creates a filter based on the provided arguments.
   */
  static create(e, t) {
    return new CompositeFilter(e, t);
  }
  matches(e) {
    return __PRIVATE_compositeFilterIsConjunction(this)
      ? void 0 === this.filters.find((t) => !t.matches(e))
      : void 0 !== this.filters.find((t) => t.matches(e));
  }
  getFlattenedFilters() {
    return (
      null !== this.ue ||
        (this.ue = this.filters.reduce(
          (e, t) => e.concat(t.getFlattenedFilters()),
          []
        )),
      this.ue
    );
  }
  // Returns a mutable copy of `this.filters`
  getFilters() {
    return Object.assign([], this.filters);
  }
}
function __PRIVATE_compositeFilterIsConjunction(e) {
  return "and" === e.op;
}
function __PRIVATE_compositeFilterIsFlatConjunction(e) {
  return (
    __PRIVATE_compositeFilterIsFlat(e) &&
    __PRIVATE_compositeFilterIsConjunction(e)
  );
}
function __PRIVATE_compositeFilterIsFlat(e) {
  for (const t of e.filters) if (t instanceof CompositeFilter) return false;
  return true;
}
function __PRIVATE_canonifyFilter(e) {
  if (e instanceof FieldFilter)
    return e.field.canonicalString() + e.op.toString() + canonicalId(e.value);
  if (__PRIVATE_compositeFilterIsFlatConjunction(e))
    return e.filters.map((e2) => __PRIVATE_canonifyFilter(e2)).join(",");
  {
    const t = e.filters.map((e2) => __PRIVATE_canonifyFilter(e2)).join(",");
    return `${e.op}(${t})`;
  }
}
function __PRIVATE_filterEquals(e, t) {
  return e instanceof FieldFilter
    ? (function __PRIVATE_fieldFilterEquals(e2, t2) {
        return (
          t2 instanceof FieldFilter &&
          e2.op === t2.op &&
          e2.field.isEqual(t2.field) &&
          __PRIVATE_valueEquals(e2.value, t2.value)
        );
      })(e, t)
    : e instanceof CompositeFilter
    ? (function __PRIVATE_compositeFilterEquals(e2, t2) {
        if (
          t2 instanceof CompositeFilter &&
          e2.op === t2.op &&
          e2.filters.length === t2.filters.length
        ) {
          return e2.filters.reduce(
            (e3, n, r2) => e3 && __PRIVATE_filterEquals(n, t2.filters[r2]),
            true
          );
        }
        return false;
      })(e, t)
    : void fail();
}
function __PRIVATE_stringifyFilter(e) {
  return e instanceof FieldFilter
    ? (function __PRIVATE_stringifyFieldFilter(e2) {
        return `${e2.field.canonicalString()} ${e2.op} ${canonicalId(
          e2.value
        )}`;
      })(e)
    : e instanceof CompositeFilter
    ? (function __PRIVATE_stringifyCompositeFilter(e2) {
        return (
          e2.op.toString() +
          " {" +
          e2.getFilters().map(__PRIVATE_stringifyFilter).join(" ,") +
          "}"
        );
      })(e)
    : "Filter";
}
class __PRIVATE_KeyFieldFilter extends FieldFilter {
  constructor(e, t, n) {
    super(e, t, n), (this.key = DocumentKey.fromName(n.referenceValue));
  }
  matches(e) {
    const t = DocumentKey.comparator(e.key, this.key);
    return this.matchesComparison(t);
  }
}
class __PRIVATE_KeyFieldInFilter extends FieldFilter {
  constructor(e, t) {
    super(e, "in", t),
      (this.keys = __PRIVATE_extractDocumentKeysFromArrayValue("in", t));
  }
  matches(e) {
    return this.keys.some((t) => t.isEqual(e.key));
  }
}
class __PRIVATE_KeyFieldNotInFilter extends FieldFilter {
  constructor(e, t) {
    super(e, "not-in", t),
      (this.keys = __PRIVATE_extractDocumentKeysFromArrayValue("not-in", t));
  }
  matches(e) {
    return !this.keys.some((t) => t.isEqual(e.key));
  }
}
function __PRIVATE_extractDocumentKeysFromArrayValue(e, t) {
  var n;
  return (
    (null === (n = t.arrayValue) || void 0 === n ? void 0 : n.values) || []
  ).map((e2) => DocumentKey.fromName(e2.referenceValue));
}
class __PRIVATE_ArrayContainsFilter extends FieldFilter {
  constructor(e, t) {
    super(e, "array-contains", t);
  }
  matches(e) {
    const t = e.data.field(this.field);
    return isArray(t) && __PRIVATE_arrayValueContains(t.arrayValue, this.value);
  }
}
class __PRIVATE_InFilter extends FieldFilter {
  constructor(e, t) {
    super(e, "in", t);
  }
  matches(e) {
    const t = e.data.field(this.field);
    return null !== t && __PRIVATE_arrayValueContains(this.value.arrayValue, t);
  }
}
class __PRIVATE_NotInFilter extends FieldFilter {
  constructor(e, t) {
    super(e, "not-in", t);
  }
  matches(e) {
    if (
      __PRIVATE_arrayValueContains(this.value.arrayValue, {
        nullValue: "NULL_VALUE",
      })
    )
      return false;
    const t = e.data.field(this.field);
    return (
      null !== t && !__PRIVATE_arrayValueContains(this.value.arrayValue, t)
    );
  }
}
class __PRIVATE_ArrayContainsAnyFilter extends FieldFilter {
  constructor(e, t) {
    super(e, "array-contains-any", t);
  }
  matches(e) {
    const t = e.data.field(this.field);
    return (
      !(!isArray(t) || !t.arrayValue.values) &&
      t.arrayValue.values.some((e2) =>
        __PRIVATE_arrayValueContains(this.value.arrayValue, e2)
      )
    );
  }
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class __PRIVATE_TargetImpl {
  constructor(e, t = null, n = [], r2 = [], i = null, s = null, o = null) {
    (this.path = e),
      (this.collectionGroup = t),
      (this.orderBy = n),
      (this.filters = r2),
      (this.limit = i),
      (this.startAt = s),
      (this.endAt = o),
      (this.ce = null);
  }
}
function __PRIVATE_newTarget(
  e,
  t = null,
  n = [],
  r2 = [],
  i = null,
  s = null,
  o = null
) {
  return new __PRIVATE_TargetImpl(e, t, n, r2, i, s, o);
}
function __PRIVATE_canonifyTarget(e) {
  const t = __PRIVATE_debugCast(e);
  if (null === t.ce) {
    let e2 = t.path.canonicalString();
    null !== t.collectionGroup && (e2 += "|cg:" + t.collectionGroup),
      (e2 += "|f:"),
      (e2 += t.filters.map((e3) => __PRIVATE_canonifyFilter(e3)).join(",")),
      (e2 += "|ob:"),
      (e2 += t.orderBy
        .map((e3) =>
          (function __PRIVATE_canonifyOrderBy(e4) {
            return e4.field.canonicalString() + e4.dir;
          })(e3)
        )
        .join(",")),
      __PRIVATE_isNullOrUndefined(t.limit) || ((e2 += "|l:"), (e2 += t.limit)),
      t.startAt &&
        ((e2 += "|lb:"),
        (e2 += t.startAt.inclusive ? "b:" : "a:"),
        (e2 += t.startAt.position.map((e3) => canonicalId(e3)).join(","))),
      t.endAt &&
        ((e2 += "|ub:"),
        (e2 += t.endAt.inclusive ? "a:" : "b:"),
        (e2 += t.endAt.position.map((e3) => canonicalId(e3)).join(","))),
      (t.ce = e2);
  }
  return t.ce;
}
function __PRIVATE_targetEquals(e, t) {
  if (e.limit !== t.limit) return false;
  if (e.orderBy.length !== t.orderBy.length) return false;
  for (let n = 0; n < e.orderBy.length; n++)
    if (!__PRIVATE_orderByEquals(e.orderBy[n], t.orderBy[n])) return false;
  if (e.filters.length !== t.filters.length) return false;
  for (let n = 0; n < e.filters.length; n++)
    if (!__PRIVATE_filterEquals(e.filters[n], t.filters[n])) return false;
  return (
    e.collectionGroup === t.collectionGroup &&
    !!e.path.isEqual(t.path) &&
    !!__PRIVATE_boundEquals(e.startAt, t.startAt) &&
    __PRIVATE_boundEquals(e.endAt, t.endAt)
  );
}
function __PRIVATE_targetIsDocumentTarget(e) {
  return (
    DocumentKey.isDocumentKey(e.path) &&
    null === e.collectionGroup &&
    0 === e.filters.length
  );
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class __PRIVATE_QueryImpl {
  /**
   * Initializes a Query with a path and optional additional query constraints.
   * Path must currently be empty if this is a collection group query.
   */
  constructor(
    e,
    t = null,
    n = [],
    r2 = [],
    i = null,
    s = "F",
    o = null,
    _ = null
  ) {
    (this.path = e),
      (this.collectionGroup = t),
      (this.explicitOrderBy = n),
      (this.filters = r2),
      (this.limit = i),
      (this.limitType = s),
      (this.startAt = o),
      (this.endAt = _),
      (this.le = null), // The corresponding `Target` of this `Query` instance, for use with
      // non-aggregate queries.
      (this.he = null), // The corresponding `Target` of this `Query` instance, for use with
      // aggregate queries. Unlike targets for non-aggregate queries,
      // aggregate query targets do not contain normalized order-bys, they only
      // contain explicit order-bys.
      (this.Pe = null),
      this.startAt,
      this.endAt;
  }
}
function __PRIVATE_newQuery(e, t, n, r2, i, s, o, _) {
  return new __PRIVATE_QueryImpl(e, t, n, r2, i, s, o, _);
}
function __PRIVATE_newQueryForPath(e) {
  return new __PRIVATE_QueryImpl(e);
}
function __PRIVATE_queryMatchesAllDocuments(e) {
  return (
    0 === e.filters.length &&
    null === e.limit &&
    null == e.startAt &&
    null == e.endAt &&
    (0 === e.explicitOrderBy.length ||
      (1 === e.explicitOrderBy.length &&
        e.explicitOrderBy[0].field.isKeyField()))
  );
}
function __PRIVATE_isCollectionGroupQuery(e) {
  return null !== e.collectionGroup;
}
function __PRIVATE_queryNormalizedOrderBy(e) {
  const t = __PRIVATE_debugCast(e);
  if (null === t.le) {
    t.le = [];
    const e2 = /* @__PURE__ */ new Set();
    for (const n2 of t.explicitOrderBy)
      t.le.push(n2), e2.add(n2.field.canonicalString());
    const n =
        t.explicitOrderBy.length > 0
          ? t.explicitOrderBy[t.explicitOrderBy.length - 1].dir
          : "asc",
      r2 = (function __PRIVATE_getInequalityFilterFields(e3) {
        let t2 = new SortedSet(FieldPath$1.comparator);
        return (
          e3.filters.forEach((e4) => {
            e4.getFlattenedFilters().forEach((e5) => {
              e5.isInequality() && (t2 = t2.add(e5.field));
            });
          }),
          t2
        );
      })(t);
    r2.forEach((r3) => {
      e2.has(r3.canonicalString()) ||
        r3.isKeyField() ||
        t.le.push(new OrderBy(r3, n));
    }), // Add the document key field to the last if it is not explicitly ordered.
      e2.has(FieldPath$1.keyField().canonicalString()) ||
        t.le.push(new OrderBy(FieldPath$1.keyField(), n));
  }
  return t.le;
}
function __PRIVATE_queryToTarget(e) {
  const t = __PRIVATE_debugCast(e);
  return (
    t.he ||
      (t.he = __PRIVATE__queryToTarget(t, __PRIVATE_queryNormalizedOrderBy(e))),
    t.he
  );
}
function __PRIVATE__queryToTarget(e, t) {
  if ("F" === e.limitType)
    return __PRIVATE_newTarget(
      e.path,
      e.collectionGroup,
      t,
      e.filters,
      e.limit,
      e.startAt,
      e.endAt
    );
  {
    t = t.map((e2) => {
      const t2 = "desc" === e2.dir ? "asc" : "desc";
      return new OrderBy(e2.field, t2);
    });
    const n = e.endAt ? new Bound(e.endAt.position, e.endAt.inclusive) : null,
      r2 = e.startAt
        ? new Bound(e.startAt.position, e.startAt.inclusive)
        : null;
    return __PRIVATE_newTarget(
      e.path,
      e.collectionGroup,
      t,
      e.filters,
      e.limit,
      n,
      r2
    );
  }
}
function __PRIVATE_queryWithAddedFilter(e, t) {
  const n = e.filters.concat([t]);
  return new __PRIVATE_QueryImpl(
    e.path,
    e.collectionGroup,
    e.explicitOrderBy.slice(),
    n,
    e.limit,
    e.limitType,
    e.startAt,
    e.endAt
  );
}
function __PRIVATE_queryWithLimit(e, t, n) {
  return new __PRIVATE_QueryImpl(
    e.path,
    e.collectionGroup,
    e.explicitOrderBy.slice(),
    e.filters.slice(),
    t,
    n,
    e.startAt,
    e.endAt
  );
}
function __PRIVATE_queryEquals(e, t) {
  return (
    __PRIVATE_targetEquals(
      __PRIVATE_queryToTarget(e),
      __PRIVATE_queryToTarget(t)
    ) && e.limitType === t.limitType
  );
}
function __PRIVATE_canonifyQuery(e) {
  return `${__PRIVATE_canonifyTarget(__PRIVATE_queryToTarget(e))}|lt:${
    e.limitType
  }`;
}
function __PRIVATE_stringifyQuery(e) {
  return `Query(target=${(function __PRIVATE_stringifyTarget(e2) {
    let t = e2.path.canonicalString();
    return (
      null !== e2.collectionGroup &&
        (t += " collectionGroup=" + e2.collectionGroup),
      e2.filters.length > 0 &&
        (t += `, filters: [${e2.filters
          .map((e3) => __PRIVATE_stringifyFilter(e3))
          .join(", ")}]`),
      __PRIVATE_isNullOrUndefined(e2.limit) || (t += ", limit: " + e2.limit),
      e2.orderBy.length > 0 &&
        (t += `, orderBy: [${e2.orderBy
          .map((e3) =>
            (function __PRIVATE_stringifyOrderBy(e4) {
              return `${e4.field.canonicalString()} (${e4.dir})`;
            })(e3)
          )
          .join(", ")}]`),
      e2.startAt &&
        ((t += ", startAt: "),
        (t += e2.startAt.inclusive ? "b:" : "a:"),
        (t += e2.startAt.position.map((e3) => canonicalId(e3)).join(","))),
      e2.endAt &&
        ((t += ", endAt: "),
        (t += e2.endAt.inclusive ? "a:" : "b:"),
        (t += e2.endAt.position.map((e3) => canonicalId(e3)).join(","))),
      `Target(${t})`
    );
  })(__PRIVATE_queryToTarget(e))}; limitType=${e.limitType})`;
}
function __PRIVATE_queryMatches(e, t) {
  return (
    t.isFoundDocument() &&
    (function __PRIVATE_queryMatchesPathAndCollectionGroup(e2, t2) {
      const n = t2.key.path;
      return null !== e2.collectionGroup
        ? t2.key.hasCollectionId(e2.collectionGroup) && e2.path.isPrefixOf(n)
        : DocumentKey.isDocumentKey(e2.path)
        ? e2.path.isEqual(n)
        : e2.path.isImmediateParentOf(n);
    })(e, t) &&
    (function __PRIVATE_queryMatchesOrderBy(e2, t2) {
      for (const n of __PRIVATE_queryNormalizedOrderBy(e2))
        if (!n.field.isKeyField() && null === t2.data.field(n.field))
          return false;
      return true;
    })(e, t) &&
    (function __PRIVATE_queryMatchesFilters(e2, t2) {
      for (const n of e2.filters) if (!n.matches(t2)) return false;
      return true;
    })(e, t) &&
    (function __PRIVATE_queryMatchesBounds(e2, t2) {
      if (
        e2.startAt &&
        !(
          /**
           * Returns true if a document sorts before a bound using the provided sort
           * order.
           */
          (function __PRIVATE_boundSortsBeforeDocument(e3, t3, n) {
            const r2 = __PRIVATE_boundCompareToDocument(e3, t3, n);
            return e3.inclusive ? r2 <= 0 : r2 < 0;
          })(e2.startAt, __PRIVATE_queryNormalizedOrderBy(e2), t2)
        )
      )
        return false;
      if (
        e2.endAt &&
        !(function __PRIVATE_boundSortsAfterDocument(e3, t3, n) {
          const r2 = __PRIVATE_boundCompareToDocument(e3, t3, n);
          return e3.inclusive ? r2 >= 0 : r2 > 0;
        })(e2.endAt, __PRIVATE_queryNormalizedOrderBy(e2), t2)
      )
        return false;
      return true;
    })(e, t)
  );
}
function __PRIVATE_queryCollectionGroup(e) {
  return (
    e.collectionGroup ||
    (e.path.length % 2 == 1
      ? e.path.lastSegment()
      : e.path.get(e.path.length - 2))
  );
}
function __PRIVATE_newQueryComparator(e) {
  return (t, n) => {
    let r2 = false;
    for (const i of __PRIVATE_queryNormalizedOrderBy(e)) {
      const e2 = __PRIVATE_compareDocs(i, t, n);
      if (0 !== e2) return e2;
      r2 = r2 || i.field.isKeyField();
    }
    return 0;
  };
}
function __PRIVATE_compareDocs(e, t, n) {
  const r2 = e.field.isKeyField()
    ? DocumentKey.comparator(t.key, n.key)
    : (function __PRIVATE_compareDocumentsByField(e2, t2, n2) {
        const r3 = t2.data.field(e2),
          i = n2.data.field(e2);
        return null !== r3 && null !== i
          ? __PRIVATE_valueCompare(r3, i)
          : fail();
      })(e.field, t, n);
  switch (e.dir) {
    case "asc":
      return r2;
    case "desc":
      return -1 * r2;
    default:
      return fail();
  }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class ObjectMap {
  constructor(e, t) {
    (this.mapKeyFn = e),
      (this.equalsFn = t),
      /**
       * The inner map for a key/value pair. Due to the possibility of collisions we
       * keep a list of entries that we do a linear search through to find an actual
       * match. Note that collisions should be rare, so we still expect near
       * constant time lookups in practice.
       */ (this.inner = {}) /** The number of entries stored in the map */,
      (this.innerSize = 0);
  }
  /** Get a value for this key, or undefined if it does not exist. */
  get(e) {
    const t = this.mapKeyFn(e),
      n = this.inner[t];
    if (void 0 !== n) {
      for (const [t2, r2] of n) if (this.equalsFn(t2, e)) return r2;
    }
  }
  has(e) {
    return void 0 !== this.get(e);
  }
  /** Put this key and value in the map. */
  set(e, t) {
    const n = this.mapKeyFn(e),
      r2 = this.inner[n];
    if (void 0 === r2) return (this.inner[n] = [[e, t]]), void this.innerSize++;
    for (let n2 = 0; n2 < r2.length; n2++)
      if (this.equalsFn(r2[n2][0], e)) return void (r2[n2] = [e, t]);
    r2.push([e, t]), this.innerSize++;
  }
  /**
   * Remove this key from the map. Returns a boolean if anything was deleted.
   */
  delete(e) {
    const t = this.mapKeyFn(e),
      n = this.inner[t];
    if (void 0 === n) return false;
    for (let r2 = 0; r2 < n.length; r2++)
      if (this.equalsFn(n[r2][0], e))
        return (
          1 === n.length ? delete this.inner[t] : n.splice(r2, 1),
          this.innerSize--,
          true
        );
    return false;
  }
  forEach(e) {
    forEach$1(this.inner, (t, n) => {
      for (const [t2, r2] of n) e(t2, r2);
    });
  }
  isEmpty() {
    return isEmpty(this.inner);
  }
  size() {
    return this.innerSize;
  }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const ie = new SortedMap(DocumentKey.comparator);
function __PRIVATE_mutableDocumentMap() {
  return ie;
}
const se = new SortedMap(DocumentKey.comparator);
function documentMap(...e) {
  let t = se;
  for (const n of e) t = t.insert(n.key, n);
  return t;
}
function __PRIVATE_convertOverlayedDocumentMapToDocumentMap(e) {
  let t = se;
  return e.forEach((e2, n) => (t = t.insert(e2, n.overlayedDocument))), t;
}
function __PRIVATE_newOverlayMap() {
  return __PRIVATE_newDocumentKeyMap();
}
function __PRIVATE_newMutationMap() {
  return __PRIVATE_newDocumentKeyMap();
}
function __PRIVATE_newDocumentKeyMap() {
  return new ObjectMap(
    (e) => e.toString(),
    (e, t) => e.isEqual(t)
  );
}
const oe = new SortedMap(DocumentKey.comparator);
const _e = new SortedSet(DocumentKey.comparator);
function __PRIVATE_documentKeySet(...e) {
  let t = _e;
  for (const n of e) t = t.add(n);
  return t;
}
const ae = new SortedSet(__PRIVATE_primitiveComparator);
function __PRIVATE_targetIdSet() {
  return ae;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function __PRIVATE_toDouble(e, t) {
  if (e.useProto3Json) {
    if (isNaN(t))
      return {
        doubleValue: "NaN",
      };
    if (t === 1 / 0)
      return {
        doubleValue: "Infinity",
      };
    if (t === -1 / 0)
      return {
        doubleValue: "-Infinity",
      };
  }
  return {
    doubleValue: __PRIVATE_isNegativeZero(t) ? "-0" : t,
  };
}
function __PRIVATE_toInteger(e) {
  return {
    integerValue: "" + e,
  };
}
function toNumber(e, t) {
  return isSafeInteger(t) ? __PRIVATE_toInteger(t) : __PRIVATE_toDouble(e, t);
}
/**
 * @license
 * Copyright 2018 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class TransformOperation {
  constructor() {
    this._ = void 0;
  }
}
function __PRIVATE_applyTransformOperationToLocalView(e, t, n) {
  return e instanceof __PRIVATE_ServerTimestampTransform
    ? (function serverTimestamp$1(e2, t2) {
        const n2 = {
          fields: {
            __type__: {
              stringValue: "server_timestamp",
            },
            __local_write_time__: {
              timestampValue: {
                seconds: e2.seconds,
                nanos: e2.nanoseconds,
              },
            },
          },
        };
        return (
          t2 &&
            __PRIVATE_isServerTimestamp(t2) &&
            (t2 = __PRIVATE_getPreviousValue(t2)),
          t2 && (n2.fields.__previous_value__ = t2),
          {
            mapValue: n2,
          }
        );
      })(n, t)
    : e instanceof __PRIVATE_ArrayUnionTransformOperation
    ? __PRIVATE_applyArrayUnionTransformOperation(e, t)
    : e instanceof __PRIVATE_ArrayRemoveTransformOperation
    ? __PRIVATE_applyArrayRemoveTransformOperation(e, t)
    : (function __PRIVATE_applyNumericIncrementTransformOperationToLocalView(
        e2,
        t2
      ) {
        const n2 = __PRIVATE_computeTransformOperationBaseValue(e2, t2),
          r2 = asNumber(n2) + asNumber(e2.Ie);
        return isInteger(n2) && isInteger(e2.Ie)
          ? __PRIVATE_toInteger(r2)
          : __PRIVATE_toDouble(e2.serializer, r2);
      })(e, t);
}
function __PRIVATE_applyTransformOperationToRemoteDocument(e, t, n) {
  return e instanceof __PRIVATE_ArrayUnionTransformOperation
    ? __PRIVATE_applyArrayUnionTransformOperation(e, t)
    : e instanceof __PRIVATE_ArrayRemoveTransformOperation
    ? __PRIVATE_applyArrayRemoveTransformOperation(e, t)
    : n;
}
function __PRIVATE_computeTransformOperationBaseValue(e, t) {
  return e instanceof __PRIVATE_NumericIncrementTransformOperation
    ? /** Returns true if `value` is either an IntegerValue or a DoubleValue. */
      (function __PRIVATE_isNumber(e2) {
        return (
          isInteger(e2) ||
          (function __PRIVATE_isDouble(e3) {
            return !!e3 && "doubleValue" in e3;
          })(e2)
        );
      })(t)
      ? t
      : {
          integerValue: 0,
        }
    : null;
}
class __PRIVATE_ServerTimestampTransform extends TransformOperation {}
class __PRIVATE_ArrayUnionTransformOperation extends TransformOperation {
  constructor(e) {
    super(), (this.elements = e);
  }
}
function __PRIVATE_applyArrayUnionTransformOperation(e, t) {
  const n = __PRIVATE_coercedFieldValuesArray(t);
  for (const t2 of e.elements)
    n.some((e2) => __PRIVATE_valueEquals(e2, t2)) || n.push(t2);
  return {
    arrayValue: {
      values: n,
    },
  };
}
class __PRIVATE_ArrayRemoveTransformOperation extends TransformOperation {
  constructor(e) {
    super(), (this.elements = e);
  }
}
function __PRIVATE_applyArrayRemoveTransformOperation(e, t) {
  let n = __PRIVATE_coercedFieldValuesArray(t);
  for (const t2 of e.elements)
    n = n.filter((e2) => !__PRIVATE_valueEquals(e2, t2));
  return {
    arrayValue: {
      values: n,
    },
  };
}
class __PRIVATE_NumericIncrementTransformOperation extends TransformOperation {
  constructor(e, t) {
    super(), (this.serializer = e), (this.Ie = t);
  }
}
function asNumber(e) {
  return __PRIVATE_normalizeNumber(e.integerValue || e.doubleValue);
}
function __PRIVATE_coercedFieldValuesArray(e) {
  return isArray(e) && e.arrayValue.values ? e.arrayValue.values.slice() : [];
}
function __PRIVATE_fieldTransformEquals(e, t) {
  return (
    e.field.isEqual(t.field) &&
    (function __PRIVATE_transformOperationEquals(e2, t2) {
      return (e2 instanceof __PRIVATE_ArrayUnionTransformOperation &&
        t2 instanceof __PRIVATE_ArrayUnionTransformOperation) ||
        (e2 instanceof __PRIVATE_ArrayRemoveTransformOperation &&
          t2 instanceof __PRIVATE_ArrayRemoveTransformOperation)
        ? __PRIVATE_arrayEquals(e2.elements, t2.elements, __PRIVATE_valueEquals)
        : e2 instanceof __PRIVATE_NumericIncrementTransformOperation &&
          t2 instanceof __PRIVATE_NumericIncrementTransformOperation
        ? __PRIVATE_valueEquals(e2.Ie, t2.Ie)
        : e2 instanceof __PRIVATE_ServerTimestampTransform &&
          t2 instanceof __PRIVATE_ServerTimestampTransform;
    })(e.transform, t.transform)
  );
}
class MutationResult {
  constructor(e, t) {
    (this.version = e), (this.transformResults = t);
  }
}
class Precondition {
  constructor(e, t) {
    (this.updateTime = e), (this.exists = t);
  }
  /** Creates a new empty Precondition. */
  static none() {
    return new Precondition();
  }
  /** Creates a new Precondition with an exists flag. */
  static exists(e) {
    return new Precondition(void 0, e);
  }
  /** Creates a new Precondition based on a version a document exists at. */
  static updateTime(e) {
    return new Precondition(e);
  }
  /** Returns whether this Precondition is empty. */
  get isNone() {
    return void 0 === this.updateTime && void 0 === this.exists;
  }
  isEqual(e) {
    return (
      this.exists === e.exists &&
      (this.updateTime
        ? !!e.updateTime && this.updateTime.isEqual(e.updateTime)
        : !e.updateTime)
    );
  }
}
function __PRIVATE_preconditionIsValidForDocument(e, t) {
  return void 0 !== e.updateTime
    ? t.isFoundDocument() && t.version.isEqual(e.updateTime)
    : void 0 === e.exists || e.exists === t.isFoundDocument();
}
class Mutation {}
function __PRIVATE_calculateOverlayMutation(e, t) {
  if (!e.hasLocalMutations || (t && 0 === t.fields.length)) return null;
  if (null === t)
    return e.isNoDocument()
      ? new __PRIVATE_DeleteMutation(e.key, Precondition.none())
      : new __PRIVATE_SetMutation(e.key, e.data, Precondition.none());
  {
    const n = e.data,
      r2 = ObjectValue.empty();
    let i = new SortedSet(FieldPath$1.comparator);
    for (let e2 of t.fields)
      if (!i.has(e2)) {
        let t2 = n.field(e2);
        null === t2 &&
          e2.length > 1 &&
          ((e2 = e2.popLast()), (t2 = n.field(e2))),
          null === t2 ? r2.delete(e2) : r2.set(e2, t2),
          (i = i.add(e2));
      }
    return new __PRIVATE_PatchMutation(
      e.key,
      r2,
      new FieldMask(i.toArray()),
      Precondition.none()
    );
  }
}
function __PRIVATE_mutationApplyToRemoteDocument(e, t, n) {
  e instanceof __PRIVATE_SetMutation
    ? (function __PRIVATE_setMutationApplyToRemoteDocument(e2, t2, n2) {
        const r2 = e2.value.clone(),
          i = __PRIVATE_serverTransformResults(
            e2.fieldTransforms,
            t2,
            n2.transformResults
          );
        r2.setAll(i),
          t2.convertToFoundDocument(n2.version, r2).setHasCommittedMutations();
      })(e, t, n)
    : e instanceof __PRIVATE_PatchMutation
    ? (function __PRIVATE_patchMutationApplyToRemoteDocument(e2, t2, n2) {
        if (!__PRIVATE_preconditionIsValidForDocument(e2.precondition, t2))
          return void t2.convertToUnknownDocument(n2.version);
        const r2 = __PRIVATE_serverTransformResults(
            e2.fieldTransforms,
            t2,
            n2.transformResults
          ),
          i = t2.data;
        i.setAll(__PRIVATE_getPatch(e2)),
          i.setAll(r2),
          t2.convertToFoundDocument(n2.version, i).setHasCommittedMutations();
      })(e, t, n)
    : (function __PRIVATE_deleteMutationApplyToRemoteDocument(e2, t2, n2) {
        t2.convertToNoDocument(n2.version).setHasCommittedMutations();
      })(0, t, n);
}
function __PRIVATE_mutationApplyToLocalView(e, t, n, r2) {
  return e instanceof __PRIVATE_SetMutation
    ? (function __PRIVATE_setMutationApplyToLocalView(e2, t2, n2, r3) {
        if (!__PRIVATE_preconditionIsValidForDocument(e2.precondition, t2))
          return n2;
        const i = e2.value.clone(),
          s = __PRIVATE_localTransformResults(e2.fieldTransforms, r3, t2);
        return (
          i.setAll(s),
          t2.convertToFoundDocument(t2.version, i).setHasLocalMutations(),
          null
        );
      })(e, t, n, r2)
    : e instanceof __PRIVATE_PatchMutation
    ? (function __PRIVATE_patchMutationApplyToLocalView(e2, t2, n2, r3) {
        if (!__PRIVATE_preconditionIsValidForDocument(e2.precondition, t2))
          return n2;
        const i = __PRIVATE_localTransformResults(e2.fieldTransforms, r3, t2),
          s = t2.data;
        if (
          (s.setAll(__PRIVATE_getPatch(e2)),
          s.setAll(i),
          t2.convertToFoundDocument(t2.version, s).setHasLocalMutations(),
          null === n2)
        )
          return null;
        return n2
          .unionWith(e2.fieldMask.fields)
          .unionWith(e2.fieldTransforms.map((e3) => e3.field));
      })(e, t, n, r2)
    : (function __PRIVATE_deleteMutationApplyToLocalView(e2, t2, n2) {
        if (__PRIVATE_preconditionIsValidForDocument(e2.precondition, t2))
          return (
            t2.convertToNoDocument(t2.version).setHasLocalMutations(), null
          );
        return n2;
      })(e, t, n);
}
function __PRIVATE_mutationExtractBaseValue(e, t) {
  let n = null;
  for (const r2 of e.fieldTransforms) {
    const e2 = t.data.field(r2.field),
      i = __PRIVATE_computeTransformOperationBaseValue(
        r2.transform,
        e2 || null
      );
    null != i && (null === n && (n = ObjectValue.empty()), n.set(r2.field, i));
  }
  return n || null;
}
function __PRIVATE_mutationEquals(e, t) {
  return (
    e.type === t.type &&
    !!e.key.isEqual(t.key) &&
    !!e.precondition.isEqual(t.precondition) &&
    !!(function __PRIVATE_fieldTransformsAreEqual(e2, t2) {
      return (
        (void 0 === e2 && void 0 === t2) ||
        (!(!e2 || !t2) &&
          __PRIVATE_arrayEquals(e2, t2, (e3, t3) =>
            __PRIVATE_fieldTransformEquals(e3, t3)
          ))
      );
    })(e.fieldTransforms, t.fieldTransforms) &&
    (0 === e.type
      ? e.value.isEqual(t.value)
      : 1 !== e.type ||
        (e.data.isEqual(t.data) && e.fieldMask.isEqual(t.fieldMask)))
  );
}
class __PRIVATE_SetMutation extends Mutation {
  constructor(e, t, n, r2 = []) {
    super(),
      (this.key = e),
      (this.value = t),
      (this.precondition = n),
      (this.fieldTransforms = r2),
      (this.type = 0);
  }
  getFieldMask() {
    return null;
  }
}
class __PRIVATE_PatchMutation extends Mutation {
  constructor(e, t, n, r2, i = []) {
    super(),
      (this.key = e),
      (this.data = t),
      (this.fieldMask = n),
      (this.precondition = r2),
      (this.fieldTransforms = i),
      (this.type = 1);
  }
  getFieldMask() {
    return this.fieldMask;
  }
}
function __PRIVATE_getPatch(e) {
  const t = /* @__PURE__ */ new Map();
  return (
    e.fieldMask.fields.forEach((n) => {
      if (!n.isEmpty()) {
        const r2 = e.data.field(n);
        t.set(n, r2);
      }
    }),
    t
  );
}
function __PRIVATE_serverTransformResults(e, t, n) {
  const r2 = /* @__PURE__ */ new Map();
  __PRIVATE_hardAssert(e.length === n.length);
  for (let i = 0; i < n.length; i++) {
    const s = e[i],
      o = s.transform,
      _ = t.data.field(s.field);
    r2.set(
      s.field,
      __PRIVATE_applyTransformOperationToRemoteDocument(o, _, n[i])
    );
  }
  return r2;
}
function __PRIVATE_localTransformResults(e, t, n) {
  const r2 = /* @__PURE__ */ new Map();
  for (const i of e) {
    const e2 = i.transform,
      s = n.data.field(i.field);
    r2.set(i.field, __PRIVATE_applyTransformOperationToLocalView(e2, s, t));
  }
  return r2;
}
class __PRIVATE_DeleteMutation extends Mutation {
  constructor(e, t) {
    super(),
      (this.key = e),
      (this.precondition = t),
      (this.type = 2),
      (this.fieldTransforms = []);
  }
  getFieldMask() {
    return null;
  }
}
class __PRIVATE_VerifyMutation extends Mutation {
  constructor(e, t) {
    super(),
      (this.key = e),
      (this.precondition = t),
      (this.type = 3),
      (this.fieldTransforms = []);
  }
  getFieldMask() {
    return null;
  }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class MutationBatch {
  /**
   * @param batchId - The unique ID of this mutation batch.
   * @param localWriteTime - The original write time of this mutation.
   * @param baseMutations - Mutations that are used to populate the base
   * values when this mutation is applied locally. This can be used to locally
   * overwrite values that are persisted in the remote document cache. Base
   * mutations are never sent to the backend.
   * @param mutations - The user-provided mutations in this mutation batch.
   * User-provided mutations are applied both locally and remotely on the
   * backend.
   */
  constructor(e, t, n, r2) {
    (this.batchId = e),
      (this.localWriteTime = t),
      (this.baseMutations = n),
      (this.mutations = r2);
  }
  /**
   * Applies all the mutations in this MutationBatch to the specified document
   * to compute the state of the remote document
   *
   * @param document - The document to apply mutations to.
   * @param batchResult - The result of applying the MutationBatch to the
   * backend.
   */
  applyToRemoteDocument(e, t) {
    const n = t.mutationResults;
    for (let t2 = 0; t2 < this.mutations.length; t2++) {
      const r2 = this.mutations[t2];
      if (r2.key.isEqual(e.key)) {
        __PRIVATE_mutationApplyToRemoteDocument(r2, e, n[t2]);
      }
    }
  }
  /**
   * Computes the local view of a document given all the mutations in this
   * batch.
   *
   * @param document - The document to apply mutations to.
   * @param mutatedFields - Fields that have been updated before applying this mutation batch.
   * @returns A `FieldMask` representing all the fields that are mutated.
   */
  applyToLocalView(e, t) {
    for (const n of this.baseMutations)
      n.key.isEqual(e.key) &&
        (t = __PRIVATE_mutationApplyToLocalView(n, e, t, this.localWriteTime));
    for (const n of this.mutations)
      n.key.isEqual(e.key) &&
        (t = __PRIVATE_mutationApplyToLocalView(n, e, t, this.localWriteTime));
    return t;
  }
  /**
   * Computes the local view for all provided documents given the mutations in
   * this batch. Returns a `DocumentKey` to `Mutation` map which can be used to
   * replace all the mutation applications.
   */
  applyToLocalDocumentSet(e, t) {
    const n = __PRIVATE_newMutationMap();
    return (
      this.mutations.forEach((r2) => {
        const i = e.get(r2.key),
          s = i.overlayedDocument;
        let o = this.applyToLocalView(s, i.mutatedFields);
        o = t.has(r2.key) ? null : o;
        const _ = __PRIVATE_calculateOverlayMutation(s, o);
        null !== _ && n.set(r2.key, _),
          s.isValidDocument() || s.convertToNoDocument(SnapshotVersion.min());
      }),
      n
    );
  }
  keys() {
    return this.mutations.reduce(
      (e, t) => e.add(t.key),
      __PRIVATE_documentKeySet()
    );
  }
  isEqual(e) {
    return (
      this.batchId === e.batchId &&
      __PRIVATE_arrayEquals(this.mutations, e.mutations, (e2, t) =>
        __PRIVATE_mutationEquals(e2, t)
      ) &&
      __PRIVATE_arrayEquals(this.baseMutations, e.baseMutations, (e2, t) =>
        __PRIVATE_mutationEquals(e2, t)
      )
    );
  }
}
class MutationBatchResult {
  constructor(e, t, n, r2) {
    (this.batch = e),
      (this.commitVersion = t),
      (this.mutationResults = n),
      (this.docVersions = r2);
  }
  /**
   * Creates a new MutationBatchResult for the given batch and results. There
   * must be one result for each mutation in the batch. This static factory
   * caches a document=&gt;version mapping (docVersions).
   */
  static from(e, t, n) {
    __PRIVATE_hardAssert(e.mutations.length === n.length);
    let r2 = (function __PRIVATE_documentVersionMap() {
      return oe;
    })();
    const i = e.mutations;
    for (let e2 = 0; e2 < i.length; e2++)
      r2 = r2.insert(i[e2].key, n[e2].version);
    return new MutationBatchResult(e, t, n, r2);
  }
}
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class Overlay {
  constructor(e, t) {
    (this.largestBatchId = e), (this.mutation = t);
  }
  getKey() {
    return this.mutation.key;
  }
  isEqual(e) {
    return null !== e && this.mutation === e.mutation;
  }
  toString() {
    return `Overlay{
      largestBatchId: ${this.largestBatchId},
      mutation: ${this.mutation.toString()}
    }`;
  }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class ExistenceFilter {
  constructor(e, t) {
    (this.count = e), (this.unchangedNames = t);
  }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var ue, ce;
function __PRIVATE_isPermanentError(e) {
  switch (e) {
    default:
      return fail();
    case D.CANCELLED:
    case D.UNKNOWN:
    case D.DEADLINE_EXCEEDED:
    case D.RESOURCE_EXHAUSTED:
    case D.INTERNAL:
    case D.UNAVAILABLE:
    case D.UNAUTHENTICATED:
      return false;
    case D.INVALID_ARGUMENT:
    case D.NOT_FOUND:
    case D.ALREADY_EXISTS:
    case D.PERMISSION_DENIED:
    case D.FAILED_PRECONDITION:
    case D.ABORTED:
    case D.OUT_OF_RANGE:
    case D.UNIMPLEMENTED:
    case D.DATA_LOSS:
      return true;
  }
}
function __PRIVATE_mapCodeFromRpcCode(e) {
  if (void 0 === e)
    return __PRIVATE_logError("GRPC error has no .code"), D.UNKNOWN;
  switch (e) {
    case ue.OK:
      return D.OK;
    case ue.CANCELLED:
      return D.CANCELLED;
    case ue.UNKNOWN:
      return D.UNKNOWN;
    case ue.DEADLINE_EXCEEDED:
      return D.DEADLINE_EXCEEDED;
    case ue.RESOURCE_EXHAUSTED:
      return D.RESOURCE_EXHAUSTED;
    case ue.INTERNAL:
      return D.INTERNAL;
    case ue.UNAVAILABLE:
      return D.UNAVAILABLE;
    case ue.UNAUTHENTICATED:
      return D.UNAUTHENTICATED;
    case ue.INVALID_ARGUMENT:
      return D.INVALID_ARGUMENT;
    case ue.NOT_FOUND:
      return D.NOT_FOUND;
    case ue.ALREADY_EXISTS:
      return D.ALREADY_EXISTS;
    case ue.PERMISSION_DENIED:
      return D.PERMISSION_DENIED;
    case ue.FAILED_PRECONDITION:
      return D.FAILED_PRECONDITION;
    case ue.ABORTED:
      return D.ABORTED;
    case ue.OUT_OF_RANGE:
      return D.OUT_OF_RANGE;
    case ue.UNIMPLEMENTED:
      return D.UNIMPLEMENTED;
    case ue.DATA_LOSS:
      return D.DATA_LOSS;
    default:
      return fail();
  }
}
((ce = ue || (ue = {}))[(ce.OK = 0)] = "OK"),
  (ce[(ce.CANCELLED = 1)] = "CANCELLED"),
  (ce[(ce.UNKNOWN = 2)] = "UNKNOWN"),
  (ce[(ce.INVALID_ARGUMENT = 3)] = "INVALID_ARGUMENT"),
  (ce[(ce.DEADLINE_EXCEEDED = 4)] = "DEADLINE_EXCEEDED"),
  (ce[(ce.NOT_FOUND = 5)] = "NOT_FOUND"),
  (ce[(ce.ALREADY_EXISTS = 6)] = "ALREADY_EXISTS"),
  (ce[(ce.PERMISSION_DENIED = 7)] = "PERMISSION_DENIED"),
  (ce[(ce.UNAUTHENTICATED = 16)] = "UNAUTHENTICATED"),
  (ce[(ce.RESOURCE_EXHAUSTED = 8)] = "RESOURCE_EXHAUSTED"),
  (ce[(ce.FAILED_PRECONDITION = 9)] = "FAILED_PRECONDITION"),
  (ce[(ce.ABORTED = 10)] = "ABORTED"),
  (ce[(ce.OUT_OF_RANGE = 11)] = "OUT_OF_RANGE"),
  (ce[(ce.UNIMPLEMENTED = 12)] = "UNIMPLEMENTED"),
  (ce[(ce.INTERNAL = 13)] = "INTERNAL"),
  (ce[(ce.UNAVAILABLE = 14)] = "UNAVAILABLE"),
  (ce[(ce.DATA_LOSS = 15)] = "DATA_LOSS");
/**
 * @license
 * Copyright 2023 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function __PRIVATE_newTextEncoder() {
  return new TextEncoder();
}
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const he = new Integer([4294967295, 4294967295], 0);
function __PRIVATE_getMd5HashValue(e) {
  const t = __PRIVATE_newTextEncoder().encode(e),
    n = new Md5();
  return n.update(t), new Uint8Array(n.digest());
}
function __PRIVATE_get64BitUints(e) {
  const t = new DataView(e.buffer),
    n = t.getUint32(
      0,
      /* littleEndian= */
      true
    ),
    r2 = t.getUint32(
      4,
      /* littleEndian= */
      true
    ),
    i = t.getUint32(
      8,
      /* littleEndian= */
      true
    ),
    s = t.getUint32(
      12,
      /* littleEndian= */
      true
    );
  return [new Integer([n, r2], 0), new Integer([i, s], 0)];
}
class BloomFilter {
  constructor(e, t, n) {
    if (
      ((this.bitmap = e),
      (this.padding = t),
      (this.hashCount = n),
      t < 0 || t >= 8)
    )
      throw new __PRIVATE_BloomFilterError(`Invalid padding: ${t}`);
    if (n < 0) throw new __PRIVATE_BloomFilterError(`Invalid hash count: ${n}`);
    if (e.length > 0 && 0 === this.hashCount)
      throw new __PRIVATE_BloomFilterError(`Invalid hash count: ${n}`);
    if (0 === e.length && 0 !== t)
      throw new __PRIVATE_BloomFilterError(
        `Invalid padding when bitmap length is 0: ${t}`
      );
    (this.Te = 8 * e.length - t), // Set the bit count in Integer to avoid repetition in mightContain().
      (this.Ee = Integer.fromNumber(this.Te));
  }
  // Calculate the ith hash value based on the hashed 64bit integers,
  // and calculate its corresponding bit index in the bitmap to be checked.
  de(e, t, n) {
    let r2 = e.add(t.multiply(Integer.fromNumber(n)));
    return (
      1 === r2.compare(he) &&
        (r2 = new Integer([r2.getBits(0), r2.getBits(1)], 0)),
      r2.modulo(this.Ee).toNumber()
    );
  }
  // Return whether the bit on the given index in the bitmap is set to 1.
  Ae(e) {
    return 0 != (this.bitmap[Math.floor(e / 8)] & (1 << e % 8));
  }
  mightContain(e) {
    if (0 === this.Te) return false;
    const t = __PRIVATE_getMd5HashValue(e),
      [n, r2] = __PRIVATE_get64BitUints(t);
    for (let e2 = 0; e2 < this.hashCount; e2++) {
      const t2 = this.de(n, r2, e2);
      if (!this.Ae(t2)) return false;
    }
    return true;
  }
  /** Create bloom filter for testing purposes only. */
  static create(e, t, n) {
    const r2 = e % 8 == 0 ? 0 : 8 - (e % 8),
      i = new Uint8Array(Math.ceil(e / 8)),
      s = new BloomFilter(i, r2, t);
    return n.forEach((e2) => s.insert(e2)), s;
  }
  insert(e) {
    if (0 === this.Te) return;
    const t = __PRIVATE_getMd5HashValue(e),
      [n, r2] = __PRIVATE_get64BitUints(t);
    for (let e2 = 0; e2 < this.hashCount; e2++) {
      const t2 = this.de(n, r2, e2);
      this.Re(t2);
    }
  }
  Re(e) {
    const t = Math.floor(e / 8),
      n = e % 8;
    this.bitmap[t] |= 1 << n;
  }
}
class __PRIVATE_BloomFilterError extends Error {
  constructor() {
    super(...arguments), (this.name = "BloomFilterError");
  }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class RemoteEvent {
  constructor(e, t, n, r2, i) {
    (this.snapshotVersion = e),
      (this.targetChanges = t),
      (this.targetMismatches = n),
      (this.documentUpdates = r2),
      (this.resolvedLimboDocuments = i);
  }
  /**
   * HACK: Views require RemoteEvents in order to determine whether the view is
   * CURRENT, but secondary tabs don't receive remote events. So this method is
   * used to create a synthesized RemoteEvent that can be used to apply a
   * CURRENT status change to a View, for queries executed in a different tab.
   */
  // PORTING NOTE: Multi-tab only
  static createSynthesizedRemoteEventForCurrentChange(e, t, n) {
    const r2 = /* @__PURE__ */ new Map();
    return (
      r2.set(
        e,
        TargetChange.createSynthesizedTargetChangeForCurrentChange(e, t, n)
      ),
      new RemoteEvent(
        SnapshotVersion.min(),
        r2,
        new SortedMap(__PRIVATE_primitiveComparator),
        __PRIVATE_mutableDocumentMap(),
        __PRIVATE_documentKeySet()
      )
    );
  }
}
class TargetChange {
  constructor(e, t, n, r2, i) {
    (this.resumeToken = e),
      (this.current = t),
      (this.addedDocuments = n),
      (this.modifiedDocuments = r2),
      (this.removedDocuments = i);
  }
  /**
   * This method is used to create a synthesized TargetChanges that can be used to
   * apply a CURRENT status change to a View (for queries executed in a different
   * tab) or for new queries (to raise snapshots with correct CURRENT status).
   */
  static createSynthesizedTargetChangeForCurrentChange(e, t, n) {
    return new TargetChange(
      n,
      t,
      __PRIVATE_documentKeySet(),
      __PRIVATE_documentKeySet(),
      __PRIVATE_documentKeySet()
    );
  }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class __PRIVATE_DocumentWatchChange {
  constructor(e, t, n, r2) {
    (this.Ve = e), (this.removedTargetIds = t), (this.key = n), (this.me = r2);
  }
}
class __PRIVATE_ExistenceFilterChange {
  constructor(e, t) {
    (this.targetId = e), (this.fe = t);
  }
}
class __PRIVATE_WatchTargetChange {
  constructor(e, t, n = ByteString.EMPTY_BYTE_STRING, r2 = null) {
    (this.state = e),
      (this.targetIds = t),
      (this.resumeToken = n),
      (this.cause = r2);
  }
}
class __PRIVATE_TargetState {
  constructor() {
    (this.ge = 0),
      /**
       * Keeps track of the document changes since the last raised snapshot.
       *
       * These changes are continuously updated as we receive document updates and
       * always reflect the current set of changes against the last issued snapshot.
       */ (this.pe =
        __PRIVATE_snapshotChangesMap()) /** See public getters for explanations of these fields. */,
      (this.ye = ByteString.EMPTY_BYTE_STRING),
      (this.we = false),
      /**
       * Whether this target state should be included in the next snapshot. We
       * initialize to true so that newly-added targets are included in the next
       * RemoteEvent.
       */ (this.Se = true);
  }
  /**
   * Whether this target has been marked 'current'.
   *
   * 'Current' has special meaning in the RPC protocol: It implies that the
   * Watch backend has sent us all changes up to the point at which the target
   * was added and that the target is consistent with the rest of the watch
   * stream.
   */
  get current() {
    return this.we;
  }
  /** The last resume token sent to us for this target. */
  get resumeToken() {
    return this.ye;
  }
  /** Whether this target has pending target adds or target removes. */
  get be() {
    return 0 !== this.ge;
  }
  /** Whether we have modified any state that should trigger a snapshot. */
  get De() {
    return this.Se;
  }
  /**
   * Applies the resume token to the TargetChange, but only when it has a new
   * value. Empty resumeTokens are discarded.
   */
  Ce(e) {
    e.approximateByteSize() > 0 && ((this.Se = true), (this.ye = e));
  }
  /**
   * Creates a target change from the current set of changes.
   *
   * To reset the document changes after raising this snapshot, call
   * `clearPendingChanges()`.
   */
  ve() {
    let e = __PRIVATE_documentKeySet(),
      t = __PRIVATE_documentKeySet(),
      n = __PRIVATE_documentKeySet();
    return (
      this.pe.forEach((r2, i) => {
        switch (i) {
          case 0:
            e = e.add(r2);
            break;
          case 2:
            t = t.add(r2);
            break;
          case 1:
            n = n.add(r2);
            break;
          default:
            fail();
        }
      }),
      new TargetChange(this.ye, this.we, e, t, n)
    );
  }
  /**
   * Resets the document changes and sets `hasPendingChanges` to false.
   */
  Fe() {
    (this.Se = false), (this.pe = __PRIVATE_snapshotChangesMap());
  }
  Me(e, t) {
    (this.Se = true), (this.pe = this.pe.insert(e, t));
  }
  xe(e) {
    (this.Se = true), (this.pe = this.pe.remove(e));
  }
  Oe() {
    this.ge += 1;
  }
  Ne() {
    (this.ge -= 1), __PRIVATE_hardAssert(this.ge >= 0);
  }
  Le() {
    (this.Se = true), (this.we = true);
  }
}
class __PRIVATE_WatchChangeAggregator {
  constructor(e) {
    (this.Be = e) /** The internal state of all tracked targets. */,
      (this.ke =
        /* @__PURE__ */ new Map()) /** Keeps track of the documents to update since the last raised snapshot. */,
      (this.qe =
        __PRIVATE_mutableDocumentMap()) /** A mapping of document keys to their set of target IDs. */,
      (this.Qe = __PRIVATE_documentTargetMap()),
      /**
       * A map of targets with existence filter mismatches. These targets are
       * known to be inconsistent and their listens needs to be re-established by
       * RemoteStore.
       */ (this.Ke = new SortedMap(__PRIVATE_primitiveComparator));
  }
  /**
   * Processes and adds the DocumentWatchChange to the current set of changes.
   */
  $e(e) {
    for (const t of e.Ve)
      e.me && e.me.isFoundDocument()
        ? this.Ue(t, e.me)
        : this.We(t, e.key, e.me);
    for (const t of e.removedTargetIds) this.We(t, e.key, e.me);
  }
  /** Processes and adds the WatchTargetChange to the current set of changes. */
  Ge(e) {
    this.forEachTarget(e, (t) => {
      const n = this.ze(t);
      switch (e.state) {
        case 0:
          this.je(t) && n.Ce(e.resumeToken);
          break;
        case 1:
          n.Ne(),
            n.be || // We have a freshly added target, so we need to reset any state
              // that we had previously. This can happen e.g. when remove and add
              // back a target for existence filter mismatches.
              n.Fe(),
            n.Ce(e.resumeToken);
          break;
        case 2:
          n.Ne(), n.be || this.removeTarget(t);
          break;
        case 3:
          this.je(t) && (n.Le(), n.Ce(e.resumeToken));
          break;
        case 4:
          this.je(t) && // Reset the target and synthesizes removes for all existing
            // documents. The backend will re-add any documents that still
            // match the target before it sends the next global snapshot.
            (this.He(t), n.Ce(e.resumeToken));
          break;
        default:
          fail();
      }
    });
  }
  /**
   * Iterates over all targetIds that the watch change applies to: either the
   * targetIds explicitly listed in the change or the targetIds of all currently
   * active targets.
   */
  forEachTarget(e, t) {
    e.targetIds.length > 0
      ? e.targetIds.forEach(t)
      : this.ke.forEach((e2, n) => {
          this.je(n) && t(n);
        });
  }
  /**
   * Handles existence filters and synthesizes deletes for filter mismatches.
   * Targets that are invalidated by filter mismatches are added to
   * `pendingTargetResets`.
   */
  Je(e) {
    const t = e.targetId,
      n = e.fe.count,
      r2 = this.Ye(t);
    if (r2) {
      const i = r2.target;
      if (__PRIVATE_targetIsDocumentTarget(i))
        if (0 === n) {
          const e2 = new DocumentKey(i.path);
          this.We(
            t,
            e2,
            MutableDocument.newNoDocument(e2, SnapshotVersion.min())
          );
        } else __PRIVATE_hardAssert(1 === n);
      else {
        const r3 = this.Ze(t);
        if (r3 !== n) {
          const n2 = this.Xe(e),
            i2 = n2 ? this.et(n2, e, r3) : 1;
          if (0 !== i2) {
            this.He(t);
            const e2 =
              2 === i2
                ? "TargetPurposeExistenceFilterMismatchBloom"
                : "TargetPurposeExistenceFilterMismatch";
            this.Ke = this.Ke.insert(t, e2);
          }
        }
      }
    }
  }
  /**
   * Parse the bloom filter from the "unchanged_names" field of an existence
   * filter.
   */
  Xe(e) {
    const t = e.fe.unchangedNames;
    if (!t || !t.bits) return null;
    const {
      bits: { bitmap: n = "", padding: r2 = 0 },
      hashCount: i = 0,
    } = t;
    let s, o;
    try {
      s = __PRIVATE_normalizeByteString(n).toUint8Array();
    } catch (e2) {
      if (e2 instanceof __PRIVATE_Base64DecodeError)
        return (
          __PRIVATE_logWarn(
            "Decoding the base64 bloom filter in existence filter failed (" +
              e2.message +
              "); ignoring the bloom filter and falling back to full re-query."
          ),
          null
        );
      throw e2;
    }
    try {
      o = new BloomFilter(s, r2, i);
    } catch (e2) {
      return (
        __PRIVATE_logWarn(
          e2 instanceof __PRIVATE_BloomFilterError
            ? "BloomFilter error: "
            : "Applying bloom filter failed: ",
          e2
        ),
        null
      );
    }
    return 0 === o.Te ? null : o;
  }
  /**
   * Apply bloom filter to remove the deleted documents, and return the
   * application status.
   */
  et(e, t, n) {
    return t.fe.count === n - this.rt(e, t.targetId) ? 0 : 2;
  }
  /**
   * Filter out removed documents based on bloom filter membership result and
   * return number of documents removed.
   */
  rt(e, t) {
    const n = this.Be.getRemoteKeysForTarget(t);
    let r2 = 0;
    return (
      n.forEach((n2) => {
        const i = this.Be.nt(),
          s = `projects/${i.projectId}/databases/${
            i.database
          }/documents/${n2.path.canonicalString()}`;
        e.mightContain(s) ||
          (this.We(
            t,
            n2,
            /*updatedDocument=*/
            null
          ),
          r2++);
      }),
      r2
    );
  }
  /**
   * Converts the currently accumulated state into a remote event at the
   * provided snapshot version. Resets the accumulated changes before returning.
   */
  it(e) {
    const t = /* @__PURE__ */ new Map();
    this.ke.forEach((n2, r3) => {
      const i = this.Ye(r3);
      if (i) {
        if (n2.current && __PRIVATE_targetIsDocumentTarget(i.target)) {
          const t2 = new DocumentKey(i.target.path);
          null !== this.qe.get(t2) ||
            this.st(r3, t2) ||
            this.We(r3, t2, MutableDocument.newNoDocument(t2, e));
        }
        n2.De && (t.set(r3, n2.ve()), n2.Fe());
      }
    });
    let n = __PRIVATE_documentKeySet();
    this.Qe.forEach((e2, t2) => {
      let r3 = true;
      t2.forEachWhile((e3) => {
        const t3 = this.Ye(e3);
        return (
          !t3 ||
          "TargetPurposeLimboResolution" === t3.purpose ||
          ((r3 = false), false)
        );
      }),
        r3 && (n = n.add(e2));
    }),
      this.qe.forEach((t2, n2) => n2.setReadTime(e));
    const r2 = new RemoteEvent(e, t, this.Ke, this.qe, n);
    return (
      (this.qe = __PRIVATE_mutableDocumentMap()),
      (this.Qe = __PRIVATE_documentTargetMap()),
      (this.Ke = new SortedMap(__PRIVATE_primitiveComparator)),
      r2
    );
  }
  /**
   * Adds the provided document to the internal list of document updates and
   * its document key to the given target's mapping.
   */
  // Visible for testing.
  Ue(e, t) {
    if (!this.je(e)) return;
    const n = this.st(e, t.key) ? 2 : 0;
    this.ze(e).Me(t.key, n),
      (this.qe = this.qe.insert(t.key, t)),
      (this.Qe = this.Qe.insert(t.key, this.ot(t.key).add(e)));
  }
  /**
   * Removes the provided document from the target mapping. If the
   * document no longer matches the target, but the document's state is still
   * known (e.g. we know that the document was deleted or we received the change
   * that caused the filter mismatch), the new document can be provided
   * to update the remote document cache.
   */
  // Visible for testing.
  We(e, t, n) {
    if (!this.je(e)) return;
    const r2 = this.ze(e);
    this.st(e, t)
      ? r2.Me(
          t,
          1
          /* ChangeType.Removed */
        )
      : // The document may have entered and left the target before we raised a
        // snapshot, so we can just ignore the change.
        r2.xe(t),
      (this.Qe = this.Qe.insert(t, this.ot(t).delete(e))),
      n && (this.qe = this.qe.insert(t, n));
  }
  removeTarget(e) {
    this.ke.delete(e);
  }
  /**
   * Returns the current count of documents in the target. This includes both
   * the number of documents that the LocalStore considers to be part of the
   * target as well as any accumulated changes.
   */
  Ze(e) {
    const t = this.ze(e).ve();
    return (
      this.Be.getRemoteKeysForTarget(e).size +
      t.addedDocuments.size -
      t.removedDocuments.size
    );
  }
  /**
   * Increment the number of acks needed from watch before we can consider the
   * server to be 'in-sync' with the client's active targets.
   */
  Oe(e) {
    this.ze(e).Oe();
  }
  ze(e) {
    let t = this.ke.get(e);
    return t || ((t = new __PRIVATE_TargetState()), this.ke.set(e, t)), t;
  }
  ot(e) {
    let t = this.Qe.get(e);
    return (
      t ||
        ((t = new SortedSet(__PRIVATE_primitiveComparator)),
        (this.Qe = this.Qe.insert(e, t))),
      t
    );
  }
  /**
   * Verifies that the user is still interested in this target (by calling
   * `getTargetDataForTarget()`) and that we are not waiting for pending ADDs
   * from watch.
   */
  je(e) {
    const t = null !== this.Ye(e);
    return (
      t ||
        __PRIVATE_logDebug(
          "WatchChangeAggregator",
          "Detected inactive target",
          e
        ),
      t
    );
  }
  /**
   * Returns the TargetData for an active target (i.e. a target that the user
   * is still interested in that has no outstanding target change requests).
   */
  Ye(e) {
    const t = this.ke.get(e);
    return t && t.be ? null : this.Be._t(e);
  }
  /**
   * Resets the state of a Watch target to its initial state (e.g. sets
   * 'current' to false, clears the resume token and removes its target mapping
   * from all documents).
   */
  He(e) {
    this.ke.set(e, new __PRIVATE_TargetState());
    this.Be.getRemoteKeysForTarget(e).forEach((t) => {
      this.We(
        e,
        t,
        /*updatedDocument=*/
        null
      );
    });
  }
  /**
   * Returns whether the LocalStore considers the document to be part of the
   * specified target.
   */
  st(e, t) {
    return this.Be.getRemoteKeysForTarget(e).has(t);
  }
}
function __PRIVATE_documentTargetMap() {
  return new SortedMap(DocumentKey.comparator);
}
function __PRIVATE_snapshotChangesMap() {
  return new SortedMap(DocumentKey.comparator);
}
const Pe = (() => {
    const e = {
      asc: "ASCENDING",
      desc: "DESCENDING",
    };
    return e;
  })(),
  Ie = (() => {
    const e = {
      "<": "LESS_THAN",
      "<=": "LESS_THAN_OR_EQUAL",
      ">": "GREATER_THAN",
      ">=": "GREATER_THAN_OR_EQUAL",
      "==": "EQUAL",
      "!=": "NOT_EQUAL",
      "array-contains": "ARRAY_CONTAINS",
      in: "IN",
      "not-in": "NOT_IN",
      "array-contains-any": "ARRAY_CONTAINS_ANY",
    };
    return e;
  })(),
  Te = (() => {
    const e = {
      and: "AND",
      or: "OR",
    };
    return e;
  })();
class JsonProtoSerializer {
  constructor(e, t) {
    (this.databaseId = e), (this.useProto3Json = t);
  }
}
function __PRIVATE_toInt32Proto(e, t) {
  return e.useProto3Json || __PRIVATE_isNullOrUndefined(t)
    ? t
    : {
        value: t,
      };
}
function toTimestamp(e, t) {
  if (e.useProto3Json) {
    return `${new Date(1e3 * t.seconds)
      .toISOString()
      .replace(/\.\d*/, "")
      .replace("Z", "")}.${("000000000" + t.nanoseconds).slice(-9)}Z`;
  }
  return {
    seconds: "" + t.seconds,
    nanos: t.nanoseconds,
  };
}
function __PRIVATE_toBytes(e, t) {
  return e.useProto3Json ? t.toBase64() : t.toUint8Array();
}
function __PRIVATE_toVersion(e, t) {
  return toTimestamp(e, t.toTimestamp());
}
function __PRIVATE_fromVersion(e) {
  return (
    __PRIVATE_hardAssert(!!e),
    SnapshotVersion.fromTimestamp(
      (function fromTimestamp(e2) {
        const t = __PRIVATE_normalizeTimestamp(e2);
        return new Timestamp(t.seconds, t.nanos);
      })(e)
    )
  );
}
function __PRIVATE_toResourceName(e, t) {
  return __PRIVATE_toResourcePath(e, t).canonicalString();
}
function __PRIVATE_toResourcePath(e, t) {
  const n = (function __PRIVATE_fullyQualifiedPrefixPath(e2) {
    return new ResourcePath([
      "projects",
      e2.projectId,
      "databases",
      e2.database,
    ]);
  })(e).child("documents");
  return void 0 === t ? n : n.child(t);
}
function __PRIVATE_fromResourceName(e) {
  const t = ResourcePath.fromString(e);
  return __PRIVATE_hardAssert(__PRIVATE_isValidResourceName(t)), t;
}
function __PRIVATE_toName(e, t) {
  return __PRIVATE_toResourceName(e.databaseId, t.path);
}
function fromName(e, t) {
  const n = __PRIVATE_fromResourceName(t);
  if (n.get(1) !== e.databaseId.projectId)
    throw new FirestoreError(
      D.INVALID_ARGUMENT,
      "Tried to deserialize key from different project: " +
        n.get(1) +
        " vs " +
        e.databaseId.projectId
    );
  if (n.get(3) !== e.databaseId.database)
    throw new FirestoreError(
      D.INVALID_ARGUMENT,
      "Tried to deserialize key from different database: " +
        n.get(3) +
        " vs " +
        e.databaseId.database
    );
  return new DocumentKey(__PRIVATE_extractLocalPathFromResourceName(n));
}
function __PRIVATE_toQueryPath(e, t) {
  return __PRIVATE_toResourceName(e.databaseId, t);
}
function __PRIVATE_fromQueryPath(e) {
  const t = __PRIVATE_fromResourceName(e);
  return 4 === t.length
    ? ResourcePath.emptyPath()
    : __PRIVATE_extractLocalPathFromResourceName(t);
}
function __PRIVATE_getEncodedDatabaseId(e) {
  return new ResourcePath([
    "projects",
    e.databaseId.projectId,
    "databases",
    e.databaseId.database,
  ]).canonicalString();
}
function __PRIVATE_extractLocalPathFromResourceName(e) {
  return (
    __PRIVATE_hardAssert(e.length > 4 && "documents" === e.get(4)),
    e.popFirst(5)
  );
}
function __PRIVATE_toMutationDocument(e, t, n) {
  return {
    name: __PRIVATE_toName(e, t),
    fields: n.value.mapValue.fields,
  };
}
function __PRIVATE_fromWatchChange(e, t) {
  let n;
  if ("targetChange" in t) {
    t.targetChange;
    const r2 = (function __PRIVATE_fromWatchTargetChangeState(e2) {
        return "NO_CHANGE" === e2
          ? 0
          : "ADD" === e2
          ? 1
          : "REMOVE" === e2
          ? 2
          : "CURRENT" === e2
          ? 3
          : "RESET" === e2
          ? 4
          : fail();
      })(t.targetChange.targetChangeType || "NO_CHANGE"),
      i = t.targetChange.targetIds || [],
      s = (function __PRIVATE_fromBytes(e2, t2) {
        return e2.useProto3Json
          ? (__PRIVATE_hardAssert(void 0 === t2 || "string" == typeof t2),
            ByteString.fromBase64String(t2 || ""))
          : (__PRIVATE_hardAssert(
              void 0 === t2 || // Check if the value is an instance of both Buffer and Uint8Array,
                // despite the fact that Buffer extends Uint8Array. In some
                // environments, such as jsdom, the prototype chain of Buffer
                // does not indicate that it extends Uint8Array.
                t2 instanceof Buffer ||
                t2 instanceof Uint8Array
            ),
            ByteString.fromUint8Array(t2 || new Uint8Array()));
      })(e, t.targetChange.resumeToken),
      o = t.targetChange.cause,
      _ =
        o &&
        (function __PRIVATE_fromRpcStatus(e2) {
          const t2 =
            void 0 === e2.code
              ? D.UNKNOWN
              : __PRIVATE_mapCodeFromRpcCode(e2.code);
          return new FirestoreError(t2, e2.message || "");
        })(o);
    n = new __PRIVATE_WatchTargetChange(r2, i, s, _ || null);
  } else if ("documentChange" in t) {
    t.documentChange;
    const r2 = t.documentChange;
    r2.document, r2.document.name, r2.document.updateTime;
    const i = fromName(e, r2.document.name),
      s = __PRIVATE_fromVersion(r2.document.updateTime),
      o = r2.document.createTime
        ? __PRIVATE_fromVersion(r2.document.createTime)
        : SnapshotVersion.min(),
      _ = new ObjectValue({
        mapValue: {
          fields: r2.document.fields,
        },
      }),
      a = MutableDocument.newFoundDocument(i, s, o, _),
      u = r2.targetIds || [],
      c = r2.removedTargetIds || [];
    n = new __PRIVATE_DocumentWatchChange(u, c, a.key, a);
  } else if ("documentDelete" in t) {
    t.documentDelete;
    const r2 = t.documentDelete;
    r2.document;
    const i = fromName(e, r2.document),
      s = r2.readTime
        ? __PRIVATE_fromVersion(r2.readTime)
        : SnapshotVersion.min(),
      o = MutableDocument.newNoDocument(i, s),
      _ = r2.removedTargetIds || [];
    n = new __PRIVATE_DocumentWatchChange([], _, o.key, o);
  } else if ("documentRemove" in t) {
    t.documentRemove;
    const r2 = t.documentRemove;
    r2.document;
    const i = fromName(e, r2.document),
      s = r2.removedTargetIds || [];
    n = new __PRIVATE_DocumentWatchChange([], s, i, null);
  } else {
    if (!("filter" in t)) return fail();
    {
      t.filter;
      const e2 = t.filter;
      e2.targetId;
      const { count: r2 = 0, unchangedNames: i } = e2,
        s = new ExistenceFilter(r2, i),
        o = e2.targetId;
      n = new __PRIVATE_ExistenceFilterChange(o, s);
    }
  }
  return n;
}
function toMutation(e, t) {
  let n;
  if (t instanceof __PRIVATE_SetMutation)
    n = {
      update: __PRIVATE_toMutationDocument(e, t.key, t.value),
    };
  else if (t instanceof __PRIVATE_DeleteMutation)
    n = {
      delete: __PRIVATE_toName(e, t.key),
    };
  else if (t instanceof __PRIVATE_PatchMutation)
    n = {
      update: __PRIVATE_toMutationDocument(e, t.key, t.data),
      updateMask: __PRIVATE_toDocumentMask(t.fieldMask),
    };
  else {
    if (!(t instanceof __PRIVATE_VerifyMutation)) return fail();
    n = {
      verify: __PRIVATE_toName(e, t.key),
    };
  }
  return (
    t.fieldTransforms.length > 0 &&
      (n.updateTransforms = t.fieldTransforms.map((e2) =>
        (function __PRIVATE_toFieldTransform(e3, t2) {
          const n2 = t2.transform;
          if (n2 instanceof __PRIVATE_ServerTimestampTransform)
            return {
              fieldPath: t2.field.canonicalString(),
              setToServerValue: "REQUEST_TIME",
            };
          if (n2 instanceof __PRIVATE_ArrayUnionTransformOperation)
            return {
              fieldPath: t2.field.canonicalString(),
              appendMissingElements: {
                values: n2.elements,
              },
            };
          if (n2 instanceof __PRIVATE_ArrayRemoveTransformOperation)
            return {
              fieldPath: t2.field.canonicalString(),
              removeAllFromArray: {
                values: n2.elements,
              },
            };
          if (n2 instanceof __PRIVATE_NumericIncrementTransformOperation)
            return {
              fieldPath: t2.field.canonicalString(),
              increment: n2.Ie,
            };
          throw fail();
        })(0, e2)
      )),
    t.precondition.isNone ||
      (n.currentDocument = (function __PRIVATE_toPrecondition(e2, t2) {
        return void 0 !== t2.updateTime
          ? {
              updateTime: __PRIVATE_toVersion(e2, t2.updateTime),
            }
          : void 0 !== t2.exists
          ? {
              exists: t2.exists,
            }
          : fail();
      })(e, t.precondition)),
    n
  );
}
function __PRIVATE_fromWriteResults(e, t) {
  return e && e.length > 0
    ? (__PRIVATE_hardAssert(void 0 !== t),
      e.map((e2) =>
        (function __PRIVATE_fromWriteResult(e3, t2) {
          let n = e3.updateTime
            ? __PRIVATE_fromVersion(e3.updateTime)
            : __PRIVATE_fromVersion(t2);
          return (
            n.isEqual(SnapshotVersion.min()) && // The Firestore Emulator currently returns an update time of 0 for
              // deletes of non-existing documents (rather than null). This breaks the
              // test "get deleted doc while offline with source=cache" as NoDocuments
              // with version 0 are filtered by IndexedDb's RemoteDocumentCache.
              // TODO(#2149): Remove this when Emulator is fixed
              (n = __PRIVATE_fromVersion(t2)),
            new MutationResult(n, e3.transformResults || [])
          );
        })(e2, t)
      ))
    : [];
}
function __PRIVATE_toDocumentsTarget(e, t) {
  return {
    documents: [__PRIVATE_toQueryPath(e, t.path)],
  };
}
function __PRIVATE_toQueryTarget(e, t) {
  const n = {
      structuredQuery: {},
    },
    r2 = t.path;
  let i;
  null !== t.collectionGroup
    ? ((i = r2),
      (n.structuredQuery.from = [
        {
          collectionId: t.collectionGroup,
          allDescendants: true,
        },
      ]))
    : ((i = r2.popLast()),
      (n.structuredQuery.from = [
        {
          collectionId: r2.lastSegment(),
        },
      ])),
    (n.parent = __PRIVATE_toQueryPath(e, i));
  const s = (function __PRIVATE_toFilters(e2) {
    if (0 === e2.length) return;
    return __PRIVATE_toFilter(
      CompositeFilter.create(
        e2,
        "and"
        /* CompositeOperator.AND */
      )
    );
  })(t.filters);
  s && (n.structuredQuery.where = s);
  const o = (function __PRIVATE_toOrder(e2) {
    if (0 === e2.length) return;
    return e2.map((e3) =>
      // visible for testing
      (function __PRIVATE_toPropertyOrder(e4) {
        return {
          field: __PRIVATE_toFieldPathReference(e4.field),
          direction: __PRIVATE_toDirection(e4.dir),
        };
      })(e3)
    );
  })(t.orderBy);
  o && (n.structuredQuery.orderBy = o);
  const _ = __PRIVATE_toInt32Proto(e, t.limit);
  return (
    null !== _ && (n.structuredQuery.limit = _),
    t.startAt &&
      (n.structuredQuery.startAt = (function __PRIVATE_toStartAtCursor(e2) {
        return {
          before: e2.inclusive,
          values: e2.position,
        };
      })(t.startAt)),
    t.endAt &&
      (n.structuredQuery.endAt = (function __PRIVATE_toEndAtCursor(e2) {
        return {
          before: !e2.inclusive,
          values: e2.position,
        };
      })(t.endAt)),
    {
      ut: n,
      parent: i,
    }
  );
}
function __PRIVATE_convertQueryTargetToQuery(e) {
  let t = __PRIVATE_fromQueryPath(e.parent);
  const n = e.structuredQuery,
    r2 = n.from ? n.from.length : 0;
  let i = null;
  if (r2 > 0) {
    __PRIVATE_hardAssert(1 === r2);
    const e2 = n.from[0];
    e2.allDescendants ? (i = e2.collectionId) : (t = t.child(e2.collectionId));
  }
  let s = [];
  n.where &&
    (s = (function __PRIVATE_fromFilters(e2) {
      const t2 = __PRIVATE_fromFilter(e2);
      if (
        t2 instanceof CompositeFilter &&
        __PRIVATE_compositeFilterIsFlatConjunction(t2)
      )
        return t2.getFilters();
      return [t2];
    })(n.where));
  let o = [];
  n.orderBy &&
    (o = (function __PRIVATE_fromOrder(e2) {
      return e2.map((e3) =>
        (function __PRIVATE_fromPropertyOrder(e4) {
          return new OrderBy(
            __PRIVATE_fromFieldPathReference(e4.field),
            // visible for testing
            (function __PRIVATE_fromDirection(e5) {
              switch (e5) {
                case "ASCENDING":
                  return "asc";
                case "DESCENDING":
                  return "desc";
                default:
                  return;
              }
            })(e4.direction)
          );
        })(e3)
      );
    })(n.orderBy));
  let _ = null;
  n.limit &&
    (_ = (function __PRIVATE_fromInt32Proto(e2) {
      let t2;
      return (
        (t2 = "object" == typeof e2 ? e2.value : e2),
        __PRIVATE_isNullOrUndefined(t2) ? null : t2
      );
    })(n.limit));
  let a = null;
  n.startAt &&
    (a = (function __PRIVATE_fromStartAtCursor(e2) {
      const t2 = !!e2.before,
        n2 = e2.values || [];
      return new Bound(n2, t2);
    })(n.startAt));
  let u = null;
  return (
    n.endAt &&
      (u = (function __PRIVATE_fromEndAtCursor(e2) {
        const t2 = !e2.before,
          n2 = e2.values || [];
        return new Bound(n2, t2);
      })(n.endAt)),
    __PRIVATE_newQuery(t, i, o, s, _, "F", a, u)
  );
}
function __PRIVATE_toListenRequestLabels(e, t) {
  const n = (function __PRIVATE_toLabel(e2) {
    switch (e2) {
      case "TargetPurposeListen":
        return null;
      case "TargetPurposeExistenceFilterMismatch":
        return "existence-filter-mismatch";
      case "TargetPurposeExistenceFilterMismatchBloom":
        return "existence-filter-mismatch-bloom";
      case "TargetPurposeLimboResolution":
        return "limbo-document";
      default:
        return fail();
    }
  })(t.purpose);
  return null == n
    ? null
    : {
        "goog-listen-tags": n,
      };
}
function __PRIVATE_fromFilter(e) {
  return void 0 !== e.unaryFilter
    ? (function __PRIVATE_fromUnaryFilter(e2) {
        switch (e2.unaryFilter.op) {
          case "IS_NAN":
            const t = __PRIVATE_fromFieldPathReference(e2.unaryFilter.field);
            return FieldFilter.create(t, "==", {
              doubleValue: NaN,
            });
          case "IS_NULL":
            const n = __PRIVATE_fromFieldPathReference(e2.unaryFilter.field);
            return FieldFilter.create(n, "==", {
              nullValue: "NULL_VALUE",
            });
          case "IS_NOT_NAN":
            const r2 = __PRIVATE_fromFieldPathReference(e2.unaryFilter.field);
            return FieldFilter.create(r2, "!=", {
              doubleValue: NaN,
            });
          case "IS_NOT_NULL":
            const i = __PRIVATE_fromFieldPathReference(e2.unaryFilter.field);
            return FieldFilter.create(i, "!=", {
              nullValue: "NULL_VALUE",
            });
          default:
            return fail();
        }
      })(e)
    : void 0 !== e.fieldFilter
    ? (function __PRIVATE_fromFieldFilter(e2) {
        return FieldFilter.create(
          __PRIVATE_fromFieldPathReference(e2.fieldFilter.field),
          (function __PRIVATE_fromOperatorName(e3) {
            switch (e3) {
              case "EQUAL":
                return "==";
              case "NOT_EQUAL":
                return "!=";
              case "GREATER_THAN":
                return ">";
              case "GREATER_THAN_OR_EQUAL":
                return ">=";
              case "LESS_THAN":
                return "<";
              case "LESS_THAN_OR_EQUAL":
                return "<=";
              case "ARRAY_CONTAINS":
                return "array-contains";
              case "IN":
                return "in";
              case "NOT_IN":
                return "not-in";
              case "ARRAY_CONTAINS_ANY":
                return "array-contains-any";
              default:
                return fail();
            }
          })(e2.fieldFilter.op),
          e2.fieldFilter.value
        );
      })(e)
    : void 0 !== e.compositeFilter
    ? (function __PRIVATE_fromCompositeFilter(e2) {
        return CompositeFilter.create(
          e2.compositeFilter.filters.map((e3) => __PRIVATE_fromFilter(e3)),
          (function __PRIVATE_fromCompositeOperatorName(e3) {
            switch (e3) {
              case "AND":
                return "and";
              case "OR":
                return "or";
              default:
                return fail();
            }
          })(e2.compositeFilter.op)
        );
      })(e)
    : fail();
}
function __PRIVATE_toDirection(e) {
  return Pe[e];
}
function __PRIVATE_toOperatorName(e) {
  return Ie[e];
}
function __PRIVATE_toCompositeOperatorName(e) {
  return Te[e];
}
function __PRIVATE_toFieldPathReference(e) {
  return {
    fieldPath: e.canonicalString(),
  };
}
function __PRIVATE_fromFieldPathReference(e) {
  return FieldPath$1.fromServerFormat(e.fieldPath);
}
function __PRIVATE_toFilter(e) {
  return e instanceof FieldFilter
    ? (function __PRIVATE_toUnaryOrFieldFilter(e2) {
        if ("==" === e2.op) {
          if (__PRIVATE_isNanValue(e2.value))
            return {
              unaryFilter: {
                field: __PRIVATE_toFieldPathReference(e2.field),
                op: "IS_NAN",
              },
            };
          if (__PRIVATE_isNullValue(e2.value))
            return {
              unaryFilter: {
                field: __PRIVATE_toFieldPathReference(e2.field),
                op: "IS_NULL",
              },
            };
        } else if ("!=" === e2.op) {
          if (__PRIVATE_isNanValue(e2.value))
            return {
              unaryFilter: {
                field: __PRIVATE_toFieldPathReference(e2.field),
                op: "IS_NOT_NAN",
              },
            };
          if (__PRIVATE_isNullValue(e2.value))
            return {
              unaryFilter: {
                field: __PRIVATE_toFieldPathReference(e2.field),
                op: "IS_NOT_NULL",
              },
            };
        }
        return {
          fieldFilter: {
            field: __PRIVATE_toFieldPathReference(e2.field),
            op: __PRIVATE_toOperatorName(e2.op),
            value: e2.value,
          },
        };
      })(e)
    : e instanceof CompositeFilter
    ? (function __PRIVATE_toCompositeFilter(e2) {
        const t = e2.getFilters().map((e3) => __PRIVATE_toFilter(e3));
        if (1 === t.length) return t[0];
        return {
          compositeFilter: {
            op: __PRIVATE_toCompositeOperatorName(e2.op),
            filters: t,
          },
        };
      })(e)
    : fail();
}
function __PRIVATE_toDocumentMask(e) {
  const t = [];
  return (
    e.fields.forEach((e2) => t.push(e2.canonicalString())),
    {
      fieldPaths: t,
    }
  );
}
function __PRIVATE_isValidResourceName(e) {
  return e.length >= 4 && "projects" === e.get(0) && "databases" === e.get(2);
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class TargetData {
  constructor(
    e,
    t,
    n,
    r2,
    i = SnapshotVersion.min(),
    s = SnapshotVersion.min(),
    o = ByteString.EMPTY_BYTE_STRING,
    _ = null
  ) {
    (this.target = e),
      (this.targetId = t),
      (this.purpose = n),
      (this.sequenceNumber = r2),
      (this.snapshotVersion = i),
      (this.lastLimboFreeSnapshotVersion = s),
      (this.resumeToken = o),
      (this.expectedCount = _);
  }
  /** Creates a new target data instance with an updated sequence number. */
  withSequenceNumber(e) {
    return new TargetData(
      this.target,
      this.targetId,
      this.purpose,
      e,
      this.snapshotVersion,
      this.lastLimboFreeSnapshotVersion,
      this.resumeToken,
      this.expectedCount
    );
  }
  /**
   * Creates a new target data instance with an updated resume token and
   * snapshot version.
   */
  withResumeToken(e, t) {
    return new TargetData(
      this.target,
      this.targetId,
      this.purpose,
      this.sequenceNumber,
      t,
      this.lastLimboFreeSnapshotVersion,
      e,
      /* expectedCount= */
      null
    );
  }
  /**
   * Creates a new target data instance with an updated expected count.
   */
  withExpectedCount(e) {
    return new TargetData(
      this.target,
      this.targetId,
      this.purpose,
      this.sequenceNumber,
      this.snapshotVersion,
      this.lastLimboFreeSnapshotVersion,
      this.resumeToken,
      e
    );
  }
  /**
   * Creates a new target data instance with an updated last limbo free
   * snapshot version number.
   */
  withLastLimboFreeSnapshotVersion(e) {
    return new TargetData(
      this.target,
      this.targetId,
      this.purpose,
      this.sequenceNumber,
      this.snapshotVersion,
      e,
      this.resumeToken,
      this.expectedCount
    );
  }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class __PRIVATE_LocalSerializer {
  constructor(e) {
    this.ct = e;
  }
}
function __PRIVATE_fromBundledQuery(e) {
  const t = __PRIVATE_convertQueryTargetToQuery({
    parent: e.parent,
    structuredQuery: e.structuredQuery,
  });
  return "LAST" === e.limitType
    ? __PRIVATE_queryWithLimit(
        t,
        t.limit,
        "L"
        /* LimitType.Last */
      )
    : t;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class __PRIVATE_MemoryIndexManager {
  constructor() {
    this._n = new __PRIVATE_MemoryCollectionParentIndex();
  }
  addToCollectionParentIndex(e, t) {
    return this._n.add(t), PersistencePromise.resolve();
  }
  getCollectionParents(e, t) {
    return PersistencePromise.resolve(this._n.getEntries(t));
  }
  addFieldIndex(e, t) {
    return PersistencePromise.resolve();
  }
  deleteFieldIndex(e, t) {
    return PersistencePromise.resolve();
  }
  deleteAllFieldIndexes(e) {
    return PersistencePromise.resolve();
  }
  createTargetIndexes(e, t) {
    return PersistencePromise.resolve();
  }
  getDocumentsMatchingTarget(e, t) {
    return PersistencePromise.resolve(null);
  }
  getIndexType(e, t) {
    return PersistencePromise.resolve(
      0
      /* IndexType.NONE */
    );
  }
  getFieldIndexes(e, t) {
    return PersistencePromise.resolve([]);
  }
  getNextCollectionGroupToUpdate(e) {
    return PersistencePromise.resolve(null);
  }
  getMinOffset(e, t) {
    return PersistencePromise.resolve(IndexOffset.min());
  }
  getMinOffsetFromCollectionGroup(e, t) {
    return PersistencePromise.resolve(IndexOffset.min());
  }
  updateCollectionGroup(e, t, n) {
    return PersistencePromise.resolve();
  }
  updateIndexEntries(e, t) {
    return PersistencePromise.resolve();
  }
}
class __PRIVATE_MemoryCollectionParentIndex {
  constructor() {
    this.index = {};
  }
  // Returns false if the entry already existed.
  add(e) {
    const t = e.lastSegment(),
      n = e.popLast(),
      r2 = this.index[t] || new SortedSet(ResourcePath.comparator),
      i = !r2.has(n);
    return (this.index[t] = r2.add(n)), i;
  }
  has(e) {
    const t = e.lastSegment(),
      n = e.popLast(),
      r2 = this.index[t];
    return r2 && r2.has(n);
  }
  getEntries(e) {
    return (this.index[e] || new SortedSet(ResourcePath.comparator)).toArray();
  }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class __PRIVATE_TargetIdGenerator {
  constructor(e) {
    this.On = e;
  }
  next() {
    return (this.On += 2), this.On;
  }
  static Nn() {
    return new __PRIVATE_TargetIdGenerator(0);
  }
  static Ln() {
    return new __PRIVATE_TargetIdGenerator(-1);
  }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class RemoteDocumentChangeBuffer {
  constructor() {
    (this.changes = new ObjectMap(
      (e) => e.toString(),
      (e, t) => e.isEqual(t)
    )),
      (this.changesApplied = false);
  }
  /**
   * Buffers a `RemoteDocumentCache.addEntry()` call.
   *
   * You can only modify documents that have already been retrieved via
   * `getEntry()/getEntries()` (enforced via IndexedDbs `apply()`).
   */
  addEntry(e) {
    this.assertNotApplied(), this.changes.set(e.key, e);
  }
  /**
   * Buffers a `RemoteDocumentCache.removeEntry()` call.
   *
   * You can only remove documents that have already been retrieved via
   * `getEntry()/getEntries()` (enforced via IndexedDbs `apply()`).
   */
  removeEntry(e, t) {
    this.assertNotApplied(),
      this.changes.set(e, MutableDocument.newInvalidDocument(e).setReadTime(t));
  }
  /**
   * Looks up an entry in the cache. The buffered changes will first be checked,
   * and if no buffered change applies, this will forward to
   * `RemoteDocumentCache.getEntry()`.
   *
   * @param transaction - The transaction in which to perform any persistence
   *     operations.
   * @param documentKey - The key of the entry to look up.
   * @returns The cached document or an invalid document if we have nothing
   * cached.
   */
  getEntry(e, t) {
    this.assertNotApplied();
    const n = this.changes.get(t);
    return void 0 !== n
      ? PersistencePromise.resolve(n)
      : this.getFromCache(e, t);
  }
  /**
   * Looks up several entries in the cache, forwarding to
   * `RemoteDocumentCache.getEntry()`.
   *
   * @param transaction - The transaction in which to perform any persistence
   *     operations.
   * @param documentKeys - The keys of the entries to look up.
   * @returns A map of cached documents, indexed by key. If an entry cannot be
   *     found, the corresponding key will be mapped to an invalid document.
   */
  getEntries(e, t) {
    return this.getAllFromCache(e, t);
  }
  /**
   * Applies buffered changes to the underlying RemoteDocumentCache, using
   * the provided transaction.
   */
  apply(e) {
    return (
      this.assertNotApplied(),
      (this.changesApplied = true),
      this.applyChanges(e)
    );
  }
  /** Helper to assert this.changes is not null  */
  assertNotApplied() {}
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class OverlayedDocument {
  constructor(e, t) {
    (this.overlayedDocument = e), (this.mutatedFields = t);
  }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class LocalDocumentsView {
  constructor(e, t, n, r2) {
    (this.remoteDocumentCache = e),
      (this.mutationQueue = t),
      (this.documentOverlayCache = n),
      (this.indexManager = r2);
  }
  /**
   * Get the local view of the document identified by `key`.
   *
   * @returns Local view of the document or null if we don't have any cached
   * state for it.
   */
  getDocument(e, t) {
    let n = null;
    return this.documentOverlayCache
      .getOverlay(e, t)
      .next((r2) => ((n = r2), this.remoteDocumentCache.getEntry(e, t)))
      .next(
        (e2) => (
          null !== n &&
            __PRIVATE_mutationApplyToLocalView(
              n.mutation,
              e2,
              FieldMask.empty(),
              Timestamp.now()
            ),
          e2
        )
      );
  }
  /**
   * Gets the local view of the documents identified by `keys`.
   *
   * If we don't have cached state for a document in `keys`, a NoDocument will
   * be stored for that key in the resulting set.
   */
  getDocuments(e, t) {
    return this.remoteDocumentCache
      .getEntries(e, t)
      .next((t2) =>
        this.getLocalViewOfDocuments(e, t2, __PRIVATE_documentKeySet()).next(
          () => t2
        )
      );
  }
  /**
   * Similar to `getDocuments`, but creates the local view from the given
   * `baseDocs` without retrieving documents from the local store.
   *
   * @param transaction - The transaction this operation is scoped to.
   * @param docs - The documents to apply local mutations to get the local views.
   * @param existenceStateChanged - The set of document keys whose existence state
   *   is changed. This is useful to determine if some documents overlay needs
   *   to be recalculated.
   */
  getLocalViewOfDocuments(e, t, n = __PRIVATE_documentKeySet()) {
    const r2 = __PRIVATE_newOverlayMap();
    return this.populateOverlays(e, r2, t).next(() =>
      this.computeViews(e, t, r2, n).next((e2) => {
        let t2 = documentMap();
        return (
          e2.forEach((e3, n2) => {
            t2 = t2.insert(e3, n2.overlayedDocument);
          }),
          t2
        );
      })
    );
  }
  /**
   * Gets the overlayed documents for the given document map, which will include
   * the local view of those documents and a `FieldMask` indicating which fields
   * are mutated locally, `null` if overlay is a Set or Delete mutation.
   */
  getOverlayedDocuments(e, t) {
    const n = __PRIVATE_newOverlayMap();
    return this.populateOverlays(e, n, t).next(() =>
      this.computeViews(e, t, n, __PRIVATE_documentKeySet())
    );
  }
  /**
   * Fetches the overlays for {@code docs} and adds them to provided overlay map
   * if the map does not already contain an entry for the given document key.
   */
  populateOverlays(e, t, n) {
    const r2 = [];
    return (
      n.forEach((e2) => {
        t.has(e2) || r2.push(e2);
      }),
      this.documentOverlayCache.getOverlays(e, r2).next((e2) => {
        e2.forEach((e3, n2) => {
          t.set(e3, n2);
        });
      })
    );
  }
  /**
   * Computes the local view for the given documents.
   *
   * @param docs - The documents to compute views for. It also has the base
   *   version of the documents.
   * @param overlays - The overlays that need to be applied to the given base
   *   version of the documents.
   * @param existenceStateChanged - A set of documents whose existence states
   *   might have changed. This is used to determine if we need to re-calculate
   *   overlays from mutation queues.
   * @return A map represents the local documents view.
   */
  computeViews(e, t, n, r2) {
    let i = __PRIVATE_mutableDocumentMap();
    const s = __PRIVATE_newDocumentKeyMap(),
      o = (function __PRIVATE_newOverlayedDocumentMap() {
        return __PRIVATE_newDocumentKeyMap();
      })();
    return (
      t.forEach((e2, t2) => {
        const o2 = n.get(t2.key);
        r2.has(t2.key) &&
        (void 0 === o2 || o2.mutation instanceof __PRIVATE_PatchMutation)
          ? (i = i.insert(t2.key, t2))
          : void 0 !== o2
          ? (s.set(t2.key, o2.mutation.getFieldMask()),
            __PRIVATE_mutationApplyToLocalView(
              o2.mutation,
              t2,
              o2.mutation.getFieldMask(),
              Timestamp.now()
            ))
          : // no overlay exists
            // Using EMPTY to indicate there is no overlay for the document.
            s.set(t2.key, FieldMask.empty());
      }),
      this.recalculateAndSaveOverlays(e, i).next(
        (e2) => (
          e2.forEach((e3, t2) => s.set(e3, t2)),
          t.forEach((e3, t2) => {
            var n2;
            return o.set(
              e3,
              new OverlayedDocument(
                t2,
                null !== (n2 = s.get(e3)) && void 0 !== n2 ? n2 : null
              )
            );
          }),
          o
        )
      )
    );
  }
  recalculateAndSaveOverlays(e, t) {
    const n = __PRIVATE_newDocumentKeyMap();
    let r2 = new SortedMap((e2, t2) => e2 - t2),
      i = __PRIVATE_documentKeySet();
    return this.mutationQueue
      .getAllMutationBatchesAffectingDocumentKeys(e, t)
      .next((e2) => {
        for (const i2 of e2)
          i2.keys().forEach((e3) => {
            const s = t.get(e3);
            if (null === s) return;
            let o = n.get(e3) || FieldMask.empty();
            (o = i2.applyToLocalView(s, o)), n.set(e3, o);
            const _ = (r2.get(i2.batchId) || __PRIVATE_documentKeySet()).add(
              e3
            );
            r2 = r2.insert(i2.batchId, _);
          });
      })
      .next(() => {
        const s = [],
          o = r2.getReverseIterator();
        for (; o.hasNext(); ) {
          const r3 = o.getNext(),
            _ = r3.key,
            a = r3.value,
            u = __PRIVATE_newMutationMap();
          a.forEach((e2) => {
            if (!i.has(e2)) {
              const r4 = __PRIVATE_calculateOverlayMutation(
                t.get(e2),
                n.get(e2)
              );
              null !== r4 && u.set(e2, r4), (i = i.add(e2));
            }
          }),
            s.push(this.documentOverlayCache.saveOverlays(e, _, u));
        }
        return PersistencePromise.waitFor(s);
      })
      .next(() => n);
  }
  /**
   * Recalculates overlays by reading the documents from remote document cache
   * first, and saves them after they are calculated.
   */
  recalculateAndSaveOverlaysForDocumentKeys(e, t) {
    return this.remoteDocumentCache
      .getEntries(e, t)
      .next((t2) => this.recalculateAndSaveOverlays(e, t2));
  }
  /**
   * Performs a query against the local view of all documents.
   *
   * @param transaction - The persistence transaction.
   * @param query - The query to match documents against.
   * @param offset - Read time and key to start scanning by (exclusive).
   * @param context - A optional tracker to keep a record of important details
   *   during database local query execution.
   */
  getDocumentsMatchingQuery(e, t, n, r2) {
    return (function __PRIVATE_isDocumentQuery$1(e2) {
      return (
        DocumentKey.isDocumentKey(e2.path) &&
        null === e2.collectionGroup &&
        0 === e2.filters.length
      );
    })(t)
      ? this.getDocumentsMatchingDocumentQuery(e, t.path)
      : __PRIVATE_isCollectionGroupQuery(t)
      ? this.getDocumentsMatchingCollectionGroupQuery(e, t, n, r2)
      : this.getDocumentsMatchingCollectionQuery(e, t, n, r2);
  }
  /**
   * Given a collection group, returns the next documents that follow the provided offset, along
   * with an updated batch ID.
   *
   * <p>The documents returned by this method are ordered by remote version from the provided
   * offset. If there are no more remote documents after the provided offset, documents with
   * mutations in order of batch id from the offset are returned. Since all documents in a batch are
   * returned together, the total number of documents returned can exceed {@code count}.
   *
   * @param transaction
   * @param collectionGroup The collection group for the documents.
   * @param offset The offset to index into.
   * @param count The number of documents to return
   * @return A LocalWriteResult with the documents that follow the provided offset and the last processed batch id.
   */
  getNextDocuments(e, t, n, r2) {
    return this.remoteDocumentCache
      .getAllFromCollectionGroup(e, t, n, r2)
      .next((i) => {
        const s =
          r2 - i.size > 0
            ? this.documentOverlayCache.getOverlaysForCollectionGroup(
                e,
                t,
                n.largestBatchId,
                r2 - i.size
              )
            : PersistencePromise.resolve(__PRIVATE_newOverlayMap());
        let o = -1,
          _ = i;
        return s.next((t2) =>
          PersistencePromise.forEach(
            t2,
            (t3, n2) => (
              o < n2.largestBatchId && (o = n2.largestBatchId),
              i.get(t3)
                ? PersistencePromise.resolve()
                : this.remoteDocumentCache.getEntry(e, t3).next((e2) => {
                    _ = _.insert(t3, e2);
                  })
            )
          )
            .next(() => this.populateOverlays(e, t2, i))
            .next(() => this.computeViews(e, _, t2, __PRIVATE_documentKeySet()))
            .next((e2) => ({
              batchId: o,
              changes: __PRIVATE_convertOverlayedDocumentMapToDocumentMap(e2),
            }))
        );
      });
  }
  getDocumentsMatchingDocumentQuery(e, t) {
    return this.getDocument(e, new DocumentKey(t)).next((e2) => {
      let t2 = documentMap();
      return e2.isFoundDocument() && (t2 = t2.insert(e2.key, e2)), t2;
    });
  }
  getDocumentsMatchingCollectionGroupQuery(e, t, n, r2) {
    const i = t.collectionGroup;
    let s = documentMap();
    return this.indexManager.getCollectionParents(e, i).next((o) =>
      PersistencePromise.forEach(o, (o2) => {
        const _ = (function __PRIVATE_asCollectionQueryAtPath(e2, t2) {
          return new __PRIVATE_QueryImpl(
            t2,
            /*collectionGroup=*/
            null,
            e2.explicitOrderBy.slice(),
            e2.filters.slice(),
            e2.limit,
            e2.limitType,
            e2.startAt,
            e2.endAt
          );
        })(t, o2.child(i));
        return this.getDocumentsMatchingCollectionQuery(e, _, n, r2).next(
          (e2) => {
            e2.forEach((e3, t2) => {
              s = s.insert(e3, t2);
            });
          }
        );
      }).next(() => s)
    );
  }
  getDocumentsMatchingCollectionQuery(e, t, n, r2) {
    let i;
    return this.documentOverlayCache
      .getOverlaysForCollection(e, t.path, n.largestBatchId)
      .next(
        (s) => (
          (i = s),
          this.remoteDocumentCache.getDocumentsMatchingQuery(e, t, n, i, r2)
        )
      )
      .next((e2) => {
        i.forEach((t2, n3) => {
          const r3 = n3.getKey();
          null === e2.get(r3) &&
            (e2 = e2.insert(r3, MutableDocument.newInvalidDocument(r3)));
        });
        let n2 = documentMap();
        return (
          e2.forEach((e3, r3) => {
            const s = i.get(e3);
            void 0 !== s &&
              __PRIVATE_mutationApplyToLocalView(
                s.mutation,
                r3,
                FieldMask.empty(),
                Timestamp.now()
              ), // Finally, insert the documents that still match the query
              __PRIVATE_queryMatches(t, r3) && (n2 = n2.insert(e3, r3));
          }),
          n2
        );
      });
  }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class __PRIVATE_MemoryBundleCache {
  constructor(e) {
    (this.serializer = e),
      (this.cr = /* @__PURE__ */ new Map()),
      (this.lr = /* @__PURE__ */ new Map());
  }
  getBundleMetadata(e, t) {
    return PersistencePromise.resolve(this.cr.get(t));
  }
  saveBundleMetadata(e, t) {
    return (
      this.cr.set(
        t.id,
        /** Decodes a BundleMetadata proto into a BundleMetadata object. */
        (function __PRIVATE_fromBundleMetadata(e2) {
          return {
            id: e2.id,
            version: e2.version,
            createTime: __PRIVATE_fromVersion(e2.createTime),
          };
        })(t)
      ),
      PersistencePromise.resolve()
    );
  }
  getNamedQuery(e, t) {
    return PersistencePromise.resolve(this.lr.get(t));
  }
  saveNamedQuery(e, t) {
    return (
      this.lr.set(
        t.name,
        (function __PRIVATE_fromProtoNamedQuery(e2) {
          return {
            name: e2.name,
            query: __PRIVATE_fromBundledQuery(e2.bundledQuery),
            readTime: __PRIVATE_fromVersion(e2.readTime),
          };
        })(t)
      ),
      PersistencePromise.resolve()
    );
  }
}
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class __PRIVATE_MemoryDocumentOverlayCache {
  constructor() {
    (this.overlays = new SortedMap(DocumentKey.comparator)),
      (this.hr = /* @__PURE__ */ new Map());
  }
  getOverlay(e, t) {
    return PersistencePromise.resolve(this.overlays.get(t));
  }
  getOverlays(e, t) {
    const n = __PRIVATE_newOverlayMap();
    return PersistencePromise.forEach(t, (t2) =>
      this.getOverlay(e, t2).next((e2) => {
        null !== e2 && n.set(t2, e2);
      })
    ).next(() => n);
  }
  saveOverlays(e, t, n) {
    return (
      n.forEach((n2, r2) => {
        this.ht(e, t, r2);
      }),
      PersistencePromise.resolve()
    );
  }
  removeOverlaysForBatchId(e, t, n) {
    const r2 = this.hr.get(n);
    return (
      void 0 !== r2 &&
        (r2.forEach((e2) => (this.overlays = this.overlays.remove(e2))),
        this.hr.delete(n)),
      PersistencePromise.resolve()
    );
  }
  getOverlaysForCollection(e, t, n) {
    const r2 = __PRIVATE_newOverlayMap(),
      i = t.length + 1,
      s = new DocumentKey(t.child("")),
      o = this.overlays.getIteratorFrom(s);
    for (; o.hasNext(); ) {
      const e2 = o.getNext().value,
        s2 = e2.getKey();
      if (!t.isPrefixOf(s2.path)) break;
      s2.path.length === i && e2.largestBatchId > n && r2.set(e2.getKey(), e2);
    }
    return PersistencePromise.resolve(r2);
  }
  getOverlaysForCollectionGroup(e, t, n, r2) {
    let i = new SortedMap((e2, t2) => e2 - t2);
    const s = this.overlays.getIterator();
    for (; s.hasNext(); ) {
      const e2 = s.getNext().value;
      if (e2.getKey().getCollectionGroup() === t && e2.largestBatchId > n) {
        let t2 = i.get(e2.largestBatchId);
        null === t2 &&
          ((t2 = __PRIVATE_newOverlayMap()),
          (i = i.insert(e2.largestBatchId, t2))),
          t2.set(e2.getKey(), e2);
      }
    }
    const o = __PRIVATE_newOverlayMap(),
      _ = i.getIterator();
    for (; _.hasNext(); ) {
      if (
        (_.getNext().value.forEach((e2, t2) => o.set(e2, t2)), o.size() >= r2)
      )
        break;
    }
    return PersistencePromise.resolve(o);
  }
  ht(e, t, n) {
    const r2 = this.overlays.get(n.key);
    if (null !== r2) {
      const e2 = this.hr.get(r2.largestBatchId).delete(n.key);
      this.hr.set(r2.largestBatchId, e2);
    }
    this.overlays = this.overlays.insert(n.key, new Overlay(t, n));
    let i = this.hr.get(t);
    void 0 === i && ((i = __PRIVATE_documentKeySet()), this.hr.set(t, i)),
      this.hr.set(t, i.add(n.key));
  }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class __PRIVATE_ReferenceSet {
  constructor() {
    (this.Pr = new SortedSet(__PRIVATE_DocReference.Ir)), // A set of outstanding references to a document sorted by target id.
      (this.Tr = new SortedSet(__PRIVATE_DocReference.Er));
  }
  /** Returns true if the reference set contains no references. */
  isEmpty() {
    return this.Pr.isEmpty();
  }
  /** Adds a reference to the given document key for the given ID. */
  addReference(e, t) {
    const n = new __PRIVATE_DocReference(e, t);
    (this.Pr = this.Pr.add(n)), (this.Tr = this.Tr.add(n));
  }
  /** Add references to the given document keys for the given ID. */
  dr(e, t) {
    e.forEach((e2) => this.addReference(e2, t));
  }
  /**
   * Removes a reference to the given document key for the given
   * ID.
   */
  removeReference(e, t) {
    this.Ar(new __PRIVATE_DocReference(e, t));
  }
  Rr(e, t) {
    e.forEach((e2) => this.removeReference(e2, t));
  }
  /**
   * Clears all references with a given ID. Calls removeRef() for each key
   * removed.
   */
  Vr(e) {
    const t = new DocumentKey(new ResourcePath([])),
      n = new __PRIVATE_DocReference(t, e),
      r2 = new __PRIVATE_DocReference(t, e + 1),
      i = [];
    return (
      this.Tr.forEachInRange([n, r2], (e2) => {
        this.Ar(e2), i.push(e2.key);
      }),
      i
    );
  }
  mr() {
    this.Pr.forEach((e) => this.Ar(e));
  }
  Ar(e) {
    (this.Pr = this.Pr.delete(e)), (this.Tr = this.Tr.delete(e));
  }
  gr(e) {
    const t = new DocumentKey(new ResourcePath([])),
      n = new __PRIVATE_DocReference(t, e),
      r2 = new __PRIVATE_DocReference(t, e + 1);
    let i = __PRIVATE_documentKeySet();
    return (
      this.Tr.forEachInRange([n, r2], (e2) => {
        i = i.add(e2.key);
      }),
      i
    );
  }
  containsKey(e) {
    const t = new __PRIVATE_DocReference(e, 0),
      n = this.Pr.firstAfterOrEqual(t);
    return null !== n && e.isEqual(n.key);
  }
}
class __PRIVATE_DocReference {
  constructor(e, t) {
    (this.key = e), (this.pr = t);
  }
  /** Compare by key then by ID */
  static Ir(e, t) {
    return (
      DocumentKey.comparator(e.key, t.key) ||
      __PRIVATE_primitiveComparator(e.pr, t.pr)
    );
  }
  /** Compare by ID then by key */
  static Er(e, t) {
    return (
      __PRIVATE_primitiveComparator(e.pr, t.pr) ||
      DocumentKey.comparator(e.key, t.key)
    );
  }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class __PRIVATE_MemoryMutationQueue {
  constructor(e, t) {
    (this.indexManager = e),
      (this.referenceDelegate = t),
      /**
       * The set of all mutations that have been sent but not yet been applied to
       * the backend.
       */ (this.mutationQueue =
        []) /** Next value to use when assigning sequential IDs to each mutation batch. */,
      (this.yr = 1) /** An ordered mapping between documents and the mutations batch IDs. */,
      (this.wr = new SortedSet(__PRIVATE_DocReference.Ir));
  }
  checkEmpty(e) {
    return PersistencePromise.resolve(0 === this.mutationQueue.length);
  }
  addMutationBatch(e, t, n, r2) {
    const i = this.yr;
    this.yr++,
      this.mutationQueue.length > 0 &&
        this.mutationQueue[this.mutationQueue.length - 1];
    const s = new MutationBatch(i, t, n, r2);
    this.mutationQueue.push(s);
    for (const t2 of r2)
      (this.wr = this.wr.add(new __PRIVATE_DocReference(t2.key, i))),
        this.indexManager.addToCollectionParentIndex(e, t2.key.path.popLast());
    return PersistencePromise.resolve(s);
  }
  lookupMutationBatch(e, t) {
    return PersistencePromise.resolve(this.Sr(t));
  }
  getNextMutationBatchAfterBatchId(e, t) {
    const n = t + 1,
      r2 = this.br(n),
      i = r2 < 0 ? 0 : r2;
    return PersistencePromise.resolve(
      this.mutationQueue.length > i ? this.mutationQueue[i] : null
    );
  }
  getHighestUnacknowledgedBatchId() {
    return PersistencePromise.resolve(
      0 === this.mutationQueue.length ? -1 : this.yr - 1
    );
  }
  getAllMutationBatches(e) {
    return PersistencePromise.resolve(this.mutationQueue.slice());
  }
  getAllMutationBatchesAffectingDocumentKey(e, t) {
    const n = new __PRIVATE_DocReference(t, 0),
      r2 = new __PRIVATE_DocReference(t, Number.POSITIVE_INFINITY),
      i = [];
    return (
      this.wr.forEachInRange([n, r2], (e2) => {
        const t2 = this.Sr(e2.pr);
        i.push(t2);
      }),
      PersistencePromise.resolve(i)
    );
  }
  getAllMutationBatchesAffectingDocumentKeys(e, t) {
    let n = new SortedSet(__PRIVATE_primitiveComparator);
    return (
      t.forEach((e2) => {
        const t2 = new __PRIVATE_DocReference(e2, 0),
          r2 = new __PRIVATE_DocReference(e2, Number.POSITIVE_INFINITY);
        this.wr.forEachInRange([t2, r2], (e3) => {
          n = n.add(e3.pr);
        });
      }),
      PersistencePromise.resolve(this.Dr(n))
    );
  }
  getAllMutationBatchesAffectingQuery(e, t) {
    const n = t.path,
      r2 = n.length + 1;
    let i = n;
    DocumentKey.isDocumentKey(i) || (i = i.child(""));
    const s = new __PRIVATE_DocReference(new DocumentKey(i), 0);
    let o = new SortedSet(__PRIVATE_primitiveComparator);
    return (
      this.wr.forEachWhile((e2) => {
        const t2 = e2.key.path;
        return (
          !!n.isPrefixOf(t2) && // Rows with document keys more than one segment longer than the query
          // path can't be matches. For example, a query on 'rooms' can't match
          // the document /rooms/abc/messages/xyx.
          // TODO(mcg): we'll need a different scanner when we implement
          // ancestor queries.
          (t2.length === r2 && (o = o.add(e2.pr)), true)
        );
      }, s),
      PersistencePromise.resolve(this.Dr(o))
    );
  }
  Dr(e) {
    const t = [];
    return (
      e.forEach((e2) => {
        const n = this.Sr(e2);
        null !== n && t.push(n);
      }),
      t
    );
  }
  removeMutationBatch(e, t) {
    __PRIVATE_hardAssert(0 === this.Cr(t.batchId, "removed")),
      this.mutationQueue.shift();
    let n = this.wr;
    return PersistencePromise.forEach(t.mutations, (r2) => {
      const i = new __PRIVATE_DocReference(r2.key, t.batchId);
      return (
        (n = n.delete(i)),
        this.referenceDelegate.markPotentiallyOrphaned(e, r2.key)
      );
    }).next(() => {
      this.wr = n;
    });
  }
  Mn(e) {}
  containsKey(e, t) {
    const n = new __PRIVATE_DocReference(t, 0),
      r2 = this.wr.firstAfterOrEqual(n);
    return PersistencePromise.resolve(t.isEqual(r2 && r2.key));
  }
  performConsistencyCheck(e) {
    return this.mutationQueue.length, PersistencePromise.resolve();
  }
  /**
   * Finds the index of the given batchId in the mutation queue and asserts that
   * the resulting index is within the bounds of the queue.
   *
   * @param batchId - The batchId to search for
   * @param action - A description of what the caller is doing, phrased in passive
   * form (e.g. "acknowledged" in a routine that acknowledges batches).
   */
  Cr(e, t) {
    return this.br(e);
  }
  /**
   * Finds the index of the given batchId in the mutation queue. This operation
   * is O(1).
   *
   * @returns The computed index of the batch with the given batchId, based on
   * the state of the queue. Note this index can be negative if the requested
   * batchId has already been remvoed from the queue or past the end of the
   * queue if the batchId is larger than the last added batch.
   */
  br(e) {
    if (0 === this.mutationQueue.length) return 0;
    return e - this.mutationQueue[0].batchId;
  }
  /**
   * A version of lookupMutationBatch that doesn't return a promise, this makes
   * other functions that uses this code easier to read and more efficent.
   */
  Sr(e) {
    const t = this.br(e);
    if (t < 0 || t >= this.mutationQueue.length) return null;
    return this.mutationQueue[t];
  }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class __PRIVATE_MemoryRemoteDocumentCacheImpl {
  /**
   * @param sizer - Used to assess the size of a document. For eager GC, this is
   * expected to just return 0 to avoid unnecessarily doing the work of
   * calculating the size.
   */
  constructor(e) {
    (this.vr = e) /** Underlying cache of documents and their read times. */,
      (this.docs = (function __PRIVATE_documentEntryMap() {
        return new SortedMap(DocumentKey.comparator);
      })()) /** Size of all cached documents. */,
      (this.size = 0);
  }
  setIndexManager(e) {
    this.indexManager = e;
  }
  /**
   * Adds the supplied entry to the cache and updates the cache size as appropriate.
   *
   * All calls of `addEntry`  are required to go through the RemoteDocumentChangeBuffer
   * returned by `newChangeBuffer()`.
   */
  addEntry(e, t) {
    const n = t.key,
      r2 = this.docs.get(n),
      i = r2 ? r2.size : 0,
      s = this.vr(t);
    return (
      (this.docs = this.docs.insert(n, {
        document: t.mutableCopy(),
        size: s,
      })),
      (this.size += s - i),
      this.indexManager.addToCollectionParentIndex(e, n.path.popLast())
    );
  }
  /**
   * Removes the specified entry from the cache and updates the cache size as appropriate.
   *
   * All calls of `removeEntry` are required to go through the RemoteDocumentChangeBuffer
   * returned by `newChangeBuffer()`.
   */
  removeEntry(e) {
    const t = this.docs.get(e);
    t && ((this.docs = this.docs.remove(e)), (this.size -= t.size));
  }
  getEntry(e, t) {
    const n = this.docs.get(t);
    return PersistencePromise.resolve(
      n ? n.document.mutableCopy() : MutableDocument.newInvalidDocument(t)
    );
  }
  getEntries(e, t) {
    let n = __PRIVATE_mutableDocumentMap();
    return (
      t.forEach((e2) => {
        const t2 = this.docs.get(e2);
        n = n.insert(
          e2,
          t2
            ? t2.document.mutableCopy()
            : MutableDocument.newInvalidDocument(e2)
        );
      }),
      PersistencePromise.resolve(n)
    );
  }
  getDocumentsMatchingQuery(e, t, n, r2) {
    let i = __PRIVATE_mutableDocumentMap();
    const s = t.path,
      o = new DocumentKey(s.child("")),
      _ = this.docs.getIteratorFrom(o);
    for (; _.hasNext(); ) {
      const {
        key: e2,
        value: { document: o2 },
      } = _.getNext();
      if (!s.isPrefixOf(e2.path)) break;
      e2.path.length > s.length + 1 ||
        __PRIVATE_indexOffsetComparator(
          __PRIVATE_newIndexOffsetFromDocument(o2),
          n
        ) <= 0 ||
        ((r2.has(o2.key) || __PRIVATE_queryMatches(t, o2)) &&
          (i = i.insert(o2.key, o2.mutableCopy())));
    }
    return PersistencePromise.resolve(i);
  }
  getAllFromCollectionGroup(e, t, n, r2) {
    fail();
  }
  Fr(e, t) {
    return PersistencePromise.forEach(this.docs, (e2) => t(e2));
  }
  newChangeBuffer(e) {
    return new __PRIVATE_MemoryRemoteDocumentChangeBuffer(this);
  }
  getSize(e) {
    return PersistencePromise.resolve(this.size);
  }
}
class __PRIVATE_MemoryRemoteDocumentChangeBuffer extends RemoteDocumentChangeBuffer {
  constructor(e) {
    super(), (this.ar = e);
  }
  applyChanges(e) {
    const t = [];
    return (
      this.changes.forEach((n, r2) => {
        r2.isValidDocument()
          ? t.push(this.ar.addEntry(e, r2))
          : this.ar.removeEntry(n);
      }),
      PersistencePromise.waitFor(t)
    );
  }
  getFromCache(e, t) {
    return this.ar.getEntry(e, t);
  }
  getAllFromCache(e, t) {
    return this.ar.getEntries(e, t);
  }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class __PRIVATE_MemoryTargetCache {
  constructor(e) {
    (this.persistence = e),
      /**
       * Maps a target to the data about that target
       */ (this.Mr = new ObjectMap(
        (e2) => __PRIVATE_canonifyTarget(e2),
        __PRIVATE_targetEquals
      )) /** The last received snapshot version. */,
      (this.lastRemoteSnapshotVersion =
        SnapshotVersion.min()) /** The highest numbered target ID encountered. */,
      (this.highestTargetId = 0) /** The highest sequence number encountered. */,
      (this.Or = 0),
      /**
       * A ordered bidirectional mapping between documents and the remote target
       * IDs.
       */ (this.Nr = new __PRIVATE_ReferenceSet()),
      (this.targetCount = 0),
      (this.Lr = __PRIVATE_TargetIdGenerator.Nn());
  }
  forEachTarget(e, t) {
    return this.Mr.forEach((e2, n) => t(n)), PersistencePromise.resolve();
  }
  getLastRemoteSnapshotVersion(e) {
    return PersistencePromise.resolve(this.lastRemoteSnapshotVersion);
  }
  getHighestSequenceNumber(e) {
    return PersistencePromise.resolve(this.Or);
  }
  allocateTargetId(e) {
    return (
      (this.highestTargetId = this.Lr.next()),
      PersistencePromise.resolve(this.highestTargetId)
    );
  }
  setTargetsMetadata(e, t, n) {
    return (
      n && (this.lastRemoteSnapshotVersion = n),
      t > this.Or && (this.Or = t),
      PersistencePromise.resolve()
    );
  }
  qn(e) {
    this.Mr.set(e.target, e);
    const t = e.targetId;
    t > this.highestTargetId &&
      ((this.Lr = new __PRIVATE_TargetIdGenerator(t)),
      (this.highestTargetId = t)),
      e.sequenceNumber > this.Or && (this.Or = e.sequenceNumber);
  }
  addTargetData(e, t) {
    return this.qn(t), (this.targetCount += 1), PersistencePromise.resolve();
  }
  updateTargetData(e, t) {
    return this.qn(t), PersistencePromise.resolve();
  }
  removeTargetData(e, t) {
    return (
      this.Mr.delete(t.target),
      this.Nr.Vr(t.targetId),
      (this.targetCount -= 1),
      PersistencePromise.resolve()
    );
  }
  removeTargets(e, t, n) {
    let r2 = 0;
    const i = [];
    return (
      this.Mr.forEach((s, o) => {
        o.sequenceNumber <= t &&
          null === n.get(o.targetId) &&
          (this.Mr.delete(s),
          i.push(this.removeMatchingKeysForTargetId(e, o.targetId)),
          r2++);
      }),
      PersistencePromise.waitFor(i).next(() => r2)
    );
  }
  getTargetCount(e) {
    return PersistencePromise.resolve(this.targetCount);
  }
  getTargetData(e, t) {
    const n = this.Mr.get(t) || null;
    return PersistencePromise.resolve(n);
  }
  addMatchingKeys(e, t, n) {
    return this.Nr.dr(t, n), PersistencePromise.resolve();
  }
  removeMatchingKeys(e, t, n) {
    this.Nr.Rr(t, n);
    const r2 = this.persistence.referenceDelegate,
      i = [];
    return (
      r2 &&
        t.forEach((t2) => {
          i.push(r2.markPotentiallyOrphaned(e, t2));
        }),
      PersistencePromise.waitFor(i)
    );
  }
  removeMatchingKeysForTargetId(e, t) {
    return this.Nr.Vr(t), PersistencePromise.resolve();
  }
  getMatchingKeysForTargetId(e, t) {
    const n = this.Nr.gr(t);
    return PersistencePromise.resolve(n);
  }
  containsKey(e, t) {
    return PersistencePromise.resolve(this.Nr.containsKey(t));
  }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class __PRIVATE_MemoryPersistence {
  /**
   * The constructor accepts a factory for creating a reference delegate. This
   * allows both the delegate and this instance to have strong references to
   * each other without having nullable fields that would then need to be
   * checked or asserted on every access.
   */
  constructor(e, t) {
    (this.Br = {}),
      (this.overlays = {}),
      (this.kr = new __PRIVATE_ListenSequence(0)),
      (this.qr = false),
      (this.qr = true),
      (this.referenceDelegate = e(this)),
      (this.Qr = new __PRIVATE_MemoryTargetCache(this));
    (this.indexManager = new __PRIVATE_MemoryIndexManager()),
      (this.remoteDocumentCache =
        (function __PRIVATE_newMemoryRemoteDocumentCache(e2) {
          return new __PRIVATE_MemoryRemoteDocumentCacheImpl(e2);
        })((e2) => this.referenceDelegate.Kr(e2))),
      (this.serializer = new __PRIVATE_LocalSerializer(t)),
      (this.$r = new __PRIVATE_MemoryBundleCache(this.serializer));
  }
  start() {
    return Promise.resolve();
  }
  shutdown() {
    return (this.qr = false), Promise.resolve();
  }
  get started() {
    return this.qr;
  }
  setDatabaseDeletedListener() {}
  setNetworkEnabled() {}
  getIndexManager(e) {
    return this.indexManager;
  }
  getDocumentOverlayCache(e) {
    let t = this.overlays[e.toKey()];
    return (
      t ||
        ((t = new __PRIVATE_MemoryDocumentOverlayCache()),
        (this.overlays[e.toKey()] = t)),
      t
    );
  }
  getMutationQueue(e, t) {
    let n = this.Br[e.toKey()];
    return (
      n ||
        ((n = new __PRIVATE_MemoryMutationQueue(t, this.referenceDelegate)),
        (this.Br[e.toKey()] = n)),
      n
    );
  }
  getTargetCache() {
    return this.Qr;
  }
  getRemoteDocumentCache() {
    return this.remoteDocumentCache;
  }
  getBundleCache() {
    return this.$r;
  }
  runTransaction(e, t, n) {
    __PRIVATE_logDebug("MemoryPersistence", "Starting transaction:", e);
    const r2 = new __PRIVATE_MemoryTransaction(this.kr.next());
    return (
      this.referenceDelegate.Ur(),
      n(r2)
        .next((e2) => this.referenceDelegate.Wr(r2).next(() => e2))
        .toPromise()
        .then((e2) => (r2.raiseOnCommittedEvent(), e2))
    );
  }
  Gr(e, t) {
    return PersistencePromise.or(
      Object.values(this.Br).map((n) => () => n.containsKey(e, t))
    );
  }
}
class __PRIVATE_MemoryTransaction extends PersistenceTransaction {
  constructor(e) {
    super(), (this.currentSequenceNumber = e);
  }
}
class __PRIVATE_MemoryEagerDelegate {
  constructor(e) {
    (this.persistence =
      e) /** Tracks all documents that are active in Query views. */,
      (this.zr =
        new __PRIVATE_ReferenceSet()) /** The list of documents that are potentially GCed after each transaction. */,
      (this.jr = null);
  }
  static Hr(e) {
    return new __PRIVATE_MemoryEagerDelegate(e);
  }
  get Jr() {
    if (this.jr) return this.jr;
    throw fail();
  }
  addReference(e, t, n) {
    return (
      this.zr.addReference(n, t),
      this.Jr.delete(n.toString()),
      PersistencePromise.resolve()
    );
  }
  removeReference(e, t, n) {
    return (
      this.zr.removeReference(n, t),
      this.Jr.add(n.toString()),
      PersistencePromise.resolve()
    );
  }
  markPotentiallyOrphaned(e, t) {
    return this.Jr.add(t.toString()), PersistencePromise.resolve();
  }
  removeTarget(e, t) {
    this.zr.Vr(t.targetId).forEach((e2) => this.Jr.add(e2.toString()));
    const n = this.persistence.getTargetCache();
    return n
      .getMatchingKeysForTargetId(e, t.targetId)
      .next((e2) => {
        e2.forEach((e3) => this.Jr.add(e3.toString()));
      })
      .next(() => n.removeTargetData(e, t));
  }
  Ur() {
    this.jr = /* @__PURE__ */ new Set();
  }
  Wr(e) {
    const t = this.persistence.getRemoteDocumentCache().newChangeBuffer();
    return PersistencePromise.forEach(this.Jr, (n) => {
      const r2 = DocumentKey.fromPath(n);
      return this.Yr(e, r2).next((e2) => {
        e2 || t.removeEntry(r2, SnapshotVersion.min());
      });
    }).next(() => ((this.jr = null), t.apply(e)));
  }
  updateLimboDocument(e, t) {
    return this.Yr(e, t).next((e2) => {
      e2 ? this.Jr.delete(t.toString()) : this.Jr.add(t.toString());
    });
  }
  Kr(e) {
    return 0;
  }
  Yr(e, t) {
    return PersistencePromise.or([
      () => PersistencePromise.resolve(this.zr.containsKey(t)),
      () => this.persistence.getTargetCache().containsKey(e, t),
      () => this.persistence.Gr(e, t),
    ]);
  }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class __PRIVATE_LocalViewChanges {
  constructor(e, t, n, r2) {
    (this.targetId = e), (this.fromCache = t), (this.qi = n), (this.Qi = r2);
  }
  static Ki(e, t) {
    let n = __PRIVATE_documentKeySet(),
      r2 = __PRIVATE_documentKeySet();
    for (const e2 of t.docChanges)
      switch (e2.type) {
        case 0:
          n = n.add(e2.doc.key);
          break;
        case 1:
          r2 = r2.add(e2.doc.key);
      }
    return new __PRIVATE_LocalViewChanges(e, t.fromCache, n, r2);
  }
}
/**
 * @license
 * Copyright 2023 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class QueryContext {
  constructor() {
    this._documentReadCount = 0;
  }
  get documentReadCount() {
    return this._documentReadCount;
  }
  incrementDocumentReadCount(e) {
    this._documentReadCount += e;
  }
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class __PRIVATE_QueryEngine {
  constructor() {
    (this.$i = false),
      (this.Ui = false),
      /**
       * SDK only decides whether it should create index when collection size is
       * larger than this.
       */ (this.Wi = 100),
      (this.Gi =
        /**
         * This cost represents the evaluation result of
         * (([index, docKey] + [docKey, docContent]) per document in the result set)
         * / ([docKey, docContent] per documents in full collection scan) coming from
         * experiment [enter PR experiment URL here].
         */
        (function __PRIVATE_getDefaultRelativeIndexReadCostPerDocument() {
          return isSafari() ? 8 : __PRIVATE_SimpleDb.v(getUA()) > 0 ? 6 : 4;
        })());
  }
  /** Sets the document view to query against. */
  initialize(e, t) {
    (this.zi = e), (this.indexManager = t), (this.$i = true);
  }
  /** Returns all local documents matching the specified query. */
  getDocumentsMatchingQuery(e, t, n, r2) {
    const i = {
      result: null,
    };
    return this.ji(e, t)
      .next((e2) => {
        i.result = e2;
      })
      .next(() => {
        if (!i.result)
          return this.Hi(e, t, r2, n).next((e2) => {
            i.result = e2;
          });
      })
      .next(() => {
        if (i.result) return;
        const n2 = new QueryContext();
        return this.Ji(e, t, n2).next((r3) => {
          if (((i.result = r3), this.Ui)) return this.Yi(e, t, n2, r3.size);
        });
      })
      .next(() => i.result);
  }
  Yi(e, t, n, r2) {
    return n.documentReadCount < this.Wi
      ? (__PRIVATE_getLogLevel() <= LogLevel.DEBUG &&
          __PRIVATE_logDebug(
            "QueryEngine",
            "SDK will not create cache indexes for query:",
            __PRIVATE_stringifyQuery(t),
            "since it only creates cache indexes for collection contains",
            "more than or equal to",
            this.Wi,
            "documents"
          ),
        PersistencePromise.resolve())
      : (__PRIVATE_getLogLevel() <= LogLevel.DEBUG &&
          __PRIVATE_logDebug(
            "QueryEngine",
            "Query:",
            __PRIVATE_stringifyQuery(t),
            "scans",
            n.documentReadCount,
            "local documents and returns",
            r2,
            "documents as results."
          ),
        n.documentReadCount > this.Gi * r2
          ? (__PRIVATE_getLogLevel() <= LogLevel.DEBUG &&
              __PRIVATE_logDebug(
                "QueryEngine",
                "The SDK decides to create cache indexes for query:",
                __PRIVATE_stringifyQuery(t),
                "as using cache indexes may help improve performance."
              ),
            this.indexManager.createTargetIndexes(
              e,
              __PRIVATE_queryToTarget(t)
            ))
          : PersistencePromise.resolve());
  }
  /**
   * Performs an indexed query that evaluates the query based on a collection's
   * persisted index values. Returns `null` if an index is not available.
   */
  ji(e, t) {
    if (__PRIVATE_queryMatchesAllDocuments(t))
      return PersistencePromise.resolve(null);
    let n = __PRIVATE_queryToTarget(t);
    return this.indexManager.getIndexType(e, n).next((r2) =>
      0 === r2
        ? null
        : (null !== t.limit &&
            1 === r2 && // We cannot apply a limit for targets that are served using a partial
            // index. If a partial index will be used to serve the target, the
            // query may return a superset of documents that match the target
            // (e.g. if the index doesn't include all the target's filters), or
            // may return the correct set of documents in the wrong order (e.g. if
            // the index doesn't include a segment for one of the orderBys).
            // Therefore, a limit should not be applied in such cases.
            ((t = __PRIVATE_queryWithLimit(
              t,
              null,
              "F"
              /* LimitType.First */
            )),
            (n = __PRIVATE_queryToTarget(t))),
          this.indexManager.getDocumentsMatchingTarget(e, n).next((r3) => {
            const i = __PRIVATE_documentKeySet(...r3);
            return this.zi.getDocuments(e, i).next((r4) =>
              this.indexManager.getMinOffset(e, n).next((n2) => {
                const s = this.Zi(t, r4);
                return this.Xi(t, s, i, n2.readTime)
                  ? this.ji(
                      e,
                      __PRIVATE_queryWithLimit(
                        t,
                        null,
                        "F"
                        /* LimitType.First */
                      )
                    )
                  : this.es(e, s, t, n2);
              })
            );
          }))
    );
  }
  /**
   * Performs a query based on the target's persisted query mapping. Returns
   * `null` if the mapping is not available or cannot be used.
   */
  Hi(e, t, n, r2) {
    return __PRIVATE_queryMatchesAllDocuments(t) ||
      r2.isEqual(SnapshotVersion.min())
      ? PersistencePromise.resolve(null)
      : this.zi.getDocuments(e, n).next((i) => {
          const s = this.Zi(t, i);
          return this.Xi(t, s, n, r2)
            ? PersistencePromise.resolve(null)
            : (__PRIVATE_getLogLevel() <= LogLevel.DEBUG &&
                __PRIVATE_logDebug(
                  "QueryEngine",
                  "Re-using previous result from %s to execute query: %s",
                  r2.toString(),
                  __PRIVATE_stringifyQuery(t)
                ),
              this.es(
                e,
                s,
                t,
                __PRIVATE_newIndexOffsetSuccessorFromReadTime(r2, -1)
              ).next((e2) => e2));
        });
  }
  /** Applies the query filter and sorting to the provided documents.  */
  Zi(e, t) {
    let n = new SortedSet(__PRIVATE_newQueryComparator(e));
    return (
      t.forEach((t2, r2) => {
        __PRIVATE_queryMatches(e, r2) && (n = n.add(r2));
      }),
      n
    );
  }
  /**
   * Determines if a limit query needs to be refilled from cache, making it
   * ineligible for index-free execution.
   *
   * @param query - The query.
   * @param sortedPreviousResults - The documents that matched the query when it
   * was last synchronized, sorted by the query's comparator.
   * @param remoteKeys - The document keys that matched the query at the last
   * snapshot.
   * @param limboFreeSnapshotVersion - The version of the snapshot when the
   * query was last synchronized.
   */
  Xi(e, t, n, r2) {
    if (null === e.limit) return false;
    if (n.size !== t.size) return true;
    const i = "F" === e.limitType ? t.last() : t.first();
    return !!i && (i.hasPendingWrites || i.version.compareTo(r2) > 0);
  }
  Ji(e, t, n) {
    return (
      __PRIVATE_getLogLevel() <= LogLevel.DEBUG &&
        __PRIVATE_logDebug(
          "QueryEngine",
          "Using full collection scan to execute query:",
          __PRIVATE_stringifyQuery(t)
        ),
      this.zi.getDocumentsMatchingQuery(e, t, IndexOffset.min(), n)
    );
  }
  /**
   * Combines the results from an indexed execution with the remaining documents
   * that have not yet been indexed.
   */
  es(e, t, n, r2) {
    return this.zi.getDocumentsMatchingQuery(e, n, r2).next(
      (e2) => (
        // Merge with existing results
        t.forEach((t2) => {
          e2 = e2.insert(t2.key, t2);
        }),
        e2
      )
    );
  }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class __PRIVATE_LocalStoreImpl {
  constructor(e, t, n, r2) {
    (this.persistence = e),
      (this.ts = t),
      (this.serializer = r2),
      /**
       * Maps a targetID to data about its target.
       *
       * PORTING NOTE: We are using an immutable data structure on Web to make re-runs
       * of `applyRemoteEvent()` idempotent.
       */ (this.ns = new SortedMap(
        __PRIVATE_primitiveComparator
      )) /** Maps a target to its targetID. */,
      // TODO(wuandy): Evaluate if TargetId can be part of Target.
      (this.rs = new ObjectMap(
        (e2) => __PRIVATE_canonifyTarget(e2),
        __PRIVATE_targetEquals
      )),
      /**
       * A per collection group index of the last read time processed by
       * `getNewDocumentChanges()`.
       *
       * PORTING NOTE: This is only used for multi-tab synchronization.
       */ (this.ss = /* @__PURE__ */ new Map()),
      (this.os = e.getRemoteDocumentCache()),
      (this.Qr = e.getTargetCache()),
      (this.$r = e.getBundleCache()),
      this._s(n);
  }
  _s(e) {
    (this.documentOverlayCache = this.persistence.getDocumentOverlayCache(e)),
      (this.indexManager = this.persistence.getIndexManager(e)),
      (this.mutationQueue = this.persistence.getMutationQueue(
        e,
        this.indexManager
      )),
      (this.localDocuments = new LocalDocumentsView(
        this.os,
        this.mutationQueue,
        this.documentOverlayCache,
        this.indexManager
      )),
      this.os.setIndexManager(this.indexManager),
      this.ts.initialize(this.localDocuments, this.indexManager);
  }
  collectGarbage(e) {
    return this.persistence.runTransaction(
      "Collect garbage",
      "readwrite-primary",
      (t) => e.collect(t, this.ns)
    );
  }
}
function __PRIVATE_newLocalStore(e, t, n, r2) {
  return new __PRIVATE_LocalStoreImpl(e, t, n, r2);
}
async function __PRIVATE_localStoreHandleUserChange(e, t) {
  const n = __PRIVATE_debugCast(e);
  return await n.persistence.runTransaction(
    "Handle user change",
    "readonly",
    (e2) => {
      let r2;
      return n.mutationQueue
        .getAllMutationBatches(e2)
        .next(
          (i) => ((r2 = i), n._s(t), n.mutationQueue.getAllMutationBatches(e2))
        )
        .next((t2) => {
          const i = [],
            s = [];
          let o = __PRIVATE_documentKeySet();
          for (const e3 of r2) {
            i.push(e3.batchId);
            for (const t3 of e3.mutations) o = o.add(t3.key);
          }
          for (const e3 of t2) {
            s.push(e3.batchId);
            for (const t3 of e3.mutations) o = o.add(t3.key);
          }
          return n.localDocuments.getDocuments(e2, o).next((e3) => ({
            us: e3,
            removedBatchIds: i,
            addedBatchIds: s,
          }));
        });
    }
  );
}
function __PRIVATE_localStoreAcknowledgeBatch(e, t) {
  const n = __PRIVATE_debugCast(e);
  return n.persistence.runTransaction(
    "Acknowledge batch",
    "readwrite-primary",
    (e2) => {
      const r2 = t.batch.keys(),
        i = n.os.newChangeBuffer({
          trackRemovals: true,
        });
      return (function __PRIVATE_applyWriteToRemoteDocuments(e3, t2, n2, r3) {
        const i2 = n2.batch,
          s = i2.keys();
        let o = PersistencePromise.resolve();
        return (
          s.forEach((e4) => {
            o = o
              .next(() => r3.getEntry(t2, e4))
              .next((t3) => {
                const s2 = n2.docVersions.get(e4);
                __PRIVATE_hardAssert(null !== s2),
                  t3.version.compareTo(s2) < 0 &&
                    (i2.applyToRemoteDocument(t3, n2),
                    t3.isValidDocument() && // We use the commitVersion as the readTime rather than the
                      // document's updateTime since the updateTime is not advanced
                      // for updates that do not modify the underlying document.
                      (t3.setReadTime(n2.commitVersion), r3.addEntry(t3)));
              });
          }),
          o.next(() => e3.mutationQueue.removeMutationBatch(t2, i2))
        );
      })(n, e2, t, i)
        .next(() => i.apply(e2))
        .next(() => n.mutationQueue.performConsistencyCheck(e2))
        .next(() =>
          n.documentOverlayCache.removeOverlaysForBatchId(
            e2,
            r2,
            t.batch.batchId
          )
        )
        .next(() =>
          n.localDocuments.recalculateAndSaveOverlaysForDocumentKeys(
            e2,
            (function __PRIVATE_getKeysWithTransformResults(e3) {
              let t2 = __PRIVATE_documentKeySet();
              for (let n2 = 0; n2 < e3.mutationResults.length; ++n2) {
                e3.mutationResults[n2].transformResults.length > 0 &&
                  (t2 = t2.add(e3.batch.mutations[n2].key));
              }
              return t2;
            })(t)
          )
        )
        .next(() => n.localDocuments.getDocuments(e2, r2));
    }
  );
}
function __PRIVATE_localStoreGetLastRemoteSnapshotVersion(e) {
  const t = __PRIVATE_debugCast(e);
  return t.persistence.runTransaction(
    "Get last remote snapshot version",
    "readonly",
    (e2) => t.Qr.getLastRemoteSnapshotVersion(e2)
  );
}
function __PRIVATE_localStoreApplyRemoteEventToLocalCache(e, t) {
  const n = __PRIVATE_debugCast(e),
    r2 = t.snapshotVersion;
  let i = n.ns;
  return n.persistence
    .runTransaction("Apply remote event", "readwrite-primary", (e2) => {
      const s = n.os.newChangeBuffer({
        trackRemovals: true,
      });
      i = n.ns;
      const o = [];
      t.targetChanges.forEach((s2, _2) => {
        const a2 = i.get(_2);
        if (!a2) return;
        o.push(
          n.Qr.removeMatchingKeys(e2, s2.removedDocuments, _2).next(() =>
            n.Qr.addMatchingKeys(e2, s2.addedDocuments, _2)
          )
        );
        let u = a2.withSequenceNumber(e2.currentSequenceNumber);
        null !== t.targetMismatches.get(_2)
          ? (u = u
              .withResumeToken(
                ByteString.EMPTY_BYTE_STRING,
                SnapshotVersion.min()
              )
              .withLastLimboFreeSnapshotVersion(SnapshotVersion.min()))
          : s2.resumeToken.approximateByteSize() > 0 &&
            (u = u.withResumeToken(s2.resumeToken, r2)),
          (i = i.insert(_2, u)), // Update the target data if there are target changes (or if
          // sufficient time has passed since the last update).
          /**
           * Returns true if the newTargetData should be persisted during an update of
           * an active target. TargetData should always be persisted when a target is
           * being released and should not call this function.
           *
           * While the target is active, TargetData updates can be omitted when nothing
           * about the target has changed except metadata like the resume token or
           * snapshot version. Occasionally it's worth the extra write to prevent these
           * values from getting too stale after a crash, but this doesn't have to be
           * too frequent.
           */
          (function __PRIVATE_shouldPersistTargetData(e3, t2, n2) {
            if (0 === e3.resumeToken.approximateByteSize()) return true;
            if (
              t2.snapshotVersion.toMicroseconds() -
                e3.snapshotVersion.toMicroseconds() >=
              3e8
            )
              return true;
            return (
              n2.addedDocuments.size +
                n2.modifiedDocuments.size +
                n2.removedDocuments.size >
              0
            );
          })(a2, u, s2) && o.push(n.Qr.updateTargetData(e2, u));
      });
      let _ = __PRIVATE_mutableDocumentMap(),
        a = __PRIVATE_documentKeySet();
      if (
        (t.documentUpdates.forEach((r3) => {
          t.resolvedLimboDocuments.has(r3) &&
            o.push(n.persistence.referenceDelegate.updateLimboDocument(e2, r3));
        }), // Each loop iteration only affects its "own" doc, so it's safe to get all
        // the remote documents in advance in a single call.
        o.push(
          __PRIVATE_populateDocumentChangeBuffer(e2, s, t.documentUpdates).next(
            (e3) => {
              (_ = e3.cs), (a = e3.ls);
            }
          )
        ),
        !r2.isEqual(SnapshotVersion.min()))
      ) {
        const t2 = n.Qr.getLastRemoteSnapshotVersion(e2).next((t3) =>
          n.Qr.setTargetsMetadata(e2, e2.currentSequenceNumber, r2)
        );
        o.push(t2);
      }
      return PersistencePromise.waitFor(o)
        .next(() => s.apply(e2))
        .next(() => n.localDocuments.getLocalViewOfDocuments(e2, _, a))
        .next(() => _);
    })
    .then((e2) => ((n.ns = i), e2));
}
function __PRIVATE_populateDocumentChangeBuffer(e, t, n) {
  let r2 = __PRIVATE_documentKeySet(),
    i = __PRIVATE_documentKeySet();
  return (
    n.forEach((e2) => (r2 = r2.add(e2))),
    t.getEntries(e, r2).next((e2) => {
      let r3 = __PRIVATE_mutableDocumentMap();
      return (
        n.forEach((n2, s) => {
          const o = e2.get(n2);
          s.isFoundDocument() !== o.isFoundDocument() && (i = i.add(n2)), // Note: The order of the steps below is important, since we want
            // to ensure that rejected limbo resolutions (which fabricate
            // NoDocuments with SnapshotVersion.min()) never add documents to
            // cache.
            s.isNoDocument() && s.version.isEqual(SnapshotVersion.min())
              ? // NoDocuments with SnapshotVersion.min() are used in manufactured
                // events. We remove these documents from cache since we lost
                // access.
                (t.removeEntry(n2, s.readTime), (r3 = r3.insert(n2, s)))
              : !o.isValidDocument() ||
                s.version.compareTo(o.version) > 0 ||
                (0 === s.version.compareTo(o.version) && o.hasPendingWrites)
              ? (t.addEntry(s), (r3 = r3.insert(n2, s)))
              : __PRIVATE_logDebug(
                  "LocalStore",
                  "Ignoring outdated watch update for ",
                  n2,
                  ". Current version:",
                  o.version,
                  " Watch version:",
                  s.version
                );
        }),
        {
          cs: r3,
          ls: i,
        }
      );
    })
  );
}
function __PRIVATE_localStoreGetNextMutationBatch(e, t) {
  const n = __PRIVATE_debugCast(e);
  return n.persistence.runTransaction(
    "Get next mutation batch",
    "readonly",
    (e2) => (
      void 0 === t && (t = -1),
      n.mutationQueue.getNextMutationBatchAfterBatchId(e2, t)
    )
  );
}
function __PRIVATE_localStoreAllocateTarget(e, t) {
  const n = __PRIVATE_debugCast(e);
  return n.persistence
    .runTransaction("Allocate target", "readwrite", (e2) => {
      let r2;
      return n.Qr.getTargetData(e2, t).next((i) =>
        i
          ? // This target has been listened to previously, so reuse the
            // previous targetID.
            // TODO(mcg): freshen last accessed date?
            ((r2 = i), PersistencePromise.resolve(r2))
          : n.Qr.allocateTargetId(e2).next(
              (i2) => (
                (r2 = new TargetData(
                  t,
                  i2,
                  "TargetPurposeListen",
                  e2.currentSequenceNumber
                )),
                n.Qr.addTargetData(e2, r2).next(() => r2)
              )
            )
      );
    })
    .then((e2) => {
      const r2 = n.ns.get(e2.targetId);
      return (
        (null === r2 || e2.snapshotVersion.compareTo(r2.snapshotVersion) > 0) &&
          ((n.ns = n.ns.insert(e2.targetId, e2)), n.rs.set(t, e2.targetId)),
        e2
      );
    });
}
async function __PRIVATE_localStoreReleaseTarget(e, t, n) {
  const r2 = __PRIVATE_debugCast(e),
    i = r2.ns.get(t),
    s = n ? "readwrite" : "readwrite-primary";
  try {
    n ||
      (await r2.persistence.runTransaction("Release target", s, (e2) =>
        r2.persistence.referenceDelegate.removeTarget(e2, i)
      ));
  } catch (e2) {
    if (!__PRIVATE_isIndexedDbTransactionError(e2)) throw e2;
    __PRIVATE_logDebug(
      "LocalStore",
      `Failed to update sequence numbers for target ${t}: ${e2}`
    );
  }
  (r2.ns = r2.ns.remove(t)), r2.rs.delete(i.target);
}
function __PRIVATE_localStoreExecuteQuery(e, t, n) {
  const r2 = __PRIVATE_debugCast(e);
  let i = SnapshotVersion.min(),
    s = __PRIVATE_documentKeySet();
  return r2.persistence.runTransaction(
    "Execute query",
    "readwrite",
    // Use readwrite instead of readonly so indexes can be created
    // Use readwrite instead of readonly so indexes can be created
    (e2) =>
      (function __PRIVATE_localStoreGetTargetData(e3, t2, n2) {
        const r3 = __PRIVATE_debugCast(e3),
          i2 = r3.rs.get(n2);
        return void 0 !== i2
          ? PersistencePromise.resolve(r3.ns.get(i2))
          : r3.Qr.getTargetData(t2, n2);
      })(r2, e2, __PRIVATE_queryToTarget(t))
        .next((t2) => {
          if (t2)
            return (
              (i = t2.lastLimboFreeSnapshotVersion),
              r2.Qr.getMatchingKeysForTargetId(e2, t2.targetId).next((e3) => {
                s = e3;
              })
            );
        })
        .next(() =>
          r2.ts.getDocumentsMatchingQuery(
            e2,
            t,
            n ? i : SnapshotVersion.min(),
            n ? s : __PRIVATE_documentKeySet()
          )
        )
        .next(
          (e3) => (
            __PRIVATE_setMaxReadTime(r2, __PRIVATE_queryCollectionGroup(t), e3),
            {
              documents: e3,
              hs: s,
            }
          )
        )
  );
}
function __PRIVATE_setMaxReadTime(e, t, n) {
  let r2 = e.ss.get(t) || SnapshotVersion.min();
  n.forEach((e2, t2) => {
    t2.readTime.compareTo(r2) > 0 && (r2 = t2.readTime);
  }),
    e.ss.set(t, r2);
}
class __PRIVATE_LocalClientState {
  constructor() {
    this.activeTargetIds = __PRIVATE_targetIdSet();
  }
  As(e) {
    this.activeTargetIds = this.activeTargetIds.add(e);
  }
  Rs(e) {
    this.activeTargetIds = this.activeTargetIds.delete(e);
  }
  /**
   * Converts this entry into a JSON-encoded format we can use for WebStorage.
   * Does not encode `clientId` as it is part of the key in WebStorage.
   */
  ds() {
    const e = {
      activeTargetIds: this.activeTargetIds.toArray(),
      updateTimeMs: Date.now(),
    };
    return JSON.stringify(e);
  }
}
class __PRIVATE_MemorySharedClientState {
  constructor() {
    (this.no = new __PRIVATE_LocalClientState()),
      (this.ro = {}),
      (this.onlineStateHandler = null),
      (this.sequenceNumberHandler = null);
  }
  addPendingMutation(e) {}
  updateMutationState(e, t, n) {}
  addLocalQueryTarget(e) {
    return this.no.As(e), this.ro[e] || "not-current";
  }
  updateQueryState(e, t, n) {
    this.ro[e] = t;
  }
  removeLocalQueryTarget(e) {
    this.no.Rs(e);
  }
  isLocalQueryTarget(e) {
    return this.no.activeTargetIds.has(e);
  }
  clearQueryState(e) {
    delete this.ro[e];
  }
  getAllActiveQueryTargets() {
    return this.no.activeTargetIds;
  }
  isActiveQueryTarget(e) {
    return this.no.activeTargetIds.has(e);
  }
  start() {
    return (this.no = new __PRIVATE_LocalClientState()), Promise.resolve();
  }
  handleUserChange(e, t, n) {}
  setOnlineState(e) {}
  shutdown() {}
  writeSequenceNumber(e) {}
  notifyBundleLoaded(e) {}
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class __PRIVATE_NoopConnectivityMonitor {
  io(e) {}
  shutdown() {}
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class __PRIVATE_BrowserConnectivityMonitor {
  constructor() {
    (this.so = () => this.oo()),
      (this._o = () => this.ao()),
      (this.uo = []),
      this.co();
  }
  io(e) {
    this.uo.push(e);
  }
  shutdown() {
    window.removeEventListener("online", this.so),
      window.removeEventListener("offline", this._o);
  }
  co() {
    window.addEventListener("online", this.so),
      window.addEventListener("offline", this._o);
  }
  oo() {
    __PRIVATE_logDebug(
      "ConnectivityMonitor",
      "Network connectivity changed: AVAILABLE"
    );
    for (const e of this.uo)
      e(
        0
        /* NetworkStatus.AVAILABLE */
      );
  }
  ao() {
    __PRIVATE_logDebug(
      "ConnectivityMonitor",
      "Network connectivity changed: UNAVAILABLE"
    );
    for (const e of this.uo)
      e(
        1
        /* NetworkStatus.UNAVAILABLE */
      );
  }
  // TODO(chenbrian): Consider passing in window either into this component or
  // here for testing via FakeWindow.
  /** Checks that all used attributes of window are available. */
  static D() {
    return (
      "undefined" != typeof window &&
      void 0 !== window.addEventListener &&
      void 0 !== window.removeEventListener
    );
  }
}
/**
 * @license
 * Copyright 2023 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
let Re = null;
function __PRIVATE_generateUniqueDebugId() {
  return (
    null === Re
      ? (Re = (function __PRIVATE_generateInitialUniqueDebugId() {
          return 268435456 + Math.round(2147483648 * Math.random());
        })())
      : Re++,
    "0x" + Re.toString(16)
  );
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const Ve = {
  BatchGetDocuments: "batchGet",
  Commit: "commit",
  RunQuery: "runQuery",
  RunAggregationQuery: "runAggregationQuery",
};
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class __PRIVATE_StreamBridge {
  constructor(e) {
    (this.lo = e.lo), (this.ho = e.ho);
  }
  Po(e) {
    this.Io = e;
  }
  To(e) {
    this.Eo = e;
  }
  onMessage(e) {
    this.Ao = e;
  }
  close() {
    this.ho();
  }
  send(e) {
    this.lo(e);
  }
  Ro() {
    this.Io();
  }
  Vo(e) {
    this.Eo(e);
  }
  mo(e) {
    this.Ao(e);
  }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const me = "WebChannelConnection";
class __PRIVATE_WebChannelConnection
  /**
   * Base class for all Rest-based connections to the backend (WebChannel and
   * HTTP).
   */
  extends class __PRIVATE_RestConnection {
    constructor(e) {
      (this.databaseInfo = e), (this.databaseId = e.databaseId);
      const t = e.ssl ? "https" : "http",
        n = encodeURIComponent(this.databaseId.projectId),
        r2 = encodeURIComponent(this.databaseId.database);
      (this.fo = t + "://" + e.host),
        (this.po = `projects/${n}/databases/${r2}`),
        (this.yo =
          "(default)" === this.databaseId.database
            ? `project_id=${n}`
            : `project_id=${n}&database_id=${r2}`);
    }
    get wo() {
      return false;
    }
    So(e, t, n, r2, i) {
      const s = __PRIVATE_generateUniqueDebugId(),
        o = this.bo(e, t.toUriEncodedString());
      __PRIVATE_logDebug("RestConnection", `Sending RPC '${e}' ${s}:`, o, n);
      const _ = {
        "google-cloud-resource-prefix": this.po,
        "x-goog-request-params": this.yo,
      };
      return (
        this.Do(_, r2, i),
        this.Co(e, o, _, n).then(
          (t2) => (
            __PRIVATE_logDebug(
              "RestConnection",
              `Received RPC '${e}' ${s}: `,
              t2
            ),
            t2
          ),
          (t2) => {
            throw (
              (__PRIVATE_logWarn(
                "RestConnection",
                `RPC '${e}' ${s} failed with error: `,
                t2,
                "url: ",
                o,
                "request:",
                n
              ),
              t2)
            );
          }
        )
      );
    }
    vo(e, t, n, r2, i, s) {
      return this.So(e, t, n, r2, i);
    }
    /**
     * Modifies the headers for a request, adding any authorization token if
     * present and any additional headers for the request.
     */
    Do(e, t, n) {
      (e["X-Goog-Api-Client"] = // SDK_VERSION is updated to different value at runtime depending on the entry point,
        // so we need to get its value when we need it in a function.
        (function __PRIVATE_getGoogApiClientValue() {
          return "gl-js/ fire/" + S;
        })()), // Content-Type: text/plain will avoid preflight requests which might
        // mess with CORS and redirects by proxies. If we add custom headers
        // we will need to change this code to potentially use the $httpOverwrite
        // parameter supported by ESF to avoid triggering preflight requests.
        (e["Content-Type"] = "text/plain"),
        this.databaseInfo.appId &&
          (e["X-Firebase-GMPID"] = this.databaseInfo.appId),
        t && t.headers.forEach((t2, n2) => (e[n2] = t2)),
        n && n.headers.forEach((t2, n2) => (e[n2] = t2));
    }
    bo(e, t) {
      const n = Ve[e];
      return `${this.fo}/v1/${t}:${n}`;
    }
    /**
     * Closes and cleans up any resources associated with the connection. This
     * implementation is a no-op because there are no resources associated
     * with the RestConnection that need to be cleaned up.
     */
    terminate() {}
  }
{
  constructor(e) {
    super(e),
      (this.forceLongPolling = e.forceLongPolling),
      (this.autoDetectLongPolling = e.autoDetectLongPolling),
      (this.useFetchStreams = e.useFetchStreams),
      (this.longPollingOptions = e.longPollingOptions);
  }
  Co(e, t, n, r2) {
    const i = __PRIVATE_generateUniqueDebugId();
    return new Promise((s, o) => {
      const _ = new XhrIo();
      _.setWithCredentials(true),
        _.listenOnce(EventType.COMPLETE, () => {
          try {
            switch (_.getLastErrorCode()) {
              case ErrorCode$1.NO_ERROR:
                const t2 = _.getResponseJson();
                __PRIVATE_logDebug(
                  me,
                  `XHR for RPC '${e}' ${i} received:`,
                  JSON.stringify(t2)
                ),
                  s(t2);
                break;
              case ErrorCode$1.TIMEOUT:
                __PRIVATE_logDebug(me, `RPC '${e}' ${i} timed out`),
                  o(
                    new FirestoreError(D.DEADLINE_EXCEEDED, "Request time out")
                  );
                break;
              case ErrorCode$1.HTTP_ERROR:
                const n2 = _.getStatus();
                if (
                  (__PRIVATE_logDebug(
                    me,
                    `RPC '${e}' ${i} failed with status:`,
                    n2,
                    "response text:",
                    _.getResponseText()
                  ),
                  n2 > 0)
                ) {
                  let e2 = _.getResponseJson();
                  Array.isArray(e2) && (e2 = e2[0]);
                  const t3 = null == e2 ? void 0 : e2.error;
                  if (t3 && t3.status && t3.message) {
                    const e3 =
                      (function __PRIVATE_mapCodeFromHttpResponseErrorStatus(
                        e4
                      ) {
                        const t4 = e4.toLowerCase().replace(/_/g, "-");
                        return Object.values(D).indexOf(t4) >= 0
                          ? t4
                          : D.UNKNOWN;
                      })(t3.status);
                    o(new FirestoreError(e3, t3.message));
                  } else
                    o(
                      new FirestoreError(
                        D.UNKNOWN,
                        "Server responded with status " + _.getStatus()
                      )
                    );
                } else
                  o(new FirestoreError(D.UNAVAILABLE, "Connection failed."));
                break;
              default:
                fail();
            }
          } finally {
            __PRIVATE_logDebug(me, `RPC '${e}' ${i} completed.`);
          }
        });
      const a = JSON.stringify(r2);
      __PRIVATE_logDebug(me, `RPC '${e}' ${i} sending request:`, r2),
        _.send(t, "POST", a, n, 15);
    });
  }
  Fo(e, t, n) {
    const r2 = __PRIVATE_generateUniqueDebugId(),
      i = [this.fo, "/", "google.firestore.v1.Firestore", "/", e, "/channel"],
      s = createWebChannelTransport(),
      o = getStatEventTarget(),
      _ = {
        // Required for backend stickiness, routing behavior is based on this
        // parameter.
        httpSessionIdParam: "gsessionid",
        initMessageHeaders: {},
        messageUrlParams: {
          // This param is used to improve routing and project isolation by the
          // backend and must be included in every request.
          database: `projects/${this.databaseId.projectId}/databases/${this.databaseId.database}`,
        },
        sendRawJson: true,
        supportsCrossDomainXhr: true,
        internalChannelParams: {
          // Override the default timeout (randomized between 10-20 seconds) since
          // a large write batch on a slow internet connection may take a long
          // time to send to the backend. Rather than have WebChannel impose a
          // tight timeout which could lead to infinite timeouts and retries, we
          // set it very large (5-10 minutes) and rely on the browser's builtin
          // timeouts to kick in if the request isn't working.
          forwardChannelRequestTimeoutMs: 6e5,
        },
        forceLongPolling: this.forceLongPolling,
        detectBufferingProxy: this.autoDetectLongPolling,
      },
      a = this.longPollingOptions.timeoutSeconds;
    void 0 !== a && (_.longPollingTimeout = Math.round(1e3 * a)),
      this.useFetchStreams && (_.useFetchStreams = true),
      this.Do(_.initMessageHeaders, t, n), // Sending the custom headers we just added to request.initMessageHeaders
      // (Authorization, etc.) will trigger the browser to make a CORS preflight
      // request because the XHR will no longer meet the criteria for a "simple"
      // CORS request:
      // https://developer.mozilla.org/en-US/docs/Web/HTTP/CORS#Simple_requests
      // Therefore to avoid the CORS preflight request (an extra network
      // roundtrip), we use the encodeInitMessageHeaders option to specify that
      // the headers should instead be encoded in the request's POST payload,
      // which is recognized by the webchannel backend.
      (_.encodeInitMessageHeaders = true);
    const u = i.join("");
    __PRIVATE_logDebug(me, `Creating RPC '${e}' stream ${r2}: ${u}`, _);
    const c = s.createWebChannel(u, _);
    let l2 = false,
      h = false;
    const P2 = new __PRIVATE_StreamBridge({
        lo: (t2) => {
          h
            ? __PRIVATE_logDebug(
                me,
                `Not sending because RPC '${e}' stream ${r2} is closed:`,
                t2
              )
            : (l2 ||
                (__PRIVATE_logDebug(
                  me,
                  `Opening RPC '${e}' stream ${r2} transport.`
                ),
                c.open(),
                (l2 = true)),
              __PRIVATE_logDebug(me, `RPC '${e}' stream ${r2} sending:`, t2),
              c.send(t2));
        },
        ho: () => c.close(),
      }),
      __PRIVATE_unguardedEventListen = (e2, t2, n2) => {
        e2.listen(t2, (e3) => {
          try {
            n2(e3);
          } catch (e4) {
            setTimeout(() => {
              throw e4;
            }, 0);
          }
        });
      };
    return (
      __PRIVATE_unguardedEventListen(c, WebChannel.EventType.OPEN, () => {
        h ||
          __PRIVATE_logDebug(me, `RPC '${e}' stream ${r2} transport opened.`);
      }),
      __PRIVATE_unguardedEventListen(c, WebChannel.EventType.CLOSE, () => {
        h ||
          ((h = true),
          __PRIVATE_logDebug(me, `RPC '${e}' stream ${r2} transport closed`),
          P2.Vo());
      }),
      __PRIVATE_unguardedEventListen(c, WebChannel.EventType.ERROR, (t2) => {
        h ||
          ((h = true),
          __PRIVATE_logWarn(
            me,
            `RPC '${e}' stream ${r2} transport errored:`,
            t2
          ),
          P2.Vo(
            new FirestoreError(
              D.UNAVAILABLE,
              "The operation could not be completed"
            )
          ));
      }),
      __PRIVATE_unguardedEventListen(c, WebChannel.EventType.MESSAGE, (t2) => {
        var n2;
        if (!h) {
          const i2 = t2.data[0];
          __PRIVATE_hardAssert(!!i2);
          const s2 = i2,
            o2 =
              s2.error ||
              (null === (n2 = s2[0]) || void 0 === n2 ? void 0 : n2.error);
          if (o2) {
            __PRIVATE_logDebug(
              me,
              `RPC '${e}' stream ${r2} received error:`,
              o2
            );
            const t3 = o2.status;
            let n3 =
                /**
                 * Maps an error Code from a GRPC status identifier like 'NOT_FOUND'.
                 *
                 * @returns The Code equivalent to the given status string or undefined if
                 *     there is no match.
                 */
                (function __PRIVATE_mapCodeFromRpcStatus(e2) {
                  const t4 = ue[e2];
                  if (void 0 !== t4) return __PRIVATE_mapCodeFromRpcCode(t4);
                })(t3),
              i3 = o2.message;
            void 0 === n3 &&
              ((n3 = D.INTERNAL),
              (i3 =
                "Unknown error status: " + t3 + " with message " + o2.message)), // Mark closed so no further events are propagated
              (h = true),
              P2.Vo(new FirestoreError(n3, i3)),
              c.close();
          } else
            __PRIVATE_logDebug(me, `RPC '${e}' stream ${r2} received:`, i2),
              P2.mo(i2);
        }
      }),
      __PRIVATE_unguardedEventListen(o, Event$1.STAT_EVENT, (t2) => {
        t2.stat === Stat.PROXY
          ? __PRIVATE_logDebug(
              me,
              `RPC '${e}' stream ${r2} detected buffering proxy`
            )
          : t2.stat === Stat.NOPROXY &&
            __PRIVATE_logDebug(
              me,
              `RPC '${e}' stream ${r2} detected no buffering proxy`
            );
      }),
      setTimeout(() => {
        P2.Ro();
      }, 0),
      P2
    );
  }
}
function getDocument() {
  return "undefined" != typeof document ? document : null;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function __PRIVATE_newSerializer(e) {
  return new JsonProtoSerializer(
    e,
    /* useProto3Json= */
    true
  );
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class __PRIVATE_ExponentialBackoff {
  constructor(e, t, n = 1e3, r2 = 1.5, i = 6e4) {
    (this.oi = e),
      (this.timerId = t),
      (this.Mo = n),
      (this.xo = r2),
      (this.Oo = i),
      (this.No = 0),
      (this.Lo = null) /** The last backoff attempt, as epoch milliseconds. */,
      (this.Bo = Date.now()),
      this.reset();
  }
  /**
   * Resets the backoff delay.
   *
   * The very next backoffAndWait() will have no delay. If it is called again
   * (i.e. due to an error), initialDelayMs (plus jitter) will be used, and
   * subsequent ones will increase according to the backoffFactor.
   */
  reset() {
    this.No = 0;
  }
  /**
   * Resets the backoff delay to the maximum delay (e.g. for use after a
   * RESOURCE_EXHAUSTED error).
   */
  ko() {
    this.No = this.Oo;
  }
  /**
   * Returns a promise that resolves after currentDelayMs, and increases the
   * delay for any subsequent attempts. If there was a pending backoff operation
   * already, it will be canceled.
   */
  qo(e) {
    this.cancel();
    const t = Math.floor(this.No + this.Qo()),
      n = Math.max(0, Date.now() - this.Bo),
      r2 = Math.max(0, t - n);
    r2 > 0 &&
      __PRIVATE_logDebug(
        "ExponentialBackoff",
        `Backing off for ${r2} ms (base delay: ${this.No} ms, delay with jitter: ${t} ms, last attempt: ${n} ms ago)`
      ),
      (this.Lo = this.oi.enqueueAfterDelay(
        this.timerId,
        r2,
        () => ((this.Bo = Date.now()), e())
      )), // Apply backoff factor to determine next delay and ensure it is within
      // bounds.
      (this.No *= this.xo),
      this.No < this.Mo && (this.No = this.Mo),
      this.No > this.Oo && (this.No = this.Oo);
  }
  Ko() {
    null !== this.Lo && (this.Lo.skipDelay(), (this.Lo = null));
  }
  cancel() {
    null !== this.Lo && (this.Lo.cancel(), (this.Lo = null));
  }
  /** Returns a random value in the range [-currentBaseMs/2, currentBaseMs/2] */
  Qo() {
    return (Math.random() - 0.5) * this.No;
  }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class __PRIVATE_PersistentStream {
  constructor(e, t, n, r2, i, s, o, _) {
    (this.oi = e),
      (this.$o = n),
      (this.Uo = r2),
      (this.connection = i),
      (this.authCredentialsProvider = s),
      (this.appCheckCredentialsProvider = o),
      (this.listener = _),
      (this.state = 0),
      /**
       * A close count that's incremented every time the stream is closed; used by
       * getCloseGuardedDispatcher() to invalidate callbacks that happen after
       * close.
       */ (this.Wo = 0),
      (this.Go = null),
      (this.zo = null),
      (this.stream = null),
      (this.jo = new __PRIVATE_ExponentialBackoff(e, t));
  }
  /**
   * Returns true if start() has been called and no error has occurred. True
   * indicates the stream is open or in the process of opening (which
   * encompasses respecting backoff, getting auth tokens, and starting the
   * actual RPC). Use isOpen() to determine if the stream is open and ready for
   * outbound requests.
   */
  Ho() {
    return 1 === this.state || 5 === this.state || this.Jo();
  }
  /**
   * Returns true if the underlying RPC is open (the onOpen() listener has been
   * called) and the stream is ready for outbound requests.
   */
  Jo() {
    return 2 === this.state || 3 === this.state;
  }
  /**
   * Starts the RPC. Only allowed if isStarted() returns false. The stream is
   * not immediately ready for use: onOpen() will be invoked when the RPC is
   * ready for outbound requests, at which point isOpen() will return true.
   *
   * When start returns, isStarted() will return true.
   */
  start() {
    4 !== this.state ? this.auth() : this.Yo();
  }
  /**
   * Stops the RPC. This call is idempotent and allowed regardless of the
   * current isStarted() state.
   *
   * When stop returns, isStarted() and isOpen() will both return false.
   */
  async stop() {
    this.Ho() &&
      (await this.close(
        0
        /* PersistentStreamState.Initial */
      ));
  }
  /**
   * After an error the stream will usually back off on the next attempt to
   * start it. If the error warrants an immediate restart of the stream, the
   * sender can use this to indicate that the receiver should not back off.
   *
   * Each error will call the onClose() listener. That function can decide to
   * inhibit backoff if required.
   */
  Zo() {
    (this.state = 0), this.jo.reset();
  }
  /**
   * Marks this stream as idle. If no further actions are performed on the
   * stream for one minute, the stream will automatically close itself and
   * notify the stream's onClose() handler with Status.OK. The stream will then
   * be in a !isStarted() state, requiring the caller to start the stream again
   * before further use.
   *
   * Only streams that are in state 'Open' can be marked idle, as all other
   * states imply pending network operations.
   */
  Xo() {
    this.Jo() &&
      null === this.Go &&
      (this.Go = this.oi.enqueueAfterDelay(this.$o, 6e4, () => this.e_()));
  }
  /** Sends a message to the underlying stream. */
  t_(e) {
    this.n_(), this.stream.send(e);
  }
  /** Called by the idle timer when the stream should close due to inactivity. */
  async e_() {
    if (this.Jo())
      return this.close(
        0
        /* PersistentStreamState.Initial */
      );
  }
  /** Marks the stream as active again. */
  n_() {
    this.Go && (this.Go.cancel(), (this.Go = null));
  }
  /** Cancels the health check delayed operation. */
  r_() {
    this.zo && (this.zo.cancel(), (this.zo = null));
  }
  /**
   * Closes the stream and cleans up as necessary:
   *
   * * closes the underlying GRPC stream;
   * * calls the onClose handler with the given 'error';
   * * sets internal stream state to 'finalState';
   * * adjusts the backoff timer based on the error
   *
   * A new stream can be opened by calling start().
   *
   * @param finalState - the intended state of the stream after closing.
   * @param error - the error the connection was closed with.
   */
  async close(e, t) {
    this.n_(),
      this.r_(),
      this.jo.cancel(), // Invalidates any stream-related callbacks (e.g. from auth or the
      // underlying stream), guaranteeing they won't execute.
      this.Wo++,
      4 !== e
        ? // If this is an intentional close ensure we don't delay our next connection attempt.
          this.jo.reset()
        : t && t.code === D.RESOURCE_EXHAUSTED
        ? // Log the error. (Probably either 'quota exceeded' or 'max queue length reached'.)
          (__PRIVATE_logError(t.toString()),
          __PRIVATE_logError(
            "Using maximum backoff delay to prevent overloading the backend."
          ),
          this.jo.ko())
        : t &&
          t.code === D.UNAUTHENTICATED &&
          3 !== this.state && // "unauthenticated" error means the token was rejected. This should rarely
          // happen since both Auth and AppCheck ensure a sufficient TTL when we
          // request a token. If a user manually resets their system clock this can
          // fail, however. In this case, we should get a Code.UNAUTHENTICATED error
          // before we received the first message and we need to invalidate the token
          // to ensure that we fetch a new token.
          (this.authCredentialsProvider.invalidateToken(),
          this.appCheckCredentialsProvider.invalidateToken()), // Clean up the underlying stream because we are no longer interested in events.
      null !== this.stream &&
        (this.i_(), this.stream.close(), (this.stream = null)), // This state must be assigned before calling onClose() to allow the callback to
      // inhibit backoff or otherwise manipulate the state in its non-started state.
      (this.state = e), // Notify the listener that the stream closed.
      await this.listener.To(t);
  }
  /**
   * Can be overridden to perform additional cleanup before the stream is closed.
   * Calling super.tearDown() is not required.
   */
  i_() {}
  auth() {
    this.state = 1;
    const e = this.s_(this.Wo),
      t = this.Wo;
    Promise.all([
      this.authCredentialsProvider.getToken(),
      this.appCheckCredentialsProvider.getToken(),
    ]).then(
      ([e2, n]) => {
        this.Wo === t && // Normally we'd have to schedule the callback on the AsyncQueue.
          // However, the following calls are safe to be called outside the
          // AsyncQueue since they don't chain asynchronous calls
          this.o_(e2, n);
      },
      (t2) => {
        e(() => {
          const e2 = new FirestoreError(
            D.UNKNOWN,
            "Fetching auth token failed: " + t2.message
          );
          return this.__(e2);
        });
      }
    );
  }
  o_(e, t) {
    const n = this.s_(this.Wo);
    (this.stream = this.a_(e, t)),
      this.stream.Po(() => {
        n(
          () => (
            (this.state = 2),
            (this.zo = this.oi.enqueueAfterDelay(
              this.Uo,
              1e4,
              () => (this.Jo() && (this.state = 3), Promise.resolve())
            )),
            this.listener.Po()
          )
        );
      }),
      this.stream.To((e2) => {
        n(() => this.__(e2));
      }),
      this.stream.onMessage((e2) => {
        n(() => this.onMessage(e2));
      });
  }
  Yo() {
    (this.state = 5),
      this.jo.qo(async () => {
        (this.state = 0), this.start();
      });
  }
  // Visible for tests
  __(e) {
    return (
      __PRIVATE_logDebug("PersistentStream", `close with error: ${e}`),
      (this.stream = null),
      this.close(4, e)
    );
  }
  /**
   * Returns a "dispatcher" function that dispatches operations onto the
   * AsyncQueue but only runs them if closeCount remains unchanged. This allows
   * us to turn auth / stream callbacks into no-ops if the stream is closed /
   * re-opened, etc.
   */
  s_(e) {
    return (t) => {
      this.oi.enqueueAndForget(() =>
        this.Wo === e
          ? t()
          : (__PRIVATE_logDebug(
              "PersistentStream",
              "stream callback skipped by getCloseGuardedDispatcher."
            ),
            Promise.resolve())
      );
    };
  }
}
class __PRIVATE_PersistentListenStream extends __PRIVATE_PersistentStream {
  constructor(e, t, n, r2, i, s) {
    super(
      e,
      "listen_stream_connection_backoff",
      "listen_stream_idle",
      "health_check_timeout",
      t,
      n,
      r2,
      s
    ),
      (this.serializer = i);
  }
  a_(e, t) {
    return this.connection.Fo("Listen", e, t);
  }
  onMessage(e) {
    this.jo.reset();
    const t = __PRIVATE_fromWatchChange(this.serializer, e),
      n = (function __PRIVATE_versionFromListenResponse(e2) {
        if (!("targetChange" in e2)) return SnapshotVersion.min();
        const t2 = e2.targetChange;
        return t2.targetIds && t2.targetIds.length
          ? SnapshotVersion.min()
          : t2.readTime
          ? __PRIVATE_fromVersion(t2.readTime)
          : SnapshotVersion.min();
      })(e);
    return this.listener.u_(t, n);
  }
  /**
   * Registers interest in the results of the given target. If the target
   * includes a resumeToken it will be included in the request. Results that
   * affect the target will be streamed back as WatchChange messages that
   * reference the targetId.
   */
  c_(e) {
    const t = {};
    (t.database = __PRIVATE_getEncodedDatabaseId(this.serializer)),
      (t.addTarget = (function __PRIVATE_toTarget(e2, t2) {
        let n2;
        const r2 = t2.target;
        if (
          ((n2 = __PRIVATE_targetIsDocumentTarget(r2)
            ? {
                documents: __PRIVATE_toDocumentsTarget(e2, r2),
              }
            : {
                query: __PRIVATE_toQueryTarget(e2, r2).ut,
              }),
          (n2.targetId = t2.targetId),
          t2.resumeToken.approximateByteSize() > 0)
        ) {
          n2.resumeToken = __PRIVATE_toBytes(e2, t2.resumeToken);
          const r3 = __PRIVATE_toInt32Proto(e2, t2.expectedCount);
          null !== r3 && (n2.expectedCount = r3);
        } else if (t2.snapshotVersion.compareTo(SnapshotVersion.min()) > 0) {
          n2.readTime = toTimestamp(e2, t2.snapshotVersion.toTimestamp());
          const r3 = __PRIVATE_toInt32Proto(e2, t2.expectedCount);
          null !== r3 && (n2.expectedCount = r3);
        }
        return n2;
      })(this.serializer, e));
    const n = __PRIVATE_toListenRequestLabels(this.serializer, e);
    n && (t.labels = n), this.t_(t);
  }
  /**
   * Unregisters interest in the results of the target associated with the
   * given targetId.
   */
  l_(e) {
    const t = {};
    (t.database = __PRIVATE_getEncodedDatabaseId(this.serializer)),
      (t.removeTarget = e),
      this.t_(t);
  }
}
class __PRIVATE_PersistentWriteStream extends __PRIVATE_PersistentStream {
  constructor(e, t, n, r2, i, s) {
    super(
      e,
      "write_stream_connection_backoff",
      "write_stream_idle",
      "health_check_timeout",
      t,
      n,
      r2,
      s
    ),
      (this.serializer = i),
      (this.h_ = false);
  }
  /**
   * Tracks whether or not a handshake has been successfully exchanged and
   * the stream is ready to accept mutations.
   */
  get P_() {
    return this.h_;
  }
  // Override of PersistentStream.start
  start() {
    (this.h_ = false), (this.lastStreamToken = void 0), super.start();
  }
  i_() {
    this.h_ && this.I_([]);
  }
  a_(e, t) {
    return this.connection.Fo("Write", e, t);
  }
  onMessage(e) {
    if (
      // Always capture the last stream token.
      (__PRIVATE_hardAssert(!!e.streamToken),
      (this.lastStreamToken = e.streamToken),
      this.h_)
    ) {
      this.jo.reset();
      const t = __PRIVATE_fromWriteResults(e.writeResults, e.commitTime),
        n = __PRIVATE_fromVersion(e.commitTime);
      return this.listener.T_(n, t);
    }
    return (
      __PRIVATE_hardAssert(!e.writeResults || 0 === e.writeResults.length),
      (this.h_ = true),
      this.listener.E_()
    );
  }
  /**
   * Sends an initial streamToken to the server, performing the handshake
   * required to make the StreamingWrite RPC work. Subsequent
   * calls should wait until onHandshakeComplete was called.
   */
  d_() {
    const e = {};
    (e.database = __PRIVATE_getEncodedDatabaseId(this.serializer)), this.t_(e);
  }
  /** Sends a group of mutations to the Firestore backend to apply. */
  I_(e) {
    const t = {
      streamToken: this.lastStreamToken,
      writes: e.map((e2) => toMutation(this.serializer, e2)),
    };
    this.t_(t);
  }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class __PRIVATE_DatastoreImpl extends class Datastore {} {
  constructor(e, t, n, r2) {
    super(),
      (this.authCredentials = e),
      (this.appCheckCredentials = t),
      (this.connection = n),
      (this.serializer = r2),
      (this.A_ = false);
  }
  R_() {
    if (this.A_)
      throw new FirestoreError(
        D.FAILED_PRECONDITION,
        "The client has already been terminated."
      );
  }
  /** Invokes the provided RPC with auth and AppCheck tokens. */
  So(e, t, n, r2) {
    return (
      this.R_(),
      Promise.all([
        this.authCredentials.getToken(),
        this.appCheckCredentials.getToken(),
      ])
        .then(([i, s]) =>
          this.connection.So(e, __PRIVATE_toResourcePath(t, n), r2, i, s)
        )
        .catch((e2) => {
          throw "FirebaseError" === e2.name
            ? (e2.code === D.UNAUTHENTICATED &&
                (this.authCredentials.invalidateToken(),
                this.appCheckCredentials.invalidateToken()),
              e2)
            : new FirestoreError(D.UNKNOWN, e2.toString());
        })
    );
  }
  /** Invokes the provided RPC with streamed results with auth and AppCheck tokens. */
  vo(e, t, n, r2, i) {
    return (
      this.R_(),
      Promise.all([
        this.authCredentials.getToken(),
        this.appCheckCredentials.getToken(),
      ])
        .then(([s, o]) =>
          this.connection.vo(e, __PRIVATE_toResourcePath(t, n), r2, s, o, i)
        )
        .catch((e2) => {
          throw "FirebaseError" === e2.name
            ? (e2.code === D.UNAUTHENTICATED &&
                (this.authCredentials.invalidateToken(),
                this.appCheckCredentials.invalidateToken()),
              e2)
            : new FirestoreError(D.UNKNOWN, e2.toString());
        })
    );
  }
  terminate() {
    (this.A_ = true), this.connection.terminate();
  }
}
class __PRIVATE_OnlineStateTracker {
  constructor(e, t) {
    (this.asyncQueue = e),
      (this.onlineStateHandler = t) /** The current OnlineState. */,
      (this.state = "Unknown"),
      /**
       * A count of consecutive failures to open the stream. If it reaches the
       * maximum defined by MAX_WATCH_STREAM_FAILURES, we'll set the OnlineState to
       * Offline.
       */ (this.m_ = 0),
      /**
       * A timer that elapses after ONLINE_STATE_TIMEOUT_MS, at which point we
       * transition from OnlineState.Unknown to OnlineState.Offline without waiting
       * for the stream to actually fail (MAX_WATCH_STREAM_FAILURES times).
       */ (this.f_ = null),
      /**
       * Whether the client should log a warning message if it fails to connect to
       * the backend (initially true, cleared after a successful stream, or if we've
       * logged the message already).
       */ (this.g_ = true);
  }
  /**
   * Called by RemoteStore when a watch stream is started (including on each
   * backoff attempt).
   *
   * If this is the first attempt, it sets the OnlineState to Unknown and starts
   * the onlineStateTimer.
   */
  p_() {
    0 === this.m_ &&
      (this.y_(
        "Unknown"
        /* OnlineState.Unknown */
      ),
      (this.f_ = this.asyncQueue.enqueueAfterDelay(
        "online_state_timeout",
        1e4,
        () => (
          (this.f_ = null),
          this.w_("Backend didn't respond within 10 seconds."),
          this.y_(
            "Offline"
            /* OnlineState.Offline */
          ),
          Promise.resolve()
        )
      )));
  }
  /**
   * Updates our OnlineState as appropriate after the watch stream reports a
   * failure. The first failure moves us to the 'Unknown' state. We then may
   * allow multiple failures (based on MAX_WATCH_STREAM_FAILURES) before we
   * actually transition to the 'Offline' state.
   */
  S_(e) {
    "Online" === this.state
      ? this.y_(
          "Unknown"
          /* OnlineState.Unknown */
        )
      : (this.m_++,
        this.m_ >= 1 &&
          (this.b_(),
          this.w_(
            `Connection failed 1 times. Most recent error: ${e.toString()}`
          ),
          this.y_(
            "Offline"
            /* OnlineState.Offline */
          )));
  }
  /**
   * Explicitly sets the OnlineState to the specified state.
   *
   * Note that this resets our timers / failure counters, etc. used by our
   * Offline heuristics, so must not be used in place of
   * handleWatchStreamStart() and handleWatchStreamFailure().
   */
  set(e) {
    this.b_(),
      (this.m_ = 0),
      "Online" === e && // We've connected to watch at least once. Don't warn the developer
        // about being offline going forward.
        (this.g_ = false),
      this.y_(e);
  }
  y_(e) {
    e !== this.state && ((this.state = e), this.onlineStateHandler(e));
  }
  w_(e) {
    const t = `Could not reach Cloud Firestore backend. ${e}
This typically indicates that your device does not have a healthy Internet connection at the moment. The client will operate in offline mode until it is able to successfully connect to the backend.`;
    this.g_
      ? (__PRIVATE_logError(t), (this.g_ = false))
      : __PRIVATE_logDebug("OnlineStateTracker", t);
  }
  b_() {
    null !== this.f_ && (this.f_.cancel(), (this.f_ = null));
  }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class __PRIVATE_RemoteStoreImpl {
  constructor(e, t, n, r2, i) {
    (this.localStore = e),
      (this.datastore = t),
      (this.asyncQueue = n),
      (this.remoteSyncer = {}),
      /**
       * A list of up to MAX_PENDING_WRITES writes that we have fetched from the
       * LocalStore via fillWritePipeline() and have or will send to the write
       * stream.
       *
       * Whenever writePipeline.length > 0 the RemoteStore will attempt to start or
       * restart the write stream. When the stream is established the writes in the
       * pipeline will be sent in order.
       *
       * Writes remain in writePipeline until they are acknowledged by the backend
       * and thus will automatically be re-sent if the stream is interrupted /
       * restarted before they're acknowledged.
       *
       * Write responses from the backend are linked to their originating request
       * purely based on order, and so we can just shift() writes from the front of
       * the writePipeline as we receive responses.
       */ (this.D_ = []),
      /**
       * A mapping of watched targets that the client cares about tracking and the
       * user has explicitly called a 'listen' for this target.
       *
       * These targets may or may not have been sent to or acknowledged by the
       * server. On re-establishing the listen stream, these targets should be sent
       * to the server. The targets removed with unlistens are removed eagerly
       * without waiting for confirmation from the listen stream.
       */ (this.C_ = /* @__PURE__ */ new Map()),
      /**
       * A set of reasons for why the RemoteStore may be offline. If empty, the
       * RemoteStore may start its network connections.
       */ (this.v_ = /* @__PURE__ */ new Set()),
      /**
       * Event handlers that get called when the network is disabled or enabled.
       *
       * PORTING NOTE: These functions are used on the Web client to create the
       * underlying streams (to support tree-shakeable streams). On Android and iOS,
       * the streams are created during construction of RemoteStore.
       */ (this.F_ = []),
      (this.M_ = i),
      this.M_.io((e2) => {
        n.enqueueAndForget(async () => {
          __PRIVATE_canUseNetwork(this) &&
            (__PRIVATE_logDebug(
              "RemoteStore",
              "Restarting streams for network reachability change."
            ),
            await (async function __PRIVATE_restartNetwork(e3) {
              const t2 = __PRIVATE_debugCast(e3);
              t2.v_.add(
                4
                /* OfflineCause.ConnectivityChange */
              ),
                await __PRIVATE_disableNetworkInternal(t2),
                t2.x_.set(
                  "Unknown"
                  /* OnlineState.Unknown */
                ),
                t2.v_.delete(
                  4
                  /* OfflineCause.ConnectivityChange */
                ),
                await __PRIVATE_enableNetworkInternal(t2);
            })(this));
        });
      }),
      (this.x_ = new __PRIVATE_OnlineStateTracker(n, r2));
  }
}
async function __PRIVATE_enableNetworkInternal(e) {
  if (__PRIVATE_canUseNetwork(e))
    for (const t of e.F_)
      await t(
        /* enabled= */
        true
      );
}
async function __PRIVATE_disableNetworkInternal(e) {
  for (const t of e.F_)
    await t(
      /* enabled= */
      false
    );
}
function __PRIVATE_remoteStoreListen(e, t) {
  const n = __PRIVATE_debugCast(e);
  n.C_.has(t.targetId) || // Mark this as something the client is currently listening for.
    (n.C_.set(t.targetId, t),
    __PRIVATE_shouldStartWatchStream(n)
      ? // The listen will be sent in onWatchStreamOpen
        __PRIVATE_startWatchStream(n)
      : __PRIVATE_ensureWatchStream(n).Jo() &&
        __PRIVATE_sendWatchRequest(n, t));
}
function __PRIVATE_remoteStoreUnlisten(e, t) {
  const n = __PRIVATE_debugCast(e),
    r2 = __PRIVATE_ensureWatchStream(n);
  n.C_.delete(t),
    r2.Jo() && __PRIVATE_sendUnwatchRequest(n, t),
    0 === n.C_.size &&
      (r2.Jo()
        ? r2.Xo()
        : __PRIVATE_canUseNetwork(n) && // Revert to OnlineState.Unknown if the watch stream is not open and we
          // have no listeners, since without any listens to send we cannot
          // confirm if the stream is healthy and upgrade to OnlineState.Online.
          n.x_.set(
            "Unknown"
            /* OnlineState.Unknown */
          ));
}
function __PRIVATE_sendWatchRequest(e, t) {
  if (
    (e.O_.Oe(t.targetId),
    t.resumeToken.approximateByteSize() > 0 ||
      t.snapshotVersion.compareTo(SnapshotVersion.min()) > 0)
  ) {
    const n = e.remoteSyncer.getRemoteKeysForTarget(t.targetId).size;
    t = t.withExpectedCount(n);
  }
  __PRIVATE_ensureWatchStream(e).c_(t);
}
function __PRIVATE_sendUnwatchRequest(e, t) {
  e.O_.Oe(t), __PRIVATE_ensureWatchStream(e).l_(t);
}
function __PRIVATE_startWatchStream(e) {
  (e.O_ = new __PRIVATE_WatchChangeAggregator({
    getRemoteKeysForTarget: (t) => e.remoteSyncer.getRemoteKeysForTarget(t),
    _t: (t) => e.C_.get(t) || null,
    nt: () => e.datastore.serializer.databaseId,
  })),
    __PRIVATE_ensureWatchStream(e).start(),
    e.x_.p_();
}
function __PRIVATE_shouldStartWatchStream(e) {
  return (
    __PRIVATE_canUseNetwork(e) &&
    !__PRIVATE_ensureWatchStream(e).Ho() &&
    e.C_.size > 0
  );
}
function __PRIVATE_canUseNetwork(e) {
  return 0 === __PRIVATE_debugCast(e).v_.size;
}
function __PRIVATE_cleanUpWatchStreamState(e) {
  e.O_ = void 0;
}
async function __PRIVATE_onWatchStreamOpen(e) {
  e.C_.forEach((t, n) => {
    __PRIVATE_sendWatchRequest(e, t);
  });
}
async function __PRIVATE_onWatchStreamClose(e, t) {
  __PRIVATE_cleanUpWatchStreamState(e), // If we still need the watch stream, retry the connection.
    __PRIVATE_shouldStartWatchStream(e)
      ? (e.x_.S_(t), __PRIVATE_startWatchStream(e))
      : // No need to restart watch stream because there are no active targets.
        // The online state is set to unknown because there is no active attempt
        // at establishing a connection
        e.x_.set(
          "Unknown"
          /* OnlineState.Unknown */
        );
}
async function __PRIVATE_onWatchStreamChange(e, t, n) {
  if (
    // Mark the client as online since we got a message from the server
    (e.x_.set(
      "Online"
      /* OnlineState.Online */
    ),
    t instanceof __PRIVATE_WatchTargetChange && 2 === t.state && t.cause)
  )
    try {
      await /** Handles an error on a target */
      (async function __PRIVATE_handleTargetError(e2, t2) {
        const n2 = t2.cause;
        for (const r2 of t2.targetIds)
          e2.C_.has(r2) &&
            (await e2.remoteSyncer.rejectListen(r2, n2),
            e2.C_.delete(r2),
            e2.O_.removeTarget(r2));
      })(e, t);
    } catch (n2) {
      __PRIVATE_logDebug(
        "RemoteStore",
        "Failed to remove targets %s: %s ",
        t.targetIds.join(","),
        n2
      ),
        await __PRIVATE_disableNetworkUntilRecovery(e, n2);
    }
  else if (
    (t instanceof __PRIVATE_DocumentWatchChange
      ? e.O_.$e(t)
      : t instanceof __PRIVATE_ExistenceFilterChange
      ? e.O_.Je(t)
      : e.O_.Ge(t),
    !n.isEqual(SnapshotVersion.min()))
  )
    try {
      const t2 = await __PRIVATE_localStoreGetLastRemoteSnapshotVersion(
        e.localStore
      );
      n.compareTo(t2) >= 0 && // We have received a target change with a global snapshot if the snapshot
        // version is not equal to SnapshotVersion.min().
        (await /**
         * Takes a batch of changes from the Datastore, repackages them as a
         * RemoteEvent, and passes that on to the listener, which is typically the
         * SyncEngine.
         */
        (function __PRIVATE_raiseWatchSnapshot(e2, t3) {
          const n2 = e2.O_.it(t3);
          return (
            n2.targetChanges.forEach((n3, r2) => {
              if (n3.resumeToken.approximateByteSize() > 0) {
                const i = e2.C_.get(r2);
                i && e2.C_.set(r2, i.withResumeToken(n3.resumeToken, t3));
              }
            }), // Re-establish listens for the targets that have been invalidated by
            // existence filter mismatches.
            n2.targetMismatches.forEach((t4, n3) => {
              const r2 = e2.C_.get(t4);
              if (!r2) return;
              e2.C_.set(
                t4,
                r2.withResumeToken(
                  ByteString.EMPTY_BYTE_STRING,
                  r2.snapshotVersion
                )
              ), // Cause a hard reset by unwatching and rewatching immediately, but
                // deliberately don't send a resume token so that we get a full update.
                __PRIVATE_sendUnwatchRequest(e2, t4);
              const i = new TargetData(r2.target, t4, n3, r2.sequenceNumber);
              __PRIVATE_sendWatchRequest(e2, i);
            }),
            e2.remoteSyncer.applyRemoteEvent(n2)
          );
        })(e, n));
    } catch (t2) {
      __PRIVATE_logDebug("RemoteStore", "Failed to raise snapshot:", t2),
        await __PRIVATE_disableNetworkUntilRecovery(e, t2);
    }
}
async function __PRIVATE_disableNetworkUntilRecovery(e, t, n) {
  if (!__PRIVATE_isIndexedDbTransactionError(t)) throw t;
  e.v_.add(
    1
    /* OfflineCause.IndexedDbFailed */
  ), // Disable network and raise offline snapshots
    await __PRIVATE_disableNetworkInternal(e),
    e.x_.set(
      "Offline"
      /* OnlineState.Offline */
    ),
    n || // Use a simple read operation to determine if IndexedDB recovered.
      // Ideally, we would expose a health check directly on SimpleDb, but
      // RemoteStore only has access to persistence through LocalStore.
      (n = () =>
        __PRIVATE_localStoreGetLastRemoteSnapshotVersion(e.localStore)), // Probe IndexedDB periodically and re-enable network
    e.asyncQueue.enqueueRetryable(async () => {
      __PRIVATE_logDebug("RemoteStore", "Retrying IndexedDB access"),
        await n(),
        e.v_.delete(
          1
          /* OfflineCause.IndexedDbFailed */
        ),
        await __PRIVATE_enableNetworkInternal(e);
    });
}
function __PRIVATE_executeWithRecovery(e, t) {
  return t().catch((n) => __PRIVATE_disableNetworkUntilRecovery(e, n, t));
}
async function __PRIVATE_fillWritePipeline(e) {
  const t = __PRIVATE_debugCast(e),
    n = __PRIVATE_ensureWriteStream(t);
  let r2 = t.D_.length > 0 ? t.D_[t.D_.length - 1].batchId : -1;
  for (; __PRIVATE_canAddToWritePipeline(t); )
    try {
      const e2 = await __PRIVATE_localStoreGetNextMutationBatch(
        t.localStore,
        r2
      );
      if (null === e2) {
        0 === t.D_.length && n.Xo();
        break;
      }
      (r2 = e2.batchId), __PRIVATE_addToWritePipeline(t, e2);
    } catch (e2) {
      await __PRIVATE_disableNetworkUntilRecovery(t, e2);
    }
  __PRIVATE_shouldStartWriteStream(t) && __PRIVATE_startWriteStream(t);
}
function __PRIVATE_canAddToWritePipeline(e) {
  return __PRIVATE_canUseNetwork(e) && e.D_.length < 10;
}
function __PRIVATE_addToWritePipeline(e, t) {
  e.D_.push(t);
  const n = __PRIVATE_ensureWriteStream(e);
  n.Jo() && n.P_ && n.I_(t.mutations);
}
function __PRIVATE_shouldStartWriteStream(e) {
  return (
    __PRIVATE_canUseNetwork(e) &&
    !__PRIVATE_ensureWriteStream(e).Ho() &&
    e.D_.length > 0
  );
}
function __PRIVATE_startWriteStream(e) {
  __PRIVATE_ensureWriteStream(e).start();
}
async function __PRIVATE_onWriteStreamOpen(e) {
  __PRIVATE_ensureWriteStream(e).d_();
}
async function __PRIVATE_onWriteHandshakeComplete(e) {
  const t = __PRIVATE_ensureWriteStream(e);
  for (const n of e.D_) t.I_(n.mutations);
}
async function __PRIVATE_onMutationResult(e, t, n) {
  const r2 = e.D_.shift(),
    i = MutationBatchResult.from(r2, t, n);
  await __PRIVATE_executeWithRecovery(e, () =>
    e.remoteSyncer.applySuccessfulWrite(i)
  ), // It's possible that with the completion of this mutation another
    // slot has freed up.
    await __PRIVATE_fillWritePipeline(e);
}
async function __PRIVATE_onWriteStreamClose(e, t) {
  t &&
    __PRIVATE_ensureWriteStream(e).P_ && // This error affects the actual write.
    (await (async function __PRIVATE_handleWriteError(e2, t2) {
      if (
        (function __PRIVATE_isPermanentWriteError(e3) {
          return __PRIVATE_isPermanentError(e3) && e3 !== D.ABORTED;
        })(t2.code)
      ) {
        const n = e2.D_.shift();
        __PRIVATE_ensureWriteStream(e2).Zo(),
          await __PRIVATE_executeWithRecovery(e2, () =>
            e2.remoteSyncer.rejectFailedWrite(n.batchId, t2)
          ), // It's possible that with the completion of this mutation
          // another slot has freed up.
          await __PRIVATE_fillWritePipeline(e2);
      }
    })(e, t)), // The write stream might have been started by refilling the write
    // pipeline for failed writes
    __PRIVATE_shouldStartWriteStream(e) && __PRIVATE_startWriteStream(e);
}
async function __PRIVATE_remoteStoreHandleCredentialChange(e, t) {
  const n = __PRIVATE_debugCast(e);
  n.asyncQueue.verifyOperationInProgress(),
    __PRIVATE_logDebug("RemoteStore", "RemoteStore received new credentials");
  const r2 = __PRIVATE_canUseNetwork(n);
  n.v_.add(
    3
    /* OfflineCause.CredentialChange */
  ),
    await __PRIVATE_disableNetworkInternal(n),
    r2 && // Don't set the network status to Unknown if we are offline.
      n.x_.set(
        "Unknown"
        /* OnlineState.Unknown */
      ),
    await n.remoteSyncer.handleCredentialChange(t),
    n.v_.delete(
      3
      /* OfflineCause.CredentialChange */
    ),
    await __PRIVATE_enableNetworkInternal(n);
}
async function __PRIVATE_remoteStoreApplyPrimaryState(e, t) {
  const n = __PRIVATE_debugCast(e);
  t
    ? (n.v_.delete(
        2
        /* OfflineCause.IsSecondary */
      ),
      await __PRIVATE_enableNetworkInternal(n))
    : t ||
      (n.v_.add(
        2
        /* OfflineCause.IsSecondary */
      ),
      await __PRIVATE_disableNetworkInternal(n),
      n.x_.set(
        "Unknown"
        /* OnlineState.Unknown */
      ));
}
function __PRIVATE_ensureWatchStream(e) {
  return (
    e.N_ || // Create stream (but note that it is not started yet).
      ((e.N_ = (function __PRIVATE_newPersistentWatchStream(e2, t, n) {
        const r2 = __PRIVATE_debugCast(e2);
        return (
          r2.R_(),
          new __PRIVATE_PersistentListenStream(
            t,
            r2.connection,
            r2.authCredentials,
            r2.appCheckCredentials,
            r2.serializer,
            n
          )
        );
      })(e.datastore, e.asyncQueue, {
        Po: __PRIVATE_onWatchStreamOpen.bind(null, e),
        To: __PRIVATE_onWatchStreamClose.bind(null, e),
        u_: __PRIVATE_onWatchStreamChange.bind(null, e),
      })),
      e.F_.push(async (t) => {
        t
          ? (e.N_.Zo(),
            __PRIVATE_shouldStartWatchStream(e)
              ? __PRIVATE_startWatchStream(e)
              : e.x_.set(
                  "Unknown"
                  /* OnlineState.Unknown */
                ))
          : (await e.N_.stop(), __PRIVATE_cleanUpWatchStreamState(e));
      })),
    e.N_
  );
}
function __PRIVATE_ensureWriteStream(e) {
  return (
    e.L_ || // Create stream (but note that it is not started yet).
      ((e.L_ = (function __PRIVATE_newPersistentWriteStream(e2, t, n) {
        const r2 = __PRIVATE_debugCast(e2);
        return (
          r2.R_(),
          new __PRIVATE_PersistentWriteStream(
            t,
            r2.connection,
            r2.authCredentials,
            r2.appCheckCredentials,
            r2.serializer,
            n
          )
        );
      })(e.datastore, e.asyncQueue, {
        Po: __PRIVATE_onWriteStreamOpen.bind(null, e),
        To: __PRIVATE_onWriteStreamClose.bind(null, e),
        E_: __PRIVATE_onWriteHandshakeComplete.bind(null, e),
        T_: __PRIVATE_onMutationResult.bind(null, e),
      })),
      e.F_.push(async (t) => {
        t
          ? (e.L_.Zo(), // This will start the write stream if necessary.
            await __PRIVATE_fillWritePipeline(e))
          : (await e.L_.stop(),
            e.D_.length > 0 &&
              (__PRIVATE_logDebug(
                "RemoteStore",
                `Stopping write stream with ${e.D_.length} pending writes`
              ),
              (e.D_ = [])));
      })),
    e.L_
  );
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class DelayedOperation {
  constructor(e, t, n, r2, i) {
    (this.asyncQueue = e),
      (this.timerId = t),
      (this.targetTimeMs = n),
      (this.op = r2),
      (this.removalCallback = i),
      (this.deferred = new __PRIVATE_Deferred()),
      (this.then = this.deferred.promise.then.bind(this.deferred.promise)), // It's normal for the deferred promise to be canceled (due to cancellation)
      // and so we attach a dummy catch callback to avoid
      // 'UnhandledPromiseRejectionWarning' log spam.
      this.deferred.promise.catch((e2) => {});
  }
  get promise() {
    return this.deferred.promise;
  }
  /**
   * Creates and returns a DelayedOperation that has been scheduled to be
   * executed on the provided asyncQueue after the provided delayMs.
   *
   * @param asyncQueue - The queue to schedule the operation on.
   * @param id - A Timer ID identifying the type of operation this is.
   * @param delayMs - The delay (ms) before the operation should be scheduled.
   * @param op - The operation to run.
   * @param removalCallback - A callback to be called synchronously once the
   *   operation is executed or canceled, notifying the AsyncQueue to remove it
   *   from its delayedOperations list.
   *   PORTING NOTE: This exists to prevent making removeDelayedOperation() and
   *   the DelayedOperation class public.
   */
  static createAndSchedule(e, t, n, r2, i) {
    const s = Date.now() + n,
      o = new DelayedOperation(e, t, s, r2, i);
    return o.start(n), o;
  }
  /**
   * Starts the timer. This is called immediately after construction by
   * createAndSchedule().
   */
  start(e) {
    this.timerHandle = setTimeout(() => this.handleDelayElapsed(), e);
  }
  /**
   * Queues the operation to run immediately (if it hasn't already been run or
   * canceled).
   */
  skipDelay() {
    return this.handleDelayElapsed();
  }
  /**
   * Cancels the operation if it hasn't already been executed or canceled. The
   * promise will be rejected.
   *
   * As long as the operation has not yet been run, calling cancel() provides a
   * guarantee that the operation will not be run.
   */
  cancel(e) {
    null !== this.timerHandle &&
      (this.clearTimeout(),
      this.deferred.reject(
        new FirestoreError(
          D.CANCELLED,
          "Operation cancelled" + (e ? ": " + e : "")
        )
      ));
  }
  handleDelayElapsed() {
    this.asyncQueue.enqueueAndForget(() =>
      null !== this.timerHandle
        ? (this.clearTimeout(), this.op().then((e) => this.deferred.resolve(e)))
        : Promise.resolve()
    );
  }
  clearTimeout() {
    null !== this.timerHandle &&
      (this.removalCallback(this),
      clearTimeout(this.timerHandle),
      (this.timerHandle = null));
  }
}
function __PRIVATE_wrapInUserErrorIfRecoverable(e, t) {
  if (
    (__PRIVATE_logError("AsyncQueue", `${t}: ${e}`),
    __PRIVATE_isIndexedDbTransactionError(e))
  )
    return new FirestoreError(D.UNAVAILABLE, `${t}: ${e}`);
  throw e;
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class DocumentSet {
  /** The default ordering is by key if the comparator is omitted */
  constructor(e) {
    (this.comparator = e
      ? (t, n) => e(t, n) || DocumentKey.comparator(t.key, n.key)
      : (e2, t) => DocumentKey.comparator(e2.key, t.key)),
      (this.keyedMap = documentMap()),
      (this.sortedSet = new SortedMap(this.comparator));
  }
  /**
   * Returns an empty copy of the existing DocumentSet, using the same
   * comparator.
   */
  static emptySet(e) {
    return new DocumentSet(e.comparator);
  }
  has(e) {
    return null != this.keyedMap.get(e);
  }
  get(e) {
    return this.keyedMap.get(e);
  }
  first() {
    return this.sortedSet.minKey();
  }
  last() {
    return this.sortedSet.maxKey();
  }
  isEmpty() {
    return this.sortedSet.isEmpty();
  }
  /**
   * Returns the index of the provided key in the document set, or -1 if the
   * document key is not present in the set;
   */
  indexOf(e) {
    const t = this.keyedMap.get(e);
    return t ? this.sortedSet.indexOf(t) : -1;
  }
  get size() {
    return this.sortedSet.size;
  }
  /** Iterates documents in order defined by "comparator" */
  forEach(e) {
    this.sortedSet.inorderTraversal((t, n) => (e(t), false));
  }
  /** Inserts or updates a document with the same key */
  add(e) {
    const t = this.delete(e.key);
    return t.copy(t.keyedMap.insert(e.key, e), t.sortedSet.insert(e, null));
  }
  /** Deletes a document with a given key */
  delete(e) {
    const t = this.get(e);
    return t
      ? this.copy(this.keyedMap.remove(e), this.sortedSet.remove(t))
      : this;
  }
  isEqual(e) {
    if (!(e instanceof DocumentSet)) return false;
    if (this.size !== e.size) return false;
    const t = this.sortedSet.getIterator(),
      n = e.sortedSet.getIterator();
    for (; t.hasNext(); ) {
      const e2 = t.getNext().key,
        r2 = n.getNext().key;
      if (!e2.isEqual(r2)) return false;
    }
    return true;
  }
  toString() {
    const e = [];
    return (
      this.forEach((t) => {
        e.push(t.toString());
      }),
      0 === e.length
        ? "DocumentSet ()"
        : "DocumentSet (\n  " + e.join("  \n") + "\n)"
    );
  }
  copy(e, t) {
    const n = new DocumentSet();
    return (
      (n.comparator = this.comparator), (n.keyedMap = e), (n.sortedSet = t), n
    );
  }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class __PRIVATE_DocumentChangeSet {
  constructor() {
    this.B_ = new SortedMap(DocumentKey.comparator);
  }
  track(e) {
    const t = e.doc.key,
      n = this.B_.get(t);
    n
      ? // Merge the new change with the existing change.
        0 !== e.type && 3 === n.type
        ? (this.B_ = this.B_.insert(t, e))
        : 3 === e.type && 1 !== n.type
        ? (this.B_ = this.B_.insert(t, {
            type: n.type,
            doc: e.doc,
          }))
        : 2 === e.type && 2 === n.type
        ? (this.B_ = this.B_.insert(t, {
            type: 2,
            doc: e.doc,
          }))
        : 2 === e.type && 0 === n.type
        ? (this.B_ = this.B_.insert(t, {
            type: 0,
            doc: e.doc,
          }))
        : 1 === e.type && 0 === n.type
        ? (this.B_ = this.B_.remove(t))
        : 1 === e.type && 2 === n.type
        ? (this.B_ = this.B_.insert(t, {
            type: 1,
            doc: n.doc,
          }))
        : 0 === e.type && 1 === n.type
        ? (this.B_ = this.B_.insert(t, {
            type: 2,
            doc: e.doc,
          }))
        : // This includes these cases, which don't make sense:
          // Added->Added
          // Removed->Removed
          // Modified->Added
          // Removed->Modified
          // Metadata->Added
          // Removed->Metadata
          fail()
      : (this.B_ = this.B_.insert(t, e));
  }
  k_() {
    const e = [];
    return (
      this.B_.inorderTraversal((t, n) => {
        e.push(n);
      }),
      e
    );
  }
}
class ViewSnapshot {
  constructor(e, t, n, r2, i, s, o, _, a) {
    (this.query = e),
      (this.docs = t),
      (this.oldDocs = n),
      (this.docChanges = r2),
      (this.mutatedKeys = i),
      (this.fromCache = s),
      (this.syncStateChanged = o),
      (this.excludesMetadataChanges = _),
      (this.hasCachedResults = a);
  }
  /** Returns a view snapshot as if all documents in the snapshot were added. */
  static fromInitialDocuments(e, t, n, r2, i) {
    const s = [];
    return (
      t.forEach((e2) => {
        s.push({
          type: 0,
          doc: e2,
        });
      }),
      new ViewSnapshot(
        e,
        t,
        DocumentSet.emptySet(t),
        s,
        n,
        r2,
        /* syncStateChanged= */
        true,
        /* excludesMetadataChanges= */
        false,
        i
      )
    );
  }
  get hasPendingWrites() {
    return !this.mutatedKeys.isEmpty();
  }
  isEqual(e) {
    if (
      !(
        this.fromCache === e.fromCache &&
        this.hasCachedResults === e.hasCachedResults &&
        this.syncStateChanged === e.syncStateChanged &&
        this.mutatedKeys.isEqual(e.mutatedKeys) &&
        __PRIVATE_queryEquals(this.query, e.query) &&
        this.docs.isEqual(e.docs) &&
        this.oldDocs.isEqual(e.oldDocs)
      )
    )
      return false;
    const t = this.docChanges,
      n = e.docChanges;
    if (t.length !== n.length) return false;
    for (let e2 = 0; e2 < t.length; e2++)
      if (t[e2].type !== n[e2].type || !t[e2].doc.isEqual(n[e2].doc))
        return false;
    return true;
  }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class __PRIVATE_QueryListenersInfo {
  constructor() {
    (this.q_ = void 0), (this.Q_ = []);
  }
  // Helper methods that checks if the query has listeners that listening to remote store
  K_() {
    return this.Q_.some((e) => e.U_());
  }
}
class __PRIVATE_EventManagerImpl {
  constructor() {
    (this.queries = new ObjectMap(
      (e) => __PRIVATE_canonifyQuery(e),
      __PRIVATE_queryEquals
    )),
      (this.onlineState = "Unknown"),
      (this.W_ = /* @__PURE__ */ new Set());
  }
}
async function __PRIVATE_eventManagerListen(e, t) {
  const n = __PRIVATE_debugCast(e);
  let r2 = 3;
  const i = t.query;
  let s = n.queries.get(i);
  s
    ? !s.K_() &&
      t.U_() && // Query has been listening to local cache, and tries to add a new listener sourced from watch.
      (r2 = 2)
    : ((s = new __PRIVATE_QueryListenersInfo()), (r2 = t.U_() ? 0 : 1));
  try {
    switch (r2) {
      case 0:
        s.q_ = await n.onListen(
          i,
          /** enableRemoteListen= */
          true
        );
        break;
      case 1:
        s.q_ = await n.onListen(
          i,
          /** enableRemoteListen= */
          false
        );
        break;
      case 2:
        await n.onFirstRemoteStoreListen(i);
    }
  } catch (e2) {
    const n2 = __PRIVATE_wrapInUserErrorIfRecoverable(
      e2,
      `Initialization of query '${__PRIVATE_stringifyQuery(t.query)}' failed`
    );
    return void t.onError(n2);
  }
  if (
    (n.queries.set(i, s),
    s.Q_.push(t), // Run global snapshot listeners if a consistent snapshot has been emitted.
    t.G_(n.onlineState),
    s.q_)
  ) {
    t.z_(s.q_) && __PRIVATE_raiseSnapshotsInSyncEvent(n);
  }
}
async function __PRIVATE_eventManagerUnlisten(e, t) {
  const n = __PRIVATE_debugCast(e),
    r2 = t.query;
  let i = 3;
  const s = n.queries.get(r2);
  if (s) {
    const e2 = s.Q_.indexOf(t);
    e2 >= 0 &&
      (s.Q_.splice(e2, 1),
      0 === s.Q_.length
        ? (i = t.U_() ? 0 : 1)
        : !s.K_() &&
          t.U_() && // The removed listener is the last one that sourced from watch.
          (i = 2));
  }
  switch (i) {
    case 0:
      return (
        n.queries.delete(r2),
        n.onUnlisten(
          r2,
          /** disableRemoteListen= */
          true
        )
      );
    case 1:
      return (
        n.queries.delete(r2),
        n.onUnlisten(
          r2,
          /** disableRemoteListen= */
          false
        )
      );
    case 2:
      return n.onLastRemoteStoreUnlisten(r2);
    default:
      return;
  }
}
function __PRIVATE_eventManagerOnWatchChange(e, t) {
  const n = __PRIVATE_debugCast(e);
  let r2 = false;
  for (const e2 of t) {
    const t2 = e2.query,
      i = n.queries.get(t2);
    if (i) {
      for (const t3 of i.Q_) t3.z_(e2) && (r2 = true);
      i.q_ = e2;
    }
  }
  r2 && __PRIVATE_raiseSnapshotsInSyncEvent(n);
}
function __PRIVATE_eventManagerOnWatchError(e, t, n) {
  const r2 = __PRIVATE_debugCast(e),
    i = r2.queries.get(t);
  if (i) for (const e2 of i.Q_) e2.onError(n);
  r2.queries.delete(t);
}
function __PRIVATE_raiseSnapshotsInSyncEvent(e) {
  e.W_.forEach((e2) => {
    e2.next();
  });
}
var fe, ge;
((ge = fe || (fe = {})).j_ = "default") /** Listen to changes in cache only */,
  (ge.Cache = "cache");
class __PRIVATE_QueryListener {
  constructor(e, t, n) {
    (this.query = e),
      (this.H_ = t),
      /**
       * Initial snapshots (e.g. from cache) may not be propagated to the wrapped
       * observer. This flag is set to true once we've actually raised an event.
       */ (this.J_ = false),
      (this.Y_ = null),
      (this.onlineState = "Unknown"),
      (this.options = n || {});
  }
  /**
   * Applies the new ViewSnapshot to this listener, raising a user-facing event
   * if applicable (depending on what changed, whether the user has opted into
   * metadata-only changes, etc.). Returns true if a user-facing event was
   * indeed raised.
   */
  z_(e) {
    if (!this.options.includeMetadataChanges) {
      const t2 = [];
      for (const n of e.docChanges) 3 !== n.type && t2.push(n);
      e = new ViewSnapshot(
        e.query,
        e.docs,
        e.oldDocs,
        t2,
        e.mutatedKeys,
        e.fromCache,
        e.syncStateChanged,
        /* excludesMetadataChanges= */
        true,
        e.hasCachedResults
      );
    }
    let t = false;
    return (
      this.J_
        ? this.Z_(e) && (this.H_.next(e), (t = true))
        : this.X_(e, this.onlineState) && (this.ea(e), (t = true)),
      (this.Y_ = e),
      t
    );
  }
  onError(e) {
    this.H_.error(e);
  }
  /** Returns whether a snapshot was raised. */
  G_(e) {
    this.onlineState = e;
    let t = false;
    return (
      this.Y_ &&
        !this.J_ &&
        this.X_(this.Y_, e) &&
        (this.ea(this.Y_), (t = true)),
      t
    );
  }
  X_(e, t) {
    if (!e.fromCache) return true;
    if (!this.U_()) return true;
    const n = "Offline" !== t;
    return (
      (!this.options.ta || !n) &&
      (!e.docs.isEmpty() || e.hasCachedResults || "Offline" === t)
    );
  }
  Z_(e) {
    if (e.docChanges.length > 0) return true;
    const t = this.Y_ && this.Y_.hasPendingWrites !== e.hasPendingWrites;
    return (
      !(!e.syncStateChanged && !t) &&
      true === this.options.includeMetadataChanges
    );
  }
  ea(e) {
    (e = ViewSnapshot.fromInitialDocuments(
      e.query,
      e.docs,
      e.mutatedKeys,
      e.fromCache,
      e.hasCachedResults
    )),
      (this.J_ = true),
      this.H_.next(e);
  }
  U_() {
    return this.options.source !== fe.Cache;
  }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class __PRIVATE_AddedLimboDocument {
  constructor(e) {
    this.key = e;
  }
}
class __PRIVATE_RemovedLimboDocument {
  constructor(e) {
    this.key = e;
  }
}
class __PRIVATE_View {
  constructor(e, t) {
    (this.query = e),
      (this.ua = t),
      (this.ca = null),
      (this.hasCachedResults = false),
      /**
       * A flag whether the view is current with the backend. A view is considered
       * current after it has seen the current flag from the backend and did not
       * lose consistency within the watch stream (e.g. because of an existence
       * filter mismatch).
       */ (this.current = false) /** Documents in the view but not in the remote target */,
      (this.la =
        __PRIVATE_documentKeySet()) /** Document Keys that have local changes */,
      (this.mutatedKeys = __PRIVATE_documentKeySet()),
      (this.ha = __PRIVATE_newQueryComparator(e)),
      (this.Pa = new DocumentSet(this.ha));
  }
  /**
   * The set of remote documents that the server has told us belongs to the target associated with
   * this view.
   */
  get Ia() {
    return this.ua;
  }
  /**
   * Iterates over a set of doc changes, applies the query limit, and computes
   * what the new results should be, what the changes were, and whether we may
   * need to go back to the local cache for more results. Does not make any
   * changes to the view.
   * @param docChanges - The doc changes to apply to this view.
   * @param previousChanges - If this is being called with a refill, then start
   *        with this set of docs and changes instead of the current view.
   * @returns a new set of docs, changes, and refill flag.
   */
  Ta(e, t) {
    const n = t ? t.Ea : new __PRIVATE_DocumentChangeSet(),
      r2 = t ? t.Pa : this.Pa;
    let i = t ? t.mutatedKeys : this.mutatedKeys,
      s = r2,
      o = false;
    const _ =
        "F" === this.query.limitType && r2.size === this.query.limit
          ? r2.last()
          : null,
      a =
        "L" === this.query.limitType && r2.size === this.query.limit
          ? r2.first()
          : null;
    if (
      (e.inorderTraversal((e2, t2) => {
        const u = r2.get(e2),
          c = __PRIVATE_queryMatches(this.query, t2) ? t2 : null,
          l2 = !!u && this.mutatedKeys.has(u.key),
          h =
            !!c &&
            (c.hasLocalMutations || // We only consider committed mutations for documents that were
              // mutated during the lifetime of the view.
              (this.mutatedKeys.has(c.key) && c.hasCommittedMutations));
        let P2 = false;
        if (u && c) {
          u.data.isEqual(c.data)
            ? l2 !== h &&
              (n.track({
                type: 3,
                doc: c,
              }),
              (P2 = true))
            : this.da(u, c) ||
              (n.track({
                type: 2,
                doc: c,
              }),
              (P2 = true),
              ((_ && this.ha(c, _) > 0) || (a && this.ha(c, a) < 0)) && // This doc moved from inside the limit to outside the limit.
                // That means there may be some other doc in the local cache
                // that should be included instead.
                (o = true));
        } else
          !u && c
            ? (n.track({
                type: 0,
                doc: c,
              }),
              (P2 = true))
            : u &&
              !c &&
              (n.track({
                type: 1,
                doc: u,
              }),
              (P2 = true),
              (_ || a) && // A doc was removed from a full limit query. We'll need to
                // requery from the local cache to see if we know about some other
                // doc that should be in the results.
                (o = true));
        P2 &&
          (c
            ? ((s = s.add(c)), (i = h ? i.add(e2) : i.delete(e2)))
            : ((s = s.delete(e2)), (i = i.delete(e2))));
      }),
      null !== this.query.limit)
    )
      for (; s.size > this.query.limit; ) {
        const e2 = "F" === this.query.limitType ? s.last() : s.first();
        (s = s.delete(e2.key)),
          (i = i.delete(e2.key)),
          n.track({
            type: 1,
            doc: e2,
          });
      }
    return {
      Pa: s,
      Ea: n,
      Xi: o,
      mutatedKeys: i,
    };
  }
  da(e, t) {
    return (
      e.hasLocalMutations && t.hasCommittedMutations && !t.hasLocalMutations
    );
  }
  /**
   * Updates the view with the given ViewDocumentChanges and optionally updates
   * limbo docs and sync state from the provided target change.
   * @param docChanges - The set of changes to make to the view's docs.
   * @param limboResolutionEnabled - Whether to update limbo documents based on
   *        this change.
   * @param targetChange - A target change to apply for computing limbo docs and
   *        sync state.
   * @param targetIsPendingReset - Whether the target is pending to reset due to
   *        existence filter mismatch. If not explicitly specified, it is treated
   *        equivalently to `false`.
   * @returns A new ViewChange with the given docs, changes, and sync state.
   */
  // PORTING NOTE: The iOS/Android clients always compute limbo document changes.
  applyChanges(e, t, n, r2) {
    const i = this.Pa;
    (this.Pa = e.Pa), (this.mutatedKeys = e.mutatedKeys);
    const s = e.Ea.k_();
    s.sort(
      (e2, t2) =>
        (function __PRIVATE_compareChangeType(e3, t3) {
          const order = (e4) => {
            switch (e4) {
              case 0:
                return 1;
              case 2:
              case 3:
                return 2;
              case 1:
                return 0;
              default:
                return fail();
            }
          };
          return order(e3) - order(t3);
        })(e2.type, t2.type) || this.ha(e2.doc, t2.doc)
    ),
      this.Aa(n),
      (r2 = null != r2 && r2);
    const o = t && !r2 ? this.Ra() : [],
      _ = 0 === this.la.size && this.current && !r2 ? 1 : 0,
      a = _ !== this.ca;
    if (((this.ca = _), 0 !== s.length || a)) {
      return {
        snapshot: new ViewSnapshot(
          this.query,
          e.Pa,
          i,
          s,
          e.mutatedKeys,
          0 === _,
          a,
          /* excludesMetadataChanges= */
          false,
          !!n && n.resumeToken.approximateByteSize() > 0
        ),
        Va: o,
      };
    }
    return {
      Va: o,
    };
  }
  /**
   * Applies an OnlineState change to the view, potentially generating a
   * ViewChange if the view's syncState changes as a result.
   */
  G_(e) {
    return this.current && "Offline" === e
      ? // If we're offline, set `current` to false and then call applyChanges()
        // to refresh our syncState and generate a ViewChange as appropriate. We
        // are guaranteed to get a new TargetChange that sets `current` back to
        // true once the client is back online.
        ((this.current = false),
        this.applyChanges(
          {
            Pa: this.Pa,
            Ea: new __PRIVATE_DocumentChangeSet(),
            mutatedKeys: this.mutatedKeys,
            Xi: false,
          },
          /* limboResolutionEnabled= */
          false
        ))
      : {
          Va: [],
        };
  }
  /**
   * Returns whether the doc for the given key should be in limbo.
   */
  ma(e) {
    return (
      !this.ua.has(e) && // The local store doesn't think it's a result, so it shouldn't be in limbo.
      !!this.Pa.has(e) &&
      !this.Pa.get(e).hasLocalMutations
    );
  }
  /**
   * Updates syncedDocuments, current, and limbo docs based on the given change.
   * Returns the list of changes to which docs are in limbo.
   */
  Aa(e) {
    e &&
      (e.addedDocuments.forEach((e2) => (this.ua = this.ua.add(e2))),
      e.modifiedDocuments.forEach((e2) => {}),
      e.removedDocuments.forEach((e2) => (this.ua = this.ua.delete(e2))),
      (this.current = e.current));
  }
  Ra() {
    if (!this.current) return [];
    const e = this.la;
    (this.la = __PRIVATE_documentKeySet()),
      this.Pa.forEach((e2) => {
        this.ma(e2.key) && (this.la = this.la.add(e2.key));
      });
    const t = [];
    return (
      e.forEach((e2) => {
        this.la.has(e2) || t.push(new __PRIVATE_RemovedLimboDocument(e2));
      }),
      this.la.forEach((n) => {
        e.has(n) || t.push(new __PRIVATE_AddedLimboDocument(n));
      }),
      t
    );
  }
  /**
   * Update the in-memory state of the current view with the state read from
   * persistence.
   *
   * We update the query view whenever a client's primary status changes:
   * - When a client transitions from primary to secondary, it can miss
   *   LocalStorage updates and its query views may temporarily not be
   *   synchronized with the state on disk.
   * - For secondary to primary transitions, the client needs to update the list
   *   of `syncedDocuments` since secondary clients update their query views
   *   based purely on synthesized RemoteEvents.
   *
   * @param queryResult.documents - The documents that match the query according
   * to the LocalStore.
   * @param queryResult.remoteKeys - The keys of the documents that match the
   * query according to the backend.
   *
   * @returns The ViewChange that resulted from this synchronization.
   */
  // PORTING NOTE: Multi-tab only.
  fa(e) {
    (this.ua = e.hs), (this.la = __PRIVATE_documentKeySet());
    const t = this.Ta(e.documents);
    return this.applyChanges(
      t,
      /* limboResolutionEnabled= */
      true
    );
  }
  /**
   * Returns a view snapshot as if this query was just listened to. Contains
   * a document add for every existing document and the `fromCache` and
   * `hasPendingWrites` status of the already established view.
   */
  // PORTING NOTE: Multi-tab only.
  ga() {
    return ViewSnapshot.fromInitialDocuments(
      this.query,
      this.Pa,
      this.mutatedKeys,
      0 === this.ca,
      this.hasCachedResults
    );
  }
}
class __PRIVATE_QueryView {
  constructor(e, t, n) {
    (this.query = e), (this.targetId = t), (this.view = n);
  }
}
class LimboResolution {
  constructor(e) {
    (this.key = e),
      /**
       * Set to true once we've received a document. This is used in
       * getRemoteKeysForTarget() and ultimately used by WatchChangeAggregator to
       * decide whether it needs to manufacture a delete event for the target once
       * the target is CURRENT.
       */ (this.pa = false);
  }
}
class __PRIVATE_SyncEngineImpl {
  constructor(e, t, n, r2, i, s) {
    (this.localStore = e),
      (this.remoteStore = t),
      (this.eventManager = n),
      (this.sharedClientState = r2),
      (this.currentUser = i),
      (this.maxConcurrentLimboResolutions = s),
      (this.ya = {}),
      (this.wa = new ObjectMap(
        (e2) => __PRIVATE_canonifyQuery(e2),
        __PRIVATE_queryEquals
      )),
      (this.Sa = /* @__PURE__ */ new Map()),
      /**
       * The keys of documents that are in limbo for which we haven't yet started a
       * limbo resolution query. The strings in this set are the result of calling
       * `key.path.canonicalString()` where `key` is a `DocumentKey` object.
       *
       * The `Set` type was chosen because it provides efficient lookup and removal
       * of arbitrary elements and it also maintains insertion order, providing the
       * desired queue-like FIFO semantics.
       */ (this.ba = /* @__PURE__ */ new Set()),
      /**
       * Keeps track of the target ID for each document that is in limbo with an
       * active target.
       */ (this.Da = new SortedMap(DocumentKey.comparator)),
      /**
       * Keeps track of the information about an active limbo resolution for each
       * active target ID that was started for the purpose of limbo resolution.
       */ (this.Ca = /* @__PURE__ */ new Map()),
      (this.va =
        new __PRIVATE_ReferenceSet()) /** Stores user completion handlers, indexed by User and BatchId. */,
      (this.Fa =
        {}) /** Stores user callbacks waiting for all pending writes to be acknowledged. */,
      (this.Ma = /* @__PURE__ */ new Map()),
      (this.xa = __PRIVATE_TargetIdGenerator.Ln()),
      (this.onlineState = "Unknown"), // The primary state is set to `true` or `false` immediately after Firestore
      // startup. In the interim, a client should only be considered primary if
      // `isPrimary` is true.
      (this.Oa = void 0);
  }
  get isPrimaryClient() {
    return true === this.Oa;
  }
}
async function __PRIVATE_syncEngineListen(e, t, n = true) {
  const r2 = __PRIVATE_ensureWatchCallbacks(e);
  let i;
  const s = r2.wa.get(t);
  return (
    s
      ? // PORTING NOTE: With Multi-Tab Web, it is possible that a query view
        // already exists when EventManager calls us for the first time. This
        // happens when the primary tab is already listening to this query on
        // behalf of another tab and the user of the primary also starts listening
        // to the query. EventManager will not have an assigned target ID in this
        // case and calls `listen` to obtain this ID.
        (r2.sharedClientState.addLocalQueryTarget(s.targetId),
        (i = s.view.ga()))
      : (i = await __PRIVATE_allocateTargetAndMaybeListen(
          r2,
          t,
          n,
          /** shouldInitializeView= */
          true
        )),
    i
  );
}
async function __PRIVATE_triggerRemoteStoreListen(e, t) {
  const n = __PRIVATE_ensureWatchCallbacks(e);
  await __PRIVATE_allocateTargetAndMaybeListen(
    n,
    t,
    /** shouldListenToRemote= */
    true,
    /** shouldInitializeView= */
    false
  );
}
async function __PRIVATE_allocateTargetAndMaybeListen(e, t, n, r2) {
  const i = await __PRIVATE_localStoreAllocateTarget(
      e.localStore,
      __PRIVATE_queryToTarget(t)
    ),
    s = i.targetId,
    o = n ? e.sharedClientState.addLocalQueryTarget(s) : "not-current";
  let _;
  return (
    r2 &&
      (_ = await __PRIVATE_initializeViewAndComputeSnapshot(
        e,
        t,
        s,
        "current" === o,
        i.resumeToken
      )),
    e.isPrimaryClient && n && __PRIVATE_remoteStoreListen(e.remoteStore, i),
    _
  );
}
async function __PRIVATE_initializeViewAndComputeSnapshot(e, t, n, r2, i) {
  e.Na = (t2, n2, r3) =>
    (async function __PRIVATE_applyDocChanges(e2, t3, n3, r4) {
      let i2 = t3.view.Ta(n3);
      i2.Xi && // The query has a limit and some docs were removed, so we need
        // to re-run the query against the local store to make sure we
        // didn't lose any good docs that had been past the limit.
        (i2 = await __PRIVATE_localStoreExecuteQuery(
          e2.localStore,
          t3.query,
          /* usePreviousResults= */
          false
        ).then(({ documents: e3 }) => t3.view.Ta(e3, i2)));
      const s2 = r4 && r4.targetChanges.get(t3.targetId),
        o2 = r4 && null != r4.targetMismatches.get(t3.targetId),
        _2 = t3.view.applyChanges(
          i2,
          /* limboResolutionEnabled= */
          e2.isPrimaryClient,
          s2,
          o2
        );
      return __PRIVATE_updateTrackedLimbos(e2, t3.targetId, _2.Va), _2.snapshot;
    })(e, t2, n2, r3);
  const s = await __PRIVATE_localStoreExecuteQuery(
      e.localStore,
      t,
      /* usePreviousResults= */
      true
    ),
    o = new __PRIVATE_View(t, s.hs),
    _ = o.Ta(s.documents),
    a = TargetChange.createSynthesizedTargetChangeForCurrentChange(
      n,
      r2 && "Offline" !== e.onlineState,
      i
    ),
    u = o.applyChanges(
      _,
      /* limboResolutionEnabled= */
      e.isPrimaryClient,
      a
    );
  __PRIVATE_updateTrackedLimbos(e, n, u.Va);
  const c = new __PRIVATE_QueryView(t, n, o);
  return (
    e.wa.set(t, c),
    e.Sa.has(n) ? e.Sa.get(n).push(t) : e.Sa.set(n, [t]),
    u.snapshot
  );
}
async function __PRIVATE_syncEngineUnlisten(e, t, n) {
  const r2 = __PRIVATE_debugCast(e),
    i = r2.wa.get(t),
    s = r2.Sa.get(i.targetId);
  if (s.length > 1)
    return (
      r2.Sa.set(
        i.targetId,
        s.filter((e2) => !__PRIVATE_queryEquals(e2, t))
      ),
      void r2.wa.delete(t)
    );
  if (r2.isPrimaryClient) {
    r2.sharedClientState.removeLocalQueryTarget(i.targetId);
    r2.sharedClientState.isActiveQueryTarget(i.targetId) ||
      (await __PRIVATE_localStoreReleaseTarget(
        r2.localStore,
        i.targetId,
        /*keepPersistedTargetData=*/
        false
      )
        .then(() => {
          r2.sharedClientState.clearQueryState(i.targetId),
            n && __PRIVATE_remoteStoreUnlisten(r2.remoteStore, i.targetId),
            __PRIVATE_removeAndCleanupTarget(r2, i.targetId);
        })
        .catch(__PRIVATE_ignoreIfPrimaryLeaseLoss));
  } else
    __PRIVATE_removeAndCleanupTarget(r2, i.targetId),
      await __PRIVATE_localStoreReleaseTarget(
        r2.localStore,
        i.targetId,
        /*keepPersistedTargetData=*/
        true
      );
}
async function __PRIVATE_triggerRemoteStoreUnlisten(e, t) {
  const n = __PRIVATE_debugCast(e),
    r2 = n.wa.get(t),
    i = n.Sa.get(r2.targetId);
  n.isPrimaryClient &&
    1 === i.length && // PORTING NOTE: Unregister the target ID with local Firestore client as
    // watch target.
    (n.sharedClientState.removeLocalQueryTarget(r2.targetId),
    __PRIVATE_remoteStoreUnlisten(n.remoteStore, r2.targetId));
}
async function __PRIVATE_syncEngineWrite(e, t, n) {
  const r2 = __PRIVATE_syncEngineEnsureWriteCallbacks(e);
  try {
    const e2 = await (function __PRIVATE_localStoreWriteLocally(e3, t2) {
      const n2 = __PRIVATE_debugCast(e3),
        r3 = Timestamp.now(),
        i = t2.reduce((e4, t3) => e4.add(t3.key), __PRIVATE_documentKeySet());
      let s, o;
      return n2.persistence
        .runTransaction("Locally write mutations", "readwrite", (e4) => {
          let _ = __PRIVATE_mutableDocumentMap(),
            a = __PRIVATE_documentKeySet();
          return n2.os
            .getEntries(e4, i)
            .next((e5) => {
              (_ = e5),
                _.forEach((e6, t3) => {
                  t3.isValidDocument() || (a = a.add(e6));
                });
            })
            .next(() => n2.localDocuments.getOverlayedDocuments(e4, _))
            .next((i2) => {
              s = i2;
              const o2 = [];
              for (const e5 of t2) {
                const t3 = __PRIVATE_mutationExtractBaseValue(
                  e5,
                  s.get(e5.key).overlayedDocument
                );
                null != t3 && // NOTE: The base state should only be applied if there's some
                  // existing document to override, so use a Precondition of
                  // exists=true
                  o2.push(
                    new __PRIVATE_PatchMutation(
                      e5.key,
                      t3,
                      __PRIVATE_extractFieldMask(t3.value.mapValue),
                      Precondition.exists(true)
                    )
                  );
              }
              return n2.mutationQueue.addMutationBatch(e4, r3, o2, t2);
            })
            .next((t3) => {
              o = t3;
              const r4 = t3.applyToLocalDocumentSet(s, a);
              return n2.documentOverlayCache.saveOverlays(e4, t3.batchId, r4);
            });
        })
        .then(() => ({
          batchId: o.batchId,
          changes: __PRIVATE_convertOverlayedDocumentMapToDocumentMap(s),
        }));
    })(r2.localStore, t);
    r2.sharedClientState.addPendingMutation(e2.batchId),
      (function __PRIVATE_addMutationCallback(e3, t2, n2) {
        let r3 = e3.Fa[e3.currentUser.toKey()];
        r3 || (r3 = new SortedMap(__PRIVATE_primitiveComparator));
        (r3 = r3.insert(t2, n2)), (e3.Fa[e3.currentUser.toKey()] = r3);
      })(r2, e2.batchId, n),
      await __PRIVATE_syncEngineEmitNewSnapsAndNotifyLocalStore(r2, e2.changes),
      await __PRIVATE_fillWritePipeline(r2.remoteStore);
  } catch (e2) {
    const t2 = __PRIVATE_wrapInUserErrorIfRecoverable(
      e2,
      "Failed to persist write"
    );
    n.reject(t2);
  }
}
async function __PRIVATE_syncEngineApplyRemoteEvent(e, t) {
  const n = __PRIVATE_debugCast(e);
  try {
    const e2 = await __PRIVATE_localStoreApplyRemoteEventToLocalCache(
      n.localStore,
      t
    );
    t.targetChanges.forEach((e3, t2) => {
      const r2 = n.Ca.get(t2);
      r2 && // Since this is a limbo resolution lookup, it's for a single document
        // and it could be added, modified, or removed, but not a combination.
        (__PRIVATE_hardAssert(
          e3.addedDocuments.size +
            e3.modifiedDocuments.size +
            e3.removedDocuments.size <=
            1
        ),
        e3.addedDocuments.size > 0
          ? (r2.pa = true)
          : e3.modifiedDocuments.size > 0
          ? __PRIVATE_hardAssert(r2.pa)
          : e3.removedDocuments.size > 0 &&
            (__PRIVATE_hardAssert(r2.pa), (r2.pa = false)));
    }),
      await __PRIVATE_syncEngineEmitNewSnapsAndNotifyLocalStore(n, e2, t);
  } catch (e2) {
    await __PRIVATE_ignoreIfPrimaryLeaseLoss(e2);
  }
}
function __PRIVATE_syncEngineApplyOnlineStateChange(e, t, n) {
  const r2 = __PRIVATE_debugCast(e);
  if ((r2.isPrimaryClient && 0 === n) || (!r2.isPrimaryClient && 1 === n)) {
    const e2 = [];
    r2.wa.forEach((n2, r3) => {
      const i = r3.view.G_(t);
      i.snapshot && e2.push(i.snapshot);
    }),
      (function __PRIVATE_eventManagerOnOnlineStateChange(e3, t2) {
        const n2 = __PRIVATE_debugCast(e3);
        n2.onlineState = t2;
        let r3 = false;
        n2.queries.forEach((e4, n3) => {
          for (const e5 of n3.Q_) e5.G_(t2) && (r3 = true);
        }),
          r3 && __PRIVATE_raiseSnapshotsInSyncEvent(n2);
      })(r2.eventManager, t),
      e2.length && r2.ya.u_(e2),
      (r2.onlineState = t),
      r2.isPrimaryClient && r2.sharedClientState.setOnlineState(t);
  }
}
async function __PRIVATE_syncEngineRejectListen(e, t, n) {
  const r2 = __PRIVATE_debugCast(e);
  r2.sharedClientState.updateQueryState(t, "rejected", n);
  const i = r2.Ca.get(t),
    s = i && i.key;
  if (s) {
    let e2 = new SortedMap(DocumentKey.comparator);
    e2 = e2.insert(s, MutableDocument.newNoDocument(s, SnapshotVersion.min()));
    const n2 = __PRIVATE_documentKeySet().add(s),
      i2 = new RemoteEvent(
        SnapshotVersion.min(),
        /* targetChanges= */
        /* @__PURE__ */ new Map(),
        /* targetMismatches= */
        new SortedMap(__PRIVATE_primitiveComparator),
        e2,
        n2
      );
    await __PRIVATE_syncEngineApplyRemoteEvent(r2, i2), // Since this query failed, we won't want to manually unlisten to it.
      // We only remove it from bookkeeping after we successfully applied the
      // RemoteEvent. If `applyRemoteEvent()` throws, we want to re-listen to
      // this query when the RemoteStore restarts the Watch stream, which should
      // re-trigger the target failure.
      (r2.Da = r2.Da.remove(s)),
      r2.Ca.delete(t),
      __PRIVATE_pumpEnqueuedLimboResolutions(r2);
  } else
    await __PRIVATE_localStoreReleaseTarget(
      r2.localStore,
      t,
      /* keepPersistedTargetData */
      false
    )
      .then(() => __PRIVATE_removeAndCleanupTarget(r2, t, n))
      .catch(__PRIVATE_ignoreIfPrimaryLeaseLoss);
}
async function __PRIVATE_syncEngineApplySuccessfulWrite(e, t) {
  const n = __PRIVATE_debugCast(e),
    r2 = t.batch.batchId;
  try {
    const e2 = await __PRIVATE_localStoreAcknowledgeBatch(n.localStore, t);
    __PRIVATE_processUserCallback(
      n,
      r2,
      /*error=*/
      null
    ),
      __PRIVATE_triggerPendingWritesCallbacks(n, r2),
      n.sharedClientState.updateMutationState(r2, "acknowledged"),
      await __PRIVATE_syncEngineEmitNewSnapsAndNotifyLocalStore(n, e2);
  } catch (e2) {
    await __PRIVATE_ignoreIfPrimaryLeaseLoss(e2);
  }
}
async function __PRIVATE_syncEngineRejectFailedWrite(e, t, n) {
  const r2 = __PRIVATE_debugCast(e);
  try {
    const e2 = await (function __PRIVATE_localStoreRejectBatch(e3, t2) {
      const n2 = __PRIVATE_debugCast(e3);
      return n2.persistence.runTransaction(
        "Reject batch",
        "readwrite-primary",
        (e4) => {
          let r3;
          return n2.mutationQueue
            .lookupMutationBatch(e4, t2)
            .next(
              (t3) => (
                __PRIVATE_hardAssert(null !== t3),
                (r3 = t3.keys()),
                n2.mutationQueue.removeMutationBatch(e4, t3)
              )
            )
            .next(() => n2.mutationQueue.performConsistencyCheck(e4))
            .next(() =>
              n2.documentOverlayCache.removeOverlaysForBatchId(e4, r3, t2)
            )
            .next(() =>
              n2.localDocuments.recalculateAndSaveOverlaysForDocumentKeys(
                e4,
                r3
              )
            )
            .next(() => n2.localDocuments.getDocuments(e4, r3));
        }
      );
    })(r2.localStore, t);
    __PRIVATE_processUserCallback(r2, t, n),
      __PRIVATE_triggerPendingWritesCallbacks(r2, t),
      r2.sharedClientState.updateMutationState(t, "rejected", n),
      await __PRIVATE_syncEngineEmitNewSnapsAndNotifyLocalStore(r2, e2);
  } catch (n2) {
    await __PRIVATE_ignoreIfPrimaryLeaseLoss(n2);
  }
}
function __PRIVATE_triggerPendingWritesCallbacks(e, t) {
  (e.Ma.get(t) || []).forEach((e2) => {
    e2.resolve();
  }),
    e.Ma.delete(t);
}
function __PRIVATE_processUserCallback(e, t, n) {
  const r2 = __PRIVATE_debugCast(e);
  let i = r2.Fa[r2.currentUser.toKey()];
  if (i) {
    const e2 = i.get(t);
    e2 && (n ? e2.reject(n) : e2.resolve(), (i = i.remove(t))),
      (r2.Fa[r2.currentUser.toKey()] = i);
  }
}
function __PRIVATE_removeAndCleanupTarget(e, t, n = null) {
  e.sharedClientState.removeLocalQueryTarget(t);
  for (const r2 of e.Sa.get(t)) e.wa.delete(r2), n && e.ya.La(r2, n);
  if ((e.Sa.delete(t), e.isPrimaryClient)) {
    e.va.Vr(t).forEach((t2) => {
      e.va.containsKey(t2) || // We removed the last reference for this key
        __PRIVATE_removeLimboTarget(e, t2);
    });
  }
}
function __PRIVATE_removeLimboTarget(e, t) {
  e.ba.delete(t.path.canonicalString());
  const n = e.Da.get(t);
  null !== n &&
    (__PRIVATE_remoteStoreUnlisten(e.remoteStore, n),
    (e.Da = e.Da.remove(t)),
    e.Ca.delete(n),
    __PRIVATE_pumpEnqueuedLimboResolutions(e));
}
function __PRIVATE_updateTrackedLimbos(e, t, n) {
  for (const r2 of n)
    if (r2 instanceof __PRIVATE_AddedLimboDocument)
      e.va.addReference(r2.key, t), __PRIVATE_trackLimboChange(e, r2);
    else if (r2 instanceof __PRIVATE_RemovedLimboDocument) {
      __PRIVATE_logDebug(
        "SyncEngine",
        "Document no longer in limbo: " + r2.key
      ),
        e.va.removeReference(r2.key, t);
      e.va.containsKey(r2.key) || // We removed the last reference for this key
        __PRIVATE_removeLimboTarget(e, r2.key);
    } else fail();
}
function __PRIVATE_trackLimboChange(e, t) {
  const n = t.key,
    r2 = n.path.canonicalString();
  e.Da.get(n) ||
    e.ba.has(r2) ||
    (__PRIVATE_logDebug("SyncEngine", "New document in limbo: " + n),
    e.ba.add(r2),
    __PRIVATE_pumpEnqueuedLimboResolutions(e));
}
function __PRIVATE_pumpEnqueuedLimboResolutions(e) {
  for (; e.ba.size > 0 && e.Da.size < e.maxConcurrentLimboResolutions; ) {
    const t = e.ba.values().next().value;
    e.ba.delete(t);
    const n = new DocumentKey(ResourcePath.fromString(t)),
      r2 = e.xa.next();
    e.Ca.set(r2, new LimboResolution(n)),
      (e.Da = e.Da.insert(n, r2)),
      __PRIVATE_remoteStoreListen(
        e.remoteStore,
        new TargetData(
          __PRIVATE_queryToTarget(__PRIVATE_newQueryForPath(n.path)),
          r2,
          "TargetPurposeLimboResolution",
          __PRIVATE_ListenSequence._e
        )
      );
  }
}
async function __PRIVATE_syncEngineEmitNewSnapsAndNotifyLocalStore(e, t, n) {
  const r2 = __PRIVATE_debugCast(e),
    i = [],
    s = [],
    o = [];
  r2.wa.isEmpty() ||
    (r2.wa.forEach((e2, _) => {
      o.push(
        r2.Na(_, t, n).then((e3) => {
          if (
            // If there are changes, or we are handling a global snapshot, notify
            // secondary clients to update query state.
            ((e3 || n) &&
              r2.isPrimaryClient &&
              r2.sharedClientState.updateQueryState(
                _.targetId,
                (null == e3 ? void 0 : e3.fromCache) ? "not-current" : "current"
              ),
            e3)
          ) {
            i.push(e3);
            const t2 = __PRIVATE_LocalViewChanges.Ki(_.targetId, e3);
            s.push(t2);
          }
        })
      );
    }),
    await Promise.all(o),
    r2.ya.u_(i),
    await (async function __PRIVATE_localStoreNotifyLocalViewChanges(e2, t2) {
      const n2 = __PRIVATE_debugCast(e2);
      try {
        await n2.persistence.runTransaction(
          "notifyLocalViewChanges",
          "readwrite",
          (e3) =>
            PersistencePromise.forEach(t2, (t3) =>
              PersistencePromise.forEach(t3.qi, (r3) =>
                n2.persistence.referenceDelegate.addReference(
                  e3,
                  t3.targetId,
                  r3
                )
              ).next(() =>
                PersistencePromise.forEach(t3.Qi, (r3) =>
                  n2.persistence.referenceDelegate.removeReference(
                    e3,
                    t3.targetId,
                    r3
                  )
                )
              )
            )
        );
      } catch (e3) {
        if (!__PRIVATE_isIndexedDbTransactionError(e3)) throw e3;
        __PRIVATE_logDebug(
          "LocalStore",
          "Failed to update sequence numbers: " + e3
        );
      }
      for (const e3 of t2) {
        const t3 = e3.targetId;
        if (!e3.fromCache) {
          const e4 = n2.ns.get(t3),
            r3 = e4.snapshotVersion,
            i2 = e4.withLastLimboFreeSnapshotVersion(r3);
          n2.ns = n2.ns.insert(t3, i2);
        }
      }
    })(r2.localStore, s));
}
async function __PRIVATE_syncEngineHandleCredentialChange(e, t) {
  const n = __PRIVATE_debugCast(e);
  if (!n.currentUser.isEqual(t)) {
    __PRIVATE_logDebug("SyncEngine", "User change. New user:", t.toKey());
    const e2 = await __PRIVATE_localStoreHandleUserChange(n.localStore, t);
    (n.currentUser = t), // Fails tasks waiting for pending writes requested by previous user.
      (function __PRIVATE_rejectOutstandingPendingWritesCallbacks(e3, t2) {
        e3.Ma.forEach((e4) => {
          e4.forEach((e5) => {
            e5.reject(new FirestoreError(D.CANCELLED, t2));
          });
        }),
          e3.Ma.clear();
      })(n, "'waitForPendingWrites' promise is rejected due to a user change."), // TODO(b/114226417): Consider calling this only in the primary tab.
      n.sharedClientState.handleUserChange(
        t,
        e2.removedBatchIds,
        e2.addedBatchIds
      ),
      await __PRIVATE_syncEngineEmitNewSnapsAndNotifyLocalStore(n, e2.us);
  }
}
function __PRIVATE_syncEngineGetRemoteKeysForTarget(e, t) {
  const n = __PRIVATE_debugCast(e),
    r2 = n.Ca.get(t);
  if (r2 && r2.pa) return __PRIVATE_documentKeySet().add(r2.key);
  {
    let e2 = __PRIVATE_documentKeySet();
    const r3 = n.Sa.get(t);
    if (!r3) return e2;
    for (const t2 of r3) {
      const r4 = n.wa.get(t2);
      e2 = e2.unionWith(r4.view.Ia);
    }
    return e2;
  }
}
function __PRIVATE_ensureWatchCallbacks(e) {
  const t = __PRIVATE_debugCast(e);
  return (
    (t.remoteStore.remoteSyncer.applyRemoteEvent =
      __PRIVATE_syncEngineApplyRemoteEvent.bind(null, t)),
    (t.remoteStore.remoteSyncer.getRemoteKeysForTarget =
      __PRIVATE_syncEngineGetRemoteKeysForTarget.bind(null, t)),
    (t.remoteStore.remoteSyncer.rejectListen =
      __PRIVATE_syncEngineRejectListen.bind(null, t)),
    (t.ya.u_ = __PRIVATE_eventManagerOnWatchChange.bind(null, t.eventManager)),
    (t.ya.La = __PRIVATE_eventManagerOnWatchError.bind(null, t.eventManager)),
    t
  );
}
function __PRIVATE_syncEngineEnsureWriteCallbacks(e) {
  const t = __PRIVATE_debugCast(e);
  return (
    (t.remoteStore.remoteSyncer.applySuccessfulWrite =
      __PRIVATE_syncEngineApplySuccessfulWrite.bind(null, t)),
    (t.remoteStore.remoteSyncer.rejectFailedWrite =
      __PRIVATE_syncEngineRejectFailedWrite.bind(null, t)),
    t
  );
}
class MemoryOfflineComponentProvider {
  constructor() {
    this.synchronizeTabs = false;
  }
  async initialize(e) {
    (this.serializer = __PRIVATE_newSerializer(e.databaseInfo.databaseId)),
      (this.sharedClientState = this.createSharedClientState(e)),
      (this.persistence = this.createPersistence(e)),
      await this.persistence.start(),
      (this.localStore = this.createLocalStore(e)),
      (this.gcScheduler = this.createGarbageCollectionScheduler(
        e,
        this.localStore
      )),
      (this.indexBackfillerScheduler = this.createIndexBackfillerScheduler(
        e,
        this.localStore
      ));
  }
  createGarbageCollectionScheduler(e, t) {
    return null;
  }
  createIndexBackfillerScheduler(e, t) {
    return null;
  }
  createLocalStore(e) {
    return __PRIVATE_newLocalStore(
      this.persistence,
      new __PRIVATE_QueryEngine(),
      e.initialUser,
      this.serializer
    );
  }
  createPersistence(e) {
    return new __PRIVATE_MemoryPersistence(
      __PRIVATE_MemoryEagerDelegate.Hr,
      this.serializer
    );
  }
  createSharedClientState(e) {
    return new __PRIVATE_MemorySharedClientState();
  }
  async terminate() {
    var e, t;
    null === (e = this.gcScheduler) || void 0 === e || e.stop(),
      null === (t = this.indexBackfillerScheduler) || void 0 === t || t.stop(),
      this.sharedClientState.shutdown(),
      await this.persistence.shutdown();
  }
}
class OnlineComponentProvider {
  async initialize(e, t) {
    this.localStore ||
      ((this.localStore = e.localStore),
      (this.sharedClientState = e.sharedClientState),
      (this.datastore = this.createDatastore(t)),
      (this.remoteStore = this.createRemoteStore(t)),
      (this.eventManager = this.createEventManager(t)),
      (this.syncEngine = this.createSyncEngine(
        t,
        /* startAsPrimary=*/
        !e.synchronizeTabs
      )),
      (this.sharedClientState.onlineStateHandler = (e2) =>
        __PRIVATE_syncEngineApplyOnlineStateChange(
          this.syncEngine,
          e2,
          1
          /* OnlineStateSource.SharedClientState */
        )),
      (this.remoteStore.remoteSyncer.handleCredentialChange =
        __PRIVATE_syncEngineHandleCredentialChange.bind(null, this.syncEngine)),
      await __PRIVATE_remoteStoreApplyPrimaryState(
        this.remoteStore,
        this.syncEngine.isPrimaryClient
      ));
  }
  createEventManager(e) {
    return (function __PRIVATE_newEventManager() {
      return new __PRIVATE_EventManagerImpl();
    })();
  }
  createDatastore(e) {
    const t = __PRIVATE_newSerializer(e.databaseInfo.databaseId),
      n = (function __PRIVATE_newConnection(e2) {
        return new __PRIVATE_WebChannelConnection(e2);
      })(e.databaseInfo);
    return (function __PRIVATE_newDatastore(e2, t2, n2, r2) {
      return new __PRIVATE_DatastoreImpl(e2, t2, n2, r2);
    })(e.authCredentials, e.appCheckCredentials, n, t);
  }
  createRemoteStore(e) {
    return (function __PRIVATE_newRemoteStore(e2, t, n, r2, i) {
      return new __PRIVATE_RemoteStoreImpl(e2, t, n, r2, i);
    })(
      this.localStore,
      this.datastore,
      e.asyncQueue,
      (e2) =>
        __PRIVATE_syncEngineApplyOnlineStateChange(
          this.syncEngine,
          e2,
          0
          /* OnlineStateSource.RemoteStore */
        ),
      (function __PRIVATE_newConnectivityMonitor() {
        return __PRIVATE_BrowserConnectivityMonitor.D()
          ? new __PRIVATE_BrowserConnectivityMonitor()
          : new __PRIVATE_NoopConnectivityMonitor();
      })()
    );
  }
  createSyncEngine(e, t) {
    return (function __PRIVATE_newSyncEngine(e2, t2, n, r2, i, s, o) {
      const _ = new __PRIVATE_SyncEngineImpl(e2, t2, n, r2, i, s);
      return o && (_.Oa = true), _;
    })(
      this.localStore,
      this.remoteStore,
      this.eventManager,
      this.sharedClientState,
      e.initialUser,
      e.maxConcurrentLimboResolutions,
      t
    );
  }
  async terminate() {
    var e;
    await (async function __PRIVATE_remoteStoreShutdown(e2) {
      const t = __PRIVATE_debugCast(e2);
      __PRIVATE_logDebug("RemoteStore", "RemoteStore shutting down."),
        t.v_.add(
          5
          /* OfflineCause.Shutdown */
        ),
        await __PRIVATE_disableNetworkInternal(t),
        t.M_.shutdown(), // Set the OnlineState to Unknown (rather than Offline) to avoid potentially
        // triggering spurious listener events with cached data, etc.
        t.x_.set(
          "Unknown"
          /* OnlineState.Unknown */
        );
    })(this.remoteStore),
      null === (e = this.datastore) || void 0 === e || e.terminate();
  }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class __PRIVATE_AsyncObserver {
  constructor(e) {
    (this.observer = e),
      /**
       * When set to true, will not raise future events. Necessary to deal with
       * async detachment of listener.
       */ (this.muted = false);
  }
  next(e) {
    this.observer.next && this.qa(this.observer.next, e);
  }
  error(e) {
    this.observer.error
      ? this.qa(this.observer.error, e)
      : __PRIVATE_logError(
          "Uncaught Error in snapshot listener:",
          e.toString()
        );
  }
  Qa() {
    this.muted = true;
  }
  qa(e, t) {
    this.muted ||
      setTimeout(() => {
        this.muted || e(t);
      }, 0);
  }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class FirestoreClient {
  constructor(e, t, n, r2) {
    (this.authCredentials = e),
      (this.appCheckCredentials = t),
      (this.asyncQueue = n),
      (this.databaseInfo = r2),
      (this.user = User.UNAUTHENTICATED),
      (this.clientId = __PRIVATE_AutoId.newId()),
      (this.authCredentialListener = () => Promise.resolve()),
      (this.appCheckCredentialListener = () => Promise.resolve()),
      this.authCredentials.start(n, async (e2) => {
        __PRIVATE_logDebug("FirestoreClient", "Received user=", e2.uid),
          await this.authCredentialListener(e2),
          (this.user = e2);
      }),
      this.appCheckCredentials.start(
        n,
        (e2) => (
          __PRIVATE_logDebug(
            "FirestoreClient",
            "Received new app check token=",
            e2
          ),
          this.appCheckCredentialListener(e2, this.user)
        )
      );
  }
  get configuration() {
    return {
      asyncQueue: this.asyncQueue,
      databaseInfo: this.databaseInfo,
      clientId: this.clientId,
      authCredentials: this.authCredentials,
      appCheckCredentials: this.appCheckCredentials,
      initialUser: this.user,
      maxConcurrentLimboResolutions: 100,
    };
  }
  setCredentialChangeListener(e) {
    this.authCredentialListener = e;
  }
  setAppCheckTokenChangeListener(e) {
    this.appCheckCredentialListener = e;
  }
  /**
   * Checks that the client has not been terminated. Ensures that other methods on //
   * this class cannot be called after the client is terminated. //
   */
  verifyNotTerminated() {
    if (this.asyncQueue.isShuttingDown)
      throw new FirestoreError(
        D.FAILED_PRECONDITION,
        "The client has already been terminated."
      );
  }
  terminate() {
    this.asyncQueue.enterRestrictedMode();
    const e = new __PRIVATE_Deferred();
    return (
      this.asyncQueue.enqueueAndForgetEvenWhileRestricted(async () => {
        try {
          this._onlineComponents && (await this._onlineComponents.terminate()),
            this._offlineComponents &&
              (await this._offlineComponents.terminate()), // The credentials provider must be terminated after shutting down the
            // RemoteStore as it will prevent the RemoteStore from retrieving auth
            // tokens.
            this.authCredentials.shutdown(),
            this.appCheckCredentials.shutdown(),
            e.resolve();
        } catch (t) {
          const n = __PRIVATE_wrapInUserErrorIfRecoverable(
            t,
            "Failed to shutdown persistence"
          );
          e.reject(n);
        }
      }),
      e.promise
    );
  }
}
async function __PRIVATE_setOfflineComponentProvider(e, t) {
  e.asyncQueue.verifyOperationInProgress(),
    __PRIVATE_logDebug(
      "FirestoreClient",
      "Initializing OfflineComponentProvider"
    );
  const n = e.configuration;
  await t.initialize(n);
  let r2 = n.initialUser;
  e.setCredentialChangeListener(async (e2) => {
    r2.isEqual(e2) ||
      (await __PRIVATE_localStoreHandleUserChange(t.localStore, e2), (r2 = e2));
  }), // When a user calls clearPersistence() in one client, all other clients
    // need to be terminated to allow the delete to succeed.
    t.persistence.setDatabaseDeletedListener(() => e.terminate()),
    (e._offlineComponents = t);
}
async function __PRIVATE_setOnlineComponentProvider(e, t) {
  e.asyncQueue.verifyOperationInProgress();
  const n = await __PRIVATE_ensureOfflineComponents(e);
  __PRIVATE_logDebug("FirestoreClient", "Initializing OnlineComponentProvider"),
    await t.initialize(n, e.configuration), // The CredentialChangeListener of the online component provider takes
    // precedence over the offline component provider.
    e.setCredentialChangeListener((e2) =>
      __PRIVATE_remoteStoreHandleCredentialChange(t.remoteStore, e2)
    ),
    e.setAppCheckTokenChangeListener((e2, n2) =>
      __PRIVATE_remoteStoreHandleCredentialChange(t.remoteStore, n2)
    ),
    (e._onlineComponents = t);
}
function __PRIVATE_canFallbackFromIndexedDbError(e) {
  return "FirebaseError" === e.name
    ? e.code === D.FAILED_PRECONDITION || e.code === D.UNIMPLEMENTED
    : !("undefined" != typeof DOMException && e instanceof DOMException) || // When the browser is out of quota we could get either quota exceeded
        // or an aborted error depending on whether the error happened during
        // schema migration.
        22 === e.code ||
        20 === e.code || // Firefox Private Browsing mode disables IndexedDb and returns
        // INVALID_STATE for any usage.
        11 === e.code;
}
async function __PRIVATE_ensureOfflineComponents(e) {
  if (!e._offlineComponents)
    if (e._uninitializedComponentsProvider) {
      __PRIVATE_logDebug(
        "FirestoreClient",
        "Using user provided OfflineComponentProvider"
      );
      try {
        await __PRIVATE_setOfflineComponentProvider(
          e,
          e._uninitializedComponentsProvider._offline
        );
      } catch (t) {
        const n = t;
        if (!__PRIVATE_canFallbackFromIndexedDbError(n)) throw n;
        __PRIVATE_logWarn(
          "Error using user provided cache. Falling back to memory cache: " + n
        ),
          await __PRIVATE_setOfflineComponentProvider(
            e,
            new MemoryOfflineComponentProvider()
          );
      }
    } else
      __PRIVATE_logDebug(
        "FirestoreClient",
        "Using default OfflineComponentProvider"
      ),
        await __PRIVATE_setOfflineComponentProvider(
          e,
          new MemoryOfflineComponentProvider()
        );
  return e._offlineComponents;
}
async function __PRIVATE_ensureOnlineComponents(e) {
  return (
    e._onlineComponents ||
      (e._uninitializedComponentsProvider
        ? (__PRIVATE_logDebug(
            "FirestoreClient",
            "Using user provided OnlineComponentProvider"
          ),
          await __PRIVATE_setOnlineComponentProvider(
            e,
            e._uninitializedComponentsProvider._online
          ))
        : (__PRIVATE_logDebug(
            "FirestoreClient",
            "Using default OnlineComponentProvider"
          ),
          await __PRIVATE_setOnlineComponentProvider(
            e,
            new OnlineComponentProvider()
          ))),
    e._onlineComponents
  );
}
function __PRIVATE_getSyncEngine(e) {
  return __PRIVATE_ensureOnlineComponents(e).then((e2) => e2.syncEngine);
}
async function __PRIVATE_getEventManager(e) {
  const t = await __PRIVATE_ensureOnlineComponents(e),
    n = t.eventManager;
  return (
    (n.onListen = __PRIVATE_syncEngineListen.bind(null, t.syncEngine)),
    (n.onUnlisten = __PRIVATE_syncEngineUnlisten.bind(null, t.syncEngine)),
    (n.onFirstRemoteStoreListen = __PRIVATE_triggerRemoteStoreListen.bind(
      null,
      t.syncEngine
    )),
    (n.onLastRemoteStoreUnlisten = __PRIVATE_triggerRemoteStoreUnlisten.bind(
      null,
      t.syncEngine
    )),
    n
  );
}
function __PRIVATE_firestoreClientGetDocumentsViaSnapshotListener(
  e,
  t,
  n = {}
) {
  const r2 = new __PRIVATE_Deferred();
  return (
    e.asyncQueue.enqueueAndForget(async () =>
      (function __PRIVATE_executeQueryViaSnapshotListener(e2, t2, n2, r3, i) {
        const s = new __PRIVATE_AsyncObserver({
            next: (n3) => {
              t2.enqueueAndForget(() => __PRIVATE_eventManagerUnlisten(e2, o)),
                n3.fromCache && "server" === r3.source
                  ? i.reject(
                      new FirestoreError(
                        D.UNAVAILABLE,
                        'Failed to get documents from server. (However, these documents may exist in the local cache. Run again without setting source to "server" to retrieve the cached documents.)'
                      )
                    )
                  : i.resolve(n3);
            },
            error: (e3) => i.reject(e3),
          }),
          o = new __PRIVATE_QueryListener(n2, s, {
            includeMetadataChanges: true,
            ta: true,
          });
        return __PRIVATE_eventManagerListen(e2, o);
      })(await __PRIVATE_getEventManager(e), e.asyncQueue, t, n, r2)
    ),
    r2.promise
  );
}
/**
 * @license
 * Copyright 2023 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function __PRIVATE_cloneLongPollingOptions(e) {
  const t = {};
  return (
    void 0 !== e.timeoutSeconds && (t.timeoutSeconds = e.timeoutSeconds), t
  );
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const pe = /* @__PURE__ */ new Map();
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function __PRIVATE_validateNonEmptyArgument(e, t, n) {
  if (!n)
    throw new FirestoreError(
      D.INVALID_ARGUMENT,
      `Function ${e}() cannot be called with an empty ${t}.`
    );
}
function __PRIVATE_validateIsNotUsedTogether(e, t, n, r2) {
  if (true === t && true === r2)
    throw new FirestoreError(
      D.INVALID_ARGUMENT,
      `${e} and ${n} cannot be used together.`
    );
}
function __PRIVATE_validateDocumentPath(e) {
  if (!DocumentKey.isDocumentKey(e))
    throw new FirestoreError(
      D.INVALID_ARGUMENT,
      `Invalid document reference. Document references must have an even number of segments, but ${e} has ${e.length}.`
    );
}
function __PRIVATE_validateCollectionPath(e) {
  if (DocumentKey.isDocumentKey(e))
    throw new FirestoreError(
      D.INVALID_ARGUMENT,
      `Invalid collection reference. Collection references must have an odd number of segments, but ${e} has ${e.length}.`
    );
}
function __PRIVATE_valueDescription(e) {
  if (void 0 === e) return "undefined";
  if (null === e) return "null";
  if ("string" == typeof e)
    return e.length > 20 && (e = `${e.substring(0, 20)}...`), JSON.stringify(e);
  if ("number" == typeof e || "boolean" == typeof e) return "" + e;
  if ("object" == typeof e) {
    if (e instanceof Array) return "an array";
    {
      const t =
        /** try to get the constructor name for an object. */
        (function __PRIVATE_tryGetCustomObjectType(e2) {
          if (e2.constructor) return e2.constructor.name;
          return null;
        })(e);
      return t ? `a custom ${t} object` : "an object";
    }
  }
  return "function" == typeof e ? "a function" : fail();
}
function __PRIVATE_cast(e, t) {
  if (
    ("_delegate" in e && // Unwrap Compat types
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      (e = e._delegate),
    !(e instanceof t))
  ) {
    if (t.name === e.constructor.name)
      throw new FirestoreError(
        D.INVALID_ARGUMENT,
        "Type does not match the expected instance. Did you pass a reference from a different Firestore SDK?"
      );
    {
      const n = __PRIVATE_valueDescription(e);
      throw new FirestoreError(
        D.INVALID_ARGUMENT,
        `Expected type '${t.name}', but it was: ${n}`
      );
    }
  }
  return e;
}
function __PRIVATE_validatePositiveNumber(e, t) {
  if (t <= 0)
    throw new FirestoreError(
      D.INVALID_ARGUMENT,
      `Function ${e}() requires a positive number, but it was: ${t}.`
    );
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class FirestoreSettingsImpl {
  constructor(e) {
    var t, n;
    if (void 0 === e.host) {
      if (void 0 !== e.ssl)
        throw new FirestoreError(
          D.INVALID_ARGUMENT,
          "Can't provide ssl option if host option is not set"
        );
      (this.host = "firestore.googleapis.com"), (this.ssl = true);
    } else
      (this.host = e.host),
        (this.ssl = null === (t = e.ssl) || void 0 === t || t);
    if (
      ((this.credentials = e.credentials),
      (this.ignoreUndefinedProperties = !!e.ignoreUndefinedProperties),
      (this.localCache = e.localCache),
      void 0 === e.cacheSizeBytes)
    )
      this.cacheSizeBytes = 41943040;
    else {
      if (-1 !== e.cacheSizeBytes && e.cacheSizeBytes < 1048576)
        throw new FirestoreError(
          D.INVALID_ARGUMENT,
          "cacheSizeBytes must be at least 1048576"
        );
      this.cacheSizeBytes = e.cacheSizeBytes;
    }
    __PRIVATE_validateIsNotUsedTogether(
      "experimentalForceLongPolling",
      e.experimentalForceLongPolling,
      "experimentalAutoDetectLongPolling",
      e.experimentalAutoDetectLongPolling
    ),
      (this.experimentalForceLongPolling = !!e.experimentalForceLongPolling),
      this.experimentalForceLongPolling
        ? (this.experimentalAutoDetectLongPolling = false)
        : void 0 === e.experimentalAutoDetectLongPolling
        ? (this.experimentalAutoDetectLongPolling = true)
        : // For backwards compatibility, coerce the value to boolean even though
          // the TypeScript compiler has narrowed the type to boolean already.
          // noinspection PointlessBooleanExpressionJS
          (this.experimentalAutoDetectLongPolling =
            !!e.experimentalAutoDetectLongPolling),
      (this.experimentalLongPollingOptions = __PRIVATE_cloneLongPollingOptions(
        null !== (n = e.experimentalLongPollingOptions) && void 0 !== n ? n : {}
      )),
      (function __PRIVATE_validateLongPollingOptions(e2) {
        if (void 0 !== e2.timeoutSeconds) {
          if (isNaN(e2.timeoutSeconds))
            throw new FirestoreError(
              D.INVALID_ARGUMENT,
              `invalid long polling timeout: ${e2.timeoutSeconds} (must not be NaN)`
            );
          if (e2.timeoutSeconds < 5)
            throw new FirestoreError(
              D.INVALID_ARGUMENT,
              `invalid long polling timeout: ${e2.timeoutSeconds} (minimum allowed value is 5)`
            );
          if (e2.timeoutSeconds > 30)
            throw new FirestoreError(
              D.INVALID_ARGUMENT,
              `invalid long polling timeout: ${e2.timeoutSeconds} (maximum allowed value is 30)`
            );
        }
      })(this.experimentalLongPollingOptions),
      (this.useFetchStreams = !!e.useFetchStreams);
  }
  isEqual(e) {
    return (
      this.host === e.host &&
      this.ssl === e.ssl &&
      this.credentials === e.credentials &&
      this.cacheSizeBytes === e.cacheSizeBytes &&
      this.experimentalForceLongPolling === e.experimentalForceLongPolling &&
      this.experimentalAutoDetectLongPolling ===
        e.experimentalAutoDetectLongPolling &&
      (function __PRIVATE_longPollingOptionsEqual(e2, t) {
        return e2.timeoutSeconds === t.timeoutSeconds;
      })(
        this.experimentalLongPollingOptions,
        e.experimentalLongPollingOptions
      ) &&
      this.ignoreUndefinedProperties === e.ignoreUndefinedProperties &&
      this.useFetchStreams === e.useFetchStreams
    );
  }
}
class Firestore$1 {
  /** @hideconstructor */
  constructor(e, t, n, r2) {
    (this._authCredentials = e),
      (this._appCheckCredentials = t),
      (this._databaseId = n),
      (this._app = r2),
      /**
       * Whether it's a Firestore or Firestore Lite instance.
       */ (this.type = "firestore-lite"),
      (this._persistenceKey = "(lite)"),
      (this._settings = new FirestoreSettingsImpl({})),
      (this._settingsFrozen = false);
  }
  /**
   * The {@link @firebase/app#FirebaseApp} associated with this `Firestore` service
   * instance.
   */
  get app() {
    if (!this._app)
      throw new FirestoreError(
        D.FAILED_PRECONDITION,
        "Firestore was not initialized using the Firebase SDK. 'app' is not available"
      );
    return this._app;
  }
  get _initialized() {
    return this._settingsFrozen;
  }
  get _terminated() {
    return void 0 !== this._terminateTask;
  }
  _setSettings(e) {
    if (this._settingsFrozen)
      throw new FirestoreError(
        D.FAILED_PRECONDITION,
        "Firestore has already been started and its settings can no longer be changed. You can only modify settings before calling any other methods on a Firestore object."
      );
    (this._settings = new FirestoreSettingsImpl(e)),
      void 0 !== e.credentials &&
        (this._authCredentials =
          (function __PRIVATE_makeAuthCredentialsProvider(e2) {
            if (!e2) return new __PRIVATE_EmptyAuthCredentialsProvider();
            switch (e2.type) {
              case "firstParty":
                return new __PRIVATE_FirstPartyAuthCredentialsProvider(
                  e2.sessionIndex || "0",
                  e2.iamToken || null,
                  e2.authTokenFactory || null
                );
              case "provider":
                return e2.client;
              default:
                throw new FirestoreError(
                  D.INVALID_ARGUMENT,
                  "makeAuthCredentialsProvider failed due to invalid credential type"
                );
            }
          })(e.credentials));
  }
  _getSettings() {
    return this._settings;
  }
  _freezeSettings() {
    return (this._settingsFrozen = true), this._settings;
  }
  _delete() {
    return (
      this._terminateTask || (this._terminateTask = this._terminate()),
      this._terminateTask
    );
  }
  /** Returns a JSON-serializable representation of this `Firestore` instance. */
  toJSON() {
    return {
      app: this._app,
      databaseId: this._databaseId,
      settings: this._settings,
    };
  }
  /**
   * Terminates all components used by this client. Subclasses can override
   * this method to clean up their own dependencies, but must also call this
   * method.
   *
   * Only ever called once.
   */
  _terminate() {
    return (
      (function __PRIVATE_removeComponents(e) {
        const t = pe.get(e);
        t &&
          (__PRIVATE_logDebug("ComponentProvider", "Removing Datastore"),
          pe.delete(e),
          t.terminate());
      })(this),
      Promise.resolve()
    );
  }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class Query {
  // This is the lite version of the Query class in the main SDK.
  /** @hideconstructor protected */
  constructor(e, t, n) {
    (this.converter = t),
      (this._query = n) /** The type of this Firestore reference. */,
      (this.type = "query"),
      (this.firestore = e);
  }
  withConverter(e) {
    return new Query(this.firestore, e, this._query);
  }
}
class DocumentReference {
  /** @hideconstructor */
  constructor(e, t, n) {
    (this.converter = t),
      (this._key = n) /** The type of this Firestore reference. */,
      (this.type = "document"),
      (this.firestore = e);
  }
  get _path() {
    return this._key.path;
  }
  /**
   * The document's identifier within its collection.
   */
  get id() {
    return this._key.path.lastSegment();
  }
  /**
   * A string representing the path of the referenced document (relative
   * to the root of the database).
   */
  get path() {
    return this._key.path.canonicalString();
  }
  /**
   * The collection this `DocumentReference` belongs to.
   */
  get parent() {
    return new CollectionReference(
      this.firestore,
      this.converter,
      this._key.path.popLast()
    );
  }
  withConverter(e) {
    return new DocumentReference(this.firestore, e, this._key);
  }
}
class CollectionReference extends Query {
  /** @hideconstructor */
  constructor(e, t, n) {
    super(e, t, __PRIVATE_newQueryForPath(n)),
      (this._path = n) /** The type of this Firestore reference. */,
      (this.type = "collection");
  }
  /** The collection's identifier. */
  get id() {
    return this._query.path.lastSegment();
  }
  /**
   * A string representing the path of the referenced collection (relative
   * to the root of the database).
   */
  get path() {
    return this._query.path.canonicalString();
  }
  /**
   * A reference to the containing `DocumentReference` if this is a
   * subcollection. If this isn't a subcollection, the reference is null.
   */
  get parent() {
    const e = this._path.popLast();
    return e.isEmpty()
      ? null
      : new DocumentReference(
          this.firestore,
          /* converter= */
          null,
          new DocumentKey(e)
        );
  }
  withConverter(e) {
    return new CollectionReference(this.firestore, e, this._path);
  }
}
function collection(e, t, ...n) {
  if (
    ((e = getModularInstance(e)),
    __PRIVATE_validateNonEmptyArgument("collection", "path", t),
    e instanceof Firestore$1)
  ) {
    const r2 = ResourcePath.fromString(t, ...n);
    return (
      __PRIVATE_validateCollectionPath(r2),
      new CollectionReference(
        e,
        /* converter= */
        null,
        r2
      )
    );
  }
  {
    if (!(e instanceof DocumentReference || e instanceof CollectionReference))
      throw new FirestoreError(
        D.INVALID_ARGUMENT,
        "Expected first argument to collection() to be a CollectionReference, a DocumentReference or FirebaseFirestore"
      );
    const r2 = e._path.child(ResourcePath.fromString(t, ...n));
    return (
      __PRIVATE_validateCollectionPath(r2),
      new CollectionReference(
        e.firestore,
        /* converter= */
        null,
        r2
      )
    );
  }
}
function doc(e, t, ...n) {
  if (
    ((e = getModularInstance(e)), // We allow omission of 'pathString' but explicitly prohibit passing in both
    // 'undefined' and 'null'.
    1 === arguments.length && (t = __PRIVATE_AutoId.newId()),
    __PRIVATE_validateNonEmptyArgument("doc", "path", t),
    e instanceof Firestore$1)
  ) {
    const r2 = ResourcePath.fromString(t, ...n);
    return (
      __PRIVATE_validateDocumentPath(r2),
      new DocumentReference(
        e,
        /* converter= */
        null,
        new DocumentKey(r2)
      )
    );
  }
  {
    if (!(e instanceof DocumentReference || e instanceof CollectionReference))
      throw new FirestoreError(
        D.INVALID_ARGUMENT,
        "Expected first argument to collection() to be a CollectionReference, a DocumentReference or FirebaseFirestore"
      );
    const r2 = e._path.child(ResourcePath.fromString(t, ...n));
    return (
      __PRIVATE_validateDocumentPath(r2),
      new DocumentReference(
        e.firestore,
        e instanceof CollectionReference ? e.converter : null,
        new DocumentKey(r2)
      )
    );
  }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class __PRIVATE_AsyncQueueImpl {
  constructor() {
    (this.nu = Promise.resolve()), // A list of retryable operations. Retryable operations are run in order and
      // retried with backoff.
      (this.ru = []), // Is this AsyncQueue being shut down? Once it is set to true, it will not
      // be changed again.
      (this.iu = false), // Operations scheduled to be queued in the future. Operations are
      // automatically removed after they are run or canceled.
      (this.su = []), // visible for testing
      (this.ou = null), // Flag set while there's an outstanding AsyncQueue operation, used for
      // assertion sanity-checks.
      (this._u = false), // Enabled during shutdown on Safari to prevent future access to IndexedDB.
      (this.au = false), // List of TimerIds to fast-forward delays for.
      (this.uu = []), // Backoff timer used to schedule retries for retryable operations
      (this.jo = new __PRIVATE_ExponentialBackoff(
        this,
        "async_queue_retry"
        /* TimerId.AsyncQueueRetry */
      )), // Visibility handler that triggers an immediate retry of all retryable
      // operations. Meant to speed up recovery when we regain file system access
      // after page comes into foreground.
      (this.cu = () => {
        const e2 = getDocument();
        e2 &&
          __PRIVATE_logDebug(
            "AsyncQueue",
            "Visibility state changed to " + e2.visibilityState
          ),
          this.jo.Ko();
      });
    const e = getDocument();
    e &&
      "function" == typeof e.addEventListener &&
      e.addEventListener("visibilitychange", this.cu);
  }
  get isShuttingDown() {
    return this.iu;
  }
  /**
   * Adds a new operation to the queue without waiting for it to complete (i.e.
   * we ignore the Promise result).
   */
  enqueueAndForget(e) {
    this.enqueue(e);
  }
  enqueueAndForgetEvenWhileRestricted(e) {
    this.lu(), // eslint-disable-next-line @typescript-eslint/no-floating-promises
      this.hu(e);
  }
  enterRestrictedMode(e) {
    if (!this.iu) {
      (this.iu = true), (this.au = e || false);
      const t = getDocument();
      t &&
        "function" == typeof t.removeEventListener &&
        t.removeEventListener("visibilitychange", this.cu);
    }
  }
  enqueue(e) {
    if ((this.lu(), this.iu)) return new Promise(() => {});
    const t = new __PRIVATE_Deferred();
    return this.hu(() =>
      this.iu && this.au
        ? Promise.resolve()
        : (e().then(t.resolve, t.reject), t.promise)
    ).then(() => t.promise);
  }
  enqueueRetryable(e) {
    this.enqueueAndForget(() => (this.ru.push(e), this.Pu()));
  }
  /**
   * Runs the next operation from the retryable queue. If the operation fails,
   * reschedules with backoff.
   */
  async Pu() {
    if (0 !== this.ru.length) {
      try {
        await this.ru[0](), this.ru.shift(), this.jo.reset();
      } catch (e) {
        if (!__PRIVATE_isIndexedDbTransactionError(e)) throw e;
        __PRIVATE_logDebug(
          "AsyncQueue",
          "Operation failed with retryable error: " + e
        );
      }
      this.ru.length > 0 && // If there are additional operations, we re-schedule `retryNextOp()`.
        // This is necessary to run retryable operations that failed during
        // their initial attempt since we don't know whether they are already
        // enqueued. If, for example, `op1`, `op2`, `op3` are enqueued and `op1`
        // needs to  be re-run, we will run `op1`, `op1`, `op2` using the
        // already enqueued calls to `retryNextOp()`. `op3()` will then run in the
        // call scheduled here.
        // Since `backoffAndRun()` cancels an existing backoff and schedules a
        // new backoff on every call, there is only ever a single additional
        // operation in the queue.
        this.jo.qo(() => this.Pu());
    }
  }
  hu(e) {
    const t = this.nu.then(
      () => (
        (this._u = true),
        e()
          .catch((e2) => {
            (this.ou = e2), (this._u = false);
            const t2 =
              /**
               * Chrome includes Error.message in Error.stack. Other browsers do not.
               * This returns expected output of message + stack when available.
               * @param error - Error or FirestoreError
               */
              (function __PRIVATE_getMessageOrStack(e3) {
                let t3 = e3.message || "";
                e3.stack &&
                  (t3 = e3.stack.includes(e3.message)
                    ? e3.stack
                    : e3.message + "\n" + e3.stack);
                return t3;
              })(e2);
            throw (__PRIVATE_logError("INTERNAL UNHANDLED ERROR: ", t2), e2);
          })
          .then((e2) => ((this._u = false), e2))
      )
    );
    return (this.nu = t), t;
  }
  enqueueAfterDelay(e, t, n) {
    this.lu(), // Fast-forward delays for timerIds that have been overriden.
      this.uu.indexOf(e) > -1 && (t = 0);
    const r2 = DelayedOperation.createAndSchedule(this, e, t, n, (e2) =>
      this.Iu(e2)
    );
    return this.su.push(r2), r2;
  }
  lu() {
    this.ou && fail();
  }
  verifyOperationInProgress() {}
  /**
   * Waits until all currently queued tasks are finished executing. Delayed
   * operations are not run.
   */
  async Tu() {
    let e;
    do {
      (e = this.nu), await e;
    } while (e !== this.nu);
  }
  /**
   * For Tests: Determine if a delayed operation with a particular TimerId
   * exists.
   */
  Eu(e) {
    for (const t of this.su) if (t.timerId === e) return true;
    return false;
  }
  /**
   * For Tests: Runs some or all delayed operations early.
   *
   * @param lastTimerId - Delayed operations up to and including this TimerId
   * will be drained. Pass TimerId.All to run all delayed operations.
   * @returns a Promise that resolves once all operations have been run.
   */
  du(e) {
    return this.Tu().then(() => {
      this.su.sort((e2, t) => e2.targetTimeMs - t.targetTimeMs);
      for (const t of this.su)
        if ((t.skipDelay(), "all" !== e && t.timerId === e)) break;
      return this.Tu();
    });
  }
  /**
   * For Tests: Skip all subsequent delays for a timer id.
   */
  Au(e) {
    this.uu.push(e);
  }
  /** Called once a DelayedOperation is run or canceled. */
  Iu(e) {
    const t = this.su.indexOf(e);
    this.su.splice(t, 1);
  }
}
class Firestore extends Firestore$1 {
  /** @hideconstructor */
  constructor(e, t, n, r2) {
    super(e, t, n, r2),
      /**
       * Whether it's a {@link Firestore} or Firestore Lite instance.
       */ (this.type = "firestore"),
      (this._queue = (function __PRIVATE_newAsyncQueue() {
        return new __PRIVATE_AsyncQueueImpl();
      })()),
      (this._persistenceKey = (null == r2 ? void 0 : r2.name) || "[DEFAULT]");
  }
  _terminate() {
    return (
      this._firestoreClient || // The client must be initialized to ensure that all subsequent API
        // usage throws an exception.
        __PRIVATE_configureFirestore(this),
      this._firestoreClient.terminate()
    );
  }
}
function initializeFirestore(e, t, n) {
  n || (n = "(default)");
  const r2 = _getProvider(e, "firestore");
  if (r2.isInitialized(n)) {
    const e2 = r2.getImmediate({
        identifier: n,
      }),
      i = r2.getOptions(n);
    if (deepEqual(i, t)) return e2;
    throw new FirestoreError(
      D.FAILED_PRECONDITION,
      "initializeFirestore() has already been called with different options. To avoid this error, call initializeFirestore() with the same options as when it was originally called, or call getFirestore() to return the already initialized instance."
    );
  }
  if (void 0 !== t.cacheSizeBytes && void 0 !== t.localCache)
    throw new FirestoreError(
      D.INVALID_ARGUMENT,
      "cache and cacheSizeBytes cannot be specified at the same time as cacheSizeBytes willbe deprecated. Instead, specify the cache size in the cache object"
    );
  if (
    void 0 !== t.cacheSizeBytes &&
    -1 !== t.cacheSizeBytes &&
    t.cacheSizeBytes < 1048576
  )
    throw new FirestoreError(
      D.INVALID_ARGUMENT,
      "cacheSizeBytes must be at least 1048576"
    );
  return r2.initialize({
    options: t,
    instanceIdentifier: n,
  });
}
function ensureFirestoreConfigured(e) {
  return (
    e._firestoreClient || __PRIVATE_configureFirestore(e),
    e._firestoreClient.verifyNotTerminated(),
    e._firestoreClient
  );
}
function __PRIVATE_configureFirestore(e) {
  var t, n, r2;
  const i = e._freezeSettings(),
    s = (function __PRIVATE_makeDatabaseInfo(e2, t2, n2, r3) {
      return new DatabaseInfo(
        e2,
        t2,
        n2,
        r3.host,
        r3.ssl,
        r3.experimentalForceLongPolling,
        r3.experimentalAutoDetectLongPolling,
        __PRIVATE_cloneLongPollingOptions(r3.experimentalLongPollingOptions),
        r3.useFetchStreams
      );
    })(
      e._databaseId,
      (null === (t = e._app) || void 0 === t ? void 0 : t.options.appId) || "",
      e._persistenceKey,
      i
    );
  (e._firestoreClient = new FirestoreClient(
    e._authCredentials,
    e._appCheckCredentials,
    e._queue,
    s
  )),
    (null === (n = i.localCache) || void 0 === n
      ? void 0
      : n._offlineComponentProvider) &&
      (null === (r2 = i.localCache) || void 0 === r2
        ? void 0
        : r2._onlineComponentProvider) &&
      (e._firestoreClient._uninitializedComponentsProvider = {
        _offlineKind: i.localCache.kind,
        _offline: i.localCache._offlineComponentProvider,
        _online: i.localCache._onlineComponentProvider,
      });
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class Bytes {
  /** @hideconstructor */
  constructor(e) {
    this._byteString = e;
  }
  /**
   * Creates a new `Bytes` object from the given Base64 string, converting it to
   * bytes.
   *
   * @param base64 - The Base64 string used to create the `Bytes` object.
   */
  static fromBase64String(e) {
    try {
      return new Bytes(ByteString.fromBase64String(e));
    } catch (e2) {
      throw new FirestoreError(
        D.INVALID_ARGUMENT,
        "Failed to construct data from Base64 string: " + e2
      );
    }
  }
  /**
   * Creates a new `Bytes` object from the given Uint8Array.
   *
   * @param array - The Uint8Array used to create the `Bytes` object.
   */
  static fromUint8Array(e) {
    return new Bytes(ByteString.fromUint8Array(e));
  }
  /**
   * Returns the underlying bytes as a Base64-encoded string.
   *
   * @returns The Base64-encoded string created from the `Bytes` object.
   */
  toBase64() {
    return this._byteString.toBase64();
  }
  /**
   * Returns the underlying bytes in a new `Uint8Array`.
   *
   * @returns The Uint8Array created from the `Bytes` object.
   */
  toUint8Array() {
    return this._byteString.toUint8Array();
  }
  /**
   * Returns a string representation of the `Bytes` object.
   *
   * @returns A string representation of the `Bytes` object.
   */
  toString() {
    return "Bytes(base64: " + this.toBase64() + ")";
  }
  /**
   * Returns true if this `Bytes` object is equal to the provided one.
   *
   * @param other - The `Bytes` object to compare against.
   * @returns true if this `Bytes` object is equal to the provided one.
   */
  isEqual(e) {
    return this._byteString.isEqual(e._byteString);
  }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class FieldPath {
  /**
   * Creates a `FieldPath` from the provided field names. If more than one field
   * name is provided, the path will point to a nested field in a document.
   *
   * @param fieldNames - A list of field names.
   */
  constructor(...e) {
    for (let t = 0; t < e.length; ++t)
      if (0 === e[t].length)
        throw new FirestoreError(
          D.INVALID_ARGUMENT,
          "Invalid field name at argument $(i + 1). Field names must not be empty."
        );
    this._internalPath = new FieldPath$1(e);
  }
  /**
   * Returns true if this `FieldPath` is equal to the provided one.
   *
   * @param other - The `FieldPath` to compare against.
   * @returns true if this `FieldPath` is equal to the provided one.
   */
  isEqual(e) {
    return this._internalPath.isEqual(e._internalPath);
  }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class FieldValue {
  /**
   * @param _methodName - The public API endpoint that returns this class.
   * @hideconstructor
   */
  constructor(e) {
    this._methodName = e;
  }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class GeoPoint {
  /**
   * Creates a new immutable `GeoPoint` object with the provided latitude and
   * longitude values.
   * @param latitude - The latitude as number between -90 and 90.
   * @param longitude - The longitude as number between -180 and 180.
   */
  constructor(e, t) {
    if (!isFinite(e) || e < -90 || e > 90)
      throw new FirestoreError(
        D.INVALID_ARGUMENT,
        "Latitude must be a number between -90 and 90, but was: " + e
      );
    if (!isFinite(t) || t < -180 || t > 180)
      throw new FirestoreError(
        D.INVALID_ARGUMENT,
        "Longitude must be a number between -180 and 180, but was: " + t
      );
    (this._lat = e), (this._long = t);
  }
  /**
   * The latitude of this `GeoPoint` instance.
   */
  get latitude() {
    return this._lat;
  }
  /**
   * The longitude of this `GeoPoint` instance.
   */
  get longitude() {
    return this._long;
  }
  /**
   * Returns true if this `GeoPoint` is equal to the provided one.
   *
   * @param other - The `GeoPoint` to compare against.
   * @returns true if this `GeoPoint` is equal to the provided one.
   */
  isEqual(e) {
    return this._lat === e._lat && this._long === e._long;
  }
  /** Returns a JSON-serializable representation of this GeoPoint. */
  toJSON() {
    return {
      latitude: this._lat,
      longitude: this._long,
    };
  }
  /**
   * Actually private to JS consumers of our API, so this function is prefixed
   * with an underscore.
   */
  _compareTo(e) {
    return (
      __PRIVATE_primitiveComparator(this._lat, e._lat) ||
      __PRIVATE_primitiveComparator(this._long, e._long)
    );
  }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const we = /^__.*__$/;
class ParsedSetData {
  constructor(e, t, n) {
    (this.data = e), (this.fieldMask = t), (this.fieldTransforms = n);
  }
  toMutation(e, t) {
    return null !== this.fieldMask
      ? new __PRIVATE_PatchMutation(
          e,
          this.data,
          this.fieldMask,
          t,
          this.fieldTransforms
        )
      : new __PRIVATE_SetMutation(e, this.data, t, this.fieldTransforms);
  }
}
function __PRIVATE_isWrite(e) {
  switch (e) {
    case 0:
    case 2:
    case 1:
      return true;
    case 3:
    case 4:
      return false;
    default:
      throw fail();
  }
}
class __PRIVATE_ParseContextImpl {
  /**
   * Initializes a ParseContext with the given source and path.
   *
   * @param settings - The settings for the parser.
   * @param databaseId - The database ID of the Firestore instance.
   * @param serializer - The serializer to use to generate the Value proto.
   * @param ignoreUndefinedProperties - Whether to ignore undefined properties
   * rather than throw.
   * @param fieldTransforms - A mutable list of field transforms encountered
   * while parsing the data.
   * @param fieldMask - A mutable list of field paths encountered while parsing
   * the data.
   *
   * TODO(b/34871131): We don't support array paths right now, so path can be
   * null to indicate the context represents any location within an array (in
   * which case certain features will not work and errors will be somewhat
   * compromised).
   */
  constructor(e, t, n, r2, i, s) {
    (this.settings = e),
      (this.databaseId = t),
      (this.serializer = n),
      (this.ignoreUndefinedProperties = r2), // Minor hack: If fieldTransforms is undefined, we assume this is an
      // external call and we need to validate the entire path.
      void 0 === i && this.Ru(),
      (this.fieldTransforms = i || []),
      (this.fieldMask = s || []);
  }
  get path() {
    return this.settings.path;
  }
  get Vu() {
    return this.settings.Vu;
  }
  /** Returns a new context with the specified settings overwritten. */
  mu(e) {
    return new __PRIVATE_ParseContextImpl(
      Object.assign(Object.assign({}, this.settings), e),
      this.databaseId,
      this.serializer,
      this.ignoreUndefinedProperties,
      this.fieldTransforms,
      this.fieldMask
    );
  }
  fu(e) {
    var t;
    const n = null === (t = this.path) || void 0 === t ? void 0 : t.child(e),
      r2 = this.mu({
        path: n,
        gu: false,
      });
    return r2.pu(e), r2;
  }
  yu(e) {
    var t;
    const n = null === (t = this.path) || void 0 === t ? void 0 : t.child(e),
      r2 = this.mu({
        path: n,
        gu: false,
      });
    return r2.Ru(), r2;
  }
  wu(e) {
    return this.mu({
      path: void 0,
      gu: true,
    });
  }
  Su(e) {
    return __PRIVATE_createError(
      e,
      this.settings.methodName,
      this.settings.bu || false,
      this.path,
      this.settings.Du
    );
  }
  /** Returns 'true' if 'fieldPath' was traversed when creating this context. */
  contains(e) {
    return (
      void 0 !== this.fieldMask.find((t) => e.isPrefixOf(t)) ||
      void 0 !== this.fieldTransforms.find((t) => e.isPrefixOf(t.field))
    );
  }
  Ru() {
    if (this.path)
      for (let e = 0; e < this.path.length; e++) this.pu(this.path.get(e));
  }
  pu(e) {
    if (0 === e.length) throw this.Su("Document fields must not be empty");
    if (__PRIVATE_isWrite(this.Vu) && we.test(e))
      throw this.Su('Document fields cannot begin and end with "__"');
  }
}
class __PRIVATE_UserDataReader {
  constructor(e, t, n) {
    (this.databaseId = e),
      (this.ignoreUndefinedProperties = t),
      (this.serializer = n || __PRIVATE_newSerializer(e));
  }
  /** Creates a new top-level parse context. */
  Cu(e, t, n, r2 = false) {
    return new __PRIVATE_ParseContextImpl(
      {
        Vu: e,
        methodName: t,
        Du: n,
        path: FieldPath$1.emptyPath(),
        gu: false,
        bu: r2,
      },
      this.databaseId,
      this.serializer,
      this.ignoreUndefinedProperties
    );
  }
}
function __PRIVATE_newUserDataReader(e) {
  const t = e._freezeSettings(),
    n = __PRIVATE_newSerializer(e._databaseId);
  return new __PRIVATE_UserDataReader(
    e._databaseId,
    !!t.ignoreUndefinedProperties,
    n
  );
}
function __PRIVATE_parseSetData(e, t, n, r2, i, s = {}) {
  const o = e.Cu(s.merge || s.mergeFields ? 2 : 0, t, n, i);
  __PRIVATE_validatePlainObject("Data must be an object, but it was:", o, r2);
  const _ = __PRIVATE_parseObject(r2, o);
  let a, u;
  if (s.merge) (a = new FieldMask(o.fieldMask)), (u = o.fieldTransforms);
  else if (s.mergeFields) {
    const e2 = [];
    for (const r3 of s.mergeFields) {
      const i2 = __PRIVATE_fieldPathFromArgument$1(t, r3, n);
      if (!o.contains(i2))
        throw new FirestoreError(
          D.INVALID_ARGUMENT,
          `Field '${i2}' is specified in your field mask but missing from your input data.`
        );
      __PRIVATE_fieldMaskContains(e2, i2) || e2.push(i2);
    }
    (a = new FieldMask(e2)),
      (u = o.fieldTransforms.filter((e3) => a.covers(e3.field)));
  } else (a = null), (u = o.fieldTransforms);
  return new ParsedSetData(new ObjectValue(_), a, u);
}
function __PRIVATE_parseQueryValue(e, t, n, r2 = false) {
  return __PRIVATE_parseData(n, e.Cu(r2 ? 4 : 3, t));
}
function __PRIVATE_parseData(e, t) {
  if (
    __PRIVATE_looksLikeJsonObject(
      // Unwrap the API type from the Compat SDK. This will return the API type
      // from firestore-exp.
      (e = getModularInstance(e))
    )
  )
    return (
      __PRIVATE_validatePlainObject("Unsupported field value:", t, e),
      __PRIVATE_parseObject(e, t)
    );
  if (e instanceof FieldValue)
    return (
      (function __PRIVATE_parseSentinelFieldValue(e2, t2) {
        if (!__PRIVATE_isWrite(t2.Vu))
          throw t2.Su(
            `${e2._methodName}() can only be used with update() and set()`
          );
        if (!t2.path)
          throw t2.Su(
            `${e2._methodName}() is not currently supported inside arrays`
          );
        const n = e2._toFieldTransform(t2);
        n && t2.fieldTransforms.push(n);
      })(e, t),
      null
    );
  if (void 0 === e && t.ignoreUndefinedProperties) return null;
  if (
    // If context.path is null we are inside an array and we don't support
    // field mask paths more granular than the top-level array.
    (t.path && t.fieldMask.push(t.path), e instanceof Array)
  ) {
    if (t.settings.gu && 4 !== t.Vu)
      throw t.Su("Nested arrays are not supported");
    return (function __PRIVATE_parseArray(e2, t2) {
      const n = [];
      let r2 = 0;
      for (const i of e2) {
        let e3 = __PRIVATE_parseData(i, t2.wu(r2));
        null == e3 && // Just include nulls in the array for fields being replaced with a
          // sentinel.
          (e3 = {
            nullValue: "NULL_VALUE",
          }),
          n.push(e3),
          r2++;
      }
      return {
        arrayValue: {
          values: n,
        },
      };
    })(e, t);
  }
  return (function __PRIVATE_parseScalarValue(e2, t2) {
    if (null === (e2 = getModularInstance(e2)))
      return {
        nullValue: "NULL_VALUE",
      };
    if ("number" == typeof e2) return toNumber(t2.serializer, e2);
    if ("boolean" == typeof e2)
      return {
        booleanValue: e2,
      };
    if ("string" == typeof e2)
      return {
        stringValue: e2,
      };
    if (e2 instanceof Date) {
      const n = Timestamp.fromDate(e2);
      return {
        timestampValue: toTimestamp(t2.serializer, n),
      };
    }
    if (e2 instanceof Timestamp) {
      const n = new Timestamp(
        e2.seconds,
        1e3 * Math.floor(e2.nanoseconds / 1e3)
      );
      return {
        timestampValue: toTimestamp(t2.serializer, n),
      };
    }
    if (e2 instanceof GeoPoint)
      return {
        geoPointValue: {
          latitude: e2.latitude,
          longitude: e2.longitude,
        },
      };
    if (e2 instanceof Bytes)
      return {
        bytesValue: __PRIVATE_toBytes(t2.serializer, e2._byteString),
      };
    if (e2 instanceof DocumentReference) {
      const n = t2.databaseId,
        r2 = e2.firestore._databaseId;
      if (!r2.isEqual(n))
        throw t2.Su(
          `Document reference is for database ${r2.projectId}/${r2.database} but should be for database ${n.projectId}/${n.database}`
        );
      return {
        referenceValue: __PRIVATE_toResourceName(
          e2.firestore._databaseId || t2.databaseId,
          e2._key.path
        ),
      };
    }
    throw t2.Su(`Unsupported field value: ${__PRIVATE_valueDescription(e2)}`);
  })(e, t);
}
function __PRIVATE_parseObject(e, t) {
  const n = {};
  return (
    isEmpty(e)
      ? // If we encounter an empty object, we explicitly add it to the update
        // mask to ensure that the server creates a map entry.
        t.path && t.path.length > 0 && t.fieldMask.push(t.path)
      : forEach$1(e, (e2, r2) => {
          const i = __PRIVATE_parseData(r2, t.fu(e2));
          null != i && (n[e2] = i);
        }),
    {
      mapValue: {
        fields: n,
      },
    }
  );
}
function __PRIVATE_looksLikeJsonObject(e) {
  return !(
    "object" != typeof e ||
    null === e ||
    e instanceof Array ||
    e instanceof Date ||
    e instanceof Timestamp ||
    e instanceof GeoPoint ||
    e instanceof Bytes ||
    e instanceof DocumentReference ||
    e instanceof FieldValue
  );
}
function __PRIVATE_validatePlainObject(e, t, n) {
  if (
    !__PRIVATE_looksLikeJsonObject(n) ||
    !(function __PRIVATE_isPlainObject(e2) {
      return (
        "object" == typeof e2 &&
        null !== e2 &&
        (Object.getPrototypeOf(e2) === Object.prototype ||
          null === Object.getPrototypeOf(e2))
      );
    })(n)
  ) {
    const r2 = __PRIVATE_valueDescription(n);
    throw "an object" === r2
      ? t.Su(e + " a custom object")
      : t.Su(e + " " + r2);
  }
}
function __PRIVATE_fieldPathFromArgument$1(e, t, n) {
  if (
    // If required, replace the FieldPath Compat class with with the firestore-exp
    // FieldPath.
    (t = getModularInstance(t)) instanceof FieldPath
  )
    return t._internalPath;
  if ("string" == typeof t)
    return __PRIVATE_fieldPathFromDotSeparatedString(e, t);
  throw __PRIVATE_createError(
    "Field path arguments must be of type string or ",
    e,
    /* hasConverter= */
    false,
    /* path= */
    void 0,
    n
  );
}
const Se = new RegExp("[~\\*/\\[\\]]");
function __PRIVATE_fieldPathFromDotSeparatedString(e, t, n) {
  if (t.search(Se) >= 0)
    throw __PRIVATE_createError(
      `Invalid field path (${t}). Paths must not contain '~', '*', '/', '[', or ']'`,
      e,
      /* hasConverter= */
      false,
      /* path= */
      void 0,
      n
    );
  try {
    return new FieldPath(...t.split("."))._internalPath;
  } catch (r2) {
    throw __PRIVATE_createError(
      `Invalid field path (${t}). Paths must not be empty, begin with '.', end with '.', or contain '..'`,
      e,
      /* hasConverter= */
      false,
      /* path= */
      void 0,
      n
    );
  }
}
function __PRIVATE_createError(e, t, n, r2, i) {
  const s = r2 && !r2.isEmpty(),
    o = void 0 !== i;
  let _ = `Function ${t}() called with invalid data`;
  n && (_ += " (via `toFirestore()`)"), (_ += ". ");
  let a = "";
  return (
    (s || o) &&
      ((a += " (found"),
      s && (a += ` in field ${r2}`),
      o && (a += ` in document ${i}`),
      (a += ")")),
    new FirestoreError(D.INVALID_ARGUMENT, _ + e + a)
  );
}
function __PRIVATE_fieldMaskContains(e, t) {
  return e.some((e2) => e2.isEqual(t));
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class DocumentSnapshot$1 {
  // Note: This class is stripped down version of the DocumentSnapshot in
  // the legacy SDK. The changes are:
  // - No support for SnapshotMetadata.
  // - No support for SnapshotOptions.
  /** @hideconstructor protected */
  constructor(e, t, n, r2, i) {
    (this._firestore = e),
      (this._userDataWriter = t),
      (this._key = n),
      (this._document = r2),
      (this._converter = i);
  }
  /** Property of the `DocumentSnapshot` that provides the document's ID. */
  get id() {
    return this._key.path.lastSegment();
  }
  /**
   * The `DocumentReference` for the document included in the `DocumentSnapshot`.
   */
  get ref() {
    return new DocumentReference(this._firestore, this._converter, this._key);
  }
  /**
   * Signals whether or not the document at the snapshot's location exists.
   *
   * @returns true if the document exists.
   */
  exists() {
    return null !== this._document;
  }
  /**
   * Retrieves all fields in the document as an `Object`. Returns `undefined` if
   * the document doesn't exist.
   *
   * @returns An `Object` containing all fields in the document or `undefined`
   * if the document doesn't exist.
   */
  data() {
    if (this._document) {
      if (this._converter) {
        const e = new QueryDocumentSnapshot$1(
          this._firestore,
          this._userDataWriter,
          this._key,
          this._document,
          /* converter= */
          null
        );
        return this._converter.fromFirestore(e);
      }
      return this._userDataWriter.convertValue(this._document.data.value);
    }
  }
  /**
   * Retrieves the field specified by `fieldPath`. Returns `undefined` if the
   * document or field doesn't exist.
   *
   * @param fieldPath - The path (for example 'foo' or 'foo.bar') to a specific
   * field.
   * @returns The data at the specified field location or undefined if no such
   * field exists in the document.
   */
  // We are using `any` here to avoid an explicit cast by our users.
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  get(e) {
    if (this._document) {
      const t = this._document.data.field(
        __PRIVATE_fieldPathFromArgument("DocumentSnapshot.get", e)
      );
      if (null !== t) return this._userDataWriter.convertValue(t);
    }
  }
}
class QueryDocumentSnapshot$1 extends DocumentSnapshot$1 {
  /**
   * Retrieves all fields in the document as an `Object`.
   *
   * @override
   * @returns An `Object` containing all fields in the document.
   */
  data() {
    return super.data();
  }
}
function __PRIVATE_fieldPathFromArgument(e, t) {
  return "string" == typeof t
    ? __PRIVATE_fieldPathFromDotSeparatedString(e, t)
    : t instanceof FieldPath
    ? t._internalPath
    : t._delegate._internalPath;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function __PRIVATE_validateHasExplicitOrderByForLimitToLast(e) {
  if ("L" === e.limitType && 0 === e.explicitOrderBy.length)
    throw new FirestoreError(
      D.UNIMPLEMENTED,
      "limitToLast() queries require specifying at least one orderBy() clause"
    );
}
class AppliableConstraint {}
class QueryConstraint extends AppliableConstraint {}
function query(e, t, ...n) {
  let r2 = [];
  t instanceof AppliableConstraint && r2.push(t),
    (r2 = r2.concat(n)),
    (function __PRIVATE_validateQueryConstraintArray(e2) {
      const t2 = e2.filter(
          (e3) => e3 instanceof QueryCompositeFilterConstraint
        ).length,
        n2 = e2.filter((e3) => e3 instanceof QueryFieldFilterConstraint).length;
      if (t2 > 1 || (t2 > 0 && n2 > 0))
        throw new FirestoreError(
          D.INVALID_ARGUMENT,
          "InvalidQuery. When using composite filters, you cannot use more than one filter at the top level. Consider nesting the multiple filters within an `and(...)` statement. For example: change `query(query, where(...), or(...))` to `query(query, and(where(...), or(...)))`."
        );
    })(r2);
  for (const t2 of r2) e = t2._apply(e);
  return e;
}
class QueryFieldFilterConstraint extends QueryConstraint {
  /**
   * @internal
   */
  constructor(e, t, n) {
    super(),
      (this._field = e),
      (this._op = t),
      (this._value = n) /** The type of this query constraint */,
      (this.type = "where");
  }
  static _create(e, t, n) {
    return new QueryFieldFilterConstraint(e, t, n);
  }
  _apply(e) {
    const t = this._parse(e);
    return (
      __PRIVATE_validateNewFieldFilter(e._query, t),
      new Query(
        e.firestore,
        e.converter,
        __PRIVATE_queryWithAddedFilter(e._query, t)
      )
    );
  }
  _parse(e) {
    const t = __PRIVATE_newUserDataReader(e.firestore),
      n = (function __PRIVATE_newQueryFilter(e2, t2, n2, r2, i, s, o) {
        let _;
        if (i.isKeyField()) {
          if ("array-contains" === s || "array-contains-any" === s)
            throw new FirestoreError(
              D.INVALID_ARGUMENT,
              `Invalid Query. You can't perform '${s}' queries on documentId().`
            );
          if ("in" === s || "not-in" === s) {
            __PRIVATE_validateDisjunctiveFilterElements(o, s);
            const t3 = [];
            for (const n3 of o)
              t3.push(__PRIVATE_parseDocumentIdValue(r2, e2, n3));
            _ = {
              arrayValue: {
                values: t3,
              },
            };
          } else _ = __PRIVATE_parseDocumentIdValue(r2, e2, o);
        } else
          ("in" !== s && "not-in" !== s && "array-contains-any" !== s) ||
            __PRIVATE_validateDisjunctiveFilterElements(o, s),
            (_ = __PRIVATE_parseQueryValue(
              n2,
              t2,
              o,
              /* allowArrays= */
              "in" === s || "not-in" === s
            ));
        return FieldFilter.create(i, s, _);
      })(
        e._query,
        "where",
        t,
        e.firestore._databaseId,
        this._field,
        this._op,
        this._value
      );
    return n;
  }
}
function where(e, t, n) {
  const r2 = t,
    i = __PRIVATE_fieldPathFromArgument("where", e);
  return QueryFieldFilterConstraint._create(i, r2, n);
}
class QueryCompositeFilterConstraint extends AppliableConstraint {
  /**
   * @internal
   */
  constructor(e, t) {
    super(), (this.type = e), (this._queryConstraints = t);
  }
  static _create(e, t) {
    return new QueryCompositeFilterConstraint(e, t);
  }
  _parse(e) {
    const t = this._queryConstraints
      .map((t2) => t2._parse(e))
      .filter((e2) => e2.getFilters().length > 0);
    return 1 === t.length
      ? t[0]
      : CompositeFilter.create(t, this._getOperator());
  }
  _apply(e) {
    const t = this._parse(e);
    return 0 === t.getFilters().length
      ? e
      : ((function __PRIVATE_validateNewFilter(e2, t2) {
          let n = e2;
          const r2 = t2.getFlattenedFilters();
          for (const e3 of r2)
            __PRIVATE_validateNewFieldFilter(n, e3),
              (n = __PRIVATE_queryWithAddedFilter(n, e3));
        })(e._query, t),
        new Query(
          e.firestore,
          e.converter,
          __PRIVATE_queryWithAddedFilter(e._query, t)
        ));
  }
  _getQueryConstraints() {
    return this._queryConstraints;
  }
  _getOperator() {
    return "and" === this.type ? "and" : "or";
  }
}
class QueryOrderByConstraint extends QueryConstraint {
  /**
   * @internal
   */
  constructor(e, t) {
    super(),
      (this._field = e),
      (this._direction = t) /** The type of this query constraint */,
      (this.type = "orderBy");
  }
  static _create(e, t) {
    return new QueryOrderByConstraint(e, t);
  }
  _apply(e) {
    const t = (function __PRIVATE_newQueryOrderBy(e2, t2, n) {
      if (null !== e2.startAt)
        throw new FirestoreError(
          D.INVALID_ARGUMENT,
          "Invalid query. You must not call startAt() or startAfter() before calling orderBy()."
        );
      if (null !== e2.endAt)
        throw new FirestoreError(
          D.INVALID_ARGUMENT,
          "Invalid query. You must not call endAt() or endBefore() before calling orderBy()."
        );
      return new OrderBy(t2, n);
    })(e._query, this._field, this._direction);
    return new Query(
      e.firestore,
      e.converter,
      (function __PRIVATE_queryWithAddedOrderBy(e2, t2) {
        const n = e2.explicitOrderBy.concat([t2]);
        return new __PRIVATE_QueryImpl(
          e2.path,
          e2.collectionGroup,
          n,
          e2.filters.slice(),
          e2.limit,
          e2.limitType,
          e2.startAt,
          e2.endAt
        );
      })(e._query, t)
    );
  }
}
function orderBy(e, t = "asc") {
  const n = t,
    r2 = __PRIVATE_fieldPathFromArgument("orderBy", e);
  return QueryOrderByConstraint._create(r2, n);
}
class QueryLimitConstraint extends QueryConstraint {
  /**
   * @internal
   */
  constructor(e, t, n) {
    super(), (this.type = e), (this._limit = t), (this._limitType = n);
  }
  static _create(e, t, n) {
    return new QueryLimitConstraint(e, t, n);
  }
  _apply(e) {
    return new Query(
      e.firestore,
      e.converter,
      __PRIVATE_queryWithLimit(e._query, this._limit, this._limitType)
    );
  }
}
function limit(e) {
  return (
    __PRIVATE_validatePositiveNumber("limit", e),
    QueryLimitConstraint._create(
      "limit",
      e,
      "F"
      /* LimitType.First */
    )
  );
}
function __PRIVATE_parseDocumentIdValue(e, t, n) {
  if ("string" == typeof (n = getModularInstance(n))) {
    if ("" === n)
      throw new FirestoreError(
        D.INVALID_ARGUMENT,
        "Invalid query. When querying with documentId(), you must provide a valid document ID, but it was an empty string."
      );
    if (!__PRIVATE_isCollectionGroupQuery(t) && -1 !== n.indexOf("/"))
      throw new FirestoreError(
        D.INVALID_ARGUMENT,
        `Invalid query. When querying a collection by documentId(), you must provide a plain document ID, but '${n}' contains a '/' character.`
      );
    const r2 = t.path.child(ResourcePath.fromString(n));
    if (!DocumentKey.isDocumentKey(r2))
      throw new FirestoreError(
        D.INVALID_ARGUMENT,
        `Invalid query. When querying a collection group by documentId(), the value provided must result in a valid document path, but '${r2}' is not because it has an odd number of segments (${r2.length}).`
      );
    return __PRIVATE_refValue(e, new DocumentKey(r2));
  }
  if (n instanceof DocumentReference) return __PRIVATE_refValue(e, n._key);
  throw new FirestoreError(
    D.INVALID_ARGUMENT,
    `Invalid query. When querying with documentId(), you must provide a valid string or a DocumentReference, but it was: ${__PRIVATE_valueDescription(
      n
    )}.`
  );
}
function __PRIVATE_validateDisjunctiveFilterElements(e, t) {
  if (!Array.isArray(e) || 0 === e.length)
    throw new FirestoreError(
      D.INVALID_ARGUMENT,
      `Invalid Query. A non-empty array is required for '${t.toString()}' filters.`
    );
}
function __PRIVATE_validateNewFieldFilter(e, t) {
  const n = (function __PRIVATE_findOpInsideFilters(e2, t2) {
    for (const n2 of e2)
      for (const e3 of n2.getFlattenedFilters())
        if (t2.indexOf(e3.op) >= 0) return e3.op;
    return null;
  })(
    e.filters,
    (function __PRIVATE_conflictingOps(e2) {
      switch (e2) {
        case "!=":
          return [
            "!=",
            "not-in",
            /* Operator.NOT_IN */
          ];
        case "array-contains-any":
        case "in":
          return [
            "not-in",
            /* Operator.NOT_IN */
          ];
        case "not-in":
          return [
            "array-contains-any",
            "in",
            "not-in",
            "!=",
            /* Operator.NOT_EQUAL */
          ];
        default:
          return [];
      }
    })(t.op)
  );
  if (null !== n)
    throw n === t.op
      ? new FirestoreError(
          D.INVALID_ARGUMENT,
          `Invalid query. You cannot use more than one '${t.op.toString()}' filter.`
        )
      : new FirestoreError(
          D.INVALID_ARGUMENT,
          `Invalid query. You cannot use '${t.op.toString()}' filters with '${n.toString()}' filters.`
        );
}
class AbstractUserDataWriter {
  convertValue(e, t = "none") {
    switch (__PRIVATE_typeOrder(e)) {
      case 0:
        return null;
      case 1:
        return e.booleanValue;
      case 2:
        return __PRIVATE_normalizeNumber(e.integerValue || e.doubleValue);
      case 3:
        return this.convertTimestamp(e.timestampValue);
      case 4:
        return this.convertServerTimestamp(e, t);
      case 5:
        return e.stringValue;
      case 6:
        return this.convertBytes(__PRIVATE_normalizeByteString(e.bytesValue));
      case 7:
        return this.convertReference(e.referenceValue);
      case 8:
        return this.convertGeoPoint(e.geoPointValue);
      case 9:
        return this.convertArray(e.arrayValue, t);
      case 10:
        return this.convertObject(e.mapValue, t);
      default:
        throw fail();
    }
  }
  convertObject(e, t) {
    return this.convertObjectMap(e.fields, t);
  }
  /**
   * @internal
   */
  convertObjectMap(e, t = "none") {
    const n = {};
    return (
      forEach$1(e, (e2, r2) => {
        n[e2] = this.convertValue(r2, t);
      }),
      n
    );
  }
  convertGeoPoint(e) {
    return new GeoPoint(
      __PRIVATE_normalizeNumber(e.latitude),
      __PRIVATE_normalizeNumber(e.longitude)
    );
  }
  convertArray(e, t) {
    return (e.values || []).map((e2) => this.convertValue(e2, t));
  }
  convertServerTimestamp(e, t) {
    switch (t) {
      case "previous":
        const n = __PRIVATE_getPreviousValue(e);
        return null == n ? null : this.convertValue(n, t);
      case "estimate":
        return this.convertTimestamp(__PRIVATE_getLocalWriteTime(e));
      default:
        return null;
    }
  }
  convertTimestamp(e) {
    const t = __PRIVATE_normalizeTimestamp(e);
    return new Timestamp(t.seconds, t.nanos);
  }
  convertDocumentKey(e, t) {
    const n = ResourcePath.fromString(e);
    __PRIVATE_hardAssert(__PRIVATE_isValidResourceName(n));
    const r2 = new DatabaseId(n.get(1), n.get(3)),
      i = new DocumentKey(n.popFirst(5));
    return (
      r2.isEqual(t) || // TODO(b/64130202): Somehow support foreign references.
        __PRIVATE_logError(
          `Document ${i} contains a document reference within a different database (${r2.projectId}/${r2.database}) which is not supported. It will be treated as a reference in the current database (${t.projectId}/${t.database}) instead.`
        ),
      i
    );
  }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function __PRIVATE_applyFirestoreDataConverter(e, t, n) {
  let r2;
  return (
    (r2 = e
      ? n && (n.merge || n.mergeFields)
        ? e.toFirestore(t, n)
        : e.toFirestore(t)
      : t),
    r2
  );
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class SnapshotMetadata {
  /** @hideconstructor */
  constructor(e, t) {
    (this.hasPendingWrites = e), (this.fromCache = t);
  }
  /**
   * Returns true if this `SnapshotMetadata` is equal to the provided one.
   *
   * @param other - The `SnapshotMetadata` to compare against.
   * @returns true if this `SnapshotMetadata` is equal to the provided one.
   */
  isEqual(e) {
    return (
      this.hasPendingWrites === e.hasPendingWrites &&
      this.fromCache === e.fromCache
    );
  }
}
class DocumentSnapshot extends DocumentSnapshot$1 {
  /** @hideconstructor protected */
  constructor(e, t, n, r2, i, s) {
    super(e, t, n, r2, s),
      (this._firestore = e),
      (this._firestoreImpl = e),
      (this.metadata = i);
  }
  /**
   * Returns whether or not the data exists. True if the document exists.
   */
  exists() {
    return super.exists();
  }
  /**
   * Retrieves all fields in the document as an `Object`. Returns `undefined` if
   * the document doesn't exist.
   *
   * By default, `serverTimestamp()` values that have not yet been
   * set to their final value will be returned as `null`. You can override
   * this by passing an options object.
   *
   * @param options - An options object to configure how data is retrieved from
   * the snapshot (for example the desired behavior for server timestamps that
   * have not yet been set to their final value).
   * @returns An `Object` containing all fields in the document or `undefined` if
   * the document doesn't exist.
   */
  data(e = {}) {
    if (this._document) {
      if (this._converter) {
        const t = new QueryDocumentSnapshot(
          this._firestore,
          this._userDataWriter,
          this._key,
          this._document,
          this.metadata,
          /* converter= */
          null
        );
        return this._converter.fromFirestore(t, e);
      }
      return this._userDataWriter.convertValue(
        this._document.data.value,
        e.serverTimestamps
      );
    }
  }
  /**
   * Retrieves the field specified by `fieldPath`. Returns `undefined` if the
   * document or field doesn't exist.
   *
   * By default, a `serverTimestamp()` that has not yet been set to
   * its final value will be returned as `null`. You can override this by
   * passing an options object.
   *
   * @param fieldPath - The path (for example 'foo' or 'foo.bar') to a specific
   * field.
   * @param options - An options object to configure how the field is retrieved
   * from the snapshot (for example the desired behavior for server timestamps
   * that have not yet been set to their final value).
   * @returns The data at the specified field location or undefined if no such
   * field exists in the document.
   */
  // We are using `any` here to avoid an explicit cast by our users.
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  get(e, t = {}) {
    if (this._document) {
      const n = this._document.data.field(
        __PRIVATE_fieldPathFromArgument("DocumentSnapshot.get", e)
      );
      if (null !== n)
        return this._userDataWriter.convertValue(n, t.serverTimestamps);
    }
  }
}
class QueryDocumentSnapshot extends DocumentSnapshot {
  /**
   * Retrieves all fields in the document as an `Object`.
   *
   * By default, `serverTimestamp()` values that have not yet been
   * set to their final value will be returned as `null`. You can override
   * this by passing an options object.
   *
   * @override
   * @param options - An options object to configure how data is retrieved from
   * the snapshot (for example the desired behavior for server timestamps that
   * have not yet been set to their final value).
   * @returns An `Object` containing all fields in the document.
   */
  data(e = {}) {
    return super.data(e);
  }
}
class QuerySnapshot {
  /** @hideconstructor */
  constructor(e, t, n, r2) {
    (this._firestore = e),
      (this._userDataWriter = t),
      (this._snapshot = r2),
      (this.metadata = new SnapshotMetadata(r2.hasPendingWrites, r2.fromCache)),
      (this.query = n);
  }
  /** An array of all the documents in the `QuerySnapshot`. */
  get docs() {
    const e = [];
    return this.forEach((t) => e.push(t)), e;
  }
  /** The number of documents in the `QuerySnapshot`. */
  get size() {
    return this._snapshot.docs.size;
  }
  /** True if there are no documents in the `QuerySnapshot`. */
  get empty() {
    return 0 === this.size;
  }
  /**
   * Enumerates all of the documents in the `QuerySnapshot`.
   *
   * @param callback - A callback to be called with a `QueryDocumentSnapshot` for
   * each document in the snapshot.
   * @param thisArg - The `this` binding for the callback.
   */
  forEach(e, t) {
    this._snapshot.docs.forEach((n) => {
      e.call(
        t,
        new QueryDocumentSnapshot(
          this._firestore,
          this._userDataWriter,
          n.key,
          n,
          new SnapshotMetadata(
            this._snapshot.mutatedKeys.has(n.key),
            this._snapshot.fromCache
          ),
          this.query.converter
        )
      );
    });
  }
  /**
   * Returns an array of the documents changes since the last snapshot. If this
   * is the first snapshot, all documents will be in the list as 'added'
   * changes.
   *
   * @param options - `SnapshotListenOptions` that control whether metadata-only
   * changes (i.e. only `DocumentSnapshot.metadata` changed) should trigger
   * snapshot events.
   */
  docChanges(e = {}) {
    const t = !!e.includeMetadataChanges;
    if (t && this._snapshot.excludesMetadataChanges)
      throw new FirestoreError(
        D.INVALID_ARGUMENT,
        "To include metadata changes with your document changes, you must also pass { includeMetadataChanges:true } to onSnapshot()."
      );
    return (
      (this._cachedChanges &&
        this._cachedChangesIncludeMetadataChanges === t) ||
        ((this._cachedChanges =
          /** Calculates the array of `DocumentChange`s for a given `ViewSnapshot`. */
          (function __PRIVATE_changesFromSnapshot(e2, t2) {
            if (e2._snapshot.oldDocs.isEmpty()) {
              let t3 = 0;
              return e2._snapshot.docChanges.map((n) => {
                const r2 = new QueryDocumentSnapshot(
                  e2._firestore,
                  e2._userDataWriter,
                  n.doc.key,
                  n.doc,
                  new SnapshotMetadata(
                    e2._snapshot.mutatedKeys.has(n.doc.key),
                    e2._snapshot.fromCache
                  ),
                  e2.query.converter
                );
                return (
                  n.doc,
                  {
                    type: "added",
                    doc: r2,
                    oldIndex: -1,
                    newIndex: t3++,
                  }
                );
              });
            }
            {
              let n = e2._snapshot.oldDocs;
              return e2._snapshot.docChanges
                .filter((e3) => t2 || 3 !== e3.type)
                .map((t3) => {
                  const r2 = new QueryDocumentSnapshot(
                    e2._firestore,
                    e2._userDataWriter,
                    t3.doc.key,
                    t3.doc,
                    new SnapshotMetadata(
                      e2._snapshot.mutatedKeys.has(t3.doc.key),
                      e2._snapshot.fromCache
                    ),
                    e2.query.converter
                  );
                  let i = -1,
                    s = -1;
                  return (
                    0 !== t3.type &&
                      ((i = n.indexOf(t3.doc.key)), (n = n.delete(t3.doc.key))),
                    1 !== t3.type &&
                      ((n = n.add(t3.doc)), (s = n.indexOf(t3.doc.key))),
                    {
                      type: __PRIVATE_resultChangeType(t3.type),
                      doc: r2,
                      oldIndex: i,
                      newIndex: s,
                    }
                  );
                });
            }
          })(this, t)),
        (this._cachedChangesIncludeMetadataChanges = t)),
      this._cachedChanges
    );
  }
}
function __PRIVATE_resultChangeType(e) {
  switch (e) {
    case 0:
      return "added";
    case 2:
    case 3:
      return "modified";
    case 1:
      return "removed";
    default:
      return fail();
  }
}
class __PRIVATE_ExpUserDataWriter extends AbstractUserDataWriter {
  constructor(e) {
    super(), (this.firestore = e);
  }
  convertBytes(e) {
    return new Bytes(e);
  }
  convertReference(e) {
    const t = this.convertDocumentKey(e, this.firestore._databaseId);
    return new DocumentReference(
      this.firestore,
      /* converter= */
      null,
      t
    );
  }
}
function getDocs(e) {
  e = __PRIVATE_cast(e, Query);
  const t = __PRIVATE_cast(e.firestore, Firestore),
    n = ensureFirestoreConfigured(t),
    r2 = new __PRIVATE_ExpUserDataWriter(t);
  return (
    __PRIVATE_validateHasExplicitOrderByForLimitToLast(e._query),
    __PRIVATE_firestoreClientGetDocumentsViaSnapshotListener(n, e._query).then(
      (n2) => new QuerySnapshot(t, r2, e, n2)
    )
  );
}
function addDoc(e, t) {
  const n = __PRIVATE_cast(e.firestore, Firestore),
    r2 = doc(e),
    i = __PRIVATE_applyFirestoreDataConverter(e.converter, t);
  return executeWrite(n, [
    __PRIVATE_parseSetData(
      __PRIVATE_newUserDataReader(e.firestore),
      "addDoc",
      r2._key,
      i,
      null !== e.converter,
      {}
    ).toMutation(r2._key, Precondition.exists(false)),
  ]).then(() => r2);
}
function executeWrite(e, t) {
  return (function __PRIVATE_firestoreClientWrite(e2, t2) {
    const n = new __PRIVATE_Deferred();
    return (
      e2.asyncQueue.enqueueAndForget(async () =>
        __PRIVATE_syncEngineWrite(await __PRIVATE_getSyncEngine(e2), t2, n)
      ),
      n.promise
    );
  })(ensureFirestoreConfigured(e), t);
}
!(function __PRIVATE_registerFirestore(e, t = true) {
  !(function __PRIVATE_setSDKVersion(e2) {
    S = e2;
  })(SDK_VERSION),
    _registerComponent(
      new Component(
        "firestore",
        (e2, { instanceIdentifier: n, options: r2 }) => {
          const i = e2.getProvider("app").getImmediate(),
            s = new Firestore(
              new __PRIVATE_FirebaseAuthCredentialsProvider(
                e2.getProvider("auth-internal")
              ),
              new __PRIVATE_FirebaseAppCheckTokenProvider(
                e2.getProvider("app-check-internal")
              ),
              (function __PRIVATE_databaseIdFromApp(e3, t2) {
                if (
                  !Object.prototype.hasOwnProperty.apply(e3.options, [
                    "projectId",
                  ])
                )
                  throw new FirestoreError(
                    D.INVALID_ARGUMENT,
                    '"projectId" not provided in firebase.initializeApp.'
                  );
                return new DatabaseId(e3.options.projectId, t2);
              })(i, n),
              i
            );
          return (
            (r2 = Object.assign(
              {
                useFetchStreams: t,
              },
              r2
            )),
            s._setSettings(r2),
            s
          );
        },
        "PUBLIC"
      ).setMultipleInstances(true)
    ),
    registerVersion(w, "4.6.0", e), // BUILD_TARGET will be replaced by values like esm5, esm2017, cjs5, etc during the compilation
    registerVersion(w, "4.6.0", "esm2017");
})();
var name$3 = "firebase";
var version$3 = "10.11.0";
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
registerVersion(name$3, version$3, "app");
function __rest(s, e) {
  var t = {};
  for (var p2 in s)
    if (Object.prototype.hasOwnProperty.call(s, p2) && e.indexOf(p2) < 0)
      t[p2] = s[p2];
  if (s != null && typeof Object.getOwnPropertySymbols === "function")
    for (var i = 0, p2 = Object.getOwnPropertySymbols(s); i < p2.length; i++) {
      if (
        e.indexOf(p2[i]) < 0 &&
        Object.prototype.propertyIsEnumerable.call(s, p2[i])
      )
        t[p2[i]] = s[p2[i]];
    }
  return t;
}
typeof SuppressedError === "function"
  ? SuppressedError
  : function (error, suppressed, message) {
      var e = new Error(message);
      return (
        (e.name = "SuppressedError"),
        (e.error = error),
        (e.suppressed = suppressed),
        e
      );
    };
function _prodErrorMap() {
  return {
    ["dependent-sdk-initialized-before-auth"]:
      /* AuthErrorCode.DEPENDENT_SDK_INIT_BEFORE_AUTH */
      "Another Firebase SDK was initialized and is trying to use Auth before Auth is initialized. Please be sure to call `initializeAuth` or `getAuth` before starting any other Firebase SDK.",
  };
}
const prodErrorMap = _prodErrorMap;
const _DEFAULT_AUTH_ERROR_FACTORY = new ErrorFactory(
  "auth",
  "Firebase",
  _prodErrorMap()
);
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const logClient = new Logger("@firebase/auth");
function _logWarn(msg, ...args) {
  if (logClient.logLevel <= LogLevel.WARN) {
    logClient.warn(`Auth (${SDK_VERSION}): ${msg}`, ...args);
  }
}
function _logError(msg, ...args) {
  if (logClient.logLevel <= LogLevel.ERROR) {
    logClient.error(`Auth (${SDK_VERSION}): ${msg}`, ...args);
  }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function _fail(authOrCode, ...rest) {
  throw createErrorInternal(authOrCode, ...rest);
}
function _createError(authOrCode, ...rest) {
  return createErrorInternal(authOrCode, ...rest);
}
function _errorWithCustomMessage(auth2, code, message) {
  const errorMap = Object.assign(Object.assign({}, prodErrorMap()), {
    [code]: message,
  });
  const factory2 = new ErrorFactory("auth", "Firebase", errorMap);
  return factory2.create(code, {
    appName: auth2.name,
  });
}
function _serverAppCurrentUserOperationNotSupportedError(auth2) {
  return _errorWithCustomMessage(
    auth2,
    "operation-not-supported-in-this-environment",
    "Operations that alter the current user are not supported in conjunction with FirebaseServerApp"
  );
}
function createErrorInternal(authOrCode, ...rest) {
  if (typeof authOrCode !== "string") {
    const code = rest[0];
    const fullParams = [...rest.slice(1)];
    if (fullParams[0]) {
      fullParams[0].appName = authOrCode.name;
    }
    return authOrCode._errorFactory.create(code, ...fullParams);
  }
  return _DEFAULT_AUTH_ERROR_FACTORY.create(authOrCode, ...rest);
}
function _assert(assertion, authOrCode, ...rest) {
  if (!assertion) {
    throw createErrorInternal(authOrCode, ...rest);
  }
}
function debugFail(failure) {
  const message = `INTERNAL ASSERTION FAILED: ` + failure;
  _logError(message);
  throw new Error(message);
}
function debugAssert(assertion, message) {
  if (!assertion) {
    debugFail(message);
  }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function _getCurrentUrl() {
  var _a2;
  return (
    (typeof self !== "undefined" &&
      ((_a2 = self.location) === null || _a2 === void 0 ? void 0 : _a2.href)) ||
    ""
  );
}
function _isHttpOrHttps() {
  return _getCurrentScheme() === "http:" || _getCurrentScheme() === "https:";
}
function _getCurrentScheme() {
  var _a2;
  return (
    (typeof self !== "undefined" &&
      ((_a2 = self.location) === null || _a2 === void 0
        ? void 0
        : _a2.protocol)) ||
    null
  );
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function _isOnline() {
  if (
    typeof navigator !== "undefined" &&
    navigator &&
    "onLine" in navigator &&
    typeof navigator.onLine === "boolean" && // Apply only for traditional web apps and Chrome extensions.
    // This is especially true for Cordova apps which have unreliable
    // navigator.onLine behavior unless cordova-plugin-network-information is
    // installed which overwrites the native navigator.onLine value and
    // defines navigator.connection.
    (_isHttpOrHttps() || isBrowserExtension() || "connection" in navigator)
  ) {
    return navigator.onLine;
  }
  return true;
}
function _getUserLanguage() {
  if (typeof navigator === "undefined") {
    return null;
  }
  const navigatorLanguage = navigator;
  return (
    // Most reliable, but only supported in Chrome/Firefox.
    (navigatorLanguage.languages && navigatorLanguage.languages[0]) || // Supported in most browsers, but returns the language of the browser
    // UI, not the language set in browser settings.
    navigatorLanguage.language || // Couldn't determine language.
    null
  );
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class Delay {
  constructor(shortDelay, longDelay) {
    this.shortDelay = shortDelay;
    this.longDelay = longDelay;
    debugAssert(
      longDelay > shortDelay,
      "Short delay should be less than long delay!"
    );
    this.isMobile = isMobileCordova() || isReactNative();
  }
  get() {
    if (!_isOnline()) {
      return Math.min(5e3, this.shortDelay);
    }
    return this.isMobile ? this.longDelay : this.shortDelay;
  }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function _emulatorUrl(config, path) {
  debugAssert(config.emulator, "Emulator should always be set here");
  const { url } = config.emulator;
  if (!path) {
    return url;
  }
  return `${url}${path.startsWith("/") ? path.slice(1) : path}`;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class FetchProvider {
  static initialize(fetchImpl, headersImpl, responseImpl) {
    this.fetchImpl = fetchImpl;
    if (headersImpl) {
      this.headersImpl = headersImpl;
    }
    if (responseImpl) {
      this.responseImpl = responseImpl;
    }
  }
  static fetch() {
    if (this.fetchImpl) {
      return this.fetchImpl;
    }
    if (typeof self !== "undefined" && "fetch" in self) {
      return self.fetch;
    }
    if (typeof globalThis !== "undefined" && globalThis.fetch) {
      return globalThis.fetch;
    }
    if (typeof fetch !== "undefined") {
      return fetch;
    }
    debugFail(
      "Could not find fetch implementation, make sure you call FetchProvider.initialize() with an appropriate polyfill"
    );
  }
  static headers() {
    if (this.headersImpl) {
      return this.headersImpl;
    }
    if (typeof self !== "undefined" && "Headers" in self) {
      return self.Headers;
    }
    if (typeof globalThis !== "undefined" && globalThis.Headers) {
      return globalThis.Headers;
    }
    if (typeof Headers !== "undefined") {
      return Headers;
    }
    debugFail(
      "Could not find Headers implementation, make sure you call FetchProvider.initialize() with an appropriate polyfill"
    );
  }
  static response() {
    if (this.responseImpl) {
      return this.responseImpl;
    }
    if (typeof self !== "undefined" && "Response" in self) {
      return self.Response;
    }
    if (typeof globalThis !== "undefined" && globalThis.Response) {
      return globalThis.Response;
    }
    if (typeof Response !== "undefined") {
      return Response;
    }
    debugFail(
      "Could not find Response implementation, make sure you call FetchProvider.initialize() with an appropriate polyfill"
    );
  }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const SERVER_ERROR_MAP = {
  // Custom token errors.
  ["CREDENTIAL_MISMATCH"]:
    /* ServerError.CREDENTIAL_MISMATCH */
    "custom-token-mismatch",
  // This can only happen if the SDK sends a bad request.
  ["MISSING_CUSTOM_TOKEN"]:
    /* ServerError.MISSING_CUSTOM_TOKEN */
    "internal-error",
  // Create Auth URI errors.
  ["INVALID_IDENTIFIER"]:
    /* ServerError.INVALID_IDENTIFIER */
    "invalid-email",
  // This can only happen if the SDK sends a bad request.
  ["MISSING_CONTINUE_URI"]:
    /* ServerError.MISSING_CONTINUE_URI */
    "internal-error",
  // Sign in with email and password errors (some apply to sign up too).
  ["INVALID_PASSWORD"]:
    /* ServerError.INVALID_PASSWORD */
    "wrong-password",
  // This can only happen if the SDK sends a bad request.
  ["MISSING_PASSWORD"]:
    /* ServerError.MISSING_PASSWORD */
    "missing-password",
  // Thrown if Email Enumeration Protection is enabled in the project and the email or password is
  // invalid.
  ["INVALID_LOGIN_CREDENTIALS"]:
    /* ServerError.INVALID_LOGIN_CREDENTIALS */
    "invalid-credential",
  // Sign up with email and password errors.
  ["EMAIL_EXISTS"]:
    /* ServerError.EMAIL_EXISTS */
    "email-already-in-use",
  ["PASSWORD_LOGIN_DISABLED"]:
    /* ServerError.PASSWORD_LOGIN_DISABLED */
    "operation-not-allowed",
  // Verify assertion for sign in with credential errors:
  ["INVALID_IDP_RESPONSE"]:
    /* ServerError.INVALID_IDP_RESPONSE */
    "invalid-credential",
  ["INVALID_PENDING_TOKEN"]:
    /* ServerError.INVALID_PENDING_TOKEN */
    "invalid-credential",
  ["FEDERATED_USER_ID_ALREADY_LINKED"]:
    /* ServerError.FEDERATED_USER_ID_ALREADY_LINKED */
    "credential-already-in-use",
  // This can only happen if the SDK sends a bad request.
  ["MISSING_REQ_TYPE"]:
    /* ServerError.MISSING_REQ_TYPE */
    "internal-error",
  // Send Password reset email errors:
  ["EMAIL_NOT_FOUND"]:
    /* ServerError.EMAIL_NOT_FOUND */
    "user-not-found",
  ["RESET_PASSWORD_EXCEED_LIMIT"]:
    /* ServerError.RESET_PASSWORD_EXCEED_LIMIT */
    "too-many-requests",
  ["EXPIRED_OOB_CODE"]:
    /* ServerError.EXPIRED_OOB_CODE */
    "expired-action-code",
  ["INVALID_OOB_CODE"]:
    /* ServerError.INVALID_OOB_CODE */
    "invalid-action-code",
  // This can only happen if the SDK sends a bad request.
  ["MISSING_OOB_CODE"]:
    /* ServerError.MISSING_OOB_CODE */
    "internal-error",
  // Operations that require ID token in request:
  ["CREDENTIAL_TOO_OLD_LOGIN_AGAIN"]:
    /* ServerError.CREDENTIAL_TOO_OLD_LOGIN_AGAIN */
    "requires-recent-login",
  ["INVALID_ID_TOKEN"]:
    /* ServerError.INVALID_ID_TOKEN */
    "invalid-user-token",
  ["TOKEN_EXPIRED"]:
    /* ServerError.TOKEN_EXPIRED */
    "user-token-expired",
  ["USER_NOT_FOUND"]:
    /* ServerError.USER_NOT_FOUND */
    "user-token-expired",
  // Other errors.
  ["TOO_MANY_ATTEMPTS_TRY_LATER"]:
    /* ServerError.TOO_MANY_ATTEMPTS_TRY_LATER */
    "too-many-requests",
  ["PASSWORD_DOES_NOT_MEET_REQUIREMENTS"]:
    /* ServerError.PASSWORD_DOES_NOT_MEET_REQUIREMENTS */
    "password-does-not-meet-requirements",
  // Phone Auth related errors.
  ["INVALID_CODE"]:
    /* ServerError.INVALID_CODE */
    "invalid-verification-code",
  ["INVALID_SESSION_INFO"]:
    /* ServerError.INVALID_SESSION_INFO */
    "invalid-verification-id",
  ["INVALID_TEMPORARY_PROOF"]:
    /* ServerError.INVALID_TEMPORARY_PROOF */
    "invalid-credential",
  ["MISSING_SESSION_INFO"]:
    /* ServerError.MISSING_SESSION_INFO */
    "missing-verification-id",
  ["SESSION_EXPIRED"]:
    /* ServerError.SESSION_EXPIRED */
    "code-expired",
  // Other action code errors when additional settings passed.
  // MISSING_CONTINUE_URI is getting mapped to INTERNAL_ERROR above.
  // This is OK as this error will be caught by client side validation.
  ["MISSING_ANDROID_PACKAGE_NAME"]:
    /* ServerError.MISSING_ANDROID_PACKAGE_NAME */
    "missing-android-pkg-name",
  ["UNAUTHORIZED_DOMAIN"]:
    /* ServerError.UNAUTHORIZED_DOMAIN */
    "unauthorized-continue-uri",
  // getProjectConfig errors when clientId is passed.
  ["INVALID_OAUTH_CLIENT_ID"]:
    /* ServerError.INVALID_OAUTH_CLIENT_ID */
    "invalid-oauth-client-id",
  // User actions (sign-up or deletion) disabled errors.
  ["ADMIN_ONLY_OPERATION"]:
    /* ServerError.ADMIN_ONLY_OPERATION */
    "admin-restricted-operation",
  // Multi factor related errors.
  ["INVALID_MFA_PENDING_CREDENTIAL"]:
    /* ServerError.INVALID_MFA_PENDING_CREDENTIAL */
    "invalid-multi-factor-session",
  ["MFA_ENROLLMENT_NOT_FOUND"]:
    /* ServerError.MFA_ENROLLMENT_NOT_FOUND */
    "multi-factor-info-not-found",
  ["MISSING_MFA_ENROLLMENT_ID"]:
    /* ServerError.MISSING_MFA_ENROLLMENT_ID */
    "missing-multi-factor-info",
  ["MISSING_MFA_PENDING_CREDENTIAL"]:
    /* ServerError.MISSING_MFA_PENDING_CREDENTIAL */
    "missing-multi-factor-session",
  ["SECOND_FACTOR_EXISTS"]:
    /* ServerError.SECOND_FACTOR_EXISTS */
    "second-factor-already-in-use",
  ["SECOND_FACTOR_LIMIT_EXCEEDED"]:
    /* ServerError.SECOND_FACTOR_LIMIT_EXCEEDED */
    "maximum-second-factor-count-exceeded",
  // Blocking functions related errors.
  ["BLOCKING_FUNCTION_ERROR_RESPONSE"]:
    /* ServerError.BLOCKING_FUNCTION_ERROR_RESPONSE */
    "internal-error",
  // Recaptcha related errors.
  ["RECAPTCHA_NOT_ENABLED"]:
    /* ServerError.RECAPTCHA_NOT_ENABLED */
    "recaptcha-not-enabled",
  ["MISSING_RECAPTCHA_TOKEN"]:
    /* ServerError.MISSING_RECAPTCHA_TOKEN */
    "missing-recaptcha-token",
  ["INVALID_RECAPTCHA_TOKEN"]:
    /* ServerError.INVALID_RECAPTCHA_TOKEN */
    "invalid-recaptcha-token",
  ["INVALID_RECAPTCHA_ACTION"]:
    /* ServerError.INVALID_RECAPTCHA_ACTION */
    "invalid-recaptcha-action",
  ["MISSING_CLIENT_TYPE"]:
    /* ServerError.MISSING_CLIENT_TYPE */
    "missing-client-type",
  ["MISSING_RECAPTCHA_VERSION"]:
    /* ServerError.MISSING_RECAPTCHA_VERSION */
    "missing-recaptcha-version",
  ["INVALID_RECAPTCHA_VERSION"]:
    /* ServerError.INVALID_RECAPTCHA_VERSION */
    "invalid-recaptcha-version",
  ["INVALID_REQ_TYPE"]:
    /* ServerError.INVALID_REQ_TYPE */
    "invalid-req-type",
  /* AuthErrorCode.INVALID_REQ_TYPE */
};
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const DEFAULT_API_TIMEOUT_MS = new Delay(3e4, 6e4);
function _addTidIfNecessary(auth2, request) {
  if (auth2.tenantId && !request.tenantId) {
    return Object.assign(Object.assign({}, request), {
      tenantId: auth2.tenantId,
    });
  }
  return request;
}
async function _performApiRequest(
  auth2,
  method,
  path,
  request,
  customErrorMap = {}
) {
  return _performFetchWithErrorHandling(auth2, customErrorMap, async () => {
    let body = {};
    let params = {};
    if (request) {
      if (method === "GET") {
        params = request;
      } else {
        body = {
          body: JSON.stringify(request),
        };
      }
    }
    const query2 = querystring(
      Object.assign({ key: auth2.config.apiKey }, params)
    ).slice(1);
    const headers = await auth2._getAdditionalHeaders();
    headers[
      "Content-Type"
      /* HttpHeader.CONTENT_TYPE */
    ] = "application/json";
    if (auth2.languageCode) {
      headers[
        "X-Firebase-Locale"
        /* HttpHeader.X_FIREBASE_LOCALE */
      ] = auth2.languageCode;
    }
    return FetchProvider.fetch()(
      _getFinalTarget(auth2, auth2.config.apiHost, path, query2),
      Object.assign(
        {
          method,
          headers,
          referrerPolicy: "no-referrer",
        },
        body
      )
    );
  });
}
async function _performFetchWithErrorHandling(auth2, customErrorMap, fetchFn) {
  auth2._canInitEmulator = false;
  const errorMap = Object.assign(
    Object.assign({}, SERVER_ERROR_MAP),
    customErrorMap
  );
  try {
    const networkTimeout = new NetworkTimeout(auth2);
    const response = await Promise.race([fetchFn(), networkTimeout.promise]);
    networkTimeout.clearNetworkTimeout();
    const json = await response.json();
    if ("needConfirmation" in json) {
      throw _makeTaggedError(
        auth2,
        "account-exists-with-different-credential",
        json
      );
    }
    if (response.ok && !("errorMessage" in json)) {
      return json;
    } else {
      const errorMessage = response.ok ? json.errorMessage : json.error.message;
      const [serverErrorCode, serverErrorMessage] = errorMessage.split(" : ");
      if (serverErrorCode === "FEDERATED_USER_ID_ALREADY_LINKED") {
        throw _makeTaggedError(auth2, "credential-already-in-use", json);
      } else if (serverErrorCode === "EMAIL_EXISTS") {
        throw _makeTaggedError(auth2, "email-already-in-use", json);
      } else if (serverErrorCode === "USER_DISABLED") {
        throw _makeTaggedError(auth2, "user-disabled", json);
      }
      const authError =
        errorMap[serverErrorCode] ||
        serverErrorCode.toLowerCase().replace(/[_\s]+/g, "-");
      if (serverErrorMessage) {
        throw _errorWithCustomMessage(auth2, authError, serverErrorMessage);
      } else {
        _fail(auth2, authError);
      }
    }
  } catch (e) {
    if (e instanceof FirebaseError) {
      throw e;
    }
    _fail(auth2, "network-request-failed", { message: String(e) });
  }
}
async function _performSignInRequest(
  auth2,
  method,
  path,
  request,
  customErrorMap = {}
) {
  const serverResponse = await _performApiRequest(
    auth2,
    method,
    path,
    request,
    customErrorMap
  );
  if ("mfaPendingCredential" in serverResponse) {
    _fail(auth2, "multi-factor-auth-required", {
      _serverResponse: serverResponse,
    });
  }
  return serverResponse;
}
function _getFinalTarget(auth2, host, path, query2) {
  const base = `${host}${path}?${query2}`;
  if (!auth2.config.emulator) {
    return `${auth2.config.apiScheme}://${base}`;
  }
  return _emulatorUrl(auth2.config, base);
}
class NetworkTimeout {
  constructor(auth2) {
    this.auth = auth2;
    this.timer = null;
    this.promise = new Promise((_, reject3) => {
      this.timer = setTimeout(() => {
        return reject3(
          _createError(
            this.auth,
            "network-request-failed"
            /* AuthErrorCode.NETWORK_REQUEST_FAILED */
          )
        );
      }, DEFAULT_API_TIMEOUT_MS.get());
    });
  }
  clearNetworkTimeout() {
    clearTimeout(this.timer);
  }
}
function _makeTaggedError(auth2, code, response) {
  const errorParams = {
    appName: auth2.name,
  };
  if (response.email) {
    errorParams.email = response.email;
  }
  if (response.phoneNumber) {
    errorParams.phoneNumber = response.phoneNumber;
  }
  const error = _createError(auth2, code, errorParams);
  error.customData._tokenResponse = response;
  return error;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
async function deleteAccount(auth2, request) {
  return _performApiRequest(auth2, "POST", "/v1/accounts:delete", request);
}
async function getAccountInfo(auth2, request) {
  return _performApiRequest(auth2, "POST", "/v1/accounts:lookup", request);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function utcTimestampToDateString(utcTimestamp) {
  if (!utcTimestamp) {
    return void 0;
  }
  try {
    const date = new Date(Number(utcTimestamp));
    if (!isNaN(date.getTime())) {
      return date.toUTCString();
    }
  } catch (e) {}
  return void 0;
}
async function getIdTokenResult(user, forceRefresh = false) {
  const userInternal = getModularInstance(user);
  const token2 = await userInternal.getIdToken(forceRefresh);
  const claims = _parseToken(token2);
  _assert(
    claims && claims.exp && claims.auth_time && claims.iat,
    userInternal.auth,
    "internal-error"
    /* AuthErrorCode.INTERNAL_ERROR */
  );
  const firebase =
    typeof claims.firebase === "object" ? claims.firebase : void 0;
  const signInProvider =
    firebase === null || firebase === void 0
      ? void 0
      : firebase["sign_in_provider"];
  return {
    claims,
    token: token2,
    authTime: utcTimestampToDateString(
      secondsStringToMilliseconds(claims.auth_time)
    ),
    issuedAtTime: utcTimestampToDateString(
      secondsStringToMilliseconds(claims.iat)
    ),
    expirationTime: utcTimestampToDateString(
      secondsStringToMilliseconds(claims.exp)
    ),
    signInProvider: signInProvider || null,
    signInSecondFactor:
      (firebase === null || firebase === void 0
        ? void 0
        : firebase["sign_in_second_factor"]) || null,
  };
}
function secondsStringToMilliseconds(seconds) {
  return Number(seconds) * 1e3;
}
function _parseToken(token2) {
  const [algorithm, payload, signature] = token2.split(".");
  if (algorithm === void 0 || payload === void 0 || signature === void 0) {
    _logError("JWT malformed, contained fewer than 3 sections");
    return null;
  }
  try {
    const decoded = base64Decode(payload);
    if (!decoded) {
      _logError("Failed to decode base64 JWT payload");
      return null;
    }
    return JSON.parse(decoded);
  } catch (e) {
    _logError(
      "Caught error parsing JWT payload as JSON",
      e === null || e === void 0 ? void 0 : e.toString()
    );
    return null;
  }
}
function _tokenExpiresIn(token2) {
  const parsedToken = _parseToken(token2);
  _assert(
    parsedToken,
    "internal-error"
    /* AuthErrorCode.INTERNAL_ERROR */
  );
  _assert(
    typeof parsedToken.exp !== "undefined",
    "internal-error"
    /* AuthErrorCode.INTERNAL_ERROR */
  );
  _assert(
    typeof parsedToken.iat !== "undefined",
    "internal-error"
    /* AuthErrorCode.INTERNAL_ERROR */
  );
  return Number(parsedToken.exp) - Number(parsedToken.iat);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
async function _logoutIfInvalidated(user, promise2, bypassAuthState = false) {
  if (bypassAuthState) {
    return promise2;
  }
  try {
    return await promise2;
  } catch (e) {
    if (e instanceof FirebaseError && isUserInvalidated(e)) {
      if (user.auth.currentUser === user) {
        await user.auth.signOut();
      }
    }
    throw e;
  }
}
function isUserInvalidated({ code }) {
  return (
    code === `auth/${"user-disabled"}` ||
    code === `auth/${"user-token-expired"}`
  );
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class ProactiveRefresh {
  constructor(user) {
    this.user = user;
    this.isRunning = false;
    this.timerId = null;
    this.errorBackoff = 3e4;
  }
  _start() {
    if (this.isRunning) {
      return;
    }
    this.isRunning = true;
    this.schedule();
  }
  _stop() {
    if (!this.isRunning) {
      return;
    }
    this.isRunning = false;
    if (this.timerId !== null) {
      clearTimeout(this.timerId);
    }
  }
  getInterval(wasError) {
    var _a2;
    if (wasError) {
      const interval = this.errorBackoff;
      this.errorBackoff = Math.min(
        this.errorBackoff * 2,
        96e4
        /* Duration.RETRY_BACKOFF_MAX */
      );
      return interval;
    } else {
      this.errorBackoff = 3e4;
      const expTime =
        (_a2 = this.user.stsTokenManager.expirationTime) !== null &&
        _a2 !== void 0
          ? _a2
          : 0;
      const interval = expTime - Date.now() - 3e5;
      return Math.max(0, interval);
    }
  }
  schedule(wasError = false) {
    if (!this.isRunning) {
      return;
    }
    const interval = this.getInterval(wasError);
    this.timerId = setTimeout(async () => {
      await this.iteration();
    }, interval);
  }
  async iteration() {
    try {
      await this.user.getIdToken(true);
    } catch (e) {
      if (
        (e === null || e === void 0 ? void 0 : e.code) ===
        `auth/${"network-request-failed"}`
      ) {
        this.schedule(
          /* wasError */
          true
        );
      }
      return;
    }
    this.schedule();
  }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class UserMetadata {
  constructor(createdAt, lastLoginAt) {
    this.createdAt = createdAt;
    this.lastLoginAt = lastLoginAt;
    this._initializeTime();
  }
  _initializeTime() {
    this.lastSignInTime = utcTimestampToDateString(this.lastLoginAt);
    this.creationTime = utcTimestampToDateString(this.createdAt);
  }
  _copy(metadata) {
    this.createdAt = metadata.createdAt;
    this.lastLoginAt = metadata.lastLoginAt;
    this._initializeTime();
  }
  toJSON() {
    return {
      createdAt: this.createdAt,
      lastLoginAt: this.lastLoginAt,
    };
  }
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
async function _reloadWithoutSaving(user) {
  var _a2;
  const auth2 = user.auth;
  const idToken = await user.getIdToken();
  const response = await _logoutIfInvalidated(
    user,
    getAccountInfo(auth2, { idToken })
  );
  _assert(
    response === null || response === void 0 ? void 0 : response.users.length,
    auth2,
    "internal-error"
    /* AuthErrorCode.INTERNAL_ERROR */
  );
  const coreAccount = response.users[0];
  user._notifyReloadListener(coreAccount);
  const newProviderData = (
    (_a2 = coreAccount.providerUserInfo) === null || _a2 === void 0
      ? void 0
      : _a2.length
  )
    ? extractProviderData(coreAccount.providerUserInfo)
    : [];
  const providerData = mergeProviderData(user.providerData, newProviderData);
  const oldIsAnonymous = user.isAnonymous;
  const newIsAnonymous =
    !(user.email && coreAccount.passwordHash) &&
    !(providerData === null || providerData === void 0
      ? void 0
      : providerData.length);
  const isAnonymous = !oldIsAnonymous ? false : newIsAnonymous;
  const updates = {
    uid: coreAccount.localId,
    displayName: coreAccount.displayName || null,
    photoURL: coreAccount.photoUrl || null,
    email: coreAccount.email || null,
    emailVerified: coreAccount.emailVerified || false,
    phoneNumber: coreAccount.phoneNumber || null,
    tenantId: coreAccount.tenantId || null,
    providerData,
    metadata: new UserMetadata(coreAccount.createdAt, coreAccount.lastLoginAt),
    isAnonymous,
  };
  Object.assign(user, updates);
}
async function reload(user) {
  const userInternal = getModularInstance(user);
  await _reloadWithoutSaving(userInternal);
  await userInternal.auth._persistUserIfCurrent(userInternal);
  userInternal.auth._notifyListenersIfCurrent(userInternal);
}
function mergeProviderData(original, newData) {
  const deduped = original.filter(
    (o) => !newData.some((n) => n.providerId === o.providerId)
  );
  return [...deduped, ...newData];
}
function extractProviderData(providers) {
  return providers.map((_a2) => {
    var { providerId } = _a2,
      provider = __rest(_a2, ["providerId"]);
    return {
      providerId,
      uid: provider.rawId || "",
      displayName: provider.displayName || null,
      email: provider.email || null,
      phoneNumber: provider.phoneNumber || null,
      photoURL: provider.photoUrl || null,
    };
  });
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
async function requestStsToken(auth2, refreshToken) {
  const response = await _performFetchWithErrorHandling(auth2, {}, async () => {
    const body = querystring({
      grant_type: "refresh_token",
      refresh_token: refreshToken,
    }).slice(1);
    const { tokenApiHost, apiKey } = auth2.config;
    const url = _getFinalTarget(
      auth2,
      tokenApiHost,
      "/v1/token",
      `key=${apiKey}`
    );
    const headers = await auth2._getAdditionalHeaders();
    headers[
      "Content-Type"
      /* HttpHeader.CONTENT_TYPE */
    ] = "application/x-www-form-urlencoded";
    return FetchProvider.fetch()(url, {
      method: "POST",
      headers,
      body,
    });
  });
  return {
    accessToken: response.access_token,
    expiresIn: response.expires_in,
    refreshToken: response.refresh_token,
  };
}
async function revokeToken(auth2, request) {
  return _performApiRequest(
    auth2,
    "POST",
    "/v2/accounts:revokeToken",
    _addTidIfNecessary(auth2, request)
  );
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class StsTokenManager {
  constructor() {
    this.refreshToken = null;
    this.accessToken = null;
    this.expirationTime = null;
  }
  get isExpired() {
    return !this.expirationTime || Date.now() > this.expirationTime - 3e4;
  }
  updateFromServerResponse(response) {
    _assert(
      response.idToken,
      "internal-error"
      /* AuthErrorCode.INTERNAL_ERROR */
    );
    _assert(
      typeof response.idToken !== "undefined",
      "internal-error"
      /* AuthErrorCode.INTERNAL_ERROR */
    );
    _assert(
      typeof response.refreshToken !== "undefined",
      "internal-error"
      /* AuthErrorCode.INTERNAL_ERROR */
    );
    const expiresIn =
      "expiresIn" in response && typeof response.expiresIn !== "undefined"
        ? Number(response.expiresIn)
        : _tokenExpiresIn(response.idToken);
    this.updateTokensAndExpiration(
      response.idToken,
      response.refreshToken,
      expiresIn
    );
  }
  updateFromIdToken(idToken) {
    _assert(
      idToken.length !== 0,
      "internal-error"
      /* AuthErrorCode.INTERNAL_ERROR */
    );
    const expiresIn = _tokenExpiresIn(idToken);
    this.updateTokensAndExpiration(idToken, null, expiresIn);
  }
  async getToken(auth2, forceRefresh = false) {
    if (!forceRefresh && this.accessToken && !this.isExpired) {
      return this.accessToken;
    }
    _assert(
      this.refreshToken,
      auth2,
      "user-token-expired"
      /* AuthErrorCode.TOKEN_EXPIRED */
    );
    if (this.refreshToken) {
      await this.refresh(auth2, this.refreshToken);
      return this.accessToken;
    }
    return null;
  }
  clearRefreshToken() {
    this.refreshToken = null;
  }
  async refresh(auth2, oldToken) {
    const { accessToken, refreshToken, expiresIn } = await requestStsToken(
      auth2,
      oldToken
    );
    this.updateTokensAndExpiration(
      accessToken,
      refreshToken,
      Number(expiresIn)
    );
  }
  updateTokensAndExpiration(accessToken, refreshToken, expiresInSec) {
    this.refreshToken = refreshToken || null;
    this.accessToken = accessToken || null;
    this.expirationTime = Date.now() + expiresInSec * 1e3;
  }
  static fromJSON(appName, object) {
    const { refreshToken, accessToken, expirationTime } = object;
    const manager = new StsTokenManager();
    if (refreshToken) {
      _assert(typeof refreshToken === "string", "internal-error", {
        appName,
      });
      manager.refreshToken = refreshToken;
    }
    if (accessToken) {
      _assert(typeof accessToken === "string", "internal-error", {
        appName,
      });
      manager.accessToken = accessToken;
    }
    if (expirationTime) {
      _assert(typeof expirationTime === "number", "internal-error", {
        appName,
      });
      manager.expirationTime = expirationTime;
    }
    return manager;
  }
  toJSON() {
    return {
      refreshToken: this.refreshToken,
      accessToken: this.accessToken,
      expirationTime: this.expirationTime,
    };
  }
  _assign(stsTokenManager) {
    this.accessToken = stsTokenManager.accessToken;
    this.refreshToken = stsTokenManager.refreshToken;
    this.expirationTime = stsTokenManager.expirationTime;
  }
  _clone() {
    return Object.assign(new StsTokenManager(), this.toJSON());
  }
  _performRefresh() {
    return debugFail("not implemented");
  }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function assertStringOrUndefined(assertion, appName) {
  _assert(
    typeof assertion === "string" || typeof assertion === "undefined",
    "internal-error",
    { appName }
  );
}
class UserImpl {
  constructor(_a2) {
    var { uid, auth: auth2, stsTokenManager } = _a2,
      opt = __rest(_a2, ["uid", "auth", "stsTokenManager"]);
    this.providerId = "firebase";
    this.proactiveRefresh = new ProactiveRefresh(this);
    this.reloadUserInfo = null;
    this.reloadListener = null;
    this.uid = uid;
    this.auth = auth2;
    this.stsTokenManager = stsTokenManager;
    this.accessToken = stsTokenManager.accessToken;
    this.displayName = opt.displayName || null;
    this.email = opt.email || null;
    this.emailVerified = opt.emailVerified || false;
    this.phoneNumber = opt.phoneNumber || null;
    this.photoURL = opt.photoURL || null;
    this.isAnonymous = opt.isAnonymous || false;
    this.tenantId = opt.tenantId || null;
    this.providerData = opt.providerData ? [...opt.providerData] : [];
    this.metadata = new UserMetadata(
      opt.createdAt || void 0,
      opt.lastLoginAt || void 0
    );
  }
  async getIdToken(forceRefresh) {
    const accessToken = await _logoutIfInvalidated(
      this,
      this.stsTokenManager.getToken(this.auth, forceRefresh)
    );
    _assert(
      accessToken,
      this.auth,
      "internal-error"
      /* AuthErrorCode.INTERNAL_ERROR */
    );
    if (this.accessToken !== accessToken) {
      this.accessToken = accessToken;
      await this.auth._persistUserIfCurrent(this);
      this.auth._notifyListenersIfCurrent(this);
    }
    return accessToken;
  }
  getIdTokenResult(forceRefresh) {
    return getIdTokenResult(this, forceRefresh);
  }
  reload() {
    return reload(this);
  }
  _assign(user) {
    if (this === user) {
      return;
    }
    _assert(
      this.uid === user.uid,
      this.auth,
      "internal-error"
      /* AuthErrorCode.INTERNAL_ERROR */
    );
    this.displayName = user.displayName;
    this.photoURL = user.photoURL;
    this.email = user.email;
    this.emailVerified = user.emailVerified;
    this.phoneNumber = user.phoneNumber;
    this.isAnonymous = user.isAnonymous;
    this.tenantId = user.tenantId;
    this.providerData = user.providerData.map((userInfo) =>
      Object.assign({}, userInfo)
    );
    this.metadata._copy(user.metadata);
    this.stsTokenManager._assign(user.stsTokenManager);
  }
  _clone(auth2) {
    const newUser = new UserImpl(
      Object.assign(Object.assign({}, this), {
        auth: auth2,
        stsTokenManager: this.stsTokenManager._clone(),
      })
    );
    newUser.metadata._copy(this.metadata);
    return newUser;
  }
  _onReload(callback) {
    _assert(
      !this.reloadListener,
      this.auth,
      "internal-error"
      /* AuthErrorCode.INTERNAL_ERROR */
    );
    this.reloadListener = callback;
    if (this.reloadUserInfo) {
      this._notifyReloadListener(this.reloadUserInfo);
      this.reloadUserInfo = null;
    }
  }
  _notifyReloadListener(userInfo) {
    if (this.reloadListener) {
      this.reloadListener(userInfo);
    } else {
      this.reloadUserInfo = userInfo;
    }
  }
  _startProactiveRefresh() {
    this.proactiveRefresh._start();
  }
  _stopProactiveRefresh() {
    this.proactiveRefresh._stop();
  }
  async _updateTokensIfNecessary(response, reload2 = false) {
    let tokensRefreshed = false;
    if (
      response.idToken &&
      response.idToken !== this.stsTokenManager.accessToken
    ) {
      this.stsTokenManager.updateFromServerResponse(response);
      tokensRefreshed = true;
    }
    if (reload2) {
      await _reloadWithoutSaving(this);
    }
    await this.auth._persistUserIfCurrent(this);
    if (tokensRefreshed) {
      this.auth._notifyListenersIfCurrent(this);
    }
  }
  async delete() {
    if (_isFirebaseServerApp(this.auth.app)) {
      return Promise.reject(
        _serverAppCurrentUserOperationNotSupportedError(this.auth)
      );
    }
    const idToken = await this.getIdToken();
    await _logoutIfInvalidated(this, deleteAccount(this.auth, { idToken }));
    this.stsTokenManager.clearRefreshToken();
    return this.auth.signOut();
  }
  toJSON() {
    return Object.assign(
      Object.assign(
        {
          uid: this.uid,
          email: this.email || void 0,
          emailVerified: this.emailVerified,
          displayName: this.displayName || void 0,
          isAnonymous: this.isAnonymous,
          photoURL: this.photoURL || void 0,
          phoneNumber: this.phoneNumber || void 0,
          tenantId: this.tenantId || void 0,
          providerData: this.providerData.map((userInfo) =>
            Object.assign({}, userInfo)
          ),
          stsTokenManager: this.stsTokenManager.toJSON(),
          // Redirect event ID must be maintained in case there is a pending
          // redirect event.
          _redirectEventId: this._redirectEventId,
        },
        this.metadata.toJSON()
      ),
      {
        // Required for compatibility with the legacy SDK (go/firebase-auth-sdk-persistence-parsing):
        apiKey: this.auth.config.apiKey,
        appName: this.auth.name,
      }
    );
  }
  get refreshToken() {
    return this.stsTokenManager.refreshToken || "";
  }
  static _fromJSON(auth2, object) {
    var _a2, _b2, _c2, _d2, _e3, _f2, _g2, _h;
    const displayName =
      (_a2 = object.displayName) !== null && _a2 !== void 0 ? _a2 : void 0;
    const email =
      (_b2 = object.email) !== null && _b2 !== void 0 ? _b2 : void 0;
    const phoneNumber =
      (_c2 = object.phoneNumber) !== null && _c2 !== void 0 ? _c2 : void 0;
    const photoURL =
      (_d2 = object.photoURL) !== null && _d2 !== void 0 ? _d2 : void 0;
    const tenantId =
      (_e3 = object.tenantId) !== null && _e3 !== void 0 ? _e3 : void 0;
    const _redirectEventId =
      (_f2 = object._redirectEventId) !== null && _f2 !== void 0 ? _f2 : void 0;
    const createdAt =
      (_g2 = object.createdAt) !== null && _g2 !== void 0 ? _g2 : void 0;
    const lastLoginAt =
      (_h = object.lastLoginAt) !== null && _h !== void 0 ? _h : void 0;
    const {
      uid,
      emailVerified,
      isAnonymous,
      providerData,
      stsTokenManager: plainObjectTokenManager,
    } = object;
    _assert(
      uid && plainObjectTokenManager,
      auth2,
      "internal-error"
      /* AuthErrorCode.INTERNAL_ERROR */
    );
    const stsTokenManager = StsTokenManager.fromJSON(
      this.name,
      plainObjectTokenManager
    );
    _assert(
      typeof uid === "string",
      auth2,
      "internal-error"
      /* AuthErrorCode.INTERNAL_ERROR */
    );
    assertStringOrUndefined(displayName, auth2.name);
    assertStringOrUndefined(email, auth2.name);
    _assert(
      typeof emailVerified === "boolean",
      auth2,
      "internal-error"
      /* AuthErrorCode.INTERNAL_ERROR */
    );
    _assert(
      typeof isAnonymous === "boolean",
      auth2,
      "internal-error"
      /* AuthErrorCode.INTERNAL_ERROR */
    );
    assertStringOrUndefined(phoneNumber, auth2.name);
    assertStringOrUndefined(photoURL, auth2.name);
    assertStringOrUndefined(tenantId, auth2.name);
    assertStringOrUndefined(_redirectEventId, auth2.name);
    assertStringOrUndefined(createdAt, auth2.name);
    assertStringOrUndefined(lastLoginAt, auth2.name);
    const user = new UserImpl({
      uid,
      auth: auth2,
      email,
      emailVerified,
      displayName,
      isAnonymous,
      photoURL,
      phoneNumber,
      tenantId,
      stsTokenManager,
      createdAt,
      lastLoginAt,
    });
    if (providerData && Array.isArray(providerData)) {
      user.providerData = providerData.map((userInfo) =>
        Object.assign({}, userInfo)
      );
    }
    if (_redirectEventId) {
      user._redirectEventId = _redirectEventId;
    }
    return user;
  }
  /**
   * Initialize a User from an idToken server response
   * @param auth
   * @param idTokenResponse
   */
  static async _fromIdTokenResponse(
    auth2,
    idTokenResponse,
    isAnonymous = false
  ) {
    const stsTokenManager = new StsTokenManager();
    stsTokenManager.updateFromServerResponse(idTokenResponse);
    const user = new UserImpl({
      uid: idTokenResponse.localId,
      auth: auth2,
      stsTokenManager,
      isAnonymous,
    });
    await _reloadWithoutSaving(user);
    return user;
  }
  /**
   * Initialize a User from an idToken server response
   * @param auth
   * @param idTokenResponse
   */
  static async _fromGetAccountInfoResponse(auth2, response, idToken) {
    const coreAccount = response.users[0];
    _assert(
      coreAccount.localId !== void 0,
      "internal-error"
      /* AuthErrorCode.INTERNAL_ERROR */
    );
    const providerData =
      coreAccount.providerUserInfo !== void 0
        ? extractProviderData(coreAccount.providerUserInfo)
        : [];
    const isAnonymous =
      !(coreAccount.email && coreAccount.passwordHash) &&
      !(providerData === null || providerData === void 0
        ? void 0
        : providerData.length);
    const stsTokenManager = new StsTokenManager();
    stsTokenManager.updateFromIdToken(idToken);
    const user = new UserImpl({
      uid: coreAccount.localId,
      auth: auth2,
      stsTokenManager,
      isAnonymous,
    });
    const updates = {
      uid: coreAccount.localId,
      displayName: coreAccount.displayName || null,
      photoURL: coreAccount.photoUrl || null,
      email: coreAccount.email || null,
      emailVerified: coreAccount.emailVerified || false,
      phoneNumber: coreAccount.phoneNumber || null,
      tenantId: coreAccount.tenantId || null,
      providerData,
      metadata: new UserMetadata(
        coreAccount.createdAt,
        coreAccount.lastLoginAt
      ),
      isAnonymous:
        !(coreAccount.email && coreAccount.passwordHash) &&
        !(providerData === null || providerData === void 0
          ? void 0
          : providerData.length),
    };
    Object.assign(user, updates);
    return user;
  }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const instanceCache = /* @__PURE__ */ new Map();
function _getInstance(cls) {
  debugAssert(cls instanceof Function, "Expected a class definition");
  let instance2 = instanceCache.get(cls);
  if (instance2) {
    debugAssert(
      instance2 instanceof cls,
      "Instance stored in cache mismatched with class"
    );
    return instance2;
  }
  instance2 = new cls();
  instanceCache.set(cls, instance2);
  return instance2;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class InMemoryPersistence {
  constructor() {
    this.type = "NONE";
    this.storage = {};
  }
  async _isAvailable() {
    return true;
  }
  async _set(key, value) {
    this.storage[key] = value;
  }
  async _get(key) {
    const value = this.storage[key];
    return value === void 0 ? null : value;
  }
  async _remove(key) {
    delete this.storage[key];
  }
  _addListener(_key, _listener) {
    return;
  }
  _removeListener(_key, _listener) {
    return;
  }
}
InMemoryPersistence.type = "NONE";
const inMemoryPersistence = InMemoryPersistence;
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function _persistenceKeyName(key, apiKey, appName) {
  return `${"firebase"}:${key}:${apiKey}:${appName}`;
}
class PersistenceUserManager {
  constructor(persistence, auth2, userKey) {
    this.persistence = persistence;
    this.auth = auth2;
    this.userKey = userKey;
    const { config, name: name2 } = this.auth;
    this.fullUserKey = _persistenceKeyName(this.userKey, config.apiKey, name2);
    this.fullPersistenceKey = _persistenceKeyName(
      "persistence",
      config.apiKey,
      name2
    );
    this.boundEventHandler = auth2._onStorageEvent.bind(auth2);
    this.persistence._addListener(this.fullUserKey, this.boundEventHandler);
  }
  setCurrentUser(user) {
    return this.persistence._set(this.fullUserKey, user.toJSON());
  }
  async getCurrentUser() {
    const blob = await this.persistence._get(this.fullUserKey);
    return blob ? UserImpl._fromJSON(this.auth, blob) : null;
  }
  removeCurrentUser() {
    return this.persistence._remove(this.fullUserKey);
  }
  savePersistenceForRedirect() {
    return this.persistence._set(
      this.fullPersistenceKey,
      this.persistence.type
    );
  }
  async setPersistence(newPersistence) {
    if (this.persistence === newPersistence) {
      return;
    }
    const currentUser = await this.getCurrentUser();
    await this.removeCurrentUser();
    this.persistence = newPersistence;
    if (currentUser) {
      return this.setCurrentUser(currentUser);
    }
  }
  delete() {
    this.persistence._removeListener(this.fullUserKey, this.boundEventHandler);
  }
  static async create(auth2, persistenceHierarchy, userKey = "authUser") {
    if (!persistenceHierarchy.length) {
      return new PersistenceUserManager(
        _getInstance(inMemoryPersistence),
        auth2,
        userKey
      );
    }
    const availablePersistences = (
      await Promise.all(
        persistenceHierarchy.map(async (persistence) => {
          if (await persistence._isAvailable()) {
            return persistence;
          }
          return void 0;
        })
      )
    ).filter((persistence) => persistence);
    let selectedPersistence =
      availablePersistences[0] || _getInstance(inMemoryPersistence);
    const key = _persistenceKeyName(userKey, auth2.config.apiKey, auth2.name);
    let userToMigrate = null;
    for (const persistence of persistenceHierarchy) {
      try {
        const blob = await persistence._get(key);
        if (blob) {
          const user = UserImpl._fromJSON(auth2, blob);
          if (persistence !== selectedPersistence) {
            userToMigrate = user;
          }
          selectedPersistence = persistence;
          break;
        }
      } catch (_a2) {}
    }
    const migrationHierarchy = availablePersistences.filter(
      (p2) => p2._shouldAllowMigration
    );
    if (
      !selectedPersistence._shouldAllowMigration ||
      !migrationHierarchy.length
    ) {
      return new PersistenceUserManager(selectedPersistence, auth2, userKey);
    }
    selectedPersistence = migrationHierarchy[0];
    if (userToMigrate) {
      await selectedPersistence._set(key, userToMigrate.toJSON());
    }
    await Promise.all(
      persistenceHierarchy.map(async (persistence) => {
        if (persistence !== selectedPersistence) {
          try {
            await persistence._remove(key);
          } catch (_a2) {}
        }
      })
    );
    return new PersistenceUserManager(selectedPersistence, auth2, userKey);
  }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function _getBrowserName(userAgent) {
  const ua2 = userAgent.toLowerCase();
  if (
    ua2.includes("opera/") ||
    ua2.includes("opr/") ||
    ua2.includes("opios/")
  ) {
    return "Opera";
  } else if (_isIEMobile(ua2)) {
    return "IEMobile";
  } else if (ua2.includes("msie") || ua2.includes("trident/")) {
    return "IE";
  } else if (ua2.includes("edge/")) {
    return "Edge";
  } else if (_isFirefox(ua2)) {
    return "Firefox";
  } else if (ua2.includes("silk/")) {
    return "Silk";
  } else if (_isBlackBerry(ua2)) {
    return "Blackberry";
  } else if (_isWebOS(ua2)) {
    return "Webos";
  } else if (_isSafari(ua2)) {
    return "Safari";
  } else if (
    (ua2.includes("chrome/") || _isChromeIOS(ua2)) &&
    !ua2.includes("edge/")
  ) {
    return "Chrome";
  } else if (_isAndroid(ua2)) {
    return "Android";
  } else {
    const re = /([a-zA-Z\d\.]+)\/[a-zA-Z\d\.]*$/;
    const matches = userAgent.match(re);
    if (
      (matches === null || matches === void 0 ? void 0 : matches.length) === 2
    ) {
      return matches[1];
    }
  }
  return "Other";
}
function _isFirefox(ua2 = getUA()) {
  return /firefox\//i.test(ua2);
}
function _isSafari(userAgent = getUA()) {
  const ua2 = userAgent.toLowerCase();
  return (
    ua2.includes("safari/") &&
    !ua2.includes("chrome/") &&
    !ua2.includes("crios/") &&
    !ua2.includes("android")
  );
}
function _isChromeIOS(ua2 = getUA()) {
  return /crios\//i.test(ua2);
}
function _isIEMobile(ua2 = getUA()) {
  return /iemobile/i.test(ua2);
}
function _isAndroid(ua2 = getUA()) {
  return /android/i.test(ua2);
}
function _isBlackBerry(ua2 = getUA()) {
  return /blackberry/i.test(ua2);
}
function _isWebOS(ua2 = getUA()) {
  return /webos/i.test(ua2);
}
function _isIOS(ua2 = getUA()) {
  return (
    /iphone|ipad|ipod/i.test(ua2) ||
    (/macintosh/i.test(ua2) && /mobile/i.test(ua2))
  );
}
function _isIOSStandalone(ua2 = getUA()) {
  var _a2;
  return (
    _isIOS(ua2) &&
    !!((_a2 = window.navigator) === null || _a2 === void 0
      ? void 0
      : _a2.standalone)
  );
}
function _isIE10() {
  return isIE() && document.documentMode === 10;
}
function _isMobileBrowser(ua2 = getUA()) {
  return (
    _isIOS(ua2) ||
    _isAndroid(ua2) ||
    _isWebOS(ua2) ||
    _isBlackBerry(ua2) ||
    /windows phone/i.test(ua2) ||
    _isIEMobile(ua2)
  );
}
function _isIframe() {
  try {
    return !!(window && window !== window.top);
  } catch (e) {
    return false;
  }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function _getClientVersion(clientPlatform, frameworks = []) {
  let reportedPlatform;
  switch (clientPlatform) {
    case "Browser":
      reportedPlatform = _getBrowserName(getUA());
      break;
    case "Worker":
      reportedPlatform = `${_getBrowserName(getUA())}-${clientPlatform}`;
      break;
    default:
      reportedPlatform = clientPlatform;
  }
  const reportedFrameworks = frameworks.length
    ? frameworks.join(",")
    : "FirebaseCore-web";
  return `${reportedPlatform}/${"JsCore"}/${SDK_VERSION}/${reportedFrameworks}`;
}
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class AuthMiddlewareQueue {
  constructor(auth2) {
    this.auth = auth2;
    this.queue = [];
  }
  pushCallback(callback, onAbort) {
    const wrappedCallback = (user) =>
      new Promise((resolve, reject3) => {
        try {
          const result = callback(user);
          resolve(result);
        } catch (e) {
          reject3(e);
        }
      });
    wrappedCallback.onAbort = onAbort;
    this.queue.push(wrappedCallback);
    const index = this.queue.length - 1;
    return () => {
      this.queue[index] = () => Promise.resolve();
    };
  }
  async runMiddleware(nextUser) {
    if (this.auth.currentUser === nextUser) {
      return;
    }
    const onAbortStack = [];
    try {
      for (const beforeStateCallback of this.queue) {
        await beforeStateCallback(nextUser);
        if (beforeStateCallback.onAbort) {
          onAbortStack.push(beforeStateCallback.onAbort);
        }
      }
    } catch (e) {
      onAbortStack.reverse();
      for (const onAbort of onAbortStack) {
        try {
          onAbort();
        } catch (_) {}
      }
      throw this.auth._errorFactory.create("login-blocked", {
        originalMessage: e === null || e === void 0 ? void 0 : e.message,
      });
    }
  }
}
/**
 * @license
 * Copyright 2023 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
async function _getPasswordPolicy(auth2, request = {}) {
  return _performApiRequest(
    auth2,
    "GET",
    "/v2/passwordPolicy",
    _addTidIfNecessary(auth2, request)
  );
}
/**
 * @license
 * Copyright 2023 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const MINIMUM_MIN_PASSWORD_LENGTH = 6;
class PasswordPolicyImpl {
  constructor(response) {
    var _a2, _b2, _c2, _d2;
    const responseOptions = response.customStrengthOptions;
    this.customStrengthOptions = {};
    this.customStrengthOptions.minPasswordLength =
      (_a2 = responseOptions.minPasswordLength) !== null && _a2 !== void 0
        ? _a2
        : MINIMUM_MIN_PASSWORD_LENGTH;
    if (responseOptions.maxPasswordLength) {
      this.customStrengthOptions.maxPasswordLength =
        responseOptions.maxPasswordLength;
    }
    if (responseOptions.containsLowercaseCharacter !== void 0) {
      this.customStrengthOptions.containsLowercaseLetter =
        responseOptions.containsLowercaseCharacter;
    }
    if (responseOptions.containsUppercaseCharacter !== void 0) {
      this.customStrengthOptions.containsUppercaseLetter =
        responseOptions.containsUppercaseCharacter;
    }
    if (responseOptions.containsNumericCharacter !== void 0) {
      this.customStrengthOptions.containsNumericCharacter =
        responseOptions.containsNumericCharacter;
    }
    if (responseOptions.containsNonAlphanumericCharacter !== void 0) {
      this.customStrengthOptions.containsNonAlphanumericCharacter =
        responseOptions.containsNonAlphanumericCharacter;
    }
    this.enforcementState = response.enforcementState;
    if (this.enforcementState === "ENFORCEMENT_STATE_UNSPECIFIED") {
      this.enforcementState = "OFF";
    }
    this.allowedNonAlphanumericCharacters =
      (_c2 =
        (_b2 = response.allowedNonAlphanumericCharacters) === null ||
        _b2 === void 0
          ? void 0
          : _b2.join("")) !== null && _c2 !== void 0
        ? _c2
        : "";
    this.forceUpgradeOnSignin =
      (_d2 = response.forceUpgradeOnSignin) !== null && _d2 !== void 0
        ? _d2
        : false;
    this.schemaVersion = response.schemaVersion;
  }
  validatePassword(password) {
    var _a2, _b2, _c2, _d2, _e3, _f2;
    const status = {
      isValid: true,
      passwordPolicy: this,
    };
    this.validatePasswordLengthOptions(password, status);
    this.validatePasswordCharacterOptions(password, status);
    status.isValid &&
      (status.isValid =
        (_a2 = status.meetsMinPasswordLength) !== null && _a2 !== void 0
          ? _a2
          : true);
    status.isValid &&
      (status.isValid =
        (_b2 = status.meetsMaxPasswordLength) !== null && _b2 !== void 0
          ? _b2
          : true);
    status.isValid &&
      (status.isValid =
        (_c2 = status.containsLowercaseLetter) !== null && _c2 !== void 0
          ? _c2
          : true);
    status.isValid &&
      (status.isValid =
        (_d2 = status.containsUppercaseLetter) !== null && _d2 !== void 0
          ? _d2
          : true);
    status.isValid &&
      (status.isValid =
        (_e3 = status.containsNumericCharacter) !== null && _e3 !== void 0
          ? _e3
          : true);
    status.isValid &&
      (status.isValid =
        (_f2 = status.containsNonAlphanumericCharacter) !== null &&
        _f2 !== void 0
          ? _f2
          : true);
    return status;
  }
  /**
   * Validates that the password meets the length options for the policy.
   *
   * @param password Password to validate.
   * @param status Validation status.
   */
  validatePasswordLengthOptions(password, status) {
    const minPasswordLength = this.customStrengthOptions.minPasswordLength;
    const maxPasswordLength = this.customStrengthOptions.maxPasswordLength;
    if (minPasswordLength) {
      status.meetsMinPasswordLength = password.length >= minPasswordLength;
    }
    if (maxPasswordLength) {
      status.meetsMaxPasswordLength = password.length <= maxPasswordLength;
    }
  }
  /**
   * Validates that the password meets the character options for the policy.
   *
   * @param password Password to validate.
   * @param status Validation status.
   */
  validatePasswordCharacterOptions(password, status) {
    this.updatePasswordCharacterOptionsStatuses(
      status,
      /* containsLowercaseCharacter= */
      false,
      /* containsUppercaseCharacter= */
      false,
      /* containsNumericCharacter= */
      false,
      /* containsNonAlphanumericCharacter= */
      false
    );
    let passwordChar;
    for (let i = 0; i < password.length; i++) {
      passwordChar = password.charAt(i);
      this.updatePasswordCharacterOptionsStatuses(
        status,
        /* containsLowercaseCharacter= */
        passwordChar >= "a" && passwordChar <= "z",
        /* containsUppercaseCharacter= */
        passwordChar >= "A" && passwordChar <= "Z",
        /* containsNumericCharacter= */
        passwordChar >= "0" && passwordChar <= "9",
        /* containsNonAlphanumericCharacter= */
        this.allowedNonAlphanumericCharacters.includes(passwordChar)
      );
    }
  }
  /**
   * Updates the running validation status with the statuses for the character options.
   * Expected to be called each time a character is processed to update each option status
   * based on the current character.
   *
   * @param status Validation status.
   * @param containsLowercaseCharacter Whether the character is a lowercase letter.
   * @param containsUppercaseCharacter Whether the character is an uppercase letter.
   * @param containsNumericCharacter Whether the character is a numeric character.
   * @param containsNonAlphanumericCharacter Whether the character is a non-alphanumeric character.
   */
  updatePasswordCharacterOptionsStatuses(
    status,
    containsLowercaseCharacter,
    containsUppercaseCharacter,
    containsNumericCharacter,
    containsNonAlphanumericCharacter
  ) {
    if (this.customStrengthOptions.containsLowercaseLetter) {
      status.containsLowercaseLetter ||
        (status.containsLowercaseLetter = containsLowercaseCharacter);
    }
    if (this.customStrengthOptions.containsUppercaseLetter) {
      status.containsUppercaseLetter ||
        (status.containsUppercaseLetter = containsUppercaseCharacter);
    }
    if (this.customStrengthOptions.containsNumericCharacter) {
      status.containsNumericCharacter ||
        (status.containsNumericCharacter = containsNumericCharacter);
    }
    if (this.customStrengthOptions.containsNonAlphanumericCharacter) {
      status.containsNonAlphanumericCharacter ||
        (status.containsNonAlphanumericCharacter =
          containsNonAlphanumericCharacter);
    }
  }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class AuthImpl {
  constructor(app2, heartbeatServiceProvider, appCheckServiceProvider, config) {
    this.app = app2;
    this.heartbeatServiceProvider = heartbeatServiceProvider;
    this.appCheckServiceProvider = appCheckServiceProvider;
    this.config = config;
    this.currentUser = null;
    this.emulatorConfig = null;
    this.operations = Promise.resolve();
    this.authStateSubscription = new Subscription(this);
    this.idTokenSubscription = new Subscription(this);
    this.beforeStateQueue = new AuthMiddlewareQueue(this);
    this.redirectUser = null;
    this.isProactiveRefreshEnabled = false;
    this.EXPECTED_PASSWORD_POLICY_SCHEMA_VERSION = 1;
    this._canInitEmulator = true;
    this._isInitialized = false;
    this._deleted = false;
    this._initializationPromise = null;
    this._popupRedirectResolver = null;
    this._errorFactory = _DEFAULT_AUTH_ERROR_FACTORY;
    this._agentRecaptchaConfig = null;
    this._tenantRecaptchaConfigs = {};
    this._projectPasswordPolicy = null;
    this._tenantPasswordPolicies = {};
    this.lastNotifiedUid = void 0;
    this.languageCode = null;
    this.tenantId = null;
    this.settings = { appVerificationDisabledForTesting: false };
    this.frameworks = [];
    this.name = app2.name;
    this.clientVersion = config.sdkClientVersion;
  }
  _initializeWithPersistence(persistenceHierarchy, popupRedirectResolver) {
    if (popupRedirectResolver) {
      this._popupRedirectResolver = _getInstance(popupRedirectResolver);
    }
    this._initializationPromise = this.queue(async () => {
      var _a2, _b2;
      if (this._deleted) {
        return;
      }
      this.persistenceManager = await PersistenceUserManager.create(
        this,
        persistenceHierarchy
      );
      if (this._deleted) {
        return;
      }
      if (
        (_a2 = this._popupRedirectResolver) === null || _a2 === void 0
          ? void 0
          : _a2._shouldInitProactively
      ) {
        try {
          await this._popupRedirectResolver._initialize(this);
        } catch (e) {}
      }
      await this.initializeCurrentUser(popupRedirectResolver);
      this.lastNotifiedUid =
        ((_b2 = this.currentUser) === null || _b2 === void 0
          ? void 0
          : _b2.uid) || null;
      if (this._deleted) {
        return;
      }
      this._isInitialized = true;
    });
    return this._initializationPromise;
  }
  /**
   * If the persistence is changed in another window, the user manager will let us know
   */
  async _onStorageEvent() {
    if (this._deleted) {
      return;
    }
    const user = await this.assertedPersistence.getCurrentUser();
    if (!this.currentUser && !user) {
      return;
    }
    if (this.currentUser && user && this.currentUser.uid === user.uid) {
      this._currentUser._assign(user);
      await this.currentUser.getIdToken();
      return;
    }
    await this._updateCurrentUser(
      user,
      /* skipBeforeStateCallbacks */
      true
    );
  }
  async initializeCurrentUserFromIdToken(idToken) {
    try {
      const response = await getAccountInfo(this, { idToken });
      const user = await UserImpl._fromGetAccountInfoResponse(
        this,
        response,
        idToken
      );
      await this.directlySetCurrentUser(user);
    } catch (err) {
      console.warn(
        "FirebaseServerApp could not login user with provided authIdToken: ",
        err
      );
      await this.directlySetCurrentUser(null);
    }
  }
  async initializeCurrentUser(popupRedirectResolver) {
    var _a2;
    if (_isFirebaseServerApp(this.app)) {
      const idToken = this.app.settings.authIdToken;
      if (idToken) {
        return new Promise((resolve) => {
          setTimeout(() =>
            this.initializeCurrentUserFromIdToken(idToken).then(
              resolve,
              resolve
            )
          );
        });
      } else {
        return this.directlySetCurrentUser(null);
      }
    }
    const previouslyStoredUser =
      await this.assertedPersistence.getCurrentUser();
    let futureCurrentUser = previouslyStoredUser;
    let needsTocheckMiddleware = false;
    if (popupRedirectResolver && this.config.authDomain) {
      await this.getOrInitRedirectPersistenceManager();
      const redirectUserEventId =
        (_a2 = this.redirectUser) === null || _a2 === void 0
          ? void 0
          : _a2._redirectEventId;
      const storedUserEventId =
        futureCurrentUser === null || futureCurrentUser === void 0
          ? void 0
          : futureCurrentUser._redirectEventId;
      const result = await this.tryRedirectSignIn(popupRedirectResolver);
      if (
        (!redirectUserEventId || redirectUserEventId === storedUserEventId) &&
        (result === null || result === void 0 ? void 0 : result.user)
      ) {
        futureCurrentUser = result.user;
        needsTocheckMiddleware = true;
      }
    }
    if (!futureCurrentUser) {
      return this.directlySetCurrentUser(null);
    }
    if (!futureCurrentUser._redirectEventId) {
      if (needsTocheckMiddleware) {
        try {
          await this.beforeStateQueue.runMiddleware(futureCurrentUser);
        } catch (e) {
          futureCurrentUser = previouslyStoredUser;
          this._popupRedirectResolver._overrideRedirectResult(this, () =>
            Promise.reject(e)
          );
        }
      }
      if (futureCurrentUser) {
        return this.reloadAndSetCurrentUserOrClear(futureCurrentUser);
      } else {
        return this.directlySetCurrentUser(null);
      }
    }
    _assert(
      this._popupRedirectResolver,
      this,
      "argument-error"
      /* AuthErrorCode.ARGUMENT_ERROR */
    );
    await this.getOrInitRedirectPersistenceManager();
    if (
      this.redirectUser &&
      this.redirectUser._redirectEventId === futureCurrentUser._redirectEventId
    ) {
      return this.directlySetCurrentUser(futureCurrentUser);
    }
    return this.reloadAndSetCurrentUserOrClear(futureCurrentUser);
  }
  async tryRedirectSignIn(redirectResolver) {
    let result = null;
    try {
      result = await this._popupRedirectResolver._completeRedirectFn(
        this,
        redirectResolver,
        true
      );
    } catch (e) {
      await this._setRedirectUser(null);
    }
    return result;
  }
  async reloadAndSetCurrentUserOrClear(user) {
    try {
      await _reloadWithoutSaving(user);
    } catch (e) {
      if (
        (e === null || e === void 0 ? void 0 : e.code) !==
        `auth/${"network-request-failed"}`
      ) {
        return this.directlySetCurrentUser(null);
      }
    }
    return this.directlySetCurrentUser(user);
  }
  useDeviceLanguage() {
    this.languageCode = _getUserLanguage();
  }
  async _delete() {
    this._deleted = true;
  }
  async updateCurrentUser(userExtern) {
    if (_isFirebaseServerApp(this.app)) {
      return Promise.reject(
        _serverAppCurrentUserOperationNotSupportedError(this)
      );
    }
    const user = userExtern ? getModularInstance(userExtern) : null;
    if (user) {
      _assert(
        user.auth.config.apiKey === this.config.apiKey,
        this,
        "invalid-user-token"
        /* AuthErrorCode.INVALID_AUTH */
      );
    }
    return this._updateCurrentUser(user && user._clone(this));
  }
  async _updateCurrentUser(user, skipBeforeStateCallbacks = false) {
    if (this._deleted) {
      return;
    }
    if (user) {
      _assert(
        this.tenantId === user.tenantId,
        this,
        "tenant-id-mismatch"
        /* AuthErrorCode.TENANT_ID_MISMATCH */
      );
    }
    if (!skipBeforeStateCallbacks) {
      await this.beforeStateQueue.runMiddleware(user);
    }
    return this.queue(async () => {
      await this.directlySetCurrentUser(user);
      this.notifyAuthListeners();
    });
  }
  async signOut() {
    if (_isFirebaseServerApp(this.app)) {
      return Promise.reject(
        _serverAppCurrentUserOperationNotSupportedError(this)
      );
    }
    await this.beforeStateQueue.runMiddleware(null);
    if (this.redirectPersistenceManager || this._popupRedirectResolver) {
      await this._setRedirectUser(null);
    }
    return this._updateCurrentUser(
      null,
      /* skipBeforeStateCallbacks */
      true
    );
  }
  setPersistence(persistence) {
    if (_isFirebaseServerApp(this.app)) {
      return Promise.reject(
        _serverAppCurrentUserOperationNotSupportedError(this)
      );
    }
    return this.queue(async () => {
      await this.assertedPersistence.setPersistence(_getInstance(persistence));
    });
  }
  _getRecaptchaConfig() {
    if (this.tenantId == null) {
      return this._agentRecaptchaConfig;
    } else {
      return this._tenantRecaptchaConfigs[this.tenantId];
    }
  }
  async validatePassword(password) {
    if (!this._getPasswordPolicyInternal()) {
      await this._updatePasswordPolicy();
    }
    const passwordPolicy = this._getPasswordPolicyInternal();
    if (
      passwordPolicy.schemaVersion !==
      this.EXPECTED_PASSWORD_POLICY_SCHEMA_VERSION
    ) {
      return Promise.reject(
        this._errorFactory.create(
          "unsupported-password-policy-schema-version",
          {}
        )
      );
    }
    return passwordPolicy.validatePassword(password);
  }
  _getPasswordPolicyInternal() {
    if (this.tenantId === null) {
      return this._projectPasswordPolicy;
    } else {
      return this._tenantPasswordPolicies[this.tenantId];
    }
  }
  async _updatePasswordPolicy() {
    const response = await _getPasswordPolicy(this);
    const passwordPolicy = new PasswordPolicyImpl(response);
    if (this.tenantId === null) {
      this._projectPasswordPolicy = passwordPolicy;
    } else {
      this._tenantPasswordPolicies[this.tenantId] = passwordPolicy;
    }
  }
  _getPersistence() {
    return this.assertedPersistence.persistence.type;
  }
  _updateErrorMap(errorMap) {
    this._errorFactory = new ErrorFactory("auth", "Firebase", errorMap());
  }
  onAuthStateChanged(nextOrObserver, error, completed) {
    return this.registerStateListener(
      this.authStateSubscription,
      nextOrObserver,
      error,
      completed
    );
  }
  beforeAuthStateChanged(callback, onAbort) {
    return this.beforeStateQueue.pushCallback(callback, onAbort);
  }
  onIdTokenChanged(nextOrObserver, error, completed) {
    return this.registerStateListener(
      this.idTokenSubscription,
      nextOrObserver,
      error,
      completed
    );
  }
  authStateReady() {
    return new Promise((resolve, reject3) => {
      if (this.currentUser) {
        resolve();
      } else {
        const unsubscribe = this.onAuthStateChanged(() => {
          unsubscribe();
          resolve();
        }, reject3);
      }
    });
  }
  /**
   * Revokes the given access token. Currently only supports Apple OAuth access tokens.
   */
  async revokeAccessToken(token2) {
    if (this.currentUser) {
      const idToken = await this.currentUser.getIdToken();
      const request = {
        providerId: "apple.com",
        tokenType: "ACCESS_TOKEN",
        token: token2,
        idToken,
      };
      if (this.tenantId != null) {
        request.tenantId = this.tenantId;
      }
      await revokeToken(this, request);
    }
  }
  toJSON() {
    var _a2;
    return {
      apiKey: this.config.apiKey,
      authDomain: this.config.authDomain,
      appName: this.name,
      currentUser:
        (_a2 = this._currentUser) === null || _a2 === void 0
          ? void 0
          : _a2.toJSON(),
    };
  }
  async _setRedirectUser(user, popupRedirectResolver) {
    const redirectManager = await this.getOrInitRedirectPersistenceManager(
      popupRedirectResolver
    );
    return user === null
      ? redirectManager.removeCurrentUser()
      : redirectManager.setCurrentUser(user);
  }
  async getOrInitRedirectPersistenceManager(popupRedirectResolver) {
    if (!this.redirectPersistenceManager) {
      const resolver =
        (popupRedirectResolver && _getInstance(popupRedirectResolver)) ||
        this._popupRedirectResolver;
      _assert(
        resolver,
        this,
        "argument-error"
        /* AuthErrorCode.ARGUMENT_ERROR */
      );
      this.redirectPersistenceManager = await PersistenceUserManager.create(
        this,
        [_getInstance(resolver._redirectPersistence)],
        "redirectUser"
        /* KeyName.REDIRECT_USER */
      );
      this.redirectUser =
        await this.redirectPersistenceManager.getCurrentUser();
    }
    return this.redirectPersistenceManager;
  }
  async _redirectUserForId(id2) {
    var _a2, _b2;
    if (this._isInitialized) {
      await this.queue(async () => {});
    }
    if (
      ((_a2 = this._currentUser) === null || _a2 === void 0
        ? void 0
        : _a2._redirectEventId) === id2
    ) {
      return this._currentUser;
    }
    if (
      ((_b2 = this.redirectUser) === null || _b2 === void 0
        ? void 0
        : _b2._redirectEventId) === id2
    ) {
      return this.redirectUser;
    }
    return null;
  }
  async _persistUserIfCurrent(user) {
    if (user === this.currentUser) {
      return this.queue(async () => this.directlySetCurrentUser(user));
    }
  }
  /** Notifies listeners only if the user is current */
  _notifyListenersIfCurrent(user) {
    if (user === this.currentUser) {
      this.notifyAuthListeners();
    }
  }
  _key() {
    return `${this.config.authDomain}:${this.config.apiKey}:${this.name}`;
  }
  _startProactiveRefresh() {
    this.isProactiveRefreshEnabled = true;
    if (this.currentUser) {
      this._currentUser._startProactiveRefresh();
    }
  }
  _stopProactiveRefresh() {
    this.isProactiveRefreshEnabled = false;
    if (this.currentUser) {
      this._currentUser._stopProactiveRefresh();
    }
  }
  /** Returns the current user cast as the internal type */
  get _currentUser() {
    return this.currentUser;
  }
  notifyAuthListeners() {
    var _a2, _b2;
    if (!this._isInitialized) {
      return;
    }
    this.idTokenSubscription.next(this.currentUser);
    const currentUid =
      (_b2 =
        (_a2 = this.currentUser) === null || _a2 === void 0
          ? void 0
          : _a2.uid) !== null && _b2 !== void 0
        ? _b2
        : null;
    if (this.lastNotifiedUid !== currentUid) {
      this.lastNotifiedUid = currentUid;
      this.authStateSubscription.next(this.currentUser);
    }
  }
  registerStateListener(subscription, nextOrObserver, error, completed) {
    if (this._deleted) {
      return () => {};
    }
    const cb2 =
      typeof nextOrObserver === "function"
        ? nextOrObserver
        : nextOrObserver.next.bind(nextOrObserver);
    let isUnsubscribed = false;
    const promise2 = this._isInitialized
      ? Promise.resolve()
      : this._initializationPromise;
    _assert(
      promise2,
      this,
      "internal-error"
      /* AuthErrorCode.INTERNAL_ERROR */
    );
    promise2.then(() => {
      if (isUnsubscribed) {
        return;
      }
      cb2(this.currentUser);
    });
    if (typeof nextOrObserver === "function") {
      const unsubscribe = subscription.addObserver(
        nextOrObserver,
        error,
        completed
      );
      return () => {
        isUnsubscribed = true;
        unsubscribe();
      };
    } else {
      const unsubscribe = subscription.addObserver(nextOrObserver);
      return () => {
        isUnsubscribed = true;
        unsubscribe();
      };
    }
  }
  /**
   * Unprotected (from race conditions) method to set the current user. This
   * should only be called from within a queued callback. This is necessary
   * because the queue shouldn't rely on another queued callback.
   */
  async directlySetCurrentUser(user) {
    if (this.currentUser && this.currentUser !== user) {
      this._currentUser._stopProactiveRefresh();
    }
    if (user && this.isProactiveRefreshEnabled) {
      user._startProactiveRefresh();
    }
    this.currentUser = user;
    if (user) {
      await this.assertedPersistence.setCurrentUser(user);
    } else {
      await this.assertedPersistence.removeCurrentUser();
    }
  }
  queue(action) {
    this.operations = this.operations.then(action, action);
    return this.operations;
  }
  get assertedPersistence() {
    _assert(
      this.persistenceManager,
      this,
      "internal-error"
      /* AuthErrorCode.INTERNAL_ERROR */
    );
    return this.persistenceManager;
  }
  _logFramework(framework) {
    if (!framework || this.frameworks.includes(framework)) {
      return;
    }
    this.frameworks.push(framework);
    this.frameworks.sort();
    this.clientVersion = _getClientVersion(
      this.config.clientPlatform,
      this._getFrameworks()
    );
  }
  _getFrameworks() {
    return this.frameworks;
  }
  async _getAdditionalHeaders() {
    var _a2;
    const headers = {
      ["X-Client-Version"]:
        /* HttpHeader.X_CLIENT_VERSION */
        this.clientVersion,
    };
    if (this.app.options.appId) {
      headers[
        "X-Firebase-gmpid"
        /* HttpHeader.X_FIREBASE_GMPID */
      ] = this.app.options.appId;
    }
    const heartbeatsHeader = await ((_a2 =
      this.heartbeatServiceProvider.getImmediate({
        optional: true,
      })) === null || _a2 === void 0
      ? void 0
      : _a2.getHeartbeatsHeader());
    if (heartbeatsHeader) {
      headers[
        "X-Firebase-Client"
        /* HttpHeader.X_FIREBASE_CLIENT */
      ] = heartbeatsHeader;
    }
    const appCheckToken = await this._getAppCheckToken();
    if (appCheckToken) {
      headers[
        "X-Firebase-AppCheck"
        /* HttpHeader.X_FIREBASE_APP_CHECK */
      ] = appCheckToken;
    }
    return headers;
  }
  async _getAppCheckToken() {
    var _a2;
    const appCheckTokenResult = await ((_a2 =
      this.appCheckServiceProvider.getImmediate({ optional: true })) === null ||
    _a2 === void 0
      ? void 0
      : _a2.getToken());
    if (
      appCheckTokenResult === null || appCheckTokenResult === void 0
        ? void 0
        : appCheckTokenResult.error
    ) {
      _logWarn(
        `Error while retrieving App Check token: ${appCheckTokenResult.error}`
      );
    }
    return appCheckTokenResult === null || appCheckTokenResult === void 0
      ? void 0
      : appCheckTokenResult.token;
  }
}
function _castAuth(auth2) {
  return getModularInstance(auth2);
}
class Subscription {
  constructor(auth2) {
    this.auth = auth2;
    this.observer = null;
    this.addObserver = createSubscribe(
      (observer) => (this.observer = observer)
    );
  }
  get next() {
    _assert(
      this.observer,
      this.auth,
      "internal-error"
      /* AuthErrorCode.INTERNAL_ERROR */
    );
    return this.observer.next.bind(this.observer);
  }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
let externalJSProvider = {
  async loadJS() {
    throw new Error("Unable to load external scripts");
  },
  recaptchaV2Script: "",
  recaptchaEnterpriseScript: "",
  gapiScript: "",
};
function _setExternalJSProvider(p2) {
  externalJSProvider = p2;
}
function _loadJS(url) {
  return externalJSProvider.loadJS(url);
}
function _gapiScriptUrl() {
  return externalJSProvider.gapiScript;
}
function _generateCallbackName(prefix) {
  return `__${prefix}${Math.floor(Math.random() * 1e6)}`;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function initializeAuth(app2, deps) {
  const provider = _getProvider(app2, "auth");
  if (provider.isInitialized()) {
    const auth3 = provider.getImmediate();
    const initialOptions = provider.getOptions();
    if (
      deepEqual(initialOptions, deps !== null && deps !== void 0 ? deps : {})
    ) {
      return auth3;
    } else {
      _fail(
        auth3,
        "already-initialized"
        /* AuthErrorCode.ALREADY_INITIALIZED */
      );
    }
  }
  const auth2 = provider.initialize({ options: deps });
  return auth2;
}
function _initializeAuthInstance(auth2, deps) {
  const persistence =
    (deps === null || deps === void 0 ? void 0 : deps.persistence) || [];
  const hierarchy = (
    Array.isArray(persistence) ? persistence : [persistence]
  ).map(_getInstance);
  if (deps === null || deps === void 0 ? void 0 : deps.errorMap) {
    auth2._updateErrorMap(deps.errorMap);
  }
  auth2._initializeWithPersistence(
    hierarchy,
    deps === null || deps === void 0 ? void 0 : deps.popupRedirectResolver
  );
}
function connectAuthEmulator(auth2, url, options) {
  const authInternal = _castAuth(auth2);
  _assert(
    authInternal._canInitEmulator,
    authInternal,
    "emulator-config-failed"
    /* AuthErrorCode.EMULATOR_CONFIG_FAILED */
  );
  _assert(
    /^https?:\/\//.test(url),
    authInternal,
    "invalid-emulator-scheme"
    /* AuthErrorCode.INVALID_EMULATOR_SCHEME */
  );
  const disableWarnings = !!(options === null || options === void 0
    ? void 0
    : options.disableWarnings);
  const protocol = extractProtocol(url);
  const { host, port } = extractHostAndPort(url);
  const portStr = port === null ? "" : `:${port}`;
  authInternal.config.emulator = { url: `${protocol}//${host}${portStr}/` };
  authInternal.settings.appVerificationDisabledForTesting = true;
  authInternal.emulatorConfig = Object.freeze({
    host,
    port,
    protocol: protocol.replace(":", ""),
    options: Object.freeze({ disableWarnings }),
  });
  if (!disableWarnings) {
    emitEmulatorWarning();
  }
}
function extractProtocol(url) {
  const protocolEnd = url.indexOf(":");
  return protocolEnd < 0 ? "" : url.substr(0, protocolEnd + 1);
}
function extractHostAndPort(url) {
  const protocol = extractProtocol(url);
  const authority = /(\/\/)?([^?#/]+)/.exec(url.substr(protocol.length));
  if (!authority) {
    return { host: "", port: null };
  }
  const hostAndPort = authority[2].split("@").pop() || "";
  const bracketedIPv6 = /^(\[[^\]]+\])(:|$)/.exec(hostAndPort);
  if (bracketedIPv6) {
    const host = bracketedIPv6[1];
    return { host, port: parsePort(hostAndPort.substr(host.length + 1)) };
  } else {
    const [host, port] = hostAndPort.split(":");
    return { host, port: parsePort(port) };
  }
}
function parsePort(portStr) {
  if (!portStr) {
    return null;
  }
  const port = Number(portStr);
  if (isNaN(port)) {
    return null;
  }
  return port;
}
function emitEmulatorWarning() {
  function attachBanner() {
    const el = document.createElement("p");
    const sty = el.style;
    el.innerText =
      "Running in emulator mode. Do not use with production credentials.";
    sty.position = "fixed";
    sty.width = "100%";
    sty.backgroundColor = "#ffffff";
    sty.border = ".1em solid #000000";
    sty.color = "#b50000";
    sty.bottom = "0px";
    sty.left = "0px";
    sty.margin = "0px";
    sty.zIndex = "10000";
    sty.textAlign = "center";
    el.classList.add("firebase-emulator-warning");
    document.body.appendChild(el);
  }
  if (typeof console !== "undefined" && typeof console.info === "function") {
    console.info(
      "WARNING: You are using the Auth Emulator, which is intended for local testing only.  Do not use with production credentials."
    );
  }
  if (typeof window !== "undefined" && typeof document !== "undefined") {
    if (document.readyState === "loading") {
      window.addEventListener("DOMContentLoaded", attachBanner);
    } else {
      attachBanner();
    }
  }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class AuthCredential {
  /** @internal */
  constructor(providerId, signInMethod) {
    this.providerId = providerId;
    this.signInMethod = signInMethod;
  }
  /**
   * Returns a JSON-serializable representation of this object.
   *
   * @returns a JSON-serializable representation of this object.
   */
  toJSON() {
    return debugFail("not implemented");
  }
  /** @internal */
  _getIdTokenResponse(_auth) {
    return debugFail("not implemented");
  }
  /** @internal */
  _linkToIdToken(_auth, _idToken) {
    return debugFail("not implemented");
  }
  /** @internal */
  _getReauthenticationResolver(_auth) {
    return debugFail("not implemented");
  }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
async function signInWithIdp(auth2, request) {
  return _performSignInRequest(
    auth2,
    "POST",
    "/v1/accounts:signInWithIdp",
    _addTidIfNecessary(auth2, request)
  );
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const IDP_REQUEST_URI$1 = "http://localhost";
class OAuthCredential extends AuthCredential {
  constructor() {
    super(...arguments);
    this.pendingToken = null;
  }
  /** @internal */
  static _fromParams(params) {
    const cred = new OAuthCredential(params.providerId, params.signInMethod);
    if (params.idToken || params.accessToken) {
      if (params.idToken) {
        cred.idToken = params.idToken;
      }
      if (params.accessToken) {
        cred.accessToken = params.accessToken;
      }
      if (params.nonce && !params.pendingToken) {
        cred.nonce = params.nonce;
      }
      if (params.pendingToken) {
        cred.pendingToken = params.pendingToken;
      }
    } else if (params.oauthToken && params.oauthTokenSecret) {
      cred.accessToken = params.oauthToken;
      cred.secret = params.oauthTokenSecret;
    } else {
      _fail(
        "argument-error"
        /* AuthErrorCode.ARGUMENT_ERROR */
      );
    }
    return cred;
  }
  /** {@inheritdoc AuthCredential.toJSON}  */
  toJSON() {
    return {
      idToken: this.idToken,
      accessToken: this.accessToken,
      secret: this.secret,
      nonce: this.nonce,
      pendingToken: this.pendingToken,
      providerId: this.providerId,
      signInMethod: this.signInMethod,
    };
  }
  /**
   * Static method to deserialize a JSON representation of an object into an
   * {@link  AuthCredential}.
   *
   * @param json - Input can be either Object or the stringified representation of the object.
   * When string is provided, JSON.parse would be called first.
   *
   * @returns If the JSON input does not represent an {@link  AuthCredential}, null is returned.
   */
  static fromJSON(json) {
    const obj = typeof json === "string" ? JSON.parse(json) : json;
    const { providerId, signInMethod } = obj,
      rest = __rest(obj, ["providerId", "signInMethod"]);
    if (!providerId || !signInMethod) {
      return null;
    }
    const cred = new OAuthCredential(providerId, signInMethod);
    cred.idToken = rest.idToken || void 0;
    cred.accessToken = rest.accessToken || void 0;
    cred.secret = rest.secret;
    cred.nonce = rest.nonce;
    cred.pendingToken = rest.pendingToken || null;
    return cred;
  }
  /** @internal */
  _getIdTokenResponse(auth2) {
    const request = this.buildRequest();
    return signInWithIdp(auth2, request);
  }
  /** @internal */
  _linkToIdToken(auth2, idToken) {
    const request = this.buildRequest();
    request.idToken = idToken;
    return signInWithIdp(auth2, request);
  }
  /** @internal */
  _getReauthenticationResolver(auth2) {
    const request = this.buildRequest();
    request.autoCreate = false;
    return signInWithIdp(auth2, request);
  }
  buildRequest() {
    const request = {
      requestUri: IDP_REQUEST_URI$1,
      returnSecureToken: true,
    };
    if (this.pendingToken) {
      request.pendingToken = this.pendingToken;
    } else {
      const postBody = {};
      if (this.idToken) {
        postBody["id_token"] = this.idToken;
      }
      if (this.accessToken) {
        postBody["access_token"] = this.accessToken;
      }
      if (this.secret) {
        postBody["oauth_token_secret"] = this.secret;
      }
      postBody["providerId"] = this.providerId;
      if (this.nonce && !this.pendingToken) {
        postBody["nonce"] = this.nonce;
      }
      request.postBody = querystring(postBody);
    }
    return request;
  }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class FederatedAuthProvider {
  /**
   * Constructor for generic OAuth providers.
   *
   * @param providerId - Provider for which credentials should be generated.
   */
  constructor(providerId) {
    this.providerId = providerId;
    this.defaultLanguageCode = null;
    this.customParameters = {};
  }
  /**
   * Set the language gode.
   *
   * @param languageCode - language code
   */
  setDefaultLanguage(languageCode) {
    this.defaultLanguageCode = languageCode;
  }
  /**
   * Sets the OAuth custom parameters to pass in an OAuth request for popup and redirect sign-in
   * operations.
   *
   * @remarks
   * For a detailed list, check the reserved required OAuth 2.0 parameters such as `client_id`,
   * `redirect_uri`, `scope`, `response_type`, and `state` are not allowed and will be ignored.
   *
   * @param customOAuthParameters - The custom OAuth parameters to pass in the OAuth request.
   */
  setCustomParameters(customOAuthParameters) {
    this.customParameters = customOAuthParameters;
    return this;
  }
  /**
   * Retrieve the current list of {@link CustomParameters}.
   */
  getCustomParameters() {
    return this.customParameters;
  }
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class BaseOAuthProvider extends FederatedAuthProvider {
  constructor() {
    super(...arguments);
    this.scopes = [];
  }
  /**
   * Add an OAuth scope to the credential.
   *
   * @param scope - Provider OAuth scope to add.
   */
  addScope(scope) {
    if (!this.scopes.includes(scope)) {
      this.scopes.push(scope);
    }
    return this;
  }
  /**
   * Retrieve the current list of OAuth scopes.
   */
  getScopes() {
    return [...this.scopes];
  }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class FacebookAuthProvider extends BaseOAuthProvider {
  constructor() {
    super(
      "facebook.com"
      /* ProviderId.FACEBOOK */
    );
  }
  /**
   * Creates a credential for Facebook.
   *
   * @example
   * ```javascript
   * // `event` from the Facebook auth.authResponseChange callback.
   * const credential = FacebookAuthProvider.credential(event.authResponse.accessToken);
   * const result = await signInWithCredential(credential);
   * ```
   *
   * @param accessToken - Facebook access token.
   */
  static credential(accessToken) {
    return OAuthCredential._fromParams({
      providerId: FacebookAuthProvider.PROVIDER_ID,
      signInMethod: FacebookAuthProvider.FACEBOOK_SIGN_IN_METHOD,
      accessToken,
    });
  }
  /**
   * Used to extract the underlying {@link OAuthCredential} from a {@link UserCredential}.
   *
   * @param userCredential - The user credential.
   */
  static credentialFromResult(userCredential) {
    return FacebookAuthProvider.credentialFromTaggedObject(userCredential);
  }
  /**
   * Used to extract the underlying {@link OAuthCredential} from a {@link AuthError} which was
   * thrown during a sign-in, link, or reauthenticate operation.
   *
   * @param userCredential - The user credential.
   */
  static credentialFromError(error) {
    return FacebookAuthProvider.credentialFromTaggedObject(
      error.customData || {}
    );
  }
  static credentialFromTaggedObject({ _tokenResponse: tokenResponse }) {
    if (!tokenResponse || !("oauthAccessToken" in tokenResponse)) {
      return null;
    }
    if (!tokenResponse.oauthAccessToken) {
      return null;
    }
    try {
      return FacebookAuthProvider.credential(tokenResponse.oauthAccessToken);
    } catch (_a2) {
      return null;
    }
  }
}
FacebookAuthProvider.FACEBOOK_SIGN_IN_METHOD = "facebook.com";
FacebookAuthProvider.PROVIDER_ID = "facebook.com";
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class GoogleAuthProvider extends BaseOAuthProvider {
  constructor() {
    super(
      "google.com"
      /* ProviderId.GOOGLE */
    );
    this.addScope("profile");
  }
  /**
   * Creates a credential for Google. At least one of ID token and access token is required.
   *
   * @example
   * ```javascript
   * // \`googleUser\` from the onsuccess Google Sign In callback.
   * const credential = GoogleAuthProvider.credential(googleUser.getAuthResponse().id_token);
   * const result = await signInWithCredential(credential);
   * ```
   *
   * @param idToken - Google ID token.
   * @param accessToken - Google access token.
   */
  static credential(idToken, accessToken) {
    return OAuthCredential._fromParams({
      providerId: GoogleAuthProvider.PROVIDER_ID,
      signInMethod: GoogleAuthProvider.GOOGLE_SIGN_IN_METHOD,
      idToken,
      accessToken,
    });
  }
  /**
   * Used to extract the underlying {@link OAuthCredential} from a {@link UserCredential}.
   *
   * @param userCredential - The user credential.
   */
  static credentialFromResult(userCredential) {
    return GoogleAuthProvider.credentialFromTaggedObject(userCredential);
  }
  /**
   * Used to extract the underlying {@link OAuthCredential} from a {@link AuthError} which was
   * thrown during a sign-in, link, or reauthenticate operation.
   *
   * @param userCredential - The user credential.
   */
  static credentialFromError(error) {
    return GoogleAuthProvider.credentialFromTaggedObject(
      error.customData || {}
    );
  }
  static credentialFromTaggedObject({ _tokenResponse: tokenResponse }) {
    if (!tokenResponse) {
      return null;
    }
    const { oauthIdToken, oauthAccessToken } = tokenResponse;
    if (!oauthIdToken && !oauthAccessToken) {
      return null;
    }
    try {
      return GoogleAuthProvider.credential(oauthIdToken, oauthAccessToken);
    } catch (_a2) {
      return null;
    }
  }
}
GoogleAuthProvider.GOOGLE_SIGN_IN_METHOD = "google.com";
GoogleAuthProvider.PROVIDER_ID = "google.com";
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class GithubAuthProvider extends BaseOAuthProvider {
  constructor() {
    super(
      "github.com"
      /* ProviderId.GITHUB */
    );
  }
  /**
   * Creates a credential for Github.
   *
   * @param accessToken - Github access token.
   */
  static credential(accessToken) {
    return OAuthCredential._fromParams({
      providerId: GithubAuthProvider.PROVIDER_ID,
      signInMethod: GithubAuthProvider.GITHUB_SIGN_IN_METHOD,
      accessToken,
    });
  }
  /**
   * Used to extract the underlying {@link OAuthCredential} from a {@link UserCredential}.
   *
   * @param userCredential - The user credential.
   */
  static credentialFromResult(userCredential) {
    return GithubAuthProvider.credentialFromTaggedObject(userCredential);
  }
  /**
   * Used to extract the underlying {@link OAuthCredential} from a {@link AuthError} which was
   * thrown during a sign-in, link, or reauthenticate operation.
   *
   * @param userCredential - The user credential.
   */
  static credentialFromError(error) {
    return GithubAuthProvider.credentialFromTaggedObject(
      error.customData || {}
    );
  }
  static credentialFromTaggedObject({ _tokenResponse: tokenResponse }) {
    if (!tokenResponse || !("oauthAccessToken" in tokenResponse)) {
      return null;
    }
    if (!tokenResponse.oauthAccessToken) {
      return null;
    }
    try {
      return GithubAuthProvider.credential(tokenResponse.oauthAccessToken);
    } catch (_a2) {
      return null;
    }
  }
}
GithubAuthProvider.GITHUB_SIGN_IN_METHOD = "github.com";
GithubAuthProvider.PROVIDER_ID = "github.com";
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class TwitterAuthProvider extends BaseOAuthProvider {
  constructor() {
    super(
      "twitter.com"
      /* ProviderId.TWITTER */
    );
  }
  /**
   * Creates a credential for Twitter.
   *
   * @param token - Twitter access token.
   * @param secret - Twitter secret.
   */
  static credential(token2, secret) {
    return OAuthCredential._fromParams({
      providerId: TwitterAuthProvider.PROVIDER_ID,
      signInMethod: TwitterAuthProvider.TWITTER_SIGN_IN_METHOD,
      oauthToken: token2,
      oauthTokenSecret: secret,
    });
  }
  /**
   * Used to extract the underlying {@link OAuthCredential} from a {@link UserCredential}.
   *
   * @param userCredential - The user credential.
   */
  static credentialFromResult(userCredential) {
    return TwitterAuthProvider.credentialFromTaggedObject(userCredential);
  }
  /**
   * Used to extract the underlying {@link OAuthCredential} from a {@link AuthError} which was
   * thrown during a sign-in, link, or reauthenticate operation.
   *
   * @param userCredential - The user credential.
   */
  static credentialFromError(error) {
    return TwitterAuthProvider.credentialFromTaggedObject(
      error.customData || {}
    );
  }
  static credentialFromTaggedObject({ _tokenResponse: tokenResponse }) {
    if (!tokenResponse) {
      return null;
    }
    const { oauthAccessToken, oauthTokenSecret } = tokenResponse;
    if (!oauthAccessToken || !oauthTokenSecret) {
      return null;
    }
    try {
      return TwitterAuthProvider.credential(oauthAccessToken, oauthTokenSecret);
    } catch (_a2) {
      return null;
    }
  }
}
TwitterAuthProvider.TWITTER_SIGN_IN_METHOD = "twitter.com";
TwitterAuthProvider.PROVIDER_ID = "twitter.com";
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
async function signUp(auth2, request) {
  return _performSignInRequest(
    auth2,
    "POST",
    "/v1/accounts:signUp",
    _addTidIfNecessary(auth2, request)
  );
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class UserCredentialImpl {
  constructor(params) {
    this.user = params.user;
    this.providerId = params.providerId;
    this._tokenResponse = params._tokenResponse;
    this.operationType = params.operationType;
  }
  static async _fromIdTokenResponse(
    auth2,
    operationType,
    idTokenResponse,
    isAnonymous = false
  ) {
    const user = await UserImpl._fromIdTokenResponse(
      auth2,
      idTokenResponse,
      isAnonymous
    );
    const providerId = providerIdForResponse(idTokenResponse);
    const userCred = new UserCredentialImpl({
      user,
      providerId,
      _tokenResponse: idTokenResponse,
      operationType,
    });
    return userCred;
  }
  static async _forOperation(user, operationType, response) {
    await user._updateTokensIfNecessary(
      response,
      /* reload */
      true
    );
    const providerId = providerIdForResponse(response);
    return new UserCredentialImpl({
      user,
      providerId,
      _tokenResponse: response,
      operationType,
    });
  }
}
function providerIdForResponse(response) {
  if (response.providerId) {
    return response.providerId;
  }
  if ("phoneNumber" in response) {
    return "phone";
  }
  return null;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
async function signInAnonymously(auth2) {
  var _a2;
  if (_isFirebaseServerApp(auth2.app)) {
    return Promise.reject(
      _serverAppCurrentUserOperationNotSupportedError(auth2)
    );
  }
  const authInternal = _castAuth(auth2);
  await authInternal._initializationPromise;
  if (
    (_a2 = authInternal.currentUser) === null || _a2 === void 0
      ? void 0
      : _a2.isAnonymous
  ) {
    return new UserCredentialImpl({
      user: authInternal.currentUser,
      providerId: null,
      operationType: "signIn",
      /* OperationType.SIGN_IN */
    });
  }
  const response = await signUp(authInternal, {
    returnSecureToken: true,
  });
  const userCredential = await UserCredentialImpl._fromIdTokenResponse(
    authInternal,
    "signIn",
    response,
    true
  );
  await authInternal._updateCurrentUser(userCredential.user);
  return userCredential;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class MultiFactorError extends FirebaseError {
  constructor(auth2, error, operationType, user) {
    var _a2;
    super(error.code, error.message);
    this.operationType = operationType;
    this.user = user;
    Object.setPrototypeOf(this, MultiFactorError.prototype);
    this.customData = {
      appName: auth2.name,
      tenantId:
        (_a2 = auth2.tenantId) !== null && _a2 !== void 0 ? _a2 : void 0,
      _serverResponse: error.customData._serverResponse,
      operationType,
    };
  }
  static _fromErrorAndOperation(auth2, error, operationType, user) {
    return new MultiFactorError(auth2, error, operationType, user);
  }
}
function _processCredentialSavingMfaContextIfNecessary(
  auth2,
  operationType,
  credential,
  user
) {
  const idTokenProvider =
    operationType === "reauthenticate"
      ? credential._getReauthenticationResolver(auth2)
      : credential._getIdTokenResponse(auth2);
  return idTokenProvider.catch((error) => {
    if (error.code === `auth/${"multi-factor-auth-required"}`) {
      throw MultiFactorError._fromErrorAndOperation(
        auth2,
        error,
        operationType,
        user
      );
    }
    throw error;
  });
}
async function _link$1(user, credential, bypassAuthState = false) {
  const response = await _logoutIfInvalidated(
    user,
    credential._linkToIdToken(user.auth, await user.getIdToken()),
    bypassAuthState
  );
  return UserCredentialImpl._forOperation(user, "link", response);
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
async function _reauthenticate(user, credential, bypassAuthState = false) {
  const { auth: auth2 } = user;
  if (_isFirebaseServerApp(auth2.app)) {
    return Promise.reject(
      _serverAppCurrentUserOperationNotSupportedError(auth2)
    );
  }
  const operationType = "reauthenticate";
  try {
    const response = await _logoutIfInvalidated(
      user,
      _processCredentialSavingMfaContextIfNecessary(
        auth2,
        operationType,
        credential,
        user
      ),
      bypassAuthState
    );
    _assert(
      response.idToken,
      auth2,
      "internal-error"
      /* AuthErrorCode.INTERNAL_ERROR */
    );
    const parsed = _parseToken(response.idToken);
    _assert(
      parsed,
      auth2,
      "internal-error"
      /* AuthErrorCode.INTERNAL_ERROR */
    );
    const { sub: localId } = parsed;
    _assert(
      user.uid === localId,
      auth2,
      "user-mismatch"
      /* AuthErrorCode.USER_MISMATCH */
    );
    return UserCredentialImpl._forOperation(user, operationType, response);
  } catch (e) {
    if (
      (e === null || e === void 0 ? void 0 : e.code) ===
      `auth/${"user-not-found"}`
    ) {
      _fail(
        auth2,
        "user-mismatch"
        /* AuthErrorCode.USER_MISMATCH */
      );
    }
    throw e;
  }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
async function _signInWithCredential(
  auth2,
  credential,
  bypassAuthState = false
) {
  if (_isFirebaseServerApp(auth2.app)) {
    return Promise.reject(
      _serverAppCurrentUserOperationNotSupportedError(auth2)
    );
  }
  const operationType = "signIn";
  const response = await _processCredentialSavingMfaContextIfNecessary(
    auth2,
    operationType,
    credential
  );
  const userCredential = await UserCredentialImpl._fromIdTokenResponse(
    auth2,
    operationType,
    response
  );
  if (!bypassAuthState) {
    await auth2._updateCurrentUser(userCredential.user);
  }
  return userCredential;
}
function onIdTokenChanged(auth2, nextOrObserver, error, completed) {
  return getModularInstance(auth2).onIdTokenChanged(
    nextOrObserver,
    error,
    completed
  );
}
function beforeAuthStateChanged(auth2, callback, onAbort) {
  return getModularInstance(auth2).beforeAuthStateChanged(callback, onAbort);
}
const STORAGE_AVAILABLE_KEY = "__sak";
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class BrowserPersistenceClass {
  constructor(storageRetriever, type3) {
    this.storageRetriever = storageRetriever;
    this.type = type3;
  }
  _isAvailable() {
    try {
      if (!this.storage) {
        return Promise.resolve(false);
      }
      this.storage.setItem(STORAGE_AVAILABLE_KEY, "1");
      this.storage.removeItem(STORAGE_AVAILABLE_KEY);
      return Promise.resolve(true);
    } catch (_a2) {
      return Promise.resolve(false);
    }
  }
  _set(key, value) {
    this.storage.setItem(key, JSON.stringify(value));
    return Promise.resolve();
  }
  _get(key) {
    const json = this.storage.getItem(key);
    return Promise.resolve(json ? JSON.parse(json) : null);
  }
  _remove(key) {
    this.storage.removeItem(key);
    return Promise.resolve();
  }
  get storage() {
    return this.storageRetriever();
  }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function _iframeCannotSyncWebStorage() {
  const ua2 = getUA();
  return _isSafari(ua2) || _isIOS(ua2);
}
const _POLLING_INTERVAL_MS$1 = 1e3;
const IE10_LOCAL_STORAGE_SYNC_DELAY = 10;
class BrowserLocalPersistence extends BrowserPersistenceClass {
  constructor() {
    super(
      () => window.localStorage,
      "LOCAL"
      /* PersistenceType.LOCAL */
    );
    this.boundEventHandler = (event, poll) => this.onStorageEvent(event, poll);
    this.listeners = {};
    this.localCache = {};
    this.pollTimer = null;
    this.safariLocalStorageNotSynced =
      _iframeCannotSyncWebStorage() && _isIframe();
    this.fallbackToPolling = _isMobileBrowser();
    this._shouldAllowMigration = true;
  }
  forAllChangedKeys(cb2) {
    for (const key of Object.keys(this.listeners)) {
      const newValue = this.storage.getItem(key);
      const oldValue = this.localCache[key];
      if (newValue !== oldValue) {
        cb2(key, oldValue, newValue);
      }
    }
  }
  onStorageEvent(event, poll = false) {
    if (!event.key) {
      this.forAllChangedKeys((key2, _oldValue, newValue) => {
        this.notifyListeners(key2, newValue);
      });
      return;
    }
    const key = event.key;
    if (poll) {
      this.detachListener();
    } else {
      this.stopPolling();
    }
    if (this.safariLocalStorageNotSynced) {
      const storedValue2 = this.storage.getItem(key);
      if (event.newValue !== storedValue2) {
        if (event.newValue !== null) {
          this.storage.setItem(key, event.newValue);
        } else {
          this.storage.removeItem(key);
        }
      } else if (this.localCache[key] === event.newValue && !poll) {
        return;
      }
    }
    const triggerListeners = () => {
      const storedValue2 = this.storage.getItem(key);
      if (!poll && this.localCache[key] === storedValue2) {
        return;
      }
      this.notifyListeners(key, storedValue2);
    };
    const storedValue = this.storage.getItem(key);
    if (
      _isIE10() &&
      storedValue !== event.newValue &&
      event.newValue !== event.oldValue
    ) {
      setTimeout(triggerListeners, IE10_LOCAL_STORAGE_SYNC_DELAY);
    } else {
      triggerListeners();
    }
  }
  notifyListeners(key, value) {
    this.localCache[key] = value;
    const listeners = this.listeners[key];
    if (listeners) {
      for (const listener of Array.from(listeners)) {
        listener(value ? JSON.parse(value) : value);
      }
    }
  }
  startPolling() {
    this.stopPolling();
    this.pollTimer = setInterval(() => {
      this.forAllChangedKeys((key, oldValue, newValue) => {
        this.onStorageEvent(
          new StorageEvent("storage", {
            key,
            oldValue,
            newValue,
          }),
          /* poll */
          true
        );
      });
    }, _POLLING_INTERVAL_MS$1);
  }
  stopPolling() {
    if (this.pollTimer) {
      clearInterval(this.pollTimer);
      this.pollTimer = null;
    }
  }
  attachListener() {
    window.addEventListener("storage", this.boundEventHandler);
  }
  detachListener() {
    window.removeEventListener("storage", this.boundEventHandler);
  }
  _addListener(key, listener) {
    if (Object.keys(this.listeners).length === 0) {
      if (this.fallbackToPolling) {
        this.startPolling();
      } else {
        this.attachListener();
      }
    }
    if (!this.listeners[key]) {
      this.listeners[key] = /* @__PURE__ */ new Set();
      this.localCache[key] = this.storage.getItem(key);
    }
    this.listeners[key].add(listener);
  }
  _removeListener(key, listener) {
    if (this.listeners[key]) {
      this.listeners[key].delete(listener);
      if (this.listeners[key].size === 0) {
        delete this.listeners[key];
      }
    }
    if (Object.keys(this.listeners).length === 0) {
      this.detachListener();
      this.stopPolling();
    }
  }
  // Update local cache on base operations:
  async _set(key, value) {
    await super._set(key, value);
    this.localCache[key] = JSON.stringify(value);
  }
  async _get(key) {
    const value = await super._get(key);
    this.localCache[key] = JSON.stringify(value);
    return value;
  }
  async _remove(key) {
    await super._remove(key);
    delete this.localCache[key];
  }
}
BrowserLocalPersistence.type = "LOCAL";
const browserLocalPersistence = BrowserLocalPersistence;
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class BrowserSessionPersistence extends BrowserPersistenceClass {
  constructor() {
    super(
      () => window.sessionStorage,
      "SESSION"
      /* PersistenceType.SESSION */
    );
  }
  _addListener(_key, _listener) {
    return;
  }
  _removeListener(_key, _listener) {
    return;
  }
}
BrowserSessionPersistence.type = "SESSION";
const browserSessionPersistence = BrowserSessionPersistence;
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function _allSettled(promises) {
  return Promise.all(
    promises.map(async (promise2) => {
      try {
        const value = await promise2;
        return {
          fulfilled: true,
          value,
        };
      } catch (reason) {
        return {
          fulfilled: false,
          reason,
        };
      }
    })
  );
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class Receiver {
  constructor(eventTarget) {
    this.eventTarget = eventTarget;
    this.handlersMap = {};
    this.boundEventHandler = this.handleEvent.bind(this);
  }
  /**
   * Obtain an instance of a Receiver for a given event target, if none exists it will be created.
   *
   * @param eventTarget - An event target (such as window or self) through which the underlying
   * messages will be received.
   */
  static _getInstance(eventTarget) {
    const existingInstance = this.receivers.find((receiver) =>
      receiver.isListeningto(eventTarget)
    );
    if (existingInstance) {
      return existingInstance;
    }
    const newInstance = new Receiver(eventTarget);
    this.receivers.push(newInstance);
    return newInstance;
  }
  isListeningto(eventTarget) {
    return this.eventTarget === eventTarget;
  }
  /**
   * Fans out a MessageEvent to the appropriate listeners.
   *
   * @remarks
   * Sends an {@link Status.ACK} upon receipt and a {@link Status.DONE} once all handlers have
   * finished processing.
   *
   * @param event - The MessageEvent.
   *
   */
  async handleEvent(event) {
    const messageEvent = event;
    const { eventId, eventType, data } = messageEvent.data;
    const handlers2 = this.handlersMap[eventType];
    if (
      !(handlers2 === null || handlers2 === void 0 ? void 0 : handlers2.size)
    ) {
      return;
    }
    messageEvent.ports[0].postMessage({
      status: "ack",
      eventId,
      eventType,
    });
    const promises = Array.from(handlers2).map(async (handler) =>
      handler(messageEvent.origin, data)
    );
    const response = await _allSettled(promises);
    messageEvent.ports[0].postMessage({
      status: "done",
      eventId,
      eventType,
      response,
    });
  }
  /**
   * Subscribe an event handler for a particular event.
   *
   * @param eventType - Event name to subscribe to.
   * @param eventHandler - The event handler which should receive the events.
   *
   */
  _subscribe(eventType, eventHandler) {
    if (Object.keys(this.handlersMap).length === 0) {
      this.eventTarget.addEventListener("message", this.boundEventHandler);
    }
    if (!this.handlersMap[eventType]) {
      this.handlersMap[eventType] = /* @__PURE__ */ new Set();
    }
    this.handlersMap[eventType].add(eventHandler);
  }
  /**
   * Unsubscribe an event handler from a particular event.
   *
   * @param eventType - Event name to unsubscribe from.
   * @param eventHandler - Optinoal event handler, if none provided, unsubscribe all handlers on this event.
   *
   */
  _unsubscribe(eventType, eventHandler) {
    if (this.handlersMap[eventType] && eventHandler) {
      this.handlersMap[eventType].delete(eventHandler);
    }
    if (!eventHandler || this.handlersMap[eventType].size === 0) {
      delete this.handlersMap[eventType];
    }
    if (Object.keys(this.handlersMap).length === 0) {
      this.eventTarget.removeEventListener("message", this.boundEventHandler);
    }
  }
}
Receiver.receivers = [];
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function _generateEventId(prefix = "", digits = 10) {
  let random = "";
  for (let i = 0; i < digits; i++) {
    random += Math.floor(Math.random() * 10);
  }
  return prefix + random;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class Sender {
  constructor(target) {
    this.target = target;
    this.handlers = /* @__PURE__ */ new Set();
  }
  /**
   * Unsubscribe the handler and remove it from our tracking Set.
   *
   * @param handler - The handler to unsubscribe.
   */
  removeMessageHandler(handler) {
    if (handler.messageChannel) {
      handler.messageChannel.port1.removeEventListener(
        "message",
        handler.onMessage
      );
      handler.messageChannel.port1.close();
    }
    this.handlers.delete(handler);
  }
  /**
   * Send a message to the Receiver located at {@link target}.
   *
   * @remarks
   * We'll first wait a bit for an ACK , if we get one we will wait significantly longer until the
   * receiver has had a chance to fully process the event.
   *
   * @param eventType - Type of event to send.
   * @param data - The payload of the event.
   * @param timeout - Timeout for waiting on an ACK from the receiver.
   *
   * @returns An array of settled promises from all the handlers that were listening on the receiver.
   */
  async _send(eventType, data, timeout = 50) {
    const messageChannel =
      typeof MessageChannel !== "undefined" ? new MessageChannel() : null;
    if (!messageChannel) {
      throw new Error(
        "connection_unavailable"
        /* _MessageError.CONNECTION_UNAVAILABLE */
      );
    }
    let completionTimer;
    let handler;
    return new Promise((resolve, reject3) => {
      const eventId = _generateEventId("", 20);
      messageChannel.port1.start();
      const ackTimer = setTimeout(() => {
        reject3(
          new Error(
            "unsupported_event"
            /* _MessageError.UNSUPPORTED_EVENT */
          )
        );
      }, timeout);
      handler = {
        messageChannel,
        onMessage(event) {
          const messageEvent = event;
          if (messageEvent.data.eventId !== eventId) {
            return;
          }
          switch (messageEvent.data.status) {
            case "ack":
              clearTimeout(ackTimer);
              completionTimer = setTimeout(
                () => {
                  reject3(
                    new Error(
                      "timeout"
                      /* _MessageError.TIMEOUT */
                    )
                  );
                },
                3e3
                /* _TimeoutDuration.COMPLETION */
              );
              break;
            case "done":
              clearTimeout(completionTimer);
              resolve(messageEvent.data.response);
              break;
            default:
              clearTimeout(ackTimer);
              clearTimeout(completionTimer);
              reject3(
                new Error(
                  "invalid_response"
                  /* _MessageError.INVALID_RESPONSE */
                )
              );
              break;
          }
        },
      };
      this.handlers.add(handler);
      messageChannel.port1.addEventListener("message", handler.onMessage);
      this.target.postMessage(
        {
          eventType,
          eventId,
          data,
        },
        [messageChannel.port2]
      );
    }).finally(() => {
      if (handler) {
        this.removeMessageHandler(handler);
      }
    });
  }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function _window() {
  return window;
}
function _setWindowLocation(url) {
  _window().location.href = url;
}
/**
 * @license
 * Copyright 2020 Google LLC.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function _isWorker() {
  return (
    typeof _window()["WorkerGlobalScope"] !== "undefined" &&
    typeof _window()["importScripts"] === "function"
  );
}
async function _getActiveServiceWorker() {
  if (
    !(navigator === null || navigator === void 0
      ? void 0
      : navigator.serviceWorker)
  ) {
    return null;
  }
  try {
    const registration = await navigator.serviceWorker.ready;
    return registration.active;
  } catch (_a2) {
    return null;
  }
}
function _getServiceWorkerController() {
  var _a2;
  return (
    ((_a2 =
      navigator === null || navigator === void 0
        ? void 0
        : navigator.serviceWorker) === null || _a2 === void 0
      ? void 0
      : _a2.controller) || null
  );
}
function _getWorkerGlobalScope() {
  return _isWorker() ? self : null;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const DB_NAME = "firebaseLocalStorageDb";
const DB_VERSION = 1;
const DB_OBJECTSTORE_NAME = "firebaseLocalStorage";
const DB_DATA_KEYPATH = "fbase_key";
class DBPromise {
  constructor(request) {
    this.request = request;
  }
  toPromise() {
    return new Promise((resolve, reject3) => {
      this.request.addEventListener("success", () => {
        resolve(this.request.result);
      });
      this.request.addEventListener("error", () => {
        reject3(this.request.error);
      });
    });
  }
}
function getObjectStore(db2, isReadWrite) {
  return db2
    .transaction([DB_OBJECTSTORE_NAME], isReadWrite ? "readwrite" : "readonly")
    .objectStore(DB_OBJECTSTORE_NAME);
}
function _deleteDatabase() {
  const request = indexedDB.deleteDatabase(DB_NAME);
  return new DBPromise(request).toPromise();
}
function _openDatabase() {
  const request = indexedDB.open(DB_NAME, DB_VERSION);
  return new Promise((resolve, reject3) => {
    request.addEventListener("error", () => {
      reject3(request.error);
    });
    request.addEventListener("upgradeneeded", () => {
      const db2 = request.result;
      try {
        db2.createObjectStore(DB_OBJECTSTORE_NAME, {
          keyPath: DB_DATA_KEYPATH,
        });
      } catch (e) {
        reject3(e);
      }
    });
    request.addEventListener("success", async () => {
      const db2 = request.result;
      if (!db2.objectStoreNames.contains(DB_OBJECTSTORE_NAME)) {
        db2.close();
        await _deleteDatabase();
        resolve(await _openDatabase());
      } else {
        resolve(db2);
      }
    });
  });
}
async function _putObject(db2, key, value) {
  const request = getObjectStore(db2, true).put({
    [DB_DATA_KEYPATH]: key,
    value,
  });
  return new DBPromise(request).toPromise();
}
async function getObject(db2, key) {
  const request = getObjectStore(db2, false).get(key);
  const data = await new DBPromise(request).toPromise();
  return data === void 0 ? null : data.value;
}
function _deleteObject(db2, key) {
  const request = getObjectStore(db2, true).delete(key);
  return new DBPromise(request).toPromise();
}
const _POLLING_INTERVAL_MS = 800;
const _TRANSACTION_RETRY_COUNT = 3;
class IndexedDBLocalPersistence {
  constructor() {
    this.type = "LOCAL";
    this._shouldAllowMigration = true;
    this.listeners = {};
    this.localCache = {};
    this.pollTimer = null;
    this.pendingWrites = 0;
    this.receiver = null;
    this.sender = null;
    this.serviceWorkerReceiverAvailable = false;
    this.activeServiceWorker = null;
    this._workerInitializationPromise =
      this.initializeServiceWorkerMessaging().then(
        () => {},
        () => {}
      );
  }
  async _openDb() {
    if (this.db) {
      return this.db;
    }
    this.db = await _openDatabase();
    return this.db;
  }
  async _withRetries(op) {
    let numAttempts = 0;
    while (true) {
      try {
        const db2 = await this._openDb();
        return await op(db2);
      } catch (e) {
        if (numAttempts++ > _TRANSACTION_RETRY_COUNT) {
          throw e;
        }
        if (this.db) {
          this.db.close();
          this.db = void 0;
        }
      }
    }
  }
  /**
   * IndexedDB events do not propagate from the main window to the worker context.  We rely on a
   * postMessage interface to send these events to the worker ourselves.
   */
  async initializeServiceWorkerMessaging() {
    return _isWorker() ? this.initializeReceiver() : this.initializeSender();
  }
  /**
   * As the worker we should listen to events from the main window.
   */
  async initializeReceiver() {
    this.receiver = Receiver._getInstance(_getWorkerGlobalScope());
    this.receiver._subscribe("keyChanged", async (_origin, data) => {
      const keys4 = await this._poll();
      return {
        keyProcessed: keys4.includes(data.key),
      };
    });
    this.receiver._subscribe("ping", async (_origin, _data) => {
      return [
        "keyChanged",
        /* _EventType.KEY_CHANGED */
      ];
    });
  }
  /**
   * As the main window, we should let the worker know when keys change (set and remove).
   *
   * @remarks
   * {@link https://developer.mozilla.org/en-US/docs/Web/API/ServiceWorkerContainer/ready | ServiceWorkerContainer.ready}
   * may not resolve.
   */
  async initializeSender() {
    var _a2, _b2;
    this.activeServiceWorker = await _getActiveServiceWorker();
    if (!this.activeServiceWorker) {
      return;
    }
    this.sender = new Sender(this.activeServiceWorker);
    const results = await this.sender._send(
      "ping",
      {},
      800
      /* _TimeoutDuration.LONG_ACK */
    );
    if (!results) {
      return;
    }
    if (
      ((_a2 = results[0]) === null || _a2 === void 0
        ? void 0
        : _a2.fulfilled) &&
      ((_b2 = results[0]) === null || _b2 === void 0
        ? void 0
        : _b2.value.includes(
            "keyChanged"
            /* _EventType.KEY_CHANGED */
          ))
    ) {
      this.serviceWorkerReceiverAvailable = true;
    }
  }
  /**
   * Let the worker know about a changed key, the exact key doesn't technically matter since the
   * worker will just trigger a full sync anyway.
   *
   * @remarks
   * For now, we only support one service worker per page.
   *
   * @param key - Storage key which changed.
   */
  async notifyServiceWorker(key) {
    if (
      !this.sender ||
      !this.activeServiceWorker ||
      _getServiceWorkerController() !== this.activeServiceWorker
    ) {
      return;
    }
    try {
      await this.sender._send(
        "keyChanged",
        { key },
        // Use long timeout if receiver has previously responded to a ping from us.
        this.serviceWorkerReceiverAvailable ? 800 : 50
        /* _TimeoutDuration.ACK */
      );
    } catch (_a2) {}
  }
  async _isAvailable() {
    try {
      if (!indexedDB) {
        return false;
      }
      const db2 = await _openDatabase();
      await _putObject(db2, STORAGE_AVAILABLE_KEY, "1");
      await _deleteObject(db2, STORAGE_AVAILABLE_KEY);
      return true;
    } catch (_a2) {}
    return false;
  }
  async _withPendingWrite(write) {
    this.pendingWrites++;
    try {
      await write();
    } finally {
      this.pendingWrites--;
    }
  }
  async _set(key, value) {
    return this._withPendingWrite(async () => {
      await this._withRetries((db2) => _putObject(db2, key, value));
      this.localCache[key] = value;
      return this.notifyServiceWorker(key);
    });
  }
  async _get(key) {
    const obj = await this._withRetries((db2) => getObject(db2, key));
    this.localCache[key] = obj;
    return obj;
  }
  async _remove(key) {
    return this._withPendingWrite(async () => {
      await this._withRetries((db2) => _deleteObject(db2, key));
      delete this.localCache[key];
      return this.notifyServiceWorker(key);
    });
  }
  async _poll() {
    const result = await this._withRetries((db2) => {
      const getAllRequest = getObjectStore(db2, false).getAll();
      return new DBPromise(getAllRequest).toPromise();
    });
    if (!result) {
      return [];
    }
    if (this.pendingWrites !== 0) {
      return [];
    }
    const keys4 = [];
    const keysInResult = /* @__PURE__ */ new Set();
    if (result.length !== 0) {
      for (const { fbase_key: key, value } of result) {
        keysInResult.add(key);
        if (JSON.stringify(this.localCache[key]) !== JSON.stringify(value)) {
          this.notifyListeners(key, value);
          keys4.push(key);
        }
      }
    }
    for (const localKey of Object.keys(this.localCache)) {
      if (this.localCache[localKey] && !keysInResult.has(localKey)) {
        this.notifyListeners(localKey, null);
        keys4.push(localKey);
      }
    }
    return keys4;
  }
  notifyListeners(key, newValue) {
    this.localCache[key] = newValue;
    const listeners = this.listeners[key];
    if (listeners) {
      for (const listener of Array.from(listeners)) {
        listener(newValue);
      }
    }
  }
  startPolling() {
    this.stopPolling();
    this.pollTimer = setInterval(
      async () => this._poll(),
      _POLLING_INTERVAL_MS
    );
  }
  stopPolling() {
    if (this.pollTimer) {
      clearInterval(this.pollTimer);
      this.pollTimer = null;
    }
  }
  _addListener(key, listener) {
    if (Object.keys(this.listeners).length === 0) {
      this.startPolling();
    }
    if (!this.listeners[key]) {
      this.listeners[key] = /* @__PURE__ */ new Set();
      void this._get(key);
    }
    this.listeners[key].add(listener);
  }
  _removeListener(key, listener) {
    if (this.listeners[key]) {
      this.listeners[key].delete(listener);
      if (this.listeners[key].size === 0) {
        delete this.listeners[key];
      }
    }
    if (Object.keys(this.listeners).length === 0) {
      this.stopPolling();
    }
  }
}
IndexedDBLocalPersistence.type = "LOCAL";
const indexedDBLocalPersistence = IndexedDBLocalPersistence;
new Delay(3e4, 6e4);
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function _withDefaultResolver(auth2, resolverOverride) {
  if (resolverOverride) {
    return _getInstance(resolverOverride);
  }
  _assert(
    auth2._popupRedirectResolver,
    auth2,
    "argument-error"
    /* AuthErrorCode.ARGUMENT_ERROR */
  );
  return auth2._popupRedirectResolver;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class IdpCredential extends AuthCredential {
  constructor(params) {
    super(
      "custom",
      "custom"
      /* ProviderId.CUSTOM */
    );
    this.params = params;
  }
  _getIdTokenResponse(auth2) {
    return signInWithIdp(auth2, this._buildIdpRequest());
  }
  _linkToIdToken(auth2, idToken) {
    return signInWithIdp(auth2, this._buildIdpRequest(idToken));
  }
  _getReauthenticationResolver(auth2) {
    return signInWithIdp(auth2, this._buildIdpRequest());
  }
  _buildIdpRequest(idToken) {
    const request = {
      requestUri: this.params.requestUri,
      sessionId: this.params.sessionId,
      postBody: this.params.postBody,
      tenantId: this.params.tenantId,
      pendingToken: this.params.pendingToken,
      returnSecureToken: true,
      returnIdpCredential: true,
    };
    if (idToken) {
      request.idToken = idToken;
    }
    return request;
  }
}
function _signIn(params) {
  return _signInWithCredential(
    params.auth,
    new IdpCredential(params),
    params.bypassAuthState
  );
}
function _reauth(params) {
  const { auth: auth2, user } = params;
  _assert(
    user,
    auth2,
    "internal-error"
    /* AuthErrorCode.INTERNAL_ERROR */
  );
  return _reauthenticate(
    user,
    new IdpCredential(params),
    params.bypassAuthState
  );
}
async function _link(params) {
  const { auth: auth2, user } = params;
  _assert(
    user,
    auth2,
    "internal-error"
    /* AuthErrorCode.INTERNAL_ERROR */
  );
  return _link$1(user, new IdpCredential(params), params.bypassAuthState);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class AbstractPopupRedirectOperation {
  constructor(auth2, filter2, resolver, user, bypassAuthState = false) {
    this.auth = auth2;
    this.resolver = resolver;
    this.user = user;
    this.bypassAuthState = bypassAuthState;
    this.pendingPromise = null;
    this.eventManager = null;
    this.filter = Array.isArray(filter2) ? filter2 : [filter2];
  }
  execute() {
    return new Promise(async (resolve, reject3) => {
      this.pendingPromise = { resolve, reject: reject3 };
      try {
        this.eventManager = await this.resolver._initialize(this.auth);
        await this.onExecution();
        this.eventManager.registerConsumer(this);
      } catch (e) {
        this.reject(e);
      }
    });
  }
  async onAuthEvent(event) {
    const {
      urlResponse,
      sessionId,
      postBody,
      tenantId,
      error,
      type: type3,
    } = event;
    if (error) {
      this.reject(error);
      return;
    }
    const params = {
      auth: this.auth,
      requestUri: urlResponse,
      sessionId,
      tenantId: tenantId || void 0,
      postBody: postBody || void 0,
      user: this.user,
      bypassAuthState: this.bypassAuthState,
    };
    try {
      this.resolve(await this.getIdpTask(type3)(params));
    } catch (e) {
      this.reject(e);
    }
  }
  onError(error) {
    this.reject(error);
  }
  getIdpTask(type3) {
    switch (type3) {
      case "signInViaPopup":
      case "signInViaRedirect":
        return _signIn;
      case "linkViaPopup":
      case "linkViaRedirect":
        return _link;
      case "reauthViaPopup":
      case "reauthViaRedirect":
        return _reauth;
      default:
        _fail(
          this.auth,
          "internal-error"
          /* AuthErrorCode.INTERNAL_ERROR */
        );
    }
  }
  resolve(cred) {
    debugAssert(this.pendingPromise, "Pending promise was never set");
    this.pendingPromise.resolve(cred);
    this.unregisterAndCleanUp();
  }
  reject(error) {
    debugAssert(this.pendingPromise, "Pending promise was never set");
    this.pendingPromise.reject(error);
    this.unregisterAndCleanUp();
  }
  unregisterAndCleanUp() {
    if (this.eventManager) {
      this.eventManager.unregisterConsumer(this);
    }
    this.pendingPromise = null;
    this.cleanUp();
  }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const _POLL_WINDOW_CLOSE_TIMEOUT = new Delay(2e3, 1e4);
class PopupOperation extends AbstractPopupRedirectOperation {
  constructor(auth2, filter2, provider, resolver, user) {
    super(auth2, filter2, resolver, user);
    this.provider = provider;
    this.authWindow = null;
    this.pollId = null;
    if (PopupOperation.currentPopupAction) {
      PopupOperation.currentPopupAction.cancel();
    }
    PopupOperation.currentPopupAction = this;
  }
  async executeNotNull() {
    const result = await this.execute();
    _assert(
      result,
      this.auth,
      "internal-error"
      /* AuthErrorCode.INTERNAL_ERROR */
    );
    return result;
  }
  async onExecution() {
    debugAssert(
      this.filter.length === 1,
      "Popup operations only handle one event"
    );
    const eventId = _generateEventId();
    this.authWindow = await this.resolver._openPopup(
      this.auth,
      this.provider,
      this.filter[0],
      // There's always one, see constructor
      eventId
    );
    this.authWindow.associatedEvent = eventId;
    this.resolver._originValidation(this.auth).catch((e) => {
      this.reject(e);
    });
    this.resolver._isIframeWebStorageSupported(this.auth, (isSupported) => {
      if (!isSupported) {
        this.reject(
          _createError(
            this.auth,
            "web-storage-unsupported"
            /* AuthErrorCode.WEB_STORAGE_UNSUPPORTED */
          )
        );
      }
    });
    this.pollUserCancellation();
  }
  get eventId() {
    var _a2;
    return (
      ((_a2 = this.authWindow) === null || _a2 === void 0
        ? void 0
        : _a2.associatedEvent) || null
    );
  }
  cancel() {
    this.reject(
      _createError(
        this.auth,
        "cancelled-popup-request"
        /* AuthErrorCode.EXPIRED_POPUP_REQUEST */
      )
    );
  }
  cleanUp() {
    if (this.authWindow) {
      this.authWindow.close();
    }
    if (this.pollId) {
      window.clearTimeout(this.pollId);
    }
    this.authWindow = null;
    this.pollId = null;
    PopupOperation.currentPopupAction = null;
  }
  pollUserCancellation() {
    const poll = () => {
      var _a2, _b2;
      if (
        (_b2 =
          (_a2 = this.authWindow) === null || _a2 === void 0
            ? void 0
            : _a2.window) === null || _b2 === void 0
          ? void 0
          : _b2.closed
      ) {
        this.pollId = window.setTimeout(
          () => {
            this.pollId = null;
            this.reject(
              _createError(
                this.auth,
                "popup-closed-by-user"
                /* AuthErrorCode.POPUP_CLOSED_BY_USER */
              )
            );
          },
          8e3
          /* _Timeout.AUTH_EVENT */
        );
        return;
      }
      this.pollId = window.setTimeout(poll, _POLL_WINDOW_CLOSE_TIMEOUT.get());
    };
    poll();
  }
}
PopupOperation.currentPopupAction = null;
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const PENDING_REDIRECT_KEY = "pendingRedirect";
const redirectOutcomeMap = /* @__PURE__ */ new Map();
class RedirectAction extends AbstractPopupRedirectOperation {
  constructor(auth2, resolver, bypassAuthState = false) {
    super(
      auth2,
      [
        "signInViaRedirect",
        "linkViaRedirect",
        "reauthViaRedirect",
        "unknown",
        /* AuthEventType.UNKNOWN */
      ],
      resolver,
      void 0,
      bypassAuthState
    );
    this.eventId = null;
  }
  /**
   * Override the execute function; if we already have a redirect result, then
   * just return it.
   */
  async execute() {
    let readyOutcome = redirectOutcomeMap.get(this.auth._key());
    if (!readyOutcome) {
      try {
        const hasPendingRedirect = await _getAndClearPendingRedirectStatus(
          this.resolver,
          this.auth
        );
        const result = hasPendingRedirect ? await super.execute() : null;
        readyOutcome = () => Promise.resolve(result);
      } catch (e) {
        readyOutcome = () => Promise.reject(e);
      }
      redirectOutcomeMap.set(this.auth._key(), readyOutcome);
    }
    if (!this.bypassAuthState) {
      redirectOutcomeMap.set(this.auth._key(), () => Promise.resolve(null));
    }
    return readyOutcome();
  }
  async onAuthEvent(event) {
    if (event.type === "signInViaRedirect") {
      return super.onAuthEvent(event);
    } else if (event.type === "unknown") {
      this.resolve(null);
      return;
    }
    if (event.eventId) {
      const user = await this.auth._redirectUserForId(event.eventId);
      if (user) {
        this.user = user;
        return super.onAuthEvent(event);
      } else {
        this.resolve(null);
      }
    }
  }
  async onExecution() {}
  cleanUp() {}
}
async function _getAndClearPendingRedirectStatus(resolver, auth2) {
  const key = pendingRedirectKey(auth2);
  const persistence = resolverPersistence(resolver);
  if (!(await persistence._isAvailable())) {
    return false;
  }
  const hasPendingRedirect = (await persistence._get(key)) === "true";
  await persistence._remove(key);
  return hasPendingRedirect;
}
function _overrideRedirectResult(auth2, result) {
  redirectOutcomeMap.set(auth2._key(), result);
}
function resolverPersistence(resolver) {
  return _getInstance(resolver._redirectPersistence);
}
function pendingRedirectKey(auth2) {
  return _persistenceKeyName(
    PENDING_REDIRECT_KEY,
    auth2.config.apiKey,
    auth2.name
  );
}
async function _getRedirectResult(
  auth2,
  resolverExtern,
  bypassAuthState = false
) {
  if (_isFirebaseServerApp(auth2.app)) {
    return Promise.reject(
      _serverAppCurrentUserOperationNotSupportedError(auth2)
    );
  }
  const authInternal = _castAuth(auth2);
  const resolver = _withDefaultResolver(authInternal, resolverExtern);
  const action = new RedirectAction(authInternal, resolver, bypassAuthState);
  const result = await action.execute();
  if (result && !bypassAuthState) {
    delete result.user._redirectEventId;
    await authInternal._persistUserIfCurrent(result.user);
    await authInternal._setRedirectUser(null, resolverExtern);
  }
  return result;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const EVENT_DUPLICATION_CACHE_DURATION_MS = 10 * 60 * 1e3;
class AuthEventManager {
  constructor(auth2) {
    this.auth = auth2;
    this.cachedEventUids = /* @__PURE__ */ new Set();
    this.consumers = /* @__PURE__ */ new Set();
    this.queuedRedirectEvent = null;
    this.hasHandledPotentialRedirect = false;
    this.lastProcessedEventTime = Date.now();
  }
  registerConsumer(authEventConsumer) {
    this.consumers.add(authEventConsumer);
    if (
      this.queuedRedirectEvent &&
      this.isEventForConsumer(this.queuedRedirectEvent, authEventConsumer)
    ) {
      this.sendToConsumer(this.queuedRedirectEvent, authEventConsumer);
      this.saveEventToCache(this.queuedRedirectEvent);
      this.queuedRedirectEvent = null;
    }
  }
  unregisterConsumer(authEventConsumer) {
    this.consumers.delete(authEventConsumer);
  }
  onEvent(event) {
    if (this.hasEventBeenHandled(event)) {
      return false;
    }
    let handled = false;
    this.consumers.forEach((consumer) => {
      if (this.isEventForConsumer(event, consumer)) {
        handled = true;
        this.sendToConsumer(event, consumer);
        this.saveEventToCache(event);
      }
    });
    if (this.hasHandledPotentialRedirect || !isRedirectEvent(event)) {
      return handled;
    }
    this.hasHandledPotentialRedirect = true;
    if (!handled) {
      this.queuedRedirectEvent = event;
      handled = true;
    }
    return handled;
  }
  sendToConsumer(event, consumer) {
    var _a2;
    if (event.error && !isNullRedirectEvent(event)) {
      const code =
        ((_a2 = event.error.code) === null || _a2 === void 0
          ? void 0
          : _a2.split("auth/")[1]) || "internal-error";
      consumer.onError(_createError(this.auth, code));
    } else {
      consumer.onAuthEvent(event);
    }
  }
  isEventForConsumer(event, consumer) {
    const eventIdMatches =
      consumer.eventId === null ||
      (!!event.eventId && event.eventId === consumer.eventId);
    return consumer.filter.includes(event.type) && eventIdMatches;
  }
  hasEventBeenHandled(event) {
    if (
      Date.now() - this.lastProcessedEventTime >=
      EVENT_DUPLICATION_CACHE_DURATION_MS
    ) {
      this.cachedEventUids.clear();
    }
    return this.cachedEventUids.has(eventUid(event));
  }
  saveEventToCache(event) {
    this.cachedEventUids.add(eventUid(event));
    this.lastProcessedEventTime = Date.now();
  }
}
function eventUid(e) {
  return [e.type, e.eventId, e.sessionId, e.tenantId]
    .filter((v2) => v2)
    .join("-");
}
function isNullRedirectEvent({ type: type3, error }) {
  return (
    type3 === "unknown" &&
    (error === null || error === void 0 ? void 0 : error.code) ===
      `auth/${"no-auth-event"}`
  );
}
function isRedirectEvent(event) {
  switch (event.type) {
    case "signInViaRedirect":
    case "linkViaRedirect":
    case "reauthViaRedirect":
      return true;
    case "unknown":
      return isNullRedirectEvent(event);
    default:
      return false;
  }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
async function _getProjectConfig(auth2, request = {}) {
  return _performApiRequest(auth2, "GET", "/v1/projects", request);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const IP_ADDRESS_REGEX = /^\d{1,3}\.\d{1,3}\.\d{1,3}\.\d{1,3}$/;
const HTTP_REGEX = /^https?/;
async function _validateOrigin(auth2) {
  if (auth2.config.emulator) {
    return;
  }
  const { authorizedDomains } = await _getProjectConfig(auth2);
  for (const domain of authorizedDomains) {
    try {
      if (matchDomain(domain)) {
        return;
      }
    } catch (_a2) {}
  }
  _fail(
    auth2,
    "unauthorized-domain"
    /* AuthErrorCode.INVALID_ORIGIN */
  );
}
function matchDomain(expected) {
  const currentUrl = _getCurrentUrl();
  const { protocol, hostname } = new URL(currentUrl);
  if (expected.startsWith("chrome-extension://")) {
    const ceUrl = new URL(expected);
    if (ceUrl.hostname === "" && hostname === "") {
      return (
        protocol === "chrome-extension:" &&
        expected.replace("chrome-extension://", "") ===
          currentUrl.replace("chrome-extension://", "")
      );
    }
    return protocol === "chrome-extension:" && ceUrl.hostname === hostname;
  }
  if (!HTTP_REGEX.test(protocol)) {
    return false;
  }
  if (IP_ADDRESS_REGEX.test(expected)) {
    return hostname === expected;
  }
  const escapedDomainPattern = expected.replace(/\./g, "\\.");
  const re = new RegExp(
    "^(.+\\." + escapedDomainPattern + "|" + escapedDomainPattern + ")$",
    "i"
  );
  return re.test(hostname);
}
/**
 * @license
 * Copyright 2020 Google LLC.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const NETWORK_TIMEOUT = new Delay(3e4, 6e4);
function resetUnloadedGapiModules() {
  const beacon = _window().___jsl;
  if (beacon === null || beacon === void 0 ? void 0 : beacon.H) {
    for (const hint of Object.keys(beacon.H)) {
      beacon.H[hint].r = beacon.H[hint].r || [];
      beacon.H[hint].L = beacon.H[hint].L || [];
      beacon.H[hint].r = [...beacon.H[hint].L];
      if (beacon.CP) {
        for (let i = 0; i < beacon.CP.length; i++) {
          beacon.CP[i] = null;
        }
      }
    }
  }
}
function loadGapi(auth2) {
  return new Promise((resolve, reject3) => {
    var _a2, _b2, _c2;
    function loadGapiIframe() {
      resetUnloadedGapiModules();
      gapi.load("gapi.iframes", {
        callback: () => {
          resolve(gapi.iframes.getContext());
        },
        ontimeout: () => {
          resetUnloadedGapiModules();
          reject3(
            _createError(
              auth2,
              "network-request-failed"
              /* AuthErrorCode.NETWORK_REQUEST_FAILED */
            )
          );
        },
        timeout: NETWORK_TIMEOUT.get(),
      });
    }
    if (
      (_b2 =
        (_a2 = _window().gapi) === null || _a2 === void 0
          ? void 0
          : _a2.iframes) === null || _b2 === void 0
        ? void 0
        : _b2.Iframe
    ) {
      resolve(gapi.iframes.getContext());
    } else if (
      !!((_c2 = _window().gapi) === null || _c2 === void 0 ? void 0 : _c2.load)
    ) {
      loadGapiIframe();
    } else {
      const cbName = _generateCallbackName("iframefcb");
      _window()[cbName] = () => {
        if (!!gapi.load) {
          loadGapiIframe();
        } else {
          reject3(
            _createError(
              auth2,
              "network-request-failed"
              /* AuthErrorCode.NETWORK_REQUEST_FAILED */
            )
          );
        }
      };
      return _loadJS(`${_gapiScriptUrl()}?onload=${cbName}`).catch((e) =>
        reject3(e)
      );
    }
  }).catch((error) => {
    cachedGApiLoader = null;
    throw error;
  });
}
let cachedGApiLoader = null;
function _loadGapi(auth2) {
  cachedGApiLoader = cachedGApiLoader || loadGapi(auth2);
  return cachedGApiLoader;
}
/**
 * @license
 * Copyright 2020 Google LLC.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const PING_TIMEOUT = new Delay(5e3, 15e3);
const IFRAME_PATH = "__/auth/iframe";
const EMULATED_IFRAME_PATH = "emulator/auth/iframe";
const IFRAME_ATTRIBUTES = {
  style: {
    position: "absolute",
    top: "-100px",
    width: "1px",
    height: "1px",
  },
  "aria-hidden": "true",
  tabindex: "-1",
};
const EID_FROM_APIHOST = /* @__PURE__ */ new Map([
  ["identitytoolkit.googleapis.com", "p"],
  ["staging-identitytoolkit.sandbox.googleapis.com", "s"],
  ["test-identitytoolkit.sandbox.googleapis.com", "t"],
  // test
]);
function getIframeUrl(auth2) {
  const config = auth2.config;
  _assert(
    config.authDomain,
    auth2,
    "auth-domain-config-required"
    /* AuthErrorCode.MISSING_AUTH_DOMAIN */
  );
  const url = config.emulator
    ? _emulatorUrl(config, EMULATED_IFRAME_PATH)
    : `https://${auth2.config.authDomain}/${IFRAME_PATH}`;
  const params = {
    apiKey: config.apiKey,
    appName: auth2.name,
    v: SDK_VERSION,
  };
  const eid = EID_FROM_APIHOST.get(auth2.config.apiHost);
  if (eid) {
    params.eid = eid;
  }
  const frameworks = auth2._getFrameworks();
  if (frameworks.length) {
    params.fw = frameworks.join(",");
  }
  return `${url}?${querystring(params).slice(1)}`;
}
async function _openIframe(auth2) {
  const context = await _loadGapi(auth2);
  const gapi2 = _window().gapi;
  _assert(
    gapi2,
    auth2,
    "internal-error"
    /* AuthErrorCode.INTERNAL_ERROR */
  );
  return context.open(
    {
      where: document.body,
      url: getIframeUrl(auth2),
      messageHandlersFilter: gapi2.iframes.CROSS_ORIGIN_IFRAMES_FILTER,
      attributes: IFRAME_ATTRIBUTES,
      dontclear: true,
    },
    (iframe) =>
      new Promise(async (resolve, reject3) => {
        await iframe.restyle({
          // Prevent iframe from closing on mouse out.
          setHideOnLeave: false,
        });
        const networkError = _createError(
          auth2,
          "network-request-failed"
          /* AuthErrorCode.NETWORK_REQUEST_FAILED */
        );
        const networkErrorTimer = _window().setTimeout(() => {
          reject3(networkError);
        }, PING_TIMEOUT.get());
        function clearTimerAndResolve() {
          _window().clearTimeout(networkErrorTimer);
          resolve(iframe);
        }
        iframe.ping(clearTimerAndResolve).then(clearTimerAndResolve, () => {
          reject3(networkError);
        });
      })
  );
}
/**
 * @license
 * Copyright 2020 Google LLC.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const BASE_POPUP_OPTIONS = {
  location: "yes",
  resizable: "yes",
  statusbar: "yes",
  toolbar: "no",
};
const DEFAULT_WIDTH = 500;
const DEFAULT_HEIGHT = 600;
const TARGET_BLANK = "_blank";
const FIREFOX_EMPTY_URL = "http://localhost";
class AuthPopup {
  constructor(window2) {
    this.window = window2;
    this.associatedEvent = null;
  }
  close() {
    if (this.window) {
      try {
        this.window.close();
      } catch (e) {}
    }
  }
}
function _open(
  auth2,
  url,
  name2,
  width = DEFAULT_WIDTH,
  height2 = DEFAULT_HEIGHT
) {
  const top = Math.max((window.screen.availHeight - height2) / 2, 0).toString();
  const left = Math.max((window.screen.availWidth - width) / 2, 0).toString();
  let target = "";
  const options = Object.assign(Object.assign({}, BASE_POPUP_OPTIONS), {
    width: width.toString(),
    height: height2.toString(),
    top,
    left,
  });
  const ua2 = getUA().toLowerCase();
  if (name2) {
    target = _isChromeIOS(ua2) ? TARGET_BLANK : name2;
  }
  if (_isFirefox(ua2)) {
    url = url || FIREFOX_EMPTY_URL;
    options.scrollbars = "yes";
  }
  const optionsString = Object.entries(options).reduce(
    (accum, [key, value]) => `${accum}${key}=${value},`,
    ""
  );
  if (_isIOSStandalone(ua2) && target !== "_self") {
    openAsNewWindowIOS(url || "", target);
    return new AuthPopup(null);
  }
  const newWin = window.open(url || "", target, optionsString);
  _assert(
    newWin,
    auth2,
    "popup-blocked"
    /* AuthErrorCode.POPUP_BLOCKED */
  );
  try {
    newWin.focus();
  } catch (e) {}
  return new AuthPopup(newWin);
}
function openAsNewWindowIOS(url, target) {
  const el = document.createElement("a");
  el.href = url;
  el.target = target;
  const click = document.createEvent("MouseEvent");
  click.initMouseEvent(
    "click",
    true,
    true,
    window,
    1,
    0,
    0,
    0,
    0,
    false,
    false,
    false,
    false,
    1,
    null
  );
  el.dispatchEvent(click);
}
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const WIDGET_PATH = "__/auth/handler";
const EMULATOR_WIDGET_PATH = "emulator/auth/handler";
const FIREBASE_APP_CHECK_FRAGMENT_ID = encodeURIComponent("fac");
async function _getRedirectUrl(
  auth2,
  provider,
  authType,
  redirectUrl,
  eventId,
  additionalParams
) {
  _assert(
    auth2.config.authDomain,
    auth2,
    "auth-domain-config-required"
    /* AuthErrorCode.MISSING_AUTH_DOMAIN */
  );
  _assert(
    auth2.config.apiKey,
    auth2,
    "invalid-api-key"
    /* AuthErrorCode.INVALID_API_KEY */
  );
  const params = {
    apiKey: auth2.config.apiKey,
    appName: auth2.name,
    authType,
    redirectUrl,
    v: SDK_VERSION,
    eventId,
  };
  if (provider instanceof FederatedAuthProvider) {
    provider.setDefaultLanguage(auth2.languageCode);
    params.providerId = provider.providerId || "";
    if (!isEmpty$1(provider.getCustomParameters())) {
      params.customParameters = JSON.stringify(provider.getCustomParameters());
    }
    for (const [key, value] of Object.entries(additionalParams || {})) {
      params[key] = value;
    }
  }
  if (provider instanceof BaseOAuthProvider) {
    const scopes = provider.getScopes().filter((scope) => scope !== "");
    if (scopes.length > 0) {
      params.scopes = scopes.join(",");
    }
  }
  if (auth2.tenantId) {
    params.tid = auth2.tenantId;
  }
  const paramsDict = params;
  for (const key of Object.keys(paramsDict)) {
    if (paramsDict[key] === void 0) {
      delete paramsDict[key];
    }
  }
  const appCheckToken = await auth2._getAppCheckToken();
  const appCheckTokenFragment = appCheckToken
    ? `#${FIREBASE_APP_CHECK_FRAGMENT_ID}=${encodeURIComponent(appCheckToken)}`
    : "";
  return `${getHandlerBase(auth2)}?${querystring(paramsDict).slice(
    1
  )}${appCheckTokenFragment}`;
}
function getHandlerBase({ config }) {
  if (!config.emulator) {
    return `https://${config.authDomain}/${WIDGET_PATH}`;
  }
  return _emulatorUrl(config, EMULATOR_WIDGET_PATH);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const WEB_STORAGE_SUPPORT_KEY = "webStorageSupport";
class BrowserPopupRedirectResolver {
  constructor() {
    this.eventManagers = {};
    this.iframes = {};
    this.originValidationPromises = {};
    this._redirectPersistence = browserSessionPersistence;
    this._completeRedirectFn = _getRedirectResult;
    this._overrideRedirectResult = _overrideRedirectResult;
  }
  // Wrapping in async even though we don't await anywhere in order
  // to make sure errors are raised as promise rejections
  async _openPopup(auth2, provider, authType, eventId) {
    var _a2;
    debugAssert(
      (_a2 = this.eventManagers[auth2._key()]) === null || _a2 === void 0
        ? void 0
        : _a2.manager,
      "_initialize() not called before _openPopup()"
    );
    const url = await _getRedirectUrl(
      auth2,
      provider,
      authType,
      _getCurrentUrl(),
      eventId
    );
    return _open(auth2, url, _generateEventId());
  }
  async _openRedirect(auth2, provider, authType, eventId) {
    await this._originValidation(auth2);
    const url = await _getRedirectUrl(
      auth2,
      provider,
      authType,
      _getCurrentUrl(),
      eventId
    );
    _setWindowLocation(url);
    return new Promise(() => {});
  }
  _initialize(auth2) {
    const key = auth2._key();
    if (this.eventManagers[key]) {
      const { manager, promise: promise3 } = this.eventManagers[key];
      if (manager) {
        return Promise.resolve(manager);
      } else {
        debugAssert(promise3, "If manager is not set, promise should be");
        return promise3;
      }
    }
    const promise2 = this.initAndGetManager(auth2);
    this.eventManagers[key] = { promise: promise2 };
    promise2.catch(() => {
      delete this.eventManagers[key];
    });
    return promise2;
  }
  async initAndGetManager(auth2) {
    const iframe = await _openIframe(auth2);
    const manager = new AuthEventManager(auth2);
    iframe.register(
      "authEvent",
      (iframeEvent) => {
        _assert(
          iframeEvent === null || iframeEvent === void 0
            ? void 0
            : iframeEvent.authEvent,
          auth2,
          "invalid-auth-event"
          /* AuthErrorCode.INVALID_AUTH_EVENT */
        );
        const handled = manager.onEvent(iframeEvent.authEvent);
        return {
          status: handled ? "ACK" : "ERROR",
          /* GapiOutcome.ERROR */
        };
      },
      gapi.iframes.CROSS_ORIGIN_IFRAMES_FILTER
    );
    this.eventManagers[auth2._key()] = { manager };
    this.iframes[auth2._key()] = iframe;
    return manager;
  }
  _isIframeWebStorageSupported(auth2, cb2) {
    const iframe = this.iframes[auth2._key()];
    iframe.send(
      WEB_STORAGE_SUPPORT_KEY,
      { type: WEB_STORAGE_SUPPORT_KEY },
      (result) => {
        var _a2;
        const isSupported =
          (_a2 = result === null || result === void 0 ? void 0 : result[0]) ===
            null || _a2 === void 0
            ? void 0
            : _a2[WEB_STORAGE_SUPPORT_KEY];
        if (isSupported !== void 0) {
          cb2(!!isSupported);
        }
        _fail(
          auth2,
          "internal-error"
          /* AuthErrorCode.INTERNAL_ERROR */
        );
      },
      gapi.iframes.CROSS_ORIGIN_IFRAMES_FILTER
    );
  }
  _originValidation(auth2) {
    const key = auth2._key();
    if (!this.originValidationPromises[key]) {
      this.originValidationPromises[key] = _validateOrigin(auth2);
    }
    return this.originValidationPromises[key];
  }
  get _shouldInitProactively() {
    return _isMobileBrowser() || _isSafari() || _isIOS();
  }
}
const browserPopupRedirectResolver = BrowserPopupRedirectResolver;
var name$2 = "@firebase/auth";
var version$2 = "1.7.1";
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class AuthInterop {
  constructor(auth2) {
    this.auth = auth2;
    this.internalListeners = /* @__PURE__ */ new Map();
  }
  getUid() {
    var _a2;
    this.assertAuthConfigured();
    return (
      ((_a2 = this.auth.currentUser) === null || _a2 === void 0
        ? void 0
        : _a2.uid) || null
    );
  }
  async getToken(forceRefresh) {
    this.assertAuthConfigured();
    await this.auth._initializationPromise;
    if (!this.auth.currentUser) {
      return null;
    }
    const accessToken = await this.auth.currentUser.getIdToken(forceRefresh);
    return { accessToken };
  }
  addAuthTokenListener(listener) {
    this.assertAuthConfigured();
    if (this.internalListeners.has(listener)) {
      return;
    }
    const unsubscribe = this.auth.onIdTokenChanged((user) => {
      listener(
        (user === null || user === void 0
          ? void 0
          : user.stsTokenManager.accessToken) || null
      );
    });
    this.internalListeners.set(listener, unsubscribe);
    this.updateProactiveRefresh();
  }
  removeAuthTokenListener(listener) {
    this.assertAuthConfigured();
    const unsubscribe = this.internalListeners.get(listener);
    if (!unsubscribe) {
      return;
    }
    this.internalListeners.delete(listener);
    unsubscribe();
    this.updateProactiveRefresh();
  }
  assertAuthConfigured() {
    _assert(
      this.auth._initializationPromise,
      "dependent-sdk-initialized-before-auth"
      /* AuthErrorCode.DEPENDENT_SDK_INIT_BEFORE_AUTH */
    );
  }
  updateProactiveRefresh() {
    if (this.internalListeners.size > 0) {
      this.auth._startProactiveRefresh();
    } else {
      this.auth._stopProactiveRefresh();
    }
  }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function getVersionForPlatform(clientPlatform) {
  switch (clientPlatform) {
    case "Node":
      return "node";
    case "ReactNative":
      return "rn";
    case "Worker":
      return "webworker";
    case "Cordova":
      return "cordova";
    case "WebExtension":
      return "web-extension";
    default:
      return void 0;
  }
}
function registerAuth(clientPlatform) {
  _registerComponent(
    new Component(
      "auth",
      (container, { options: deps }) => {
        const app2 = container.getProvider("app").getImmediate();
        const heartbeatServiceProvider = container.getProvider("heartbeat");
        const appCheckServiceProvider =
          container.getProvider("app-check-internal");
        const { apiKey, authDomain } = app2.options;
        _assert(apiKey && !apiKey.includes(":"), "invalid-api-key", {
          appName: app2.name,
        });
        const config = {
          apiKey,
          authDomain,
          clientPlatform,
          apiHost: "identitytoolkit.googleapis.com",
          tokenApiHost: "securetoken.googleapis.com",
          apiScheme: "https",
          sdkClientVersion: _getClientVersion(clientPlatform),
        };
        const authInstance = new AuthImpl(
          app2,
          heartbeatServiceProvider,
          appCheckServiceProvider,
          config
        );
        _initializeAuthInstance(authInstance, deps);
        return authInstance;
      },
      "PUBLIC"
      /* ComponentType.PUBLIC */
    )
      .setInstantiationMode(
        "EXPLICIT"
        /* InstantiationMode.EXPLICIT */
      )
      .setInstanceCreatedCallback(
        (container, _instanceIdentifier, _instance) => {
          const authInternalProvider = container.getProvider(
            "auth-internal"
            /* _ComponentName.AUTH_INTERNAL */
          );
          authInternalProvider.initialize();
        }
      )
  );
  _registerComponent(
    new Component(
      "auth-internal",
      (container) => {
        const auth2 = _castAuth(
          container
            .getProvider(
              "auth"
              /* _ComponentName.AUTH */
            )
            .getImmediate()
        );
        return ((auth3) => new AuthInterop(auth3))(auth2);
      },
      "PRIVATE"
      /* ComponentType.PRIVATE */
    ).setInstantiationMode(
      "EXPLICIT"
      /* InstantiationMode.EXPLICIT */
    )
  );
  registerVersion(name$2, version$2, getVersionForPlatform(clientPlatform));
  registerVersion(name$2, version$2, "esm2017");
}
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const DEFAULT_ID_TOKEN_MAX_AGE = 5 * 60;
const authIdTokenMaxAge =
  getExperimentalSetting("authIdTokenMaxAge") || DEFAULT_ID_TOKEN_MAX_AGE;
let lastPostedIdToken = null;
const mintCookieFactory = (url) => async (user) => {
  const idTokenResult = user && (await user.getIdTokenResult());
  const idTokenAge =
    idTokenResult &&
    /* @__PURE__ */ (new Date().getTime() -
      Date.parse(idTokenResult.issuedAtTime)) /
      1e3;
  if (idTokenAge && idTokenAge > authIdTokenMaxAge) {
    return;
  }
  const idToken =
    idTokenResult === null || idTokenResult === void 0
      ? void 0
      : idTokenResult.token;
  if (lastPostedIdToken === idToken) {
    return;
  }
  lastPostedIdToken = idToken;
  await fetch(url, {
    method: idToken ? "POST" : "DELETE",
    headers: idToken
      ? {
          Authorization: `Bearer ${idToken}`,
        }
      : {},
  });
};
function getAuth(app2 = getApp()) {
  const provider = _getProvider(app2, "auth");
  if (provider.isInitialized()) {
    return provider.getImmediate();
  }
  const auth2 = initializeAuth(app2, {
    popupRedirectResolver: browserPopupRedirectResolver,
    persistence: [
      indexedDBLocalPersistence,
      browserLocalPersistence,
      browserSessionPersistence,
    ],
  });
  const authTokenSyncPath = getExperimentalSetting("authTokenSyncURL");
  if (
    authTokenSyncPath &&
    typeof isSecureContext === "boolean" &&
    isSecureContext
  ) {
    const authTokenSyncUrl = new URL(authTokenSyncPath, location.origin);
    if (location.origin === authTokenSyncUrl.origin) {
      const mintCookie = mintCookieFactory(authTokenSyncUrl.toString());
      beforeAuthStateChanged(auth2, mintCookie, () =>
        mintCookie(auth2.currentUser)
      );
      onIdTokenChanged(auth2, (user) => mintCookie(user));
    }
  }
  const authEmulatorHost = getDefaultEmulatorHost("auth");
  if (authEmulatorHost) {
    connectAuthEmulator(auth2, `http://${authEmulatorHost}`);
  }
  return auth2;
}
function getScriptParentElement() {
  var _a2, _b2;
  return (_b2 =
    (_a2 = document.getElementsByTagName("head")) === null || _a2 === void 0
      ? void 0
      : _a2[0]) !== null && _b2 !== void 0
    ? _b2
    : document;
}
_setExternalJSProvider({
  loadJS(url) {
    return new Promise((resolve, reject3) => {
      const el = document.createElement("script");
      el.setAttribute("src", url);
      el.onload = resolve;
      el.onerror = (e) => {
        const error = _createError(
          "internal-error"
          /* AuthErrorCode.INTERNAL_ERROR */
        );
        error.customData = e;
        reject3(error);
      };
      el.type = "text/javascript";
      el.charset = "UTF-8";
      getScriptParentElement().appendChild(el);
    });
  },
  gapiScript: "https://apis.google.com/js/api.js",
  recaptchaV2Script: "https://www.google.com/recaptcha/api.js",
  recaptchaEnterpriseScript:
    "https://www.google.com/recaptcha/enterprise.js?render=",
});
registerAuth(
  "Browser"
  /* ClientPlatform.BROWSER */
);
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const DEFAULT_HOST = "firebasestorage.googleapis.com";
const CONFIG_STORAGE_BUCKET_KEY = "storageBucket";
const DEFAULT_MAX_OPERATION_RETRY_TIME = 2 * 60 * 1e3;
const DEFAULT_MAX_UPLOAD_RETRY_TIME = 10 * 60 * 1e3;
const DEFAULT_MIN_SLEEP_TIME_MILLIS = 1e3;
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class StorageError extends FirebaseError {
  /**
   * @param code - A `StorageErrorCode` string to be prefixed with 'storage/' and
   *  added to the end of the message.
   * @param message  - Error message.
   * @param status_ - Corresponding HTTP Status Code
   */
  constructor(code, message, status_ = 0) {
    super(
      prependCode(code),
      `Firebase Storage: ${message} (${prependCode(code)})`
    );
    this.status_ = status_;
    this.customData = { serverResponse: null };
    this._baseMessage = this.message;
    Object.setPrototypeOf(this, StorageError.prototype);
  }
  get status() {
    return this.status_;
  }
  set status(status) {
    this.status_ = status;
  }
  /**
   * Compares a `StorageErrorCode` against this error's code, filtering out the prefix.
   */
  _codeEquals(code) {
    return prependCode(code) === this.code;
  }
  /**
   * Optional response message that was added by the server.
   */
  get serverResponse() {
    return this.customData.serverResponse;
  }
  set serverResponse(serverResponse) {
    this.customData.serverResponse = serverResponse;
    if (this.customData.serverResponse) {
      this.message = `${this._baseMessage}
${this.customData.serverResponse}`;
    } else {
      this.message = this._baseMessage;
    }
  }
}
var StorageErrorCode;
(function (StorageErrorCode2) {
  StorageErrorCode2["UNKNOWN"] = "unknown";
  StorageErrorCode2["OBJECT_NOT_FOUND"] = "object-not-found";
  StorageErrorCode2["BUCKET_NOT_FOUND"] = "bucket-not-found";
  StorageErrorCode2["PROJECT_NOT_FOUND"] = "project-not-found";
  StorageErrorCode2["QUOTA_EXCEEDED"] = "quota-exceeded";
  StorageErrorCode2["UNAUTHENTICATED"] = "unauthenticated";
  StorageErrorCode2["UNAUTHORIZED"] = "unauthorized";
  StorageErrorCode2["UNAUTHORIZED_APP"] = "unauthorized-app";
  StorageErrorCode2["RETRY_LIMIT_EXCEEDED"] = "retry-limit-exceeded";
  StorageErrorCode2["INVALID_CHECKSUM"] = "invalid-checksum";
  StorageErrorCode2["CANCELED"] = "canceled";
  StorageErrorCode2["INVALID_EVENT_NAME"] = "invalid-event-name";
  StorageErrorCode2["INVALID_URL"] = "invalid-url";
  StorageErrorCode2["INVALID_DEFAULT_BUCKET"] = "invalid-default-bucket";
  StorageErrorCode2["NO_DEFAULT_BUCKET"] = "no-default-bucket";
  StorageErrorCode2["CANNOT_SLICE_BLOB"] = "cannot-slice-blob";
  StorageErrorCode2["SERVER_FILE_WRONG_SIZE"] = "server-file-wrong-size";
  StorageErrorCode2["NO_DOWNLOAD_URL"] = "no-download-url";
  StorageErrorCode2["INVALID_ARGUMENT"] = "invalid-argument";
  StorageErrorCode2["INVALID_ARGUMENT_COUNT"] = "invalid-argument-count";
  StorageErrorCode2["APP_DELETED"] = "app-deleted";
  StorageErrorCode2["INVALID_ROOT_OPERATION"] = "invalid-root-operation";
  StorageErrorCode2["INVALID_FORMAT"] = "invalid-format";
  StorageErrorCode2["INTERNAL_ERROR"] = "internal-error";
  StorageErrorCode2["UNSUPPORTED_ENVIRONMENT"] = "unsupported-environment";
})(StorageErrorCode || (StorageErrorCode = {}));
function prependCode(code) {
  return "storage/" + code;
}
function unknown() {
  const message =
    "An unknown error occurred, please check the error payload for server response.";
  return new StorageError(StorageErrorCode.UNKNOWN, message);
}
function objectNotFound(path) {
  return new StorageError(
    StorageErrorCode.OBJECT_NOT_FOUND,
    "Object '" + path + "' does not exist."
  );
}
function quotaExceeded(bucket) {
  return new StorageError(
    StorageErrorCode.QUOTA_EXCEEDED,
    "Quota for bucket '" +
      bucket +
      "' exceeded, please view quota on https://firebase.google.com/pricing/."
  );
}
function unauthenticated() {
  const message =
    "User is not authenticated, please authenticate using Firebase Authentication and try again.";
  return new StorageError(StorageErrorCode.UNAUTHENTICATED, message);
}
function unauthorizedApp() {
  return new StorageError(
    StorageErrorCode.UNAUTHORIZED_APP,
    "This app does not have permission to access Firebase Storage on this project."
  );
}
function unauthorized(path) {
  return new StorageError(
    StorageErrorCode.UNAUTHORIZED,
    "User does not have permission to access '" + path + "'."
  );
}
function retryLimitExceeded() {
  return new StorageError(
    StorageErrorCode.RETRY_LIMIT_EXCEEDED,
    "Max retry time for operation exceeded, please try again."
  );
}
function canceled() {
  return new StorageError(
    StorageErrorCode.CANCELED,
    "User canceled the upload/download."
  );
}
function invalidUrl(url) {
  return new StorageError(
    StorageErrorCode.INVALID_URL,
    "Invalid URL '" + url + "'."
  );
}
function invalidDefaultBucket(bucket) {
  return new StorageError(
    StorageErrorCode.INVALID_DEFAULT_BUCKET,
    "Invalid default bucket '" + bucket + "'."
  );
}
function noDefaultBucket() {
  return new StorageError(
    StorageErrorCode.NO_DEFAULT_BUCKET,
    "No default bucket found. Did you set the '" +
      CONFIG_STORAGE_BUCKET_KEY +
      "' property when initializing the app?"
  );
}
function cannotSliceBlob() {
  return new StorageError(
    StorageErrorCode.CANNOT_SLICE_BLOB,
    "Cannot slice blob for upload. Please retry the upload."
  );
}
function serverFileWrongSize() {
  return new StorageError(
    StorageErrorCode.SERVER_FILE_WRONG_SIZE,
    "Server recorded incorrect upload file size, please retry the upload."
  );
}
function noDownloadURL() {
  return new StorageError(
    StorageErrorCode.NO_DOWNLOAD_URL,
    "The given file does not have any download URLs."
  );
}
function missingPolyFill(polyFill) {
  return new StorageError(
    StorageErrorCode.UNSUPPORTED_ENVIRONMENT,
    `${polyFill} is missing. Make sure to install the required polyfills. See https://firebase.google.com/docs/web/environments-js-sdk#polyfills for more information.`
  );
}
function invalidArgument(message) {
  return new StorageError(StorageErrorCode.INVALID_ARGUMENT, message);
}
function appDeleted() {
  return new StorageError(
    StorageErrorCode.APP_DELETED,
    "The Firebase app was deleted."
  );
}
function invalidRootOperation(name2) {
  return new StorageError(
    StorageErrorCode.INVALID_ROOT_OPERATION,
    "The operation '" +
      name2 +
      "' cannot be performed on a root reference, create a non-root reference using child, such as .child('file.png')."
  );
}
function invalidFormat(format, message) {
  return new StorageError(
    StorageErrorCode.INVALID_FORMAT,
    "String does not match format '" + format + "': " + message
  );
}
function internalError(message) {
  throw new StorageError(
    StorageErrorCode.INTERNAL_ERROR,
    "Internal error: " + message
  );
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class Location {
  constructor(bucket, path) {
    this.bucket = bucket;
    this.path_ = path;
  }
  get path() {
    return this.path_;
  }
  get isRoot() {
    return this.path.length === 0;
  }
  fullServerUrl() {
    const encode2 = encodeURIComponent;
    return "/b/" + encode2(this.bucket) + "/o/" + encode2(this.path);
  }
  bucketOnlyServerUrl() {
    const encode2 = encodeURIComponent;
    return "/b/" + encode2(this.bucket) + "/o";
  }
  static makeFromBucketSpec(bucketString, host) {
    let bucketLocation;
    try {
      bucketLocation = Location.makeFromUrl(bucketString, host);
    } catch (e) {
      return new Location(bucketString, "");
    }
    if (bucketLocation.path === "") {
      return bucketLocation;
    } else {
      throw invalidDefaultBucket(bucketString);
    }
  }
  static makeFromUrl(url, host) {
    let location2 = null;
    const bucketDomain = "([A-Za-z0-9.\\-_]+)";
    function gsModify(loc) {
      if (loc.path.charAt(loc.path.length - 1) === "/") {
        loc.path_ = loc.path_.slice(0, -1);
      }
    }
    const gsPath = "(/(.*))?$";
    const gsRegex = new RegExp("^gs://" + bucketDomain + gsPath, "i");
    const gsIndices = { bucket: 1, path: 3 };
    function httpModify(loc) {
      loc.path_ = decodeURIComponent(loc.path);
    }
    const version2 = "v[A-Za-z0-9_]+";
    const firebaseStorageHost = host.replace(/[.]/g, "\\.");
    const firebaseStoragePath = "(/([^?#]*).*)?$";
    const firebaseStorageRegExp = new RegExp(
      `^https?://${firebaseStorageHost}/${version2}/b/${bucketDomain}/o${firebaseStoragePath}`,
      "i"
    );
    const firebaseStorageIndices = { bucket: 1, path: 3 };
    const cloudStorageHost =
      host === DEFAULT_HOST
        ? "(?:storage.googleapis.com|storage.cloud.google.com)"
        : host;
    const cloudStoragePath = "([^?#]*)";
    const cloudStorageRegExp = new RegExp(
      `^https?://${cloudStorageHost}/${bucketDomain}/${cloudStoragePath}`,
      "i"
    );
    const cloudStorageIndices = { bucket: 1, path: 2 };
    const groups = [
      { regex: gsRegex, indices: gsIndices, postModify: gsModify },
      {
        regex: firebaseStorageRegExp,
        indices: firebaseStorageIndices,
        postModify: httpModify,
      },
      {
        regex: cloudStorageRegExp,
        indices: cloudStorageIndices,
        postModify: httpModify,
      },
    ];
    for (let i = 0; i < groups.length; i++) {
      const group = groups[i];
      const captures = group.regex.exec(url);
      if (captures) {
        const bucketValue = captures[group.indices.bucket];
        let pathValue = captures[group.indices.path];
        if (!pathValue) {
          pathValue = "";
        }
        location2 = new Location(bucketValue, pathValue);
        group.postModify(location2);
        break;
      }
    }
    if (location2 == null) {
      throw invalidUrl(url);
    }
    return location2;
  }
}
class FailRequest {
  constructor(error) {
    this.promise_ = Promise.reject(error);
  }
  /** @inheritDoc */
  getPromise() {
    return this.promise_;
  }
  /** @inheritDoc */
  cancel(_appDelete = false) {}
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function start(doRequest, backoffCompleteCb, timeout) {
  let waitSeconds = 1;
  let retryTimeoutId = null;
  let globalTimeoutId = null;
  let hitTimeout = false;
  let cancelState = 0;
  function canceled2() {
    return cancelState === 2;
  }
  let triggeredCallback = false;
  function triggerCallback(...args) {
    if (!triggeredCallback) {
      triggeredCallback = true;
      backoffCompleteCb.apply(null, args);
    }
  }
  function callWithDelay(millis) {
    retryTimeoutId = setTimeout(() => {
      retryTimeoutId = null;
      doRequest(responseHandler, canceled2());
    }, millis);
  }
  function clearGlobalTimeout() {
    if (globalTimeoutId) {
      clearTimeout(globalTimeoutId);
    }
  }
  function responseHandler(success, ...args) {
    if (triggeredCallback) {
      clearGlobalTimeout();
      return;
    }
    if (success) {
      clearGlobalTimeout();
      triggerCallback.call(null, success, ...args);
      return;
    }
    const mustStop = canceled2() || hitTimeout;
    if (mustStop) {
      clearGlobalTimeout();
      triggerCallback.call(null, success, ...args);
      return;
    }
    if (waitSeconds < 64) {
      waitSeconds *= 2;
    }
    let waitMillis;
    if (cancelState === 1) {
      cancelState = 2;
      waitMillis = 0;
    } else {
      waitMillis = (waitSeconds + Math.random()) * 1e3;
    }
    callWithDelay(waitMillis);
  }
  let stopped = false;
  function stop2(wasTimeout) {
    if (stopped) {
      return;
    }
    stopped = true;
    clearGlobalTimeout();
    if (triggeredCallback) {
      return;
    }
    if (retryTimeoutId !== null) {
      if (!wasTimeout) {
        cancelState = 2;
      }
      clearTimeout(retryTimeoutId);
      callWithDelay(0);
    } else {
      if (!wasTimeout) {
        cancelState = 1;
      }
    }
  }
  callWithDelay(0);
  globalTimeoutId = setTimeout(() => {
    hitTimeout = true;
    stop2(true);
  }, timeout);
  return stop2;
}
function stop(id2) {
  id2(false);
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function isJustDef(p2) {
  return p2 !== void 0;
}
function isFunction$1(p2) {
  return typeof p2 === "function";
}
function isNonArrayObject(p2) {
  return typeof p2 === "object" && !Array.isArray(p2);
}
function isString(p2) {
  return typeof p2 === "string" || p2 instanceof String;
}
function isNativeBlob(p2) {
  return isNativeBlobDefined() && p2 instanceof Blob;
}
function isNativeBlobDefined() {
  return typeof Blob !== "undefined";
}
function validateNumber(argument, minValue, maxValue, value) {
  if (value < minValue) {
    throw invalidArgument(
      `Invalid value for '${argument}'. Expected ${minValue} or greater.`
    );
  }
  if (value > maxValue) {
    throw invalidArgument(
      `Invalid value for '${argument}'. Expected ${maxValue} or less.`
    );
  }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function makeUrl(urlPart, host, protocol) {
  let origin = host;
  if (protocol == null) {
    origin = `https://${host}`;
  }
  return `${protocol}://${origin}/v0${urlPart}`;
}
function makeQueryString(params) {
  const encode2 = encodeURIComponent;
  let queryPart = "?";
  for (const key in params) {
    if (params.hasOwnProperty(key)) {
      const nextPart = encode2(key) + "=" + encode2(params[key]);
      queryPart = queryPart + nextPart + "&";
    }
  }
  queryPart = queryPart.slice(0, -1);
  return queryPart;
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var ErrorCode;
(function (ErrorCode2) {
  ErrorCode2[(ErrorCode2["NO_ERROR"] = 0)] = "NO_ERROR";
  ErrorCode2[(ErrorCode2["NETWORK_ERROR"] = 1)] = "NETWORK_ERROR";
  ErrorCode2[(ErrorCode2["ABORT"] = 2)] = "ABORT";
})(ErrorCode || (ErrorCode = {}));
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function isRetryStatusCode(status, additionalRetryCodes) {
  const isFiveHundredCode = status >= 500 && status < 600;
  const extraRetryCodes = [
    // Request Timeout: web server didn't receive full request in time.
    408,
    // Too Many Requests: you're getting rate-limited, basically.
    429,
  ];
  const isExtraRetryCode = extraRetryCodes.indexOf(status) !== -1;
  const isAdditionalRetryCode = additionalRetryCodes.indexOf(status) !== -1;
  return isFiveHundredCode || isExtraRetryCode || isAdditionalRetryCode;
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class NetworkRequest {
  constructor(
    url_,
    method_,
    headers_,
    body_,
    successCodes_,
    additionalRetryCodes_,
    callback_,
    errorCallback_,
    timeout_,
    progressCallback_,
    connectionFactory_,
    retry = true
  ) {
    this.url_ = url_;
    this.method_ = method_;
    this.headers_ = headers_;
    this.body_ = body_;
    this.successCodes_ = successCodes_;
    this.additionalRetryCodes_ = additionalRetryCodes_;
    this.callback_ = callback_;
    this.errorCallback_ = errorCallback_;
    this.timeout_ = timeout_;
    this.progressCallback_ = progressCallback_;
    this.connectionFactory_ = connectionFactory_;
    this.retry = retry;
    this.pendingConnection_ = null;
    this.backoffId_ = null;
    this.canceled_ = false;
    this.appDelete_ = false;
    this.promise_ = new Promise((resolve, reject3) => {
      this.resolve_ = resolve;
      this.reject_ = reject3;
      this.start_();
    });
  }
  /**
   * Actually starts the retry loop.
   */
  start_() {
    const doTheRequest = (backoffCallback, canceled2) => {
      if (canceled2) {
        backoffCallback(false, new RequestEndStatus(false, null, true));
        return;
      }
      const connection = this.connectionFactory_();
      this.pendingConnection_ = connection;
      const progressListener = (progressEvent) => {
        const loaded = progressEvent.loaded;
        const total = progressEvent.lengthComputable ? progressEvent.total : -1;
        if (this.progressCallback_ !== null) {
          this.progressCallback_(loaded, total);
        }
      };
      if (this.progressCallback_ !== null) {
        connection.addUploadProgressListener(progressListener);
      }
      connection
        .send(this.url_, this.method_, this.body_, this.headers_)
        .then(() => {
          if (this.progressCallback_ !== null) {
            connection.removeUploadProgressListener(progressListener);
          }
          this.pendingConnection_ = null;
          const hitServer = connection.getErrorCode() === ErrorCode.NO_ERROR;
          const status = connection.getStatus();
          if (
            !hitServer ||
            (isRetryStatusCode(status, this.additionalRetryCodes_) &&
              this.retry)
          ) {
            const wasCanceled = connection.getErrorCode() === ErrorCode.ABORT;
            backoffCallback(
              false,
              new RequestEndStatus(false, null, wasCanceled)
            );
            return;
          }
          const successCode = this.successCodes_.indexOf(status) !== -1;
          backoffCallback(true, new RequestEndStatus(successCode, connection));
        });
    };
    const backoffDone = (requestWentThrough, status) => {
      const resolve = this.resolve_;
      const reject3 = this.reject_;
      const connection = status.connection;
      if (status.wasSuccessCode) {
        try {
          const result = this.callback_(connection, connection.getResponse());
          if (isJustDef(result)) {
            resolve(result);
          } else {
            resolve();
          }
        } catch (e) {
          reject3(e);
        }
      } else {
        if (connection !== null) {
          const err = unknown();
          err.serverResponse = connection.getErrorText();
          if (this.errorCallback_) {
            reject3(this.errorCallback_(connection, err));
          } else {
            reject3(err);
          }
        } else {
          if (status.canceled) {
            const err = this.appDelete_ ? appDeleted() : canceled();
            reject3(err);
          } else {
            const err = retryLimitExceeded();
            reject3(err);
          }
        }
      }
    };
    if (this.canceled_) {
      backoffDone(false, new RequestEndStatus(false, null, true));
    } else {
      this.backoffId_ = start(doTheRequest, backoffDone, this.timeout_);
    }
  }
  /** @inheritDoc */
  getPromise() {
    return this.promise_;
  }
  /** @inheritDoc */
  cancel(appDelete) {
    this.canceled_ = true;
    this.appDelete_ = appDelete || false;
    if (this.backoffId_ !== null) {
      stop(this.backoffId_);
    }
    if (this.pendingConnection_ !== null) {
      this.pendingConnection_.abort();
    }
  }
}
class RequestEndStatus {
  constructor(wasSuccessCode, connection, canceled2) {
    this.wasSuccessCode = wasSuccessCode;
    this.connection = connection;
    this.canceled = !!canceled2;
  }
}
function addAuthHeader_(headers, authToken) {
  if (authToken !== null && authToken.length > 0) {
    headers["Authorization"] = "Firebase " + authToken;
  }
}
function addVersionHeader_(headers, firebaseVersion) {
  headers["X-Firebase-Storage-Version"] =
    "webjs/" +
    (firebaseVersion !== null && firebaseVersion !== void 0
      ? firebaseVersion
      : "AppManager");
}
function addGmpidHeader_(headers, appId) {
  if (appId) {
    headers["X-Firebase-GMPID"] = appId;
  }
}
function addAppCheckHeader_(headers, appCheckToken) {
  if (appCheckToken !== null) {
    headers["X-Firebase-AppCheck"] = appCheckToken;
  }
}
function makeRequest(
  requestInfo,
  appId,
  authToken,
  appCheckToken,
  requestFactory,
  firebaseVersion,
  retry = true
) {
  const queryPart = makeQueryString(requestInfo.urlParams);
  const url = requestInfo.url + queryPart;
  const headers = Object.assign({}, requestInfo.headers);
  addGmpidHeader_(headers, appId);
  addAuthHeader_(headers, authToken);
  addVersionHeader_(headers, firebaseVersion);
  addAppCheckHeader_(headers, appCheckToken);
  return new NetworkRequest(
    url,
    requestInfo.method,
    headers,
    requestInfo.body,
    requestInfo.successCodes,
    requestInfo.additionalRetryCodes,
    requestInfo.handler,
    requestInfo.errorHandler,
    requestInfo.timeout,
    requestInfo.progressCallback,
    requestFactory,
    retry
  );
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function getBlobBuilder() {
  if (typeof BlobBuilder !== "undefined") {
    return BlobBuilder;
  } else if (typeof WebKitBlobBuilder !== "undefined") {
    return WebKitBlobBuilder;
  } else {
    return void 0;
  }
}
function getBlob$1(...args) {
  const BlobBuilder2 = getBlobBuilder();
  if (BlobBuilder2 !== void 0) {
    const bb2 = new BlobBuilder2();
    for (let i = 0; i < args.length; i++) {
      bb2.append(args[i]);
    }
    return bb2.getBlob();
  } else {
    if (isNativeBlobDefined()) {
      return new Blob(args);
    } else {
      throw new StorageError(
        StorageErrorCode.UNSUPPORTED_ENVIRONMENT,
        "This browser doesn't seem to support creating Blobs"
      );
    }
  }
}
function sliceBlob(blob, start2, end) {
  if (blob.webkitSlice) {
    return blob.webkitSlice(start2, end);
  } else if (blob.mozSlice) {
    return blob.mozSlice(start2, end);
  } else if (blob.slice) {
    return blob.slice(start2, end);
  }
  return null;
}
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function decodeBase64(encoded) {
  if (typeof atob === "undefined") {
    throw missingPolyFill("base-64");
  }
  return atob(encoded);
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const StringFormat = {
  /**
   * Indicates the string should be interpreted "raw", that is, as normal text.
   * The string will be interpreted as UTF-16, then uploaded as a UTF-8 byte
   * sequence.
   * Example: The string 'Hello! \\ud83d\\ude0a' becomes the byte sequence
   * 48 65 6c 6c 6f 21 20 f0 9f 98 8a
   */
  RAW: "raw",
  /**
   * Indicates the string should be interpreted as base64-encoded data.
   * Padding characters (trailing '='s) are optional.
   * Example: The string 'rWmO++E6t7/rlw==' becomes the byte sequence
   * ad 69 8e fb e1 3a b7 bf eb 97
   */
  BASE64: "base64",
  /**
   * Indicates the string should be interpreted as base64url-encoded data.
   * Padding characters (trailing '='s) are optional.
   * Example: The string 'rWmO--E6t7_rlw==' becomes the byte sequence
   * ad 69 8e fb e1 3a b7 bf eb 97
   */
  BASE64URL: "base64url",
  /**
   * Indicates the string is a data URL, such as one obtained from
   * canvas.toDataURL().
   * Example: the string 'data:application/octet-stream;base64,aaaa'
   * becomes the byte sequence
   * 69 a6 9a
   * (the content-type "application/octet-stream" is also applied, but can
   * be overridden in the metadata object).
   */
  DATA_URL: "data_url",
};
class StringData {
  constructor(data, contentType) {
    this.data = data;
    this.contentType = contentType || null;
  }
}
function dataFromString(format, stringData) {
  switch (format) {
    case StringFormat.RAW:
      return new StringData(utf8Bytes_(stringData));
    case StringFormat.BASE64:
    case StringFormat.BASE64URL:
      return new StringData(base64Bytes_(format, stringData));
    case StringFormat.DATA_URL:
      return new StringData(
        dataURLBytes_(stringData),
        dataURLContentType_(stringData)
      );
  }
  throw unknown();
}
function utf8Bytes_(value) {
  const b2 = [];
  for (let i = 0; i < value.length; i++) {
    let c = value.charCodeAt(i);
    if (c <= 127) {
      b2.push(c);
    } else {
      if (c <= 2047) {
        b2.push(192 | (c >> 6), 128 | (c & 63));
      } else {
        if ((c & 64512) === 55296) {
          const valid =
            i < value.length - 1 && (value.charCodeAt(i + 1) & 64512) === 56320;
          if (!valid) {
            b2.push(239, 191, 189);
          } else {
            const hi = c;
            const lo = value.charCodeAt(++i);
            c = 65536 | ((hi & 1023) << 10) | (lo & 1023);
            b2.push(
              240 | (c >> 18),
              128 | ((c >> 12) & 63),
              128 | ((c >> 6) & 63),
              128 | (c & 63)
            );
          }
        } else {
          if ((c & 64512) === 56320) {
            b2.push(239, 191, 189);
          } else {
            b2.push(224 | (c >> 12), 128 | ((c >> 6) & 63), 128 | (c & 63));
          }
        }
      }
    }
  }
  return new Uint8Array(b2);
}
function percentEncodedBytes_(value) {
  let decoded;
  try {
    decoded = decodeURIComponent(value);
  } catch (e) {
    throw invalidFormat(StringFormat.DATA_URL, "Malformed data URL.");
  }
  return utf8Bytes_(decoded);
}
function base64Bytes_(format, value) {
  switch (format) {
    case StringFormat.BASE64: {
      const hasMinus = value.indexOf("-") !== -1;
      const hasUnder = value.indexOf("_") !== -1;
      if (hasMinus || hasUnder) {
        const invalidChar = hasMinus ? "-" : "_";
        throw invalidFormat(
          format,
          "Invalid character '" +
            invalidChar +
            "' found: is it base64url encoded?"
        );
      }
      break;
    }
    case StringFormat.BASE64URL: {
      const hasPlus = value.indexOf("+") !== -1;
      const hasSlash = value.indexOf("/") !== -1;
      if (hasPlus || hasSlash) {
        const invalidChar = hasPlus ? "+" : "/";
        throw invalidFormat(
          format,
          "Invalid character '" + invalidChar + "' found: is it base64 encoded?"
        );
      }
      value = value.replace(/-/g, "+").replace(/_/g, "/");
      break;
    }
  }
  let bytes;
  try {
    bytes = decodeBase64(value);
  } catch (e) {
    if (e.message.includes("polyfill")) {
      throw e;
    }
    throw invalidFormat(format, "Invalid character found");
  }
  const array = new Uint8Array(bytes.length);
  for (let i = 0; i < bytes.length; i++) {
    array[i] = bytes.charCodeAt(i);
  }
  return array;
}
class DataURLParts {
  constructor(dataURL) {
    this.base64 = false;
    this.contentType = null;
    const matches = dataURL.match(/^data:([^,]+)?,/);
    if (matches === null) {
      throw invalidFormat(
        StringFormat.DATA_URL,
        "Must be formatted 'data:[<mediatype>][;base64],<data>"
      );
    }
    const middle = matches[1] || null;
    if (middle != null) {
      this.base64 = endsWith(middle, ";base64");
      this.contentType = this.base64
        ? middle.substring(0, middle.length - ";base64".length)
        : middle;
    }
    this.rest = dataURL.substring(dataURL.indexOf(",") + 1);
  }
}
function dataURLBytes_(dataUrl) {
  const parts = new DataURLParts(dataUrl);
  if (parts.base64) {
    return base64Bytes_(StringFormat.BASE64, parts.rest);
  } else {
    return percentEncodedBytes_(parts.rest);
  }
}
function dataURLContentType_(dataUrl) {
  const parts = new DataURLParts(dataUrl);
  return parts.contentType;
}
function endsWith(s, end) {
  const longEnough = s.length >= end.length;
  if (!longEnough) {
    return false;
  }
  return s.substring(s.length - end.length) === end;
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class FbsBlob {
  constructor(data, elideCopy) {
    let size = 0;
    let blobType = "";
    if (isNativeBlob(data)) {
      this.data_ = data;
      size = data.size;
      blobType = data.type;
    } else if (data instanceof ArrayBuffer) {
      if (elideCopy) {
        this.data_ = new Uint8Array(data);
      } else {
        this.data_ = new Uint8Array(data.byteLength);
        this.data_.set(new Uint8Array(data));
      }
      size = this.data_.length;
    } else if (data instanceof Uint8Array) {
      if (elideCopy) {
        this.data_ = data;
      } else {
        this.data_ = new Uint8Array(data.length);
        this.data_.set(data);
      }
      size = data.length;
    }
    this.size_ = size;
    this.type_ = blobType;
  }
  size() {
    return this.size_;
  }
  type() {
    return this.type_;
  }
  slice(startByte, endByte) {
    if (isNativeBlob(this.data_)) {
      const realBlob = this.data_;
      const sliced = sliceBlob(realBlob, startByte, endByte);
      if (sliced === null) {
        return null;
      }
      return new FbsBlob(sliced);
    } else {
      const slice3 = new Uint8Array(
        this.data_.buffer,
        startByte,
        endByte - startByte
      );
      return new FbsBlob(slice3, true);
    }
  }
  static getBlob(...args) {
    if (isNativeBlobDefined()) {
      const blobby = args.map((val) => {
        if (val instanceof FbsBlob) {
          return val.data_;
        } else {
          return val;
        }
      });
      return new FbsBlob(getBlob$1.apply(null, blobby));
    } else {
      const uint8Arrays = args.map((val) => {
        if (isString(val)) {
          return dataFromString(StringFormat.RAW, val).data;
        } else {
          return val.data_;
        }
      });
      let finalLength = 0;
      uint8Arrays.forEach((array) => {
        finalLength += array.byteLength;
      });
      const merged = new Uint8Array(finalLength);
      let index = 0;
      uint8Arrays.forEach((array) => {
        for (let i = 0; i < array.length; i++) {
          merged[index++] = array[i];
        }
      });
      return new FbsBlob(merged, true);
    }
  }
  uploadData() {
    return this.data_;
  }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function jsonObjectOrNull(s) {
  let obj;
  try {
    obj = JSON.parse(s);
  } catch (e) {
    return null;
  }
  if (isNonArrayObject(obj)) {
    return obj;
  } else {
    return null;
  }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function parent$1(path) {
  if (path.length === 0) {
    return null;
  }
  const index = path.lastIndexOf("/");
  if (index === -1) {
    return "";
  }
  const newPath = path.slice(0, index);
  return newPath;
}
function child(path, childPath) {
  const canonicalChildPath = childPath
    .split("/")
    .filter((component) => component.length > 0)
    .join("/");
  if (path.length === 0) {
    return canonicalChildPath;
  } else {
    return path + "/" + canonicalChildPath;
  }
}
function lastComponent(path) {
  const index = path.lastIndexOf("/", path.length - 2);
  if (index === -1) {
    return path;
  } else {
    return path.slice(index + 1);
  }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function noXform_(metadata, value) {
  return value;
}
class Mapping {
  constructor(server, local, writable, xform) {
    this.server = server;
    this.local = local || server;
    this.writable = !!writable;
    this.xform = xform || noXform_;
  }
}
let mappings_ = null;
function xformPath(fullPath) {
  if (!isString(fullPath) || fullPath.length < 2) {
    return fullPath;
  } else {
    return lastComponent(fullPath);
  }
}
function getMappings() {
  if (mappings_) {
    return mappings_;
  }
  const mappings = [];
  mappings.push(new Mapping("bucket"));
  mappings.push(new Mapping("generation"));
  mappings.push(new Mapping("metageneration"));
  mappings.push(new Mapping("name", "fullPath", true));
  function mappingsXformPath(_metadata, fullPath) {
    return xformPath(fullPath);
  }
  const nameMapping = new Mapping("name");
  nameMapping.xform = mappingsXformPath;
  mappings.push(nameMapping);
  function xformSize(_metadata, size) {
    if (size !== void 0) {
      return Number(size);
    } else {
      return size;
    }
  }
  const sizeMapping = new Mapping("size");
  sizeMapping.xform = xformSize;
  mappings.push(sizeMapping);
  mappings.push(new Mapping("timeCreated"));
  mappings.push(new Mapping("updated"));
  mappings.push(new Mapping("md5Hash", null, true));
  mappings.push(new Mapping("cacheControl", null, true));
  mappings.push(new Mapping("contentDisposition", null, true));
  mappings.push(new Mapping("contentEncoding", null, true));
  mappings.push(new Mapping("contentLanguage", null, true));
  mappings.push(new Mapping("contentType", null, true));
  mappings.push(new Mapping("metadata", "customMetadata", true));
  mappings_ = mappings;
  return mappings_;
}
function addRef(metadata, service) {
  function generateRef() {
    const bucket = metadata["bucket"];
    const path = metadata["fullPath"];
    const loc = new Location(bucket, path);
    return service._makeStorageReference(loc);
  }
  Object.defineProperty(metadata, "ref", { get: generateRef });
}
function fromResource(service, resource, mappings) {
  const metadata = {};
  metadata["type"] = "file";
  const len = mappings.length;
  for (let i = 0; i < len; i++) {
    const mapping = mappings[i];
    metadata[mapping.local] = mapping.xform(metadata, resource[mapping.server]);
  }
  addRef(metadata, service);
  return metadata;
}
function fromResourceString(service, resourceString, mappings) {
  const obj = jsonObjectOrNull(resourceString);
  if (obj === null) {
    return null;
  }
  const resource = obj;
  return fromResource(service, resource, mappings);
}
function downloadUrlFromResourceString(
  metadata,
  resourceString,
  host,
  protocol
) {
  const obj = jsonObjectOrNull(resourceString);
  if (obj === null) {
    return null;
  }
  if (!isString(obj["downloadTokens"])) {
    return null;
  }
  const tokens = obj["downloadTokens"];
  if (tokens.length === 0) {
    return null;
  }
  const encode2 = encodeURIComponent;
  const tokensList = tokens.split(",");
  const urls = tokensList.map((token2) => {
    const bucket = metadata["bucket"];
    const path = metadata["fullPath"];
    const urlPart = "/b/" + encode2(bucket) + "/o/" + encode2(path);
    const base = makeUrl(urlPart, host, protocol);
    const queryString2 = makeQueryString({
      alt: "media",
      token: token2,
    });
    return base + queryString2;
  });
  return urls[0];
}
function toResourceString(metadata, mappings) {
  const resource = {};
  const len = mappings.length;
  for (let i = 0; i < len; i++) {
    const mapping = mappings[i];
    if (mapping.writable) {
      resource[mapping.server] = metadata[mapping.local];
    }
  }
  return JSON.stringify(resource);
}
class RequestInfo {
  constructor(url, method, handler, timeout) {
    this.url = url;
    this.method = method;
    this.handler = handler;
    this.timeout = timeout;
    this.urlParams = {};
    this.headers = {};
    this.body = null;
    this.errorHandler = null;
    this.progressCallback = null;
    this.successCodes = [200];
    this.additionalRetryCodes = [];
  }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function handlerCheck(cndn) {
  if (!cndn) {
    throw unknown();
  }
}
function metadataHandler(service, mappings) {
  function handler(xhr, text2) {
    const metadata = fromResourceString(service, text2, mappings);
    handlerCheck(metadata !== null);
    return metadata;
  }
  return handler;
}
function downloadUrlHandler(service, mappings) {
  function handler(xhr, text2) {
    const metadata = fromResourceString(service, text2, mappings);
    handlerCheck(metadata !== null);
    return downloadUrlFromResourceString(
      metadata,
      text2,
      service.host,
      service._protocol
    );
  }
  return handler;
}
function sharedErrorHandler(location2) {
  function errorHandler(xhr, err) {
    let newErr;
    if (xhr.getStatus() === 401) {
      if (
        // This exact message string is the only consistent part of the
        // server's error response that identifies it as an App Check error.
        xhr.getErrorText().includes("Firebase App Check token is invalid")
      ) {
        newErr = unauthorizedApp();
      } else {
        newErr = unauthenticated();
      }
    } else {
      if (xhr.getStatus() === 402) {
        newErr = quotaExceeded(location2.bucket);
      } else {
        if (xhr.getStatus() === 403) {
          newErr = unauthorized(location2.path);
        } else {
          newErr = err;
        }
      }
    }
    newErr.status = xhr.getStatus();
    newErr.serverResponse = err.serverResponse;
    return newErr;
  }
  return errorHandler;
}
function objectErrorHandler(location2) {
  const shared = sharedErrorHandler(location2);
  function errorHandler(xhr, err) {
    let newErr = shared(xhr, err);
    if (xhr.getStatus() === 404) {
      newErr = objectNotFound(location2.path);
    }
    newErr.serverResponse = err.serverResponse;
    return newErr;
  }
  return errorHandler;
}
function getMetadata$2(service, location2, mappings) {
  const urlPart = location2.fullServerUrl();
  const url = makeUrl(urlPart, service.host, service._protocol);
  const method = "GET";
  const timeout = service.maxOperationRetryTime;
  const requestInfo = new RequestInfo(
    url,
    method,
    metadataHandler(service, mappings),
    timeout
  );
  requestInfo.errorHandler = objectErrorHandler(location2);
  return requestInfo;
}
function getDownloadUrl(service, location2, mappings) {
  const urlPart = location2.fullServerUrl();
  const url = makeUrl(urlPart, service.host, service._protocol);
  const method = "GET";
  const timeout = service.maxOperationRetryTime;
  const requestInfo = new RequestInfo(
    url,
    method,
    downloadUrlHandler(service, mappings),
    timeout
  );
  requestInfo.errorHandler = objectErrorHandler(location2);
  return requestInfo;
}
function determineContentType_(metadata, blob) {
  return (
    (metadata && metadata["contentType"]) ||
    (blob && blob.type()) ||
    "application/octet-stream"
  );
}
function metadataForUpload_(location2, blob, metadata) {
  const metadataClone = Object.assign({}, metadata);
  metadataClone["fullPath"] = location2.path;
  metadataClone["size"] = blob.size();
  if (!metadataClone["contentType"]) {
    metadataClone["contentType"] = determineContentType_(null, blob);
  }
  return metadataClone;
}
function multipartUpload(service, location2, mappings, blob, metadata) {
  const urlPart = location2.bucketOnlyServerUrl();
  const headers = {
    "X-Goog-Upload-Protocol": "multipart",
  };
  function genBoundary() {
    let str = "";
    for (let i = 0; i < 2; i++) {
      str = str + Math.random().toString().slice(2);
    }
    return str;
  }
  const boundary = genBoundary();
  headers["Content-Type"] = "multipart/related; boundary=" + boundary;
  const metadata_ = metadataForUpload_(location2, blob, metadata);
  const metadataString = toResourceString(metadata_, mappings);
  const preBlobPart =
    "--" +
    boundary +
    "\r\nContent-Type: application/json; charset=utf-8\r\n\r\n" +
    metadataString +
    "\r\n--" +
    boundary +
    "\r\nContent-Type: " +
    metadata_["contentType"] +
    "\r\n\r\n";
  const postBlobPart = "\r\n--" + boundary + "--";
  const body = FbsBlob.getBlob(preBlobPart, blob, postBlobPart);
  if (body === null) {
    throw cannotSliceBlob();
  }
  const urlParams = { name: metadata_["fullPath"] };
  const url = makeUrl(urlPart, service.host, service._protocol);
  const method = "POST";
  const timeout = service.maxUploadRetryTime;
  const requestInfo = new RequestInfo(
    url,
    method,
    metadataHandler(service, mappings),
    timeout
  );
  requestInfo.urlParams = urlParams;
  requestInfo.headers = headers;
  requestInfo.body = body.uploadData();
  requestInfo.errorHandler = sharedErrorHandler(location2);
  return requestInfo;
}
class ResumableUploadStatus {
  constructor(current, total, finalized, metadata) {
    this.current = current;
    this.total = total;
    this.finalized = !!finalized;
    this.metadata = metadata || null;
  }
}
function checkResumeHeader_(xhr, allowed) {
  let status = null;
  try {
    status = xhr.getResponseHeader("X-Goog-Upload-Status");
  } catch (e) {
    handlerCheck(false);
  }
  const allowedStatus = allowed || ["active"];
  handlerCheck(!!status && allowedStatus.indexOf(status) !== -1);
  return status;
}
function createResumableUpload(service, location2, mappings, blob, metadata) {
  const urlPart = location2.bucketOnlyServerUrl();
  const metadataForUpload = metadataForUpload_(location2, blob, metadata);
  const urlParams = { name: metadataForUpload["fullPath"] };
  const url = makeUrl(urlPart, service.host, service._protocol);
  const method = "POST";
  const headers = {
    "X-Goog-Upload-Protocol": "resumable",
    "X-Goog-Upload-Command": "start",
    "X-Goog-Upload-Header-Content-Length": `${blob.size()}`,
    "X-Goog-Upload-Header-Content-Type": metadataForUpload["contentType"],
    "Content-Type": "application/json; charset=utf-8",
  };
  const body = toResourceString(metadataForUpload, mappings);
  const timeout = service.maxUploadRetryTime;
  function handler(xhr) {
    checkResumeHeader_(xhr);
    let url2;
    try {
      url2 = xhr.getResponseHeader("X-Goog-Upload-URL");
    } catch (e) {
      handlerCheck(false);
    }
    handlerCheck(isString(url2));
    return url2;
  }
  const requestInfo = new RequestInfo(url, method, handler, timeout);
  requestInfo.urlParams = urlParams;
  requestInfo.headers = headers;
  requestInfo.body = body;
  requestInfo.errorHandler = sharedErrorHandler(location2);
  return requestInfo;
}
function getResumableUploadStatus(service, location2, url, blob) {
  const headers = { "X-Goog-Upload-Command": "query" };
  function handler(xhr) {
    const status = checkResumeHeader_(xhr, ["active", "final"]);
    let sizeString = null;
    try {
      sizeString = xhr.getResponseHeader("X-Goog-Upload-Size-Received");
    } catch (e) {
      handlerCheck(false);
    }
    if (!sizeString) {
      handlerCheck(false);
    }
    const size = Number(sizeString);
    handlerCheck(!isNaN(size));
    return new ResumableUploadStatus(size, blob.size(), status === "final");
  }
  const method = "POST";
  const timeout = service.maxUploadRetryTime;
  const requestInfo = new RequestInfo(url, method, handler, timeout);
  requestInfo.headers = headers;
  requestInfo.errorHandler = sharedErrorHandler(location2);
  return requestInfo;
}
const RESUMABLE_UPLOAD_CHUNK_SIZE = 256 * 1024;
function continueResumableUpload(
  location2,
  service,
  url,
  blob,
  chunkSize,
  mappings,
  status,
  progressCallback
) {
  const status_ = new ResumableUploadStatus(0, 0);
  if (status) {
    status_.current = status.current;
    status_.total = status.total;
  } else {
    status_.current = 0;
    status_.total = blob.size();
  }
  if (blob.size() !== status_.total) {
    throw serverFileWrongSize();
  }
  const bytesLeft = status_.total - status_.current;
  let bytesToUpload = bytesLeft;
  if (chunkSize > 0) {
    bytesToUpload = Math.min(bytesToUpload, chunkSize);
  }
  const startByte = status_.current;
  const endByte = startByte + bytesToUpload;
  let uploadCommand = "";
  if (bytesToUpload === 0) {
    uploadCommand = "finalize";
  } else if (bytesLeft === bytesToUpload) {
    uploadCommand = "upload, finalize";
  } else {
    uploadCommand = "upload";
  }
  const headers = {
    "X-Goog-Upload-Command": uploadCommand,
    "X-Goog-Upload-Offset": `${status_.current}`,
  };
  const body = blob.slice(startByte, endByte);
  if (body === null) {
    throw cannotSliceBlob();
  }
  function handler(xhr, text2) {
    const uploadStatus = checkResumeHeader_(xhr, ["active", "final"]);
    const newCurrent = status_.current + bytesToUpload;
    const size = blob.size();
    let metadata;
    if (uploadStatus === "final") {
      metadata = metadataHandler(service, mappings)(xhr, text2);
    } else {
      metadata = null;
    }
    return new ResumableUploadStatus(
      newCurrent,
      size,
      uploadStatus === "final",
      metadata
    );
  }
  const method = "POST";
  const timeout = service.maxUploadRetryTime;
  const requestInfo = new RequestInfo(url, method, handler, timeout);
  requestInfo.headers = headers;
  requestInfo.body = body.uploadData();
  requestInfo.progressCallback = progressCallback || null;
  requestInfo.errorHandler = sharedErrorHandler(location2);
  return requestInfo;
}
const TaskState = {
  /** The task is currently transferring data. */
  RUNNING: "running",
  /** The task was paused by the user. */
  PAUSED: "paused",
  /** The task completed successfully. */
  SUCCESS: "success",
  /** The task was canceled. */
  CANCELED: "canceled",
  /** The task failed with an error. */
  ERROR: "error",
};
function taskStateFromInternalTaskState(state) {
  switch (state) {
    case "running":
    case "pausing":
    case "canceling":
      return TaskState.RUNNING;
    case "paused":
      return TaskState.PAUSED;
    case "success":
      return TaskState.SUCCESS;
    case "canceled":
      return TaskState.CANCELED;
    case "error":
      return TaskState.ERROR;
    default:
      return TaskState.ERROR;
  }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class Observer {
  constructor(nextOrObserver, error, complete) {
    const asFunctions =
      isFunction$1(nextOrObserver) || error != null || complete != null;
    if (asFunctions) {
      this.next = nextOrObserver;
      this.error = error !== null && error !== void 0 ? error : void 0;
      this.complete =
        complete !== null && complete !== void 0 ? complete : void 0;
    } else {
      const observer = nextOrObserver;
      this.next = observer.next;
      this.error = observer.error;
      this.complete = observer.complete;
    }
  }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function async(f) {
  return (...argsToForward) => {
    Promise.resolve().then(() => f(...argsToForward));
  };
}
class XhrConnection {
  constructor() {
    this.sent_ = false;
    this.xhr_ = new XMLHttpRequest();
    this.initXhr();
    this.errorCode_ = ErrorCode.NO_ERROR;
    this.sendPromise_ = new Promise((resolve) => {
      this.xhr_.addEventListener("abort", () => {
        this.errorCode_ = ErrorCode.ABORT;
        resolve();
      });
      this.xhr_.addEventListener("error", () => {
        this.errorCode_ = ErrorCode.NETWORK_ERROR;
        resolve();
      });
      this.xhr_.addEventListener("load", () => {
        resolve();
      });
    });
  }
  send(url, method, body, headers) {
    if (this.sent_) {
      throw internalError("cannot .send() more than once");
    }
    this.sent_ = true;
    this.xhr_.open(method, url, true);
    if (headers !== void 0) {
      for (const key in headers) {
        if (headers.hasOwnProperty(key)) {
          this.xhr_.setRequestHeader(key, headers[key].toString());
        }
      }
    }
    if (body !== void 0) {
      this.xhr_.send(body);
    } else {
      this.xhr_.send();
    }
    return this.sendPromise_;
  }
  getErrorCode() {
    if (!this.sent_) {
      throw internalError("cannot .getErrorCode() before sending");
    }
    return this.errorCode_;
  }
  getStatus() {
    if (!this.sent_) {
      throw internalError("cannot .getStatus() before sending");
    }
    try {
      return this.xhr_.status;
    } catch (e) {
      return -1;
    }
  }
  getResponse() {
    if (!this.sent_) {
      throw internalError("cannot .getResponse() before sending");
    }
    return this.xhr_.response;
  }
  getErrorText() {
    if (!this.sent_) {
      throw internalError("cannot .getErrorText() before sending");
    }
    return this.xhr_.statusText;
  }
  /** Aborts the request. */
  abort() {
    this.xhr_.abort();
  }
  getResponseHeader(header) {
    return this.xhr_.getResponseHeader(header);
  }
  addUploadProgressListener(listener) {
    if (this.xhr_.upload != null) {
      this.xhr_.upload.addEventListener("progress", listener);
    }
  }
  removeUploadProgressListener(listener) {
    if (this.xhr_.upload != null) {
      this.xhr_.upload.removeEventListener("progress", listener);
    }
  }
}
class XhrTextConnection extends XhrConnection {
  initXhr() {
    this.xhr_.responseType = "text";
  }
}
function newTextConnection() {
  return new XhrTextConnection();
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class UploadTask {
  /**
   * @param ref - The firebaseStorage.Reference object this task came
   *     from, untyped to avoid cyclic dependencies.
   * @param blob - The blob to upload.
   */
  constructor(ref2, blob, metadata = null) {
    this._transferred = 0;
    this._needToFetchStatus = false;
    this._needToFetchMetadata = false;
    this._observers = [];
    this._error = void 0;
    this._uploadUrl = void 0;
    this._request = void 0;
    this._chunkMultiplier = 1;
    this._resolve = void 0;
    this._reject = void 0;
    this._ref = ref2;
    this._blob = blob;
    this._metadata = metadata;
    this._mappings = getMappings();
    this._resumable = this._shouldDoResumable(this._blob);
    this._state = "running";
    this._errorHandler = (error) => {
      this._request = void 0;
      this._chunkMultiplier = 1;
      if (error._codeEquals(StorageErrorCode.CANCELED)) {
        this._needToFetchStatus = true;
        this.completeTransitions_();
      } else {
        const backoffExpired = this.isExponentialBackoffExpired();
        if (isRetryStatusCode(error.status, [])) {
          if (backoffExpired) {
            error = retryLimitExceeded();
          } else {
            this.sleepTime = Math.max(
              this.sleepTime * 2,
              DEFAULT_MIN_SLEEP_TIME_MILLIS
            );
            this._needToFetchStatus = true;
            this.completeTransitions_();
            return;
          }
        }
        this._error = error;
        this._transition(
          "error"
          /* InternalTaskState.ERROR */
        );
      }
    };
    this._metadataErrorHandler = (error) => {
      this._request = void 0;
      if (error._codeEquals(StorageErrorCode.CANCELED)) {
        this.completeTransitions_();
      } else {
        this._error = error;
        this._transition(
          "error"
          /* InternalTaskState.ERROR */
        );
      }
    };
    this.sleepTime = 0;
    this.maxSleepTime = this._ref.storage.maxUploadRetryTime;
    this._promise = new Promise((resolve, reject3) => {
      this._resolve = resolve;
      this._reject = reject3;
      this._start();
    });
    this._promise.then(null, () => {});
  }
  isExponentialBackoffExpired() {
    return this.sleepTime > this.maxSleepTime;
  }
  _makeProgressCallback() {
    const sizeBefore = this._transferred;
    return (loaded) => this._updateProgress(sizeBefore + loaded);
  }
  _shouldDoResumable(blob) {
    return blob.size() > 256 * 1024;
  }
  _start() {
    if (this._state !== "running") {
      return;
    }
    if (this._request !== void 0) {
      return;
    }
    if (this._resumable) {
      if (this._uploadUrl === void 0) {
        this._createResumable();
      } else {
        if (this._needToFetchStatus) {
          this._fetchStatus();
        } else {
          if (this._needToFetchMetadata) {
            this._fetchMetadata();
          } else {
            this.pendingTimeout = setTimeout(() => {
              this.pendingTimeout = void 0;
              this._continueUpload();
            }, this.sleepTime);
          }
        }
      }
    } else {
      this._oneShotUpload();
    }
  }
  _resolveToken(callback) {
    Promise.all([
      this._ref.storage._getAuthToken(),
      this._ref.storage._getAppCheckToken(),
    ]).then(([authToken, appCheckToken]) => {
      switch (this._state) {
        case "running":
          callback(authToken, appCheckToken);
          break;
        case "canceling":
          this._transition(
            "canceled"
            /* InternalTaskState.CANCELED */
          );
          break;
        case "pausing":
          this._transition(
            "paused"
            /* InternalTaskState.PAUSED */
          );
          break;
      }
    });
  }
  // TODO(andysoto): assert false
  _createResumable() {
    this._resolveToken((authToken, appCheckToken) => {
      const requestInfo = createResumableUpload(
        this._ref.storage,
        this._ref._location,
        this._mappings,
        this._blob,
        this._metadata
      );
      const createRequest = this._ref.storage._makeRequest(
        requestInfo,
        newTextConnection,
        authToken,
        appCheckToken
      );
      this._request = createRequest;
      createRequest.getPromise().then((url) => {
        this._request = void 0;
        this._uploadUrl = url;
        this._needToFetchStatus = false;
        this.completeTransitions_();
      }, this._errorHandler);
    });
  }
  _fetchStatus() {
    const url = this._uploadUrl;
    this._resolveToken((authToken, appCheckToken) => {
      const requestInfo = getResumableUploadStatus(
        this._ref.storage,
        this._ref._location,
        url,
        this._blob
      );
      const statusRequest = this._ref.storage._makeRequest(
        requestInfo,
        newTextConnection,
        authToken,
        appCheckToken
      );
      this._request = statusRequest;
      statusRequest.getPromise().then((status) => {
        status = status;
        this._request = void 0;
        this._updateProgress(status.current);
        this._needToFetchStatus = false;
        if (status.finalized) {
          this._needToFetchMetadata = true;
        }
        this.completeTransitions_();
      }, this._errorHandler);
    });
  }
  _continueUpload() {
    const chunkSize = RESUMABLE_UPLOAD_CHUNK_SIZE * this._chunkMultiplier;
    const status = new ResumableUploadStatus(
      this._transferred,
      this._blob.size()
    );
    const url = this._uploadUrl;
    this._resolveToken((authToken, appCheckToken) => {
      let requestInfo;
      try {
        requestInfo = continueResumableUpload(
          this._ref._location,
          this._ref.storage,
          url,
          this._blob,
          chunkSize,
          this._mappings,
          status,
          this._makeProgressCallback()
        );
      } catch (e) {
        this._error = e;
        this._transition(
          "error"
          /* InternalTaskState.ERROR */
        );
        return;
      }
      const uploadRequest = this._ref.storage._makeRequest(
        requestInfo,
        newTextConnection,
        authToken,
        appCheckToken,
        /*retry=*/
        false
        // Upload requests should not be retried as each retry should be preceded by another query request. Which is handled in this file.
      );
      this._request = uploadRequest;
      uploadRequest.getPromise().then((newStatus) => {
        this._increaseMultiplier();
        this._request = void 0;
        this._updateProgress(newStatus.current);
        if (newStatus.finalized) {
          this._metadata = newStatus.metadata;
          this._transition(
            "success"
            /* InternalTaskState.SUCCESS */
          );
        } else {
          this.completeTransitions_();
        }
      }, this._errorHandler);
    });
  }
  _increaseMultiplier() {
    const currentSize = RESUMABLE_UPLOAD_CHUNK_SIZE * this._chunkMultiplier;
    if (currentSize * 2 < 32 * 1024 * 1024) {
      this._chunkMultiplier *= 2;
    }
  }
  _fetchMetadata() {
    this._resolveToken((authToken, appCheckToken) => {
      const requestInfo = getMetadata$2(
        this._ref.storage,
        this._ref._location,
        this._mappings
      );
      const metadataRequest = this._ref.storage._makeRequest(
        requestInfo,
        newTextConnection,
        authToken,
        appCheckToken
      );
      this._request = metadataRequest;
      metadataRequest.getPromise().then((metadata) => {
        this._request = void 0;
        this._metadata = metadata;
        this._transition(
          "success"
          /* InternalTaskState.SUCCESS */
        );
      }, this._metadataErrorHandler);
    });
  }
  _oneShotUpload() {
    this._resolveToken((authToken, appCheckToken) => {
      const requestInfo = multipartUpload(
        this._ref.storage,
        this._ref._location,
        this._mappings,
        this._blob,
        this._metadata
      );
      const multipartRequest = this._ref.storage._makeRequest(
        requestInfo,
        newTextConnection,
        authToken,
        appCheckToken
      );
      this._request = multipartRequest;
      multipartRequest.getPromise().then((metadata) => {
        this._request = void 0;
        this._metadata = metadata;
        this._updateProgress(this._blob.size());
        this._transition(
          "success"
          /* InternalTaskState.SUCCESS */
        );
      }, this._errorHandler);
    });
  }
  _updateProgress(transferred) {
    const old = this._transferred;
    this._transferred = transferred;
    if (this._transferred !== old) {
      this._notifyObservers();
    }
  }
  _transition(state) {
    if (this._state === state) {
      return;
    }
    switch (state) {
      case "canceling":
      case "pausing":
        this._state = state;
        if (this._request !== void 0) {
          this._request.cancel();
        } else if (this.pendingTimeout) {
          clearTimeout(this.pendingTimeout);
          this.pendingTimeout = void 0;
          this.completeTransitions_();
        }
        break;
      case "running":
        const wasPaused = this._state === "paused";
        this._state = state;
        if (wasPaused) {
          this._notifyObservers();
          this._start();
        }
        break;
      case "paused":
        this._state = state;
        this._notifyObservers();
        break;
      case "canceled":
        this._error = canceled();
        this._state = state;
        this._notifyObservers();
        break;
      case "error":
        this._state = state;
        this._notifyObservers();
        break;
      case "success":
        this._state = state;
        this._notifyObservers();
        break;
    }
  }
  completeTransitions_() {
    switch (this._state) {
      case "pausing":
        this._transition(
          "paused"
          /* InternalTaskState.PAUSED */
        );
        break;
      case "canceling":
        this._transition(
          "canceled"
          /* InternalTaskState.CANCELED */
        );
        break;
      case "running":
        this._start();
        break;
    }
  }
  /**
   * A snapshot of the current task state.
   */
  get snapshot() {
    const externalState = taskStateFromInternalTaskState(this._state);
    return {
      bytesTransferred: this._transferred,
      totalBytes: this._blob.size(),
      state: externalState,
      metadata: this._metadata,
      task: this,
      ref: this._ref,
    };
  }
  /**
   * Adds a callback for an event.
   * @param type - The type of event to listen for.
   * @param nextOrObserver -
   *     The `next` function, which gets called for each item in
   *     the event stream, or an observer object with some or all of these three
   *     properties (`next`, `error`, `complete`).
   * @param error - A function that gets called with a `StorageError`
   *     if the event stream ends due to an error.
   * @param completed - A function that gets called if the
   *     event stream ends normally.
   * @returns
   *     If only the event argument is passed, returns a function you can use to
   *     add callbacks (see the examples above). If more than just the event
   *     argument is passed, returns a function you can call to unregister the
   *     callbacks.
   */
  on(type3, nextOrObserver, error, completed) {
    const observer = new Observer(
      nextOrObserver || void 0,
      error || void 0,
      completed || void 0
    );
    this._addObserver(observer);
    return () => {
      this._removeObserver(observer);
    };
  }
  /**
   * This object behaves like a Promise, and resolves with its snapshot data
   * when the upload completes.
   * @param onFulfilled - The fulfillment callback. Promise chaining works as normal.
   * @param onRejected - The rejection callback.
   */
  then(onFulfilled, onRejected) {
    return this._promise.then(onFulfilled, onRejected);
  }
  /**
   * Equivalent to calling `then(null, onRejected)`.
   */
  catch(onRejected) {
    return this.then(null, onRejected);
  }
  /**
   * Adds the given observer.
   */
  _addObserver(observer) {
    this._observers.push(observer);
    this._notifyObserver(observer);
  }
  /**
   * Removes the given observer.
   */
  _removeObserver(observer) {
    const i = this._observers.indexOf(observer);
    if (i !== -1) {
      this._observers.splice(i, 1);
    }
  }
  _notifyObservers() {
    this._finishPromise();
    const observers = this._observers.slice();
    observers.forEach((observer) => {
      this._notifyObserver(observer);
    });
  }
  _finishPromise() {
    if (this._resolve !== void 0) {
      let triggered = true;
      switch (taskStateFromInternalTaskState(this._state)) {
        case TaskState.SUCCESS:
          async(this._resolve.bind(null, this.snapshot))();
          break;
        case TaskState.CANCELED:
        case TaskState.ERROR:
          const toCall = this._reject;
          async(toCall.bind(null, this._error))();
          break;
        default:
          triggered = false;
          break;
      }
      if (triggered) {
        this._resolve = void 0;
        this._reject = void 0;
      }
    }
  }
  _notifyObserver(observer) {
    const externalState = taskStateFromInternalTaskState(this._state);
    switch (externalState) {
      case TaskState.RUNNING:
      case TaskState.PAUSED:
        if (observer.next) {
          async(observer.next.bind(observer, this.snapshot))();
        }
        break;
      case TaskState.SUCCESS:
        if (observer.complete) {
          async(observer.complete.bind(observer))();
        }
        break;
      case TaskState.CANCELED:
      case TaskState.ERROR:
        if (observer.error) {
          async(observer.error.bind(observer, this._error))();
        }
        break;
      default:
        if (observer.error) {
          async(observer.error.bind(observer, this._error))();
        }
    }
  }
  /**
   * Resumes a paused task. Has no effect on a currently running or failed task.
   * @returns True if the operation took effect, false if ignored.
   */
  resume() {
    const valid = this._state === "paused" || this._state === "pausing";
    if (valid) {
      this._transition(
        "running"
        /* InternalTaskState.RUNNING */
      );
    }
    return valid;
  }
  /**
   * Pauses a currently running task. Has no effect on a paused or failed task.
   * @returns True if the operation took effect, false if ignored.
   */
  pause() {
    const valid = this._state === "running";
    if (valid) {
      this._transition(
        "pausing"
        /* InternalTaskState.PAUSING */
      );
    }
    return valid;
  }
  /**
   * Cancels a currently running or paused task. Has no effect on a complete or
   * failed task.
   * @returns True if the operation took effect, false if ignored.
   */
  cancel() {
    const valid = this._state === "running" || this._state === "pausing";
    if (valid) {
      this._transition(
        "canceling"
        /* InternalTaskState.CANCELING */
      );
    }
    return valid;
  }
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class Reference {
  constructor(_service, location2) {
    this._service = _service;
    if (location2 instanceof Location) {
      this._location = location2;
    } else {
      this._location = Location.makeFromUrl(location2, _service.host);
    }
  }
  /**
   * Returns the URL for the bucket and path this object references,
   *     in the form gs://<bucket>/<object-path>
   * @override
   */
  toString() {
    return "gs://" + this._location.bucket + "/" + this._location.path;
  }
  _newRef(service, location2) {
    return new Reference(service, location2);
  }
  /**
   * A reference to the root of this object's bucket.
   */
  get root() {
    const location2 = new Location(this._location.bucket, "");
    return this._newRef(this._service, location2);
  }
  /**
   * The name of the bucket containing this reference's object.
   */
  get bucket() {
    return this._location.bucket;
  }
  /**
   * The full path of this object.
   */
  get fullPath() {
    return this._location.path;
  }
  /**
   * The short name of this object, which is the last component of the full path.
   * For example, if fullPath is 'full/path/image.png', name is 'image.png'.
   */
  get name() {
    return lastComponent(this._location.path);
  }
  /**
   * The `StorageService` instance this `StorageReference` is associated with.
   */
  get storage() {
    return this._service;
  }
  /**
   * A `StorageReference` pointing to the parent location of this `StorageReference`, or null if
   * this reference is the root.
   */
  get parent() {
    const newPath = parent$1(this._location.path);
    if (newPath === null) {
      return null;
    }
    const location2 = new Location(this._location.bucket, newPath);
    return new Reference(this._service, location2);
  }
  /**
   * Utility function to throw an error in methods that do not accept a root reference.
   */
  _throwIfRoot(name2) {
    if (this._location.path === "") {
      throw invalidRootOperation(name2);
    }
  }
}
function uploadBytesResumable$1(ref2, data, metadata) {
  ref2._throwIfRoot("uploadBytesResumable");
  return new UploadTask(ref2, new FbsBlob(data), metadata);
}
function getDownloadURL$1(ref2) {
  ref2._throwIfRoot("getDownloadURL");
  const requestInfo = getDownloadUrl(
    ref2.storage,
    ref2._location,
    getMappings()
  );
  return ref2.storage
    .makeRequestWithTokens(requestInfo, newTextConnection)
    .then((url) => {
      if (url === null) {
        throw noDownloadURL();
      }
      return url;
    });
}
function _getChild$1(ref2, childPath) {
  const newPath = child(ref2._location.path, childPath);
  const location2 = new Location(ref2._location.bucket, newPath);
  return new Reference(ref2.storage, location2);
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function isUrl(path) {
  return /^[A-Za-z]+:\/\//.test(path);
}
function refFromURL(service, url) {
  return new Reference(service, url);
}
function refFromPath(ref2, path) {
  if (ref2 instanceof FirebaseStorageImpl) {
    const service = ref2;
    if (service._bucket == null) {
      throw noDefaultBucket();
    }
    const reference = new Reference(service, service._bucket);
    if (path != null) {
      return refFromPath(reference, path);
    } else {
      return reference;
    }
  } else {
    if (path !== void 0) {
      return _getChild$1(ref2, path);
    } else {
      return ref2;
    }
  }
}
function ref$1(serviceOrRef, pathOrUrl) {
  if (pathOrUrl && isUrl(pathOrUrl)) {
    if (serviceOrRef instanceof FirebaseStorageImpl) {
      return refFromURL(serviceOrRef, pathOrUrl);
    } else {
      throw invalidArgument(
        "To use ref(service, url), the first argument must be a Storage instance."
      );
    }
  } else {
    return refFromPath(serviceOrRef, pathOrUrl);
  }
}
function extractBucket(host, config) {
  const bucketString =
    config === null || config === void 0
      ? void 0
      : config[CONFIG_STORAGE_BUCKET_KEY];
  if (bucketString == null) {
    return null;
  }
  return Location.makeFromBucketSpec(bucketString, host);
}
function connectStorageEmulator$1(storage2, host, port, options = {}) {
  storage2.host = `${host}:${port}`;
  storage2._protocol = "http";
  const { mockUserToken } = options;
  if (mockUserToken) {
    storage2._overrideAuthToken =
      typeof mockUserToken === "string"
        ? mockUserToken
        : createMockUserToken(mockUserToken, storage2.app.options.projectId);
  }
}
class FirebaseStorageImpl {
  constructor(app2, _authProvider, _appCheckProvider, _url, _firebaseVersion) {
    this.app = app2;
    this._authProvider = _authProvider;
    this._appCheckProvider = _appCheckProvider;
    this._url = _url;
    this._firebaseVersion = _firebaseVersion;
    this._bucket = null;
    this._host = DEFAULT_HOST;
    this._protocol = "https";
    this._appId = null;
    this._deleted = false;
    this._maxOperationRetryTime = DEFAULT_MAX_OPERATION_RETRY_TIME;
    this._maxUploadRetryTime = DEFAULT_MAX_UPLOAD_RETRY_TIME;
    this._requests = /* @__PURE__ */ new Set();
    if (_url != null) {
      this._bucket = Location.makeFromBucketSpec(_url, this._host);
    } else {
      this._bucket = extractBucket(this._host, this.app.options);
    }
  }
  /**
   * The host string for this service, in the form of `host` or
   * `host:port`.
   */
  get host() {
    return this._host;
  }
  set host(host) {
    this._host = host;
    if (this._url != null) {
      this._bucket = Location.makeFromBucketSpec(this._url, host);
    } else {
      this._bucket = extractBucket(host, this.app.options);
    }
  }
  /**
   * The maximum time to retry uploads in milliseconds.
   */
  get maxUploadRetryTime() {
    return this._maxUploadRetryTime;
  }
  set maxUploadRetryTime(time) {
    validateNumber(
      "time",
      /* minValue=*/
      0,
      /* maxValue= */
      Number.POSITIVE_INFINITY,
      time
    );
    this._maxUploadRetryTime = time;
  }
  /**
   * The maximum time to retry operations other than uploads or downloads in
   * milliseconds.
   */
  get maxOperationRetryTime() {
    return this._maxOperationRetryTime;
  }
  set maxOperationRetryTime(time) {
    validateNumber(
      "time",
      /* minValue=*/
      0,
      /* maxValue= */
      Number.POSITIVE_INFINITY,
      time
    );
    this._maxOperationRetryTime = time;
  }
  async _getAuthToken() {
    if (this._overrideAuthToken) {
      return this._overrideAuthToken;
    }
    const auth2 = this._authProvider.getImmediate({ optional: true });
    if (auth2) {
      const tokenData = await auth2.getToken();
      if (tokenData !== null) {
        return tokenData.accessToken;
      }
    }
    return null;
  }
  async _getAppCheckToken() {
    const appCheck = this._appCheckProvider.getImmediate({ optional: true });
    if (appCheck) {
      const result = await appCheck.getToken();
      return result.token;
    }
    return null;
  }
  /**
   * Stop running requests and prevent more from being created.
   */
  _delete() {
    if (!this._deleted) {
      this._deleted = true;
      this._requests.forEach((request) => request.cancel());
      this._requests.clear();
    }
    return Promise.resolve();
  }
  /**
   * Returns a new firebaseStorage.Reference object referencing this StorageService
   * at the given Location.
   */
  _makeStorageReference(loc) {
    return new Reference(this, loc);
  }
  /**
   * @param requestInfo - HTTP RequestInfo object
   * @param authToken - Firebase auth token
   */
  _makeRequest(
    requestInfo,
    requestFactory,
    authToken,
    appCheckToken,
    retry = true
  ) {
    if (!this._deleted) {
      const request = makeRequest(
        requestInfo,
        this._appId,
        authToken,
        appCheckToken,
        requestFactory,
        this._firebaseVersion,
        retry
      );
      this._requests.add(request);
      request.getPromise().then(
        () => this._requests.delete(request),
        () => this._requests.delete(request)
      );
      return request;
    } else {
      return new FailRequest(appDeleted());
    }
  }
  async makeRequestWithTokens(requestInfo, requestFactory) {
    const [authToken, appCheckToken] = await Promise.all([
      this._getAuthToken(),
      this._getAppCheckToken(),
    ]);
    return this._makeRequest(
      requestInfo,
      requestFactory,
      authToken,
      appCheckToken
    ).getPromise();
  }
}
const name$1 = "@firebase/storage";
const version$1 = "0.12.4";
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const STORAGE_TYPE = "storage";
function uploadBytesResumable(ref2, data, metadata) {
  ref2 = getModularInstance(ref2);
  return uploadBytesResumable$1(ref2, data, metadata);
}
function getDownloadURL(ref2) {
  ref2 = getModularInstance(ref2);
  return getDownloadURL$1(ref2);
}
function ref(serviceOrRef, pathOrUrl) {
  serviceOrRef = getModularInstance(serviceOrRef);
  return ref$1(serviceOrRef, pathOrUrl);
}
function getStorage(app2 = getApp(), bucketUrl) {
  app2 = getModularInstance(app2);
  const storageProvider = _getProvider(app2, STORAGE_TYPE);
  const storageInstance = storageProvider.getImmediate({
    identifier: bucketUrl,
  });
  const emulator = getDefaultEmulatorHostnameAndPort("storage");
  if (emulator) {
    connectStorageEmulator(storageInstance, ...emulator);
  }
  return storageInstance;
}
function connectStorageEmulator(storage2, host, port, options = {}) {
  connectStorageEmulator$1(storage2, host, port, options);
}
function factory(container, { instanceIdentifier: url }) {
  const app2 = container.getProvider("app").getImmediate();
  const authProvider = container.getProvider("auth-internal");
  const appCheckProvider = container.getProvider("app-check-internal");
  return new FirebaseStorageImpl(
    app2,
    authProvider,
    appCheckProvider,
    url,
    SDK_VERSION
  );
}
function registerStorage() {
  _registerComponent(
    new Component(
      STORAGE_TYPE,
      factory,
      "PUBLIC"
      /* ComponentType.PUBLIC */
    ).setMultipleInstances(true)
  );
  registerVersion(name$1, version$1, "");
  registerVersion(name$1, version$1, "esm2017");
}
registerStorage();
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const FUNCTIONS_TYPE = "functions";
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class ContextProvider {
  constructor(authProvider, messagingProvider, appCheckProvider) {
    this.auth = null;
    this.messaging = null;
    this.appCheck = null;
    this.auth = authProvider.getImmediate({ optional: true });
    this.messaging = messagingProvider.getImmediate({
      optional: true,
    });
    if (!this.auth) {
      authProvider.get().then(
        (auth2) => (this.auth = auth2),
        () => {}
      );
    }
    if (!this.messaging) {
      messagingProvider.get().then(
        (messaging) => (this.messaging = messaging),
        () => {}
      );
    }
    if (!this.appCheck) {
      appCheckProvider.get().then(
        (appCheck) => (this.appCheck = appCheck),
        () => {}
      );
    }
  }
  async getAuthToken() {
    if (!this.auth) {
      return void 0;
    }
    try {
      const token2 = await this.auth.getToken();
      return token2 === null || token2 === void 0 ? void 0 : token2.accessToken;
    } catch (e) {
      return void 0;
    }
  }
  async getMessagingToken() {
    if (
      !this.messaging ||
      !("Notification" in self) ||
      Notification.permission !== "granted"
    ) {
      return void 0;
    }
    try {
      return await this.messaging.getToken();
    } catch (e) {
      return void 0;
    }
  }
  async getAppCheckToken(limitedUseAppCheckTokens) {
    if (this.appCheck) {
      const result = limitedUseAppCheckTokens
        ? await this.appCheck.getLimitedUseToken()
        : await this.appCheck.getToken();
      if (result.error) {
        return null;
      }
      return result.token;
    }
    return null;
  }
  async getContext(limitedUseAppCheckTokens) {
    const authToken = await this.getAuthToken();
    const messagingToken = await this.getMessagingToken();
    const appCheckToken = await this.getAppCheckToken(limitedUseAppCheckTokens);
    return { authToken, messagingToken, appCheckToken };
  }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const DEFAULT_REGION = "us-central1";
class FunctionsService {
  /**
   * Creates a new Functions service for the given app.
   * @param app - The FirebaseApp to use.
   */
  constructor(
    app2,
    authProvider,
    messagingProvider,
    appCheckProvider,
    regionOrCustomDomain = DEFAULT_REGION,
    fetchImpl
  ) {
    this.app = app2;
    this.fetchImpl = fetchImpl;
    this.emulatorOrigin = null;
    this.contextProvider = new ContextProvider(
      authProvider,
      messagingProvider,
      appCheckProvider
    );
    this.cancelAllRequests = new Promise((resolve) => {
      this.deleteService = () => {
        return Promise.resolve(resolve());
      };
    });
    try {
      const url = new URL(regionOrCustomDomain);
      this.customDomain = url.origin;
      this.region = DEFAULT_REGION;
    } catch (e) {
      this.customDomain = null;
      this.region = regionOrCustomDomain;
    }
  }
  _delete() {
    return this.deleteService();
  }
  /**
   * Returns the URL for a callable with the given name.
   * @param name - The name of the callable.
   * @internal
   */
  _url(name2) {
    const projectId = this.app.options.projectId;
    if (this.emulatorOrigin !== null) {
      const origin = this.emulatorOrigin;
      return `${origin}/${projectId}/${this.region}/${name2}`;
    }
    if (this.customDomain !== null) {
      return `${this.customDomain}/${name2}`;
    }
    return `https://${this.region}-${projectId}.cloudfunctions.net/${name2}`;
  }
}
function connectFunctionsEmulator$1(functionsInstance, host, port) {
  functionsInstance.emulatorOrigin = `http://${host}:${port}`;
}
const name = "@firebase/functions";
const version = "0.11.4";
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const AUTH_INTERNAL_NAME = "auth-internal";
const APP_CHECK_INTERNAL_NAME = "app-check-internal";
const MESSAGING_INTERNAL_NAME = "messaging-internal";

/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function getFunctions(app2 = getApp(), regionOrCustomDomain = DEFAULT_REGION) {
  const functionsProvider = _getProvider(
    getModularInstance(app2),
    FUNCTIONS_TYPE
  );
  const functionsInstance = functionsProvider.getImmediate({
    identifier: regionOrCustomDomain,
  });
  const emulator = getDefaultEmulatorHostnameAndPort("functions");
  if (emulator) {
    connectFunctionsEmulator(functionsInstance, ...emulator);
  }
  return functionsInstance;
}
function connectFunctionsEmulator(functionsInstance, host, port) {
  connectFunctionsEmulator$1(getModularInstance(functionsInstance), host, port);
}

const getAllImages = async (uid, selected_link) => {
  
  const data = {
    foldername: "preview_images",
    customer_id: customer_custom_store,
    selected_link: selected_link,
  };
  data.ip = device_ip
 
  if(!data.ip) data.ip =await ipaddress()
  if(!data.ip) data.ip =await ipaddress()
  if(!data.ip) data.ip =await ipaddress()
  if(!data.ip) data.ip =await ipaddress()
  if(!data.ip) data.ip =await ipaddress()
  const fingerprint = await getFingerprint();
  return fetch("https://webhook.wallart.ai/getImageHistoryNewDev", {
    method: "POST",
    headers: {
      "content-type": "application/json",
      "x-device-id": fingerprint,
    },
    body: JSON.stringify(data),
  }).then((res) =>{ 
  
      setTimeout(async () => {
      // let takeatourmodal =  await getCookiein("takeatourmodalopned");
      // if(!takeatourmodal) opentakeatourmodalModal()
      document.cookie = `takeatourmodalopned=true`;
      // opentakeatourmodalModal()
      }, 100);
    return res.json()
  
  });
};
const doIOwnTheArtInURL = async (imageUrl, uid) => {
  if (!imageUrl || !uid) return false;
  const imageCollection = collection(db, "images");
  const imageName = imageUrl.split("/").pop().split(".")[0];
  try {
    const q2 = query(
      imageCollection,
      where("name", "==", Number(imageName)),
      where("uid", "==", uid)
    );
    const querySnapshot = await getDocs(q2);
    return !querySnapshot.empty;
  } catch (error) {
    return false;
  }
};
// Encrypt IP address
// async function encryptIp(ip) {
//   const encoder = new TextEncoder();
//   const key = await crypto.subtle.importKey(
//     "raw",
//     encoder.encode("dfgfdsasdedfrtghbvgfrdcvftyuhjkm"), // Must be 32 bytes for AES-256
//     { name: "AES-CBC", length: 256 },
//     false,
//     ["encrypt"]
//   );
//   const iv = crypto.getRandomValues(new Uint8Array(16)); // Initialization vector
//   const encrypted = await crypto.subtle.encrypt(
//     { name: "AES-CBC", iv },
//     key,
//     encoder.encode(ip)
//   );
//   const encryptedBase64 = btoa(
//     String.fromCharCode(...new Uint8Array(encrypted))
//   );
//   const ivBase64 = btoa(String.fromCharCode(...iv));
//   return { data: encryptedBase64, iv: ivBase64 };
// }
// Working code backup
function blobToBase64(blob) {
  return new Promise((resolve) => {
    const reader = new FileReader();
    reader.onloadend = () => resolve(reader.result); // Base64 string
    reader.readAsDataURL(blob); // Convert blob to base64
  });
}
const checktodaysimagecount = async (check_customer_id,check_ip_address, prompt )=>{
      const fingerprint = await getFingerprint();
      return fetch("https://webhook.wallart.ai/checktodaysimagecount", {
        method: "POST",
        headers: {
          "content-type": "application/json",
          "x-device-id": fingerprint,
        },
        body: JSON.stringify({
          customer_id:check_customer_id, ip :check_ip_address, prompt:prompt
        }),
      }).then((response) => response.json());
}
const generateImageFromText = async (body) => {
    
    if (customer_custom_store) {
      body.customer_id = customer_custom_store;
    } else {
      body.customer_id = false;
    }
    body.type = "imagefromtext";
    const fingerprint = await getFingerprint();
    delete body.imageUrl;
    body.Style = body.stylePreset.Style;
    body.guidance_scale = body.stylePreset.guidance_scale;
    body.inference_steps = body.stylePreset.inference_steps;
    body.label = body.stylePreset.label;
    body.negative = body.stylePreset.negative;
    body.prefix = body.stylePreset.prefix;
    body.suffix = body.stylePreset.suffix;
    body.ip = device_ip
    if(!body.ip) body.ip= await ipaddress()
    if(!body.ip) body.ip=await ipaddress()
    if(!body.ip) body.ip=await ipaddress()
    if(!body.ip) body.ip=await ipaddress()
    if(!body.ip) body.ip=await ipaddress()
    body.prompt = body.convertedprompt?body.convertedprompt:body.prompt
    // console.log("body-action--", body.action)
    // console.log("body-prompt--", body.prompt)
    // console.log("body--Style-", body.Style)
    return fetch("https://webhook.wallart.ai/generateImageflux2", {
      method: "POST",
      headers: {
        "content-type": "application/json",
        "x-device-id": fingerprint,
      },
      body: JSON.stringify(body),
    }).then(async (res) => {
      let response = res.json();
      await checkimagegenerationstatus(response);
      return response;
    });
};
const delay3 = (ms) => new Promise(resolve => setTimeout(resolve, ms));

const getimagedescription = async () => {
  while (!image_description) {
    await delay3(200); 
  }
  return image_description;
};
const editimage = async(body)=>{
  
    if (customer_custom_store) {
        body.customer_id = customer_custom_store;
      } else {
        body.customer_id = false;
      }
      body.type = "editimage";
     
      if(body.convertedprompt)  body.prompt= body.convertedprompt;
      else  body.prompt = body.editimageprompt;
      body.ip = device_ip
      // body.image_description = await getimagedescription();
        body.image_description = "";
      if(!body.ip) body.ip=await ipaddress()
      if(!body.ip) body.ip=await ipaddress()
      if(!body.ip) body.ip=await ipaddress()
      if(!body.ip) body.ip=await ipaddress()
      if(!body.ip) body.ip=await ipaddress()
      const fingerprint = await getFingerprint();
      //https://webhook.wallart.ai
      return fetch("https://webhook.wallart.ai/editImage", {
        method: "POST",
        headers: {
          "content-type": "application/json",
          "x-device-id": fingerprint,
        },
        body: JSON.stringify(body),
      }).then(async (res) =>{ 
        let response = res.json();
            generated_image_array.push(action)
            
            if(generated_image_array.length==2 && generated_image_array.includes(action)){
                image_description = false
                editimageprompt = false
                imagetobeedited = false
                formDetailHistory = false
            }
      
          await checkimagegenerationstatus(response, 2)
     
        
        return response
      });  
}
const delay2 = (ms) => new Promise(resolve => setTimeout(resolve, ms));
// const checkvalidateimage = async ()=>{
//   while (validated_image === "in progress") {
//     await delay2(200); 
//   }
//   return validated_image;
// }
const checkvalidateimage = async ()=>{
    let c = 1;
    while (c <= 30) {
        // console.log("validating image attempt:", c, validated_image )
        if (validated_image!="in progress") {
          return validated_image; // image exists
        }
        await delay2(200); 
        c++;
    }
    return validated_image;
}
const checkimagestatus = async () => {
    let c = 1;
    while (c <= 50) {
          
          if ( get_image_detail!="in progress") {
            return true; // image exists
          }
          await delay2(200);
          c++;
    }
    return get_image_detail;
};

const checkimagegenerationstatus = async (response, maximage = 4)=>{
      if(response && !response.error) {
        
        if(!customer_custom_store){
          if(response?.total_image_generated==100){
            openerrormodalcontentModal("Please note that you only have 20 left for today")
          }
        }
        // if(action == "4" || action == 4){
        if(generated_image_array.length==maximage && generated_image_array.includes(action)){
          if(!customer_custom_store){
            setTimeout(async function () {
             
              let prompttosignupmodal =  await getCookiein("prompttosignupmodalopned");
      
              if(!prompttosignupmodal) openprompttosignupmodalModal(false)
              document.cookie = `prompttosignupmodalopned=true`;
  
            }, 2000)
          }
          try{
  
            const iframe = document.getElementById('iframe');
            const iframeDoc = iframe.contentWindow.document;
            iframeDoc.getElementById("edit-image").classList.remove("hidden");
            iframeDoc.getElementById("hreartunhearticon").classList.remove("hidden");
           }
           catch(err){
            console.log(err)
           }
           generated_image_array = []
           image_generation_error = false;
      }
      }
}
const generateImageFromImage = async (body) => {

  // console.log("hello")
  let validateimage = await checkvalidateimage()
  if(!validateimage) return {"error":true, "message":image_validation_error}
  let status = await checkimagestatus()
  
  

  if (customer_custom_store) {
    body.customer_id = customer_custom_store;
  } else {
    body.customer_id = false;
  }
 
  body.type = "imagefromimage";
  body.numberoffaces = numberoffaces;
  const fingerprint = await getFingerprint();
  const formData = new FormData();
  if(!body.imageUrl || body.imageUrl==""){
    if(formDetailHistoryImageURL) formData.append("imageUrl", formDetailHistoryImageURL);
    else return {"error":true, "message":"Please upload an image"}
  }else{
    if(typeof body.imageUrl=="string" || typeof body.imageUrl=="String")  formData.append("imageUrl", body.imageUrl); 
    else formData.append("imageUrl", body.imageUrl, "image"); // Append the blob with a filename
  }
  
  

  formData.append("action", body.action);
  formData.append("custom_style", body.custom_style);
  formData.append("height", body.height);
  formData.append("type", body.type);
  formData.append("numberoffaces", body.numberoffaces);
  formData.append("imageContentType", body.imageContentType);
  if(body.convertedprompt) formData.append("prompt", body.convertedprompt);
  else formData.append("prompt", body.prompt);
  formData.append("seed", body.seed);
  formData.append("createcompositionsame", body.createcompositionsame);

  while(!croppedimages3bucketurl){
    await delay2(100); 
  } 
  while(image_detail_array.length == 0){
    await delay2(100); 
  } 
  if(croppedimages3bucketurl){ 
    
    formData.append("originalimageurl", croppedimages3bucketurl);
    
  }
  
  if (croppedimages3bucketurl && image_detail_array.length > 0){
    
    for (let i = 0; i < image_detail_array.length; i++) {
      const item = image_detail_array[i];

      for (const key in item) {
        const value = item[key];
        // console.log("value----------", value)
        // console.log("value.imageid-------------", value["imageid"])
        if(value["imageid"] == body.imageid)
              image_detail = value;
        
      }
    }
  }
  else{
    
    image_detail = {"girl child":0,"boy child":0,"adult woman":0,"adult man":0, "number of animals":0, "toddler":0, "object":1,"objectname":"","total figures":0,"image_detail_inshort":""};
  }
  
  formData.append("image_detail", JSON.stringify(image_detail));
  formData.append("width", body.width);
  formData.append("customer_id", body.customer_id);

  formData.append("Style", body.stylePreset.Style);
  formData.append("guidance_scale", body.stylePreset.guidance_scale);
  formData.append("inference_steps", body.stylePreset.inference_steps);
  formData.append("label", body.stylePreset.label);
  formData.append("negative", body.stylePreset.negative);
  formData.append("prefix", body.stylePreset.prefix);
  formData.append("suffix", body.stylePreset.suffix);
  body.ip = device_ip
  if(!body.ip) body.ip=await ipaddress()
  if(!body.ip) body.ip=await ipaddress()
  if(!body.ip) body.ip=await ipaddress()
  if(!body.ip) body.ip=await ipaddress()
  if(!body.ip) body.ip= await ipaddress()
  formData.append("ip", body.ip);
  // for (let [key, value] of formData.entries()) {
    // if(key == "image_detail") console.log(key, value);
    // console.log("-----------------------------------------")
  // }
  return fetch("https://webhook.wallart.ai/generateImage", {
    method: "POST",
    body: formData,
      headers: {
      "x-device-id": fingerprint,
    },
  }).then(async (res) => {
    // console.log("generated image -----------------")
    let response = res.json()
    await checkimagegenerationstatus(response)
    return response
  });
};

const global$1 = {
  product: window.product,
  lang: {
    heading:
      ((_a = window == null ? void 0 : window.layout) == null
        ? void 0
        : _a.heading) || "Heading",
    subtext:
      ((_b = window == null ? void 0 : window.layout) == null
        ? void 0
        : _b.subtext) || "Subtext",
    loading:
      ((_c = window == null ? void 0 : window.layout) == null
        ? void 0
        : _c.loading) || "Loading",
    placeholder:
      ((_d = window == null ? void 0 : window.layout) == null
        ? void 0
        : _d.placeholder) || "placeholder",
    orderButtonText:
      ((_e2 = window == null ? void 0 : window.layout) == null
        ? void 0
        : _e2.orderButtonText) || "Purchase Options",
  },
  galleryImages: [],
  backgroundImageSrc:
    ((_g =
      (_f = window == null ? void 0 : window.layout) == null
        ? void 0
        : _f.backgroundImageSrc) == null
      ? void 0
      : _g.src) ||
    "https://cdn.shopify.com/s/files/1/0736/6996/8165/files/background.jpg?v=1699444641",
 stylePresets: [
    {
      label: "Random Styles",
      prefix:
        "Fusion of futuristic, synthwave, abstract elements with vibrancy of pop art of",
      suffix:
        "anime and synthwave, intertwining the imaginative with the futuristic",
      negative:
        "Avoid leaning heavily towards one style, Exclude traditional boundaries of styles, No isolated elements without integration",
      guidance_scale: 7,
      inference_steps: 14,
    },{
      label: "Custom Style",
      prefix:
        "Fusion of futuristic, synthwave, abstract elements with vibrancy of pop art of",
      suffix:
        "anime and synthwave, intertwining the imaginative with the futuristic",
      negative:
        "Avoid leaning heavily towards one style, Exclude traditional boundaries of styles, No isolated elements without integration",
      guidance_scale: 7.3,
      inference_steps: 28,
    },{
      label: "Watercolor",
      prefix: "",
      Style: "Watercolor",
      suffix:
        "Soft watercolor painting, gentle washes, blended pigments, light diffusion, hand-painted texture. Avoid sharp lines, Avoid heavy saturation",
      negative: "No sharp lines, Avoid heavy saturation",
      guidance_scale: 7.3,
      inference_steps: 28,
    },
    {
      label: "Impressionism",
      prefix: "",
      Style: "Impressionism",
      // suffix:
      //   "Bold, modern digital impressionist style with the subject clearly defined using refined, high-contrast brushwork and color separation. The background features radiant, outward-moving strokes that combine washed-out luminous hues with thick, textural oil paint applied with palette knife techniques. Use dynamic layering and intentional color variation to create a glowing aura around the subject, amplifying separation and depth. Brush textures should vary from soft blends on the subject to aggressive, expressive impasto strokes in the background. Emphasize movement, light, and painterly emotion. 4K resolution, gallery-worthy finish—ideal for fine art prints and trending on ArtStation. Avoid detailed precision, Exclude dark, moody settings",
      suffix:"painted entirely in a rich impressionist style. The whole scene —  subject itself — rendered with visible oil brush strokes and soft color blending. Warm golden sunlight reflecting on the pavement, dynamic paint textures capturing motion, inspired by the loose brushwork of impressionist painters. Soft glowing atmosphere, vibrant color palette, artistic painterly motion.",
      negative: "No detailed precision, Exclude dark, moody settings",
      guidance_scale: 7.3,
      inference_steps: 28,
    },
 
    {
      label: "Futuristic",
      prefix: "",
      Style: "Futuristic",
      // suffix:
      //   " Cyberpunk 4K art: sleek metallic aesthetic, glowing neon blues, teals, and oranges. Futuristic cityscape with rain-slick streets, holographic billboards, and dramatic lighting. Subject in advanced, futuristic clothing with illuminated tech details. Emphasize symmetry, cinematic depth, and powerful post-digital presence—ideal for concept art and ArtStation",
      suffix:"Cyberpunk 4K art:  glowing neon blues, teals, and oranges. Futuristic cityscape with rain-slick streets, holographic billboards, and dramatic lighting. Emphasize symmetry, cinematic depth, and powerful post-digital presence—ideal for concept art",
      negative: "Avoid traditional designs, No historical references",
      guidance_scale: 7.3,
      inference_steps: 28,
    },
    {
      label: "Photorealistic",
      prefix: "",
      Style: "Photorealistic",
      suffix:
        "Ultra-detailed, lifelike representation, true-to-life lighting, 4K UHD, Sony FE 85mm f/1.8 lens quality. Avoid exaggerated colors, No abstract interpretations",
      negative: "No exaggerated colors, No abstract interpretations",
      guidance_scale: 7.3,
      inference_steps: 35,
    },
    {
      label: "Abstract",
      prefix: "",
      Style: "Abstract",
      suffix:
        "Stylized abstract art, bold geometric contrasts, expressive strokes, fluid shapes in background, 4K resolution. Avoid clear subjects, Exclude detailed backgrounds",
      negative: "No clear subjects, Exclude detailed backgrounds",
      guidance_scale: 7.3,
      inference_steps: 28,
    },
    {
      label: "Minimalist",
      prefix: "",
      Style: "Minimalist",
      suffix:
        "Simplified rendering, bare essentials, muted tones, basic shapes, crisp lines, 4K sharpness. Avoid intricate designs, Avoid clutter",
      negative: "No intricate designs, Avoid clutter",
      guidance_scale: 7.3,
      inference_steps: 28,
    },
    {
      label: "Pop Art",
      prefix: "",
      Style: "Pop Art",
      suffix:
        "Bold comic-style illustration with vibrant, high-contrast colors; thick black outlines;  dramatic expressions or dynamic poses; exaggerated highlights and shadows; explosive backgrounds with radial bursts or geometric patterns; halftone textures and Ben-Day dot shading in the background; inspired by 1960s Roy Lichtenstein and vintage comic book aesthetics; clean, graphic look designed for visual impact; 4K resolution, crisp and eye-catching, perfect for trending on ArtStation. Avoid realism, No muted colors",
      negative: "Avoid realism, No muted colors",
      guidance_scale: 7.3,
      inference_steps: 28,
    },
    {
      label: "3D Animated",
      prefix: "",
      Style: "3D Animated",
      suffix:
        "CGI rendering, dynamic lighting, high-definition digital environment, 3D modeling, 4K HD. Avoid flat designs, exclude 2D elements",
      negative: "No flat designs, exclude 2D elements",
      guidance_scale: 7.5,
      inference_steps: 32,
    },
    {
      label: "Anime",
      prefix: "",
      Style: "Anime",
      suffix:
        "High-resolution anime-style illustration with expressive, oversized eyes featuring detailed highlights and reflections; smooth and intricate with subtle gradients; finely drawn details; soft lighting with gentle bloom and background bokeh; engaging expressions with a slightly dreamy or heartfelt tone; 4K resolution, polished and ideal for trending on Pixiv or ArtStation poses. Avoid western character designs, Exclude muted colors",
      negative: "No western character designs, Exclude muted colors",
      guidance_scale: 7.3,
      inference_steps: 28,
    },
    {
      label: "Synthwave",
      prefix: "",
      Style: "Synthwave",
      // suffix:
      //   "80s neon representation, retro-futuristic grid, synth-filled atmosphere, neon glow, 4K, intricate detail. Avoid natural colors",
      suffix:"synthwaveSUBJECT, ultra-detailed vector illustration, geometric shapes, sharp clean lines, smooth gradients, high contrast lighting, neon color palette (electric blue, magenta, cyan, purple, hot pink), dramatic rim lighting, glowing edges, cyberpunk aesthetic, dark background, vibrant color blocking, glossy highlights, soft airbrush shading, editorial fashion lighting, minimal background, poster design, crisp outlines, depth and shadows --v 6 --style raw --q 2 --s 750",
      negative: "No natural colors",
      guidance_scale: 7.3,
      inference_steps: 28,
    },
    
    {
      label: "Vector Art",
      prefix: "",
      Style: "Vector Art",
      suffix:
        "Stylized, cartoon-inspired digital vector art with clean lines, bold shapes, and smooth gradients; exaggerated proportions and expressive features for a playful, modern aesthetic; cinematic lighting with rich shadows and glowing highlights to simulate 3D depth; vivid, saturated color palette with high contrast; dynamic posing and movement-friendly framing; glossy, polished finish which would be suitable for mobile games, branding, or sticker packs; 4K resolution, crisp and professional, trending on Dribbble and Behance.",
      negative: "",
      guidance_scale: 7.3,
      inference_steps: 28,
    },
    {
      label: "Steampunk",
      prefix: "",
      Style: "VSteampunk",
      suffix:
        "Richly detailed steampunk aesthetic with ornate Victorian-era influences and mechanical embellishments; brass, copper, and aged leather textures throughout; gears, cogs, steam vents, and intricate machinery integrated into the subject design; warm, sepia or rust-toned color palette with metallic highlights; moody or dramatic lighting with a cinematic atmosphere; subject may include goggles, timepieces, pipes, or industrial accessories; setting may feature old-world backdrops, clockwork environments, or mechanical skies; high-resolution, concept art quality, perfect for graphic novels, fantasy posters, or ArtStation showcases.",
      negative: "",
      guidance_scale: 7.3,
      inference_steps: 28,
    },
    {
      label: "Retro",
      prefix: "",
      Style: "Retro",
      suffix:
        "Do not use rounded corners and border,70s-inspired vintage rendition, grainy 4K finish, retro textures, old-school color palette, faded background and subtle faded hues at sides, giving it a nostalgic vintage feel, no rounded corners,use sharp corners",
      negative: "Avoid futuristic elements and digital enhancements",
      guidance_scale: 6.5,
      inference_steps: 26,
    } ,  {
      label: "Whimsacle",
      prefix:
        "Fusion of futuristic, synthwave, abstract elements with vibrancy of pop art of",
      Style: "Imaginative",
      suffix:`Surreal, story-driven composition blending reality with fantasy in a vivid, dreamlike visual narrative. Merge unexpected elements—celestial, mythic, symbolic, or organic—into a unified scene that evokes wonder, mystery, or transcendence. Use flowing forms, radiant color transitions, and layered symbolism. Backgrounds should feel cosmic, otherworldly, or spiritual, incorporating glowing lights, starscapes, natural motifs, or sacred geometry.Exclude all human figures or hands—focus solely on the subject and imaginative environment. Avoid gallery-art composition styles that include signature areas. Ensure the bottom corners remain clean, blank, and uninterrupted. Prioritize painterly textures, emotional lighting, imaginative logic (floating objects, giant symbolism, celestial interaction). Use 4K resolution with gallery-quality depth—ideal for visionary art collectors and trending on ArtStation.`,

      negative: "No realistic elements, Exclude modern settings",
      guidance_scale: 7.3,
      inference_steps: 28,
    },
    
  ],
  imageToImagePresets:  [
    {
      label: "Random Styles",
      prefix:
        "Fusion of futuristic, synthwave, abstract elements with vibrancy of pop art of",
      suffix:
        "anime and synthwave, intertwining the imaginative with the futuristic",
      negative:
        "Avoid leaning heavily towards one style, Exclude traditional boundaries of styles, No isolated elements without integration",
      guidance_scale: 7,
      inference_steps: 14,
    },{
      label: "Custom Style",
      prefix:
        "Fusion of futuristic, synthwave, abstract elements with vibrancy of pop art of",
      suffix:
        "anime and synthwave, intertwining the imaginative with the futuristic",
      negative:
        "Avoid leaning heavily towards one style, Exclude traditional boundaries of styles, No isolated elements without integration",
      guidance_scale: 7.3,
      inference_steps: 28,
    },{
      label: "Watercolor",
      prefix: "",
      Style: "Watercolor",
      suffix:
        "Soft watercolor painting, gentle washes, blended pigments, light diffusion, hand-painted texture. Avoid sharp lines, Avoid heavy saturation",
      negative: "No sharp lines, Avoid heavy saturation",
      guidance_scale: 7,
      inference_steps: 20,
    },
    {
      label: "Impressionism",
      prefix: "",
      Style: "Impressionism",
      // suffix:
      //   "Bold, modern digital impressionist style with the subject clearly defined using refined, high-contrast brushwork and color separation. The background features radiant, outward-moving strokes that combine washed-out luminous hues with thick, textural oil paint applied with palette knife techniques. Use dynamic layering and intentional color variation to create a glowing aura around the subject, amplifying separation and depth. Brush textures should vary from soft blends on the subject to aggressive, expressive impasto strokes in the background. Emphasize movement, light, and painterly emotion. 4K resolution, gallery-worthy finish—ideal for fine art prints and trending on ArtStation. Avoid detailed precision, Exclude dark, moody settings",
      suffix:"painted entirely in a rich impressionist style. The whole scene —  subject itself — rendered with visible oil brush strokes and soft color blending. Warm golden sunlight reflecting on the pavement, dynamic paint textures capturing motion, inspired by the loose brushwork of impressionist painters. Soft glowing atmosphere, vibrant color palette, artistic painterly motion.",
      negative: "No detailed precision, Exclude dark, moody settings",
      guidance_scale: 7.3,
      inference_steps: 28,
    },
  
    {
      label: "Futuristic",
      prefix: "",
      Style: "Futuristic",
      // suffix:
      //   " Cyberpunk 4K art: sleek metallic aesthetic, glowing neon blues, teals, and oranges. Futuristic cityscape with rain-slick streets, holographic billboards, and dramatic lighting. Subject in advanced, futuristic clothing with illuminated tech details. Emphasize symmetry, cinematic depth, and powerful post-digital presence—ideal for concept art and ArtStation",
      suffix:"Cyberpunk 4K art:  glowing neon blues, teals, and oranges. Futuristic cityscape with rain-slick streets, holographic billboards, and dramatic lighting . Emphasize symmetry, cinematic depth, and powerful post-digital presence—ideal for concept art",
      negative: "Avoid traditional designs, No historical references",
      guidance_scale: 7.3,
      inference_steps: 28,
    },
    {
      label: "Photorealistic",
      prefix: "",
      Style: "Photorealistic",
      suffix:
        "Ultra-detailed, lifelike representation, true-to-life lighting, 4K UHD, Sony FE 85mm f/1.8 lens quality. Avoid exaggerated colors, No abstract interpretations",
      negative: "No exaggerated colors, No abstract interpretations",
      guidance_scale: 7.3,
      inference_steps: 35,
    },
    {
      label: "Abstract",
      prefix: "",
      Style: "Abstract",
      suffix:
        "Stylized abstract art, bold geometric contrasts, expressive strokes, fluid shapes in background, 4K resolution. Avoid clear subjects, Exclude detailed backgrounds",
      negative: "No clear subjects, Exclude detailed backgrounds",
      guidance_scale: 7.3,
      inference_steps: 28,
    },
    {
      label: "Minimalist",
      prefix: "",
      Style: "Minimalist",
      suffix:
        "Simplified rendering, bare essentials, muted tones, basic shapes, crisp lines, 4K sharpness. Avoid intricate designs, Avoid clutter",
      negative: "No intricate designs, Avoid clutter",
      guidance_scale: 7.3,
      inference_steps: 28,
    },
    {
      label: "Pop Art",
      prefix: "",
      Style: "Pop Art",
      suffix:
        "Bold comic-style illustration with vibrant, high-contrast colors; thick black outlines;  dramatic expressions or dynamic poses; exaggerated highlights and shadows; explosive backgrounds with radial bursts or geometric patterns; halftone textures and Ben-Day dot shading in the background; inspired by 1960s Roy Lichtenstein and vintage comic book aesthetics; clean, graphic look designed for visual impact; 4K resolution, crisp and eye-catching, perfect for trending on ArtStation. Avoid realism, No muted colors",
      negative: "Avoid realism, No muted colors",
      guidance_scale: 7.3,
      inference_steps: 28,
    },
    {
      label: "3D Animated",
      prefix: "",
      Style: "3D Animated",
      suffix:
        "CGI rendering, dynamic lighting, high-definition digital environment, 3D modeling, 4K HD. Avoid flat designs, exclude 2D elements",
      negative: "No flat designs, exclude 2D elements",
      guidance_scale: 7.5,
      inference_steps: 32,
    },
    {
      label: "Anime",
      prefix: "",
      Style: "Anime",
      suffix:
        "High-resolution anime-style illustration with expressive, oversized eyes featuring detailed highlights and reflections; smooth and intricate with subtle gradients; finely drawn details; soft lighting with gentle bloom and background bokeh; engaging expressions with a slightly dreamy or heartfelt tone; 4K resolution, polished and ideal for trending on Pixiv or ArtStation poses. Avoid western character designs, Exclude muted colors",
      negative: "No western character designs, Exclude muted colors",
      guidance_scale: 7.3,
      inference_steps: 28,
    },
    {
      label: "Synthwave",
      prefix: "",
      Style: "Synthwave",
      // suffix:
      //   "80s neon representation, retro-futuristic grid, synth-filled atmosphere, neon glow, 4K, intricate detail. Avoid natural colors",
      suffix:"synthwaveSUBJECT, ultra-detailed vector illustration, geometric shapes, sharp clean lines, smooth gradients, high contrast lighting, neon color palette (electric blue, magenta, cyan, purple, hot pink), dramatic rim lighting, glowing edges, cyberpunk aesthetic, dark background, vibrant color blocking, glossy highlights, soft airbrush shading, editorial fashion lighting, minimal background, poster design, crisp outlines, depth and shadows --v 6 --style raw --q 2 --s 750",
      negative: "No natural colors",
      guidance_scale: 7.3,
      inference_steps: 28,
    },
    
    {
      label: "Vector Art",
      prefix: "",
      Style: "Vector Art",
      suffix:
        "Stylized, cartoon-inspired digital vector art with clean lines, bold shapes, and smooth gradients; exaggerated proportions and expressive features for a playful, modern aesthetic; cinematic lighting with rich shadows and glowing highlights to simulate 3D depth; vivid, saturated color palette with high contrast; dynamic posing and movement-friendly framing; glossy, polished finish which would be suitable for mobile games, branding, or sticker packs; 4K resolution, crisp and professional, trending on Dribbble and Behance.",
      negative: "",
      guidance_scale: 7.3,
      inference_steps: 28,
    },
    {
      label: "Steampunk",
      prefix: "",
      Style: "VSteampunk",
      suffix:
        "Richly detailed steampunk aesthetic with ornate Victorian-era influences and mechanical embellishments; brass, copper, and aged leather textures throughout; gears, cogs, steam vents, and intricate machinery integrated into the subject design; warm, sepia or rust-toned color palette with metallic highlights; moody or dramatic lighting with a cinematic atmosphere; subject may include goggles, timepieces, pipes, or industrial accessories; setting may feature old-world backdrops, clockwork environments, or mechanical skies; high-resolution, concept art quality, perfect for graphic novels, fantasy posters, or ArtStation showcases.",
      negative: "",
      guidance_scale: 7.3,
      inference_steps: 28,
    },
    {
      label: "Retro",
      prefix: "",
      Style: "Retro",
      suffix:
        "Do not use rounded corners and border,70s-inspired vintage rendition, grainy 4K finish, retro textures, old-school color palette, faded background and subtle faded hues at sides, giving it a nostalgic vintage feel, no rounded corners,use sharp corners",
      negative: "Avoid futuristic elements and digital enhancements",
      guidance_scale: 6.5,
      inference_steps: 26,
    } , {
      label: "Whimsacle",
      prefix:
        "Fusion of futuristic, synthwave, abstract elements with vibrancy of pop art of",
      Style: "Imaginative",
      suffix:`Surreal, story-driven composition blending reality with fantasy in a vivid, dreamlike visual narrative. Merge unexpected elements—celestial, mythic, symbolic, or organic—into a unified scene that evokes wonder, mystery, or transcendence. Use flowing forms, radiant color transitions, and layered symbolism. Backgrounds should feel cosmic, otherworldly, or spiritual, incorporating glowing lights, starscapes, natural motifs, or sacred geometry.Exclude all human figures or hands—focus solely on the subject and imaginative environment. Avoid gallery-art composition styles that include signature areas. Ensure the bottom corners remain clean, blank, and uninterrupted. Prioritize painterly textures, emotional lighting, imaginative logic (floating objects, giant symbolism, celestial interaction). Use 4K resolution with gallery-quality depth—ideal for visionary art collectors and trending on ArtStation.`,
      negative: "No realistic elements, Exclude modern settings",
      guidance_scale: 7.3,
      inference_steps: 28,
    },
    
  ],
};
const token = "%[a-f0-9]{2}";
const singleMatcher = new RegExp("(" + token + ")|([^%]+?)", "gi");
const multiMatcher = new RegExp("(" + token + ")+", "gi");
function decodeComponents(components, split) {
  try {
    return [decodeURIComponent(components.join(""))];
  } catch {}
  if (components.length === 1) {
    return components;
  }
  split = split || 1;
  const left = components.slice(0, split);
  const right = components.slice(split);
  return Array.prototype.concat.call(
    [],
    decodeComponents(left),
    decodeComponents(right)
  );
}
function decode$1(input) {
  try {
    return decodeURIComponent(input);
  } catch {
    let tokens = input.match(singleMatcher) || [];
    for (let i = 1; i < tokens.length; i++) {
      input = decodeComponents(tokens, i).join("");
      tokens = input.match(singleMatcher) || [];
    }
    return input;
  }
}
function customDecodeURIComponent(input) {
  const replaceMap = {
    "%FE%FF": "��",
    "%FF%FE": "��",
  };
  let match = multiMatcher.exec(input);
  while (match) {
    try {
      replaceMap[match[0]] = decodeURIComponent(match[0]);
    } catch {
      const result = decode$1(match[0]);
      if (result !== match[0]) {
        replaceMap[match[0]] = result;
      }
    }
    match = multiMatcher.exec(input);
  }
  replaceMap["%C2"] = "�";
  const entries = Object.keys(replaceMap);
  for (const key of entries) {
    input = input.replace(new RegExp(key, "g"), replaceMap[key]);
  }
  return input;
}
function decodeUriComponent(encodedURI) {
  if (typeof encodedURI !== "string") {
    throw new TypeError(
      "Expected `encodedURI` to be of type `string`, got `" +
        typeof encodedURI +
        "`"
    );
  }
  try {
    return decodeURIComponent(encodedURI);
  } catch {
    return customDecodeURIComponent(encodedURI);
  }
}
function splitOnFirst(string, separator) {
  if (!(typeof string === "string" && typeof separator === "string")) {
    throw new TypeError("Expected the arguments to be of type `string`");
  }
  if (string === "" || separator === "") {
    return [];
  }
  const separatorIndex = string.indexOf(separator);
  if (separatorIndex === -1) {
    return [];
  }
  return [
    string.slice(0, separatorIndex),
    string.slice(separatorIndex + separator.length),
  ];
}
function includeKeys(object, predicate) {
  const result = {};
  if (Array.isArray(predicate)) {
    for (const key of predicate) {
      const descriptor = Object.getOwnPropertyDescriptor(object, key);
      if (descriptor == null ? void 0 : descriptor.enumerable) {
        Object.defineProperty(result, key, descriptor);
      }
    }
  } else {
    for (const key of Reflect.ownKeys(object)) {
      const descriptor = Object.getOwnPropertyDescriptor(object, key);
      if (descriptor.enumerable) {
        const value = object[key];
        if (predicate(key, value, object)) {
          Object.defineProperty(result, key, descriptor);
        }
      }
    }
  }
  return result;
}
const isNullOrUndefined = (value) => value === null || value === void 0;
const strictUriEncode = (string) =>
  encodeURIComponent(string).replace(
    /[!'()*]/g,
    (x2) => `%${x2.charCodeAt(0).toString(16).toUpperCase()}`
  );
const encodeFragmentIdentifier = Symbol("encodeFragmentIdentifier");
function encoderForArrayFormat(options) {
  switch (options.arrayFormat) {
    case "index": {
      return (key) => (result, value) => {
        const index = result.length;
        if (
          value === void 0 ||
          (options.skipNull && value === null) ||
          (options.skipEmptyString && value === "")
        ) {
          return result;
        }
        if (value === null) {
          return [...result, [encode(key, options), "[", index, "]"].join("")];
        }
        return [
          ...result,
          [
            encode(key, options),
            "[",
            encode(index, options),
            "]=",
            encode(value, options),
          ].join(""),
        ];
      };
    }
    case "bracket": {
      return (key) => (result, value) => {
        if (
          value === void 0 ||
          (options.skipNull && value === null) ||
          (options.skipEmptyString && value === "")
        ) {
          return result;
        }
        if (value === null) {
          return [...result, [encode(key, options), "[]"].join("")];
        }
        return [
          ...result,
          [encode(key, options), "[]=", encode(value, options)].join(""),
        ];
      };
    }
    case "colon-list-separator": {
      return (key) => (result, value) => {
        if (
          value === void 0 ||
          (options.skipNull && value === null) ||
          (options.skipEmptyString && value === "")
        ) {
          return result;
        }
        if (value === null) {
          return [...result, [encode(key, options), ":list="].join("")];
        }
        return [
          ...result,
          [encode(key, options), ":list=", encode(value, options)].join(""),
        ];
      };
    }
    case "comma":
    case "separator":
    case "bracket-separator": {
      const keyValueSep =
        options.arrayFormat === "bracket-separator" ? "[]=" : "=";
      return (key) => (result, value) => {
        if (
          value === void 0 ||
          (options.skipNull && value === null) ||
          (options.skipEmptyString && value === "")
        ) {
          return result;
        }
        value = value === null ? "" : value;
        if (result.length === 0) {
          return [
            [encode(key, options), keyValueSep, encode(value, options)].join(
              ""
            ),
          ];
        }
        return [
          [result, encode(value, options)].join(options.arrayFormatSeparator),
        ];
      };
    }
    default: {
      return (key) => (result, value) => {
        if (
          value === void 0 ||
          (options.skipNull && value === null) ||
          (options.skipEmptyString && value === "")
        ) {
          return result;
        }
        if (value === null) {
          return [...result, encode(key, options)];
        }
        return [
          ...result,
          [encode(key, options), "=", encode(value, options)].join(""),
        ];
      };
    }
  }
}
function parserForArrayFormat(options) {
  let result;
  switch (options.arrayFormat) {
    case "index": {
      return (key, value, accumulator) => {
        result = /\[(\d*)]$/.exec(key);
        key = key.replace(/\[\d*]$/, "");
        if (!result) {
          accumulator[key] = value;
          return;
        }
        if (accumulator[key] === void 0) {
          accumulator[key] = {};
        }
        accumulator[key][result[1]] = value;
      };
    }
    case "bracket": {
      return (key, value, accumulator) => {
        result = /(\[])$/.exec(key);
        key = key.replace(/\[]$/, "");
        if (!result) {
          accumulator[key] = value;
          return;
        }
        if (accumulator[key] === void 0) {
          accumulator[key] = [value];
          return;
        }
        accumulator[key] = [...accumulator[key], value];
      };
    }
    case "colon-list-separator": {
      return (key, value, accumulator) => {
        result = /(:list)$/.exec(key);
        key = key.replace(/:list$/, "");
        if (!result) {
          accumulator[key] = value;
          return;
        }
        if (accumulator[key] === void 0) {
          accumulator[key] = [value];
          return;
        }
        accumulator[key] = [...accumulator[key], value];
      };
    }
    case "comma":
    case "separator": {
      return (key, value, accumulator) => {
        const isArray2 =
          typeof value === "string" &&
          value.includes(options.arrayFormatSeparator);
        const isEncodedArray =
          typeof value === "string" &&
          !isArray2 &&
          decode(value, options).includes(options.arrayFormatSeparator);
        value = isEncodedArray ? decode(value, options) : value;
        const newValue =
          isArray2 || isEncodedArray
            ? value
                .split(options.arrayFormatSeparator)
                .map((item) => decode(item, options))
            : value === null
            ? value
            : decode(value, options);
        accumulator[key] = newValue;
      };
    }
    case "bracket-separator": {
      return (key, value, accumulator) => {
        const isArray2 = /(\[])$/.test(key);
        key = key.replace(/\[]$/, "");
        if (!isArray2) {
          accumulator[key] = value ? decode(value, options) : value;
          return;
        }
        const arrayValue =
          value === null
            ? []
            : value
                .split(options.arrayFormatSeparator)
                .map((item) => decode(item, options));
        if (accumulator[key] === void 0) {
          accumulator[key] = arrayValue;
          return;
        }
        accumulator[key] = [...accumulator[key], ...arrayValue];
      };
    }
    default: {
      return (key, value, accumulator) => {
        if (accumulator[key] === void 0) {
          accumulator[key] = value;
          return;
        }
        accumulator[key] = [...[accumulator[key]].flat(), value];
      };
    }
  }
}
function validateArrayFormatSeparator(value) {
  if (typeof value !== "string" || value.length !== 1) {
    throw new TypeError("arrayFormatSeparator must be single character string");
  }
}
function encode(value, options) {
  if (options.encode) {
    return options.strict ? strictUriEncode(value) : encodeURIComponent(value);
  }
  return value;
}
function decode(value, options) {
  if (options.decode) {
    return decodeUriComponent(value);
  }
  return value;
}
function keysSorter(input) {
  if (Array.isArray(input)) {
    return input.sort();
  }
  if (typeof input === "object") {
    return keysSorter(Object.keys(input))
      .sort((a, b2) => Number(a) - Number(b2))
      .map((key) => input[key]);
  }
  return input;
}
function removeHash(input) {
  const hashStart = input.indexOf("#");
  if (hashStart !== -1) {
    input = input.slice(0, hashStart);
  }
  return input;
}
function getHash(url) {
  let hash2 = "";
  const hashStart = url.indexOf("#");
  if (hashStart !== -1) {
    hash2 = url.slice(hashStart);
  }
  return hash2;
}
function parseValue(value, options) {
  if (
    options.parseNumbers &&
    !Number.isNaN(Number(value)) &&
    typeof value === "string" &&
    value.trim() !== ""
  ) {
    value = Number(value);
  } else if (
    options.parseBooleans &&
    value !== null &&
    (value.toLowerCase() === "true" || value.toLowerCase() === "false")
  ) {
    value = value.toLowerCase() === "true";
  }
  return value;
}
function extract(input) {
  input = removeHash(input);
  const queryStart = input.indexOf("?");
  if (queryStart === -1) {
    return "";
  }
  return input.slice(queryStart + 1);
}
function parse(query2, options) {
  options = {
    decode: true,
    sort: true,
    arrayFormat: "none",
    arrayFormatSeparator: ",",
    parseNumbers: false,
    parseBooleans: false,
    ...options,
  };
  validateArrayFormatSeparator(options.arrayFormatSeparator);
  const formatter = parserForArrayFormat(options);
  const returnValue = /* @__PURE__ */ Object.create(null);
  if (typeof query2 !== "string") {
    return returnValue;
  }
  query2 = query2.trim().replace(/^[?#&]/, "");
  if (!query2) {
    return returnValue;
  }
  for (const parameter of query2.split("&")) {
    if (parameter === "") {
      continue;
    }
    const parameter_ = options.decode
      ? parameter.replace(/\+/g, " ")
      : parameter;
    let [key, value] = splitOnFirst(parameter_, "=");
    if (key === void 0) {
      key = parameter_;
    }
    value =
      value === void 0
        ? null
        : ["comma", "separator", "bracket-separator"].includes(
            options.arrayFormat
          )
        ? value
        : decode(value, options);
    formatter(decode(key, options), value, returnValue);
  }
  for (const [key, value] of Object.entries(returnValue)) {
    if (typeof value === "object" && value !== null) {
      for (const [key2, value2] of Object.entries(value)) {
        value[key2] = parseValue(value2, options);
      }
    } else {
      returnValue[key] = parseValue(value, options);
    }
  }
  if (options.sort === false) {
    return returnValue;
  }
  return (
    options.sort === true
      ? Object.keys(returnValue).sort()
      : Object.keys(returnValue).sort(options.sort)
  ).reduce((result, key) => {
    const value = returnValue[key];
    if (Boolean(value) && typeof value === "object" && !Array.isArray(value)) {
      result[key] = keysSorter(value);
    } else {
      result[key] = value;
    }
    return result;
  }, /* @__PURE__ */ Object.create(null));
}
function stringify(object, options) {
  if (!object) {
    return "";
  }
  options = {
    encode: true,
    strict: true,
    arrayFormat: "none",
    arrayFormatSeparator: ",",
    ...options,
  };
  validateArrayFormatSeparator(options.arrayFormatSeparator);
  const shouldFilter = (key) =>
    (options.skipNull && isNullOrUndefined(object[key])) ||
    (options.skipEmptyString && object[key] === "");
  const formatter = encoderForArrayFormat(options);
  const objectCopy = {};
  for (const [key, value] of Object.entries(object)) {
    if (!shouldFilter(key)) {
      objectCopy[key] = value;
    }
  }
  const keys4 = Object.keys(objectCopy);
  if (options.sort !== false) {
    keys4.sort(options.sort);
  }
  return keys4
    .map((key) => {
      const value = object[key];
      if (value === void 0) {
        return "";
      }
      if (value === null) {
        return encode(key, options);
      }
      if (Array.isArray(value)) {
        if (value.length === 0 && options.arrayFormat === "bracket-separator") {
          return encode(key, options) + "[]";
        }
        return value.reduce(formatter(key), []).join("&");
      }
      return encode(key, options) + "=" + encode(value, options);
    })
    .filter((x2) => x2.length > 0)
    .join("&");
}
function parseUrl(url, options) {
  var _a2;
  options = {
    decode: true,
    ...options,
  };
  let [url_, hash2] = splitOnFirst(url, "#");
  if (url_ === void 0) {
    url_ = url;
  }
  return {
    url:
      ((_a2 = url_ == null ? void 0 : url_.split("?")) == null
        ? void 0
        : _a2[0]) ?? "",
    query: parse(extract(url), options),
    ...(options && options.parseFragmentIdentifier && hash2
      ? { fragmentIdentifier: decode(hash2, options) }
      : {}),
  };
}
function stringifyUrl(object, options) {
  options = {
    encode: true,
    strict: true,
    [encodeFragmentIdentifier]: true,
    ...options,
  };
  const url = removeHash(object.url).split("?")[0] || "";
  const queryFromUrl = extract(object.url);
  const query2 = {
    ...parse(queryFromUrl, { sort: false }),
    ...object.query,
  };
  let queryString2 = stringify(query2, options);
  if (queryString2) {
    queryString2 = `?${queryString2}`;
  }
  let hash2 = getHash(object.url);
  if (object.fragmentIdentifier) {
    const urlObjectForFragmentEncode = new URL(url);
    urlObjectForFragmentEncode.hash = object.fragmentIdentifier;
    hash2 = options[encodeFragmentIdentifier]
      ? urlObjectForFragmentEncode.hash
      : `#${object.fragmentIdentifier}`;
  }
  return `${url}${queryString2}${hash2}`;
}
function pick(input, filter2, options) {
  options = {
    parseFragmentIdentifier: true,
    [encodeFragmentIdentifier]: false,
    ...options,
  };
  const { url, query: query2, fragmentIdentifier } = parseUrl(input, options);
  return stringifyUrl(
    {
      url,
      query: includeKeys(query2, filter2),
      fragmentIdentifier,
    },
    options
  );
}
function exclude(input, filter2, options) {
  const exclusionFilter = Array.isArray(filter2)
    ? (key) => !filter2.includes(key)
    : (key, value) => !filter2(key, value);
  return pick(input, exclusionFilter, options);
}
const queryString = /* @__PURE__ */ Object.freeze(
  /* @__PURE__ */ Object.defineProperty(
    {
      __proto__: null,
      exclude,
      extract,
      parse,
      parseUrl,
      pick,
      stringify,
      stringifyUrl,
    },
    Symbol.toStringTag,
    { value: "Module" }
  )
);
const uniqueRandom = (minimum, maximum) => {
  let previousValue;
  return function random() {
    const number = Math.floor(
      Math.random() * (maximum - minimum + 1) + minimum
    );
    previousValue =
      number === previousValue && minimum !== maximum ? random() : number;
    return previousValue;
  };
};
// const pickStylePreset = (list, currentPreset) => {
  
//   if (selected_style.length >= list.length - 1) {
//     selected_style.splice(0, selected_style.length);
//   }
//   const _currentPreset = JSON.parse(currentPreset);
//   const currentPresetLabel = _currentPreset.label.toLowerCase();
  
//   if (!currentPresetLabel.match("mix") || !currentPresetLabel.match("mix it up")) {
//     return _currentPreset;
//   }

//   const random = uniqueRandom(2, list.length - 1);
//   let idx = random();

//   if (selected_style.length && selected_style.includes(idx)) {
//     idx = random();
//     if (selected_style.length && selected_style.includes(idx)) {
//       idx = random();
//       if (selected_style.length && selected_style.includes(idx)) {
//         idx = random();
//         if (selected_style.length && selected_style.includes(idx)) {
//           idx = random();
//         }
//       }
//     }
//     selected_style.push(idx);
//   } else {
//     selected_style.push(idx);
//   }
  
//   return list[idx];
// };
const pickStylePreset = (list, currentPreset) => {
  
  if (selected_style.length >= list.length - 2) {
    selected_style.splice(0, selected_style.length);
  }
  const _currentPreset = JSON.parse(currentPreset);
  const currentPresetLabel = _currentPreset.label.toLowerCase();
  

  if (!currentPresetLabel.match("random styles")) {
    
    return _currentPreset;
  }else{
    
  }
  const random = uniqueRandom(2, list.length - 2);
  let idx = random();
  // console.log("list[idx]-----------", list[idx].label)
  if (selected_style.length && selected_style.includes(idx)) {
    idx = random();
    if (selected_style.length && selected_style.includes(idx)) {
      idx = random();
      if (selected_style.length && selected_style.includes(idx)) {
        idx = random();
        if (selected_style.length && selected_style.includes(idx)) {
          idx = random();
        }
      }
    }
    selected_style.push(idx);
  } else {
    selected_style.push(idx);
  }
  
  return list[idx];
};

const saveImageToBucket = async (
  imgd_id,
  src,
  uid,
  $$invalidate
) => {
  
  const formData = new FormData();
  formData.append("file", src, "image.png"); // Append the blob with a filename
  formData.append("uid", uid);
  return fetch("https://webhook.wallart.ai/saveImageToBucket", {
    method: "POST",

    body: formData,
  }).then((res) =>res.json()).then(data=>{
      croppedimages3bucketurl = (data)? data?.src: "";
   
        // inprogressimageid = false;
      // $$invalidate(8, (userImageUrl = croppedimages3bucketurl));
  });
};
const saveImageToStorage = async (
  { src, isVertical },
  uid,
  isUserImage = false
) => {
  const response = await fetch(src);
  const blob = await response.blob();

  const name2 = Date.now();
  const storageRef = ref(storage, `${name2}.png`);
  const imageUploadTask = uploadBytesResumable(storageRef, blob);
  return new Promise((resolve, reject3) => {
    imageUploadTask.on(
      "state_changed",
      () => console.info("Uploading...."),
      (error) => {
        reject3(error);
        console.error("failed to upload your image", {
          error,
        });
      },
      async () => {
        console.info("Uploaded Successfully");
        const newImageURL = await getDownloadURL(imageUploadTask.snapshot.ref);
        const body = {
          uid,
          name: name2,
          isVertical,
          isUserImage,
          src: newImageURL,
          // temporaryImageURL: src,
        };

        await addDoc(collection(db, "images"), body);
        return resolve(body);
      }
    );
  });
};

const setImageToURL = (image) => {
  const { isVertical, src } = image;
  const url = new URL(location.href);

  url.searchParams.set("src", src);
  url.searchParams.set("isVertical", isVertical);

  return history.pushState({}, document.title, url);
};
const clearURLParams = () => {
  const locationWithoutParams = location.origin + location.pathname;
  history.replaceState({}, document.title, locationWithoutParams);
  return;
};
const cleanImageSrc = (src) => {
  try {
    const { origin, pathname } = new URL(src);
    return origin.concat(pathname);
  } catch (err) {
    return false;
  }
};
const buildShareLink = (platform, content) => {
  const { url, text: text2, imageUrl, description } = content;
  const encodedURL = encodeURIComponent(url);
  const encodedText = encodeURIComponent(text2);
  const encodedImageURL = encodeURIComponent(imageUrl);
  const encodedDescription = encodeURIComponent(description);
  switch (platform) {
    case "twitter":
      return `https://twitter.com/share?url=${encodedURL}&text=${encodedText}`;
    case "facebook":
      return `https://www.facebook.com/sharer/sharer.php?u=${encodedURL}`;
    case "pinterest":
      return `https://pinterest.com/pin/create/button/?url=${encodedURL}&media=${encodedImageURL}&description=${encodedDescription}`;
    default:
      return "";
  }
};
function cubicOut(t) {
  const f = t - 1;
  return f * f * f + 1;
}
function fade(node, { delay = 0, duration = 400, easing = identity$2 } = {}) {
  const o = +getComputedStyle(node).opacity;
  return {
    delay,
    duration,
    easing,
    css: (t) => `opacity: ${t * o}`,
  };
}
function fly(
  node,
  {
    delay = 0,
    duration = 400,
    easing = cubicOut,
    x: x2 = 0,
    y: y2 = 0,
    opacity = 0,
  } = {}
) {
  const style2 = getComputedStyle(node);
  const target_opacity = +style2.opacity;
  const transform = style2.transform === "none" ? "" : style2.transform;
  const od2 = target_opacity * (1 - opacity);
  const [xValue, xUnit] = split_css_unit(x2);
  const [yValue, yUnit] = split_css_unit(y2);
  return {
    delay,
    duration,
    easing,
    css: (t, u) => `
			transform: ${transform} translate(${(1 - t) * xValue}${xUnit}, ${
      (1 - t) * yValue
    }${yUnit});
			opacity: ${target_opacity - od2 * u}`,
  };
}
function create_if_block$6(ctx) {
  let p2;
  let p_transition;
  let current;
  return {
    c() {
      p2 = element("p");
      p2.textContent = "Copied";
      attr(
        p2,
        "class",
        "absolute -top-8 right-0 bg-gray-950 text-white rounded-full px-4 py-1 text-xs"
      );
    },
    m(target, anchor) {
      insert(target, p2, anchor);
      current = true;
    },
    i(local) {
      if (current) return;
      add_render_callback(() => {
        if (!current) return;
        if (!p_transition)
          p_transition = create_bidirectional_transition(p2, fly, {}, true);
        p_transition.run(1);
      });
      current = true;
    },
    o(local) {
      if (!p_transition)
        p_transition = create_bidirectional_transition(p2, fly, {}, false);
      p_transition.run(0);
      current = false;
    },
    d(detaching) {
      if (detaching) detach(p2);
      if (detaching && p_transition) p_transition.end();
    },
  };
}
function create_fragment$c(ctx) {
  let ul;
  let li0;
  let a0;
  let svg0;
  let path0;
  let t0;
  let li1;
  let a1;
  let svg1;
  let path1;
  let t1;
  let li2;
  let a2;
  let svg2;
  let path2;
  let t2;
  let li3;
  let button;
  let svg3;
  let path3;
  let t3;
  let current;
  let mounted;
  let dispose;
  let if_block =
    /*hasCopied*/
    ctx[0] && create_if_block$6();
  return {
    c() {
      ul = element("ul");
      li0 = element("li");
      a0 = element("a");
      svg0 = svg_element("svg");
      path0 = svg_element("path");
      t0 = space();
      li1 = element("li");
      a1 = element("a");
      svg1 = svg_element("svg");
      path1 = svg_element("path");
      t1 = space();
      li2 = element("li");
      a2 = element("a");
      svg2 = svg_element("svg");
      path2 = svg_element("path");
      t2 = space();
      li3 = element("li");
      button = element("button");
      svg3 = svg_element("svg");
      path3 = svg_element("path");
      t3 = space();
      if (if_block) if_block.c();
      attr(path0, "fill", "currentColor");
      attr(
        path0,
        "d",
        "M459.37 151.716c.325 4.548.325 9.097.325 13.645 0 138.72-105.583 298.558-298.558 298.558-59.452 0-114.68-17.219-161.137-47.106 8.447.974 16.568 1.299 25.34 1.299 49.055 0 94.213-16.568 130.274-44.832-46.132-.975-84.792-31.188-98.112-72.772 6.498.974 12.995 1.624 19.818 1.624 9.421 0 18.843-1.3 27.614-3.573-48.081-9.747-84.143-51.98-84.143-102.985v-1.299c13.969 7.797 30.214 12.67 47.431 13.319-28.264-18.843-46.781-51.005-46.781-87.391 0-19.492 5.197-37.36 14.294-52.954 51.655 63.675 129.3 105.258 216.365 109.807-1.624-7.797-2.599-15.918-2.599-24.04 0-57.828 46.782-104.934 104.934-104.934 30.213 0 57.502 12.67 76.67 33.137 23.715-4.548 46.456-13.32 66.599-25.34-7.798 24.366-24.366 44.833-46.132 57.827 21.117-2.273 41.584-8.122 60.426-16.243-14.292 20.791-32.161 39.308-52.628 54.253z"
      );
      attr(
        svg0,
        "class",
        "svg-inline--fa hover:text-red-500 active:text-red-600 text-gray-600 md:w-5 w-4 fa-twitter cursor-pointer hover:brightness-75 text-xl"
      );
      attr(svg0, "aria-hidden", "true");
      attr(svg0, "focusable", "false");
      attr(svg0, "data-prefix", "fab");
      attr(svg0, "data-icon", "twitter");
      attr(svg0, "role", "img");
      attr(svg0, "xmlns", "http://www.w3.org/2000/svg");
      attr(svg0, "viewBox", "0 0 512 512");
      attr(svg0, "data-fa-i2svg", "");
      attr(a0, "rel", "noreferrer");
      attr(a0, "target", "_parent _blank");
      attr(a0, "id", "twitterlink");
      attr(
        a0,
        "href",
        /*twitterShareLink*/
        ctx[3]
      );
      attr(
        a0,
        "class",
        "border-none bg-transparent flex items-center justify-center h-8 w-8 rounded-full"
      );
      attr(path1, "fill", "currentColor");
      attr(
        path1,
        "d",
        "M504 256C504 119 393 8 256 8S8 119 8 256c0 123.78 90.69 226.38 209.25 245V327.69h-63V256h63v-54.64c0-62.15 37-96.48 93.67-96.48 27.14 0 55.52 4.84 55.52 4.84v61h-31.28c-30.8 0-40.41 19.12-40.41 38.73V256h68.78l-11 71.69h-57.78V501C413.31 482.38 504 379.78 504 256z"
      );
      attr(
        svg1,
        "class",
        "svg-inline--fa hover:text-red-500 active:text-red-600 text-gray-600 md:w-5 w-4 fa-twitter cursor-pointer hover:brightness-75 text-xl"
      );
      attr(svg1, "aria-hidden", "true");
      attr(svg1, "focusable", "false");
      attr(svg1, "data-prefix", "fab");
      attr(svg1, "data-icon", "facebook");
      attr(svg1, "role", "img");
      attr(svg1, "xmlns", "http://www.w3.org/2000/svg");
      attr(svg1, "viewBox", "0 0 512 512");
      attr(svg1, "data-fa-i2svg", "");
      attr(a1, "rel", "noreferrer");
      attr(a1, "target", "_parent _blank");
      attr(a1, "id", "facebooklink");
      attr(
        a1,
        "href",
        /*facebookShareLink*/
        ctx[2]
      );
      attr(
        a1,
        "class",
        "border-none bg-transparent flex items-center justify-center h-8 w-8 rounded-full"
      );
      attr(
        path2,
        "d",
        "M405.017,52.467C369.774,18.634,321.001,0,267.684,0C186.24,0,136.148,33.385,108.468,61.39\n	c-34.114,34.513-53.675,80.34-53.675,125.732c0,56.993,23.839,100.737,63.76,117.011c2.68,1.098,5.377,1.651,8.021,1.651\n	c8.422,0,15.095-5.511,17.407-14.35c1.348-5.071,4.47-17.582,5.828-23.013c2.906-10.725,0.558-15.884-5.78-23.353\n	c-11.546-13.662-16.923-29.817-16.923-50.842c0-62.451,46.502-128.823,132.689-128.823c68.386,0,110.866,38.868,110.866,101.434\n	c0,39.482-8.504,76.046-23.951,102.961c-10.734,18.702-29.609,40.995-58.585,40.995c-12.53,0-23.786-5.147-30.888-14.121\n	c-6.709-8.483-8.921-19.441-6.222-30.862c3.048-12.904,7.205-26.364,11.228-39.376c7.337-23.766,14.273-46.213,14.273-64.122\n	c0-30.632-18.832-51.215-46.857-51.215c-35.616,0-63.519,36.174-63.519,82.354c0,22.648,6.019,39.588,8.744,46.092\n	c-4.487,19.01-31.153,132.03-36.211,153.342c-2.925,12.441-20.543,110.705,8.618,118.54c32.764,8.803,62.051-86.899,65.032-97.713\n	c2.416-8.795,10.869-42.052,16.049-62.495c15.817,15.235,41.284,25.535,66.064,25.535c46.715,0,88.727-21.022,118.298-59.189\n	c28.679-37.02,44.474-88.618,44.474-145.282C457.206,127.983,438.182,84.311,405.017,52.467z"
      );
      attr(svg2, "height", "20");
      attr(svg2, "width", "20");
      attr(svg2, "version", "1.1");
      attr(svg2, "viewBox", "0 0 511.998 511.998");
      attr(
        svg2,
        "class",
        "svg-inline--fa hover:fill-red-500 active:fill-red-600 fill-gray-600 md:w-5 w-4 fa-twitter cursor-pointer hover:brightness-75 text-xl"
      );
      attr(a2, "target", "_parent _blank");
      attr(a2, "id", "pinterestlink");
      attr(
        a2,
        "href",
        /*pinterestShareLink*/
        ctx[1]
      );
      attr(
        a2,
        "class",
        "border-none bg-transparent flex items-center justify-center h-8 w-8 rounded-full"
      );
      attr(path3, "fill", "currentColor");
      attr(
        path3,
        "d",
        "M579.8 267.7c56.5-56.5 56.5-148 0-204.5c-50-50-128.8-56.5-186.3-15.4l-1.6 1.1c-14.4 10.3-17.7 30.3-7.4 44.6s30.3 17.7 44.6 7.4l1.6-1.1c32.1-22.9 76-19.3 103.8 8.6c31.5 31.5 31.5 82.5 0 114L422.3 334.8c-31.5 31.5-82.5 31.5-114 0c-27.9-27.9-31.5-71.8-8.6-103.8l1.1-1.6c10.3-14.4 6.9-34.4-7.4-44.6s-34.4-6.9-44.6 7.4l-1.1 1.6C206.5 251.2 213 330 263 380c56.5 56.5 148 56.5 204.5 0L579.8 267.7zM60.2 244.3c-56.5 56.5-56.5 148 0 204.5c50 50 128.8 56.5 186.3 15.4l1.6-1.1c14.4-10.3 17.7-30.3 7.4-44.6s-30.3-17.7-44.6-7.4l-1.6 1.1c-32.1 22.9-76 19.3-103.8-8.6C74 372 74 321 105.5 289.5L217.7 177.2c31.5-31.5 82.5-31.5 114 0c27.9 27.9 31.5 71.8 8.6 103.9l-1.1 1.6c-10.3 14.4-6.9 34.4 7.4 44.6s34.4 6.9 44.6-7.4l1.1-1.6C433.5 260.8 427 182 377 132c-56.5-56.5-148-56.5-204.5 0L60.2 244.3z"
      );
      attr(
        svg3,
        "class",
        "svg-inline--fa hover:text-red-500 active:text-red-600 text-gray-600 md:w-5 w-4 fa-twitter cursor-pointer hover:brightness-75 text-xl"
      );
      attr(svg3, "aria-hidden", "true");
      attr(svg3, "focusable", "false");
      attr(svg3, "data-prefix", "fas");
      attr(svg3, "data-icon", "link");
      attr(svg3, "role", "img");
      attr(svg3, "xmlns", "http://www.w3.org/2000/svg");
      attr(svg3, "viewBox", "0 0 640 512");
      attr(svg3, "data-fa-i2svg", "");
      attr(
        button,
        "class",
        "border-none relative bg-none bg-transparent flex items-center justify-center h-8 w-8 rounded-full"
      );
      attr(
        ul,
        "class",
        "m-0 p-0 px-2 list-none flex items-center flex-column md:justify-end justify-center rounded-md"
      );
    },
    m(target, anchor) {
      insert(target, ul, anchor);
      append(ul, li0);
      append(li0, a0);
      append(a0, svg0);
      append(svg0, path0);
      append(ul, t0);
      append(ul, li1);
      append(li1, a1);
      append(a1, svg1);
      append(svg1, path1);
      append(ul, t1);
      append(ul, li2);
      append(li2, a2);
      append(a2, svg2);
      append(svg2, path2);
      append(ul, t2);
      append(ul, li3);
      append(li3, button);
      append(button, svg3);
      append(svg3, path3);
      append(button, t3);
      if (if_block) if_block.m(button, null);
      current = true;
      if (!mounted) {
        dispose = listen(
          button,
          "click",
          /*copy*/
          ctx[4]
        );
        mounted = true;
      }
    },
    p(ctx2, [dirty]) {
      if (!current || dirty /*twitterShareLink*/ & 8) {
        attr(
          a0,
          "href",
          /*twitterShareLink*/
          ctx2[3]
        );
      }
      if (!current || dirty /*facebookShareLink*/ & 4) {
        attr(
          a1,
          "href",
          /*facebookShareLink*/
          ctx2[2]
        );
      }
      if (!current || dirty /*pinterestShareLink*/ & 2) {
        attr(
          a2,
          "href",
          /*pinterestShareLink*/
          ctx2[1]
        );
      }
      if (
        /*hasCopied*/
        ctx2[0]
      ) {
        if (if_block) {
          if (dirty /*hasCopied*/ & 1) {
            transition_in(if_block, 1);
          }
        } else {
          if_block = create_if_block$6();
          if_block.c();
          transition_in(if_block, 1);
          if_block.m(button, null);
        }
      } else if (if_block) {
        group_outros();
        transition_out(if_block, 1, 1, () => {
          if_block = null;
        });
        check_outros();
      }
    },
    i(local) {
      if (current) return;
      transition_in(if_block);
      current = true;
    },
    o(local) {
      transition_out(if_block);
      current = false;
    },
    d(detaching) {
      if (detaching) detach(ul);
      if (if_block) if_block.d();
      mounted = false;
      dispose();
    },
  };
}
const text =
  "Check out what I just created using A.I.!  Create one-of-a-kind art for your wall in seconds \n\n";
function instance$b($$self, $$props, $$invalidate) {
  let url;
  let twitterShareLink;
  let facebookShareLink;
  let pinterestShareLink;
  let hasCopied = false;
  // function copy() {
  //   var input = document.createElement("textarea");
  //   input.innerHTML = parent.location.href;
  //   document.body.appendChild(input);
  //   input.select();
  //   const result = document.execCommand("copy");
  //   document.body.removeChild(input);
  //   $$invalidate(0, (hasCopied = true));
  //   setTimeout(() => {
  //     $$invalidate(0, (hasCopied = false));
  //   }, 3e3);
  //   return result;
  // }
  function copy() {
    const productURL = new URL(parent.location.href);
    const params = new URLSearchParams(productURL.search);
    const paramssrc = decodeURIComponent(params.get("src"));
    const paramisvertical = decodeURIComponent(params.get("isVertical"));

    url = `https://wallart.ai/products/ai-art-canvas?src=${paramssrc}&isVertical=${paramisvertical}`;
   
    var input = document.createElement("textarea");
    attr(input, "id", "copyandsharelink");
    // input.innerHTML = parent.location.href;
    input.innerHTML = url
    document.body.appendChild(input);
    input.select();
    const result = document.execCommand("copy");
    document.body.removeChild(input);
    $$invalidate(0, (hasCopied = true));
    setTimeout(() => {
      $$invalidate(0, (hasCopied = false));
    }, 3e3);
    return result;
  }
  $$self.$$.update = () => {
    if ($$self.$$.dirty /*url*/ & 32) {
      $$invalidate(
        3,
        (twitterShareLink = buildShareLink("twitter", {
          url,
          text,
          imageUrl: url,
          description: text,
        }))
      );
    }
    if ($$self.$$.dirty /*url*/ & 32) {
      $$invalidate(
        2,
        (facebookShareLink = buildShareLink("facebook", {
          url,
          text,
          imageUrl: url,
          description: text,
        }))
      );
    }
    if ($$self.$$.dirty /*url*/ & 32) {
      $$invalidate(
        1,
        (pinterestShareLink = buildShareLink("pinterest", {
          url,
          text,
          imageUrl: url,
          description: text,
        }))
      );
    }
  };
  $$invalidate(5, (url = parent.location.href));
  return [
    hasCopied,
    pinterestShareLink,
    facebookShareLink,
    twitterShareLink,
    copy,
    url,
  ];
}
class ShareLinks extends SvelteComponent {
  constructor(options) {
    super();
    init(this, options, instance$b, create_fragment$c, safe_not_equal, {});
  }
}
function create_fragment$b(ctx) {
  let div;
  let svg;
  let path0;
  let path1;
  let path1_class_value;
  let svg_class_value;
  return {
    c() {
      div = element("div");
      svg = svg_element("svg");
      path0 = svg_element("path");
      path1 = svg_element("path");
      attr(
        path0,
        "d",
        "M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
      );
      attr(path0, "fill", "currentColor");
      attr(
        path1,
        "class",
        (path1_class_value = "fill-red-500 " /*fillClass*/ + ctx[0])
      );
      attr(path1, "fill", "currentColor");
      attr(
        path1,
        "d",
        "M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
      );
      set_style(svg, "animation-duration", "0.5s");
      attr(svg, "aria-hidden", "true");
      attr(
        svg,
        "class",
        (svg_class_value =
          "inline w-6 h-6 text-gray-200 animate-spin " /*className*/ + ctx[1])
      );
      attr(svg, "viewBox", "0 0 100 101");
      attr(svg, "fill", "none");
      attr(svg, "xmlns", "http://www.w3.org/2000/svg");
    },
    m(target, anchor) {
      insert(target, div, anchor);
      append(div, svg);
      append(svg, path0);
      append(svg, path1);
    },
    p(ctx2, [dirty]) {
      if (
        dirty /*fillClass*/ & 1 &&
        path1_class_value !==
          (path1_class_value = "fill-red-500 " /*fillClass*/ + ctx2[0])
      ) {
        attr(path1, "class", path1_class_value);
      }
      if (
        dirty /*className*/ & 2 &&
        svg_class_value !==
          (svg_class_value =
            "inline w-6 h-6 text-gray-200 animate-spin " /*className*/ +
            ctx2[1])
      ) {
        attr(svg, "class", svg_class_value);
      }
    },
    i: noop$1,
    o: noop$1,
    d(detaching) {
      if (detaching) detach(div);
    },
  };
}
function instance$a($$self, $$props, $$invalidate) {
  let { fillClass = "" } = $$props;
  let { class: className = "" } = $$props;
  $$self.$$set = ($$props2) => {
    if ("fillClass" in $$props2)
      $$invalidate(0, (fillClass = $$props2.fillClass));
    if ("class" in $$props2) $$invalidate(1, (className = $$props2.class));
  };
  return [fillClass, className];
}
class SpinnerSmall extends SvelteComponent {
  constructor(options) {
    super();
    init(this, options, instance$a, create_fragment$b, safe_not_equal, {
      fillClass: 0,
      class: 1,
    });
  }
}
function create_if_block_5(ctx) {
  let div1;
  let div0;
  let sharelinks;
  let div1_transition;
  let current;

  sharelinks = new ShareLinks({});

  return {
    c() {
      div1 = element("div");
      div0 = element("div");
      create_component(sharelinks.$$.fragment);

      attr(div0, "class", "bg-white1 border1 rounded-full1 shadow1 p-4");

      // Debug bg color added
      attr(
        div1,
        "class",
        "absolute top-0 left-0 w-full h-full z-[2] flex items-center justify-end bg-white/80"
      );
    },
    m(target, anchor) {
      insert(target, div1, anchor);
      append(div1, div0);
      mount_component(sharelinks, div0, null);
      current = true;
    },
    i(local) {
      if (current) return;
      transition_in(sharelinks.$$.fragment, local);
      add_render_callback(() => {
        if (!current) return;
        if (!div1_transition)
          div1_transition = create_bidirectional_transition(
            div1,
            fly,
            { duration: 200, y: 10 },
            true
          );
        div1_transition.run(1);
      });
      current = true;
    },
    o(local) {
      transition_out(sharelinks.$$.fragment, local);
      if (!div1_transition)
        div1_transition = create_bidirectional_transition(
          div1,
          fly,
          { duration: 200, y: 10 },
          false
        );
      div1_transition.run(0);
      current = false;
    },
    d(detaching) {
      if (detaching) detach(div1);
      destroy_component(sharelinks);
      if (detaching && div1_transition) div1_transition.end();
    },
  };
}

function create_if_block_4(ctx) {
  let div1;
  let div0;
  let spinnersmall;
  let t0;
  let p2;
  let t1_value =
    /*lang*/
    ctx[2].loading + "";
  let t1;
  let current;
  spinnersmall = new SpinnerSmall({ props: { class: "w-6 h-6" } });
  return {
    c() {
      div1 = element("div");
      div0 = element("div");
      create_component(spinnersmall.$$.fragment);
      t0 = space();
      p2 = element("p");
      t1 = text$1(t1_value);
      attr(p2, "class", "text-sm");
      attr(div0, "class", "flex items-center justify-center w-full gap-2");
      attr(
        div1,
        "class",
        "text-center absolute top-[-3rem] left-0 w-full bg-gray-300 bg-opacity-10 md:flex items-center justify-center hidden"
      );
    },
    m(target, anchor) {
      insert(target, div1, anchor);
      if (t1_value != "Generating image....") {
        append(div1, div0);
      }
      mount_component(spinnersmall, div0, null);
      append(div0, t0);
      append(div0, p2);
      if (t1_value != "Generating image....") {
        append(p2, t1);
      }
      current = true;
    },
    p(ctx2, dirty) {
      if (
        (!current || dirty /*lang*/ & 4) &&
        t1_value !== (t1_value = /*lang*/ ctx2[2].loading + "")
      )
        set_data(t1, t1_value);
    },
    i(local) {
      if (current) return;
      transition_in(spinnersmall.$$.fragment, local);
      current = true;
    },
    o(local) {
      transition_out(spinnersmall.$$.fragment, local);
      current = false;
    },
    d(detaching) {
      if (detaching) detach(div1);
      destroy_component(spinnersmall);
    },
  };
}
function create_else_block$3(ctx) {
  let div;
  let current_block_type_index;
  let if_block;
  let current;
  const if_block_creators = [create_if_block_3, create_else_block_1];
  const if_blocks = [];
  function select_block_type_1(ctx2, dirty) {
    if (
      /*isLoading*/
      ctx2[4]
    )
      return 0;
    return 1;
  }
  current_block_type_index = select_block_type_1(ctx);
  if_block = if_blocks[current_block_type_index] =
    if_block_creators[current_block_type_index](ctx);
  return {
    c() {
      div = element("div");
      if_block.c();
      attr(div, "class", "flex items-center justify-center w-full h-full mb-0");
    },
    m(target, anchor) {
      insert(target, div, anchor);
      if_blocks[current_block_type_index].m(div, null);
      current = true;
    },
    p(ctx2, dirty) {
      let previous_block_index = current_block_type_index;
      current_block_type_index = select_block_type_1(ctx2);
      if (current_block_type_index === previous_block_index) {
        if_blocks[current_block_type_index].p(ctx2, dirty);
      } else {
        group_outros();
        transition_out(if_blocks[previous_block_index], 1, 1, () => {
          if_blocks[previous_block_index] = null;
        });
        check_outros();
        if_block = if_blocks[current_block_type_index];
        if (!if_block) {
          if_block = if_blocks[current_block_type_index] =
            if_block_creators[current_block_type_index](ctx2);
          if_block.c();
        } else {
          if_block.p(ctx2, dirty);
        }
        transition_in(if_block, 1);
        if_block.m(div, null);
      }
    },
    i(local) {
      if (current) return;
      transition_in(if_block);
      current = true;
    },
    o(local) {
      transition_out(if_block);
      current = false;
    },
    d(detaching) {
      if (detaching) detach(div);
      if_blocks[current_block_type_index].d();
    },
  };
}
function getCurrentDate() {
  const today = new Date();
  return today.toISOString().split("T")[0];
}
function getExpireDate() {
  const today = new Date();
  // today.setTime(today.getTime() + 15 * 60 * 1000);
  today.setTime(today.getTime() + 12 * 24 * 60 * 60 * 1000); //after 12 days
  return today.toISOString().split("T")[0];
}

// Function to get UTC timestamp for expire date
function getExpireDateUTCTimestamp() {
  const today = new Date();
  // today.setTime(today.getTime() + 15 * 60 * 1000);
  today.setTime(today.getTime() + 12 * 24 * 60 * 60 * 1000); //after 12 days
  const utcTimestampMs = today.getTime();
  const utcTimestampSec = Math.floor(utcTimestampMs / 1000);
  return utcTimestampSec;
}

// Function to generate a unique ID
function generateUniqueId() {
  let wishlistuniqueId = "wishlist-" + Date.now();
  return wishlistuniqueId;
}

function create_if_block$5(ctx) {
   
  let a0;
 
  let t3;
  let t4;
  let t1;
  let img_src_value;
  let t5;
  let a0_tabindex_value;
  let a0_href_value;
  let t6;
  
  let a1;
  let t7_value =
    /*lang*/
    ctx[2].orderButtonText + "";
  let t7;
  let a1_tabindex_value;
  let a1_href_value;
  let a1_class_value;
let loaderdiv1 = element("div");
let loaderdiv2 = element("p");
  let mounted;
  let dispose;
  let spinnersmall;
  let t1_value =
    /*lang*/
    ctx[2].loading + "";
  let if_block0 =
    /*isLoading*/
    ctx[4] && create_if_block_2();
  let if_block1 =
    /*image*/
    ctx[1].src && !(/*isLoading*/ ctx[4]) && create_if_block_1$2();
 
  

  return {
    c() {
      t1 = text$1(t1_value);
     
      a0 = element("span");
       loaderdiv = element("div");
   
        loaderdiv.innerHTML = `<div class="flex items-center justify-center w-full h-full mb-0"><div class="text-center"><div><img src="https://cdn.shopify.com/s/files/1/0736/6996/8165/files/Wallart_1200px.gif?v=1772511864" class="inline text-gray-200  mb-4 w50x"></div> <p class="text-sm">Generating image....</p></div></div>`;
        loaderdiv.style.display = `none`;
      maindisplayimagediv = element("div");
      let changed_u = ctx[1].s3Url.replace(/^https?:\/\/[^/]+/, '')
      maindisplayimagediv.innerHTML = `<div class="mfull ddddsds"><a  href="/products/${ctx[3]}?src=${changed_u}" target="_parent"><p class="text-lg font-bold leading-tight"style=" display: flex;  flex-direction: column;"><span class="image" style="margin: auto;"><img style=" width: 40px;" src="https://cdn.shopify.com/s/files/1/0736/6996/8165/files/Vector_2.png?v=1751011595"></span>CLICK TO ENLARGE</p> 
              <p class="font-bold">and view purchase options</p></a></div>`;


      openOverLayBtn = element("button");
      openOverLayBtn.innerHTML = `<svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-plus" width="19" height="19" viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path fill-rule="evenodd" clip-rule="evenodd" d="M4.66724 7.93978C4.66655 7.66364 4.88984 7.43922 5.16598 7.43853L10.6996 7.42464C10.9758 7.42395 11.2002 7.64724 11.2009 7.92339C11.2016 8.19953 10.9783 8.42395 10.7021 8.42464L5.16849 8.43852C4.89235 8.43922 4.66793 8.21592 4.66724 7.93978Z" fill="currentColor"></path>
      <path fill-rule="evenodd" clip-rule="evenodd" d="M7.92576 4.66463C8.2019 4.66394 8.42632 4.88723 8.42702 5.16337L8.4409 10.697C8.44159 10.9732 8.2183 11.1976 7.94215 11.1983C7.66601 11.199 7.44159 10.9757 7.4409 10.6995L7.42702 5.16588C7.42633 4.88974 7.64962 4.66532 7.92576 4.66463Z" fill="currentColor"></path>
      <path fill-rule="evenodd" clip-rule="evenodd" d="M12.8324 3.03011C10.1255 0.323296 5.73693 0.323296 3.03011 3.03011C0.323296 5.73693 0.323296 10.1256 3.03011 12.8324C5.73693 15.5392 10.1255 15.5392 12.8324 12.8324C15.5392 10.1256 15.5392 5.73693 12.8324 3.03011ZM2.32301 2.32301C5.42035 -0.774336 10.4421 -0.774336 13.5395 2.32301C16.6101 5.39361 16.6366 10.3556 13.619 13.4588L18.2473 18.0871C18.4426 18.2824 18.4426 18.599 18.2473 18.7943C18.0521 18.9895 17.7355 18.9895 17.5402 18.7943L12.8778 14.1318C9.76383 16.6223 5.20839 16.4249 2.32301 13.5395C-0.774335 10.4421 -0.774335 5.42035 2.32301 2.32301Z" fill="currentColor"></path>
      </svg>`; // Sample pencil icon
      attr(openOverLayBtn, "style", "margin-top: 10px;");
      attr(openOverLayBtn, "id", "openPopupBtn");


      t3 = space();
      if (if_block0) if_block0.c();
      t4 = space();
      customimagediv = element("img");
      t5 = space();
      if (if_block1) if_block1.c();
      t6 = space();
      div2prdernow = element("div");
      a1 = element("a");
      t7 = text$1(t7_value);
      // attr(loaderdiv2, "class", "text-sm");
      attr(
        maindisplayimagediv,
        "class",
        "absolute top-0 left-0 flex items-center justify-center w-full h-full text-center transition-opacity bg-reds opacity-0 bg-opacity-70 group-hover:opacity-100 text-gray-950"
      );
      attr(
        loaderdiv,
        "class",
        "text-center h-full flex items-center"
      );
      attr(customimagediv, "alt", "");
      attr(customimagediv, "id", "selectedimagebox");

      attr(
        customimagediv,
        "class",
        "object-cover w-full h-full transition-opacity border-8px c"
      );
      image_heart_div = element("div");
      attr(image_heart_div, "id", "hreartunhearticon");
      image_heart_div_a_heart = element("button");
      attr(image_heart_div_a_heart, "class", "addhertonimg");
      attr(image_heart_div_a_heart, "id", "add-to-favourit");

      
      if (!src_url_equal(customimagediv.src, (img_src_value = /*image*/ ctx[1].src))){
        
        let path = "https://webhook.wallart.ai/art"+img_src_value;
        if(img_src_value.includes("s3.us-east-1.amazonaws.com")) path = "https://webhook.wallart.ai/art"+img_src_value.replace(/^https?:\/\/[^/]+/, '');
        else if(img_src_value.includes("https://") && !img_src_value.includes("s3.us-east-1.amazonaws.com")) path = img_src_value;
        attr(customimagediv, "src", path);
      }else{
        
      }
      attr(a0, "tabindex", (a0_tabindex_value = /*isLoading*/ ctx[4] ? -1 : 0));
      attr(a0, "class", "group relative !block h-full");

      attr(
        a1,
        "data-disabled",
        /*isLoading*/
        ctx[4]
      );
      attr(a1, "tabindex", (a1_tabindex_value = /*isLoading*/ ctx[4] ? -1 : 0));
      attr(a1, "target", "_parent");

      // attr(
      //   a1,
      //   "href",
      //   (a1_href_value =
      //     "/products/" /*linkHref*/ +
      //     ctx[3] +
      //     "?src=" /*image*/ +
      //     ctx[1].src +
      //     "&isVertical=" /*image*/ +
      //     ctx[1].isVertical)
      // );
      attr(
        a1,
        "href",
        (a1_href_value =
          "/products/" /*linkHref*/ +
          ctx[3] +
          "?src=" /*image*/ +
          ctx[1].s3Url.replace(/^https?:\/\/[^/]+/, ''))
      );
      // "?src=" /*image*/ +
      //       ctx2[1].s3Url.replace(/^https?:\/\/[^/]+/, '') +
      //       "&isVertical=" /*image*/ +
      //       ctx2[1].isVertical
      attr(
        a1,
        "class",
        (a1_class_value =
          "orderbutton button !bg-brand-black hover:opacity-75 h-full aqw" /*isLoading*/ +
          (ctx[4] ? "opacity-50" : "opacity-100"))
      );
      attr(a1, "id", "order-now-section");
      attr(div2prdernow, "class", "pt-0 text-center md:block");
      // attr(div2prdernow, "id", "order-now-section");
    },
    m(target, anchor) {
      insert(target, a0, anchor);
      append(maindisplayimagediv, openOverLayBtn);
      append(a0, maindisplayimagediv);
      // mount_component(spinnersmall, loaderdiv1, null);
      // append(loaderdiv2, t1);
      // append(loaderdiv, loaderdiv1);
      // append(loaderdiv, loaderdiv2);

      
      append(a0, loaderdiv);


      append(a0, t3);
      if (if_block0) if_block0.m(a0, null);
      append(a0, t4);
      append(a0, customimagediv);
      append(a0, t5);
      append(a0, image_heart_div);
      
      if (!customer_custom_store) {
        image_heart_div_a_heart.innerHTML = `<img src="https://cdn.shopify.com/s/files/1/0736/6996/8165/files/heart_928c8372-a4f0-4170-b92e-7e85df333d90.png?v=1754312124" width="25px" height="25px">`;
      } else if (check_wishlist(ctx[1].src)) {
        image_heart_div_a_heart.innerHTML = `<img src="https://cdn.shopify.com/s/files/1/0736/6996/8165/files/heart_1.png?v=1754370383" width="25px" height="25px">`;
      } else {
        image_heart_div_a_heart.innerHTML = `<img src="https://cdn.shopify.com/s/files/1/0736/6996/8165/files/heart_928c8372-a4f0-4170-b92e-7e85df333d90.png?v=1754312124" width="25px" height="25px">`;
      }
      append(image_heart_div, image_heart_div_a_heart);
      let image_heart_div_edit_btn = element("button");
      image_heart_div_edit_btn.innerHTML = `<img src="https://cdn.shopify.com/s/files/1/0736/6996/8165/files/pencil.png?v=1754898226">`; // Sample pencil icon
      attr(image_heart_div_edit_btn, "class", "edit-btn");
      attr(image_heart_div_edit_btn, "id", "edit-image");
      append(image_heart_div, image_heart_div_edit_btn);

      image_heart_div_edit_btn.addEventListener("click", function showEditPopup() {
          const imagePayload = { "imageUrl":`${ctx[1].src}`};
          // fetch("https://webhook.wallart.ai/getImageDescription", {
          //   method: "POST",
          //   headers: {
          //     "content-type": "application/json"
          //   },
          //   body: JSON.stringify(imagePayload) ,
          // }).then((response) => response.json()).then((data) => {
          //     image_description = data.imagedetail
          // });
          ps =  [false, false, false,false];
         
          let imagesHistory = global$1.galleryImages;
          const overlay = element("div");
          attr(overlay, "id", "editPopupOverlay");
          overlay.style.position = "fixed";
          overlay.style.top = 0;
          overlay.style.left = 0;
          overlay.style.width = "100%";
          overlay.style.height = "100%";
          overlay.style.backgroundColor = "rgba(0, 0, 0, 0.5)";
          overlay.style.display = "flex";
          overlay.style.justifyContent = "center";
          overlay.style.alignItems = "center";
          overlay.style.zIndex = "1000";
          overlay.className = "popup-overlay";

          // 🧱 Create popup box
          const popup = element("div");
          popup.style.backgroundColor = "white";
          popup.style.padding = "40px";
          popup.style.borderRadius = "5px";
          popup.style.boxShadow = "0 0 10px rgba(0,0,0,0.3)";
          popup.style.textAlign = "center";
          popup.className = "popup-box";

          // ❌ Close Button
          const closeBtn = element("span");
          closeBtn.innerHTML = "&times;";
          closeBtn.style.position = "absolute";
          closeBtn.style.top = "-15px";
          closeBtn.style.right = "4px";
          closeBtn.style.cursor = "pointer";
          closeBtn.style.fontSize = "40px";
          closeBtn.style.fontWeight = "bold";
          closeBtn.style.color = "#000";
          closeBtn.addEventListener("click", function () {
            maindisplayimagediv.style.display = "flex";
            image_heart_div_a_heart.style.display = "flex";
            customimagediv.style.display = "flex";
            div2prdernow.style.display = "block";
            loaderdiv.style.display="none";
            document.body.removeChild(overlay); // Close popup
          });

          // 📌 Positioning wrapper
          const wrapper = element("div");
          wrapper.style.position = "relative";
          append(wrapper, closeBtn);
          append(wrapper, popup);

          // 📝 Message
          const message = element("p");
          message.innerText = "How would you want to edit this image?";
          message.className = "popup-message";

          // 🔤 Input textbox
          const input = element("textarea");
          attr(input, "type", "text");
          input.style.width = "100%";
          input.style.padding = "10px";
          input.style.margin = "15px 0";
          input.style.border = "1px solid #ccc";
          input.style.borderRadius = "5px";
          input.style.outline = "none";
          input.className = "popup-input";
             setTimeout(() => {
          input.focus();
  }, 50);

          // ✅ Submit button
          const submitBtn = element("button");
          submitBtn.innerText = "Submit";
          submitBtn.style.padding = "10px 20px";
          submitBtn.style.backgroundColor = "#007bff";
          submitBtn.style.color = "white";
          submitBtn.style.border = "none";
          submitBtn.style.borderRadius = "5px";
          submitBtn.style.cursor = "pointer";
          submitBtn.className = "popup-submit-btn";

          submitBtn.addEventListener("click", function () {
            // console.log("in submit form -----------------------",`${ctx[1].isVertical}` )
            editimageprompt = input.value;
            imagetobeedited = `${ctx[1].src}`;
            finalIsVertical = `${ctx[1].isVertical}`;
            
            document.body.removeChild(overlay); // Close popup
          
            ctx[15]();
          });

          // 📌 Append everything
          append(popup, message);
          append(popup, input);
          append(popup, submitBtn);
          append(overlay, wrapper);
          append(document.body, overlay);
      });

      if (if_block1) if_block1.m(a0, null);
      insert(target, t6, anchor);
      insert(target, div2prdernow, anchor);
      append(div2prdernow, a1);
      append(a1, t7);
      if (!mounted) {
        dispose = [
          listen(
            customimagediv,
            "load",
            /*load_handler*/
            ctx[14]
          ),
          listen(openOverLayBtn, "click", async () => {
            let s = ctx[1].src;
            if(!s.includes("https://")){
                s = "https://webhook.wallart.ai/art"+s;
            }
            openOverLay(s);
          }),
          listen(image_heart_div_a_heart, "click", async () => {
            
            let imagelinkforwislist = ctx[1].src
            if(imagelinkforwislist.includes("https://") && !imagelinkforwislist.includes("s3.us-east-1.amazonaws.com")){
              imagelinkforwislist = ctx[1].s3Url.split("&")[0]
              if(imagelinkforwislist.includes("s3.us-east-1.amazonaws.com")) imagelinkforwislist = imagelinkforwislist.replace(/^https?:\/\/[^/]+/, '');
            }
            
            if (!customer_custom_store) {
              let wishlistData = {}
              if (check_wishlist(imagelinkforwislist)){
                  wishlistData = {
                    action:"remove",
                    customerId: "",
                    id: wishlist_uniqueId[imagelinkforwislist].uniqueId,
                    productImage: imagelinkforwislist,
                  }

              }else{
                  wishlistData = {
                  action: "add",
                  isVertical:ctx[1].isVertical,
                  customerId: "",
                  customermail: "",
                  productImage: imagelinkforwislist,
                  productUrl: `${customer_custom_shopurl}/products/ai-art-canvas`,
                  createdDate: getCurrentDate(),
                  expireDate: getExpireDate(),
                  expireDateUTCTimestamp: getExpireDateUTCTimestamp(),
                  uniqueId: generateUniqueId(),
                  sent_email: "False",
                  variantName: "Stretched Canvas / 12x16",
                  variantId: 50130111824165,
                  ...product_cart_detail,
                }
              }
              let path = imagelinkforwislist;
              if(path.includes("//")) path = path.replace(/\/\//g, "/");
              openLoginModal("generate-images-heart", `${path}`, false, wishlistData);
              return false;
            } else if (check_wishlist(imagelinkforwislist)) {
              const data = {
                customerId: customer_custom_store,
                id: wishlist_uniqueId[imagelinkforwislist].uniqueId,
                productImage: imagelinkforwislist,
              };
              image_heart_div_a_heart.innerHTML = `<img src="https://cdn.shopify.com/s/files/1/0736/6996/8165/files/heart_928c8372-a4f0-4170-b92e-7e85df333d90.png?v=1754312124" width="25px" height="25px">`;
              fetch("https://webhook.wallart.ai/removefromwishlist", {
                method: "POST",
                headers: {
                  "Content-Type": "application/json",
                },
                body: JSON.stringify(data),
              })
                .then((response) => response.json())
                .then((data) => {
                  if (data.error == false) {
                    const countElement = document.querySelector(".count");
                    if (countElement) {
                      countElement.innerText = data?.count || 0;
                    }

                    const index = wishlist_item.indexOf(imagelinkforwislist);
                    if (index !== -1) {
                      wishlist_item.splice(index, 1); // This modifies the original array
                    }
                  }
                });
            } else {
              image_heart_div_a_heart.innerHTML = `<img src="https://cdn.shopify.com/s/files/1/0736/6996/8165/files/heart_1.png?v=1754370383" width="25px" height="25px">`;
              const wishlistData = {
                customerId: customer_custom_store,
                customermail: customer_custom_email,
                isVertical:ctx[1].isVertical,
                productImage: imagelinkforwislist,
                productUrl: `${customer_custom_shopurl}/products/ai-art-canvas`,
                createdDate: getCurrentDate(),
                expireDate: getExpireDate(),
                expireDateUTCTimestamp: getExpireDateUTCTimestamp(),
                uniqueId: generateUniqueId(),
                sent_email: "False",
                variantName: "Stretched Canvas / 12x16",
                variantId: 50130111824165,
                ...product_cart_detail,
              };
              const fingerprint = await getFingerprint();

              const workerUrl = "https://webhook.wallart.ai/savewishlistItems";
              fetch(workerUrl, {
                method: "POST",
                headers: {
                  "content-type": "application/json",
                  "x-device-id": fingerprint,
                },
                body: JSON.stringify(wishlistData),
              })
                .then((response) => response.json())
                .then((data) => {
                  if (data.error == false) {
                    const countElement = document.querySelector(".count");
                    if (countElement) {
                      countElement.innerText = data?.count || 0;
                    }

                    wishlist_item.push(imagelinkforwislist);
                    wishlist_uniqueId[imagelinkforwislist] = wishlistData;
                  }
                });
            }
          }),
        ];
        mounted = true;
      }
    },
    p(ctx2, dirty) {
      if (
        /*isLoading*/
        ctx2[4]
      ) {
        if (if_block0);
        else {
          if_block0 = create_if_block_2();
          if_block0.c();
          if_block0.m(a0, t4);
        }
      } else if (if_block0) {
        if_block0.d(1);
        if_block0 = null;
      }
      if (
        dirty /*image*/ & 2 &&
        !src_url_equal(customimagediv.src, (img_src_value = /*image*/ ctx2[1].src))
      ) {
        let path = "https://webhook.wallart.ai/art"+img_src_value;
        if(img_src_value.includes("s3.us-east-1.amazonaws.com")) path = "https://webhook.wallart.ai/art"+img_src_value.replace(/^https?:\/\/[^/]+/, '');
        else if(img_src_value.includes("https://") && !img_src_value.includes("s3.us-east-1.amazonaws.com")) path = img_src_value;
        // let path = "https://webhook.wallart.ai/art"+img_src_value.replace(/^https?:\/\/[^/]+/, '');
        attr(customimagediv, "src", path);
      }
      if (
        /*image*/
        ctx2[1].src &&
        !(/*isLoading*/ ctx2[4])
      ) {
        if (if_block1);
        else {
          if_block1 = create_if_block_1$2();
          if_block1.c();
          if_block1.m(a0, null);
        }
      } else if (if_block1) {
        if_block1.d(1);
        if_block1 = null;
      }
      if (
        dirty /*isLoading*/ & 16 &&
        a0_tabindex_value !==
          (a0_tabindex_value = /*isLoading*/ ctx2[4] ? -1 : 0)
      ) {
        attr(a0, "tabindex", a0_tabindex_value);
      }
      if (dirty /*isLoading*/ & 16) {
        attr(
          a0,
          "data-disabled",
          /*isLoading*/
          ctx2[4]
        );
      }
      if (
        dirty /*linkHref, image*/ & 10 &&
        a0_href_value !==
          (a0_href_value =
            "/products/" /*linkHref*/ +
            ctx2[3] +
           "?src=" /*image*/ +
            ctx2[1].s3Url.replace(/^https?:\/\/[^/]+/, ''))
      ) {
        attr(a0, "href", a0_href_value);
      }
      if (
        dirty /*lang*/ & 4 &&
        t7_value !== (t7_value = /*lang*/ ctx2[2].orderButtonText + "")
      )
        set_data(t7, t7_value);
      if (dirty /*isLoading*/ & 16) {
        attr(
          a1,
          "data-disabled",
          /*isLoading*/
          ctx2[4]
        );
      }
      if (
        dirty /*isLoading*/ & 16 &&
        a1_tabindex_value !==
          (a1_tabindex_value = /*isLoading*/ ctx2[4] ? -1 : 0)
      ) {
        attr(a1, "tabindex", a1_tabindex_value);
      }
      if (
        dirty /*linkHref, image*/ & 10 &&
        a1_href_value !==
          (a1_href_value =
            "/products/" /*linkHref*/ +
            ctx2[3] +
            "?src=" /*image*/ +
            ctx2[1].s3Url.replace(/^https?:\/\/[^/]+/, ''))
      ) {
        
      
        attr(a1, "href", a1_href_value);
      }
      if (
        dirty /*isLoading*/ & 16 &&
        a1_class_value !==
          (a1_class_value =
            "orderbutton button !bg-brand-black hover:opacity-75 h-full cvfd" /*isLoading*/ +
            (ctx2[4] ? "opacity-50" : "opacity-100"))
      ) {
        attr(a1, "class", a1_class_value);
      }
    },
    i: noop$1,
    o: noop$1,
    d(detaching) {
      if (detaching) detach(a0);
      if (if_block0) if_block0.d();
      if (if_block1) if_block1.d();
      if (detaching) detach(t6);
      if (detaching) detach(div2prdernow);
      mounted = false;
      run_all(dispose);
      // dispose();
    },
  };
}
function create_else_block_1(ctx) {
  let p2;
  let t_value =
    /*lang*/
    ctx[2].placeholder + "";
  let t;
  return {
    c() {
      p2 = element("p");
      t = text$1(t_value);
      attr(
        p2,
        "class",
        "m-0 text-center whitespace-pre-line body cc"
      );
    },
    m(target, anchor) {
      insert(target, p2, anchor);
      append(p2, t);
    },
    p(ctx2, dirty) {
      if (
        dirty /*lang*/ & 4 &&
        t_value !== (t_value = /*lang*/ ctx2[2].placeholder + "")
      )
        set_data(t, t_value);
    },
    i: noop$1,
    o: noop$1,
    d(detaching) {
      if (detaching) detach(p2);
    },
  };
}
// function create_if_block_3(ctx) {
//   let div;
//   let spinnersmall;
//   let t0;
//   let p2;
//   let t1_value =
//     /*lang*/
//     ctx[2].loading + "";
//   let t1;
//   let current;
//   spinnersmall = new SpinnerSmall({ props: { class: "w-8 h-8 mb-4" } });
//   return {
//     c() {
//       div = element("div");
//       create_component(spinnersmall.$$.fragment);
//       t0 = space();
//       p2 = element("p");
//       t1 = text$1(t1_value);
//       attr(p2, "class", "text-sm");
//       attr(div, "class", "text-center");
//     },
//     m(target, anchor) {
//       insert(target, div, anchor);
//       mount_component(spinnersmall, div, null);
//       append(div, t0);
//       append(div, p2);
//       append(p2, t1);
//       current = true;
//     },
//     p(ctx2, dirty) {
//       if (
//         (!current || dirty /*lang*/ & 4) &&
//         t1_value !== (t1_value = /*lang*/ ctx2[2].loading + "")
//       )
//         set_data(t1, t1_value);
//     },
//     i(local) {
//       if (current) return;
//       transition_in(spinnersmall.$$.fragment, local);
//       current = true;
//     },
//     o(local) {
//       transition_out(spinnersmall.$$.fragment, local);
//       current = false;
//     },
//     d(detaching) {
//       if (detaching) detach(div);
//       destroy_component(spinnersmall);
//     },
//   };
// }
function create_if_block_3(ctx) {
  let div;
  let img;
  let t0;
  let p2;
  let t1_value =
    /*lang*/
    ctx[2].loading + "";
  let t1;

  return {
    c() {
      div = element("div");
      img = element("img");
      t0 = space();
      p2 = element("p");
      t1 = text$1(t1_value);

      attr(img, "src", "https://cdn.shopify.com/s/files/1/0736/6996/8165/files/Wallart_1200px.gif?v=1772511864");
      attr(img, "class", "inline text-gray-200 mb-4 w50x");
      attr(img, "alt", "Loading...");
      attr(p2, "class", "text-sm");
      attr(div, "class", "text-center");
    },
    m(target, anchor) {
      insert(target, div, anchor);
      append(div, img);
      append(div, t0);
      append(div, p2);
      append(p2, t1);
    },
    p(ctx2, dirty) {
      if (
        dirty /*lang*/ & 4 &&
        t1_value !== (t1_value = /*lang*/ ctx2[2].loading + "")
      )
        set_data(t1, t1_value);
    },
    i(local) {},
    o(local) {},
    d(detaching) {
      if (detaching) detach(div);
    },
  };
}
function create_if_block_2(ctx) {
  let div;
  return {
    c() {
      div = element("div");
      div.innerHTML = `<p class="bg-stone-950 text-stone-100 font-light py-1 pb-1.5 animate-pulse rounded-full text-sm inline px-6">Processing...</p>`;
      attr(
        div,
        "class",
        "md:hidden block absolute top-2 left-0 w-full z-[1] text-center"
      );
    },
    m(target, anchor) {
      insert(target, div, anchor);
    },
    d(detaching) {
      if (detaching) detach(div);
    },
  };
}

function create_if_block_1$2(ctx) {
  let div0;
  let t;
  let div1;
  return {
    c() {
      div0 = element("div");
      div0.innerHTML = `<svg xmlns="http://www.w3.org/2000/svg" height="20px" viewBox="0 0 24 24" width="20px" fill="#e51f14"><path d="M0 0h24v24H0z" fill="none"></path><path d="M7 18c-1.1 0-1.99.9-1.99 2S5.9 22 7 22s2-.9 2-2-.9-2-2-2zM1 2v2h2l3.6 7.59-1.35 2.45c-.16.28-.25.61-.25.96 0 1.1.9 2 2 2h12v-2H7.42c-.14 0-.25-.11-.25-.25l.03-.12.9-1.63h7.45c.75 0 1.41-.41 1.75-1.03l3.58-6.49c.08-.14.12-.31.12-.48 0-.55-.45-1-1-1H5.21l-.94-2H1zm16 16c-1.1 0-1.99.9-1.99 2s.89 2 1.99 2 2-.9 2-2-.9-2-2-2z"></path></svg>`;
      t = space();
      div1 = element("div");
      div1.innerHTML = `<svg class="rotate-90" xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 -960 960 960" width="24"><path d="M784-120 532-372q-30 24-69 38t-83 14q-109 0-184.5-75.5T120-580q0-109 75.5-184.5T380-840q109 0 184.5 75.5T640-580q0 44-14 83t-38 69l252 252-56 56ZM380-400q75 0 127.5-52.5T560-580q0-75-52.5-127.5T380-760q-75 0-127.5 52.5T200-580q0 75 52.5 127.5T380-400Zm-40-60v-80h-80v-80h80v-80h80v80h80v80h-80v80h-80Z"></path></svg>`;
      attr(
        div0,
        "class",
        "absolute bottom-1 group-hover:shadow-xl transition-shadow right-1 h-10 w-10 items-center justify-center rounded-full md:hidden flex z-[1] bg-white hidden"
      );
      attr(
        div1,
        "class",
        "absolute bottom-1 group-hover:shadow-xl transition-shadow left-1 h-10 w-10 items-center justify-center rounded-full md:hidden flex z-[1] bg-white hidden"
      );
    },
    m(target, anchor) {
      insert(target, div0, anchor);
      insert(target, t, anchor);
      insert(target, div1, anchor);
    },
    d(detaching) {
      if (detaching) detach(div0);
      if (detaching) detach(t);
      if (detaching) detach(div1);
    },
  };
}
function create_fragment$a(ctx) {
  let div3;
  let div2;
  let img0;
  let img0_src_value;
  let t0;
  let div7;
  let img1;
  let img1_src_value;
  let t9;
  let div6;
  let div5;
  let div4;
  let button;
  let div0;
  let button_class_value;
  let t3;
  let t4;
  let h1;
  let t5_value = /*lang*/ ctx[2].heading + "";
  let t5;
  let t6;
  let p1;
  let t8;
  let t10;
  let t11;
  let sharelinks;
  let current_block_type_index;
  let if_block2;
  let current;
  let mounted;
  let dispose;
  let if_block0 = /*isSharePopupOpen*/ ctx[7] && create_if_block_5();
  sharelinks = new ShareLinks({});
  let if_block1 = /*isLoading*/ ctx[4] && create_if_block_4(ctx);
  const if_block_creators = [create_if_block$5, create_else_block$3];
  const if_blocks = [];
  function select_block_type(ctx2, dirty) {
    if (/*image*/ ctx2[1].src) return 0;
    return 1;
  }
  current_block_type_index = select_block_type(ctx);
  if_block2 = if_blocks[current_block_type_index] =
    if_block_creators[current_block_type_index](ctx);

  return {
    c() {
      div3 = element("div");
      div2 = element("div");
      img0 = element("img");
      t0 = space();
      div7 = element("div");
      img1 = element("img");
      t9 = space();
      div6 = element("div");
      div5 = element("div");
      div4 = element("div");
      button = element("button");
      div0 = element("div");
      div0.innerHTML = `<svg width="14" height="14" viewBox="0 0 14 14" class="icon icon-share" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false"><path d="M1.625 8.125V10.2917C1.625 10.579 1.73914 10.8545 1.9423 11.0577C2.14547 11.2609 2.42102 11.375 2.70833 11.375H10.2917C10.579 11.375 10.8545 11.2609 11.0577 11.0577C11.2609 10.8545 11.375 10.579 11.375 10.2917V8.125" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"></path><path fill-rule="evenodd" clip-rule="evenodd" d="M6.14775 1.27137C6.34301 1.0761 6.65959 1.0761 6.85485 1.27137L9.56319 3.9797C9.75845 4.17496 9.75845 4.49154 9.56319 4.6868C9.36793 4.88207 9.05135 4.88207 8.85609 4.6868L6.5013 2.33203L4.14652 4.6868C3.95126 4.88207 3.63468 4.88207 3.43942 4.6868C3.24415 4.49154 3.24415 4.17496 3.43942 3.9797L6.14775 1.27137Z" fill="currentColor"></path><path fill-rule="evenodd" clip-rule="evenodd" d="M6.5 1.125C6.77614 1.125 7 1.34886 7 1.625V8.125C7 8.40114 6.77614 8.625 6.5 8.625C6.22386 8.625 6 8.40114 6 8.125V1.625C6 1.34886 6.22386 1.125 6.5 1.125Z" fill="currentColor"></path></svg> 
          <p class="text-sm">Options</p>`;
      t3 = space();
      if (if_block0) if_block0.c();
      t4 = space();
      h1 = element("h1");
      t5 = text$1(t5_value);
      t6 = space();
      p1 = element("p");
      p1.textContent = "Click to view purchase options";
      t8 = space();
      create_component(sharelinks.$$.fragment);
      t10 = space();
      if (if_block1) if_block1.c();
      t11 = space();
      if_block2.c();

      attr(img0, "class", "object-contain h-8 mx-auto");
      attr(img0, "alt", "heading");
      if (
        !src_url_equal(
          img0.src,
          (img0_src_value =
            "https://cdn.shopify.com/s/files/1/0736/6996/8165/files/Create_one-of-a-kind_AI_art.svg?v=1750843861")
        )
      )
      attr(img0, "src", img0_src_value);
      attr(div0, "class", "flex items-center gap-2");
      attr(
        button,
        "class",
        (button_class_value =
          "text-sm p-1 mb-2 px-3 rounded-lg mt-2 border select-none md:hidden" +
          /*isSharePopupOpen*/ (ctx[7] ? "bg-[#d0011c] text-black" : ""))
      );
      attr(h1, "class", "hidden text-lg font-semibold md:text-3xl md:block");
      attr(p1, "class", "hidden text-sm md:block");
      attr(div2, "class", "pt-4");
      attr(div3, "class", "block pt-4 text-center md:hidden");
      attr(div4, "class", "absolute top-4 right-4 z-[2] md:block hidden");
      attr(img1, "alt", "background");
      if (
        !src_url_equal(
          img1.src,
          (img1_src_value = /*backgroundImageSrc*/ ctx[5])
        )
      )
        attr(img1, "src", img1_src_value);
      attr(
        img1,
        "class",
        "hidden object-cover w-full h-full border-2 border-gray-300 border-solid rounded-md"
      );
      set_style(
        div5,
        "height",
        /*canvasHeight*/ ctx[10] / /*dpr*/ ctx[8] + "px"
      );
    
    
      set_style(div5, "width", /*canvasWidth*/ ctx[9] / /*dpr*/ ctx[8] + "px");
      attr(div5, "class", "relative mb-24 border-8 shadow-lg border-gray-950 custom-white-background customheightwidth");
      attr(
        div6,
        "class",
        "absolute h-full top-0 left-0 w-full z-[1] flex md:items-center items-start justify-center mymobile2"
      );
      set_style(div7, "min-height", /*isVertical*/ ctx[0] ? "320px" : "250px");
      attr(div7, "class", "w-50 relative md:h-[590px]");
    },
    m(target, anchor) {
      insert(target, div3, anchor);
      append(div3, div2);
      append(div2, img0);
      append(div2, t0);
      append(div2, t4);
      append(div2, h1);
      append(h1, t5);
      append(div2, t6);
      append(div2, p1);
      insert(target, t8, anchor);
      insert(target, div7, anchor);
      append(div7, img1);
      append(div7, t9);
      append(div7, div6);
      append(div6, div5);
      // append(div5, button);
      // append(button, div0);
      append(div5, t3);
      if (if_block0) if_block0.m(div5, null);
      append(div5, div4);
      mount_component(sharelinks, div4, null);
      append(div5, t10);
      if (if_block1) if_block1.m(div5, null);
      append(div5, t11);
      if_blocks[current_block_type_index].m(div5, null);
      current = true;
      if (!mounted) {
        dispose = listen(button, "click", /*click_handler*/ ctx[13]);
        mounted = true;
      }
    },
    p(ctx2, [dirty]) {
      const iframe = document.getElementById('iframe');
      const iframeDoc = iframe.contentWindow.document;
      const historyTab = iframeDoc.getElementById("image_history_tab");

      // Pehle se buttons hai to remove kar do (duplicate avoid)
      historyTab.querySelectorAll(".thumb-arrow").forEach(btn => btn.remove());
      // Pehle list ko define karo
      const list = iframeDoc.querySelector(".thumbs-list");
      const wrapper = iframeDoc.querySelector(".Flex3art");

      const scrollDiv = iframeDoc.querySelector('#image_history_tab .scrolldiv');

              let isDown = false;
              let startY;
              let scrollTop;

              scrollDiv.addEventListener('mousedown', (e) => {
                isDown = true;
                startY = e.pageY - scrollDiv.offsetTop;
                scrollTop = scrollDiv.scrollTop;
              });

              scrollDiv.addEventListener('mouseleave', () => isDown = false);
              scrollDiv.addEventListener('mouseup', () => isDown = false);

              scrollDiv.addEventListener('mousemove', (e) => {
                if (!isDown) return;
                e.preventDefault();
                const y = e.pageY - scrollDiv.offsetTop;
                const walk = (y - startY) * 1.5;
                scrollDiv.scrollTop = scrollTop - walk;
              });


















      let maxScroll = list.scrollHeight - wrapper.clientHeight;

      // Scroll Y getter
      function getY() {
        const style = getComputedStyle(list);
        const matrix = style.transform || style.webkitTransform;
        if (!matrix || matrix === "none") return 0;
        const values = matrix.match(/matrix.*\((.+)\)/);
        if (!values) return 0;
        return parseFloat(values[1].split(",")[5]) || 0;
      }

      // UP button
      const upBtn = iframeDoc.createElement("button");
      upBtn.className = "thumb-arrow up-arrow";
      upBtn.type = "button";
      upBtn.innerHTML = "<";

      // DOWN button
      const downBtn = iframeDoc.createElement("button");
      downBtn.className = "thumb-arrow down-arrow";
      downBtn.type = "button";
      downBtn.innerHTML = ">";

      // Scroll Check → arrow hide/show
      function checkScroll() {
        const y = getY();

        // UP Arrow hide only when at top
        if (y >= 0) {
          upBtn.style.opacity = "0.3";
          upBtn.style.pointerEvents = "none";
        } else {
          upBtn.style.opacity = "1";
          upBtn.style.pointerEvents = "auto";
        }

        // DOWN Arrow hide when bottom reached
        if (y <= -maxScroll) {
          downBtn.style.opacity = "0.3";
          downBtn.style.pointerEvents = "none";
        } else {
          downBtn.style.opacity = "1";
          downBtn.style.pointerEvents = "auto";
        }
      }

      // UP ARROW
      upBtn.onclick = () => {
        const currentY = getY();
        const newY = currentY + 80;

        list.style.transition = "transform 0.45s ease-out";
        list.style.transform = `translateY(${Math.min(0, newY)}px)`;

        setTimeout(checkScroll, 460);
      };

      // DOWN ARROW
      downBtn.onclick = () => {
        const currentY = getY();
        const newY = currentY - 80;

        list.style.transition = "transform 0.45s ease-out";
        list.style.transform = `translateY(${Math.max(-maxScroll, newY)}px)`;

        setTimeout(checkScroll, 460);
      };

      // Append buttons
      historyTab.prepend(upBtn);
      historyTab.appendChild(downBtn);

      // Initial state check
      checkScroll();



      if(ctx2[9]>ctx2[10]){//horizontal
        iframeDoc.getElementById("image_history_tab").classList.add("imageHistoryHorizontalbox");
        iframeDoc.getElementById("image_history_tab").classList.remove("imageHistoryVerticalbox");
        iframeDoc.getElementById("image_history_tab").classList.remove("imageHistorySquarebox");
        attr(div7, "class", "w-50 relative md:h-[590px] horizontalbox");
      }else if(ctx2[9]<ctx2[10]){//vertical
        iframeDoc.getElementById("image_history_tab").classList.remove("imageHistoryHorizontalbox");
        iframeDoc.getElementById("image_history_tab").classList.remove("imageHistorySquarebox");
        iframeDoc.getElementById("image_history_tab").classList.add("imageHistoryVerticalbox");
        attr(div7, "class", "w-50 relative md:h-[590px] verticalbox");
      }else{
        iframeDoc.getElementById("image_history_tab").classList.remove("imageHistoryHorizontalbox");
        iframeDoc.getElementById("image_history_tab").classList.remove("imageHistoryVerticalbox");
        iframeDoc.getElementById("image_history_tab").classList.add("imageHistorySquarebox");
        attr(div7, "class", "w-50 relative md:h-[590px] squarebox");
      } 
      if (
        !current ||
        (dirty /*isSharePopupOpen*/ & 128 &&
          button_class_value !==
            (button_class_value =
              "text-sm p-1 mb-2 px-3 rounded-lg mt-2 border select-none md:hidden" +
              /*isSharePopupOpen*/ (ctx2[7] ? "bg-[#d0011c] text-black" : "")))
      ) {
        attr(button, "class", button_class_value);
      }
      if (/*isSharePopupOpen*/ ctx2[7]) {
        if (if_block0) {
          if (dirty /*isSharePopupOpen*/ & 128) {
            transition_in(if_block0, 1);
          }
        } else {
          if_block0 = create_if_block_5();
          if_block0.c();
          transition_in(if_block0, 1);
          if_block0.m(div5, t10);
        }
      } else if (if_block0) {
        group_outros();
        transition_out(if_block0, 1, 1, () => {
          if_block0 = null;
        });
        check_outros();
      }
      if (
        (!current || dirty /*lang*/ & 4) &&
        t5_value !== (t5_value = /*lang*/ ctx2[2].heading + "")
      )
        set_data(t5, t5_value);
      if (
        !current ||
        (dirty /*backgroundImageSrc*/ & 32 &&
          !src_url_equal(
            img1.src,
            (img1_src_value = /*backgroundImageSrc*/ ctx2[5])
          ))
      ) {
        attr(img1, "src", img1_src_value);
      }
      if (/*isLoading*/ ctx2[4]) {
        if (if_block1) {
          if_block1.p(ctx2, dirty);
          if (dirty /*isLoading*/ & 16) {
            transition_in(if_block1, 1);
          }
        } else {
          if_block1 = create_if_block_4(ctx2);
          if_block1.c();
          transition_in(if_block1, 1);
          if_block1.m(div5, t11);
        }
      } else if (if_block1) {
        group_outros();
        transition_out(if_block1, 1, 1, () => {
          if_block1 = null;
        });
        check_outros();
      }
      let previous_block_index = current_block_type_index;
      current_block_type_index = select_block_type(ctx2);
      if (current_block_type_index === previous_block_index) {
        if_blocks[current_block_type_index].p(ctx2, dirty);
      } else {
        group_outros();
        transition_out(if_blocks[previous_block_index], 1, 1, () => {
          if_blocks[previous_block_index] = null;
        });
        check_outros();
        if_block2 = if_blocks[current_block_type_index];
        if (!if_block2) {
          if_block2 = if_blocks[current_block_type_index] =
            if_block_creators[current_block_type_index](ctx2);
          if_block2.c();
        } else {
          if_block2.p(ctx2, dirty);
        }
        transition_in(if_block2, 1);
        if_block2.m(div5, null);
      }
      if (!current || dirty /*canvasHeight, dpr*/ & 1280) {
        set_style(
          div5,
          "height",
          /*canvasHeight*/ ctx2[10] / /*dpr*/ ctx2[8] + "px"
        );
      }
      if (!current || dirty /*canvasWidth, dpr*/ & 768) {
        set_style(
          div5,
          "width",
          /*canvasWidth*/ ctx2[9] / /*dpr*/ ctx2[8] + "px"
        );
      }
      if (!current || dirty /*isVertical*/ & 1) {
        set_style(
          div7,
          "min-height",
          /*isVertical*/ ctx2[0] ? "320px" : "250px"
        );
      }
    },
    i(local) {
      if (current) return;
      transition_in(if_block0);
      transition_in(sharelinks.$$.fragment, local);
      transition_in(if_block1);
      transition_in(if_block2);
      current = true;
    },
    o(local) {
      transition_out(if_block0);
      transition_out(sharelinks.$$.fragment, local);
      transition_out(if_block1);
      transition_out(if_block2);
      current = false;
    },
    d(detaching) {
      if (detaching) detach(div3);
      if (if_block0) if_block0.d();
      if (detaching) detach(t8);
      if (detaching) detach(div7);
      destroy_component(sharelinks);
      if (if_block1) if_block1.d();
      if_blocks[current_block_type_index].d();
      mounted = false;
      dispose();
    },
  };
}

function instance$9($$self, $$props, $$invalidate) {
  let canvasHeight;
  let canvasWidth;
  let dpr;
  let { lang = {} } = $$props;
  let { linkHref = null } = $$props;
  let { isLoading = false } = $$props;
  let { isVertical = false } = $$props;
  let { isTextToImage = true } = $$props;
  let { isCropperOpen = false } = $$props;
  let { backgroundImageSrc = null } = $$props;
  let { generateImagesInSequence } = $$props;
  let { image = { src: null, isVertical: false } } = $$props;
  let isImageLoaded = false;
  let isSharePopupOpen = false;
  const click_handler = () =>{

    $$invalidate(7, (isSharePopupOpen = !isSharePopupOpen));
    // validated_image = false
  }
  const load_handler = () =>
    !isImageLoaded && $$invalidate(6, (isImageLoaded = true));
  $$self.$$set = ($$props2) => {
    if ("lang" in $$props2) $$invalidate(2, (lang = $$props2.lang));
    if ("linkHref" in $$props2) $$invalidate(3, (linkHref = $$props2.linkHref));
    if ("isLoading" in $$props2)
      $$invalidate(4, (isLoading = $$props2.isLoading));
    if ("isVertical" in $$props2)
      $$invalidate(0, (isVertical = $$props2.isVertical));
    if ("isTextToImage" in $$props2)
      $$invalidate(12, (isTextToImage = $$props2.isTextToImage));
    if ("isCropperOpen" in $$props2)
      $$invalidate(11, (isCropperOpen = $$props2.isCropperOpen));
    if ("backgroundImageSrc" in $$props2)
      $$invalidate(5, (backgroundImageSrc = $$props2.backgroundImageSrc));
    if ("image" in $$props2) $$invalidate(1, (image = $$props2.image));
  };
  $$self.$$.update = () => {
    if ($$self.$$.dirty /*isTextToImage*/ & 4096) {
      !isTextToImage && ($$invalidate(1, (image = {})), clearURLParams());
    }
    if ($$self.$$.dirty /*image*/ & 2) {
      image.src && $$invalidate(0, (isVertical = image.isVertical));
    }
    if ($$self.$$.dirty /*image*/ & 2) {
      image.src, $$invalidate(6, (isImageLoaded = false));
    }
    if ($$self.$$.dirty /*isVertical*/ & 1) {
      $$invalidate(11, (isCropperOpen = false));
    }
    if ($$self.$$.dirty /*isVertical*/ & 1) {
      // console.log("isVertical-------------@@", typeof isVertical, isVertical)
      updated_is_vertical = isVertical
      let screenheight = 492;
      if( window.screen.width){

      } 
      // if( isVertical=="true" || isVertical==true || isVertical=="square" ) $$invalidate(10, (canvasHeight = 492));
      // if( isVertical=="false" || isVertical==false) $$invalidate(10, (canvasHeight = 373));
      if(in_progress_orientation!="none"){
        updated_is_vertical = in_progress_orientation
        if( in_progress_orientation=="true" || in_progress_orientation==true || in_progress_orientation=="square" ) $$invalidate(10, (canvasHeight = 492));
        if( in_progress_orientation=="false" || in_progress_orientation==false) $$invalidate(10, (canvasHeight = 373));
      }else{
        updated_is_vertical = isVertical
        if( isVertical=="true" || isVertical==true || isVertical=="square" ) $$invalidate(10, (canvasHeight = 492));
        if( isVertical=="false" || isVertical==false) $$invalidate(10, (canvasHeight = 373));
      }
     
    }
    if ($$self.$$.dirty /*isVertical*/ & 1) {
        // updated_is_vertical = isVertical
        // if(isVertical && isVertical=="square") $$invalidate(9, (canvasWidth = 492));
        // if(isVertical=="true" || isVertical==true) $$invalidate(9, (canvasWidth = 373));
        // if(isVertical=="false" || isVertical==false) $$invalidate(9, (canvasWidth = 492));
        if(in_progress_orientation!="none"){
          updated_is_vertical = in_progress_orientation
          if(in_progress_orientation && in_progress_orientation=="square") $$invalidate(9, (canvasWidth = 492));
          if(in_progress_orientation=="true" || in_progress_orientation==true) $$invalidate(9, (canvasWidth = 373));
          if(in_progress_orientation=="false" || in_progress_orientation==false) $$invalidate(9, (canvasWidth = 492));
        }else{

          updated_is_vertical = isVertical
          if(isVertical && isVertical=="square") $$invalidate(9, (canvasWidth = 492));
          if(isVertical=="true" || isVertical==true) $$invalidate(9, (canvasWidth = 373));
          if(isVertical=="false" || isVertical==false) $$invalidate(9, (canvasWidth = 492));
        }
    }
  };
  
  $$invalidate(8, (dpr = window.innerWidth <= 768 ? 1.16 : 1));
  return [
    isVertical,
    image,
    lang,
    linkHref,
    isLoading,
    backgroundImageSrc,
    isImageLoaded,
    isSharePopupOpen,
    dpr,
    canvasWidth,
    canvasHeight,
    isCropperOpen,
    isTextToImage,
    click_handler,
    load_handler,
     generateImagesInSequence
  ];
}
class Canvas extends SvelteComponent {
  constructor(options) {
    super();
    init(this, options, instance$9, create_fragment$a, safe_not_equal, {
      lang: 2,
      linkHref: 3,
      isLoading: 4,
      isVertical: 0,
      isTextToImage: 12,
      isCropperOpen: 11,
      backgroundImageSrc: 5,
      image: 1,
      generateImagesInSequence:15
    });
  }
}
function create_fragment$9(ctx) {
  let button;
  let mounted;
  let dispose;
  return {
    c() {
      button = element("button");
      // button.innerHTML = `<p class="text-lg">💡</p>`;
      button.innerHTML = `<p class="text-lg"><img src="https://cdn.shopify.com/s/files/1/0736/6996/8165/files/editcustomicon.jpg?v=1764146029"></p>`;
      attr(button, "type", "button");
      attr(
        button,
        "class",
        "h-8 w-8 rounded-full active:bg-yellow-200 cursor-pointer flex items-center justify-center bg-yellow-50 border-solid border-[1px] border-yellow-400 bulb"
      );
    },
    m(target, anchor) {
      insert(target, button, anchor);
      if (!mounted) {
        dispose = listen(
          button,
          "click",
          /*setPrompt*/
          ctx[0]
        );
        mounted = true;
      }
    },
    p: noop$1,
    i: noop$1,
    o: noop$1,
    d(detaching) {
      if (detaching) detach(button);
      mounted = false;
      dispose();
    },
  };
}
function instance$8($$self, $$props, $$invalidate) {
 
   let defaultprompts = [
    
    "A dark, shadowy forest with traps and dangers hidden among the undergrowth",
    "illustration of a Audi a3 2007 by dan mumford, alien landscape and vegetation, epic scene, a lot of swirling clouds, high exposure, highly detailed, fantastical, vibrant purple tinted colors, uhd",
    "Bill Gates photo realistic high detail canon 5d as cage fighter",
    'Picture of a fox, at a computer desk, with the word "puzzle" in the background',
    "galley in big storm, Giger style, antique painting, realistic color, beauty",
    "sea scene with waves and cliffs, modern art",
    "a chameleon that is in a rocket",
    "Mumbai realistic  skyline in an epic beautiful sundowner scene, 4K, realistic, detailed.",
    "A raccoon holding an umbrella in the rain"
  ];
  let imagefromtextsuggestionarray = []
  imagefromtextsuggestionarray =  imagefromtextsuggestion.split("|");


  let { value = null } = $$props;
  let prompts = (imagefromtextsuggestionarray.length)?imagefromtextsuggestionarray:defaultprompts;
 
  const getRandomIndex = () => Math.floor(Math.random() * prompts.length);
  const setPrompt = () => $$invalidate(1, (value = prompts[getRandomIndex()]));
  $$self.$$set = ($$props2) => {
    if ("value" in $$props2) $$invalidate(1, (value = $$props2.value));
  };
  return [setPrompt, value];
}
class Prompts extends SvelteComponent {
  constructor(options) {
    super();
    init(this, options, instance$8, create_fragment$9, safe_not_equal, {
      value: 1,
    });
  }
}
/*!
 * Cropper.js v1.6.1
 * https://fengyuanchen.github.io/cropperjs
 *
 * Copyright 2015-present Chen Fengyuan
 * Released under the MIT license
 *
 * Date: 2023-09-17T03:44:19.860Z
 */
function ownKeys(e, r2) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r2 &&
      (o = o.filter(function (r3) {
        return Object.getOwnPropertyDescriptor(e, r3).enumerable;
      })),
      t.push.apply(t, o);
  }
  return t;
}
function _objectSpread2(e) {
  for (var r2 = 1; r2 < arguments.length; r2++) {
    var t = null != arguments[r2] ? arguments[r2] : {};
    r2 % 2
      ? ownKeys(Object(t), true).forEach(function (r3) {
          _defineProperty(e, r3, t[r3]);
        })
      : Object.getOwnPropertyDescriptors
      ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t))
      : ownKeys(Object(t)).forEach(function (r3) {
          Object.defineProperty(e, r3, Object.getOwnPropertyDescriptor(t, r3));
        });
  }
  return e;
}
function _typeof(o) {
  "@babel/helpers - typeof";
  return (
    (_typeof =
      "function" == typeof Symbol && "symbol" == typeof Symbol.iterator
        ? function (o2) {
            return typeof o2;
          }
        : function (o2) {
            return o2 &&
              "function" == typeof Symbol &&
              o2.constructor === Symbol &&
              o2 !== Symbol.prototype
              ? "symbol"
              : typeof o2;
          }),
    _typeof(o)
  );
}
function _classCallCheck(instance2, Constructor) {
  if (!(instance2 instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
  }
}
function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", {
    writable: false,
  });
  return Constructor;
}
function _defineProperty(obj, key, value) {
  key = _toPropertyKey(key);
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value,
      enumerable: true,
      configurable: true,
      writable: true,
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _toConsumableArray(arr) {
  return (
    _arrayWithoutHoles(arr) ||
    _iterableToArray(arr) ||
    _unsupportedIterableToArray(arr) ||
    _nonIterableSpread()
  );
}
function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function _iterableToArray(iter) {
  if (
    (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null) ||
    iter["@@iterator"] != null
  )
    return Array.from(iter);
}
function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))
    return _arrayLikeToArray(o, minLen);
}
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
  return arr2;
}
function _nonIterableSpread() {
  throw new TypeError(
    "Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."
  );
}
function _toPrimitive(input, hint) {
  if (typeof input !== "object" || input === null) return input;
  var prim = input[Symbol.toPrimitive];
  if (prim !== void 0) {
    var res = prim.call(input, hint || "default");
    if (typeof res !== "object") return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (hint === "string" ? String : Number)(input);
}
function _toPropertyKey(arg) {
  var key = _toPrimitive(arg, "string");
  return typeof key === "symbol" ? key : String(key);
}
var IS_BROWSER =
  typeof window !== "undefined" && typeof window.document !== "undefined";
var WINDOW = IS_BROWSER ? window : {};
var IS_TOUCH_DEVICE =
  IS_BROWSER && WINDOW.document.documentElement
    ? "ontouchstart" in WINDOW.document.documentElement
    : false;
var HAS_POINTER_EVENT = IS_BROWSER ? "PointerEvent" in WINDOW : false;
var NAMESPACE = "cropper";
var ACTION_ALL = "all";
var ACTION_CROP = "crop";
var ACTION_MOVE = "move";
var ACTION_ZOOM = "zoom";
var ACTION_EAST = "e";
var ACTION_WEST = "w";
var ACTION_SOUTH = "s";
var ACTION_NORTH = "n";
var ACTION_NORTH_EAST = "ne";
var ACTION_NORTH_WEST = "nw";
var ACTION_SOUTH_EAST = "se";
var ACTION_SOUTH_WEST = "sw";
var CLASS_CROP = "".concat(NAMESPACE, "-crop");
var CLASS_DISABLED = "".concat(NAMESPACE, "-disabled");
var CLASS_HIDDEN = "".concat(NAMESPACE, "-hidden");
var CLASS_HIDE = "".concat(NAMESPACE, "-hide");
var CLASS_INVISIBLE = "".concat(NAMESPACE, "-invisible");
var CLASS_MODAL = "".concat(NAMESPACE, "-modal");
var CLASS_MOVE = "".concat(NAMESPACE, "-move");
var DATA_ACTION = "".concat(NAMESPACE, "Action");
var DATA_PREVIEW = "".concat(NAMESPACE, "Preview");
var DRAG_MODE_CROP = "crop";
var DRAG_MODE_MOVE = "move";
var DRAG_MODE_NONE = "none";
var EVENT_CROP = "crop";
var EVENT_CROP_END = "cropend";
var EVENT_CROP_MOVE = "cropmove";
var EVENT_CROP_START = "cropstart";
var EVENT_DBLCLICK = "dblclick";
var EVENT_TOUCH_START = IS_TOUCH_DEVICE ? "touchstart" : "mousedown";
var EVENT_TOUCH_MOVE = IS_TOUCH_DEVICE ? "touchmove" : "mousemove";
var EVENT_TOUCH_END = IS_TOUCH_DEVICE ? "touchend touchcancel" : "mouseup";
var EVENT_POINTER_DOWN = HAS_POINTER_EVENT ? "pointerdown" : EVENT_TOUCH_START;
var EVENT_POINTER_MOVE = HAS_POINTER_EVENT ? "pointermove" : EVENT_TOUCH_MOVE;
var EVENT_POINTER_UP = HAS_POINTER_EVENT
  ? "pointerup pointercancel"
  : EVENT_TOUCH_END;
var EVENT_READY = "ready";
var EVENT_RESIZE = "resize";
var EVENT_WHEEL = "wheel";
var EVENT_ZOOM = "zoom";
var MIME_TYPE_JPEG = "image/jpeg";
var REGEXP_ACTIONS = /^e|w|s|n|se|sw|ne|nw|all|crop|move|zoom$/;
var REGEXP_DATA_URL = /^data:/;
var REGEXP_DATA_URL_JPEG = /^data:image\/jpeg;base64,/;
var REGEXP_TAG_NAME = /^img|canvas$/i;
var MIN_CONTAINER_WIDTH = 200;
var MIN_CONTAINER_HEIGHT = 100;
var DEFAULTS = {
  // Define the view mode of the cropper
  viewMode: 0,
  // 0, 1, 2, 3
  // Define the dragging mode of the cropper
  dragMode: DRAG_MODE_CROP,
  // 'crop', 'move' or 'none'
  // Define the initial aspect ratio of the crop box
  initialAspectRatio: NaN,
  // Define the aspect ratio of the crop box
  aspectRatio: NaN,
  // An object with the previous cropping result data
  data: null,
  // A selector for adding extra containers to preview
  preview: "",
  // Re-render the cropper when resize the window
  responsive: true,
  // Restore the cropped area after resize the window
  restore: true,
  // Check if the current image is a cross-origin image
  checkCrossOrigin: true,
  // Check the current image's Exif Orientation information
  checkOrientation: true,
  // Show the black modal
  modal: true,
  // Show the dashed lines for guiding
  guides: true,
  // Show the center indicator for guiding
  center: true,
  // Show the white modal to highlight the crop box
  highlight: true,
  // Show the grid background
  background: true,
  // Enable to crop the image automatically when initialize
  autoCrop: true,
  // Define the percentage of automatic cropping area when initializes
  autoCropArea: 0.8,
  // Enable to move the image
  movable: true,
  // Enable to rotate the image
  rotatable: true,
  // Enable to scale the image
  scalable: true,
  // Enable to zoom the image
  zoomable: true,
  // Enable to zoom the image by dragging touch
  zoomOnTouch: true,
  // Enable to zoom the image by wheeling mouse
  zoomOnWheel: true,
  // Define zoom ratio when zoom the image by wheeling mouse
  wheelZoomRatio: 0.1,
  // Enable to move the crop box
  cropBoxMovable: true,
  // Enable to resize the crop box
  cropBoxResizable: true,
  // Toggle drag mode between "crop" and "move" when click twice on the cropper
  toggleDragModeOnDblclick: true,
  // Size limitation
  minCanvasWidth: 0,
  minCanvasHeight: 0,
  minCropBoxWidth: 0,
  minCropBoxHeight: 0,
  minContainerWidth: MIN_CONTAINER_WIDTH,
  minContainerHeight: MIN_CONTAINER_HEIGHT,
  // Shortcuts of events
  ready: null,
  cropstart: null,
  cropmove: null,
  cropend: null,
  crop: null,
  zoom: null,
};
var TEMPLATE =
  '<div class="cropper-container" touch-action="none"><div class="cropper-wrap-box"><div class="cropper-canvas"></div></div><div class="cropper-drag-box"></div><div class="cropper-crop-box"><span class="cropper-view-box"></span><span class="cropper-dashed dashed-h"></span><span class="cropper-dashed dashed-v"></span><span class="cropper-center"></span><span class="cropper-face"></span><span class="cropper-line line-e" data-cropper-action="e"></span><span class="cropper-line line-n" data-cropper-action="n"></span><span class="cropper-line line-w" data-cropper-action="w"></span><span class="cropper-line line-s" data-cropper-action="s"></span><span class="cropper-point point-e" data-cropper-action="e"></span><span class="cropper-point point-n" data-cropper-action="n"></span><span class="cropper-point point-w" data-cropper-action="w"></span><span class="cropper-point point-s" data-cropper-action="s"></span><span class="cropper-point point-ne" data-cropper-action="ne"></span><span class="cropper-point point-nw" data-cropper-action="nw"></span><span class="cropper-point point-sw" data-cropper-action="sw"></span><span class="cropper-point point-se" data-cropper-action="se"></span></div></div>';
var isNaN$1 = Number.isNaN || WINDOW.isNaN;
function isNumber(value) {
  return typeof value === "number" && !isNaN$1(value);
}
var isPositiveNumber = function isPositiveNumber2(value) {
  return value > 0 && value < Infinity;
};
function isUndefined(value) {
  return typeof value === "undefined";
}
function isObject(value) {
  return _typeof(value) === "object" && value !== null;
}
var hasOwnProperty = Object.prototype.hasOwnProperty;
function isPlainObject(value) {
  if (!isObject(value)) {
    return false;
  }
  try {
    var _constructor = value.constructor;
    var prototype = _constructor.prototype;
    return (
      _constructor &&
      prototype &&
      hasOwnProperty.call(prototype, "isPrototypeOf")
    );
  } catch (error) {
    return false;
  }
}
function isFunction(value) {
  return typeof value === "function";
}
var slice2 = Array.prototype.slice;
function toArray(value) {
  return Array.from ? Array.from(value) : slice2.call(value);
}
function forEach(data, callback) {
  if (data && isFunction(callback)) {
    if (Array.isArray(data) || isNumber(data.length)) {
      toArray(data).forEach(function (value, key) {
        callback.call(data, value, key, data);
      });
    } else if (isObject(data)) {
      Object.keys(data).forEach(function (key) {
        callback.call(data, data[key], key, data);
      });
    }
  }
  return data;
}
var assign =
  Object.assign ||
  function assign2(target) {
    for (
      var _len = arguments.length,
        args = new Array(_len > 1 ? _len - 1 : 0),
        _key = 1;
      _key < _len;
      _key++
    ) {
      args[_key - 1] = arguments[_key];
    }
    if (isObject(target) && args.length > 0) {
      args.forEach(function (arg) {
        if (isObject(arg)) {
          Object.keys(arg).forEach(function (key) {
            target[key] = arg[key];
          });
        }
      });
    }
    return target;
  };
var REGEXP_DECIMALS = /\.\d*(?:0|9){12}\d*$/;
function normalizeDecimalNumber(value) {
  var times =
    arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 1e11;
  return REGEXP_DECIMALS.test(value)
    ? Math.round(value * times) / times
    : value;
}
var REGEXP_SUFFIX = /^width|height|left|top|marginLeft|marginTop$/;
function setStyle(element2, styles2) {
  var style2 = element2.style;
  forEach(styles2, function (value, property) {
    if (REGEXP_SUFFIX.test(property) && isNumber(value)) {
      value = "".concat(value, "px");
    }
    style2[property] = value;
  });
}
function hasClass(element2, value) {
  return element2.classList
    ? element2.classList.contains(value)
    : element2.className.indexOf(value) > -1;
}
function addClass(element2, value) {
  if (!value) {
    return;
  }
  if (isNumber(element2.length)) {
    forEach(element2, function (elem) {
      addClass(elem, value);
    });
    return;
  }
  if (element2.classList) {
    element2.classList.add(value);
    return;
  }
  var className = element2.className.trim();
  if (!className) {
    element2.className = value;
  } else if (className.indexOf(value) < 0) {
    element2.className = "".concat(className, " ").concat(value);
  }
}
function removeClass(element2, value) {
  if (!value) {
    return;
  }
  if (isNumber(element2.length)) {
    forEach(element2, function (elem) {
      removeClass(elem, value);
    });
    return;
  }
  if (element2.classList) {
    element2.classList.remove(value);
    return;
  }
  if (element2.className.indexOf(value) >= 0) {
    element2.className = element2.className.replace(value, "");
  }
}
function toggleClass(element2, value, added) {
  if (!value) {
    return;
  }
  if (isNumber(element2.length)) {
    forEach(element2, function (elem) {
      toggleClass(elem, value, added);
    });
    return;
  }
  if (added) {
    addClass(element2, value);
  } else {
    removeClass(element2, value);
  }
}
var REGEXP_CAMEL_CASE = /([a-z\d])([A-Z])/g;
function toParamCase(value) {
  return value.replace(REGEXP_CAMEL_CASE, "$1-$2").toLowerCase();
}
function getData(element2, name2) {
  if (isObject(element2[name2])) {
    return element2[name2];
  }
  if (element2.dataset) {
    return element2.dataset[name2];
  }
  return element2.getAttribute("data-".concat(toParamCase(name2)));
}
function setData(element2, name2, data) {
  if (isObject(data)) {
    element2[name2] = data;
  } else if (element2.dataset) {
    element2.dataset[name2] = data;
  } else {
    element2.setAttribute("data-".concat(toParamCase(name2)), data);
  }
}
function removeData(element2, name2) {
  if (isObject(element2[name2])) {
    try {
      delete element2[name2];
    } catch (error) {
      element2[name2] = void 0;
    }
  } else if (element2.dataset) {
    try {
      delete element2.dataset[name2];
    } catch (error) {
      element2.dataset[name2] = void 0;
    }
  } else {
    element2.removeAttribute("data-".concat(toParamCase(name2)));
  }
}
var REGEXP_SPACES = /\s\s*/;
var onceSupported = (function () {
  var supported = false;
  if (IS_BROWSER) {
    var once = false;
    var listener = function listener2() {};
    var options = Object.defineProperty({}, "once", {
      get: function get() {
        supported = true;
        return once;
      },
      /**
       * This setter can fix a `TypeError` in strict mode
       * {@link https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Errors/Getter_only}
       * @param {boolean} value - The value to set
       */
      set: function set(value) {
        once = value;
      },
    });
    WINDOW.addEventListener("test", listener, options);
    WINDOW.removeEventListener("test", listener, options);
  }
  return supported;
})();
function removeListener(element2, type3, listener) {
  var options =
    arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};
  var handler = listener;
  type3
    .trim()
    .split(REGEXP_SPACES)
    .forEach(function (event) {
      if (!onceSupported) {
        var listeners = element2.listeners;
        if (listeners && listeners[event] && listeners[event][listener]) {
          handler = listeners[event][listener];
          delete listeners[event][listener];
          if (Object.keys(listeners[event]).length === 0) {
            delete listeners[event];
          }
          if (Object.keys(listeners).length === 0) {
            delete element2.listeners;
          }
        }
      }
      element2.removeEventListener(event, handler, options);
    });
}
function addListener(element2, type3, listener) {
  var options =
    arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};
  var _handler = listener;
  type3
    .trim()
    .split(REGEXP_SPACES)
    .forEach(function (event) {
      if (options.once && !onceSupported) {
        var _element$listeners = element2.listeners,
          listeners = _element$listeners === void 0 ? {} : _element$listeners;
        _handler = function handler() {
          delete listeners[event][listener];
          element2.removeEventListener(event, _handler, options);
          for (
            var _len2 = arguments.length, args = new Array(_len2), _key2 = 0;
            _key2 < _len2;
            _key2++
          ) {
            args[_key2] = arguments[_key2];
          }
          listener.apply(element2, args);
        };
        if (!listeners[event]) {
          listeners[event] = {};
        }
        if (listeners[event][listener]) {
          element2.removeEventListener(
            event,
            listeners[event][listener],
            options
          );
        }
        listeners[event][listener] = _handler;
        element2.listeners = listeners;
      }
      element2.addEventListener(event, _handler, options);
    });
}
function dispatchEvent(element2, type3, data) {
  var event;
  if (isFunction(Event) && isFunction(CustomEvent)) {
    event = new CustomEvent(type3, {
      detail: data,
      bubbles: true,
      cancelable: true,
    });
  } else {
    event = document.createEvent("CustomEvent");
    event.initCustomEvent(type3, true, true, data);
  }
  return element2.dispatchEvent(event);
}
function getOffset(element2) {
  var box = element2.getBoundingClientRect();
  return {
    left: box.left + (window.pageXOffset - document.documentElement.clientLeft),
    top: box.top + (window.pageYOffset - document.documentElement.clientTop),
  };
}
var location$1 = WINDOW.location;
var REGEXP_ORIGINS = /^(\w+:)\/\/([^:/?#]*):?(\d*)/i;
function isCrossOriginURL(url) {
  var parts = url.match(REGEXP_ORIGINS);
  return (
    parts !== null &&
    (parts[1] !== location$1.protocol ||
      parts[2] !== location$1.hostname ||
      parts[3] !== location$1.port)
  );
}
function addTimestamp(url) {
  var timestamp = "timestamp=".concat(/* @__PURE__ */ new Date().getTime());
  return url + (url.indexOf("?") === -1 ? "?" : "&") + timestamp;
}
function getTransforms(_ref) {
  var rotate2 = _ref.rotate,
    scaleX2 = _ref.scaleX,
    scaleY2 = _ref.scaleY,
    translateX = _ref.translateX,
    translateY = _ref.translateY;
  var values = [];
  if (isNumber(translateX) && translateX !== 0) {
    values.push("translateX(".concat(translateX, "px)"));
  }
  if (isNumber(translateY) && translateY !== 0) {
    values.push("translateY(".concat(translateY, "px)"));
  }
  if (isNumber(rotate2) && rotate2 !== 0) {
    values.push("rotate(".concat(rotate2, "deg)"));
  }
  if (isNumber(scaleX2) && scaleX2 !== 1) {
    values.push("scaleX(".concat(scaleX2, ")"));
  }
  if (isNumber(scaleY2) && scaleY2 !== 1) {
    values.push("scaleY(".concat(scaleY2, ")"));
  }
  var transform = values.length ? values.join(" ") : "none";
  return {
    WebkitTransform: transform,
    msTransform: transform,
    transform,
  };
}
function getMaxZoomRatio(pointers) {
  var pointers2 = _objectSpread2({}, pointers);
  var maxRatio = 0;
  forEach(pointers, function (pointer, pointerId) {
    delete pointers2[pointerId];
    forEach(pointers2, function (pointer2) {
      var x1 = Math.abs(pointer.startX - pointer2.startX);
      var y1 = Math.abs(pointer.startY - pointer2.startY);
      var x2 = Math.abs(pointer.endX - pointer2.endX);
      var y2 = Math.abs(pointer.endY - pointer2.endY);
      var z1 = Math.sqrt(x1 * x1 + y1 * y1);
      var z2 = Math.sqrt(x2 * x2 + y2 * y2);
      var ratio = (z2 - z1) / z1;
      if (Math.abs(ratio) > Math.abs(maxRatio)) {
        maxRatio = ratio;
      }
    });
  });
  return maxRatio;
}
function getPointer(_ref2, endOnly) {
  var pageX = _ref2.pageX,
    pageY = _ref2.pageY;
  var end = {
    endX: pageX,
    endY: pageY,
  };
  return endOnly
    ? end
    : _objectSpread2(
        {
          startX: pageX,
          startY: pageY,
        },
        end
      );
}
function getPointersCenter(pointers) {
  var pageX = 0;
  var pageY = 0;
  var count = 0;
  forEach(pointers, function (_ref3) {
    var startX = _ref3.startX,
      startY = _ref3.startY;
    pageX += startX;
    pageY += startY;
    count += 1;
  });
  pageX /= count;
  pageY /= count;
  return {
    pageX,
    pageY,
  };
}
function getAdjustedSizes(_ref4) {
  var aspectRatio = _ref4.aspectRatio,
    height2 = _ref4.height,
    width = _ref4.width;
  var type3 =
    arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "contain";
  var isValidWidth = isPositiveNumber(width);
  var isValidHeight = isPositiveNumber(height2);
  if (isValidWidth && isValidHeight) {
    var adjustedWidth = height2 * aspectRatio;
    if (
      (type3 === "contain" && adjustedWidth > width) ||
      (type3 === "cover" && adjustedWidth < width)
    ) {
      height2 = width / aspectRatio;
    } else {
      width = height2 * aspectRatio;
    }
  } else if (isValidWidth) {
    height2 = width / aspectRatio;
  } else if (isValidHeight) {
    width = height2 * aspectRatio;
  }
  return {
    width,
    height: height2,
  };
}
function getRotatedSizes(_ref5) {
  var width = _ref5.width,
    height2 = _ref5.height,
    degree = _ref5.degree;
  degree = Math.abs(degree) % 180;
  if (degree === 90) {
    return {
      width: height2,
      height: width,
    };
  }
  var arc = ((degree % 90) * Math.PI) / 180;
  var sinArc = Math.sin(arc);
  var cosArc = Math.cos(arc);
  var newWidth = width * cosArc + height2 * sinArc;
  var newHeight = width * sinArc + height2 * cosArc;
  return degree > 90
    ? {
        width: newHeight,
        height: newWidth,
      }
    : {
        width: newWidth,
        height: newHeight,
      };
}
function getSourceCanvas(image, _ref6, _ref7, _ref8) {
  var imageAspectRatio = _ref6.aspectRatio,
    imageNaturalWidth = _ref6.naturalWidth,
    imageNaturalHeight = _ref6.naturalHeight,
    _ref6$rotate = _ref6.rotate,
    rotate2 = _ref6$rotate === void 0 ? 0 : _ref6$rotate,
    _ref6$scaleX = _ref6.scaleX,
    scaleX2 = _ref6$scaleX === void 0 ? 1 : _ref6$scaleX,
    _ref6$scaleY = _ref6.scaleY,
    scaleY2 = _ref6$scaleY === void 0 ? 1 : _ref6$scaleY;
  var aspectRatio = _ref7.aspectRatio,
    naturalWidth = _ref7.naturalWidth,
    naturalHeight = _ref7.naturalHeight;
  var _ref8$fillColor = _ref8.fillColor,
    fillColor = _ref8$fillColor === void 0 ? "transparent" : _ref8$fillColor,
    _ref8$imageSmoothingE = _ref8.imageSmoothingEnabled,
    imageSmoothingEnabled =
      _ref8$imageSmoothingE === void 0 ? true : _ref8$imageSmoothingE,
    _ref8$imageSmoothingQ = _ref8.imageSmoothingQuality,
    imageSmoothingQuality =
      _ref8$imageSmoothingQ === void 0 ? "low" : _ref8$imageSmoothingQ,
    _ref8$maxWidth = _ref8.maxWidth,
    maxWidth = _ref8$maxWidth === void 0 ? Infinity : _ref8$maxWidth,
    _ref8$maxHeight = _ref8.maxHeight,
    maxHeight = _ref8$maxHeight === void 0 ? Infinity : _ref8$maxHeight,
    _ref8$minWidth = _ref8.minWidth,
    minWidth = _ref8$minWidth === void 0 ? 0 : _ref8$minWidth,
    _ref8$minHeight = _ref8.minHeight,
    minHeight = _ref8$minHeight === void 0 ? 0 : _ref8$minHeight;
  var canvas = document.createElement("canvas");
  var context = canvas.getContext("2d");
  var maxSizes = getAdjustedSizes({
    aspectRatio,
    width: maxWidth,
    height: maxHeight,
  });
  var minSizes = getAdjustedSizes(
    {
      aspectRatio,
      width: minWidth,
      height: minHeight,
    },
    "cover"
  );
  var width = Math.min(maxSizes.width, Math.max(minSizes.width, naturalWidth));
  var height2 = Math.min(
    maxSizes.height,
    Math.max(minSizes.height, naturalHeight)
  );
  var destMaxSizes = getAdjustedSizes({
    aspectRatio: imageAspectRatio,
    width: maxWidth,
    height: maxHeight,
  });
  var destMinSizes = getAdjustedSizes(
    {
      aspectRatio: imageAspectRatio,
      width: minWidth,
      height: minHeight,
    },
    "cover"
  );
  var destWidth = Math.min(
    destMaxSizes.width,
    Math.max(destMinSizes.width, imageNaturalWidth)
  );
  var destHeight = Math.min(
    destMaxSizes.height,
    Math.max(destMinSizes.height, imageNaturalHeight)
  );
  var params = [-destWidth / 2, -destHeight / 2, destWidth, destHeight];
  canvas.width = normalizeDecimalNumber(width);
  canvas.height = normalizeDecimalNumber(height2);
  context.fillStyle = fillColor;
  context.fillRect(0, 0, width, height2);
  context.save();
  context.translate(width / 2, height2 / 2);
  context.rotate((rotate2 * Math.PI) / 180);
  context.scale(scaleX2, scaleY2);
  context.imageSmoothingEnabled = imageSmoothingEnabled;
  context.imageSmoothingQuality = imageSmoothingQuality;
  context.drawImage.apply(
    context,
    [image].concat(
      _toConsumableArray(
        params.map(function (param) {
          return Math.floor(normalizeDecimalNumber(param));
        })
      )
    )
  );
  context.restore();
  return canvas;
}
var fromCharCode = String.fromCharCode;
function getStringFromCharCode(dataView, start2, length) {
  var str = "";
  length += start2;
  for (var i = start2; i < length; i += 1) {
    str += fromCharCode(dataView.getUint8(i));
  }
  return str;
}
var REGEXP_DATA_URL_HEAD = /^data:.*,/;
function dataURLToArrayBuffer(dataURL) {
  var base642 = dataURL.replace(REGEXP_DATA_URL_HEAD, "");
  var binary = atob(base642);
  var arrayBuffer = new ArrayBuffer(binary.length);
  var uint8 = new Uint8Array(arrayBuffer);
  forEach(uint8, function (value, i) {
    uint8[i] = binary.charCodeAt(i);
  });
  return arrayBuffer;
}
function arrayBufferToDataURL(arrayBuffer, mimeType) {
  var chunks = [];
  var chunkSize = 8192;
  var uint8 = new Uint8Array(arrayBuffer);
  while (uint8.length > 0) {
    chunks.push(
      fromCharCode.apply(null, toArray(uint8.subarray(0, chunkSize)))
    );
    uint8 = uint8.subarray(chunkSize);
  }
  return "data:".concat(mimeType, ";base64,").concat(btoa(chunks.join("")));
}
function resetAndGetOrientation(arrayBuffer) {
  var dataView = new DataView(arrayBuffer);
  var orientation;
  try {
    var littleEndian;
    var app1Start;
    var ifdStart;
    if (dataView.getUint8(0) === 255 && dataView.getUint8(1) === 216) {
      var length = dataView.byteLength;
      var offset = 2;
      while (offset + 1 < length) {
        if (
          dataView.getUint8(offset) === 255 &&
          dataView.getUint8(offset + 1) === 225
        ) {
          app1Start = offset;
          break;
        }
        offset += 1;
      }
    }
    if (app1Start) {
      var exifIDCode = app1Start + 4;
      var tiffOffset = app1Start + 10;
      if (getStringFromCharCode(dataView, exifIDCode, 4) === "Exif") {
        var endianness = dataView.getUint16(tiffOffset);
        littleEndian = endianness === 18761;
        if (littleEndian || endianness === 19789) {
          if (dataView.getUint16(tiffOffset + 2, littleEndian) === 42) {
            var firstIFDOffset = dataView.getUint32(
              tiffOffset + 4,
              littleEndian
            );
            if (firstIFDOffset >= 8) {
              ifdStart = tiffOffset + firstIFDOffset;
            }
          }
        }
      }
    }
    if (ifdStart) {
      var _length = dataView.getUint16(ifdStart, littleEndian);
      var _offset;
      var i;
      for (i = 0; i < _length; i += 1) {
        _offset = ifdStart + i * 12 + 2;
        if (dataView.getUint16(_offset, littleEndian) === 274) {
          _offset += 8;
          orientation = dataView.getUint16(_offset, littleEndian);
          dataView.setUint16(_offset, 1, littleEndian);
          break;
        }
      }
    }
  } catch (error) {
    orientation = 1;
  }
  return orientation;
}
function parseOrientation(orientation) {
  var rotate2 = 0;
  var scaleX2 = 1;
  var scaleY2 = 1;
  switch (orientation) {
    case 2:
      scaleX2 = -1;
      break;
    case 3:
      rotate2 = -180;
      break;
    case 4:
      scaleY2 = -1;
      break;
    case 5:
      rotate2 = 90;
      scaleY2 = -1;
      break;
    case 6:
      rotate2 = 90;
      break;
    case 7:
      rotate2 = 90;
      scaleX2 = -1;
      break;
    case 8:
      rotate2 = -90;
      break;
  }
  return {
    rotate: rotate2,
    scaleX: scaleX2,
    scaleY: scaleY2,
  };
}
var render = {
  render: function render2() {
    this.initContainer();
    this.initCanvas();
    this.initCropBox();
    this.renderCanvas();
    if (this.cropped) {
      this.renderCropBox();
    }
  },
  initContainer: function initContainer() {
    var element2 = this.element,
      options = this.options,
      container = this.container,
      cropper = this.cropper;
    var minWidth = Number(options.minContainerWidth);
    var minHeight = Number(options.minContainerHeight);
    addClass(cropper, CLASS_HIDDEN);
    removeClass(element2, CLASS_HIDDEN);
    var containerData = {
      width: Math.max(
        container.offsetWidth,
        minWidth >= 0 ? minWidth : MIN_CONTAINER_WIDTH
      ),
      height: Math.max(
        container.offsetHeight,
        minHeight >= 0 ? minHeight : MIN_CONTAINER_HEIGHT
      ),
    };
    this.containerData = containerData;
    setStyle(cropper, {
      width: containerData.width,
      height: containerData.height,
    });
    addClass(element2, CLASS_HIDDEN);
    removeClass(cropper, CLASS_HIDDEN);
  },
  // Canvas (image wrapper)
  initCanvas: function initCanvas() {
    var containerData = this.containerData,
      imageData = this.imageData;
    var viewMode = this.options.viewMode;
    var rotated = Math.abs(imageData.rotate) % 180 === 90;
    var naturalWidth = rotated
      ? imageData.naturalHeight
      : imageData.naturalWidth;
    var naturalHeight = rotated
      ? imageData.naturalWidth
      : imageData.naturalHeight;
    var aspectRatio = naturalWidth / naturalHeight;
    var canvasWidth = containerData.width;
    var canvasHeight = containerData.height;
    if (containerData.height * aspectRatio > containerData.width) {
      if (viewMode === 3) {
        canvasWidth = containerData.height * aspectRatio;
      } else {
        canvasHeight = containerData.width / aspectRatio;
      }
    } else if (viewMode === 3) {
      canvasHeight = containerData.width / aspectRatio;
    } else {
      canvasWidth = containerData.height * aspectRatio;
    }
    var canvasData = {
      aspectRatio,
      naturalWidth,
      naturalHeight,
      width: canvasWidth,
      height: canvasHeight,
    };
    this.canvasData = canvasData;
    this.limited = viewMode === 1 || viewMode === 2;
    this.limitCanvas(true, true);
    canvasData.width = Math.min(
      Math.max(canvasData.width, canvasData.minWidth),
      canvasData.maxWidth
    );
    canvasData.height = Math.min(
      Math.max(canvasData.height, canvasData.minHeight),
      canvasData.maxHeight
    );
    canvasData.left = (containerData.width - canvasData.width) / 2;
    canvasData.top = (containerData.height - canvasData.height) / 2;
    canvasData.oldLeft = canvasData.left;
    canvasData.oldTop = canvasData.top;
    this.initialCanvasData = assign({}, canvasData);
  },
  limitCanvas: function limitCanvas(sizeLimited, positionLimited) {
    var options = this.options,
      containerData = this.containerData,
      canvasData = this.canvasData,
      cropBoxData = this.cropBoxData;
    var viewMode = options.viewMode;
    var aspectRatio = canvasData.aspectRatio;
    var cropped = this.cropped && cropBoxData;
    if (sizeLimited) {
      var minCanvasWidth = Number(options.minCanvasWidth) || 0;
      var minCanvasHeight = Number(options.minCanvasHeight) || 0;
      if (viewMode > 1) {
        minCanvasWidth = Math.max(minCanvasWidth, containerData.width);
        minCanvasHeight = Math.max(minCanvasHeight, containerData.height);
        if (viewMode === 3) {
          if (minCanvasHeight * aspectRatio > minCanvasWidth) {
            minCanvasWidth = minCanvasHeight * aspectRatio;
          } else {
            minCanvasHeight = minCanvasWidth / aspectRatio;
          }
        }
      } else if (viewMode > 0) {
        if (minCanvasWidth) {
          minCanvasWidth = Math.max(
            minCanvasWidth,
            cropped ? cropBoxData.width : 0
          );
        } else if (minCanvasHeight) {
          minCanvasHeight = Math.max(
            minCanvasHeight,
            cropped ? cropBoxData.height : 0
          );
        } else if (cropped) {
          minCanvasWidth = cropBoxData.width;
          minCanvasHeight = cropBoxData.height;
          if (minCanvasHeight * aspectRatio > minCanvasWidth) {
            minCanvasWidth = minCanvasHeight * aspectRatio;
          } else {
            minCanvasHeight = minCanvasWidth / aspectRatio;
          }
        }
      }
      var _getAdjustedSizes = getAdjustedSizes({
        aspectRatio,
        width: minCanvasWidth,
        height: minCanvasHeight,
      });
      minCanvasWidth = _getAdjustedSizes.width;
      minCanvasHeight = _getAdjustedSizes.height;
      canvasData.minWidth = minCanvasWidth;
      canvasData.minHeight = minCanvasHeight;
      canvasData.maxWidth = Infinity;
      canvasData.maxHeight = Infinity;
    }
    if (positionLimited) {
      if (viewMode > (cropped ? 0 : 1)) {
        var newCanvasLeft = containerData.width - canvasData.width;
        var newCanvasTop = containerData.height - canvasData.height;
        canvasData.minLeft = Math.min(0, newCanvasLeft);
        canvasData.minTop = Math.min(0, newCanvasTop);
        canvasData.maxLeft = Math.max(0, newCanvasLeft);
        canvasData.maxTop = Math.max(0, newCanvasTop);
        if (cropped && this.limited) {
          canvasData.minLeft = Math.min(
            cropBoxData.left,
            cropBoxData.left + (cropBoxData.width - canvasData.width)
          );
          canvasData.minTop = Math.min(
            cropBoxData.top,
            cropBoxData.top + (cropBoxData.height - canvasData.height)
          );
          canvasData.maxLeft = cropBoxData.left;
          canvasData.maxTop = cropBoxData.top;
          if (viewMode === 2) {
            if (canvasData.width >= containerData.width) {
              canvasData.minLeft = Math.min(0, newCanvasLeft);
              canvasData.maxLeft = Math.max(0, newCanvasLeft);
            }
            if (canvasData.height >= containerData.height) {
              canvasData.minTop = Math.min(0, newCanvasTop);
              canvasData.maxTop = Math.max(0, newCanvasTop);
            }
          }
        }
      } else {
        canvasData.minLeft = -canvasData.width;
        canvasData.minTop = -canvasData.height;
        canvasData.maxLeft = containerData.width;
        canvasData.maxTop = containerData.height;
      }
    }
  },
  renderCanvas: function renderCanvas(changed, transformed) {
    var canvasData = this.canvasData,
      imageData = this.imageData;
    if (transformed) {
      var _getRotatedSizes = getRotatedSizes({
          width: imageData.naturalWidth * Math.abs(imageData.scaleX || 1),
          height: imageData.naturalHeight * Math.abs(imageData.scaleY || 1),
          degree: imageData.rotate || 0,
        }),
        naturalWidth = _getRotatedSizes.width,
        naturalHeight = _getRotatedSizes.height;
      var width = canvasData.width * (naturalWidth / canvasData.naturalWidth);
      var height2 =
        canvasData.height * (naturalHeight / canvasData.naturalHeight);
      canvasData.left -= (width - canvasData.width) / 2;
      canvasData.top -= (height2 - canvasData.height) / 2;
      canvasData.width = width;
      canvasData.height = height2;
      canvasData.aspectRatio = naturalWidth / naturalHeight;
      canvasData.naturalWidth = naturalWidth;
      canvasData.naturalHeight = naturalHeight;
      this.limitCanvas(true, false);
    }
    if (
      canvasData.width > canvasData.maxWidth ||
      canvasData.width < canvasData.minWidth
    ) {
      canvasData.left = canvasData.oldLeft;
    }
    if (
      canvasData.height > canvasData.maxHeight ||
      canvasData.height < canvasData.minHeight
    ) {
      canvasData.top = canvasData.oldTop;
    }
    canvasData.width = Math.min(
      Math.max(canvasData.width, canvasData.minWidth),
      canvasData.maxWidth
    );
    canvasData.height = Math.min(
      Math.max(canvasData.height, canvasData.minHeight),
      canvasData.maxHeight
    );
    this.limitCanvas(false, true);
    canvasData.left = Math.min(
      Math.max(canvasData.left, canvasData.minLeft),
      canvasData.maxLeft
    );
    canvasData.top = Math.min(
      Math.max(canvasData.top, canvasData.minTop),
      canvasData.maxTop
    );
    canvasData.oldLeft = canvasData.left;
    canvasData.oldTop = canvasData.top;
    setStyle(
      this.canvas,
      assign(
        {
          width: canvasData.width,
          height: canvasData.height,
        },
        getTransforms({
          translateX: canvasData.left,
          translateY: canvasData.top,
        })
      )
    );
    this.renderImage(changed);
    if (this.cropped && this.limited) {
      this.limitCropBox(true, true);
    }
  },
  renderImage: function renderImage(changed) {
    var canvasData = this.canvasData,
      imageData = this.imageData;
    var width =
      imageData.naturalWidth * (canvasData.width / canvasData.naturalWidth);
    var height2 =
      imageData.naturalHeight * (canvasData.height / canvasData.naturalHeight);
    assign(imageData, {
      width,
      height: height2,
      left: (canvasData.width - width) / 2,
      top: (canvasData.height - height2) / 2,
    });
    setStyle(
      this.image,
      assign(
        {
          width: imageData.width,
          height: imageData.height,
        },
        getTransforms(
          assign(
            {
              translateX: imageData.left,
              translateY: imageData.top,
            },
            imageData
          )
        )
      )
    );
    if (changed) {
      this.output();
    }
  },
  initCropBox: function initCropBox() {
    var options = this.options,
      canvasData = this.canvasData;
    var aspectRatio = options.aspectRatio || options.initialAspectRatio;
    var autoCropArea = Number(options.autoCropArea) || 0.8;
    var cropBoxData = {
      width: canvasData.width,
      height: canvasData.height,
    };
    if (aspectRatio) {
      if (canvasData.height * aspectRatio > canvasData.width) {
        cropBoxData.height = cropBoxData.width / aspectRatio;
      } else {
        cropBoxData.width = cropBoxData.height * aspectRatio;
      }
    }
    this.cropBoxData = cropBoxData;
    this.limitCropBox(true, true);
    cropBoxData.width = Math.min(
      Math.max(cropBoxData.width, cropBoxData.minWidth),
      cropBoxData.maxWidth
    );
    cropBoxData.height = Math.min(
      Math.max(cropBoxData.height, cropBoxData.minHeight),
      cropBoxData.maxHeight
    );
    cropBoxData.width = Math.max(
      cropBoxData.minWidth,
      cropBoxData.width * autoCropArea
    );
    cropBoxData.height = Math.max(
      cropBoxData.minHeight,
      cropBoxData.height * autoCropArea
    );
    cropBoxData.left =
      canvasData.left + (canvasData.width - cropBoxData.width) / 2;
    cropBoxData.top =
      canvasData.top + (canvasData.height - cropBoxData.height) / 2;
    cropBoxData.oldLeft = cropBoxData.left;
    cropBoxData.oldTop = cropBoxData.top;
    this.initialCropBoxData = assign({}, cropBoxData);
  },
  limitCropBox: function limitCropBox(sizeLimited, positionLimited) {
    var options = this.options,
      containerData = this.containerData,
      canvasData = this.canvasData,
      cropBoxData = this.cropBoxData,
      limited = this.limited;
    var aspectRatio = options.aspectRatio;
    if (sizeLimited) {
      var minCropBoxWidth = Number(options.minCropBoxWidth) || 0;
      var minCropBoxHeight = Number(options.minCropBoxHeight) || 0;
      var maxCropBoxWidth = limited
        ? Math.min(
            containerData.width,
            canvasData.width,
            canvasData.width + canvasData.left,
            containerData.width - canvasData.left
          )
        : containerData.width;
      var maxCropBoxHeight = limited
        ? Math.min(
            containerData.height,
            canvasData.height,
            canvasData.height + canvasData.top,
            containerData.height - canvasData.top
          )
        : containerData.height;
      minCropBoxWidth = Math.min(minCropBoxWidth, containerData.width);
      minCropBoxHeight = Math.min(minCropBoxHeight, containerData.height);
      if (aspectRatio) {
        if (minCropBoxWidth && minCropBoxHeight) {
          if (minCropBoxHeight * aspectRatio > minCropBoxWidth) {
            minCropBoxHeight = minCropBoxWidth / aspectRatio;
          } else {
            minCropBoxWidth = minCropBoxHeight * aspectRatio;
          }
        } else if (minCropBoxWidth) {
          minCropBoxHeight = minCropBoxWidth / aspectRatio;
        } else if (minCropBoxHeight) {
          minCropBoxWidth = minCropBoxHeight * aspectRatio;
        }
        if (maxCropBoxHeight * aspectRatio > maxCropBoxWidth) {
          maxCropBoxHeight = maxCropBoxWidth / aspectRatio;
        } else {
          maxCropBoxWidth = maxCropBoxHeight * aspectRatio;
        }
      }
      cropBoxData.minWidth = Math.min(minCropBoxWidth, maxCropBoxWidth);
      cropBoxData.minHeight = Math.min(minCropBoxHeight, maxCropBoxHeight);
      cropBoxData.maxWidth = maxCropBoxWidth;
      cropBoxData.maxHeight = maxCropBoxHeight;
    }
    if (positionLimited) {
      if (limited) {
        cropBoxData.minLeft = Math.max(0, canvasData.left);
        cropBoxData.minTop = Math.max(0, canvasData.top);
        cropBoxData.maxLeft =
          Math.min(containerData.width, canvasData.left + canvasData.width) -
          cropBoxData.width;
        cropBoxData.maxTop =
          Math.min(containerData.height, canvasData.top + canvasData.height) -
          cropBoxData.height;
      } else {
        cropBoxData.minLeft = 0;
        cropBoxData.minTop = 0;
        cropBoxData.maxLeft = containerData.width - cropBoxData.width;
        cropBoxData.maxTop = containerData.height - cropBoxData.height;
      }
    }
  },
  renderCropBox: function renderCropBox() {
    var options = this.options,
      containerData = this.containerData,
      cropBoxData = this.cropBoxData;
    if (
      cropBoxData.width > cropBoxData.maxWidth ||
      cropBoxData.width < cropBoxData.minWidth
    ) {
      cropBoxData.left = cropBoxData.oldLeft;
    }
    if (
      cropBoxData.height > cropBoxData.maxHeight ||
      cropBoxData.height < cropBoxData.minHeight
    ) {
      cropBoxData.top = cropBoxData.oldTop;
    }
    cropBoxData.width = Math.min(
      Math.max(cropBoxData.width, cropBoxData.minWidth),
      cropBoxData.maxWidth
    );
    cropBoxData.height = Math.min(
      Math.max(cropBoxData.height, cropBoxData.minHeight),
      cropBoxData.maxHeight
    );
    this.limitCropBox(false, true);
    cropBoxData.left = Math.min(
      Math.max(cropBoxData.left, cropBoxData.minLeft),
      cropBoxData.maxLeft
    );
    cropBoxData.top = Math.min(
      Math.max(cropBoxData.top, cropBoxData.minTop),
      cropBoxData.maxTop
    );
    cropBoxData.oldLeft = cropBoxData.left;
    cropBoxData.oldTop = cropBoxData.top;
    if (options.movable && options.cropBoxMovable) {
      setData(
        this.face,
        DATA_ACTION,
        cropBoxData.width >= containerData.width &&
          cropBoxData.height >= containerData.height
          ? ACTION_MOVE
          : ACTION_ALL
      );
    }
    setStyle(
      this.cropBox,
      assign(
        {
          width: cropBoxData.width,
          height: cropBoxData.height,
        },
        getTransforms({
          translateX: cropBoxData.left,
          translateY: cropBoxData.top,
        })
      )
    );
    if (this.cropped && this.limited) {
      this.limitCanvas(true, true);
    }
    if (!this.disabled) {
      this.output();
    }
  },
  output: function output() {
    this.preview();
    dispatchEvent(this.element, EVENT_CROP, this.getData());
  },
};
var preview = {
  initPreview: function initPreview() {
    var element2 = this.element,
      crossOrigin = this.crossOrigin;
    var preview3 = this.options.preview;
    var url = crossOrigin ? this.crossOriginUrl : this.url;
    var alt = element2.alt || "The image to preview";
    var image = document.createElement("img");
    if (crossOrigin) {
      image.crossOrigin = crossOrigin;
    }
    image.src = url;
    image.alt = alt;
    this.viewBox.appendChild(image);
    this.viewBoxImage = image;
    if (!preview3) {
      return;
    }
    var previews = preview3;
    if (typeof preview3 === "string") {
      previews = element2.ownerDocument.querySelectorAll(preview3);
    } else if (preview3.querySelector) {
      previews = [preview3];
    }
    this.previews = previews;
    forEach(previews, function (el) {
      var img = document.createElement("img");
      setData(el, DATA_PREVIEW, {
        width: el.offsetWidth,
        height: el.offsetHeight,
        html: el.innerHTML,
      });
      if (crossOrigin) {
        img.crossOrigin = crossOrigin;
      }
      img.src = url;
      img.alt = alt;
      img.style.cssText =
        'display:block;width:100%;height:auto;min-width:0!important;min-height:0!important;max-width:none!important;max-height:none!important;image-orientation:0deg!important;"';
      el.innerHTML = "";
      el.appendChild(img);
    });
  },
  resetPreview: function resetPreview() {
    forEach(this.previews, function (element2) {
      var data = getData(element2, DATA_PREVIEW);
      setStyle(element2, {
        width: data.width,
        height: data.height,
      });
      element2.innerHTML = data.html;
      removeData(element2, DATA_PREVIEW);
    });
  },
  preview: function preview2() {
    var imageData = this.imageData,
      canvasData = this.canvasData,
      cropBoxData = this.cropBoxData;
    var cropBoxWidth = cropBoxData.width,
      cropBoxHeight = cropBoxData.height;
    var width = imageData.width,
      height2 = imageData.height;
    var left = cropBoxData.left - canvasData.left - imageData.left;
    var top = cropBoxData.top - canvasData.top - imageData.top;
    if (!this.cropped || this.disabled) {
      return;
    }
    setStyle(
      this.viewBoxImage,
      assign(
        {
          width,
          height: height2,
        },
        getTransforms(
          assign(
            {
              translateX: -left,
              translateY: -top,
            },
            imageData
          )
        )
      )
    );
    forEach(this.previews, function (element2) {
      var data = getData(element2, DATA_PREVIEW);
      var originalWidth = data.width;
      var originalHeight = data.height;
      var newWidth = originalWidth;
      var newHeight = originalHeight;
      var ratio = 1;
      if (cropBoxWidth) {
        ratio = originalWidth / cropBoxWidth;
        newHeight = cropBoxHeight * ratio;
      }
      if (cropBoxHeight && newHeight > originalHeight) {
        ratio = originalHeight / cropBoxHeight;
        newWidth = cropBoxWidth * ratio;
        newHeight = originalHeight;
      }
      setStyle(element2, {
        width: newWidth,
        height: newHeight,
      });
      setStyle(
        element2.getElementsByTagName("img")[0],
        assign(
          {
            width: width * ratio,
            height: height2 * ratio,
          },
          getTransforms(
            assign(
              {
                translateX: -left * ratio,
                translateY: -top * ratio,
              },
              imageData
            )
          )
        )
      );
    });
  },
};
var events = {
  bind: function bind3() {
    var element2 = this.element,
      options = this.options,
      cropper = this.cropper;
    if (isFunction(options.cropstart)) {
      addListener(element2, EVENT_CROP_START, options.cropstart);
    }
    if (isFunction(options.cropmove)) {
      addListener(element2, EVENT_CROP_MOVE, options.cropmove);
    }
    if (isFunction(options.cropend)) {
      addListener(element2, EVENT_CROP_END, options.cropend);
    }
    if (isFunction(options.crop)) {
      addListener(element2, EVENT_CROP, options.crop);
    }
    if (isFunction(options.zoom)) {
      addListener(element2, EVENT_ZOOM, options.zoom);
    }
    addListener(
      cropper,
      EVENT_POINTER_DOWN,
      (this.onCropStart = this.cropStart.bind(this))
    );
    if (options.zoomable && options.zoomOnWheel) {
      addListener(
        cropper,
        EVENT_WHEEL,
        (this.onWheel = this.wheel.bind(this)),
        {
          passive: false,
          capture: true,
        }
      );
    }
    if (options.toggleDragModeOnDblclick) {
      addListener(
        cropper,
        EVENT_DBLCLICK,
        (this.onDblclick = this.dblclick.bind(this))
      );
    }
    addListener(
      element2.ownerDocument,
      EVENT_POINTER_MOVE,
      (this.onCropMove = this.cropMove.bind(this))
    );
    addListener(
      element2.ownerDocument,
      EVENT_POINTER_UP,
      (this.onCropEnd = this.cropEnd.bind(this))
    );
    if (options.responsive) {
      addListener(
        window,
        EVENT_RESIZE,
        (this.onResize = this.resize.bind(this))
      );
    }
  },
  unbind: function unbind() {
    var element2 = this.element,
      options = this.options,
      cropper = this.cropper;
    if (isFunction(options.cropstart)) {
      removeListener(element2, EVENT_CROP_START, options.cropstart);
    }
    if (isFunction(options.cropmove)) {
      removeListener(element2, EVENT_CROP_MOVE, options.cropmove);
    }
    if (isFunction(options.cropend)) {
      removeListener(element2, EVENT_CROP_END, options.cropend);
    }
    if (isFunction(options.crop)) {
      removeListener(element2, EVENT_CROP, options.crop);
    }
    if (isFunction(options.zoom)) {
      removeListener(element2, EVENT_ZOOM, options.zoom);
    }
    removeListener(cropper, EVENT_POINTER_DOWN, this.onCropStart);
    if (options.zoomable && options.zoomOnWheel) {
      removeListener(cropper, EVENT_WHEEL, this.onWheel, {
        passive: false,
        capture: true,
      });
    }
    if (options.toggleDragModeOnDblclick) {
      removeListener(cropper, EVENT_DBLCLICK, this.onDblclick);
    }
    removeListener(element2.ownerDocument, EVENT_POINTER_MOVE, this.onCropMove);
    removeListener(element2.ownerDocument, EVENT_POINTER_UP, this.onCropEnd);
    if (options.responsive) {
      removeListener(window, EVENT_RESIZE, this.onResize);
    }
  },
};
var handlers = {
  resize: function resize() {
    if (this.disabled) {
      return;
    }
    var options = this.options,
      container = this.container,
      containerData = this.containerData;
    var ratioX = container.offsetWidth / containerData.width;
    var ratioY = container.offsetHeight / containerData.height;
    var ratio = Math.abs(ratioX - 1) > Math.abs(ratioY - 1) ? ratioX : ratioY;
    if (ratio !== 1) {
      var canvasData;
      var cropBoxData;
      if (options.restore) {
        canvasData = this.getCanvasData();
        cropBoxData = this.getCropBoxData();
      }
      this.render();
      if (options.restore) {
        this.setCanvasData(
          forEach(canvasData, function (n, i) {
            canvasData[i] = n * ratio;
          })
        );
        this.setCropBoxData(
          forEach(cropBoxData, function (n, i) {
            cropBoxData[i] = n * ratio;
          })
        );
      }
    }
  },
  dblclick: function dblclick() {
    if (this.disabled || this.options.dragMode === DRAG_MODE_NONE) {
      return;
    }
    this.setDragMode(
      hasClass(this.dragBox, CLASS_CROP) ? DRAG_MODE_MOVE : DRAG_MODE_CROP
    );
  },
  wheel: function wheel(event) {
    var _this = this;
    var ratio = Number(this.options.wheelZoomRatio) || 0.1;
    var delta = 1;
    if (this.disabled) {
      return;
    }
    event.preventDefault();
    if (this.wheeling) {
      return;
    }
    this.wheeling = true;
    setTimeout(function () {
      _this.wheeling = false;
    }, 50);
    if (event.deltaY) {
      delta = event.deltaY > 0 ? 1 : -1;
    } else if (event.wheelDelta) {
      delta = -event.wheelDelta / 120;
    } else if (event.detail) {
      delta = event.detail > 0 ? 1 : -1;
    }
    this.zoom(-delta * ratio, event);
  },
  cropStart: function cropStart(event) {
    var buttons = event.buttons,
      button = event.button;
    if (
      this.disabled ||
      ((event.type === "mousedown" ||
        (event.type === "pointerdown" && event.pointerType === "mouse")) && // No primary button (Usually the left button)
        ((isNumber(buttons) && buttons !== 1) ||
          (isNumber(button) && button !== 0) ||
          event.ctrlKey))
    ) {
      return;
    }
    var options = this.options,
      pointers = this.pointers;
    var action;
    if (event.changedTouches) {
      forEach(event.changedTouches, function (touch) {
        pointers[touch.identifier] = getPointer(touch);
      });
    } else {
      pointers[event.pointerId || 0] = getPointer(event);
    }
    if (
      Object.keys(pointers).length > 1 &&
      options.zoomable &&
      options.zoomOnTouch
    ) {
      action = ACTION_ZOOM;
    } else {
      action = getData(event.target, DATA_ACTION);
    }
    if (!REGEXP_ACTIONS.test(action)) {
      return;
    }
    if (
      dispatchEvent(this.element, EVENT_CROP_START, {
        originalEvent: event,
        action,
      }) === false
    ) {
      return;
    }
    event.preventDefault();
    this.action = action;
    this.cropping = false;
    if (action === ACTION_CROP) {
      this.cropping = true;
      addClass(this.dragBox, CLASS_MODAL);
    }
  },
  cropMove: function cropMove(event) {
    var action = this.action;
    if (this.disabled || !action) {
      return;
    }
    var pointers = this.pointers;
    event.preventDefault();
    if (
      dispatchEvent(this.element, EVENT_CROP_MOVE, {
        originalEvent: event,
        action,
      }) === false
    ) {
      return;
    }
    if (event.changedTouches) {
      forEach(event.changedTouches, function (touch) {
        assign(pointers[touch.identifier] || {}, getPointer(touch, true));
      });
    } else {
      assign(pointers[event.pointerId || 0] || {}, getPointer(event, true));
    }
    this.change(event);
  },
  cropEnd: function cropEnd(event) {
    if (this.disabled) {
      return;
    }
    var action = this.action,
      pointers = this.pointers;
    if (event.changedTouches) {
      forEach(event.changedTouches, function (touch) {
        delete pointers[touch.identifier];
      });
    } else {
      delete pointers[event.pointerId || 0];
    }
    if (!action) {
      return;
    }
    event.preventDefault();
    if (!Object.keys(pointers).length) {
      this.action = "";
    }
    if (this.cropping) {
      this.cropping = false;
      toggleClass(
        this.dragBox,
        CLASS_MODAL,
        this.cropped && this.options.modal
      );
    }
    dispatchEvent(this.element, EVENT_CROP_END, {
      originalEvent: event,
      action,
    });
  },
};
var change = {
  change: function change2(event) {
    var options = this.options,
      canvasData = this.canvasData,
      containerData = this.containerData,
      cropBoxData = this.cropBoxData,
      pointers = this.pointers;
    var action = this.action;
    var aspectRatio = options.aspectRatio;
    var left = cropBoxData.left,
      top = cropBoxData.top,
      width = cropBoxData.width,
      height2 = cropBoxData.height;
    var right = left + width;
    var bottom = top + height2;
    var minLeft = 0;
    var minTop = 0;
    var maxWidth = containerData.width;
    var maxHeight = containerData.height;
    var renderable = true;
    var offset;
    if (!aspectRatio && event.shiftKey) {
      aspectRatio = width && height2 ? width / height2 : 1;
    }
    if (this.limited) {
      minLeft = cropBoxData.minLeft;
      minTop = cropBoxData.minTop;
      maxWidth =
        minLeft +
        Math.min(
          containerData.width,
          canvasData.width,
          canvasData.left + canvasData.width
        );
      maxHeight =
        minTop +
        Math.min(
          containerData.height,
          canvasData.height,
          canvasData.top + canvasData.height
        );
    }
    var pointer = pointers[Object.keys(pointers)[0]];
    var range = {
      x: pointer.endX - pointer.startX,
      y: pointer.endY - pointer.startY,
    };
    var check = function check2(side) {
      switch (side) {
        case ACTION_EAST:
          if (right + range.x > maxWidth) {
            range.x = maxWidth - right;
          }
          break;
        case ACTION_WEST:
          if (left + range.x < minLeft) {
            range.x = minLeft - left;
          }
          break;
        case ACTION_NORTH:
          if (top + range.y < minTop) {
            range.y = minTop - top;
          }
          break;
        case ACTION_SOUTH:
          if (bottom + range.y > maxHeight) {
            range.y = maxHeight - bottom;
          }
          break;
      }
    };
    switch (action) {
      case ACTION_ALL:
        left += range.x;
        top += range.y;
        break;
      case ACTION_EAST:
        if (
          range.x >= 0 &&
          (right >= maxWidth ||
            (aspectRatio && (top <= minTop || bottom >= maxHeight)))
        ) {
          renderable = false;
          break;
        }
        check(ACTION_EAST);
        width += range.x;
        if (width < 0) {
          action = ACTION_WEST;
          width = -width;
          left -= width;
        }
        if (aspectRatio) {
          height2 = width / aspectRatio;
          top += (cropBoxData.height - height2) / 2;
        }
        break;
      case ACTION_NORTH:
        if (
          range.y <= 0 &&
          (top <= minTop ||
            (aspectRatio && (left <= minLeft || right >= maxWidth)))
        ) {
          renderable = false;
          break;
        }
        check(ACTION_NORTH);
        height2 -= range.y;
        top += range.y;
        if (height2 < 0) {
          action = ACTION_SOUTH;
          height2 = -height2;
          top -= height2;
        }
        if (aspectRatio) {
          width = height2 * aspectRatio;
          left += (cropBoxData.width - width) / 2;
        }
        break;
      case ACTION_WEST:
        if (
          range.x <= 0 &&
          (left <= minLeft ||
            (aspectRatio && (top <= minTop || bottom >= maxHeight)))
        ) {
          renderable = false;
          break;
        }
        check(ACTION_WEST);
        width -= range.x;
        left += range.x;
        if (width < 0) {
          action = ACTION_EAST;
          width = -width;
          left -= width;
        }
        if (aspectRatio) {
          height2 = width / aspectRatio;
          top += (cropBoxData.height - height2) / 2;
        }
        break;
      case ACTION_SOUTH:
        if (
          range.y >= 0 &&
          (bottom >= maxHeight ||
            (aspectRatio && (left <= minLeft || right >= maxWidth)))
        ) {
          renderable = false;
          break;
        }
        check(ACTION_SOUTH);
        height2 += range.y;
        if (height2 < 0) {
          action = ACTION_NORTH;
          height2 = -height2;
          top -= height2;
        }
        if (aspectRatio) {
          width = height2 * aspectRatio;
          left += (cropBoxData.width - width) / 2;
        }
        break;
      case ACTION_NORTH_EAST:
        if (aspectRatio) {
          if (range.y <= 0 && (top <= minTop || right >= maxWidth)) {
            renderable = false;
            break;
          }
          check(ACTION_NORTH);
          height2 -= range.y;
          top += range.y;
          width = height2 * aspectRatio;
        } else {
          check(ACTION_NORTH);
          check(ACTION_EAST);
          if (range.x >= 0) {
            if (right < maxWidth) {
              width += range.x;
            } else if (range.y <= 0 && top <= minTop) {
              renderable = false;
            }
          } else {
            width += range.x;
          }
          if (range.y <= 0) {
            if (top > minTop) {
              height2 -= range.y;
              top += range.y;
            }
          } else {
            height2 -= range.y;
            top += range.y;
          }
        }
        if (width < 0 && height2 < 0) {
          action = ACTION_SOUTH_WEST;
          height2 = -height2;
          width = -width;
          top -= height2;
          left -= width;
        } else if (width < 0) {
          action = ACTION_NORTH_WEST;
          width = -width;
          left -= width;
        } else if (height2 < 0) {
          action = ACTION_SOUTH_EAST;
          height2 = -height2;
          top -= height2;
        }
        break;
      case ACTION_NORTH_WEST:
        if (aspectRatio) {
          if (range.y <= 0 && (top <= minTop || left <= minLeft)) {
            renderable = false;
            break;
          }
          check(ACTION_NORTH);
          height2 -= range.y;
          top += range.y;
          width = height2 * aspectRatio;
          left += cropBoxData.width - width;
        } else {
          check(ACTION_NORTH);
          check(ACTION_WEST);
          if (range.x <= 0) {
            if (left > minLeft) {
              width -= range.x;
              left += range.x;
            } else if (range.y <= 0 && top <= minTop) {
              renderable = false;
            }
          } else {
            width -= range.x;
            left += range.x;
          }
          if (range.y <= 0) {
            if (top > minTop) {
              height2 -= range.y;
              top += range.y;
            }
          } else {
            height2 -= range.y;
            top += range.y;
          }
        }
        if (width < 0 && height2 < 0) {
          action = ACTION_SOUTH_EAST;
          height2 = -height2;
          width = -width;
          top -= height2;
          left -= width;
        } else if (width < 0) {
          action = ACTION_NORTH_EAST;
          width = -width;
          left -= width;
        } else if (height2 < 0) {
          action = ACTION_SOUTH_WEST;
          height2 = -height2;
          top -= height2;
        }
        break;
      case ACTION_SOUTH_WEST:
        if (aspectRatio) {
          if (range.x <= 0 && (left <= minLeft || bottom >= maxHeight)) {
            renderable = false;
            break;
          }
          check(ACTION_WEST);
          width -= range.x;
          left += range.x;
          height2 = width / aspectRatio;
        } else {
          check(ACTION_SOUTH);
          check(ACTION_WEST);
          if (range.x <= 0) {
            if (left > minLeft) {
              width -= range.x;
              left += range.x;
            } else if (range.y >= 0 && bottom >= maxHeight) {
              renderable = false;
            }
          } else {
            width -= range.x;
            left += range.x;
          }
          if (range.y >= 0) {
            if (bottom < maxHeight) {
              height2 += range.y;
            }
          } else {
            height2 += range.y;
          }
        }
        if (width < 0 && height2 < 0) {
          action = ACTION_NORTH_EAST;
          height2 = -height2;
          width = -width;
          top -= height2;
          left -= width;
        } else if (width < 0) {
          action = ACTION_SOUTH_EAST;
          width = -width;
          left -= width;
        } else if (height2 < 0) {
          action = ACTION_NORTH_WEST;
          height2 = -height2;
          top -= height2;
        }
        break;
      case ACTION_SOUTH_EAST:
        if (aspectRatio) {
          if (range.x >= 0 && (right >= maxWidth || bottom >= maxHeight)) {
            renderable = false;
            break;
          }
          check(ACTION_EAST);
          width += range.x;
          height2 = width / aspectRatio;
        } else {
          check(ACTION_SOUTH);
          check(ACTION_EAST);
          if (range.x >= 0) {
            if (right < maxWidth) {
              width += range.x;
            } else if (range.y >= 0 && bottom >= maxHeight) {
              renderable = false;
            }
          } else {
            width += range.x;
          }
          if (range.y >= 0) {
            if (bottom < maxHeight) {
              height2 += range.y;
            }
          } else {
            height2 += range.y;
          }
        }
        if (width < 0 && height2 < 0) {
          action = ACTION_NORTH_WEST;
          height2 = -height2;
          width = -width;
          top -= height2;
          left -= width;
        } else if (width < 0) {
          action = ACTION_SOUTH_WEST;
          width = -width;
          left -= width;
        } else if (height2 < 0) {
          action = ACTION_NORTH_EAST;
          height2 = -height2;
          top -= height2;
        }
        break;
      case ACTION_MOVE:
        this.move(range.x, range.y);
        renderable = false;
        break;
      case ACTION_ZOOM:
        this.zoom(getMaxZoomRatio(pointers), event);
        renderable = false;
        break;
      case ACTION_CROP:
        if (!range.x || !range.y) {
          renderable = false;
          break;
        }
        offset = getOffset(this.cropper);
        left = pointer.startX - offset.left;
        top = pointer.startY - offset.top;
        width = cropBoxData.minWidth;
        height2 = cropBoxData.minHeight;
        if (range.x > 0) {
          action = range.y > 0 ? ACTION_SOUTH_EAST : ACTION_NORTH_EAST;
        } else if (range.x < 0) {
          left -= width;
          action = range.y > 0 ? ACTION_SOUTH_WEST : ACTION_NORTH_WEST;
        }
        if (range.y < 0) {
          top -= height2;
        }
        if (!this.cropped) {
          removeClass(this.cropBox, CLASS_HIDDEN);
          this.cropped = true;
          if (this.limited) {
            this.limitCropBox(true, true);
          }
        }
        break;
    }
    if (renderable) {
      cropBoxData.width = width;
      cropBoxData.height = height2;
      cropBoxData.left = left;
      cropBoxData.top = top;
      this.action = action;
      this.renderCropBox();
    }
    forEach(pointers, function (p2) {
      p2.startX = p2.endX;
      p2.startY = p2.endY;
    });
  },
};
var methods = {
  // Show the crop box manually
  crop: function crop() {
    if (this.ready && !this.cropped && !this.disabled) {
      this.cropped = true;
      this.limitCropBox(true, true);
      if (this.options.modal) {
        addClass(this.dragBox, CLASS_MODAL);
      }
      removeClass(this.cropBox, CLASS_HIDDEN);
      this.setCropBoxData(this.initialCropBoxData);
    }
    return this;
  },
  // Reset the image and crop box to their initial states
  reset: function reset() {
    if (this.ready && !this.disabled) {
      this.imageData = assign({}, this.initialImageData);
      this.canvasData = assign({}, this.initialCanvasData);
      this.cropBoxData = assign({}, this.initialCropBoxData);
      this.renderCanvas();
      if (this.cropped) {
        this.renderCropBox();
      }
    }
    return this;
  },
  // Clear the crop box
  clear: function clear() {
    if (this.cropped && !this.disabled) {
      assign(this.cropBoxData, {
        left: 0,
        top: 0,
        width: 0,
        height: 0,
      });
      this.cropped = false;
      this.renderCropBox();
      this.limitCanvas(true, true);
      this.renderCanvas();
      removeClass(this.dragBox, CLASS_MODAL);
      addClass(this.cropBox, CLASS_HIDDEN);
    }
    return this;
  },
  /**
   * Replace the image's src and rebuild the cropper
   * @param {string} url - The new URL.
   * @param {boolean} [hasSameSize] - Indicate if the new image has the same size as the old one.
   * @returns {Cropper} this
   */
  replace: function replace(url) {
    var hasSameSize =
      arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    if (!this.disabled && url) {
      if (this.isImg) {
        this.element.src = url;
      }
      if (hasSameSize) {
        this.url = url;
        this.image.src = url;
        if (this.ready) {
          this.viewBoxImage.src = url;
          forEach(this.previews, function (element2) {
            element2.getElementsByTagName("img")[0].src = url;
          });
        }
      } else {
        if (this.isImg) {
          this.replaced = true;
        }
        this.options.data = null;
        this.uncreate();
        this.load(url);
      }
    }
    return this;
  },
  // Enable (unfreeze) the cropper
  enable: function enable() {
    if (this.ready && this.disabled) {
      this.disabled = false;
      removeClass(this.cropper, CLASS_DISABLED);
    }
    return this;
  },
  // Disable (freeze) the cropper
  disable: function disable() {
    if (this.ready && !this.disabled) {
      this.disabled = true;
      addClass(this.cropper, CLASS_DISABLED);
    }
    return this;
  },
  /**
   * Destroy the cropper and remove the instance from the image
   * @returns {Cropper} this
   */
  destroy: function destroy() {
    var element2 = this.element;
    if (!element2[NAMESPACE]) {
      return this;
    }
    element2[NAMESPACE] = void 0;
    if (this.isImg && this.replaced) {
      element2.src = this.originalUrl;
    }
    this.uncreate();
    return this;
  },
  /**
   * Move the canvas with relative offsets
   * @param {number} offsetX - The relative offset distance on the x-axis.
   * @param {number} [offsetY=offsetX] - The relative offset distance on the y-axis.
   * @returns {Cropper} this
   */
  move: function move(offsetX) {
    var offsetY =
      arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : offsetX;
    var _this$canvasData = this.canvasData,
      left = _this$canvasData.left,
      top = _this$canvasData.top;
    return this.moveTo(
      isUndefined(offsetX) ? offsetX : left + Number(offsetX),
      isUndefined(offsetY) ? offsetY : top + Number(offsetY)
    );
  },
  /**
   * Move the canvas to an absolute point
   * @param {number} x - The x-axis coordinate.
   * @param {number} [y=x] - The y-axis coordinate.
   * @returns {Cropper} this
   */
  moveTo: function moveTo(x2) {
    var y2 =
      arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : x2;
    var canvasData = this.canvasData;
    var changed = false;
    x2 = Number(x2);
    y2 = Number(y2);
    if (this.ready && !this.disabled && this.options.movable) {
      if (isNumber(x2)) {
        canvasData.left = x2;
        changed = true;
      }
      if (isNumber(y2)) {
        canvasData.top = y2;
        changed = true;
      }
      if (changed) {
        this.renderCanvas(true);
      }
    }
    return this;
  },
  /**
   * Zoom the canvas with a relative ratio
   * @param {number} ratio - The target ratio.
   * @param {Event} _originalEvent - The original event if any.
   * @returns {Cropper} this
   */
  zoom: function zoom(ratio, _originalEvent) {
    var canvasData = this.canvasData;
    ratio = Number(ratio);
    if (ratio < 0) {
      ratio = 1 / (1 - ratio);
    } else {
      ratio = 1 + ratio;
    }
    return this.zoomTo(
      (canvasData.width * ratio) / canvasData.naturalWidth,
      null,
      _originalEvent
    );
  },
  /**
   * Zoom the canvas to an absolute ratio
   * @param {number} ratio - The target ratio.
   * @param {Object} pivot - The zoom pivot point coordinate.
   * @param {Event} _originalEvent - The original event if any.
   * @returns {Cropper} this
   */
  zoomTo: function zoomTo(ratio, pivot, _originalEvent) {
    var options = this.options,
      canvasData = this.canvasData;
    var width = canvasData.width,
      height2 = canvasData.height,
      naturalWidth = canvasData.naturalWidth,
      naturalHeight = canvasData.naturalHeight;
    ratio = Number(ratio);
    if (ratio >= 0 && this.ready && !this.disabled && options.zoomable) {
      var newWidth = naturalWidth * ratio;
      var newHeight = naturalHeight * ratio;
      if (
        dispatchEvent(this.element, EVENT_ZOOM, {
          ratio,
          oldRatio: width / naturalWidth,
          originalEvent: _originalEvent,
        }) === false
      ) {
        return this;
      }
      if (_originalEvent) {
        var pointers = this.pointers;
        var offset = getOffset(this.cropper);
        var center =
          pointers && Object.keys(pointers).length
            ? getPointersCenter(pointers)
            : {
                pageX: _originalEvent.pageX,
                pageY: _originalEvent.pageY,
              };
        canvasData.left -=
          (newWidth - width) *
          ((center.pageX - offset.left - canvasData.left) / width);
        canvasData.top -=
          (newHeight - height2) *
          ((center.pageY - offset.top - canvasData.top) / height2);
      } else if (
        isPlainObject(pivot) &&
        isNumber(pivot.x) &&
        isNumber(pivot.y)
      ) {
        canvasData.left -=
          (newWidth - width) * ((pivot.x - canvasData.left) / width);
        canvasData.top -=
          (newHeight - height2) * ((pivot.y - canvasData.top) / height2);
      } else {
        canvasData.left -= (newWidth - width) / 2;
        canvasData.top -= (newHeight - height2) / 2;
      }
      canvasData.width = newWidth;
      canvasData.height = newHeight;
      this.renderCanvas(true);
    }
    return this;
  },
  /**
   * Rotate the canvas with a relative degree
   * @param {number} degree - The rotate degree.
   * @returns {Cropper} this
   */
  rotate: function rotate(degree) {
    return this.rotateTo((this.imageData.rotate || 0) + Number(degree));
  },
  /**
   * Rotate the canvas to an absolute degree
   * @param {number} degree - The rotate degree.
   * @returns {Cropper} this
   */
  rotateTo: function rotateTo(degree) {
    degree = Number(degree);
    if (
      isNumber(degree) &&
      this.ready &&
      !this.disabled &&
      this.options.rotatable
    ) {
      this.imageData.rotate = degree % 360;
      this.renderCanvas(true, true);
    }
    return this;
  },
  /**
   * Scale the image on the x-axis.
   * @param {number} scaleX - The scale ratio on the x-axis.
   * @returns {Cropper} this
   */
  scaleX: function scaleX(_scaleX) {
    var scaleY2 = this.imageData.scaleY;
    return this.scale(_scaleX, isNumber(scaleY2) ? scaleY2 : 1);
  },
  /**
   * Scale the image on the y-axis.
   * @param {number} scaleY - The scale ratio on the y-axis.
   * @returns {Cropper} this
   */
  scaleY: function scaleY(_scaleY) {
    var scaleX2 = this.imageData.scaleX;
    return this.scale(isNumber(scaleX2) ? scaleX2 : 1, _scaleY);
  },
  /**
   * Scale the image
   * @param {number} scaleX - The scale ratio on the x-axis.
   * @param {number} [scaleY=scaleX] - The scale ratio on the y-axis.
   * @returns {Cropper} this
   */
  scale: function scale(scaleX2) {
    var scaleY2 =
      arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : scaleX2;
    var imageData = this.imageData;
    var transformed = false;
    scaleX2 = Number(scaleX2);
    scaleY2 = Number(scaleY2);
    if (this.ready && !this.disabled && this.options.scalable) {
      if (isNumber(scaleX2)) {
        imageData.scaleX = scaleX2;
        transformed = true;
      }
      if (isNumber(scaleY2)) {
        imageData.scaleY = scaleY2;
        transformed = true;
      }
      if (transformed) {
        this.renderCanvas(true, true);
      }
    }
    return this;
  },
  /**
   * Get the cropped area position and size data (base on the original image)
   * @param {boolean} [rounded=false] - Indicate if round the data values or not.
   * @returns {Object} The result cropped data.
   */
  getData: function getData2() {
    var rounded =
      arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false;
    var options = this.options,
      imageData = this.imageData,
      canvasData = this.canvasData,
      cropBoxData = this.cropBoxData;
    var data;
    if (this.ready && this.cropped) {
      data = {
        x: cropBoxData.left - canvasData.left,
        y: cropBoxData.top - canvasData.top,
        width: cropBoxData.width,
        height: cropBoxData.height,
      };
      var ratio = imageData.width / imageData.naturalWidth;
      forEach(data, function (n, i) {
        data[i] = n / ratio;
      });
      if (rounded) {
        var bottom = Math.round(data.y + data.height);
        var right = Math.round(data.x + data.width);
        data.x = Math.round(data.x);
        data.y = Math.round(data.y);
        data.width = right - data.x;
        data.height = bottom - data.y;
      }
    } else {
      data = {
        x: 0,
        y: 0,
        width: 0,
        height: 0,
      };
    }
    if (options.rotatable) {
      data.rotate = imageData.rotate || 0;
    }
    if (options.scalable) {
      data.scaleX = imageData.scaleX || 1;
      data.scaleY = imageData.scaleY || 1;
    }
    return data;
  },
  /**
   * Set the cropped area position and size with new data
   * @param {Object} data - The new data.
   * @returns {Cropper} this
   */
  setData: function setData2(data) {
    var options = this.options,
      imageData = this.imageData,
      canvasData = this.canvasData;
    var cropBoxData = {};
    if (this.ready && !this.disabled && isPlainObject(data)) {
      var transformed = false;
      if (options.rotatable) {
        if (isNumber(data.rotate) && data.rotate !== imageData.rotate) {
          imageData.rotate = data.rotate;
          transformed = true;
        }
      }
      if (options.scalable) {
        if (isNumber(data.scaleX) && data.scaleX !== imageData.scaleX) {
          imageData.scaleX = data.scaleX;
          transformed = true;
        }
        if (isNumber(data.scaleY) && data.scaleY !== imageData.scaleY) {
          imageData.scaleY = data.scaleY;
          transformed = true;
        }
      }
      if (transformed) {
        this.renderCanvas(true, true);
      }
      var ratio = imageData.width / imageData.naturalWidth;
      if (isNumber(data.x)) {
        cropBoxData.left = data.x * ratio + canvasData.left;
      }
      if (isNumber(data.y)) {
        cropBoxData.top = data.y * ratio + canvasData.top;
      }
      if (isNumber(data.width)) {
        cropBoxData.width = data.width * ratio;
      }
      if (isNumber(data.height)) {
        cropBoxData.height = data.height * ratio;
      }
      this.setCropBoxData(cropBoxData);
    }
    return this;
  },
  /**
   * Get the container size data.
   * @returns {Object} The result container data.
   */
  getContainerData: function getContainerData() {
    return this.ready ? assign({}, this.containerData) : {};
  },
  /**
   * Get the image position and size data.
   * @returns {Object} The result image data.
   */
  getImageData: function getImageData() {
    return this.sized ? assign({}, this.imageData) : {};
  },
  /**
   * Get the canvas position and size data.
   * @returns {Object} The result canvas data.
   */
  getCanvasData: function getCanvasData() {
    var canvasData = this.canvasData;
    var data = {};
    if (this.ready) {
      forEach(
        ["left", "top", "width", "height", "naturalWidth", "naturalHeight"],
        function (n) {
          data[n] = canvasData[n];
        }
      );
    }
    return data;
  },
  /**
   * Set the canvas position and size with new data.
   * @param {Object} data - The new canvas data.
   * @returns {Cropper} this
   */
  setCanvasData: function setCanvasData(data) {
    var canvasData = this.canvasData;
    var aspectRatio = canvasData.aspectRatio;
    if (this.ready && !this.disabled && isPlainObject(data)) {
      if (isNumber(data.left)) {
        canvasData.left = data.left;
      }
      if (isNumber(data.top)) {
        canvasData.top = data.top;
      }
      if (isNumber(data.width)) {
        canvasData.width = data.width;
        canvasData.height = data.width / aspectRatio;
      } else if (isNumber(data.height)) {
        canvasData.height = data.height;
        canvasData.width = data.height * aspectRatio;
      }
      this.renderCanvas(true);
    }
    return this;
  },
  /**
   * Get the crop box position and size data.
   * @returns {Object} The result crop box data.
   */
  getCropBoxData: function getCropBoxData() {
    var cropBoxData = this.cropBoxData;
    var data;
    if (this.ready && this.cropped) {
      data = {
        left: cropBoxData.left,
        top: cropBoxData.top,
        width: cropBoxData.width,
        height: cropBoxData.height,
      };
    }
    return data || {};
  },
  /**
   * Set the crop box position and size with new data.
   * @param {Object} data - The new crop box data.
   * @returns {Cropper} this
   */
  setCropBoxData: function setCropBoxData(data) {
    var cropBoxData = this.cropBoxData;
    var aspectRatio = this.options.aspectRatio;
    var widthChanged;
    var heightChanged;
    if (this.ready && this.cropped && !this.disabled && isPlainObject(data)) {
      if (isNumber(data.left)) {
        cropBoxData.left = data.left;
      }
      if (isNumber(data.top)) {
        cropBoxData.top = data.top;
      }
      if (isNumber(data.width) && data.width !== cropBoxData.width) {
        widthChanged = true;
        cropBoxData.width = data.width;
      }
      if (isNumber(data.height) && data.height !== cropBoxData.height) {
        heightChanged = true;
        cropBoxData.height = data.height;
      }
      if (aspectRatio) {
        if (widthChanged) {
          cropBoxData.height = cropBoxData.width / aspectRatio;
        } else if (heightChanged) {
          cropBoxData.width = cropBoxData.height * aspectRatio;
        }
      }
      this.renderCropBox();
    }
    return this;
  },
  /**
   * Get a canvas drawn the cropped image.
   * @param {Object} [options={}] - The config options.
   * @returns {HTMLCanvasElement} - The result canvas.
   */
  getCroppedCanvas: function getCroppedCanvas() {
    var options =
      arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    if (!this.ready || !window.HTMLCanvasElement) {
      return null;
    }
    var canvasData = this.canvasData;
    var source = getSourceCanvas(
      this.image,
      this.imageData,
      canvasData,
      options
    );
    if (!this.cropped) {
      return source;
    }
    var _this$getData = this.getData(options.rounded),
      initialX = _this$getData.x,
      initialY = _this$getData.y,
      initialWidth = _this$getData.width,
      initialHeight = _this$getData.height;
    var ratio = source.width / Math.floor(canvasData.naturalWidth);
    if (ratio !== 1) {
      initialX *= ratio;
      initialY *= ratio;
      initialWidth *= ratio;
      initialHeight *= ratio;
    }
    var aspectRatio = initialWidth / initialHeight;
    var maxSizes = getAdjustedSizes({
      aspectRatio,
      width: options.maxWidth || Infinity,
      height: options.maxHeight || Infinity,
    });
    var minSizes = getAdjustedSizes(
      {
        aspectRatio,
        width: options.minWidth || 0,
        height: options.minHeight || 0,
      },
      "cover"
    );
    var _getAdjustedSizes = getAdjustedSizes({
        aspectRatio,
        width: options.width || (ratio !== 1 ? source.width : initialWidth),
        height: options.height || (ratio !== 1 ? source.height : initialHeight),
      }),
      width = _getAdjustedSizes.width,
      height2 = _getAdjustedSizes.height;
    width = Math.min(maxSizes.width, Math.max(minSizes.width, width));
    height2 = Math.min(maxSizes.height, Math.max(minSizes.height, height2));
    var canvas = document.createElement("canvas");
    var context = canvas.getContext("2d");
    canvas.width = normalizeDecimalNumber(width);
    canvas.height = normalizeDecimalNumber(height2);
    context.fillStyle = options.fillColor || "transparent";
    context.fillRect(0, 0, width, height2);
    var _options$imageSmoothi = options.imageSmoothingEnabled,
      imageSmoothingEnabled =
        _options$imageSmoothi === void 0 ? true : _options$imageSmoothi,
      imageSmoothingQuality = options.imageSmoothingQuality;
    context.imageSmoothingEnabled = imageSmoothingEnabled;
    if (imageSmoothingQuality) {
      context.imageSmoothingQuality = imageSmoothingQuality;
    }
    var sourceWidth = source.width;
    var sourceHeight = source.height;
    var srcX = initialX;
    var srcY = initialY;
    var srcWidth;
    var srcHeight;
    var dstX;
    var dstY;
    var dstWidth;
    var dstHeight;
    if (srcX <= -initialWidth || srcX > sourceWidth) {
      srcX = 0;
      srcWidth = 0;
      dstX = 0;
      dstWidth = 0;
    } else if (srcX <= 0) {
      dstX = -srcX;
      srcX = 0;
      srcWidth = Math.min(sourceWidth, initialWidth + srcX);
      dstWidth = srcWidth;
    } else if (srcX <= sourceWidth) {
      dstX = 0;
      srcWidth = Math.min(initialWidth, sourceWidth - srcX);
      dstWidth = srcWidth;
    }
    if (srcWidth <= 0 || srcY <= -initialHeight || srcY > sourceHeight) {
      srcY = 0;
      srcHeight = 0;
      dstY = 0;
      dstHeight = 0;
    } else if (srcY <= 0) {
      dstY = -srcY;
      srcY = 0;
      srcHeight = Math.min(sourceHeight, initialHeight + srcY);
      dstHeight = srcHeight;
    } else if (srcY <= sourceHeight) {
      dstY = 0;
      srcHeight = Math.min(initialHeight, sourceHeight - srcY);
      dstHeight = srcHeight;
    }
    var params = [srcX, srcY, srcWidth, srcHeight];
    if (dstWidth > 0 && dstHeight > 0) {
      var scale2 = width / initialWidth;
      params.push(
        dstX * scale2,
        dstY * scale2,
        dstWidth * scale2,
        dstHeight * scale2
      );
    }
    context.drawImage.apply(
      context,
      [source].concat(
        _toConsumableArray(
          params.map(function (param) {
            return Math.floor(normalizeDecimalNumber(param));
          })
        )
      )
    );
    return canvas;
  },
  /**
   * Change the aspect ratio of the crop box.
   * @param {number} aspectRatio - The new aspect ratio.
   * @returns {Cropper} this
   */
  setAspectRatio: function setAspectRatio(aspectRatio) {
    var options = this.options;
    if (!this.disabled && !isUndefined(aspectRatio)) {
      options.aspectRatio = Math.max(0, aspectRatio) || NaN;
      if (this.ready) {
        this.initCropBox();
        if (this.cropped) {
          this.renderCropBox();
        }
      }
    }
    return this;
  },
  /**
   * Change the drag mode.
   * @param {string} mode - The new drag mode.
   * @returns {Cropper} this
   */
  setDragMode: function setDragMode(mode) {
    var options = this.options,
      dragBox = this.dragBox,
      face = this.face;
    if (this.ready && !this.disabled) {
      var croppable = mode === DRAG_MODE_CROP;
      var movable = options.movable && mode === DRAG_MODE_MOVE;
      mode = croppable || movable ? mode : DRAG_MODE_NONE;
      options.dragMode = mode;
      setData(dragBox, DATA_ACTION, mode);
      toggleClass(dragBox, CLASS_CROP, croppable);
      toggleClass(dragBox, CLASS_MOVE, movable);
      if (!options.cropBoxMovable) {
        setData(face, DATA_ACTION, mode);
        toggleClass(face, CLASS_CROP, croppable);
        toggleClass(face, CLASS_MOVE, movable);
      }
    }
    return this;
  },
};
var AnotherCropper = WINDOW.Cropper;
var Cropper = /* @__PURE__ */ (function () {
  function Cropper2(element2) {
    var options =
      arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    _classCallCheck(this, Cropper2);
    if (!element2 || !REGEXP_TAG_NAME.test(element2.tagName)) {
      throw new Error(
        "The first argument is required and must be an <img> or <canvas> element."
      );
    }
    this.element = element2;
    this.options = assign({}, DEFAULTS, isPlainObject(options) && options);
    this.cropped = false;
    this.disabled = false;
    this.pointers = {};
    this.ready = false;
    this.reloading = false;
    this.replaced = false;
    this.sized = false;
    this.sizing = false;
    this.init();
  }
  _createClass(
    Cropper2,
    [
      {
        key: "init",
        value: function init2() {
          var element2 = this.element;
          var tagName = element2.tagName.toLowerCase();
          var url;
          if (element2[NAMESPACE]) {
            return;
          }
          element2[NAMESPACE] = this;
          if (tagName === "img") {
            this.isImg = true;
            url = element2.getAttribute("src") || "";
            this.originalUrl = url;
            if (!url) {
              return;
            }
            url = element2.src;
          } else if (tagName === "canvas" && window.HTMLCanvasElement) {
            url = element2.toDataURL();
          }
          this.load(url);
        },
      },
      {
        key: "load",
        value: function load(url) {
          var _this = this;
          if (!url) {
            return;
          }
          this.url = url;
          this.imageData = {};
          var element2 = this.element,
            options = this.options;
          if (!options.rotatable && !options.scalable) {
            options.checkOrientation = false;
          }
          if (!options.checkOrientation || !window.ArrayBuffer) {
            this.clone();
            return;
          }
          if (REGEXP_DATA_URL.test(url)) {
            if (REGEXP_DATA_URL_JPEG.test(url)) {
              this.read(dataURLToArrayBuffer(url));
            } else {
              this.clone();
            }
            return;
          }
          var xhr = new XMLHttpRequest();
          var clone = this.clone.bind(this);
          this.reloading = true;
          this.xhr = xhr;
          xhr.onabort = clone;
          xhr.onerror = clone;
          xhr.ontimeout = clone;
          xhr.onprogress = function () {
            if (xhr.getResponseHeader("content-type") !== MIME_TYPE_JPEG) {
              xhr.abort();
            }
          };
          xhr.onload = function () {
            _this.read(xhr.response);
          };
          xhr.onloadend = function () {
            _this.reloading = false;
            _this.xhr = null;
          };
          if (
            options.checkCrossOrigin &&
            isCrossOriginURL(url) &&
            element2.crossOrigin
          ) {
            url = addTimestamp(url);
          }
          xhr.open("GET", url, true);
          xhr.responseType = "arraybuffer";
          xhr.withCredentials = element2.crossOrigin === "use-credentials";
          xhr.send();
        },
      },
      {
        key: "read",
        value: function read(arrayBuffer) {
          var options = this.options,
            imageData = this.imageData;
          var orientation = resetAndGetOrientation(arrayBuffer);
          var rotate2 = 0;
          var scaleX2 = 1;
          var scaleY2 = 1;
          if (orientation > 1) {
            this.url = arrayBufferToDataURL(arrayBuffer, MIME_TYPE_JPEG);
            var _parseOrientation = parseOrientation(orientation);
            rotate2 = _parseOrientation.rotate;
            scaleX2 = _parseOrientation.scaleX;
            scaleY2 = _parseOrientation.scaleY;
          }
          if (options.rotatable) {
            imageData.rotate = rotate2;
          }
          if (options.scalable) {
            imageData.scaleX = scaleX2;
            imageData.scaleY = scaleY2;
          }
          this.clone();
        },
      },
      {
        key: "clone",
        value: function clone() {
          var element2 = this.element,
            url = this.url;
          var crossOrigin = element2.crossOrigin;
          var crossOriginUrl = url;
          if (this.options.checkCrossOrigin && isCrossOriginURL(url)) {
            if (!crossOrigin) {
              crossOrigin = "anonymous";
            }
            crossOriginUrl = addTimestamp(url);
          }
          this.crossOrigin = crossOrigin;
          this.crossOriginUrl = crossOriginUrl;
          var image = document.createElement("img");
          if (crossOrigin) {
            image.crossOrigin = crossOrigin;
          }
          image.src = crossOriginUrl || url;
          image.alt = element2.alt || "The image to crop";
          this.image = image;
          image.onload = this.start.bind(this);
          image.onerror = this.stop.bind(this);
          addClass(image, CLASS_HIDE);
          element2.parentNode.insertBefore(image, element2.nextSibling);
        },
      },
      {
        key: "start",
        value: function start2() {
          var _this2 = this;
          var image = this.image;
          image.onload = null;
          image.onerror = null;
          this.sizing = true;
          var isIOSWebKit =
            WINDOW.navigator &&
            /(?:iPad|iPhone|iPod).*?AppleWebKit/i.test(
              WINDOW.navigator.userAgent
            );
          var done = function done2(naturalWidth, naturalHeight) {
            assign(_this2.imageData, {
              naturalWidth,
              naturalHeight,
              aspectRatio: naturalWidth / naturalHeight,
            });
            _this2.initialImageData = assign({}, _this2.imageData);
            _this2.sizing = false;
            _this2.sized = true;
            _this2.build();
          };
          if (image.naturalWidth && !isIOSWebKit) {
            done(image.naturalWidth, image.naturalHeight);
            return;
          }
          var sizingImage = document.createElement("img");
          var body = document.body || document.documentElement;
          this.sizingImage = sizingImage;
          sizingImage.onload = function () {
            done(sizingImage.width, sizingImage.height);
            if (!isIOSWebKit) {
              body.removeChild(sizingImage);
            }
          };
          sizingImage.src = image.src;
          if (!isIOSWebKit) {
            sizingImage.style.cssText =
              "left:0;max-height:none!important;max-width:none!important;min-height:0!important;min-width:0!important;opacity:0;position:absolute;top:0;z-index:-1;";
            body.appendChild(sizingImage);
          }
        },
      },
      {
        key: "stop",
        value: function stop2() {
          var image = this.image;
          image.onload = null;
          image.onerror = null;
          image.parentNode.removeChild(image);
          this.image = null;
        },
      },
      {
        key: "build",
        value: function build() {
          if (!this.sized || this.ready) {
            return;
          }
          var element2 = this.element,
            options = this.options,
            image = this.image;
          var container = element2.parentNode;
          var template = document.createElement("div");
          template.innerHTML = TEMPLATE;
          var cropper = template.querySelector(
            ".".concat(NAMESPACE, "-container")
          );
          var canvas = cropper.querySelector(".".concat(NAMESPACE, "-canvas"));
          var dragBox = cropper.querySelector(
            ".".concat(NAMESPACE, "-drag-box")
          );
          var cropBox = cropper.querySelector(
            ".".concat(NAMESPACE, "-crop-box")
          );
          var face = cropBox.querySelector(".".concat(NAMESPACE, "-face"));
          this.container = container;
          this.cropper = cropper;
          this.canvas = canvas;
          this.dragBox = dragBox;
          this.cropBox = cropBox;
          this.viewBox = cropper.querySelector(
            ".".concat(NAMESPACE, "-view-box")
          );
          this.face = face;
          canvas.appendChild(image);
          addClass(element2, CLASS_HIDDEN);
          container.insertBefore(cropper, element2.nextSibling);
          removeClass(image, CLASS_HIDE);
          this.initPreview();
          this.bind();
          options.initialAspectRatio =
            Math.max(0, options.initialAspectRatio) || NaN;
          options.aspectRatio = Math.max(0, options.aspectRatio) || NaN;
          options.viewMode =
            Math.max(0, Math.min(3, Math.round(options.viewMode))) || 0;
          addClass(cropBox, CLASS_HIDDEN);
          if (!options.guides) {
            addClass(
              cropBox.getElementsByClassName("".concat(NAMESPACE, "-dashed")),
              CLASS_HIDDEN
            );
          }
          if (!options.center) {
            addClass(
              cropBox.getElementsByClassName("".concat(NAMESPACE, "-center")),
              CLASS_HIDDEN
            );
          }
          if (options.background) {
            addClass(cropper, "".concat(NAMESPACE, "-bg"));
          }
          if (!options.highlight) {
            addClass(face, CLASS_INVISIBLE);
          }
          if (options.cropBoxMovable) {
            addClass(face, CLASS_MOVE);
            setData(face, DATA_ACTION, ACTION_ALL);
          }
          if (!options.cropBoxResizable) {
            addClass(
              cropBox.getElementsByClassName("".concat(NAMESPACE, "-line")),
              CLASS_HIDDEN
            );
            addClass(
              cropBox.getElementsByClassName("".concat(NAMESPACE, "-point")),
              CLASS_HIDDEN
            );
          }
          this.render();
          this.ready = true;
          this.setDragMode(options.dragMode);
          if (options.autoCrop) {
            this.crop();
          }
          this.setData(options.data);
          if (isFunction(options.ready)) {
            addListener(element2, EVENT_READY, options.ready, {
              once: true,
            });
          }
          dispatchEvent(element2, EVENT_READY);
        },
      },
      {
        key: "unbuild",
        value: function unbuild() {
          if (!this.ready) {
            return;
          }
          this.ready = false;
          this.unbind();
          this.resetPreview();
          var parentNode = this.cropper.parentNode;
          if (parentNode) {
            parentNode.removeChild(this.cropper);
          }
          removeClass(this.element, CLASS_HIDDEN);
        },
      },
      {
        key: "uncreate",
        value: function uncreate() {
          if (this.ready) {
            this.unbuild();
            this.ready = false;
            this.cropped = false;
          } else if (this.sizing) {
            this.sizingImage.onload = null;
            this.sizing = false;
            this.sized = false;
          } else if (this.reloading) {
            this.xhr.onabort = null;
            this.xhr.abort();
          } else if (this.image) {
            this.stop();
          }
        },
        /**
         * Get the no conflict cropper class.
         * @returns {Cropper} The cropper class.
         */
      },
    ],
    [
      {
        key: "noConflict",
        value: function noConflict() {
          window.Cropper = AnotherCropper;
          return Cropper2;
        },
        /**
         * Change the default options.
         * @param {Object} options - The new default options.
         */
      },
      {
        key: "setDefaults",
        value: function setDefaults(options) {
          assign(DEFAULTS, isPlainObject(options) && options);
        },
      },
    ]
  );
  return Cropper2;
})();
assign(Cropper.prototype, render, preview, events, handlers, change, methods);
const resizeImageFromURL = async (url, newHeight) => {
  return new Promise((resolve, reject3) => {
    const img = new Image();
    img.src = url;
    img.crossOrigin = "Anonymous";
    img.onload = () => {
      const aspectRatio = img.width / img.height;
      const newWidth = newHeight * aspectRatio;
      const canvas = document.createElement("canvas");
      canvas.width = newWidth;
      canvas.height = newHeight;
      const ctx = canvas.getContext("2d");
      ctx.drawImage(img, 0, 0, newWidth, newHeight);
      canvas.toBlob((blob) => resolve(blob), "image/jpeg");
    };
    img.onerror = (err) => reject3(err);
  });
};
function create_if_block$4(ctx) {
  let div1;
  let img;
  let img_src_value;
  let t0;
  let div0;
  // let button0;
  let t1_value =
    /*isCroping*/
    ctx[2] ? "Saving..." : "Save";
  let t1;
  let t2;
  // let button1;
  let t3;
  let div1_class_value;
  let mounted;
  let dispose;
  return {
    c() {
      div1 = element("div");
      img = element("img");
      t0 = space();
      div0 = element("div");
      button0 = element("button");
      t1 = text$1(t1_value);
      t2 = space();
      cancelimagebutton1 = element("button");
      t3 = text$1("Cancel");
      attr(img, "class", "block max-w-full");
      attr(img, "alt", "cropper pic input");
      if (!src_url_equal(img.src, (img_src_value = /*imageUrl*/ ctx[0])))
        attr(img, "src", img_src_value);
      attr(img, "crossorigin", "");
      attr(button0, "type", "button");
      button0.disabled = /*isCroping*/ ctx[2];
      attr(button0, "class", "!text-sm !py-2 !p-4 button SaveButton");
      attr(cancelimagebutton1, "type", "button");
      cancelimagebutton1.disabled = /*isCroping*/ ctx[2];
      attr(
        cancelimagebutton1,
        "class",
        "!text-sm py-2 p-4 hover:text-red-500 select-none CanButton"
      );
      attr(div0, "class", "flex items-center justify-center pt-4");
      attr(
        div1,
        "class",
        (div1_class_value =
          "h-full w-full " /*isLoading*/ + (ctx[3] ? "invisible" : "visible"))
      );
    },
    m(target, anchor) {
      insert(target, div1, anchor);
      append(div1, img);
      ctx[7](img);
      append(div1, t0);
      append(div1, div0);
      append(div0, button0);
      append(button0, t1);
      append(div0, t2);
      append(div0, cancelimagebutton1);
      append(cancelimagebutton1, t3);
      if (!mounted) {
        dispose = [
          listen(button0, "click", async () => {
            // validated_image = true;
            button0.disabled = true;
          }),
          listen(
            button0,
            "click",
            /*getCroppedValue*/
            ctx[4]
          ),
          listen(
            cancelimagebutton1,
            "click",
            /*click_handler*/
            ctx[6]
          ),
        ];
        mounted = true;
      }
    },
    p(ctx2, dirty) {
      if (
        dirty /*imageUrl*/ & 1 &&
        !src_url_equal(img.src, (img_src_value = /*imageUrl*/ ctx2[0]))
      ) {
        attr(img, "src", img_src_value);
      }
      if (
        dirty /*isCroping*/ & 4 &&
        t1_value !== (t1_value = /*isCroping*/ ctx2[2] ? "Saving..." : "Save")
      )
        set_data(t1, t1_value);
      if (dirty /*isCroping*/ & 4) {
        button0.disabled = /*isCroping*/ ctx2[2];
      }
      if (dirty /*isCroping*/ & 4) {
        cancelimagebutton1.disabled = /*isCroping*/ ctx2[2];
      }
      if (
        dirty /*isLoading*/ & 8 &&
        div1_class_value !==
          (div1_class_value =
            "h-full w-full " /*isLoading*/ +
            (ctx2[3] ? "invisible" : "visible"))
      ) {
        attr(div1, "class", div1_class_value);
      }
    },
    d(detaching) {
      if (detaching) detach(div1);
      ctx[7](null);
      mounted = false;
      run_all(dispose);
    },
  };
}
function create_fragment$8(ctx) {
  let if_block_anchor;
  let if_block =
    /*imageUrl*/
    ctx[0] && create_if_block$4(ctx);
  return {
    c() {
      if (if_block) if_block.c();
      if_block_anchor = empty();
    },
    m(target, anchor) {
      if (if_block) if_block.m(target, anchor);
      insert(target, if_block_anchor, anchor);
    },
    p(ctx2, [dirty]) {
      if (
        /*imageUrl*/
        ctx2[0]
      ) {
        if (if_block) {
          if_block.p(ctx2, dirty);
        } else {
          if_block = create_if_block$4(ctx2);
          if_block.c();
          if_block.m(if_block_anchor.parentNode, if_block_anchor);
        }
      } else if (if_block) {
        if_block.d(1);
        if_block = null;
      }
    },
    i: noop$1,
    o: noop$1,
    d(detaching) {
      if (if_block) if_block.d(detaching);
      if (detaching) detach(if_block_anchor);
    },
  };
}


function instance$7($$self, $$props, $$invalidate) {
  // ... existing variable declarations ...
  var _a2;
  let { imageUrl = null } = $$props;
  let { isVertical = false } = $$props;
  let cropper;
  let imageNode;
  let isCroping = false;
  let isLoading = true;
  // const uid =
  //   (_a2 = auth == null ? void 0 : auth.currentUser) == null ? void 0 : _a2.uid;
  const uid = { currentUser: { uid: generateSimpleId() } };
  const dispatch2 = createEventDispatcher();
  


  const getCroppedValue = async () => {
  
    if (!uid) return;
    if (cropper.cropBoxData.width > cropper.cropBoxData.height)
      isVertical = false;
    else if(cropper.cropBoxData.width < cropper.cropBoxData.height)
     isVertical = true;
    else
      isVertical = "square";
    button0.disabled = true;
    $$invalidate(2, (isCroping = true));

    // cropper.getCroppedCanvas().toBlob(async (blob) => {
    //   $$invalidate(2, (isCroping = true));

    //   const isUserImage = true;
      
    //   const savedImage = { src: blob, isVertical };
     
    //   croppedImageBinary = blob;
    //   finalIsVertical = isVertical;
    //   $$invalidate(2, (isCroping = false));
    //   advanceButton.classList.remove("hidden");
    
    //   return dispatch2("save", { value: savedImage });
    // });
    cropper.getCroppedCanvas().toBlob(
      async (blob) => {
          $$invalidate(2, (isCroping = true));

          const isUserImage = true;

          const savedImage = { src: blob, isVertical };

          croppedImageBinary = blob;
          finalIsVertical = isVertical;
          $$invalidate(2, (isCroping = false));
          advanceButton.classList.remove("hidden");
          
          // console.log("getCroppedCanvas finalIsVertical--------------", finalIsVertical)
          return dispatch2("save", { value: savedImage });
        },
        "image/jpeg", // force JPEG instead of default PNG
        0.8           // quality (0–1, try 0.7–0.9 for good balance)
    );

  };
  
   function initializeCropper(isVerticalCustom = false) {
   
    // console.log("v-----------------before--", isVerticalCustom)
    if(updated_is_vertical=="square"){

      isVerticalCustom = 3;
    }else if(Boolean(updated_is_vertical)){
      isVerticalCustom = 1
    }else if(!Boolean(updated_is_vertical)){
      isVerticalCustom = 2
    }
    let v = false;
    if (isVerticalCustom && isVerticalCustom == 1) v = true;
    else if (isVerticalCustom && isVerticalCustom == 2) v = false;
    else if (isVerticalCustom && isVerticalCustom == 3) v = "square";
    if (cropper) cropper.destroy();
    // console.log("v-------------------", v)
    if (imageNode) {
      let ratio = 1/1
      if(v && v!="square"){
        ratio = 3 / 4
      }else if(!v){
        ratio = 4 / 3
      }
      // console.log("ratio--------------", ratio)
      cropper = new Cropper(imageNode, {
        viewMode: 1,
        dragMode: "move",
        checkCrossOrigin: false,
        aspectRatio: ratio,
        ready() {
          $$invalidate(3, (isLoading = false));
        },
      });
    }
  }

  // Expose the function
  $$self.initializeCropper = initializeCropper;

  // Initialize on mount
  onMount(() => {
    // alert("mmmmm")
    initializeCropper();
    return () => cropper?.destroy();
  });
  // Add reactive statement for aspect ratio changes
  $: if ($$props.isVertical !== undefined) {
    initializeCropper();
  }
  // onDestroy(() => cropper.destroy());
  function click_handler(event) {
    bubble.call(this, $$self, event);
  }
  function img_binding($$value) {
    binding_callbacks[$$value ? "unshift" : "push"](() => {
      imageNode = $$value;
      $$invalidate(1, imageNode);
    });
  }
  $$self.$$set = ($$props2) => {
    if ("imageUrl" in $$props2) $$invalidate(0, (imageUrl = $$props2.imageUrl));
    if ("isVertical" in $$props2)
      $$invalidate(5, (isVertical = $$props2.isVertical));
  };

  return [
    imageUrl,
    imageNode,
    isCroping,
    isLoading,
    getCroppedValue,
    isVertical,
    click_handler,
    img_binding,
  ];
  // ... rest of your existing code ...
}
class Cropper_1 extends SvelteComponent {
  constructor(options) {
    super();
    init(this, options, instance$7, create_fragment$8, safe_not_equal, {
      imageUrl: 0,
      isVertical: 5,
    });
  }
}
// function create_else_block$2(ctx) {
//   let img;
//   return {
//     c() {
//       img = element("img");
//       img.src =
//         "https://cdn.shopify.com/s/files/1/0736/6996/8165/files/Frame_5265.svg?v=1751372390"; // ← Replace with actual image path
//       img.alt = "Upload image";
//       img.style.width = "184px";
//       img.style.height = "100%";
//     },
//     m(target, anchor) {
//       insert(target, img, anchor);
//     },
//     p: noop$1,
//     d(detaching) {
//       if (detaching) detach(img);
//     },
//   };
// }
function create_else_block$2(ctx) {

  let img;
  return {
    c() {

      if(formDetailHistory && formDetailHistory.imageUrl){
        img = element("img");
        img.src = formDetailHistory.imageUrl;
        // "https://cdn.shopify.com/s/files/1/0736/6996/8165/files/Frame_5265.svg?v=1751372390"; // ← Replace with actual image path
        img.alt = "Upload image ";
        img.style.width = "45px";
      }else{

        img = element("img");
        img.src = 
          "https://cdn.shopify.com/s/files/1/0736/6996/8165/files/Frame_5265.svg?v=1751372390"; // ← Replace with actual image path
        img.alt = "Upload image ";
        img.style.width = "184px";
        img.style.height = "100%";
      }

    },
    m(target, anchor) {
      insert(target, img, anchor);
    },
    p: noop$1,
    d(detaching) {
      if (detaching) detach(img);
    },
  };
}
function create_if_block_1$1(ctx) {
 
  let div;
  let fileName = /*file*/ ctx[0]?.name || "No file selected";
  let fileUrl = /*blobUrl*/ ctx[7];
  let t0; // File name
  let img; // Image element
  if (croppedImageBinary) {
      fileUrl = URL.createObjectURL(croppedImageBinary); // Create a temporary URL
      croppedImageBinary = false

  }
  
  return {
    c() {
      div = element("div");
      t0 = text$1("File: " + fileName);
      img = element("img");

      // If blobUrl is available use it, otherwise use dummy placeholder
      attr(img, "src", fileUrl || "https://cdn.shopify.com/s/files/1/0736/6996/8165/files/Frame_5265_8f635f71-7027-494a-9eb2-f0f976438f7a.png?v=1754895841");
      attr(img, "alt", "Preview");
      attr(img, "class", "w-32 h-32 object-cover mt-2 border ddddd");
       attr(img, "width", "45");

      attr(div, "class", "text-sm text-gray-500");
    },
    m(target, anchor) {
      insert(target, div, anchor);
      append(div, t0);
      append(div, img);
    },
    p(ctx2, dirty) {
       if (dirty & /*blobUrl*/ 128) {
        attr(img, "src", ctx2[7] || "https://cdn.shopify.com/s/files/1/0736/6996/8165/files/Frame_5265_8f635f71-7027-494a-9eb2-f0f976438f7a.png?v=1754895841");
      }
      if (dirty & /*file*/ 1 && fileName !== (fileName = /*file*/ ctx2[0]?.name || "No file selected")) {
        set_data(t0, "File: " + fileName);
      }
     
    },
    d(detaching) {
      if (detaching) detach(div);
    },
  };
}

// function create_if_block_1$1(ctx) {
//   let t_value =
//     /*file*/
//     ctx[0].name + "";
//   let t;
//   return {
//     c() {
//       t = text$1(t_value);
//     },
//     m(target, anchor) {
//       insert(target, t, anchor);
//     },
//     p(ctx2, dirty) {
//       if (
//         dirty /*file*/ & 1 &&
//         t_value !== (t_value = /*file*/ ctx2[0].name + "")
//       )
//         set_data(t, t_value);
//     },
//     d(detaching) {
//       if (detaching) detach(t);
//     },
//   };
// }
function create_fragment$7(ctx) {
  let div1;
  let input;
  let t;
  let div0;
  let label;
  let div0_class_value;
  let mounted;
  let dispose;
  
    function select_block_type(ctx2, dirty) {
    if (
      /*file*/
      ctx2[0]
    ){
      // if(!validated_image) validateImage(ctx2)
      return create_if_block_1$1;
    }
    return create_else_block$2;
  }
  let current_block_type = select_block_type(ctx);
  let if_block = current_block_type(ctx);
  return {
    c() {
      div_message = element("div");
      attr(div_message, "class", "py-2 disk2");
      p_message = element("p");
      attr(p_message, "class", "text-xs md:text-sm");
      t__message = text$1("");

      div1 = element("div");
      input = element("input");
      t = space();
      div0 = element("div");
      label = element("label");
      if_block.c();
      attr(input, "type", "file");
      attr(input, "accept", "image/*");  // ADD
      attr(input, "id", "fileInput");
      attr(
        input,
        "class",
        "absolute opacity-0 w-full h-full cursor-pointer nnz"
      );
      attr(label, "for", "fileInput");
      attr(label, "class", "cursor-pointer");
      attr(
        div0,
        "class",
        (div0_class_value =
          "bg-gray-50 " /*isFocused*/ +
          (ctx[2] ? "border-gray-700" : "border-gray-400") +
          " text-sm text-gray-500 border-2 body border-dashed md:h-20 h-14 flex items-center justify-center text-right cursor-pointer m-0 active:border-gray-700 hover:border-gray-60 rounded-md")
      );
      attr(div1, "class", "relative group ");
    },
    m(target, anchor) {
      insert(target, div1, anchor);

      append(div1, input);
      append(div1, input);
      ctx[4](input);
      append(div1, t);
      append(div1, div0);
      append(div0, label);

      append(div1, div_message);
      append(div_message, p_message);
      append(p_message, t__message);

      if_block.m(label, null);
      if (!mounted) {
        dispose = [
          listen(
            input,
            "change",
            /*onFileSelected*/
            ctx[3]
          ),
          listen(
            div1,
            "dragenter",
            /*dragenter_handler*/
            ctx[5]
          ),
          listen(
            div1,
            "dragleave",
            /*dragleave_handler*/
            ctx[6]
          ),
        ];
        mounted = true;
      }
    },
    p(ctx2, [dirty]) {
      if (
        current_block_type === (current_block_type = select_block_type(ctx2)) &&
        if_block
      ) {
        if_block.p(ctx2, dirty);
      } else {
        if_block.d(1);
        if_block = current_block_type(ctx2);
        if (if_block) {
          if_block.c();
          if_block.m(label, null);
        }
      }
      if (
        dirty /*isFocused*/ & 4 &&
        div0_class_value !==
          (div0_class_value =
            "bg-gray-50 " /*isFocused*/ +
            (ctx2[2] ? "border-gray-700" : "border-gray-400") +
            " text-sm text-gray-500 border-2 body border-dashed md:h-20 h-14 flex items-center justify-center text-right cursor-pointer m-0 active:border-gray-700 hover:border-gray-60 rounded-md")
      ) {
        attr(div0, "class", div0_class_value);
      }
    },
    i: noop$1,
    o: noop$1,
    d(detaching) {
      if (detaching) detach(div1);
      ctx[4](null);
      if_block.d();
      mounted = false;
      run_all(dispose);
    },
  };
}
function instance$6($$self, $$props, $$invalidate) {
  let fileinput;
  let { file = null } = $$props;
  let isFocused = false;
  let blobUrl = null; // State to store the Blob URL
  const dispatch2 = createEventDispatcher();

  const onFileSelected = (event) => {
    const selectedFile = event.target.files[0];
    if (!selectedFile) {
      console.error("No file selected");
      return;
    }

    $$invalidate(0, (file = selectedFile)); // Update file state
    const reader = new FileReader();

    reader.onloadend = () => {
        const blob = new Blob([reader.result], { type: selectedFile.type });
        const url = URL.createObjectURL(blob);

        $$invalidate(7, (blobUrl = url)); // Update blobUrl state

        dispatch2("read", { value: url }); // Dispatch event for other components
        validated_image = "in progress";
       
        // image_validation_error = ""
        // validated_image = true
        const formData = new FormData();
        formData.append("imageUrl", blob, "image.png"); // Append the blob with a filename
        // https://webhook.wallart.ai
        fetch("https://webhook.wallart.ai/validateImage", {
          method: "POST",
          body: formData,
        }).then((response) => response.json()).then((data) => {
            
            if(!data.allowed){
              image_validation_error = data.message
              validated_image = false
            }else{
              image_validation_error = ""
              validated_image = true
            }
        });
      };

      reader.onerror = (error) => {
        console.error("FileReader error:", error);
        alert("Failed to read the file. Try refreshing the page.");
      };

      reader.readAsArrayBuffer(selectedFile);
  };

  function input_binding($$value) {
    binding_callbacks[$$value ? "unshift" : "push"](() => {
      fileinput = $$value;
      $$invalidate(1, fileinput);
    });
  }

  const dragenter_handler = () => $$invalidate(2, (isFocused = true));
  const dragleave_handler = () => $$invalidate(2, (isFocused = false));

  $$self.$$set = ($$props2) => {
    if ("file" in $$props2) $$invalidate(0, (file = $$props2.file));
  };

  return [
    file,
    fileinput,
    isFocused,
    onFileSelected,
    input_binding,
    dragenter_handler,
    dragleave_handler,
    blobUrl, // Ensure blobUrl is at index 7
  ];
}
class FileUpload extends SvelteComponent {
  constructor(options) {
    super();
    init(this, options, instance$6, create_fragment$7, safe_not_equal, {
      file: 0,
    });
  }
}
function create_if_block_1(ctx) {
  let div1;
  let div0;
  // let cropper;
  let span;  // ADD
  let current;
  let cropperRef;
  // console.log("create_if_block_1--------------------------", ctx[0])
  cropper = new Cropper_1({
    props: {
      imageUrl: ctx[3].src,
      isVertical: ctx[0],
    },
    $$inline: true,
  });

  // Store reference to access methods
  cropper.$on("mount", () => {
    cropperRef = cropper;
  });

  cropper.$on("click", ctx[6]);
  cropper.$on("save", ctx[4]);

  return {
c() {
  div1 = element("div");
  div0 = element("div");
  span = element("span");                                    // ADD
  create_component(cropper.$$.fragment);
  attr(span, "class", "croptext");  
  attr(div0, "class", "h-[18rem] w-full max-w-[15rem] mx-auto");
                         // ADD - apni class likho
  span.textContent = "Crop image as desired and click save."; // ADD
  attr(div1, "class", "mb-8 p-8 bg-gray-100 border pb-16 rounded-lg");
},
   m(target, anchor) {
  insert(target, div1, anchor);
   append(div1, span);  // ADD
  append(div1, div0);
  mount_component(cropper, div0, null);
 
  current = true;
},
    p(ctx2, dirty) {
      const cropper_changes = {};
      if (dirty & 8) cropper_changes.imageUrl = ctx2[3].src;
      if (dirty & 1) {
        // console.log("ssssssssssssssss ctx2[0]", ctx2[0])
        cropper_changes.isVertical = ctx2[0];
        // Force reinitialization when orientation changes
        if (cropperRef && cropperRef.initializeCropper) {
          cropperRef.initializeCropper();
        }
      }
      cropper.$set(cropper_changes);
    },
    i(local) {
      if (current) return;
      transition_in(cropper.$$.fragment, local);
      current = true;
    },
    o(local) {
      transition_out(cropper.$$.fragment, local);
      current = false;
    },
    d(detaching) {
      if (detaching) detach(div1);
      destroy_component(cropper);
    },
  };
}

function create_if_block$3(ctx) {
  let fileupload;
  let updating_file;
  let current;
  function fileupload_file_binding(value) {
    ctx[9](value);
  }
  let fileupload_props = {};
  if (
    /*file*/
    ctx[1] !== void 0
  ) {
    fileupload_props.file = /*file*/ ctx[1];
  }
  fileupload = new FileUpload({ props: fileupload_props });
  binding_callbacks.push(() =>
    bind$2(fileupload, "file", fileupload_file_binding)
  );
  fileupload.$on(
    "read",
    /*setImageFromFileUpload*/
    ctx[5]
  );
  return {
    c() {
      create_component(fileupload.$$.fragment);
    },
    m(target, anchor) {
      mount_component(fileupload, target, anchor);
      current = true;
    },
    p(ctx2, dirty) {
      const fileupload_changes = {};
      if (!updating_file && dirty /*file*/ & 2) {
        updating_file = true;
        fileupload_changes.file = /*file*/ ctx2[1];
        add_flush_callback(() => (updating_file = false));
      }
      fileupload.$set(fileupload_changes);
    },
    i(local) {
      if (current) return;
      transition_in(fileupload.$$.fragment, local);
      current = true;
    },
    o(local) {
      transition_out(fileupload.$$.fragment, local);
      current = false;
    },
    d(detaching) {
      destroy_component(fileupload, detaching);
    },
  };
}
function create_fragment$6(ctx) {
  let t;
  let if_block1_anchor;
  let current;
  let if_block0 =
    /*isOpen*/
    ctx[2] && create_if_block_1(ctx);
  let if_block1 = !(/*isOpen*/ ctx[2]) && create_if_block$3(ctx);
  return {
    c() {
      if (if_block0) if_block0.c();
      t = space();
      if (if_block1) if_block1.c();
      if_block1_anchor = empty();
    },
    m(target, anchor) {
      if (if_block0) if_block0.m(target, anchor);
      insert(target, t, anchor);
      if (if_block1) if_block1.m(target, anchor);
      insert(target, if_block1_anchor, anchor);
      current = true;
    },
    p(ctx2, [dirty]) {
      if (
        /*isOpen*/
        ctx2[2]
      ) {
        if (if_block0) {
          if_block0.p(ctx2, dirty);
          if (dirty /*isOpen*/ & 4) {
            transition_in(if_block0, 1);
          }
        } else {
          if_block0 = create_if_block_1(ctx2);
          if_block0.c();
          transition_in(if_block0, 1);
          if_block0.m(t.parentNode, t);
        }
      } else if (if_block0) {
        group_outros();
        transition_out(if_block0, 1, 1, () => {
          if_block0 = null;
        });
        check_outros();
      }
      if (!(/*isOpen*/ ctx2[2])) {
        if (if_block1) {
          if_block1.p(ctx2, dirty);
          if (dirty /*isOpen*/ & 4) {
            transition_in(if_block1, 1);
          }
        } else {
          if_block1 = create_if_block$3(ctx2);
          if_block1.c();
          transition_in(if_block1, 1);
          if_block1.m(if_block1_anchor.parentNode, if_block1_anchor);
        }
      } else if (if_block1) {
        group_outros();
        transition_out(if_block1, 1, 1, () => {
          if_block1 = null;
        });
        check_outros();
      }
    },
    i(local) {
      if (current) return;
      transition_in(if_block0);
      transition_in(if_block1);
      current = true;
    },
    o(local) {
      transition_out(if_block0);
      transition_out(if_block1);
      current = false;
    },
    d(detaching) {
      if (if_block0) if_block0.d(detaching);
      if (detaching) detach(t);
      if (if_block1) if_block1.d(detaching);
      if (detaching) detach(if_block1_anchor);
    },
  };
}
function instance$5($$self, $$props, $$invalidate) {
  let { isVertical = false } = $$props;
  let { hasUserUploadedImage } = $$props;
  let file;
  let isOpen = false;
  let image = null;
  let { userImageUrl = null } = $$props;
  const setImageValueFromCanvas = ({ detail: { value } }) => {
    get_image_detail = "in progress";
    
    inprogressimageid = `${Date.now().toString(36) + Math.random().toString(36).slice(2)}_${value.isVertical}`
    generate_image_description = false;
    image_detail = ""
    
    const { src, isVertical: isVertical2 } = value;
    const croppedImage = { src, isVertical: isVertical2 };
    
    const formData = new FormData();
    formData.append("imageUrl", croppedImage.src, "image.png");
    
    fetch("https://webhook.wallart.ai/getImageDetail", {
      method: "POST",
      body: formData,
    }).then((response) => response.json()).then((data) => {
        get_image_detail = true
        
        image_detail = data.imagedetail
        image_detail["imageid"] = inprogressimageid
        // console.log(image_detail)
        image_detail_array.push({
          [image_detail.imageid]: image_detail
        });
        // console.log("image_detail_array---------", image_detail_array)
        // inprogressimageid = false
        saveImageToBucket(image_detail.imageid, croppedImage.src,"fhjugurgyuy", $$invalidate);
        return image_detail;
    })



    $$invalidate(2, (isOpen = false));
    $$invalidate(3, (image = croppedImage));
    $$invalidate(7, (hasUserUploadedImage = true));
    $$invalidate(8, (userImageUrl = src));
    
    return;
  };
  const setImageFromFileUpload = ({ detail: { value } }) => {
    $$invalidate(2, (isOpen = false));
    $$invalidate(2, (isOpen = true));
    $$invalidate(3, (image = { src: value, isVertical: true }));
  };
  const closeCropper = () => (
    $$invalidate(2, (isOpen = false)),
    $$invalidate(1, (file = null)),
    $$invalidate(7, (hasUserUploadedImage = false))
  );
  function fileupload_file_binding(value) {
    file = value;
    $$invalidate(1, file);
  }
  $$self.$$set = ($$props2) => {
    if ("isVertical" in $$props2)
      $$invalidate(0, (isVertical = $$props2.isVertical));
    if ("hasUserUploadedImage" in $$props2)
      $$invalidate(7, (hasUserUploadedImage = $$props2.hasUserUploadedImage));
    if ("userImageUrl" in $$props2)
      $$invalidate(8, (userImageUrl = $$props2.userImageUrl));
  };
  return [
    isVertical,
    file,
    isOpen,
    image,
    setImageValueFromCanvas,
    setImageFromFileUpload,
    closeCropper,
    hasUserUploadedImage,
    userImageUrl,
    fileupload_file_binding,
  ];
}
class ImageToImage extends SvelteComponent {
  constructor(options) {
    super();

    init(this, options, instance$5, create_fragment$6, safe_not_equal, {
      isVertical: 0,
      hasUserUploadedImage: 7,
      userImageUrl: 8,
    });
  }
}
function get_each_context$1(ctx, list, i) {
  const child_ctx = ctx.slice();
  child_ctx[24] = list[i];
  return child_ctx;
}
function create_else_block$1(ctx) {
  let div2;
  let imagetoimage;
  let updating_userImageUrl;
  let updating_hasUserUploadedImage;
  let t0;
  let div1;
  let select5; // Dropdown
  let t_select; // Spacer after dropdown
  // let advanceButton; // New "Advance Options" button
  let t_advance; // Spacer after advance button
  let input; // Textarea
  let t_input; // Spacer after textarea
  let button; // Existing button with 💡
  let p; // Paragraph inside button
  let t_button; // Spacer after button
  let div0; // Description div
  let current;
  let mounted;
  let dispose;
  // let checkboxWrapper ;
      

  // Track the selected dropdown value explicitly
  let selectedContent = "human"; // Default value
  // Track visibility of advanced options
  let showAdvancedOptions = false; // Hidden by default
  if(formDetailHistory && formDetailHistory.imageUrl){ 
    showAdvancedOptions = true;
    preloadedimageurl = formDetailHistory.imageUrl;
  }
  function imagetoimage_userImageUrl_binding(value) {
    ctx[19](value);
  }
  function imagetoimage_hasUserUploadedImage_binding(value) {
    ctx[20](value);
  }

  let imagetoimage_props = {};
  if (/*userImageUrl*/ ctx[3] !== void 0) {
    imagetoimage_props.userImageUrl = /*userImageUrl*/ ctx[3];
  }
  if (/*hasUserUploadedImage*/ ctx[8] !== void 0) {
    imagetoimage_props.hasUserUploadedImage = /*hasUserUploadedImage*/ ctx[8];
  }
  // console.log("aaaaaaaaaaaaaaaaa-----------ctx[0]--", ctx[0])
  imagetoimage_props.isVertical = /*isvertical*/ ctx[0];
  updated_is_vertical = ctx[0];

  imagetoimage = new ImageToImage({ props: imagetoimage_props });
  binding_callbacks.push(() =>
    bind$2(imagetoimage, "userImageUrl", imagetoimage_userImageUrl_binding)
  );
  binding_callbacks.push(() =>
    bind$2(
      imagetoimage,
      "hasUserUploadedImage",
      imagetoimage_hasUserUploadedImage_binding
    )
  );

  // Sample JSON data for dropdown options
  const dropdownOptions = [
    { id: "style1", name: "Person", value: "human" },
    { id: "style2", name: "Animal", value: "animal" },
    { id: "style3", name: "Other", value: "other" },
  ];

  return {
    c() {
      let imagefromimagesuggestionarray = [];
      imagefromimagesuggestionarray = imagefromimagesuggestion.split("|");
      let placeholderprompts = imagefromimagesuggestionarray.length
        ? imagefromimagesuggestionarray[0]
        : "e.g add cowboy hat";

      div2 = element("div");
      create_component(imagetoimage.$$.fragment);
      t0 = space();
      div1 = element("div");

      select5 = element("select");
      dropdownOptions.forEach((option) => {
        const opt = element("option");
        opt.textContent = option.name;
        opt.value = option.value;
        append(select5, opt);
      });
      select5.style.display = "none";
      t_select = space();

      advanceButton = element("button");
      if(showAdvancedOptions){
        advanceButton.textContent = "Hide Advanced Options";
      }else{

        advanceButton.textContent = "✎ Advanced Options";
      }
      t_advance = space();

      // ✅ Checkbox container
         checkboxWrapper = element("div");
        //  //-----------------varied composition----------------------------------
        // variedcheckbox = element("input");
        // variedcheckbox.checked = false;
        // if(showAdvancedOptions && formDetailHistory && formDetailHistory.createcompositionsame==false) variedcheckbox.checked = true
        // else if(showAdvancedOptions && formDetailHistory && formDetailHistory.createcompositionsame==true) variedcheckbox.checked = false
        // variedcheckboxLabel = element("label");
        // attr(variedcheckbox, "type", "checkbox");
        // attr(variedcheckbox, "id", "varied-composition");
        // attr(variedcheckbox, "class", "mr-2 cursor-pointer");
        // variedcheckboxLabel.setAttribute("for", "varied-composition");
        // variedcheckboxLabel.textContent = "Varied Composition";
        // attr(variedcheckboxLabel, "class", "text-sm labels");
        // //-----------------same composition----------------------------------

        //  compositioncheckbox = element("input");
        //  compositioncheckbox.checked = true
        //  if(showAdvancedOptions && formDetailHistory && formDetailHistory.createcompositionsame==true) compositioncheckbox.checked = true
        //  else if(showAdvancedOptions && formDetailHistory && formDetailHistory.createcompositionsame==false) compositioncheckbox.checked = false
        //  compositioncheckboxLabel = element("label");

        // attr(compositioncheckbox, "type", "checkbox");
        // attr(compositioncheckbox, "id", "same-composition");
        // attr(compositioncheckbox, "class", "mr-2 cursor-pointer");

        // compositioncheckboxLabel.setAttribute("for", "same-composition");
        // compositioncheckboxLabel.textContent = "Same Composition";
        // attr(compositioncheckboxLabel, "class", "text-sm labels");
        //  //-----------------same composition----------------------------------
        // append(checkboxWrapper, compositioncheckbox);
        // append(checkboxWrapper, compositioncheckboxLabel);
        // //------------------------varied composition--------------------------
        // append(checkboxWrapper, variedcheckbox);
        // append(checkboxWrapper, variedcheckboxLabel);


      //-----------------varied composition----------------------------------
let compositionLabel = element("label");
compositionLabel.textContent = "Composition :";
attr(compositionLabel, "class", "text-sm labels paddlefnone");

variedcheckbox = element("input");
attr(variedcheckbox, "type", "radio");
attr(variedcheckbox, "name", "composition"); // SAME NAME
attr(variedcheckbox, "id", "varied-composition");
attr(variedcheckbox, "class", "mr-2 cursor-pointer cst-mladjustradio");

if (showAdvancedOptions && formDetailHistory && formDetailHistory.createcompositionsame == false) {
    variedcheckbox.checked = true;
}

variedcheckboxLabel = element("label");
variedcheckboxLabel.setAttribute("for", "varied-composition");
variedcheckboxLabel.textContent = "Varied";
attr(variedcheckboxLabel, "class", "text-sm labels");

//-----------------same composition----------------------------------
compositioncheckbox = element("input");
attr(compositioncheckbox, "type", "radio");
attr(compositioncheckbox, "name", "composition"); // SAME NAME
attr(compositioncheckbox, "id", "same-composition");
attr(compositioncheckbox, "class", "mr-2 cursor-pointer cst-mladjustradio");

if (!formDetailHistory || formDetailHistory.createcompositionsame == true) {
    compositioncheckbox.checked = true;
}

compositioncheckboxLabel = element("label");
compositioncheckboxLabel.setAttribute("for", "same-composition");
compositioncheckboxLabel.textContent = "Same";
attr(compositioncheckboxLabel, "class", "text-sm labels");


//-----------------append----------------------------------

append(checkboxWrapper, compositionLabel);


append(checkboxWrapper, compositioncheckbox);
append(checkboxWrapper, compositioncheckboxLabel);

append(checkboxWrapper, variedcheckbox);
append(checkboxWrapper, variedcheckboxLabel);
//----------------------------------------------------------------------------


        if(showAdvancedOptions) attr(checkboxWrapper, "class", "flex items-center mb-2");
        else attr(checkboxWrapper, "class", "flex items-center mb-2 hidden");

      input = element("textarea");
      t_input = space();

      button = element("button");
      button.innerHTML = `<p class="text-lg"><img src="https://cdn.shopify.com/s/files/1/0736/6996/8165/files/editcustomicon.jpg?v=1764146029"></p>`;
      // p = element("p");
      // p.textContent = "💡";
      // p.textContent =`<img src="https://cdn.shopify.com/s/files/1/0736/6996/8165/files/editcustomicon.jpg?v=1764146029"></p>`
      t_button = space();

      div0 = element("span");
      div0.innerHTML = `<span style="font-size: 13px; text-align: left; display: block;">
  Describe any desired changes(optional)
</span>`;

      attr(select5, "class", "select border-gray-400 w-full mb-4");
      attr(select5, "id", "image-content-value");
      attr(select5, "required", "required");
      select5.disabled = /*isLoading*/ ctx[6];

      attr(input, "row", "8");
      // input.disabled = /*isLoading*/ ctx[6];
      attr(input, "placeholder", placeholderprompts);
      attr(
        input,
        "class",
        "textarea !border-1 md:min-h-[3rem] min-h-[1.5rem] border-gray-400 lxmd cxzxc"
      );

      attr(advanceButton, "type", "button");
      if(showAdvancedOptions){
        attr(
           advanceButton,
           "class",
           "rounded-md active:bg-blue-200 flex items-center justify-center bg-blue-50 px-0 mb-2 hovehideshow"
         );
       }else{

         attr(
           advanceButton,
           "class",
           "rounded-md active:bg-blue-200 flex items-center justify-center bg-blue-50 px-0 mb-2 hovehideshow hidden"
         );
       }

      attr(button, "type", "button");
      attr(
        button,
        "class",
        "h-8 w-8 rounded-full active:bg-yellow-200 cursor-pointer flex items-center justify-center bg-yellow-50 border-solid border-[1px] border-yellow-400 bpst"
      );
      // attr(p, "class", "text-lg");

      // Set initial visibility for advanced options
      input.style.display = showAdvancedOptions ? "block" : "none";
      button.style.display = showAdvancedOptions ? "block" : "none";
      div0.style.display = showAdvancedOptions ? "block" : "none";

      if (selectedContent === "other") {
        attr(input, "placeholder", "e.g A bright red apple on a white background");
      } else if (selectedContent === "human") {
        attr(input, "placeholder", placeholderprompts);
      }
      // Conditional visibility based on dropdown
      input.style.display =
        selectedContent === "human" || selectedContent === "other"
          ? showAdvancedOptions
            ? "block"
            : "none"
          : "none";
      button.style.display =
        selectedContent === "human" || selectedContent === "other"
          ? showAdvancedOptions
            ? "block"
            : "none"
          : "none";
      div0.style.display =
        selectedContent === "human" || selectedContent === "other"
          ? showAdvancedOptions
            ? "block"
            : "none"
          : "none";

      attr(div0, "class", "py-2 disk2 text-left");
      attr(div1, "class", "relative mt-4 md:scale-100 scale-[0.98]");
    },
    m(target, anchor) {
      insert(target, div2, anchor);
      mount_component(imagetoimage, div2, null);
      append(div2, t0);
      append(div2, div1);

      append(div1, select5);
      append(div1, t_select);
      append(div1, advanceButton);
     
      append(div1, t_advance);
       append(div1, checkboxWrapper);
      append(div1, div0);
      append(div1, input);
      append(div1, t_input);
      append(div1, button);
      // append(button, p);
      append(div1, t_button);

      // set_input_value(input, /*prompt*/ ctx[2]);
      if(formDetailHistory && formDetailHistory.prompt ){ 
        set_input_value(input, /*prompt*/ formDetailHistory.prompt);
      }else{
        set_input_value(input, /*prompt*/ ctx[2]);
      }

      current = true;

      // Set initial select value
      select5.value = selectedContent;

      if (!mounted) {
        dispose = [
          listen(advanceButton, "click", () => {
            showAdvancedOptions = !showAdvancedOptions;
            advanceButton.textContent = showAdvancedOptions
              ? "Hide Advance Options"
              : "✎ Advance Options";

            // ✅ Checkbox wrapper show/hide
            if (showAdvancedOptions) {
              checkboxWrapper.classList.remove("hidden");
            } else {
              checkboxWrapper.classList.add("hidden");
            }

            input.style.display =
              (selectedContent === "human" || selectedContent === "other") && showAdvancedOptions
                ? "block"
                : "none";
            button.style.display =
              (selectedContent === "human" || selectedContent === "other") && showAdvancedOptions
                ? "block"
                : "none";
            div0.style.display =
              (selectedContent === "human" || selectedContent === "other") && showAdvancedOptions
                ? "block"
                : "none";
          }),
          
          listen(button, "click", (e) => {
            let imagefromimagesuggestionarray = [];
            imagefromimagesuggestionarray = imagefromimagesuggestion.split("|");
            let prompts = [
              "e.g add a full moon in the background",
              "e.g place a flower crown on head",
              "e.g add cowboy hat",
            ];
            
            
              prompts = imagefromimagesuggestionarray.length ? imagefromimagesuggestionarray : prompts;
           
            attr(input, "placeholder", prompts[selected_iti_prompt]);
            selected_iti_prompt++;
            if (selected_iti_prompt > prompts.length - 1) selected_iti_prompt = 0;
          }),
          listen(input, "input", /*input_input_handler*/ ctx[21]),
          listen(select5, "change", (e) => {
            selectedContent = e.target.value;
            detach(t__message);
            t__message =
              selectedContent === "human"
                ? text$1(
                    "NOTE: Only upload a photo of one person. Multiple people will not be recognized"
                  )
                : selectedContent === "animal"
                ? text$1(
                    "NOTE: Only upload a photo of one animal. Multiple animals will not be recognized"
                  )
                : text$1(
                    "NOTE: Image dimensions must be between 320 and 1536 pixels for both width and height."
                  );
            p_message.append(t__message);
            // Update placeholder based on dropdown
            if (selectedContent === "other") {
              attr(input, "placeholder", "e.g A bright red apple on a white background");
            } else {
              attr(input, "placeholder", "e.g. add cowboy hat");
            }
            // Update visibility based on dropdown and advanced options toggle
            input.style.display =
              (selectedContent === "human" || selectedContent === "other") && showAdvancedOptions
                ? "block"
                : "none";
            button.style.display =
              (selectedContent === "human" || selectedContent === "other") && showAdvancedOptions
                ? "block"
                : "none";
            div0.style.display =
              (selectedContent === "human" || selectedContent === "other") && showAdvancedOptions
                ? "block"
                : "none";
            ctx[24](selectedContent); // Call original change handler
          }),
        ];
        mounted = true;
      }
    },
    p(ctx2, dirty) {
      const imagetoimage_changes = {};
      if (!updating_userImageUrl && dirty & 8) {
        updating_userImageUrl = true;
        imagetoimage_changes.userImageUrl = ctx2[3];
        add_flush_callback(() => (updating_userImageUrl = false));
      }
      if (!updating_hasUserUploadedImage && dirty & 256) {
        updating_hasUserUploadedImage = true;
        imagetoimage_changes.hasUserUploadedImage = ctx2[8];
        add_flush_callback(() => (updating_hasUserUploadedImage = false));
      }
      imagetoimage.$set(imagetoimage_changes);

      if (dirty & 64) {
        
        // select5.disabled = ctx2[6];
        // input.disabled = ctx2[6];
      }

      if (dirty & 4 && input.value !== ctx2[2]) {
        set_input_value(input, ctx2[2]);
      }
    },
    i(local) {
      if (current) return;
      transition_in(imagetoimage.$$.fragment, local);
      current = true;
    },
    o(local) {
      transition_out(imagetoimage.$$.fragment, local);
      current = false;
    },
    d(detaching) {
      if (detaching) detach(div2);
      destroy_component(imagetoimage);
      mounted = false;
      dispose.forEach((fn) => fn());
    },
  };
}
function create_if_block$2(ctx) {
  let div1;
  let textarea;
  let t;
  let div0;
  let prompts;
  let updating_value;
  let current;
  let mounted;
  let dispose;
  function prompts_value_binding(value) {
    ctx[18](value);
  }
  let prompts_props = {};
  if (
    /*prompt*/
    ctx[2] !== void 0
  ) {
    prompts_props.value = /*prompt*/ ctx[2];
  }
  if(formDetailHistory && formDetailHistory.prompt){
        prompts_props.value = formDetailHistory.prompt;
  }
  prompts = new Prompts({ props: prompts_props });
  binding_callbacks.push(() => bind$2(prompts, "value", prompts_value_binding));
  return {
    c() {
      let imagefromtextsuggestionarray = []
      imagefromtextsuggestionarray =  imagefromtextsuggestion.split("|");
      div1 = element("div");
      textarea = element("textarea");
      if(formDetailHistory && formDetailHistory.prompt ){
        ctx[2] = formDetailHistory.prompt;
        textarea.value = formDetailHistory.prompt;
      }
      t = space();
      div0 = element("div");
      create_component(prompts.$$.fragment);
      attr(textarea, "row", "8");
      textarea.required = true;
      // textarea.disabled = /*isLoading*/ ctx[6];
      attr(textarea, "id", "ImagefromTextBox");
      attr(
        textarea,
        "placeholder",
        (imagefromtextsuggestionarray.length)?imagefromtextsuggestionarray[0]:"A raccoon holding an umbrella in the rain"
      );
      attr(textarea, "class", "textarea md:min-h-[8rem] min-h-[4rem] p-r-5");
      attr(div0, "class", "absolute right-3 bottom-4");
      attr(div1, "class", "relative");
    },
    m(target, anchor) {
      insert(target, div1, anchor);
      append(div1, textarea);
      set_input_value(
        textarea,
        /*prompt*/
        ctx[2]
      );
      append(div1, t);
      append(div1, div0);
      mount_component(prompts, div0, null);
      current = true;
      if (!mounted) {
        dispose = listen(
          textarea,
          "input",
          /*textarea_input_handler*/
          ctx[17]
        );
        mounted = true;
      }
    },
    p(ctx2, dirty) {
      if (!current || dirty /*isLoading*/ & 64) {
        // textarea.disabled = /*isLoading*/ ctx2[6];
      }
      if (dirty /*prompt*/ & 4) {
        set_input_value(
          textarea,
          /*prompt*/
          ctx2[2]
        );
      }
      const prompts_changes = {};
      if (!updating_value && dirty /*prompt*/ & 4) {
        updating_value = true;
        prompts_changes.value = /*prompt*/ ctx2[2];
        add_flush_callback(() => (updating_value = false));
      }
      prompts.$set(prompts_changes);
    },
    i(local) {
      if (current) return;
      transition_in(prompts.$$.fragment, local);
      current = true;
    },
    o(local) {
      transition_out(prompts.$$.fragment, local);
      current = false;
    },
    d(detaching) {
      if (detaching) detach(div1);
      destroy_component(prompts);
      mounted = false;
      dispose();
    },
  };
}
function create_each_block$1(ctx) {
  let option;
  let t_value = /*preset*/ ctx[24].label + "";
  let t;
  let option_selected_value;
  let option_value_value;
  return {
    c() {
      option = element("option");
      t = text$1(t_value);
      option.selected = option_selected_value =
        /*stylePreset*/ (ctx[4] === void 0 &&
          /*preset*/ ctx[24].label === "Random Styles") ||
        JSON.parse(/*stylePreset*/ ctx[4] || "{}").label ===
          /*preset*/ ctx[24].label;
      option.__value = option_value_value = JSON.stringify(/*preset*/ ctx[24]);
      option.value = option.__value;
    },
    m(target, anchor) {
      insert(target, option, anchor);
      append(option, t);
    },
    p(ctx2, dirty) {
      if (
        dirty /*artStyleOptions*/ & 128 &&
        t_value !== (t_value = /*preset*/ ctx2[24].label + "")
      )
        set_data(t, t_value);
      if (
        dirty /*stylePreset, artStyleOptions, JSON*/ & 144 &&
        option_selected_value !==
          (option_selected_value =
            /*stylePreset*/ (ctx2[4] === void 0 &&
              /*preset*/ ctx2[24].label === "Random Styles") ||
            JSON.parse(/*stylePreset*/ ctx2[4] || "{}").label ===
              /*preset*/ ctx2[24].label)
      ) {
        option.selected = option_selected_value;
      }
      if (
        dirty /*artStyleOptions*/ & 128 &&
        option_value_value !==
          (option_value_value = JSON.stringify(/*preset*/ ctx2[24]))
      ) {
        option.__value = option_value_value;
        option.value = option.__value;
      }
    },
    d(detaching) {
      if (detaching) detach(option);
    },
  };
}

function create_each_block_image_list(ctx) {
  let li;
  let img;
  let img_src_value;
  let t0;
  let p;
  let t1_value = /*preset*/ ctx[24].label + "";
  let t1;
  let li_class_value;
  let mounted;
  let dispose;

 const imageUrlMap = {
    "Random Styles":
      "https://cdn.shopify.com/s/files/1/0736/6996/8165/files/ezgif.com-animated-gif-maker.gif?v=1752747231",
     "Custom Style":
      "https://cdn.shopify.com/s/files/1/0736/6996/8165/files/cusom.png?v=1762757129",
         Watercolor:
      "https://cdn.shopify.com/s/files/1/0736/6996/8165/files/Watercolor.png?v=1751365090",
    Impressionism:
      "https://cdn.shopify.com/s/files/1/0736/6996/8165/files/Impressionism.png?v=1751365090",
  
    Futuristic:
      "https://cdn.shopify.com/s/files/1/0736/6996/8165/files/Futuristic.png?v=1751365090",
    Retro:
      "https://cdn.shopify.com/s/files/1/0736/6996/8165/files/Retro.png?v=1751365090",
    Photorealistic:
      "https://cdn.shopify.com/s/files/1/0736/6996/8165/files/Photorealistic.png?v=1751365090",
    Abstract:
      "https://cdn.shopify.com/s/files/1/0736/6996/8165/files/Abstract.png?v=1751365090",
    Minimalist:
      "https://cdn.shopify.com/s/files/1/0736/6996/8165/files/Minimalist.png?v=1751365090",
    "Pop Art":
      "https://cdn.shopify.com/s/files/1/0736/6996/8165/files/Pop.png?v=1751365090",
    "3D Animated":
      "https://cdn.shopify.com/s/files/1/0736/6996/8165/files/Animated.png?v=1751365090",
    Anime:
      "https://cdn.shopify.com/s/files/1/0736/6996/8165/files/Anime.png?v=1751365090",
    Synthwave:
      "https://cdn.shopify.com/s/files/1/0736/6996/8165/files/Synthwave.png?v=1751365090",
 
    "Vector Art":
      "https://cdn.shopify.com/s/files/1/0736/6996/8165/files/vectorart.png?v=1752043945",
    Steampunk:
      "https://cdn.shopify.com/s/files/1/0736/6996/8165/files/steampunk.png?v=1752043945",
        Whimsacle:
      "https://cdn.shopify.com/s/files/1/0736/6996/8165/files/imgg.png?v=1751365091",
    
  };

  return {
    c() {
      li = element("li");
      img = element("img");
      t0 = space();
      p = element("p");
      t1 = text$1(t1_value);
      attr(img, "class", "h-5 w-5 object-cover rounded w75");
      attr(img, "alt", /*preset*/ ctx[24].label);
      if (
        !src_url_equal(
          img.src,
          (img_src_value =
            imageUrlMap[/*preset*/ ctx[24].label] ||
            "https://via.placeholder.com/48")
        )
      ) {
        attr(img, "src", img_src_value);
      }
      attr(p, "class", "text-sm font-medium");
      attr(
        li,
        "class",
        (li_class_value = `sss flex items-center gap-2 p-2 rounded hover:bg-gray-100 cursor-pointer ${
          JSON.parse(/*stylePreset*/ ctx[4] || "{}").label ===
          /*preset*/ ctx[24].label
            ? "bg-gray-200"
            : ""
        }`)
      );
    },
    m(target, anchor, select_element, button_dropdown, button_img) {
      insert(target, li, anchor);
      append(li, img);
      append(li, t0);
      append(li, p);
      append(p, t1);
      if (!mounted) {
        dispose = listen(li, "click", () => {
          
          select_element.value = JSON.stringify(/*preset*/ ctx[24]);
          button_dropdown.querySelector("span").textContent =
            /*preset*/ ctx[24].label;
          const newImgSrc =
            imageUrlMap[/*preset*/ ctx[24].label] ||
            "https://via.placeholder.com/48";
          
          if (!src_url_equal(button_img.src, newImgSrc)) {
            attr(button_img, "src", newImgSrc);
            attr(button_img, "alt", /*preset*/ ctx[24].label);
          }
          ul_images_stylepresets = button_dropdown.parentElement.querySelector("ul");

          // ul_images_stylepresets.style.display="none";

          // ul_images_stylepresets.classList.add("hidden");
          const event = new Event("change");
          select_element.dispatchEvent(event);
        });
        mounted = true;
      }
    },
    p(ctx2, dirty) {
   
      if (
        dirty /*artStyleOptions*/ & 128 &&
        !src_url_equal(
          img.src,
          (img_src_value =
            imageUrlMap[/*preset*/ ctx2[24].label] ||
            "https://via.placeholder.com/48")
        )
      ) {
        attr(img, "src", img_src_value);
      }
      if (
        dirty /*artStyleOptions*/ & 128 &&
        t1_value !== (t1_value = /*preset*/ ctx2[24].label + "")
      ) {
        set_data(t1, t1_value);
      }
      if (
        dirty /*stylePreset, artStyleOptions*/ & 144 &&
        li_class_value !==
          (li_class_value = `ddd flex items-center gap-2 p-2 rounded hover:bg-gray-100 cursor-pointer ${
            JSON.parse(/*stylePreset*/ ctx2[4] || "{}").label ===
            /*preset*/ ctx2[24].label
              ? "bg-gray-200"
              : ""
          }`)
      ) {
        attr(li, "class", li_class_value);
      }
    },
    d(detaching) {
      if (detaching) detach(li);
      mounted = false;
      dispose && dispose();
    },
  };
}

function create_fragment$5(ctx) {
  let div9;
  let div0;
  let img;
  let img_src_value;
  let t0;
  let p0;
  let t1_value = /*lang*/ ctx[5].subtext + "";
  let t1;
  let t2;
  let form;
  let ul;
  let li0;
  let div1;
  let t6;
  let div2;
  let label0;
  let input0;
  let t7;
  let t8;
  let label_square; // NEW
  let input_square; // NEW
  let t11_value = "\n            Square"; // NEW
  let t11; // NEW
  let t12; // NEW space
  let label1;
  let input1;
  let t9;
  let t10;
  let li1;
  let div3;
  let t14;
  let div4;
  let label2;
  let input2;
  let t15;
  let t16;
  let label3;
  let input3;
  let t17;
  let t18;
  let div5;
  let current_block_type_index;
  let if_block;
  let t19;
  let li2;
  let div6;
  let t23;
  let div7;
  let select;
  let t24;
  let div_dropdown;
  let button_dropdown;
  let button_img;
  let t25;
  let button_text;
  let t26;
  // let ul_images;
  let t27;
  let div_custom_style;
  // let input_custom_style;
  let t28_custom;
  let label_custom_style;
  let t28_bulb;
  let button_bulb;
  let t28;
  let div8;
  // let button;

  t29_value = /*isLoading*/ ctx[6] ? "Generating..." : "Generate Art ";
 
  
  // let button_disabled_value;
  let current;
  let binding_group;
  let binding_group_1;
  let mounted;
  let dispose;
  let div_temporary;

const imageUrlMap = {
    "Random Styles": "https://cdn.shopify.com/s/files/1/0736/6996/8165/files/ezgif.com-animated-gif-maker.gif?v=1752747231",
    "Custom Style": "https://cdn.shopify.com/s/files/1/0736/6996/8165/files/cusom.png?v=1762757129",
        Watercolor: "https://cdn.shopify.com/s/files/1/0736/6996/8165/files/Watercolor.png?v=1751365090",
    Impressionism: "https://cdn.shopify.com/s/files/1/0736/6996/8165/files/Impressionism.png?v=1751365090",
    
    Futuristic: "https://cdn.shopify.com/s/files/1/0736/6996/8165/files/Futuristic.png?v=1751365090",
    Retro: "https://cdn.shopify.com/s/files/1/0736/6996/8165/files/Retro.png?v=1751365090",
    Photorealistic: "https://cdn.shopify.com/s/files/1/0736/6996/8165/files/Photorealistic.png?v=1751365090",
    Abstract: "https://cdn.shopify.com/s/files/1/0736/6996/8165/files/Abstract.png?v=1751365090",
    Minimalist: "https://cdn.shopify.com/s/files/1/0736/6996/8165/files/Minimalist.png?v=1751365090",
    "Pop Art": "https://cdn.shopify.com/s/files/1/0736/6996/8165/files/Pop.png?v=1751365090",
    "3D Animated": "https://cdn.shopify.com/s/files/1/0736/6996/8165/files/Animated.png?v=1751365090",
    Anime: "https://cdn.shopify.com/s/files/1/0736/6996/8165/files/Anime.png?v=1751365090",
    Synthwave: "https://cdn.shopify.com/s/files/1/0736/6996/8165/files/Synthwave.png?v=1751365090",

    "Vector Art": "https://cdn.shopify.com/s/files/1/0736/6996/8165/files/vectorart.png?v=1752043945",
    Steampunk: "https://cdn.shopify.com/s/files/1/0736/6996/8165/files/steampunk.png?v=1752043945",
    Whimsacle: "https://cdn.shopify.com/s/files/1/0736/6996/8165/files/imgg.png?v=1751365091",
  };

const artStyleOptions = /*artStyleOptions*/ ctx[7] || [
    { label: "Random Styles" },
    { label: "Custom Style" },
       { label: "Watercolor" },
    { label: "Impressionism" },
    { label: "Futuristic" },
    { label: "Retro" },
    { label: "Photorealistic" },
    { label: "Abstract" },
    { label: "Minimalist" },
    { label: "Pop Art" },
    { label: "3D Animated" },
    { label: "Anime" },
    { label: "Synthwave" },
 
    { label: "Vector Art" },
    { label: "Steampunk" },
    { label: "Whimsacle" },
  ];

  const if_block_creators = [create_if_block$2, create_else_block$1];
  const if_blocks = [];
  function select_block_type(ctx2, dirty) {
    if (/*isTextToImage*/ ctx2[1]) return 0;
    return 1;
  }
  current_block_type_index = select_block_type(ctx);
  if_block = if_blocks[current_block_type_index] =
    if_block_creators[current_block_type_index](ctx);
  let each_value = artStyleOptions;
  let each_blocks = [];
  let each_image_blocks = [];
  for (let i = 0; i < each_value.length; i += 1) {
    each_blocks[i] = create_each_block$1(
      get_each_context$1(ctx, each_value, i)
    );
    each_image_blocks[i] = create_each_block_image_list(
      get_each_context$1(ctx, each_value, i)
    );
  }
  binding_group = init_binding_group(/*$$binding_groups*/ ctx[13][0]);
  binding_group_1 = init_binding_group(/*$$binding_groups*/ ctx[13][1]);

  function select_option(select, value, force = false) {
    const parsedValue = value
      ? JSON.parse(value).label
      : artStyleOptions[0].label;
    for (let i = 0; i < select.options.length; i++) {
      if (select.options[i].value === parsedValue) {
        select.options[i].selected = true;
        break;
      }
    }
  }

  return {
    c() {
      // orientation_wrapper =  element("div");
      div_temporary = element("div");
      div_temporary.innerHTML = `
      <div> 
        <div class="relative group ">
              <input type="file" class="absolute opacity-0 w-full h-full cursor-pointer nn"> 
              <div class="bg-gray-50 border-gray-400 text-sm text-gray-500 border-2 body border-dashed md:h-20 h-14 flex items-center justify-center text-right cursor-pointer m-0 active:border-gray-700 hover:border-gray-60 rounded-md">
                  <label for="fileInput" class="cursor-pointer">
                    <img src="https://cdn.shopify.com/s/files/1/0736/6996/8165/files/Frame_5265.svg?v=1751372390" alt="Upload image " style="width: 184px; height: 100%;">
                  </label>
              </div>
              <div class="py-2 disk2">
                <p class="text-xs md:text-sm"></p>
              </div>
        </div> 
      </div> `;
      attr(div_temporary, "class", "pl-1 md:pl-8");
      attr(div_temporary, "id", "temporarysuggetionboxdiv");
      div_temporary.style.display="none";

      div9 = element("div");
      div0 = element("div");
      img = element("img");
      t0 = space();
      p0 = element("p");
      t1 = text$1(t1_value);
      t2 = space();
      form = element("form");
      ul = element("ul");
      li0 = element("li");
      div1 = element("div");
      div1.innerHTML = `<p class="step-icon">1</p><p class="m-0 text-base font-semibold">Orientation</p>`;
      t6 = space();
      div2 = element("div");
      label0 = element("label");
      input0 = element("input");
      t7 = text$1("\n            Vertical");
      t8 = space();
      label_square = element("label"); // NEW
      input_square = element("input"); // NEW
      t11 = text$1(t11_value); // NEW
      t12 = space(); // NEW
      label1 = element("label");
      input1 = element("input");
      t9 = text$1("\n            Horizontal");
      t10 = space();
      li1 = element("li");
      div3 = element("div");
      div3.innerHTML = `<p class="step-icon">2</p><p class="m-0 text-base font-semibold">Provide Subject Matter</p>`;
      t14 = space();
      div4 = element("div");
      label2 = element("label");
      input2 = element("input");
      t15 = text$1("\n            Text to Image");
      t16 = space();
      label3 = element("label");
      input3 = element("input");
      t17 = text$1("\n            Upload an image");
      t18 = space();
      div5 = element("div");
      if_block.c();
      t19 = space();
      li2 = element("li");
      div6 = element("div");
      div6.innerHTML = `<p class="step-icon">3</p><p class="m-0 text-base font-semibold">Select Style</p>`;
      t23 = space();
      div7 = element("div");
      select = element("select");
      for (let i = 0; i < each_blocks.length; i += 1) {
        each_blocks[i].c();
      }
      t24 = space();
      div_dropdown = element("div");
      button_dropdown = element("button");
      button_img = element("img");
      t25 = space();
      button_text = element("span");
      // button_text.textContent = /*stylePreset*/ ctx[4]
      //   ? JSON.parse(/*stylePreset*/ ctx[4]).label
      //   : "Mix it Up";
      button_text.textContent = /*stylePreset*/ ctx[4]
        ? JSON.parse(/*stylePreset*/ ctx[4]).label
        : "Random Styles";
      t26 = space();
      ul_images_stylepresets = element("ul");
      for (let i = 0; i < each_image_blocks.length; i += 1) {
        each_image_blocks[i].c();
      }
      t27 = space();
      div_custom_style = element("div");
      input_custom_style = element("textarea");
      if(formDetailHistory && formDetailHistory.custom_style){

        input_custom_style.value = formDetailHistory.custom_style;
      }
      t28_custom = space();
      label_custom_style = element("label");
      label_custom_style.textContent = "Describe your desired art style";
      t28_bulb = space();
      button_bulb = element("button");
      // button_bulb.innerHTML = `<p class="text-lg">💡</p>`;
      button_bulb.innerHTML = `<p class="text-lg"><img src="https://cdn.shopify.com/s/files/1/0736/6996/8165/files/editcustomicon.jpg?v=1764146029"></p>`
      
      t28 = space();
      div8 = element("div");
     finalsubmissionbutton = element("button");
      button_art_icon = element("img"); // NEW
      attr(button_art_icon, "src", "https://cdn.shopify.com/s/files/1/0736/6996/8165/files/art-palette.png?v=1773403223"); // NEW
      attr(button_art_icon, "alt", "art icon"); // NEW
      attr(button_art_icon, "class", "h-5 w-5 inline-block mr-2 align-middle"); // NEW
      t29 = text$1(t29_value);

      attr(img, "class", "h-14 d-desktop");
      attr(img, "alt", "create one a of kind art");
      if (
        !src_url_equal(
          img.src,
          (img_src_value =
            "https://cdn.shopify.com/s/files/1/0736/6996/8165/files/Create_one-of-a-kind_AI_art.svg?v=1750843861")
        )
      )
        attr(img, "src", img_src_value);
      attr(p0, "class", "hidden m-0 text-base font-light whitespace-pre-line");
      attr(div0, "class", "mb-8");
      attr(div1, "class", "flex items-center gap-4");
      attr(input0, "type", "radio");
      // input0.disabled = /*isLoading*/ ctx[6];
      attr(input0, "name", "vertical");
      input0.__value = true;
      input0.value = input0.__value;
  
      // attr(
      //   label0,
      //   "class",
      //   `text-sm cursor-pointer select-none ${
      //     /*isVertical*/ ctx[0] ? "selected" : ""
      //   }`
      // );


      attr(
        label0,
        "class",
        `text-sm cursor-pointer select-none ${
          /*isVertical*/ ctx[0] && ctx[0]!="square" ? "selected" : ""
        }`
      );

      attr(input_square, "type", "radio"); // NEW
      input_square.disabled = /*isLoading*/ ctx[6];
      attr(input_square, "name", "square");
      input_square.__value = "square";
      input_square.value = input_square.__value;

      attr(label_square, "class", `text-sm cursor-pointer select-none ${/*orientation*/ ctx[0] === "square" ? "selected" : ""}`); // NEW

      attr(input1, "type", "radio");
      input1.disabled = /*isLoading*/ ctx[6];
      attr(input1, "name", "horizontal");
      input1.__value = false;
      input1.value = input1.__value;
  
      attr(
        label1,
        "class",
        `text-sm cursor-pointer select-none ${
          /*isVertical*/ ctx[0] ? "" : "selected"
        }`
      );
      attr(div2, "class", "flex gap-4 pt-4 pl-1 md:pl-10");
      attr(li0, "class", "pl-4 md:pl-0");
      
      // attr(orientation_wrapper, "id", "orientation-section");
       attr(li0, "id", "orientation-section")
      attr(div3, "class", "flex items-center gap-4");
      attr(input2, "type", "radio");
      attr(input2, "name", "text-to-image");
      // input2.disabled = /*isLoading*/ ctx[6];
      input2.__value = true;
      input2.value = input2.__value;
      
      attr(
        label2,
        "class",
        `text-sm cursor-pointer select-none ${
          /*isTextToImage*/ ctx[1] ? "selected" : ""
        }`
      );
      attr(input3, "type", "radio");
      attr(input3, "name", "image-to-image");
      input3.__value = false;
      input3.value = input3.__value;
      
      attr(label2, "id", "ImagefromTextLabelBox");
      attr(label3, "id", "ImagefromImageBox");
      attr(
        label3,
        "class",
        `text-sm cursor-pointer select-none ${
          /*isTextToImage*/ ctx[1] ? "" : "selected"
        }`
      );
      let imagefromtextsuggestionarray = [];
      imagefromtextsuggestionarray = imagefromtextsuggestion.split("|");
      attr(div4, "class", "flex gap-4 p-4 pl-1 md:pl-8");
      // attr(div5, "class", "pl-1 md:pl-8");

      attr(div5, "class", "pl-1 md:pl-8 suggetionbox");
      attr(div5, "id", "suggetionboxdiv");

      attr(li1, "class", "pl-4 pr-4 md:pl-0 md:pr-0");
      attr(li1, "id", "subject-section");
      attr(div6, "class", "flex items-center gap-4");
      select.required = true;
      // select.disabled = /*isLoading*/ ctx[6];
      attr(select, "placeholder", (imagefromtextsuggestionarray.length) ? imagefromtextsuggestionarray[0] : "A raccoon holding an umbrella in the rain");
      attr(select, "class", "select mysleect");
      if (!(/*stylePreset*/ ctx[4])) {
        ctx[4] = JSON.stringify(artStyleOptions[0]);
        select_option(select, ctx[4], true);
      } else {
     
            if(formDetailHistory && formDetailHistory.stylePreset){
              const styepresetdata = JSON.parse(formDetailHistory.stylePreset)
              const formstyle = artStyleOptions.find(item => item.label === styepresetdata.label);
              
              ctx[4] = JSON.stringify(formstyle)
              select_option(select, ctx[4], true);
              
              button_text.textContent = /*stylePreset*/ ctx[4]
              ? JSON.parse(/*stylePreset*/ ctx[4]).label
              : "Random Styles";
          }else{ 
              select_option(select, /*stylePreset*/ ctx[4], true);
          }
      }
      attr(
        button_img,
        "class",
        "h-5 w-5 object-cover rounded inline-block mr-2"
      );
      attr(
        button_img,
        "alt",
        /*stylePreset*/ ctx[4]
          ? JSON.parse(/*stylePreset*/ ctx[4]).label
          : "Random Styles"
      );
      if (
        !src_url_equal(
          button_img.src,
          imageUrlMap[
            /*stylePreset*/ ctx[4]
              ? JSON.parse(/*stylePreset*/ ctx[4]).label
              : "Random Styles"
          ] || "https://via.placeholder.com/48"
        )
      )
        attr(
          button_img,
          "src",
          imageUrlMap[
            /*stylePreset*/ ctx[4]
              ? JSON.parse(/*stylePreset*/ ctx[4]).label
              : "Random Styles"
          ] || "https://via.placeholder.com/48"
        );
      attr(button_dropdown, "type", "button");
      
      attr(
        button_dropdown,
        "class",
        "border border-gray-300 rounded p-2 bg-white w-full text-left flex items-center"
      );
      attr(div_dropdown, "class", "relative mydropdown");
      attr(
        ul_images_stylepresets,
        "class",
        "testclass absolute z-10 bg-white border border-gray-300 rounded mt-1 w-full max-h-60 overflow-y-auto"
      );
     
      attr(ul_images_stylepresets, "style", "display: none;");
      attr(ul_images_stylepresets, "id", "styledropdownbox")
      attr(div7, "class", "p-4 pl-1 pr-0 md:pl-8");
      attr(input_custom_style, "type", "text");
      let customstyledefaultprompts = "e.g hyperrealistic";
      let customstylesuggestionarray = [];
      customstylesuggestionarray = customstylesuggestion.split("|");
      customstyledefaultprompts = (customstylesuggestionarray.length) ? customstylesuggestionarray[0] : customstyledefaultprompts;
      attr(
        input_custom_style,
        "placeholder",
        customstyledefaultprompts
      );
      attr(
        label_custom_style,
        "class",
        "text-sm font-medium text-gray-700 mt-1"
      );
      attr(
        input_custom_style,
        "class",
        "border border-gray-300 rounded p-2 w-full mt-2 textarea !border-1 md:min-h-[3rem] min-h-[1.5rem] border-gray-400"
      );
      attr(
        div_custom_style,
        "class",
        `relative mt-2 ${
          /*stylePreset*/ ctx[4] &&
          JSON.parse(/*stylePreset*/ ctx[4]).label === "Custom Style"
            ? ""
            : "hidden"
        }`
      );
      attr(
        button_bulb,
        "type",
        "button"
      );
      attr(
        button_bulb,
        "class",
        "h-8 w-8 rounded-full active:bg-yellow-200 cursor-pointer flex items-center justify-center bg-yellow-50 border-solid border-[1px] border-yellow-400 bpsta"
      );
      attr(button_bulb, "style", "display: block;");
      attr(li2, "class", "pl-4 pr-4 md:pl-0 md:pr-0");
      attr(li2, "id", "style-section");
      
      attr(ul, "class", "flex flex-col gap-4 pl-0 list-none md:gap-8");
      attr(finalsubmissionbutton, "type", "submit");
      // button.disabled = button_disabled_value =
      //   /*isLoading*/ ctx[6] ||
      //   (!(/*isTextToImage*/ ctx[1]) && !(/*hasUserUploadedImage*/ ctx[8]));
      if(formDetailHistory){
          
      }else{

        finalsubmissionbutton.disabled = button_disabled_value =
          /*isLoading*/ ctx[6] ||
          (!(/*isTextToImage*/ ctx[1]) && !(/*hasUserUploadedImage*/ ctx[8]));
 
      }
      attr(
        finalsubmissionbutton,
        "class",
        "button md:!px-12 md:w-auto w-full !bg-brand-red gnrateart"
      );
      attr(
        finalsubmissionbutton,
        "id",
        "generate-button"
      );
      attr(
        div8,
        "class",
        "flex justify-center px-4 text-right md:ml-8 md:justify-center md:px-0 sm:px-0"
      );
      attr(form, "class", "flex flex-col gap-4");
      binding_group.p(input2, input3);
      binding_group_1.p(input0, input1);
    },
    m(target, anchor) {
    
      insert(target, div9, anchor);
      append(div9, div0);
      append(div0, img);
      append(div0, t0);
      append(div0, p0);
      append(p0, t1);
      append(div9, t2);
      append(div9, form);
      append(form, ul);
      // append(orientation_wrapper, li0);
      // append(ul, orientation_wrapper);
      append(ul, li0);
      
      append(li0, div1);
        append(label0, t7);
      append(div2, t8);
      append(div2, label1);
      append(label1, input1);
      input1.checked = input1.__value === /*isVertical*/ ctx[0];
      // console.log("input1.checked horizontal", input1.checked)
      append(li0, t6);
      append(li0, div2);
      append(div2, label0);
      append(label0, input0);
      input0.checked = input0.__value === /*isVertical*/ ctx[0];
      // console.log("input0.checked VERTICAL", input0.checked)
      append(label1, t9);
      append(div2, label_square); // NEW
      append(label_square, input_square);
      append(label_square, t11); // NEW

      append(div2, t12); // NEW space
     
      input_square.checked = /*orientation*/ ctx[0] === "square"; // NEW
      append(ul, t10);
      append(ul, li1);
      append(li1, div3);
      append(li1, t14);
      append(li1, div4);
      append(div4, label2);
      append(label2, input2);
      input2.checked = input2.__value === /*isTextToImage*/ ctx[1];
      append(label2, t15);
      append(div4, t16);
      append(div4, label3);
      append(label3, input3);
      input3.checked = input3.__value === /*isTextToImage*/ ctx[1];
      append(label3, t17);
      append(li1, t18);
      append(li1, div_temporary);
      append(li1, div5);
      if_blocks[current_block_type_index].m(div5, null);
      append(ul, t19);
      append(ul, li2);
      append(li2, div6);
      append(li2, t23);
      append(li2, div7);
      append(div7, select);
      for (let i = 0; i < each_blocks.length; i += 1) {
        if (each_blocks[i]) {
          each_blocks[i].m(select, null);
        }
      }
      append(div7, t24);
      append(div7, div_dropdown);
      append(div_dropdown, button_dropdown);
      append(button_dropdown, button_img);
      append(button_dropdown, t25);
      append(button_dropdown, button_text);
      append(div_dropdown, t26);
      append(div_dropdown, ul_images_stylepresets);
      for (let i = 0; i < each_image_blocks.length; i += 1) {
        if (each_image_blocks[i]) {
          each_image_blocks[i].m(
            ul_images_stylepresets,
            null,
            select,
            button_dropdown,
            button_img
          );
        }
      }
      append(li2, t27);
      append(li2, div_custom_style);
      append(div_custom_style, label_custom_style);
      append(div_custom_style, t28_custom);
      append(div_custom_style, input_custom_style);
      append(div_custom_style, t28_bulb);
      append(div_custom_style, button_bulb);
      append(form, t28);
      append(form, div8);
      append(div8, finalsubmissionbutton);
      append(finalsubmissionbutton, button_art_icon);
      append(finalsubmissionbutton, t29);
      current = true;
      if (!mounted) {
        dispose = [
          listen(input0, "change", /*clearSelectedImage*/ ctx[9]),
          listen(input0, "change", /*input0_change_handler*/ ctx[12]),
          listen(input_square, "change", /*clearSelectedImage*/ ctx[9]), // NEW
          listen(input_square, "change", /*square_change_handler*/ ctx[25]), // NEW
          listen(input1, "change", /*clearSelectedImage*/ ctx[9]),
          listen(input1, "change", /*input1_change_handler*/ ctx[14]),
          listen(input2, "change", /*input2_change_handler*/ ctx[15]),
          listen(input3, "change", /*input3_change_handler*/ ctx[16]),
           listen(input3, "change", () => {
          setTimeout(function(){
           div5.querySelector(".nnz").click();
          },1);
          }),
          listen(select, "change", () => {
            /*select_change_handler*/ ctx[22].call(select);
          }),
          listen(button_dropdown, "click", (e) => {
            e.stopPropagation(); // Prevent button click from bubbling to document
            if(ul_images_stylepresets.style.display === "none") ul_images_stylepresets.style.display="block";
            else ul_images_stylepresets.style.display="none";
            
          }),
         
         
         
          listen(input_custom_style, "input", (event) => {
            if (ctx[23]) ctx[23](event.target.value);
          }),
          listen(button_bulb, "click", () => {
           
            let customstylesuggestionarray = [];
            customstylesuggestionarray = customstylesuggestion.split("|");
            let prompts = [
              "e.g hyperrealistic",
              "e.g bright lighting",
              "e.g comic",
              "e.g ghibli",
              "e.g cinematic"
            ];
            prompts = customstylesuggestionarray.length ? customstylesuggestionarray : prompts;
            attr(input_custom_style, "placeholder", prompts[selected_iti_prompt]);
             input_custom_style.value = prompts[selected_iti_prompt];
            selected_iti_prompt++;
            if (selected_iti_prompt > prompts.length - 1) selected_iti_prompt = 0;
          }),
          listen(form, "submit", (event) => {
            event.preventDefault();
            if (/*submit_handler*/ ctx[11]) {
              try {
                /*submit_handler*/ ctx[11](event);
              } catch (e) {
                console.error("Error in submit_handler:", e);
              }
            }
          }),
          listen(finalsubmissionbutton, "click", (event) => {
        

            if (/*submit_handler*/ ctx[11]) {
              try {
                /*submit_handler*/ ctx[11](event);
              } catch (e) {
                console.error("Error in submit_handler:", e);
              }
            }
          }),
        ];
        mounted = true;
      }
    },
    p(ctx2, [dirty]) {
      if (
        !current ||
        (dirty /*lang*/ & 32 &&
          t1_value !== (t1_value = /*lang*/ ctx2[5].subtext + ""))
      )
        set_data(t1, t1_value);
      if (!current || dirty /*isLoading*/ & 64) {
        // input0.disabled = /*isLoading*/ ctx2[6];
      }
      if (dirty /*isVertical*/ & 1) {
       
        // input0.checked = input0.__value === /*isVertical*/ ctx2[0];
        if(in_progress_orientation!="none")
          input0.checked = input0.__value === /*isVertical*/ in_progress_orientation;
        else
          input0.checked = input0.__value === /*isVertical*/ ctx2[0];
      }
      if (!current || dirty /*isLoading*/ & 64) {
        // input1.disabled = /*isLoading*/ ctx2[6];
      }
      if (dirty /*isVertical*/ & 1) {
        // input1.checked = input1.__value === /*isVertical*/ ctx2[0];
        if(in_progress_orientation!="none")
          input1.checked = input1.__value === /*isVertical*/ in_progress_orientation;
        else
          input1.checked = input1.__value === /*isVertical*/ ctx2[0];
      }
      //new for square
      if (!current || dirty /*isLoading*/ & 64) {
        // input_square.disabled = /*isLoading*/ ctx2[6];
      }
      if (dirty /*isVertical*/ & 1) {
        // input_square.checked = input_square.__value === /*isVertical*/ ctx2[0];
        if(in_progress_orientation!="none")
          input_square.checked = input_square.__value === /*isVertical*/ in_progress_orientation;
        else
          input_square.checked = input_square.__value === /*isVertical*/ ctx2[0];
      }
      //new for square

      if (dirty /*isVertical*/ & 1) {
        // console.log("in is vertical while changing the label0")
        attr(
          label0,
          "class",
          `text-sm cursor-pointer select-none ${
            /*isVertical*/ ctx2[0] && ctx2[0]!="square" && ctx2[0]!="false" && ctx2[0]!=false ? "selected" : ""
          }`
        );
        attr(label_square, "class", `text-sm cursor-pointer select-none ${ctx2[0] === "square" ? "selected" : ""}`); // NEW
        // console.log("label1---------------", label1)
        attr(
          label1,
          "class",
          `text-sm cursor-pointer select-none ${
            /*isVertical*/ (ctx2[0]===false || ctx2[0]=="false") ? "selected" : ""
          }`
        );
      }
      if (!current || dirty /*isLoading*/ & 64) {
        // input2.disabled = /*isLoading*/ ctx2[6];
      }
      if (dirty /*isTextToImage*/ & 2) {
        input2.checked = input2.__value === /*isTextToImage*/ ctx2[1];
      }
      if (dirty /*isTextToImage*/ & 2) {
        input3.checked = input3.__value === /*isTextToImage*/ ctx2[1];
      }
      if (dirty /*isTextToImage*/ & 2) {
        attr(
          label2,
          "class",
          `text-sm cursor-pointer select-none ${
            /*isTextToImage*/ ctx2[1] ? "selected" : ""
          }`
        );
        attr(
          label3,
          "class",
          `text-sm cursor-pointer select-none ${
            /*isTextToImage*/ ctx2[1] ? "" : "selected"
          }`
        );
      }
      let previous_block_index = current_block_type_index;
      current_block_type_index = select_block_type(ctx2);
      if (current_block_type_index === previous_block_index) {
        if_blocks[current_block_type_index].p(ctx2, dirty);
      } else {
        group_outros();
        transition_out(if_blocks[previous_block_index], 1, 1, () => {
          if_blocks[previous_block_index] = null;
        });
        check_outros();
        if_block = if_blocks[current_block_type_index];
        if (!if_block) {
          if_block = if_blocks[current_block_type_index] =
            if_block_creators[current_block_type_index](ctx2);
          if_block.c();
        } else {
          if_block.p(ctx2, dirty);
        }
        transition_in(if_block, 1);
        if_block.m(div5, null);
      }
      if (dirty /*JSON, stylePreset, artStyleOptions*/ & 144) {
        each_value = artStyleOptions;
        let i;
        for (i = 0; i < each_value.length; i += 1) {
          const child_ctx = get_each_context$1(ctx2, each_value, i);
          if (each_blocks[i]) {
            each_blocks[i].p(child_ctx, dirty);
          } else {
            each_blocks[i] = create_each_block$1(child_ctx);
            each_blocks[i].c();
            each_blocks[i].m(select, null);
          }
          if (each_image_blocks[i]) {
            each_image_blocks[i].p(child_ctx, dirty);
          } else {
            each_image_blocks[i] = create_each_block_image_list(child_ctx);
            each_image_blocks[i].c();
            each_image_blocks[i].m(
              ul_images_stylepresets,
              null,
              select,
              button_dropdown,
              button_img
            );
          }
        }
        for (; i < each_blocks.length; i += 1) {
          each_blocks[i].d(1);
        }
        each_blocks.length = each_value.length;
        for (; i < each_image_blocks.length; i += 1) {
          each_image_blocks[i].d(1);
        }
        each_image_blocks.length = each_value.length;
      }
      if (!current || dirty /*stylePreset, JSON*/ & 16) {
        const selectedLabel = /*stylePreset*/ ctx2[4]
          ? JSON.parse(/*stylePreset*/ ctx2[4]).label
          : "Random Styles";
        button_text.textContent = selectedLabel;
        if (
          !src_url_equal(
            button_img.src,
            imageUrlMap[selectedLabel] || "https://via.placeholder.com/48"
          )
        ) {
          attr(
            button_img,
            "src",
            imageUrlMap[selectedLabel] || "https://via.placeholder.com/48"
          );
          attr(button_img, "alt", selectedLabel);
        }
        attr(
          div_custom_style,
          "class",
          `relative mt-2 ${
            selectedLabel === "Custom Style" ? "" : "hidden"
          }`
        );
      }
      if (!current || dirty /*isLoading*/ & 64) {
        // select.disabled = /*isLoading*/ ctx2[6];
      }
      if (dirty /*stylePreset, JSON, artStyleOptions*/ & 144) {
        select_option(select, /*stylePreset*/ ctx2[4]);
      }
      if (
        !current ||
        (dirty /*isLoading*/ & 64 &&
          t29_value !==
            (t29_value = /*isLoading*/ ctx2[6]
              ? "Generating..."
              : "Generate Art "))
      )
        set_data(t29, t29_value);
      if (
        !current ||
        (dirty /*isLoading, isTextToImage, hasUserUploadedImage*/ & 322 &&
          button_disabled_value !==
            (button_disabled_value =
              /*isLoading*/ ctx2[6] ||
              (!(/*isTextToImage*/ ctx2[1]) &&
                !(/*hasUserUploadedImage*/ ctx2[8]))))
      )
        finalsubmissionbutton.disabled = button_disabled_value;

      if(formDetailHistory && !formsubmittedafterlogin){
        button_disabled_value = false
      }
      finalsubmissionbutton.disabled = button_disabled_value;
      if(formDetailHistory && !formsubmittedafterlogin){
   
        finalsubmissionbutton.click();
        formsubmittedafterlogin = true
      }
    },
    i(local) {
      if (current) return;
      transition_in(if_block);
      current = true;
    },
    o(local) {
      transition_out(if_block);
      current = false;
    },
    d(detaching) {
      if (detaching) detach(div9);
      if_blocks[current_block_type_index].d();
      destroy_each(each_blocks, detaching);
      destroy_each(each_image_blocks, detaching);
      binding_group.r();
      binding_group_1.r();
      mounted = false;
      run_all(dispose);
    },
  };
}



// Update variable name in your codebase
let artStyleOptions = [
  { label: "Random Styles" },
{ label: "Custom Style" },
 { label: "Watercolor" },
  { label: "Impressionism" },
  
  { label: "Futuristic" },
  { label: "Retro" },
  { label: "Photorealistic" },
  { label: "Abstract" },
  { label: "Minimalist" },
  { label: "Pop Art" },
  { label: "3D Animated" },
  { label: "Anime" },
  { label: "Synthwave" },
 
  { label: "Vector Art" },
  { label: "Steampunk" },
  { label: "Whimsacle" },
  
];

function instance$4($$self, $$props, $$invalidate) {
  let { lang = {} } = $$props;
  let { image = {} } = $$props;
  let { prompt = "" } = $$props;
  let { isLoading = false } = $$props;
  let { isVertical = false } = $$props;
  let { isTextToImage = true } = $$props;
  let { userImageUrl = null } = $$props;
  let { stylePreset = {} } = $$props;
  let { stylePresets = [] } = $$props;
  let { imageContentType = false } = $$props;
  let hasUserUploadedImage = false;
  const clearSelectedImage = () => {
    $$invalidate(10, (image = {}));
    clearURLParams();
  };
  const $$binding_groups = [[], []];
  const delay30 = (ms) => new Promise(resolve => setTimeout(resolve, ms));
  async function submit_handler(event) {
    
    if(pending_images_array.length>0){
      // t29_value = "Generating...";
      // t29 = text$1(t29_value);

      // finalsubmissionbutton.replaceChildren(); // removes everything
      // append(finalsubmissionbutton, button_art_icon);
      // append(finalsubmissionbutton, t29);
      while (pending_images_array.length>0) {
          finalsubmissionbutton.disabled = "disabled"
          // console.log("waiting to in progress image")
          await delay30(200); 
          finalsubmissionbutton.disabled = ""
      }
    }
    
    editimageprompt = false;
    imagetobeedited = false;
    image_description = false;
    bubble.call(this, $$self, event);
  }
 
  function input0_change_handler() {
    // console.log("in input0_change_handler")
    const iframe = document.getElementById('iframe');
    iframe.classList.remove('horizontal-iframe');
    iframe.classList.add('vframe-iframe');
    isVerticalCustomNew = this.__value;
    finalIsVertical = this.__value;
    isVertical = this.__value;
    
    // console.log("isVertical----input0_change_handler---", isVertical)
    updated_is_vertical = isVertical
    $$invalidate(0, isVertical);
    if (cropper) {
      if (isVertical) cropper.initializeCropper(1);
      else cropper.initializeCropper(2);
    }
  }

  function square_change_handler() {
    // console.log("in square_change_handler")
    const iframe = document.getElementById('iframe');
    iframe.classList.remove('horizontal-iframe');
     iframe.classList.add('sframe-iframe');
    isVerticalCustomNew = "square";
    finalIsVertical = "square";
    isVertical = "square";
    updated_is_vertical = isVertical
    $$invalidate(0, isVertical);
    if (cropper) {
      cropper.initializeCropper(3);
      
    }
  }

  function input1_change_handler() {
    //  console.log("in input1_change_handler")
    const iframe = document.getElementById('iframe');
    iframe.classList.add('horizontal-iframe');
    iframe.classList.remove('vframe-iframe');
    isVertical = this.__value;
    finalIsVertical = this.__value;
    isVerticalCustomNew = this.__value;
    // console.log("isVertical----input1_change_handler---", isVertical)
    updated_is_vertical = isVertical
    $$invalidate(0, isVertical);
    if (cropper) {
      if (isVertical) cropper.initializeCropper(1);
      else cropper.initializeCropper(2);
    }
  }
  function input2_change_handler() {
    isTextToImage = this.__value;
    $$invalidate(1, isTextToImage), $$invalidate(0, isVertical);
  }
  const getCookiein = async (name) => {
    const cookies = document.cookie.split("; ");
    for (const cookie of cookies) {
      const [key, value] = cookie.split("=");
      if (key === name) return value;
    }
    return null;
  };
  async function input3_change_handler() {
    let tncpopup =  await getCookiein("popupopened");
    // if(!tncpopup) openTermsandConditionsModal()
    document.cookie = `popupopened=true`;
    isTextToImage = this.__value;

    $$invalidate(1, isTextToImage), $$invalidate(0, isVertical);
  }
  function textarea_input_handler() {
    prompt = this.value;
    $$invalidate(2, prompt),
      $$invalidate(1, isTextToImage),
      $$invalidate(0, isVertical);
  }
  function prompts_value_binding(value) {
    prompt = value;
    $$invalidate(2, prompt),
      $$invalidate(1, isTextToImage),
      $$invalidate(0, isVertical);
  }
  function imagetoimage_userImageUrl_binding(value) {
    userImageUrl = value;
    $$invalidate(3, userImageUrl);
  }
  function imagetoimage_hasUserUploadedImage_binding(value) {
    hasUserUploadedImage = value;
    $$invalidate(8, hasUserUploadedImage),
      $$invalidate(1, isTextToImage),
      $$invalidate(0, isVertical);
  }
  function input_input_handler() {
    prompt = this.value;
    $$invalidate(2, prompt),
      $$invalidate(1, isTextToImage),
      $$invalidate(0, isVertical);
  }
  function select_change_handler() {
    stylePreset = select_value(this);

    $$invalidate(4, stylePreset);
    $$invalidate(7, stylePresets);
  }
  function select_content_change_handler(v) {

    imageContentType = v;

    $$invalidate(23, imageContentType);
  }

  $$self.$$set = ($$props2) => {
    if ("lang" in $$props2) $$invalidate(5, (lang = $$props2.lang));
    if ("image" in $$props2) $$invalidate(10, (image = $$props2.image));
    if ("prompt" in $$props2) $$invalidate(2, (prompt = $$props2.prompt));
    if ("isLoading" in $$props2)
      $$invalidate(6, (isLoading = $$props2.isLoading));
    if ("isVertical" in $$props2)
      $$invalidate(0, (isVertical = $$props2.isVertical));
    if ("isTextToImage" in $$props2)
      $$invalidate(1, (isTextToImage = $$props2.isTextToImage));
    if ("userImageUrl" in $$props2)
      $$invalidate(3, (userImageUrl = $$props2.userImageUrl));
    if ("stylePreset" in $$props2)
      $$invalidate(4, (stylePreset = $$props2.stylePreset));
    if ("stylePresets" in $$props2)
      $$invalidate(7, (stylePresets = $$props2.stylePresets));
    if ("imageContentType" in $$props2)
      $$invalidate(23, (imageContentType = $$props2.imageContentType));
  };
  $$self.$$.update = () => {
    if ($$self.$$.dirty /*isVertical*/ & 1) {
      // !isVertical && $$invalidate(1, (isTextToImage = true));
      // !isTextToImage && $$invalidate(1, (isTextToImage = true));
      // $$invalidate(1, (isTextToImage = true));
    }
    if ($$self.$$.dirty /*isTextToImage*/ & 2) {
      $$invalidate(2, (prompt = ""));
    }
    if ($$self.$$.dirty /*isTextToImage*/ & 2) {
      !isTextToImage && $$invalidate(8, (hasUserUploadedImage = false));
    }
  };
  return [
    isVertical,
    isTextToImage,
    prompt,
    userImageUrl,
    stylePreset,
    lang,
    isLoading,
    stylePresets,
    hasUserUploadedImage,
    clearSelectedImage,
    image,
    submit_handler,
    input0_change_handler,
    $$binding_groups,
    input1_change_handler,
    input2_change_handler,
    input3_change_handler,
    textarea_input_handler,
    prompts_value_binding,
    imagetoimage_userImageUrl_binding,
    imagetoimage_hasUserUploadedImage_binding,
    input_input_handler,
    select_change_handler,
    imageContentType,
    select_content_change_handler,
    square_change_handler
  ];
}
class PromptForm extends SvelteComponent {
  constructor(options) {
    super();
    init(this, options, instance$4, create_fragment$5, safe_not_equal, {
      lang: 5,
      image: 10,
      prompt: 2,
      isLoading: 6,
      isVertical: 0,
      isTextToImage: 1,
      userImageUrl: 3,
      stylePreset: 4,
      stylePresets: 7,
      imageContentType: 23,
    });
  }
}
function create_fragment$4(ctx) {
  let div1;
  let div0;
  let t;
  let spinnersmall;
  let div1_class_value;
  let current;
  spinnersmall = new SpinnerSmall({});
  return {
    c() {
      div1 = element("div");
      div0 = element("div");
      div0.innerHTML = `<span></span>`;
      t = space();
      create_component(spinnersmall.$$.fragment);
      attr(
        div0,
        "class",
        "absolute top-0 left-0 w-full h-full bg-gray-950 bg-opacity-10 z-[1]"
      );

      if(finalIsVertical && finalIsVertical=="square"){

        attr(
          div1,
          "class",
          (div1_class_value =
            "squareload jjjjj relative overflow-hidden object-cover border-gray-300 border-2 rounded-md transition-all flex items-center justify-center animate-pulse " /*className*/ +
            ctx[0])
        );
      }
        else if(finalIsVertical=="true" || finalIsVertical==true ){
          attr(
            div1,
            "class",
            (div1_class_value =
              "varitcalload jjjjj relative overflow-hidden object-cover border-gray-300 border-2 rounded-md transition-all flex items-center justify-center animate-pulse " /*className*/ +
              ctx[0])
          );
        }
      else{

        attr(
           div1,
           "class",
           (div1_class_value =
             "horiload jjjjj relative overflow-hidden object-cover border-gray-300 border-2 rounded-md transition-all flex items-center justify-center animate-pulse " /*className*/ +
             ctx[0])
         );
      }
    },
    m(target, anchor) {
      insert(target, div1, anchor);
      append(div1, div0);
      append(div1, t);
      mount_component(spinnersmall, div1, null);
      current = true;
    },
    p(ctx2, [dirty]) {
      if (
        !current ||
        (dirty /*className*/ & 1 &&
          div1_class_value !==
            (div1_class_value =
              "horiload ccc relative overflow-hidden object-cover border-gray-300 border-2 rounded-md transition-all flex items-center justify-center animate-pulse " /*className*/ +
              ctx2[0]))
      ) {
        attr(div1, "class", div1_class_value);
      }
    },
    i(local) {
      if (current) return;
      transition_in(spinnersmall.$$.fragment, local);
      current = true;
    },
    o(local) {
      transition_out(spinnersmall.$$.fragment, local);
      current = false;
    },
    d(detaching) {
      if (detaching) detach(div1);
      destroy_component(spinnersmall);
    },
  };
}
function instance$3($$self, $$props, $$invalidate) {
  let { class: className } = $$props;
  $$self.$$set = ($$props2) => {
    if ("class" in $$props2) $$invalidate(0, (className = $$props2.class));
  };
  return [className];
}
class PlaceholderThumb extends SvelteComponent {
  constructor(options) {
    super();
    init(this, options, instance$3, create_fragment$4, safe_not_equal, {
      class: 0,
    });
  }
}
function get_each_context(ctx, list, i) {
  const child_ctx = ctx.slice();
  child_ctx[6] = list[i];

  return child_ctx;
}
function create_else_block(ctx) {
  let li;
  let button;
  let img;
  let img_src_value;
  let img_class_value;
  let t;
  let li_intro;
  let mounted;
  let dispose;
  return {
    c() {
      li = element("li");
      button = element("button");
      img = element("img");
      t = space();
      attr(img, "alt", "");
      if (
        !src_url_equal(
          img.src,
          (img_src_value =
            /*_image*/
            ctx[6].thumbnailImageURL /*_image*/ || ctx[6].src)
        )
      ){
        let width = 492
        if(ctx[6].isVertical) width = 373;
        let path = "https://webhook.wallart.ai/art"+img_src_value;
        if(img_src_value.includes("s3.us-east-1.amazonaws.com")) path = "https://webhook.wallart.ai/art"+img_src_value.replace(/^https?:\/\/[^/]+/, '');
        else if(img_src_value.includes("https://") && !img_src_value.includes("s3.us-east-1.amazonaws.com")) path = img_src_value;
     
        attr(img, "src", path);}
        let fsize = squareSize;
        if(/*_image*/ ctx[6].isVertical && ctx[6].isVertical!="square"){
          fsize = verticalSize;
        }else if(!ctx[6].isVertical){
          fsize = horizontalSize;
        }
      attr(
        img,
        "class",
        (img_class_value =
          "border-2 rounded-md object-cover " +
          fsize +
          " " /*checkIfIsActive*/ +
          (ctx[5](
            /*image*/
            ctx[0],
            /*_image*/
            ctx[6]
          )
            ? "border-gray-600"
            : "border-gray-300"))
      );
      button.disabled = /*isLoading*/ ctx[2];
      attr(button, "class", "relative overflow-hidden rounded-md outline-none");
    },
    m(target, anchor) {
      insert(target, li, anchor);
      append(li, button);
      append(button, img);
      append(li, t);
      if (!mounted) {
        dispose = listen(button, "mousedown", function () {
          if (
            is_function(
              /*selectImage*/
              ctx[4](
                /*image*/
                ctx[0],
                /*_image*/
                ctx[6]
              )
            )
          )
            ctx[4](
              /*image*/
              ctx[0],
              /*_image*/
              ctx[6]
            ).apply(this, arguments);
        });
        mounted = true;
      }
    },
    p(new_ctx, dirty) {
      ctx = new_ctx;
      if (
        dirty /*images*/ & 2 &&
        !src_url_equal(
          img.src,
          (img_src_value =
            /*_image*/
            ctx[6].thumbnailImageURL /*_image*/ || ctx[6].src)
        )
      ) {
        let path = "https://webhook.wallart.ai/art"+img_src_value;
        if(img_src_value.includes("s3.us-east-1.amazonaws.com")) path = "https://webhook.wallart.ai/art"+img_src_value.replace(/^https?:\/\/[^/]+/, '');
        else if(img_src_value.includes("https://") && !img_src_value.includes("s3.us-east-1.amazonaws.com")) path = img_src_value;
        // let path = "https://webhook.wallart.ai/art"+img_src_value.replace(/^https?:\/\/[^/]+/, '');
        // attr(img, "src", img_src_value);
        attr(img, "src", path);
      }
      if (
        dirty /*images, image*/ & 3 &&
        img_class_value !==
          (img_class_value =
            "border-2 rounded-md object-cover " +
            (!(/*_image*/ ctx[6].isVertical) ? verticalSize : horizontalSize) +
            " " /*checkIfIsActive*/ +
            (ctx[5](
              /*image*/
              ctx[0],
              /*_image*/
              ctx[6]
            )
              ? "border-gray-600"
              : "border-gray-300"))
      ) {
        attr(img, "class", img_class_value);
      }
      if (dirty /*isLoading*/ & 4) {
        button.disabled = /*isLoading*/ ctx[2];
      }
    },
    i(local) {
      if (!li_intro) {
        add_render_callback(() => {
          li_intro = create_in_transition(li, fade, {});
          li_intro.start();
        });
      }
    },
    o: noop$1,
    d(detaching) {
      if (detaching) detach(li);
      mounted = false;
      dispose();
    },
  };
}
function create_if_block$1(ctx) {
  let li;
  let placeholderthumb;
  let t;
  let li_intro;
  let current;
  placeholderthumb = new PlaceholderThumb({
    props: {
      class: !(/*isVertical*/ ctx[3]) ? verticalSize : horizontalSize,
    },
  });
  return {
    c() {
      li = element("li");
      create_component(placeholderthumb.$$.fragment);
      t = space();
    },
    m(target, anchor) {
      insert(target, li, anchor);
      mount_component(placeholderthumb, li, null);
      append(li, t);
      current = true;
    },
    p(ctx2, dirty) {
      const placeholderthumb_changes = {};
      if (dirty /*isVertical*/ & 8)
        placeholderthumb_changes.class = !(/*isVertical*/ ctx2[3])
          ? verticalSize
          : horizontalSize;
      placeholderthumb.$set(placeholderthumb_changes);
    },
    i(local) {
      if (current) return;
      transition_in(placeholderthumb.$$.fragment, local);
      if (!li_intro) {
        add_render_callback(() => {
          li_intro = create_in_transition(li, fade, {});
          li_intro.start();
        });
      }
      current = true;
    },
    o(local) {
      transition_out(placeholderthumb.$$.fragment, local);
      current = false;
    },
    d(detaching) {
      if (detaching) detach(li);
      destroy_component(placeholderthumb);
    },
  };
}
function create_each_block(ctx) {
  let current_block_type_index;
  let if_block;
  let if_block_anchor;
  let current;
  const if_block_creators = [create_if_block$1, create_else_block];
  const if_blocks = [];
  function select_block_type(ctx2, dirty) {
    if (!(/*_image*/ ctx2[6].src)) return 0;
    return 1;
  }
  current_block_type_index = select_block_type(ctx);
  if_block = if_blocks[current_block_type_index] =
    if_block_creators[current_block_type_index](ctx);
  return {
    c() {
      if_block.c();
      if_block_anchor = empty();
    },
    m(target, anchor) {
      if_blocks[current_block_type_index].m(target, anchor);
      insert(target, if_block_anchor, anchor);
      current = true;
    },
    p(ctx2, dirty) {
      let previous_block_index = current_block_type_index;
      current_block_type_index = select_block_type(ctx2);
      if (current_block_type_index === previous_block_index) {
        if_blocks[current_block_type_index].p(ctx2, dirty);
      } else {
        group_outros();
        transition_out(if_blocks[previous_block_index], 1, 1, () => {
          if_blocks[previous_block_index] = null;
        });
        check_outros();
        if_block = if_blocks[current_block_type_index];
        if (!if_block) {
          if_block = if_blocks[current_block_type_index] =
            if_block_creators[current_block_type_index](ctx2);
          if_block.c();
        } else {
          if_block.p(ctx2, dirty);
        }
        transition_in(if_block, 1);
        if_block.m(if_block_anchor.parentNode, if_block_anchor);
      }
    },
    i(local) {
      if (current) return;
      transition_in(if_block);
      current = true;
    },
    o(local) {
      transition_out(if_block);
      current = false;
    },
    d(detaching) {
      if_blocks[current_block_type_index].d(detaching);
      if (detaching) detach(if_block_anchor);
    },
  };
}
function create_fragment$3(ctx) {
  let ul;
  let current;
  let div;  // ADD
  let each_value =
    /*images*/
    ctx[1];
  let each_blocks = [];
  for (let i = 0; i < each_value.length; i += 1) {
    each_blocks[i] = create_each_block(get_each_context(ctx, each_value, i));
  }
  const out = (i) =>
    transition_out(each_blocks[i], 1, 1, () => {
      each_blocks[i] = null;
    });
  return {
    c() {
       div = element("div");  // ADD
      ul = element("ul");
      for (let i = 0; i < each_blocks.length; i += 1) {
        each_blocks[i].c();
      }
       attr(div, "class", "scrolldiv");  // ADD - apni class yahan likho
      attr(
        ul,
        "class",
        "thumbs-list fwrap w-full gap-2 flex items-start justify-start list-none p-0 max-w-[100%]"
      );
    },
    m(target, anchor) {
      insert(target, div, anchor);  // ul ki jagah div
  append(div, ul); 
      for (let i = 0; i < each_blocks.length; i += 1) {
        if (each_blocks[i]) {
          each_blocks[i].m(ul, null);
        }
      }
      current = true;
    },
    p(ctx2, [dirty]) {
      if (
        dirty /*isVertical, verticalSize, horizontalSize, images, isLoading, selectImage, image, checkIfIsActive*/ &
        63
      ) {
        each_value = /*images*/ ctx2[1];
        let i;
        for (i = 0; i < each_value.length; i += 1) {
          const child_ctx = get_each_context(ctx2, each_value, i);
          if (each_blocks[i]) {
            each_blocks[i].p(child_ctx, dirty);
            transition_in(each_blocks[i], 1);
          } else {
            each_blocks[i] = create_each_block(child_ctx);
            each_blocks[i].c();
            transition_in(each_blocks[i], 1);
            each_blocks[i].m(ul, null);
          }
        }
        group_outros();
        for (i = each_value.length; i < each_blocks.length; i += 1) {
          out(i);
        }
        check_outros();
      }
    },
    i(local) {
      if (current) return;
      for (let i = 0; i < each_value.length; i += 1) {
        transition_in(each_blocks[i]);
      }
      current = true;
    },
    o(local) {
      each_blocks = each_blocks.filter(Boolean);
      for (let i = 0; i < each_blocks.length; i += 1) {
        transition_out(each_blocks[i]);
      }
      current = false;
    },
   d(detaching) {
  if (detaching) detach(div);  // ul ki jagah div
  destroy_each(each_blocks, detaching);
},
  };
}
const squareSize = "w-16 h-16 min-w-[4rem]";
const verticalSize = "w-16 h-12 min-w-[4rem]";
const horizontalSize = "h-16 w-12 min-w-[3rem]";
function instance$2($$self, $$props, $$invalidate) {
  let { image = {} } = $$props;
  let { images = [] } = $$props;
  let { isLoading = false } = $$props;
  let { isVertical = false } = $$props;
  const selectImage = (currImage, _image) => () => {
    // console.log("selectImage _image-------------------", _image)
    const iframe = document.getElementById('iframe');
    const iframeDoc = iframe.contentWindow.document;
    // if(_image.isVertical && _image.isVertical=="square"){
    //   iframe.classList.add('sframe-iframe');
    //     iframe.classList.remove('horizontal-iframe');
    //     iframe.classList.remove('vframe-iframe');
    // }else
    // if(_image.isVertical){
      
    //     iframe.classList.remove('horizontal-iframe');
    //     iframe.classList.add('vframe-iframe');
    //      iframe.classList.remove('sframe-iframe');
    // }else{
    //     iframe.classList.add('horizontal-iframe');
    //     iframe.classList.remove('vframe-iframe');
    //     iframe.classList.remove('sframe-iframe');
    // }
        let width = 492
    let height = 492
    if(_image.isVertical=="square"){
      // console.log("in square")
      iframe.classList.add('sframe-iframe');
        iframe.classList.remove('horizontal-iframe');
        iframe.classList.remove('vframe-iframe');
    }else
    if(_image.isVertical=="true" || _image.isVertical==true){
      // console.log("in vertical")
        width = 373
        height = 492
        iframe.classList.remove('horizontal-iframe');
        iframe.classList.add('vframe-iframe');
         iframe.classList.remove('sframe-iframe');
    }else if(_image.isVertical=="false" || _image.isVertical==false){
      // console.log("in horizontal")
        width = 492
        height =  373 
        iframe.classList.add('horizontal-iframe');
        iframe.classList.remove('vframe-iframe');
        iframe.classList.remove('sframe-iframe');
    }
    if (!customer_custom_store) {
      image_heart_div_a_heart.innerHTML = `<img src="https://cdn.shopify.com/s/files/1/0736/6996/8165/files/heart_928c8372-a4f0-4170-b92e-7e85df333d90.png?v=1754312124" width="25px" height="25px">`;
    } else if (check_wishlist(_image.src)) {
      image_heart_div_a_heart.innerHTML = `<img src="https://cdn.shopify.com/s/files/1/0736/6996/8165/files/heart_1.png?v=1754370383" width="25px" height="25px">`;
    } else {
      image_heart_div_a_heart.innerHTML = `<img src="https://cdn.shopify.com/s/files/1/0736/6996/8165/files/heart_928c8372-a4f0-4170-b92e-7e85df333d90.png?v=1754312124" width="25px" height="25px">`;
    }
    const text ="Check out what I just created using A.I.!  Create one-of-a-kind art for your wall in seconds \n\n";
    let s3Key = _image.s3Url.replace(/^https?:\/\/[^/]+/, '');
    let url = `https://wallart.ai/products/ai-art-canvas?src=${s3Key}`;
    maindisplayimagediv.innerHTML = `<div class="mfull ccccc"><a href="/products/ai-art-canvas?src=${s3Key}" target="_parent"><p class="text-lg font-bold leading-tight">🔎 CLICK TO ENLARGE</p> 
              <p class="font-bold">and view purchase options</p></a></div>`;
    append(maindisplayimagediv, openOverLayBtn);
 
    // if ( _image.src.includes(currImage.src) ||  currImage.src.includes(_image.src)) return;
    // if(!_image.src.includes("?width=")) _image.src = _image.src+`?width=${width}`
    // setImageToURL(_image);
    if (currImage.src == _image.src) return;
    setImageToURL(_image);

      setTimeout(function(){
        let twitterShareLink = buildShareLink("twitter", {
          url,
          text,
          imageUrl: url,
          description: text
        })
        let facebookShareLink = buildShareLink("facebook", {
          url,
          text,
          imageUrl: url,
          description: text,
        })
        let pinterestShareLink = buildShareLink("pinterest", {
          url,
          text,
          imageUrl: url,
          description: text,
        })
        try{
          // const iframe = document.getElementById('iframe');
          // const iframeDoc = iframe.contentWindow.document;
          iframeDoc.getElementById("twitterlink").setAttribute("href", twitterShareLink);
          iframeDoc.getElementById("facebooklink").setAttribute("href", facebookShareLink);
          iframeDoc.getElementById("pinterestlink").setAttribute("href", pinterestShareLink);
        }catch(err){
          console.log(err)
        }
      },50)




    $$invalidate(0, (image = _image));
  };
  const checkIfIsActive = (image2, _image) => {
    
    // return image2.src && cleanImageSrc(image2.src) == cleanImageSrc(_image.src);
    return image2.src && image2.src == _image.src;
  };
  $$self.$$set = ($$props2) => {
    // console.log("in set loading")
    if ("image" in $$props2) $$invalidate(0, (image = $$props2.image));
    if ("images" in $$props2) $$invalidate(1, (images = $$props2.images));
    if ("isLoading" in $$props2)
      $$invalidate(2, (isLoading = $$props2.isLoading));
    if ("isVertical" in $$props2)
      $$invalidate(3, (isVertical = $$props2.isVertical));
  };
  return [image, images, isLoading, isVertical, selectImage, checkIfIsActive];
}
class ImageGallery extends SvelteComponent {
  constructor(options) {
    super();
    init(this, options, instance$2, create_fragment$3, safe_not_equal, {
      image: 0,
      images: 1,
      isLoading: 2,
      isVertical: 3,
    });
  }
}
async function getDefaultProductCartDetail() {
  const data = { currency: "USD", productId: 8207159230757 };
  fetch("https://webhook.wallart.ai/getProductDetail", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(data),
  })
    .then((response) => response.json())
    .then((data) => {
      if (data.error == false) {
        product_cart_detail = data.data;
      }
    });
  return true;
}
async function getwishlistItem(customerId) {
  const data = { customerId: customerId };
  fetch("https://webhook.wallart.ai/getwishlistItems", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(data),
  })
    .then((response) => response.json())
    .then((data) => {
      if (data.error == false) {
        wishlist_item = data.wishlist.map((item) => {
          wishlist_uniqueId[item.productSourceImage] = item;
          return item.productSourceImage;
        });
      }
    });
  return true;
}
function check_wishlist(imageURL) {
  if (wishlist_item.includes(imageURL)) return true;
  return false;
}

function create_fragment$2(ctx) {
  if (customer_custom_store) getwishlistItem(customer_custom_store);
  // if (customer_custom_store) getDefaultProductCartDetail();
  getDefaultProductCartDetail();
  let section;
  let div3;
  let div0;
  let promptform;
  let updating_prompt;
  let updating_isLoading;
  let updating_isVertical;
  let updating_stylePresets;
  let updating_stylePreset;
  let updating_userImageUrl;
  let updating_isCropperOpen;
  let updating_isTextToImage;
  let updating_image;
  let t0;
  // let div2_imagehistory;
  let canvas;
  let updating_image_1;
  let updating_isLoading_1;
  let updating_isVertical_1;
  let updating_isCropperOpen_1;
  let t1;
  
  let div4; // New div for "Generated Art"
  let t2; // Text node for "Generated Art"
  let t3; // New space before ImageGallery
  let div5;     // hint container
  let span;     // bulb emoji span
  let loginLink;   // “Login” link
  let orText;      // “ or ” text
  let regLink;     // “Register” link
  let t4;       // "HINT: " text
  let t5;       // " to save favorites!" text

  let imagegallery;
  let updating_image_2;
  let updating_isVertical_2;
  let updating_images;
  let updating_isTextToImage_1;
  let div1_class_value;
  let current;

  // PromptForm bindings (unchanged)
  function promptform_prompt_binding(value) {
    ctx[17](value);
  }
  function promptform_isLoading_binding(value) {
    ctx[18](value);
  }
  function promptform_isVertical_binding(value) {
    ctx[19](value);
  }
  function promptform_stylePresets_binding(value) {
    ctx[20](value);
  }
  function promptform_stylePreset_binding(value) {
    ctx[21](value);
  }
  function promptform_imagecontenttype_binding(value) {
    ctx[34](value);
  }
  function promptform_userImageUrl_binding(value) {
    ctx[22](value);
  }
  function promptform_isCropperOpen_binding(value) {
    ctx[23](value);
  }
  function promptform_isTextToImage_binding(value) {
    ctx[24](value);
  }
  function promptform_image_binding(value) {
    ctx[25](value);
  }
  let promptform_props = {
    lang: /*lang*/ ctx[11],
  };
  if (/*prompt*/ ctx[1] !== void 0) {
    promptform_props.prompt = /*prompt*/ ctx[1];
  }
  if (/*isLoading*/ ctx[2] !== void 0) {
    promptform_props.isLoading = /*isLoading*/ ctx[2];
  }
  if (/*isVertical*/ ctx[3] !== void 0) {
    promptform_props.isVertical = /*isVertical*/ ctx[3];
  }
  if (/*stylePresets*/ ctx[9] !== void 0) {
    promptform_props.stylePresets = /*stylePresets*/ ctx[9];
  }
  if (/*stylePreset*/ ctx[10] !== void 0) {
    promptform_props.stylePreset = /*stylePreset*/ ctx[10];
  }
  if (/*imageContentType*/ ctx[35] !== void 0) {
    promptform_props.imageContentType = /*imageContentType*/ ctx[35];
  }
  if (/*userImageUrl*/ ctx[5] !== void 0) {
    promptform_props.userImageUrl = /*userImageUrl*/ ctx[5];
  }
  if (/*isCropperOpen*/ ctx[4] !== void 0) {
    promptform_props.isCropperOpen = /*isCropperOpen*/ ctx[4];
  }
  if (/*isTextToImage*/ ctx[0] !== void 0) {
    promptform_props.isTextToImage = /*isTextToImage*/ ctx[0];
  }
  if (/*selectedImage*/ ctx[6] !== void 0) {
    promptform_props.image = /*selectedImage*/ ctx[6];
  }
  promptform = new PromptForm({ props: promptform_props });
  binding_callbacks.push(() =>
    bind$2(promptform, "prompt", promptform_prompt_binding)
  );
  binding_callbacks.push(() =>
    bind$2(promptform, "isLoading", promptform_isLoading_binding)
  );
  binding_callbacks.push(() =>
    bind$2(promptform, "isVertical", promptform_isVertical_binding)
  );
  binding_callbacks.push(() =>
    bind$2(promptform, "stylePresets", promptform_stylePresets_binding)
  );
  binding_callbacks.push(() =>
    bind$2(promptform, "stylePreset", promptform_stylePreset_binding)
  );
  binding_callbacks.push(() =>
    bind$2(promptform, "userImageUrl", promptform_userImageUrl_binding)
  );
  binding_callbacks.push(() =>
    bind$2(promptform, "isCropperOpen", promptform_isCropperOpen_binding)
  );
  binding_callbacks.push(() =>
    bind$2(promptform, "isTextToImage", promptform_isTextToImage_binding)
  );
  binding_callbacks.push(() =>
    bind$2(promptform, "image", promptform_image_binding)
  );
  binding_callbacks.push(() =>
    bind$2(promptform, "imageContentType", promptform_imagecontenttype_binding)
  );
  promptform.$on("submit", /*generateImagesInSequence*/ ctx[14]);

  // Canvas bindings (unchanged)
  function canvas_image_binding(value) {
    ctx[26](value);
  }
  function canvas_isLoading_binding(value) {
    ctx[27](value);
  }
  function canvas_isVertical_binding(value) {
    ctx[28](value);
  }
  function canvas_isCropperOpen_binding(value) {
    ctx[29](value);
  }
  let canvas_props = {
    lang: /*lang*/ ctx[11],
    linkHref: /*productURL*/ ctx[12],
    isTextToImage: /*isTextToImage*/ ctx[0],
    backgroundImageSrc: /*backgroundImageSrc*/ ctx[13],
  };
  if (/*selectedImage*/ ctx[6] !== void 0) {
    canvas_props.image = /*selectedImage*/ ctx[6];
  }
  if (/*isLoading*/ ctx[2] !== void 0) {
    canvas_props.isLoading = /*isLoading*/ ctx[2];
  }
  if (/*isVertical*/ ctx[3] !== void 0) {
    canvas_props.isVertical = /*isVertical*/ ctx[3];
  }
  if (/*isCropperOpen*/ ctx[4] !== void 0) {
    canvas_props.isCropperOpen = /*isCropperOpen*/ ctx[4];
  }
  canvas_props.generateImagesInSequence = /*generateImagesInSequence*/ctx[14]
  canvas = new Canvas({ props: canvas_props });
  binding_callbacks.push(() => bind$2(canvas, "image", canvas_image_binding));
  binding_callbacks.push(() =>
    bind$2(canvas, "isLoading", canvas_isLoading_binding)
  );
  binding_callbacks.push(() =>
    bind$2(canvas, "isVertical", canvas_isVertical_binding)
  );
  binding_callbacks.push(() =>
    bind$2(canvas, "isCropperOpen", canvas_isCropperOpen_binding)
  );

  // ImageGallery bindings (unchanged)
  function imagegallery_image_binding(value) {
    ctx[30](value);
  }
  function imagegallery_isVertical_binding(value) {
    ctx[31](value);
  }
  function imagegallery_images_binding(value) {
    ctx[32](value);
  }
  function imagegallery_isTextToImage_binding(value) {
    ctx[33](value);
  }
  let imagegallery_props = {
    isLoading: /*isLoading*/ ctx[2],
  };
  if (/*selectedImage*/ ctx[6] !== void 0) {
    imagegallery_props.image = /*selectedImage*/ ctx[6];
  }
  if (/*isVertical*/ ctx[3] !== void 0) {
    imagegallery_props.isVertical = /*isVertical*/ ctx[3];
  }
  if (/*imagesHistory*/ ctx[8] !== void 0) {
    imagegallery_props.images = /*imagesHistory*/ ctx[8];
  }
  if (/*isTextToImage*/ ctx[0] !== void 0) {
    imagegallery_props.isTextToImage = /*isTextToImage*/ ctx[0];
  }
  imagegallery = new ImageGallery({ props: imagegallery_props });
  binding_callbacks.push(() =>
    bind$2(imagegallery, "image", imagegallery_image_binding)
  );
  binding_callbacks.push(() =>
    bind$2(imagegallery, "isVertical", imagegallery_isVertical_binding)
  );
  binding_callbacks.push(() =>
    bind$2(imagegallery, "images", imagegallery_images_binding)
  );
  binding_callbacks.push(() =>
    bind$2(imagegallery, "isTextToImage", imagegallery_isTextToImage_binding)
  );

  return {
    c() {
      section = element("section");
      div3 = element("div");
      div0 = element("div");
      create_component(promptform.$$.fragment);
      t0 = space();
      div2_imagehistory = element("div");
      create_component(canvas.$$.fragment);
      t1 = space();
      div1_image_history = element("div");
      div4 = element("div"); // New div for "Generated Art"
      t2 = text$1("Generated Art"); // Text node for "Generated Art"
      t3 = space(); // New space before ImageGallery
            // Hint only if not logged in
    
      if (!customer_custom_store){
      


          div5      = element("div");
          t4 = element("strong");
          append(t4, text$1("HINT:"));
          span      = element("span");
          loginLink = element("a");
          orText    = text$1(" or ");
          regLink   = element("a");

          t5        = text$1(" to save Favorites!");
          // ---- Login link ----
          attr(loginLink, "href", "javascript:void(0);");
          attr(loginLink, "class", "underline text-blue-600 cursor-pointer csd");
          loginLink.onclick = () => openLoginModal && openLoginModal("login");
          append(loginLink, text$1("Login"));

          // ---- Register link ----
          attr(regLink, "href", "javascript:void(0);");
          attr(regLink, "class", "underline text-blue-600 cursor-pointer csd");
          regLink.onclick = () => openLoginModal && openLoginModal("register");   // ← change to openRegisterModal() if you have it
          append(regLink, text$1("Register"));

          append(div5, t4);
          append(div5, span);
          //append(span, text$1("light_bulb"));
          append(div5, loginLink);
          append(div5, orText);
          append(div5, regLink);
          append(div5, t5);

          attr(div5, "class", "w-full text-left text-sm text-gray-600 mb-4 posabtbtm");
          // attr(span, "class", "inline-block mr-1");
     }
      create_component(imagegallery.$$.fragment);
      attr(div0, "class", "mx-450 md:flex-[0_1_16prem] flex-1 w-full h-full");
      attr(div1_image_history, "id", "image_history_tab");
      attr(
        div1_image_history,
        "class",
        (div1_class_value =
          "Flex3art w-full overflow-auto max-w-full mt-4 " /*isLoadingHistory*/ +
          (ctx[7] ? "opacity-100" : "opacity-100"))
      );
      attr(div2_imagehistory, "class", "w-full overflow-x-auto mymobile1");
      attr(div4, "class", "w-full text-left text-lg font-semibold mb-4"); // Styling for new div
      if (!customer_custom_store) {
        attr(div5, "class", "w-full text-left text-sm text-gray-600 mb-4 posabtbtm"); // Styling for hint div
       attr(span, "class", "inline-block mr-1"); // Styling for bulb span
     }
      attr(
        div3,
        "class",
        "flex flex-col-reverse items-start justify-between gap-0 md:flex-row pt-12 md:gap-16 pb-14"
      );
    },
    m(target, anchor) {
      insert(target, section, anchor);
      append(section, div3);
      append(div3, div0);
      mount_component(promptform, div0, null);
      append(div3, t0);
      append(div3, div2_imagehistory);
      mount_component(canvas, div2_imagehistory, null);
      append(div3, t1);
      append(div3, div1_image_history);
      append(div1_image_history, div4); // Append new div inside div1_image_history
      append(div4, t2); // Append "Generated Art" text
      append(div1_image_history, t3); // Append space before ImageGallery
     if (!customer_custom_store) {
        append(div1_image_history, div5);
      }
      mount_component(imagegallery, div1_image_history, null);
      current = true;
    },
    p(ctx2, dirty) {
      const promptform_changes = {};
      if (!updating_prompt && dirty[0] /*prompt*/ & 2) {
        updating_prompt = true;
        promptform_changes.prompt = /*prompt*/ ctx2[1];
        add_flush_callback(() => (updating_prompt = false));
      }
      if (!updating_isLoading && dirty[0] /*isLoading*/ & 4) {
        updating_isLoading = true;
        promptform_changes.isLoading = /*isLoading*/ ctx2[2];
        add_flush_callback(() => (updating_isLoading = false));
      }
      if (!updating_isVertical && dirty[0] /*isVertical*/ & 8) {
        updating_isVertical = true;
        promptform_changes.isVertical = /*isVertical*/ ctx2[3];
        add_flush_callback(() => (updating_isVertical = false));
      }
      if (!updating_stylePresets && dirty[0] /*stylePresets*/ & 512) {
        updating_stylePresets = true;
        promptform_changes.stylePresets = /*stylePresets*/ ctx2[9];
        add_flush_callback(() => (updating_stylePresets = false));
      }
      if (!updating_stylePreset && dirty[0] /*stylePreset*/ & 1024) {
        updating_stylePreset = true;
        promptform_changes.stylePreset = /*stylePreset*/ ctx2[10];
        add_flush_callback(() => (updating_stylePreset = false));
      }
      if (!updating_userImageUrl && dirty[0] /*userImageUrl*/ & 32) {
        updating_userImageUrl = true;
        promptform_changes.userImageUrl = /*userImageUrl*/ ctx2[5];
        add_flush_callback(() => (updating_userImageUrl = false));
      }
      if (!updating_isCropperOpen && dirty[0] /*isCropperOpen*/ & 16) {
        updating_isCropperOpen = true;
        promptform_changes.isCropperOpen = /*isCropperOpen*/ ctx2[4];
        add_flush_callback(() => (updating_isCropperOpen = false));
      }
      if (!updating_isTextToImage && dirty[0] /*isTextToImage*/ & 1) {
        updating_isTextToImage = true;
        promptform_changes.isTextToImage = /*isTextToImage*/ ctx2[0];
        add_flush_callback(() => (updating_isTextToImage = false));
      }
      if (!updating_image && dirty[0] /*selectedImage*/ & 64) {
        updating_image = true;
        promptform_changes.image = /*selectedImage*/ ctx2[6];
        add_flush_callback(() => (updating_image = false));
      }
      promptform.$set(promptform_changes);

      const canvas_changes = {};
      if (dirty[0] /*isTextToImage*/ & 1)
        canvas_changes.isTextToImage = /*isTextToImage*/ ctx2[0];
      if (!updating_image_1 && dirty[0] /*selectedImage*/ & 64) {
        updating_image_1 = true;
        canvas_changes.image = /*selectedImage*/ ctx2[6];
        add_flush_callback(() => (updating_image_1 = false));
      }
      if (!updating_isLoading_1 && dirty[0] /*isLoading*/ & 4) {
        updating_isLoading_1 = true;
        canvas_changes.isLoading = /*isLoading*/ ctx2[2];
        add_flush_callback(() => (updating_isLoading_1 = false));
      }
      if (!updating_isVertical_1 && dirty[0] /*isVertical*/ & 8) {
        updating_isVertical_1 = true;
        canvas_changes.isVertical = /*isVertical*/ ctx2[3];
        add_flush_callback(() => (updating_isVertical_1 = false));
      }
      if (!updating_isCropperOpen_1 && dirty[0] /*isCropperOpen*/ & 16) {
        updating_isCropperOpen_1 = true;
        canvas_changes.isCropperOpen = /*isCropperOpen*/ ctx2[4];
        add_flush_callback(() => (updating_isCropperOpen_1 = false));
      }
      canvas.$set(canvas_changes);

      const imagegallery_changes = {};
      if (dirty[0] /*isLoading*/ & 4)
        imagegallery_changes.isLoading = /*isLoading*/ ctx2[2];
      if (!updating_image_2 && dirty[0] /*selectedImage*/ & 64) {
        updating_image_2 = true;
        imagegallery_changes.image = /*selectedImage*/ ctx2[6];
        add_flush_callback(() => (updating_image_2 = false));
      }
      if (!updating_isVertical_2 && dirty[0] /*isVertical*/ & 8) {
        updating_isVertical_2 = true;
        imagegallery_changes.isVertical = /*isVertical*/ ctx2[3];
        add_flush_callback(() => (updating_isVertical_2 = false));
      }
      if (!updating_images && dirty[0] /*imagesHistory*/ & 256) {
        updating_images = true;
        imagegallery_changes.images = /*imagesHistory*/ ctx2[8];
        add_flush_callback(() => (updating_images = false));
      }
      if (!updating_isTextToImage_1 && dirty[0] /*isTextToImage*/ & 1) {
        updating_isTextToImage_1 = true;
        imagegallery_changes.isTextToImage = /*isTextToImage*/ ctx2[0];
        add_flush_callback(() => (updating_isTextToImage_1 = false));
      }
      imagegallery.$set(imagegallery_changes);

      if (
        !current ||
        (dirty[0] /*isLoadingHistory*/ & 128 &&
          div1_class_value !==
            (div1_class_value =
              "Flex3art w-full overflow-auto max-w-full mt-4 " /*isLoadingHistory*/ +
              (ctx2[7] ? "opacity-0" : "opacity-100")))
      ) {
        attr(div1_image_history, "class", div1_class_value);
      }
    },
    i(local) {
      if (current) return;
      transition_in(promptform.$$.fragment, local);
      transition_in(canvas.$$.fragment, local);
      transition_in(imagegallery.$$.fragment, local);
      current = true;
    },
    o(local) {
      transition_out(promptform.$$.fragment, local);
      transition_out(canvas.$$.fragment, local);
      transition_out(imagegallery.$$.fragment, local);
      current = false;
    },
    d(detaching) {
      if (detaching) detach(section);
      destroy_component(promptform);
      destroy_component(canvas);
      destroy_component(imagegallery);
    },
  };
}



function instance$1($$self, $$props, $$invalidate) {
   
    var _a2, _b2;
    let { auth: auth2, parentFrame } = $$props;
    let prompt = "";
    let isLoading = false;
    let isVertical = false;
    let isTextToImage = true;
    let isCropperOpen = false;
    let userImageUrl = "";
    let selectedImage = {};
    let lang = global$1.lang;
    let isLoadingHistory = true;
    let productURL =
      (_a2 = global$1 == null ? void 0 : global$1.product) == null
      ? void 0
      : _a2.handle;
    let imagesHistory = global$1.galleryImages;

    let backgroundImageSrc = global$1.backgroundImageSrc;
    let stylePresets, stylePreset, imageContentType;
    const uid = { uid: generateSimpleId() };
    const prepare_image_data = async (imageid, key, props, seed = false, action = false, convertedprompt=false, selectedPreset, random_style=false)=>{
        try {
            if(random_style) selectedPreset = pickStylePreset(stylePresets, selectedPreset);
             // get styles from the selected style preset
            let formdata = false;
            if(editimageprompt && imagetobeedited){ // if image is being edited and process is not interrupted
                    formdata={
                        "imageid": imageid,
                        editimageprompt,
                        ...props,
                        imageUrl: imagetobeedited,
                        seed: seed,
                        action: action,
                        convertedprompt:convertedprompt,
                        createcompositionsame:  compositioncheckbox?.checked,
                        processingstate:false
                    }
              
            }else {
              // console.log("userImageUrl------------", userImageUrl)
                    formdata={
                      "imageid": imageid,
                      prompt,
                      ...props,
                      imageContentType: imageContentType ? imageContentType : false,
                      stylePreset: selectedPreset,
                      imageUrl: userImageUrl,
                      seed: seed,
                      action: action,
                      custom_style: input_custom_style?.value,
                      convertedprompt:convertedprompt,
                      createcompositionsame:  compositioncheckbox?.checked,
                      processingstate:false
                    }
            }
            return formdata;
        } catch (error) {
          throw `${key} error: ${error}`;
        }
    }
    const generateImage = async (key, formdata, newprompt, isTextToImage_in_progress) => {
      
      let imageid = formdata.imageid;
      // Scroll the window to the top while generating first image so that user can see the progesss
      if(formdata.action == "same"){

        parent.window.scrollTo(0, 0);
        if(window.screen.width<=768){
          const iframe = document.getElementById('iframe');
          const iframeDoc = iframe.contentWindow.document;
          iframeDoc.querySelectorAll(".thumbs-list").forEach(el => el.style.transform = "translateY(0px)");
        }else{
          div1_image_history.scrollTo({ top: 0, behavior: 'smooth' })
        }
      }
    
    try {
      const generate = isTextToImage_in_progress
      ? generateImageFromText
      : generateImageFromImage; // define functions based on conditions


      let selectedValue = false;
      let response=false

      if(editimageprompt && imagetobeedited && !process_interrupted){ // if image is being edited and process is not interrupted
            // console.log("in editor------------")
             response = await editimage(formdata);
      }else if(!process_interrupted){
            formdata.convertedprompt = newprompt
            response = await generate(formdata);
      }else{
            alert("in Process Interrupted")
            throw "Process Interrupted"
      }

      if (response && response.error) {
            process_interrupted = true
            generated_image_array = []
            try{
              const iframe = document.getElementById('iframe');
              const iframeDoc = iframe.contentWindow.document;
              iframeDoc.getElementById("edit-image").classList.remove("hidden");
              iframeDoc.getElementById("hreartunhearticon").classList.remove("hidden");
            }
            catch(err){
              console.log(err)
            }
            if (response.message == "Please do signup to generate more images."){
              if(editimageprompt && imagetobeedited){
              }else{
                formdata.imageUrl = croppedimages3bucketurl;
                formdata.image_detail = image_detail
                formdata.stylePreset = stylePreset
              }
              if(!image_generation_error) openprompttoreached20Modal(formdata)
            }else
          if (response.message == "Image generation timed out"){
              if(editimageprompt && imagetobeedited){
              }else{
                formdata.imageUrl = croppedimages3bucketurl;
                formdata.image_detail = image_detail
                formdata.stylePreset = stylePreset
              }
              if(!image_generation_error) openerrormodalcontentModal("Process can not be completed right now, Please try again")
                
            }
          
            else if (response.message == "Insufficient credits"){
                if(editimageprompt && imagetobeedited){
                    editimageprompt = false 
                    imagetobeedited = false
                    formDetailHistory = false
                    image_description = false
                }
                if(!image_generation_error)  alert("Insufficient credits");
            }else if (response.message == "Text contains a banned content"){
                if(editimageprompt && imagetobeedited){
                    editimageprompt = false 
                    imagetobeedited = false
                    formDetailHistory = false
                    image_description = false
                }
                if(!image_generation_error) openerrormodalcontentModal(response.message)
            }else if(response.message=="Content flagged as potentially sensitive. Please try different prompts or images"){
                if(editimageprompt && imagetobeedited){
                    editimageprompt = false 
                    imagetobeedited = false
                    formDetailHistory = false
                    image_description = false
                }
                if(!image_generation_error) openerrormodalcontentModal(response.message)
            }else if(response.message=="You’ve reached your daily limit of 120."){
                if(editimageprompt && imagetobeedited){
                    editimageprompt = false 
                    imagetobeedited = false
                    formDetailHistory = false
                    image_description = false
                }
                if(!image_generation_error) openprompttoreacheddailylimitModal();
            }else{
                if(editimageprompt && imagetobeedited){
                    editimageprompt = false 
                    imagetobeedited = false
                    formDetailHistory = false
                    image_description = false
                }
                if(!image_generation_error) openerrormodalcontentModal(response.message)
            }
            maindisplayimagediv.style.display = "flex";
            image_heart_div_a_heart.style.display = "flex";
            customimagediv.style.display = "flex";
            div2prdernow.style.display = "block";
            loaderdiv.style.display="none";
            
            editimageprompt = false
            imagetobeedited = false
            formDetailHistory = false
            image_description = false
            image_generation_error = true;
            
            throw response.message;
      }
      
      return response;
    } catch (error) {
      
      console.error({ [key]: error });
      throw error
    }
  };

    const generateImagesInSequence = async () => {
      // console.log("in image generation")
      finalsubmissionbutton.disabled = "disabled"
      in_progress_prompt = prompt
      process_interrupted = false
      generated_image_array = []
      image_generation_error = false;
      ps = [false, false, false, false];
      let isTextToImage_in_progress = isTextToImage;
      if(!isTextToImage_in_progress)
        isVertical = finalIsVertical;

      if(formDetailHistory){
        isVertical =  (parseInt(formDetailHistory.height)>parseInt(formDetailHistory.width))?true:false;
      }

      in_progress_orientation = isVertical
      const delay3 = (ms) => new Promise(resolve => setTimeout(resolve, ms));
      const checkmaindivstatus = async (numprompts) => {
          while (maindisplayimagediv==undefined) {
            await delay3(100);
          }
          return true
      };
      await checkmaindivstatus();
      // CHECKING FOR MAIN DIV ui start from here
      maindisplayimagediv.style.display = "none";
      loaderdiv.style.display = "block";
      customimagediv.style.display = "none";
      div2prdernow.style.display = "none";
      image_heart_div_a_heart.style.display = "none";
      try{

          const iframe = document.getElementById('iframe');
          const iframeDoc = iframe.contentWindow.document;
          iframeDoc.getElementById("edit-image").classList.add("hidden");
          iframeDoc.getElementById("hreartunhearticon").classList.add("hidden");
      }
      catch(err){
          console.log(err)
      }
      // CHECKING FOR MAIN DIV ui end here
     
    try {
      $$invalidate(2, (isLoading = false));
      await delay2(100); 
      $$invalidate(2, (isLoading = true)); //started loader
      clearURLParams(); 
      
      //generate 4 or 3 different prompts if varied variation is selected and propmt is filled
      const generateprompts = async (promptstobegenerate, numberofprompts, type, image_detail )=>{
     
              let body = {
                "prompt":promptstobegenerate,
                "numberofprompts":numberofprompts,
                "isTextToImage":type,
                "image_detail":image_detail
              }
              return fetch("https://webhook.wallart.ai/generateprompts", {
                method: "POST",
                headers: {
                  "content-type": "application/json",
                },
                body: JSON.stringify(body),
              }).then((res) => res.json()).then(data=>{
                  ps = data.generatedprompt
                  
                  return true
              });
      }
      // run for image from image and check wheather the image detail is available
      const checkimagestatus = async (numprompts, formtype=false) => {
        while (get_image_detail=="in progress") {
            await delay2(100); 
        }
        if(formtype=="formhistory")
          generateprompts(formDetailHistory?.prompt, numprompts,false, formDetailHistory?.image_detail);
        else
          generateprompts(in_progress_prompt, numprompts,false, image_detail); //generate image pormpts for image from image varied composition
      };
     
      let numprompts = 3;
     
      // for current image generation both(imagefromimage and imagefromtext)
      if(in_progress_prompt && !isTextToImage_in_progress && !editimageprompt){
          checkimagestatus( numprompts); //image from image generate prompts variation
      }else 
      if(in_progress_prompt && isTextToImage_in_progress && !editimageprompt){  //for image from text whether its varied or same compositon in each case it will created 3 different prompts using base prompt
          generateprompts(in_progress_prompt, numprompts,isTextToImage_in_progress, false);
      }else if(!in_progress_prompt && !isTextToImage_in_progress && !editimageprompt){ }
      else if(editimageprompt){}
      const generateUniqueId = async ()=>{
          return Date.now().toString(36) + Math.random().toString(36).slice(2);
      }
      // main image generation function
      const replaceWithImage = async (
        index,
        label,
        imageData,
        newprompt,
        isTextToImage_in_progress
      ) => {
        let generatedbasecode = await generateImage(
          label,
          imageData,
          newprompt,
          isTextToImage_in_progress
        ); // start point to prepare data to be send to image generation api's
        
        let image = {};
        const base64StringImage = generatedbasecode; // Base64 string
       
        // console.log("imageData.width======================", imageData.width)
        // console.log("imageData.height======================", imageData.height)
        let tempvertical; 
        if(imageData.width==imageData.height){
          tempvertical = "square"
                      in_progress_orientation = "square"
                      finalIsVertical = "square"
                      image = {
                        src: `${base64StringImage.src}`,
                        prompt: "A simple wallart",
                        width: 1024,
                        height: 1024,
                        s3Url: `${base64StringImage.s3Url}`
                      };
        }else if(imageData.width>imageData.height){
           tempvertical = false
               in_progress_orientation = false
              finalIsVertical = false
              image = {
                src: `${base64StringImage.src}`,
                prompt: "A simple wallart",
                width: 1024,
                height: 768,
                s3Url: `${base64StringImage.s3Url}`
              };
        }else if(imageData.width<imageData.height){
          tempvertical = true
          in_progress_orientation = true
          finalIsVertical = true
          image = {
            src: `${base64StringImage.src}`,
            prompt: "A simple wallart",
            width: 768,
            height: 1024,
            s3Url: `${base64StringImage.s3Url}`
          };
        }
        
        
        const _image = { ...image, "isVertical":finalIsVertical, "in_progress_orientation":tempvertical };
        $$invalidate(6, (selectedImage = _image));
        $$invalidate(8, (imagesHistory[index] = _image), imagesHistory);
        $$invalidate(8, (imagesHistory = [...imagesHistory]));
        let isUserImage = false;
        const savedImage = {
          uid,
          name: image.image_name,
          "isVertical":finalIsVertical,
          "in_progress_orientation":tempvertical,
          isUserImage,
          src: image.src,
          s3Url: `${image.s3Url}`
        };
        $$invalidate(8, (imagesHistory[index] = savedImage), imagesHistory);
        $$invalidate(8, (imagesHistory = [...imagesHistory]));
        let seindex = index
        $$invalidate(6, (selectedImage = savedImage));
        setImageToURL(savedImage);
        let s3Key = savedImage.s3Url.replace(/^https?:\/\/[^/]+/, '');
        maindisplayimagediv.innerHTML = `<div><a href="/products/ai-art-canvas?src=${s3Key}&isVertical=${savedImage.isVertical}" target="_parent"><p class="text-lg font-bold leading-tight">🔎 CLICK TO ENLARGE</p> 
            <p class="font-bold">and view purchase options</p></a></div>`;
        maindisplayimagediv.style.display = "flex";
        customimagediv.style.display = "flex";
        div2prdernow.style.display = "block";
        image_heart_div_a_heart.style.display = "flex";
        loaderdiv.style.display="none";
        setTimeout(() => {
          $$invalidate(2, (isLoading = false));
        }, 2000);
       
      };
      let check_customer_id = customer_custom_store
      let check_ip_address = device_ip
      //get the ip address to save it in db
      if(!check_ip_address) check_ip_address= await ipaddress()
      if(!check_ip_address) check_ip_address=await ipaddress()
      if(!check_ip_address) check_ip_address=await ipaddress()
      if(!check_ip_address) check_ip_address=await ipaddress()
      if(!check_ip_address) check_ip_address=await ipaddress()
      let response = false;
      // apply all validation before generating the image 
      // check if image count exceeds to the limit pre day 
      if(editimageprompt) {
        response = await checktodaysimagecount(check_customer_id,check_ip_address, editimageprompt);
      }else if(in_progress_prompt){ 
        response = await checktodaysimagecount(check_customer_id,check_ip_address, in_progress_prompt);
      }else{
        response = await checktodaysimagecount(check_customer_id,check_ip_address, false);
      }
      if (response && response.error) {
        //interupt the whole process and reset everything starts here
        process_interrupted = true
        generated_image_array = [] // free up the memory space
        try{
            const iframe = document.getElementById('iframe');
            const iframeDoc = iframe.contentWindow.document;
            iframeDoc.getElementById("edit-image").classList.remove("hidden");
            iframeDoc.getElementById("hreartunhearticon").classList.remove("hidden");
        }
        catch(err){
            console.log(err)
        }
        if (response.message == "Please do signup to generate more images."){
            openprompttoreached20Modal(false)
        }
        else  if(response.message=="Content flagged as potentially sensitive. Please try different prompts or images"){
        if(editimageprompt && imagetobeedited){
              editimageprompt = false 
              imagetobeedited = false
              formDetailHistory = false
              image_description = false
          }
          openerrormodalcontentModal(response.message)
        }else if(response.message=="You’ve reached your daily limit of 120."){
          if(editimageprompt && imagetobeedited){
              editimageprompt = false 
              imagetobeedited = false
              formDetailHistory = false
              image_description = false
          }
          openprompttoreacheddailylimitModal();
        }
        else{
          if(editimageprompt && imagetobeedited){
              editimageprompt = false 
              imagetobeedited = false
              formDetailHistory = false
              image_description = false
          }
         openerrormodalcontentModal(response.message)
        }
        // reset everything, all error responses and all flags
        maindisplayimagediv.style.display = "flex";
        image_heart_div_a_heart.style.display = "flex";
        customimagediv.style.display = "flex";
        div2prdernow.style.display = "block";
        loaderdiv.style.display="none";
        
        editimageprompt = false
        imagetobeedited = false
        formDetailHistory = false
        image_description = false
        throw response.message;
        //interupt the whole process and reset everything ends here
      }else{
              // prepare image data 
             
              // define seeds starts here      
              let min = 1000000000;
              let max = 9999999999;
              let seed1 = Math.floor(Math.random() * (max - min + 1)) + min;
        
              min = 10000000000;
              max = 99999999999;
              let seed2 = Math.floor(Math.random() * (max - min + 1)) + min;
        
              min = 123456789;
              max = 999999999;
              let seed3 = Math.floor(Math.random() * (max - min + 1)) + min;
        
              min = 123456789909;
              max = 999999999999;
              let seed4 = Math.floor(Math.random() * (max - min + 1)) + min;
              // define seeds ends here
              
             
              let selectedPreset;
              let random_style = false;
              const _currentPreset = JSON.parse(stylePreset);
              const currentPresetLabel = _currentPreset.label.toLowerCase();
              if (!currentPresetLabel.match("random styles")) {
                selectedPreset = pickStylePreset(stylePresets, stylePreset);
              }else{
                random_style = true;
                selectedPreset = stylePreset;
              }




              // process the image generation starts here
              if(editimageprompt){
               
                    let heightAndWidthTemp = { height: 1024, width: 1024 }
                    if(in_progress_orientation && in_progress_orientation=="square") heightAndWidthTemp = { height: 1024, width: 1024 }
                    else if(in_progress_orientation==false || in_progress_orientation=="false") heightAndWidthTemp = { height: 768, width: 1024 }
                    else  heightAndWidthTemp = { height: 1024, width: 768 }
                    const heightAndWidth = heightAndWidthTemp

                    let imagedata1 = await prepare_image_data(await generateUniqueId(), "image1", heightAndWidth, seed1, "same", in_progress_prompt, selectedPreset, random_style )
                    let imagedata2 = await prepare_image_data(await generateUniqueId(),"image2", heightAndWidth, seed2, "2", ps[0], selectedPreset, random_style)
                    
                    $$invalidate(8, (imagesHistory = [{}, {}, ...imagesHistory])); // generate only 2 images at once while editing an image
                    //image1
                    pending_images_array.push(imagedata1);
                    //image2
                    pending_images_array.push(imagedata2);
                    await replaceWithImage(0, "image1", pending_images_array[0], in_progress_prompt, isTextToImage_in_progress); // initiate the image generation 1  for edit image
                    await replaceWithImage(1, "image2", pending_images_array[1], ps[0], isTextToImage_in_progress);// initiate the image generation 2  for edit image
                    editimageprompt = false; // this flag is to notify that the image is being edited and also to prevennt confliction when user uploaded new image during the process
                    // await delay2(1000);
                    // $$invalidate(2, (isLoading = false)); // remove the  loader
              }else{
                    let orientation = in_progress_orientation;
                    if(!isTextToImage_in_progress){
                      while(!inprogressimageid){
                        await delay2(100)
                      }
                      orientation = inprogressimageid.split("_")[1]
                    }
                    let heightAndWidthTemp = { height: 1024, width: 1024 }
                    if(orientation && orientation=="square") heightAndWidthTemp = { height: 1024, width: 1024 }
                    else if(orientation==false || orientation=="false") heightAndWidthTemp = { height: 768, width: 1024 }
                    else  heightAndWidthTemp = { height: 1024, width: 768 }
                    const heightAndWidth = heightAndWidthTemp

                    let imagedata1 = await prepare_image_data(inprogressimageid, "image1", heightAndWidth, seed1, "same", in_progress_prompt, selectedPreset, random_style)
                    let imagedata2 = await prepare_image_data(inprogressimageid,"image2", heightAndWidth, seed2, "2", ps[0], selectedPreset, random_style)
                    let imagedata3 = await prepare_image_data(inprogressimageid,"image3", heightAndWidth, seed3, "3", ps[1], selectedPreset, random_style)
                    let imagedata4 = await prepare_image_data(inprogressimageid,"image4", heightAndWidth, seed4, "4", ps[2], selectedPreset, random_style)
                    

                    // console.log("imagedata1--------------",imagedata1)
                    // console.log("imagedata2--------------",imagedata2)
                    // console.log("imagedata3--------------",imagedata3)
                    // console.log("imagedata4--------------",imagedata4)

                    pending_images_array.push(imagedata1);
                    pending_images_array.push(imagedata2);
                    pending_images_array.push(imagedata3);
                    pending_images_array.push(imagedata4);

                 
                    console.log("croppedimages3bucketurl------------------", croppedimages3bucketurl)

                    $$invalidate(8, (imagesHistory = [{}, {}, {}, {}, ...imagesHistory])); // generate only 4 images at once newly created images
                    replaceWithImage(0, "image1", pending_images_array[0], in_progress_prompt, isTextToImage_in_progress); // initiate the image generation 1  for generate new image
                    finalsubmissionbutton.disabled = "disabled"
                    if(in_progress_prompt) await delay2(7000);
                    else await delay2(3000);
                    if(!process_interrupted){ // applied check if process is not interupted and not throws errors
                      replaceWithImage(1, "image2",pending_images_array[1], ps[0], isTextToImage_in_progress);  // initiate the image generation 2  for generate new image
                      await delay2(1500);
                    }else{
                      throw "error";
                    }
                    finalsubmissionbutton.disabled = "disabled"
                    if(!process_interrupted){ // applied check if process is not interupted and not throws errors
                      
                      replaceWithImage(2, "image3",pending_images_array[2], ps[1], isTextToImage_in_progress); // initiate the image generation 3  for generate new image
                      await delay2(1500);
                    }else{
                      throw "error";
                    }
                    finalsubmissionbutton.disabled = "disabled"
                    if(!process_interrupted){ // applied check if process is not interupted and not throws errors
                    
                        await replaceWithImage(3, "image4",pending_images_array[3], ps[2], isTextToImage_in_progress) // initiate the image generation 4  for generate new image
                    }else{
                      process_interrupted = false
                      throw "error";
                    }
                    finalsubmissionbutton.disabled = "disabled"
              }
              
              if(image_detail_array.length>1) image_detail_array.splice(0, 1);
              in_progress_orientation = "none";
              pending_images_array = []
              in_progress_prompt = "";
              finalsubmissionbutton.disabled = ""
              
              try{
                const iframe = document.getElementById('iframe');
                const iframeDoc = iframe.contentWindow.document;
                iframeDoc.getElementById("edit-image").classList.remove("hidden"); //enable edit-image buttn
                iframeDoc.getElementById("hreartunhearticon").classList.remove("hidden");  //enable like-dislike button buttn
              }
              catch(err){
                console.log("err00000000000000000", err)
              }
      }
    } catch (error) {

          // error handling if in case process is interrupted in between
          try{
            if(image_detail_array.length>1) image_detail_array.splice(0, 1);
            in_progress_orientation = "none";
            pending_images_array = []
            in_progress_prompt = "";
            process_interrupted = false
            finalsubmissionbutton.disabled = ""
            const iframe = document.getElementById('iframe');
            const iframeDoc = iframe.contentWindow.document;
            iframeDoc.getElementById("edit-image").classList.remove("hidden");
            iframeDoc.getElementById("hreartunhearticon").classList.remove("hidden");
           }
           catch(err){
            console.log(err)
           }
   
          $$invalidate(2, (isLoading = false)); // remove the  loader
          console.warn(error);
          return $$invalidate(
            8,
            (imagesHistory = imagesHistory.filter((image) => image.src))
          );
       
    }
  };
  const setUrlImageToCanvas = async () => {
    if (!parentFrame.location.search) return;
    const urlImage = queryString.parse(parentFrame.location.search);
    const _src = (urlImage == null ? void 0 : urlImage.src) + "?alt=media";
    const isMyArt = false;
    
    if (!isMyArt) return clearURLParams();
    if (!urlImage) return $$invalidate(6, (selectedImage = {}));
    // console.log("setUrlImageToCanvas------------", urlImage)
    $$invalidate(
      6,
      (selectedImage = {
        src: _src,
        isVertical: urlImage.isVertical != "false",
      })
    );
  };
  const getCookiein = async (name) => {
      const cookies = document.cookie.split("; ");
      for (const cookie of cookies) {
          const [key, value] = cookie.split("=");
          if (key === name) return value;
      }
      return null;
  };
  const deleteCookiein = async (name) => {
      document.cookie = `${name}=; path=/; max-age=0`;
  };
  const addGeneratedImagesToHistory = async () => {
    let selected_link_index = 0;
   
    await deleteCookiein("dataforwishlist");
    await deleteCookiein("selectedlink");
    await deleteCookiein("formdetail");

    const userImageHistoryData = await getAllImages(uid, selected_link);
    const userImageHistory = userImageHistoryData["keys"];
    if (userImageHistory.length > 0) {
      selected_link_index = userImageHistoryData.selected_link_index;
      const iframe = document.getElementById('iframe');
      if(userImageHistory[selected_link_index]['isVertical'] && userImageHistory[selected_link_index]['isVertical']=="square"){
          iframe.classList.remove('horizontal-iframe');
          iframe.classList.remove('vframe-iframe');
          iframe.classList.add('sframe-iframe');
      }if(userImageHistory[selected_link_index]['isVertical'] && userImageHistory[selected_link_index]['isVertical']!="square"){
          iframe.classList.remove('horizontal-iframe');
          iframe.classList.add('vframe-iframe');
          iframe.classList.remove('sframe-iframe');
      }else{
          iframe.classList.add('horizontal-iframe');
          iframe.classList.remove('vframe-iframe');
          iframe.classList.remove('sframe-iframe');
      }
      $$invalidate(8, (imagesHistory = userImageHistory));
    } else {
        $$invalidate(
        8,
        (imagesHistory = [
           {
            src: "/default_images/default1_new.png",
            isVertical: false,
            width: 768,
            height: 1024,
            s3Url:  "/default_images/default1_new.png&isVertical=false"
          },
          {
            src: "/default_images/default2_new.png",
            isVertical: false,
            width: 768,
            height: 1024,
            s3Url:  "/default_images/default2_new.png&isVertical=false"
          },
          {
            src: "/default_images/default3_new.png",
            isVertical: "square",
            width: 1024,
            height: 768,
            s3Url:  "/default_images/default3_new.png&isVertical=square"
          },
          {
            src: "/default_images/default4_new.png",
            isVertical: "square",
            width: 1024,
            height: 768,
            s3Url:  "/default_images/default4_new.png&isVertical=square"
          },
          {
            src: "/default_images/default5_new.png",
            isVertical: true,
            width: 1024,
            height: 768,
            s3Url:  "/default_images/default5_new.png&isVertical=true"
          },
          {
            src: "/default_images/default6_new.png",
            isVertical: true,
            width: 1024,
            height: 768,
            s3Url:  "/default_images/default6_new.png&isVertical=true"
          }
        ])
      );
    }
    if(formDetailHistory){

      if (selectedImage.src) return $$invalidate(7, (isLoadingHistory = false));
      $$invalidate(7, (isLoadingHistory = false));
      let u = "https://mywallartbucket.s3.us-east-1.amazonaws.com/default_images/Create+Something+Amazing!.png";
      let orientation = false
      if(parseInt(formDetailHistory.height)>parseInt(formDetailHistory.width)){
        orientation = true
      }else if(parseInt(formDetailHistory.height)==parseInt(formDetailHistory.width)){
        orientation = "square"
      }
      $$invalidate(6, (selectedImage = {
        src: u,
        isVertical: orientation,
        width: parseInt(formDetailHistory.width),
        height: parseInt(formDetailHistory.height),
      }));
      setImageToURL(selectedImage);
   }else{

      if (selectedImage.src) return $$invalidate(7, (isLoadingHistory = false));
      $$invalidate(7, (isLoadingHistory = false));
      
      $$invalidate(6, (selectedImage = imagesHistory[selected_link_index]));
      setImageToURL(selectedImage);
        
      let url  = `https://wallart.ai/products/ai-art-canvas?src=${imagesHistory[selected_link_index].s3Url}`;
      let twitterShareLink = buildShareLink("twitter", {
        url,
        text,
        imageUrl: url,
        description: text
      })


      let facebookShareLink = buildShareLink("facebook", {
        url,
        text,
        imageUrl: url,
        description: text,
      })

      let pinterestShareLink = buildShareLink("pinterest", {
        url,
        text,
        imageUrl: url,
        description: text,
      })
      
      const iframe = document.getElementById('iframe');
      const iframeDoc = iframe.contentWindow.document;
      iframeDoc.getElementById("twitterlink").setAttribute("href", twitterShareLink);
      iframeDoc.getElementById("facebooklink").setAttribute("href", facebookShareLink);
      iframeDoc.getElementById("pinterestlink").setAttribute("href", pinterestShareLink);



   }
  };
  onMount(() => {
    

    setUrlImageToCanvas();
    addGeneratedImagesToHistory();
  });
  function promptform_prompt_binding(value) {
    if(formDetailHistory && formDetailHistory?.prompt)  prompt = formDetailHistory?.prompt;
    else prompt = value;
    $$invalidate(1, prompt);
  }
  function promptform_isLoading_binding(value) {
    isLoading = value;
    $$invalidate(2, isLoading);
  }
  function promptform_isVertical_binding(value) {
    isVertical = value;
    $$invalidate(3, isVertical);
  }
  function promptform_stylePresets_binding(value) {
    stylePresets = value;
    $$invalidate(9, stylePresets), $$invalidate(0, isTextToImage);
  }
  function promptform_stylePreset_binding(value) {
    stylePreset = value;
    $$invalidate(10, stylePreset), $$invalidate(0, isTextToImage);
  }
  function promptform_imagecontenttype_binding(value) {
   
    imageContentType = value;
    $$invalidate(35, imageContentType);
  }
  function promptform_userImageUrl_binding(value) {
    userImageUrl = value;
    $$invalidate(5, userImageUrl);
  }
  function promptform_isCropperOpen_binding(value) {
    isCropperOpen = value;
    $$invalidate(4, isCropperOpen);
  }
  
  function promptform_isTextToImage_binding(value) {
    //change text to image from here formDetailHistory
    if(formDetailHistory && formDetailHistory.type=="imagefromimage"){
      isTextToImage = false;
      
    }
    else
      isTextToImage = value;
    $$invalidate(0, isTextToImage);
  }
  function promptform_image_binding(value) {
    selectedImage = value;
    $$invalidate(6, selectedImage);
  }
  function canvas_image_binding(value) {
    selectedImage = value;
    $$invalidate(6, selectedImage);
  }
  function canvas_isLoading_binding(value) {
    isLoading = value;
    $$invalidate(2, isLoading);
  }
  function canvas_isVertical_binding(value) {
    isVertical = value;
    $$invalidate(3, isVertical);
  }
  function canvas_isCropperOpen_binding(value) {
    isCropperOpen = value;
    $$invalidate(4, isCropperOpen);
  }
  function imagegallery_image_binding(value) {
    selectedImage = value;
    $$invalidate(6, selectedImage);
  }
  function imagegallery_isVertical_binding(value) {
    isVertical = value;
    $$invalidate(3, isVertical);
  }
  function imagegallery_images_binding(value) {
    imagesHistory = value;
    $$invalidate(8, imagesHistory);
  }
  function imagegallery_isTextToImage_binding(value) {
    isTextToImage = value;
    $$invalidate(0, isTextToImage);
  }
  $$self.$$set = ($$props2) => {
    if ("auth" in $$props2) $$invalidate(15, (auth2 = $$props2.auth));
    if ("parentFrame" in $$props2)
      $$invalidate(16, (parentFrame = $$props2.parentFrame));
  };
 
  $$self.$$.update = () => {
    
    if ($$self.$$.dirty[0] /*isTextToImage*/ & 1) {
      if(!stylePresets){
          

          $$invalidate(
            9,
            (stylePresets = isTextToImage
              ? global$1.stylePresets
              : global$1.imageToImagePresets)
          );
          $$invalidate(
            10,
            (stylePreset = JSON.stringify(global$1.stylePresets[0]) || {})
          );
      }
    }
  };
  return [
    isTextToImage,
    prompt,
    isLoading,
    isVertical,
    isCropperOpen,
    userImageUrl,
    selectedImage,
    isLoadingHistory,
    imagesHistory,
    stylePresets,
    stylePreset,
    lang,
    productURL,
    backgroundImageSrc,
    generateImagesInSequence,
    auth2,
    parentFrame,
    promptform_prompt_binding,
    promptform_isLoading_binding,
    promptform_isVertical_binding,
    promptform_stylePresets_binding,
    promptform_stylePreset_binding,
    promptform_userImageUrl_binding,
    promptform_isCropperOpen_binding,
    promptform_isTextToImage_binding,
    promptform_image_binding,
    canvas_image_binding,
    canvas_isLoading_binding,
    canvas_isVertical_binding,
    canvas_isCropperOpen_binding,
    imagegallery_image_binding,
    imagegallery_isVertical_binding,
    imagegallery_images_binding,
    imagegallery_isTextToImage_binding,
    promptform_imagecontenttype_binding,
    imageContentType,
  ];
}
class Generator extends SvelteComponent {
  constructor(options) {
    super();
    init(
      this,
      options,
      instance$1,
      create_fragment$2,
      safe_not_equal,
      { auth: 15, parentFrame: 16 },
      null,
      [-1, -1]
    );
  }
}
function create_fragment$1(ctx) {
  let div3;
  return {
    c() {
      div3 = element("div");
      div3.innerHTML = `<div style="animation-duration: 450ms" class="relative h-20 w-20 rounded-full animate-spin mx-auto will-change-transform"><div class="!block absolute left-0 top-0 h-full w-full rounded-full border-r-[0.4rem] border-t-[0.4rem] border-r-transparent border-t-black"></div> 
    <div class="!block absolute left-0 top-0 h-full w-full rounded-full border-b-[0.4rem] border-l-[0.4rem] border-b-[#d0011c] border-l-transparent"></div></div> 

  <p class="mt-4 block w-full">Loading...</p>`;
      attr(div3, "class", "text-center");
    },
    m(target, anchor) {
      insert(target, div3, anchor);
    },
    p: noop$1,
    i: noop$1,
    o: noop$1,
    d(detaching) {
      if (detaching) detach(div3);
    },
  };
}
class Spinner extends SvelteComponent {
  constructor(options) {
    super();
    init(this, options, null, create_fragment$1, safe_not_equal, {});
  }
}
function create_if_block(ctx) {
  let div;
  let spinner;
  let current;
  spinner = new Spinner({});
  return {
    c() {
      div = element("div");
      create_component(spinner.$$.fragment);
      attr(
        div,
        "class",
        "fixed top-0 left-0 w-full h-full flex items-center justify-center bg-white/50"
      );
    },
    m(target, anchor) {
      insert(target, div, anchor);
      mount_component(spinner, div, null);
      current = true;
    },
    i(local) {
      if (current) return;
      transition_in(spinner.$$.fragment, local);
      current = true;
    },
    o(local) {
      transition_out(spinner.$$.fragment, local);
      current = false;
    },
    d(detaching) {
      if (detaching) detach(div);
      destroy_component(spinner);
    },
  };
}
function create_fragment(ctx) {
  let if_block_anchor;
  let current;
  let if_block = !(/*isAuthorized*/ ctx[0]) && create_if_block();
  return {
    c() {
      if (if_block) if_block.c();
      if_block_anchor = empty();
    },
    m(target, anchor) {
      if (if_block) if_block.m(target, anchor);
      insert(target, if_block_anchor, anchor);
      current = true;
    },
    p(ctx2, [dirty]) {
      if (!(/*isAuthorized*/ ctx2[0])) {
        if (if_block) {
          if (dirty /*isAuthorized*/ & 1) {
            transition_in(if_block, 1);
          }
        } else {
          if_block = create_if_block();
          if_block.c();
          transition_in(if_block, 1);
          if_block.m(if_block_anchor.parentNode, if_block_anchor);
        }
      } else if (if_block) {
        group_outros();
        transition_out(if_block, 1, 1, () => {
          if_block = null;
        });
        check_outros();
      }
    },
    i(local) {
      if (current) return;
      transition_in(if_block);
      current = true;
    },
    o(local) {
      transition_out(if_block);
      current = false;
    },
    d(detaching) {
      if (if_block) if_block.d(detaching);
      if (detaching) detach(if_block_anchor);
    },
  };
}
async function generateSimpleId() {
  
  const uid = await getFingerprint();
  return uid;
}
function instance($$self, $$props, $$invalidate) {

  let isAuthorized = true; // Always authorized
  let uid = generateSimpleId();
  const renderIframeContent = (props) => {
    
    const iframe = document.getElementById("iframe");

    const iframeDocument = iframe.contentDocument;
    iframeDocument.addEventListener('contextmenu', event => event.preventDefault());
    iframeDocument.addEventListener('dragstart', event => event.preventDefault());
    const coreStyles = iframeDocument.createElement("style");

    coreStyles.innerHTML = styles;
    iframeDocument?.head?.appendChild(coreStyles);
    const frameNode = iframeDocument.getElementById("frame");
    //new code starts here
    // Inject CSS

    const tourStyles = iframeDocument.createElement("style");
    tourStyles.innerHTML = taketourcss;
    iframeDocument?.head?.appendChild(tourStyles);



    // Inject JS
    const script = iframeDocument.createElement("script");
    script.src = "https://unpkg.com/intro.js/intro.js";
    iframeDocument?.head?.appendChild(script);

    // Microsoft clarity Tracking Code
    const msClarityScript = iframeDocument.createElement("script");
    msClarityScript.innerHTML = `(function(c,l,a,r,i,t,y){         
        c[a]=c[a]||function(){(c[a].q=c[a].q||[]).push(arguments)};         
        t=l.createElement(r);t.async=1;t.src="https://www.clarity.ms/tag/"+i;         
        y=l.getElementsByTagName(r)[0];y.parentNode.insertBefore(t,y);     
      })(window, document, "clarity", "script", "u7irlkp8yp");
    `;
    iframeDocument?.head?.appendChild(msClarityScript);
    //End Microsoft clarity Tracking Code

    // Insert GTM Script in HEAD
    const gtmScript = iframeDocument.createElement("script");
    gtmScript.innerHTML = `
    (function(w,d,s,l,i){
    w[l]=w[l]||[];
    w[l].push({'gtm.start': new Date().getTime(), event:'gtm.js'});
    var f=d.getElementsByTagName(s)[0],
    j=d.createElement(s), dl=l!='dataLayer'?'&l='+l:'';
    j.async=true;
    j.src='https://www.googletagmanager.com/gtm.js?id='+i+dl;
    f.parentNode.insertBefore(j,f);
    })(window,document,'script','dataLayer','GTM-NBF57CGS');
    `;
    iframeDocument?.head?.appendChild(gtmScript);
    const gtmNoScript = iframeDocument.createElement("noscript");
    gtmNoScript.innerHTML = `
    <iframe src="https://www.googletagmanager.com/ns.html?id=GTM-NBF57CGS"
    height="0" width="0" style="display:none;visibility:hidden"></iframe>
    `;
    iframeDocument?.body?.prepend(gtmNoScript);
    const newscript = iframeDocument.createElement("script");
    newscript.textContent = `
      document.addEventListener('click', function(e) {
        if (e.target && e.target.id === 'generate-button') {
          window.parent.postMessage({ event: 'product_customized' }, '*');
        }
      });
    `;

    iframeDocument.head.appendChild(newscript);
    //new code ends here
    if (!frameNode) {
      setTimeout(() => {
        location.reload();
      }, 1000);
    } else {
      if (frameNode?.children?.length !== 0) return;
      new Generator({ props, target: frameNode });
      return iframe;
    }
  };
  const setFrameHeight = (frame) => () => {
    frame.style.height = "";
    const height2 =
      frame.contentWindow.document.documentElement.scrollHeight + 30;
    frame.style.height = height2 + "px";
  };
  onMount(async () => {
    try {
      $$invalidate(0, (isAuthorized = true));
      const frame = renderIframeContent({
        uid,
        parentFrame: {
          location: {
            href: window.location.href,
            search: window.location.search,
          },
        },
      });
      if (!frame) return;
      setFrameHeight(frame)();
      window.addEventListener("resize", setFrameHeight(frame));
      frame.contentWindow.document.addEventListener('click', ()=>{
        // console.log("ssssssssssssssssssssssss in sssssssssssssss")
        const runningtour = localStorage.getItem('runningtour'); 
        if (!runningtour) {
          ul_images_stylepresets.style.display="none";
        }  
                // ul_images_stylepresets.classList.add("hidden");
      });
      const observer = new MutationObserver(() => {
        frame.style.height = "";
        setFrameHeight(frame)();
      });
      observer.observe(frame.contentWindow.document.body, {
        childList: true,
        // observe direct children addition/removal
        subtree: true,
        // observe all descendants
      });
      return () => {
        observer.disconnect();
        window.removeEventListener("resize", setFrameHeight(frame, height));
      };
    } catch (error) {
      console.error(error);
    }
  });
  return [isAuthorized];
}
class Wrapper extends SvelteComponent {
  constructor(options) {
    super();
    init(this, options, instance, create_fragment, safe_not_equal, {});
  }
}
setTimeout(() => {
  new Wrapper({
    target: document.getElementById("app"),
  });
}, 500);